webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(349)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(350),
  /* template */
  __webpack_require__(351),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(29);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);

// URL and endpoint constants
var API_URL = "https://pib-api.prod.uks.ufes.br";

var getOpcoesTabelaEstruturada = function getOpcoesTabelaEstruturada(codTabela) {
  var OPCOES_URL = API_URL + '/opcoes/' + codTabela;
  var config = {
    method: 'get',
    url: OPCOES_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getProjetoSIEX = function getProjetoSIEX(registroSIEX) {
  var IMPORTAR_URL = API_URL + '/projetos/importar/' + registroSIEX;
  var config = {
    method: 'get',
    url: IMPORTAR_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getRelatorioProjeto = function getRelatorioProjeto(idProjeto) {
  var RELATORIO_URL = API_URL + '/projetos/' + idProjeto + '/relatorio';
  var config = {
    method: 'get',
    url: RELATORIO_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getMeusProjetos = function getMeusProjetos(idProjeto) {
  var MEUS_PROJETOS_URL = API_URL + '/meus-projetos';
  var config = {
    method: 'get',
    url: MEUS_PROJETOS_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getMeusProjetosAtivos = function getMeusProjetosAtivos(idProjeto) {
  var MEUS_PROJETOS_URL = API_URL + '/meus-projetos-ativos';
  var config = {
    method: 'get',
    url: MEUS_PROJETOS_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getConsultaProjetos = function getConsultaProjetos(pesquisa) {
  var PROJETOS_URL = API_URL + '/projetos';
  var config = {
    method: 'get',
    url: PROJETOS_URL,
    params: pesquisa,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getConsultaRelatoriosTecnicos = function getConsultaRelatoriosTecnicos(pesquisa) {
  var RELATORIOS_TECNICOS_URL = API_URL + '/relatorios-tecnicos';
  var config = {
    method: 'get',
    url: RELATORIOS_TECNICOS_URL,
    params: pesquisa,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getProjeto = function getProjeto(idProjeto) {
  var PROJETO_URL = API_URL + '/projetos/' + idProjeto;
  var config = {
    method: 'get',
    url: PROJETO_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var deleteProjeto = function deleteProjeto(idProjeto) {
  var PROJETO_URL = API_URL + '/projetos/' + idProjeto;
  var config = {
    method: 'delete',
    url: PROJETO_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getClassificacoesPossiveis = function getClassificacoesPossiveis(item) {
  var CLASSIFICACOES_URL = API_URL + '/classificacoes/' + item;
  var config = {
    method: 'get',
    url: CLASSIFICACOES_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getClassificacoesAreasDoConhecimento = function getClassificacoesAreasDoConhecimento() {
  var CLASSIFICACOES_URL = API_URL + '/classificacoes/areas-do-conhecimento';
  var config = {
    method: 'get',
    url: CLASSIFICACOES_URL,
    responseType: 'text'
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getClassificacoesClassificacaoSuperior = function getClassificacoesClassificacaoSuperior(idClassifSup) {
  var CLASSIFICACOES_URL = API_URL + '/classificacoes/classificacao-superior/' + idClassifSup;
  var config = {
    method: 'get',
    url: CLASSIFICACOES_URL,
    responseType: 'text'
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getClassificacoesDoProjeto = function getClassificacoesDoProjeto(idProjeto) {
  var CLASSIFICACOES_URL = API_URL + '/projetos/' + idProjeto + '/classificacoes';
  var config = {
    method: 'get',
    url: CLASSIFICACOES_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getExtensaoDoProjeto = function getExtensaoDoProjeto(idProjeto) {
  var EXTENSAO_URL = API_URL + '/projetos/' + idProjeto + '/extensao';
  var config = {
    method: 'get',
    url: EXTENSAO_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getContatosDoProjeto = function getContatosDoProjeto(idProjeto) {
  var CONTATOS_URL = API_URL + '/projetos/' + idProjeto + '/contatos';
  var config = {
    method: 'get',
    url: CONTATOS_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getIntegrantesDoProjeto = function getIntegrantesDoProjeto(idProjeto) {
  var PARTICIPANTES_URL = API_URL + '/projetos/' + idProjeto + '/participantes';
  var config = {
    method: 'get',
    url: PARTICIPANTES_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getVinculosDoProjeto = function getVinculosDoProjeto(idProjeto) {
  var VINCULOS_URL = API_URL + '/projetos/' + idProjeto + '/vinculos';
  var config = {
    method: 'get',
    url: VINCULOS_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getParceriasDoProjeto = function getParceriasDoProjeto(idProjeto) {
  var PARCERIAS_URL = API_URL + '/projetos/' + idProjeto + '/parcerias';
  var config = {
    method: 'get',
    url: PARCERIAS_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getAtividadesDoProjeto = function getAtividadesDoProjeto(idProjeto) {
  var ATIVIDADES_URL = API_URL + '/projetos/' + idProjeto + '/atividades';
  var config = {
    method: 'get',
    url: ATIVIDADES_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getSuspensoes = function getSuspensoes(idProjeto) {
  var SUSPENSOES_URL = API_URL + '/projetos/' + idProjeto + '/suspensao';
  var config = {
    method: 'get',
    url: SUSPENSOES_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getAtividade = function getAtividade(idProjeto, idAtividade) {
  var ATIVIDADES_URL = API_URL + '/projetos/' + idProjeto + '/atividades/' + idAtividade;
  var config = {
    method: 'get',
    url: ATIVIDADES_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var deleteAtividade = function deleteAtividade(idProjeto, idAtividade) {
  var ATIVIDADES_URL = API_URL + '/projetos/' + idProjeto + '/atividades/' + idAtividade;
  var config = {
    method: 'delete',
    url: ATIVIDADES_URL,
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getParceria = function getParceria(idProjeto, idParceria) {
  var PARCERIAS_URL = API_URL + '/projetos/' + idProjeto + '/parcerias/' + idParceria;
  var config = {
    method: 'get',
    url: PARCERIAS_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var putAtividade = function putAtividade(idProjeto, idAtividade, atividade) {
  var ATIVIDADES_URL = API_URL + '/projetos/' + idProjeto + '/atividades/' + idAtividade;
  var config = {
    method: 'put',
    url: ATIVIDADES_URL,
    responseType: 'text',
    credentials: true,
    body: atividade
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getBolsasDoProjeto = function getBolsasDoProjeto(idProjeto) {
  var BOLSAS_URL = API_URL + '/projetos/' + idProjeto + '/bolsas';
  var config = {
    method: 'get',
    url: BOLSAS_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getArquivosDoProjeto = function getArquivosDoProjeto(idProjeto) {
  var ARQUIVOS_URL = API_URL + '/projetos/' + idProjeto + '/arquivos';
  var config = {
    method: 'get',
    url: ARQUIVOS_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getArquivo = function getArquivo(idProjeto, idArquivo) {
  var ARQUIVOS_URL = API_URL + '/projetos/' + idProjeto + '/arquivos/' + idArquivo + '/informacoes';
  var config = {
    method: 'get',
    url: ARQUIVOS_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getIntegrante = function getIntegrante(idProjeto, idParticipante) {
  var PARTICIPANTE_URL = API_URL + '/projetos/' + idProjeto + '/participantes/' + idParticipante;
  var config = {
    method: 'get',
    url: PARTICIPANTE_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var deleteIntegrante = function deleteIntegrante(idProjeto, idIntegrante) {
  var INTEGRANTES_URL = API_URL + '/projetos/' + idProjeto + '/participantes/' + idIntegrante;
  var config = {
    method: 'delete',
    url: INTEGRANTES_URL,
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getPessoasPorNome = function getPessoasPorNome(nome) {
  var PESSOAS_URL = API_URL + '/pessoas';
  var config = {
    method: 'get',
    url: PESSOAS_URL,
    responseType: 'text',
    credentials: true,
    params: { nome: nome }
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getPessoasPorCpf = function getPessoasPorCpf(cpf) {
  var PESSOAS_URL = API_URL + '/pessoas';
  var config = {
    method: 'get',
    url: PESSOAS_URL,
    responseType: 'text',
    credentials: true,
    params: { cpf: cpf }
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getPessoa = function getPessoa(idPessoa) {
  var PESSOA_URL = API_URL + '/pessoas/' + idPessoa;
  var config = {
    method: 'get',
    url: PESSOA_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var putPessoa = function putPessoa(idPessoa, pessoa) {
  var PESSOA_URL = API_URL + '/pessoas/' + idPessoa;
  var config = {
    method: 'put',
    url: PESSOA_URL,
    responseType: 'text',
    credentials: true,
    body: pessoa
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getUnidadesExtensao = function getUnidadesExtensao() {
  var UNIDADES_URL = API_URL + '/unidades';
  var config = {
    method: 'get',
    url: UNIDADES_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getUnidades = function getUnidades(tipoUnidadeItem) {
  var UNIDADES_URL = API_URL + '/unidades/tipo/' + tipoUnidadeItem;
  var config = {
    method: 'get',
    url: UNIDADES_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var postIntegrante = function postIntegrante(idProjeto, integrante) {
  var PARTICIPANTE_URL = API_URL + '/projetos/' + idProjeto + '/participantes';
  var config = {
    method: 'post',
    url: PARTICIPANTE_URL,
    responseType: 'text',
    credentials: true,
    body: integrante
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var postImportarProjetoSIEX = function postImportarProjetoSIEX(registroSIEX, projetoSIEX) {
  var IMPORTAR_URL = API_URL + '/projetos/importar/' + registroSIEX;
  var config = {
    method: 'post',
    url: IMPORTAR_URL,
    responseType: 'text',
    credentials: true,
    body: projetoSIEX
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var putIntegrante = function putIntegrante(idProjeto, idParticipante, integrante) {
  var PARTICIPANTE_URL = API_URL + '/projetos/' + idProjeto + '/participantes/' + idParticipante;
  var config = {
    method: 'put',
    url: PARTICIPANTE_URL,
    responseType: 'json',
    credentials: true,
    body: integrante
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var putCoordenador = function putCoordenador(idProjeto, idParticipante) {
  var COORDENADOR_URL = API_URL + '/projetos/' + idProjeto + '/participantes/' + idParticipante + '/novoCoordenador';
  var config = {
    method: 'put',
    url: COORDENADOR_URL,
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var postProjeto = function postProjeto(projeto) {
  var PROJETOS_URL = API_URL + '/projetos';
  var config = {
    method: 'post',
    url: PROJETOS_URL,
    responseType: 'json',
    credentials: true,
    body: projeto
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var postClassificacoesDoProjeto = function postClassificacoesDoProjeto(idProjeto, classificacoes) {
  var CLASSIFICACOES_URL = API_URL + '/projetos/' + idProjeto + '/classificacoes';
  var config = {
    method: 'post',
    url: CLASSIFICACOES_URL,
    responseType: 'json',
    credentials: true,
    body: classificacoes
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var postParceriasDoProjeto = function postParceriasDoProjeto(idProjeto, parceria) {
  var PARCERIAS_URL = API_URL + '/projetos/' + idProjeto + '/parcerias';
  var config = {
    method: 'post',
    url: PARCERIAS_URL,
    responseType: 'json',
    credentials: true,
    body: parceria
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var putParceriasDoProjeto = function putParceriasDoProjeto(idProjeto, idParceria, parceria) {
  var PARCERIAS_URL = API_URL + '/projetos/' + idProjeto + '/parcerias/' + idParceria;
  var config = {
    method: 'put',
    url: PARCERIAS_URL,
    responseType: 'json',
    credentials: true,
    body: parceria
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var postAtividadesDoProjeto = function postAtividadesDoProjeto(idProjeto, atividade) {
  var ATIVIDADES_URL = API_URL + '/projetos/' + idProjeto + '/atividades';
  var config = {
    method: 'post',
    url: ATIVIDADES_URL,
    responseType: 'json',
    credentials: true,
    body: atividade
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var putProjeto = function putProjeto(idProjeto, projeto) {
  var PROJETO_URL = API_URL + '/projetos/' + idProjeto;
  var config = {
    method: 'put',
    url: PROJETO_URL,
    responseType: 'json',
    credentials: true,
    body: projeto
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var postExtensao = function postExtensao(idProjeto, extensao) {
  var EXTENSAO_URL = API_URL + '/projetos/' + idProjeto + '/extensao';
  var config = {
    method: 'post',
    url: EXTENSAO_URL,
    responseType: 'json',
    credentials: true,
    body: extensao
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var postContatos = function postContatos(idProjeto, contatos) {
  var CONTATOS_URL = API_URL + '/projetos/' + idProjeto + '/contatos';
  var config = {
    method: 'post',
    url: CONTATOS_URL,
    responseType: 'json',
    credentials: true,
    body: contatos
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var postRelatorio = function postRelatorio(idProjeto, relatorio) {
  var RELATORIO_URL = API_URL + '/projetos/' + idProjeto + '/relatorios/extensao';
  var config = {
    method: 'post',
    url: RELATORIO_URL,
    responseType: 'text',
    credentials: true,
    body: relatorio
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var postBolsista = function postBolsista(idProjeto, bolsista) {
  var BOLSISTA_URL = API_URL + '/projetos/' + idProjeto + '/bolsistas';
  var config = {
    method: 'post',
    url: BOLSISTA_URL,
    responseType: 'json',
    credentials: true,
    body: bolsista
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var postArquivo = function postArquivo(idProjeto, arquivo) {
  var ARQUIVOS_URL = API_URL + '/projetos/' + idProjeto + '/arquivos';
  var config = {
    method: 'post',
    url: ARQUIVOS_URL,
    responseType: 'json',
    credentials: true,
    body: arquivo
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var putArquivo = function putArquivo(idProjeto, idArquivo, arquivo) {
  var ARQUIVOS_URL = API_URL + '/projetos/' + idProjeto + '/arquivos/' + idArquivo;
  var config = {
    method: 'put',
    url: ARQUIVOS_URL,
    responseType: 'json',
    credentials: true,
    body: arquivo
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var deleteArquivo = function deleteArquivo(idProjeto, idArquivo) {
  var ARQUIVOS_URL = API_URL + '/projetos/' + idProjeto + '/arquivos/' + idArquivo;
  var config = {
    method: 'delete',
    url: ARQUIVOS_URL,
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var deleteParceria = function deleteParceria(idProjeto, idParceria) {
  var PARCERIAS_URL = API_URL + '/projetos/' + idProjeto + '/parcerias/' + idParceria;
  var config = {
    method: 'delete',
    url: PARCERIAS_URL,
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getListaLocalidade = function getListaLocalidade(idProjeto) {
  var LOCALIDADES_URL = API_URL + '/projetos/' + idProjeto + '/localidades';
  var config = {
    method: 'get',
    url: LOCALIDADES_URL,
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getLocalidade = function getLocalidade(idProjeto, idLocalidade) {
  var LOCALIDADES_URL = API_URL + '/projetos/' + idProjeto + '/localidades/' + idLocalidade;
  var config = {
    method: 'get',
    url: LOCALIDADES_URL,
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var postLocalidade = function postLocalidade(idProjeto, localidade) {
  var LOCALIDADES_URL = API_URL + '/projetos/' + idProjeto + '/localidades';
  var config = {
    method: 'post',
    url: LOCALIDADES_URL,
    responseType: 'json',
    credentials: true,
    body: localidade
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var putLocalidade = function putLocalidade(idProjeto, idLocalidade, localidade) {
  var LOCALIDADES_URL = API_URL + '/projetos/' + idProjeto + '/localidades/' + idLocalidade;
  var config = {
    method: 'put',
    url: LOCALIDADES_URL,
    responseType: 'json',
    credentials: true,
    body: localidade
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var deleteLocalidade = function deleteLocalidade(idProjeto, idLocalidade) {
  var LOCALIDADES_URL = API_URL + '/projetos/' + idProjeto + '/localidades/' + idLocalidade;
  var config = {
    method: 'delete',
    url: LOCALIDADES_URL,
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getCidades = function getCidades(ufCidadeItem) {
  var CIDADES_URL = API_URL + '/cidades/' + ufCidadeItem;
  var config = {
    method: 'get',
    url: CIDADES_URL,
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getEstados = function getEstados(itemPais) {
  var ESTADOS_URL = API_URL + '/estados/' + itemPais;
  var config = {
    method: 'get',
    url: ESTADOS_URL,
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var postPessoa = function postPessoa(pessoa) {
  var PESSOA_URL = API_URL + '/pessoas';
  var config = {
    method: 'post',
    url: PESSOA_URL,
    responseType: 'text',
    credentials: true,
    body: pessoa
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getAcaoExtensao = function getAcaoExtensao(registro) {
  var ACAO_EXTENSAO_URL = API_URL + '/acoes-extensao?registro=' + registro;
  var config = {
    method: 'get',
    url: ACAO_EXTENSAO_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var postSubmissaoAprovacao = function postSubmissaoAprovacao(idProjeto) {
  var SUBMISSAO_URL = API_URL + '/projetos/' + idProjeto + '/submissao-aprovacao';
  var config = {
    method: 'post',
    url: SUBMISSAO_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var postConcluirImportacao = function postConcluirImportacao(idProjeto) {
  var IMPORTACAO_URL = API_URL + '/projetos/' + idProjeto + '/conclui-importacao';
  var config = {
    method: 'post',
    url: IMPORTACAO_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var postAprovarProjeto = function postAprovarProjeto(idProjeto, aprovacao) {
  var APROVACAO_URL = API_URL + '/projetos/' + idProjeto + '/aprovacao';
  var config = {
    method: 'post',
    url: APROVACAO_URL,
    responseType: 'text',
    credentials: true,
    body: aprovacao
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var postDevolverProjeto = function postDevolverProjeto(idProjeto, devolucao) {
  var DEVOLUCAO_URL = API_URL + '/projetos/' + idProjeto + '/devolucao';
  var config = {
    method: 'post',
    url: DEVOLUCAO_URL,
    responseType: 'text',
    credentials: true,
    body: devolucao
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var postLiberarRelatorioFinal = function postLiberarRelatorioFinal(idProjeto) {
  var LIBERACAO_URL = API_URL + '/projetos/' + idProjeto + '/liberacao-relatorio-final';
  var config = {
    method: 'post',
    url: LIBERACAO_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var postInabilitarProjeto = function postInabilitarProjeto(idProjeto, inabilitacao) {
  var INABILITACAO_URL = API_URL + '/projetos/' + idProjeto + '/inabilitacao';
  var config = {
    method: 'post',
    url: INABILITACAO_URL,
    responseType: 'text',
    credentials: true,
    body: inabilitacao
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var postAlterarClassificacaoSecundaria = function postAlterarClassificacaoSecundaria(idProjeto, alteracao) {
  var ALTERACAO_URL = API_URL + '/projetos/' + idProjeto + '/classificacao-secundaria';
  var config = {
    method: 'post',
    url: ALTERACAO_URL,
    responseType: 'text',
    credentials: true,
    body: alteracao
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var postSuspenderAcaoExtensao = function postSuspenderAcaoExtensao(idProjeto, suspensao) {
  var SUSPENSAO_URL = API_URL + '/projetos/' + idProjeto + '/suspensao';
  var config = {
    method: 'post',
    url: SUSPENSAO_URL,
    responseType: 'text',
    credentials: true,
    body: suspensao
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var postReativarAcaoExtensao = function postReativarAcaoExtensao(idProjeto, reativacao) {
  var REATIVACAO_URL = API_URL + '/projetos/' + idProjeto + '/reativacao';
  var config = {
    method: 'post',
    url: REATIVACAO_URL,
    responseType: 'text',
    credentials: true,
    body: reativacao
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var postProrrogarSuspensaoAcaoExtensao = function postProrrogarSuspensaoAcaoExtensao(idProjeto, suspensao) {
  var SUSPENSAO_URL = API_URL + '/projetos/' + idProjeto + '/prorrogacao-suspensao';
  var config = {
    method: 'post',
    url: SUSPENSAO_URL,
    responseType: 'text',
    credentials: true,
    body: suspensao
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var postSubmissaoConclusao = function postSubmissaoConclusao(idProjeto) {
  var CONCLUSAO_URL = API_URL + '/projetos/' + idProjeto + '/submissao-conclusao';
  var config = {
    method: 'post',
    url: CONCLUSAO_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getParcerias = function getParcerias() {
  var PARCERIAS_URL = API_URL + '/parcerias';
  var config = {
    method: 'get',
    url: PARCERIAS_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getOcorrenciasIntegrante = function getOcorrenciasIntegrante(idProjeto, idParticipante) {
  var OCORRENCIAS_INTEGRANTE_URL = API_URL + '/projetos/' + idProjeto + '/participantes/' + idParticipante + '/ocorrencias';
  var config = {
    method: 'get',
    url: OCORRENCIAS_INTEGRANTE_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var postFinalizarProjeto = function postFinalizarProjeto(idProjeto, finalizacao) {
  var FINALIZAR_PROJETO_URL = API_URL + '/projetos/' + idProjeto + '/finalizar';
  var config = {
    method: 'post',
    url: FINALIZAR_PROJETO_URL,
    responseType: 'text',
    credentials: true,
    body: finalizacao
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var postConcluirProjeto = function postConcluirProjeto(idProjeto, conclusao) {
  var CONCLUIR_PROJETO_URL = API_URL + '/projetos/' + idProjeto + '/concluir';
  var config = {
    method: 'post',
    url: CONCLUIR_PROJETO_URL,
    responseType: 'text',
    credentials: true,
    body: conclusao
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var postCancelarProjeto = function postCancelarProjeto(idProjeto, cancelamento) {
  var CANCELAR_PROJETO_URL = API_URL + '/projetos/' + idProjeto + '/cancelar';
  var config = {
    method: 'post',
    url: CANCELAR_PROJETO_URL,
    responseType: 'text',
    credentials: true,
    body: cancelamento
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var postDesfazerFinalizacaoProjeto = function postDesfazerFinalizacaoProjeto(idProjeto, cancelamento) {
  var DESFAZER_FINALIZACAO_PROJETO_URL = API_URL + '/projetos/' + idProjeto + '/desfazer-finalizacao';
  var config = {
    method: 'post',
    url: DESFAZER_FINALIZACAO_PROJETO_URL,
    responseType: 'text',
    credentials: true,
    body: cancelamento
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var postDesfazerExclusaoProjeto = function postDesfazerExclusaoProjeto(idProjeto, cancelamento) {
  var CANCELAR_PROJETO_URL = API_URL + '/projetos/' + idProjeto + '/desfazer-exclusao';
  var config = {
    method: 'post',
    url: CANCELAR_PROJETO_URL,
    responseType: 'text',
    credentials: true,
    body: cancelamento
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getRelatoriosGestao = function getRelatoriosGestao() {
  var RELATORIOS_GESTAO_URL = API_URL + '/gestao/relatorios';
  var config = {
    method: 'get',
    url: RELATORIOS_GESTAO_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var postProjetoSuperior = function postProjetoSuperior(idProjeto, idProjetoSuperior) {
  var PROJETO_SUPERIOR_URL = API_URL + '/projetos/' + idProjeto + '/superior/' + idProjetoSuperior;
  var config = {
    method: 'post',
    url: PROJETO_SUPERIOR_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getProjetosVencidos = function getProjetosVencidos() {
  var PROJETOS_VENCIDOS_URL = API_URL + '/projetos-preenchimento-incompleto-mais-seis-meses';
  var config = {
    method: 'get',
    url: PROJETOS_VENCIDOS_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getProjetosComRelatorioReprovavel = function getProjetosComRelatorioReprovavel() {
  var PROJETOS_RELATORIO_REPROVAVEL = API_URL + '/projetos-relatorio-reprovavel';
  var config = {
    method: 'get',
    url: PROJETOS_RELATORIO_REPROVAVEL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getRegistrosDeEnvioDeRelatorioDeProjeto = function getRegistrosDeEnvioDeRelatorioDeProjeto(idProjeto) {
  var REGISTROS_ENVIO_RELATORIOS_PROJETO = API_URL + '/projetos/' + idProjeto + '/registro-envio-relatorio';
  var config = {
    method: 'get',
    url: REGISTROS_ENVIO_RELATORIOS_PROJETO,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getListaMensagem = function getListaMensagem() {
  var MENSAGEM_URL = API_URL + '/mensagem';
  var config = {
    method: 'get',
    url: MENSAGEM_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var postMensagem = function postMensagem(mensagem) {
  var MENSAGEM_URL = API_URL + '/mensagem';
  var config = {
    method: 'post',
    url: MENSAGEM_URL,
    responseType: 'text',
    credentials: true,
    body: mensagem
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var deleteProjetoSuperior = function deleteProjetoSuperior(idProjeto, idProjetoSuperior) {
  var SUPERIOR_URL = API_URL + '/projetos/' + idProjeto + '/superior/' + idProjetoSuperior;
  var config = {
    method: 'delete',
    url: SUPERIOR_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getDuplicacao = function getDuplicacao(idProjeto) {
  var DUPLICACAO_URL = API_URL + '/projetos/' + idProjeto + '/duplicacao';
  var config = {
    method: 'get',
    url: DUPLICACAO_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var postDuplicacao = function postDuplicacao(idProjeto, duplicacao) {
  var DUPLICACAO_URL = API_URL + '/projetos/' + idProjeto + '/duplicacao';
  var config = {
    method: 'post',
    url: DUPLICACAO_URL,
    responseType: 'text',
    credentials: true,
    body: duplicacao
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getRelatoriosDoProjeto = function getRelatoriosDoProjeto(idProjeto) {
  var RELATORIO_URL = API_URL + '/projetos/' + idProjeto + '/relatorios-tecnicos';
  var config = {
    method: 'get',
    url: RELATORIO_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getRelatorioExtensao = function getRelatorioExtensao(idProjeto, idRelatorio) {
  var RELATORIO_URL = API_URL + '/projetos/' + idProjeto + '/relatorios-tecnicos/' + idRelatorio;
  var config = {
    method: 'get',
    url: RELATORIO_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var postRelatorioExtensao = function postRelatorioExtensao(idProjeto, relatorioExtensao) {
  var RELATORIO_URL = API_URL + '/projetos/' + idProjeto + '/relatorios-tecnicos/';
  var config = {
    method: 'post',
    url: RELATORIO_URL,
    responseType: 'text',
    credentials: true,
    body: relatorioExtensao
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var putRelatorioExtensao = function putRelatorioExtensao(idProjeto, idRelatorioExtensao, relatorioExtensao) {
  var RELATORIO_URL = API_URL + '/projetos/' + idProjeto + '/relatorios-tecnicos/' + idRelatorioExtensao;
  var config = {
    method: 'put',
    url: RELATORIO_URL,
    responseType: 'text',
    credentials: true,
    body: relatorioExtensao
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var postSubmeterRelatorio = function postSubmeterRelatorio(idProjeto, idRelatorioExtensao, submissao) {
  var SUBMETER_RELATORIO_URL = API_URL + '/projetos/' + idProjeto + '/relatorios-tecnicos/' + idRelatorioExtensao + '/submissao';
  var config = {
    method: 'post',
    url: SUBMETER_RELATORIO_URL,
    responseType: 'text',
    credentials: true,
    body: submissao
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var postAprovarRelatorio = function postAprovarRelatorio(idProjeto, idRelatorioExtensao, aprovacao) {
  var APROVAR_RELATORIO_URL = API_URL + '/projetos/' + idProjeto + '/relatorios-tecnicos/' + idRelatorioExtensao + '/aprovacao';
  var config = {
    method: 'post',
    url: APROVAR_RELATORIO_URL,
    responseType: 'text',
    credentials: true,
    body: aprovacao
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var postDevolverRelatorio = function postDevolverRelatorio(idProjeto, idRelatorioExtensao, devolucao) {
  var DEVOLVER_RELATORIO_URL = API_URL + '/projetos/' + idProjeto + '/relatorios-tecnicos/' + idRelatorioExtensao + '/devolucao';
  var config = {
    method: 'post',
    url: DEVOLVER_RELATORIO_URL,
    responseType: 'text',
    credentials: true,
    body: devolucao
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var postReprovarRelatorio = function postReprovarRelatorio(idProjeto, idRelatorioExtensao, reprovacao) {
  var REPROVAR_RELATORIO_URL = API_URL + '/projetos/' + idProjeto + '/relatorios-tecnicos/' + idRelatorioExtensao + '/reprovacao';
  var config = {
    method: 'post',
    url: REPROVAR_RELATORIO_URL,
    responseType: 'text',
    credentials: true,
    body: reprovacao
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var postRegistrarEnvioDeRelatorioDeProjeto = function postRegistrarEnvioDeRelatorioDeProjeto(idProjeto, payload) {
  var REGISTRO_ENVIO_RELATORIO_URL = API_URL + '/projetos/' + idProjeto + '/registro-envio-relatorio';
  var config = {
    method: 'post',
    url: REGISTRO_ENVIO_RELATORIO_URL,
    responseType: 'text',
    credentials: true,
    body: payload
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var deleteRegistroEnvioDeRelatorioDeProjeto = function deleteRegistroEnvioDeRelatorioDeProjeto(idProjeto, idRegistroRelatorioProjeto) {
  var DELETE_REGISTRO_RELATORIO_URL = API_URL + '/projetos/' + idProjeto + '/registro-envio-relatorio/' + idRegistroRelatorioProjeto;
  var config = {
    method: 'delete',
    url: DELETE_REGISTRO_RELATORIO_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var putRegistroEnvioDeRelatorioDeProjeto = function putRegistroEnvioDeRelatorioDeProjeto(idProjeto, idRegistroRelatorioProjeto, payload) {
  var PUT_REGISTRO_RELATORIO_URL = API_URL + '/projetos/' + idProjeto + '/registro-envio-relatorio' + '/' + idRegistroRelatorioProjeto;
  var config = {
    method: 'put',
    url: PUT_REGISTRO_RELATORIO_URL,
    responseType: 'text',
    credentials: true,
    body: payload
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var postReprovarRelatorioComSuspensaoDeCoordenador = function postReprovarRelatorioComSuspensaoDeCoordenador(idProjeto, payload) {
  var REPROVAR_RELATORIO_SUSPENSAO_COORDENADOR_URL = API_URL + '/projetos/' + idProjeto + '/reprovar-relatorio-suspender-coordenador';
  var config = {
    method: 'post',
    url: REPROVAR_RELATORIO_SUSPENSAO_COORDENADOR_URL,
    responseType: 'text',
    credentials: true,
    body: payload
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var postAtivarAdministrador = function postAtivarAdministrador() {
  var ATIVAR_ADMINISTRADOR_URL = API_URL + '/ativa-administrador';
  var config = {
    method: 'post',
    url: ATIVAR_ADMINISTRADOR_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var postDesativarAdministrador = function postDesativarAdministrador() {
  var DESATIVAR_ADMINISTRADOR_URL = API_URL + '/desativa-administrador';
  var config = {
    method: 'post',
    url: DESATIVAR_ADMINISTRADOR_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getPrazoDias = function getPrazoDias(idProjeto) {
  var URL = API_URL + '/projetos/' + idProjeto + '/prazo-dias';
  var config = {
    method: 'get',
    url: URL,
    responseType: 'text'
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getRelatorioTecnicoForaPrazo = function getRelatorioTecnicoForaPrazo(idProjeto, idRelatorioExtensao) {
  var URL = API_URL + '/projetos/' + idProjeto + '/relatorios-tecnicos/' + idRelatorioExtensao + '/relatorio-fora-prazo';
  var config = {
    method: 'get',
    url: URL,
    responseType: 'text'
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getVerificarPendenciasRelatorio = function getVerificarPendenciasRelatorio(idProjeto, idRelatorioExtensao) {
  var VERIFICAR_PENDENCIAS_RELATORIO_URL = API_URL + '/projetos/' + idProjeto + '/relatorios-tecnicos/' + idRelatorioExtensao + '/validar';
  var config = {
    method: 'get',
    url: VERIFICAR_PENDENCIAS_RELATORIO_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getPeriodoRelatorio = function getPeriodoRelatorio(idProjeto) {
  var PERIODO_RELATORIO_URL = API_URL + '/projetos/' + idProjeto + '/relatorios-tecnicos/' + 'novo';
  var config = {
    method: 'get',
    url: PERIODO_RELATORIO_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getEmailCargaHorariaCoordenador = function getEmailCargaHorariaCoordenador(idProjeto) {
  var EMAIL_CARGA_HORARIA_COORDENADOR_URL = API_URL + '/projetos/' + idProjeto + '/coordenador';
  var config = {
    method: 'get',
    url: EMAIL_CARGA_HORARIA_COORDENADOR_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getExcadServer = function getExcadServer() {
  var EXCAD_SERVER_URL = API_URL + '/excad-server';
  var config = {
    method: 'get',
    url: EXCAD_SERVER_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getDocumentoProtocolo = function getDocumentoProtocolo(documento) {
  var PROTOCOLO_SERVER_URL = 'https://api.lepisma.ufes.br/documentos';
  var config = {
    method: 'get',
    url: PROTOCOLO_SERVER_URL,
    params: documento,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

// Cadastra um novo projeto de pesquisa.
var postProjetoPesquisa = function postProjetoPesquisa(projetoPesquisa) {
  var PROJETOS_URL = API_URL + '/pesquisa/projetos';
  var config = {
    method: 'post',
    url: PROJETOS_URL,
    responseType: 'text',
    credentials: true,
    body: projetoPesquisa
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

// Consulta projetos de pesquisa.
var getConsultaProjetosPesquisa = function getConsultaProjetosPesquisa(consulta) {
  var PROJETOS_URL = API_URL + '/pesquisa/projetos';
  var config = {
    method: 'get',
    url: PROJETOS_URL,
    params: consulta,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

// Envia um projeto de pesquisa para registro.
var postProjetoPesquisaRegistro = function postProjetoPesquisaRegistro(idProjetoPesquisa) {
  var PROJETOS_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa + '/registro';
  var config = {
    method: 'post',
    url: PROJETOS_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

// Registra um projeto de pesquisa.
var postRegistrarProjetoPesquisa = function postRegistrarProjetoPesquisa(idProjetoPesquisa) {
  var PROJETOS_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa + '/aprovacao';
  var config = {
    method: 'post',
    url: PROJETOS_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

// Devolve um projeto de pesquisa.
var postDevolverProjetoPesquisa = function postDevolverProjetoPesquisa(idProjetoPesquisa) {
  var PROJETOS_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa + '/devolucao';
  var config = {
    method: 'post',
    url: PROJETOS_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

// Conclui um projeto de pesquisa.
var postConcluirProjetoPesquisa = function postConcluirProjetoPesquisa(idProjetoPesquisa) {
  var PROJETOS_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa + '/conclusao';
  var config = {
    method: 'post',
    url: PROJETOS_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

// Cancela um projeto de pesquisa.
var postCancelarProjetoPesquisa = function postCancelarProjetoPesquisa(idProjetoPesquisa) {
  var PROJETOS_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa + '/cancelamento';
  var config = {
    method: 'post',
    url: PROJETOS_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

// Retorna os projetos de pesquisa dos quais o usuário logado faz parte.
var getMeusProjetosPesquisa = function getMeusProjetosPesquisa() {
  var MEUS_PROJETOS_URL = API_URL + '/pesquisa/meus-projetos';
  var config = {
    method: 'get',
    url: MEUS_PROJETOS_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

// Retorna um determinado projeto de pesquisa.
var getProjetoPesquisa = function getProjetoPesquisa(idProjetoPesquisa) {
  var PROJETO_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa;
  var config = {
    method: 'get',
    url: PROJETO_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

// Retorna as instituições de um projeto de pesquisa.
var getInstituicoesProjetoPesquisa = function getInstituicoesProjetoPesquisa(idProjetoPesquisa) {
  var INSTITUICOES_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa + '/instituicoes';
  var config = {
    method: 'get',
    url: INSTITUICOES_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

// Retorna os participantes de um projeto de pesquisa.
var getParticipantesProjetoPesquisa = function getParticipantesProjetoPesquisa(idProjetoPesquisa) {
  var PARTICIPANTES_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa + '/participantes';
  var config = {
    method: 'get',
    url: PARTICIPANTES_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

// Retorna os órgãos financiadores de um projeto de pesquisa.
var getOrgaosFinanciadoresProjetoPesquisa = function getOrgaosFinanciadoresProjetoPesquisa(idProjetoPesquisa) {
  var ORGAOS_FINANCIADORES_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa + '/orgaos-financiadores';
  var config = {
    method: 'get',
    url: ORGAOS_FINANCIADORES_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

// Retorna os arquivos de um projeto de pesquisa.
var getArquivosProjetoPesquisa = function getArquivosProjetoPesquisa(idProjetoPesquisa) {
  var ARQUIVOS_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa + '/arquivos';
  var config = {
    method: 'get',
    url: ARQUIVOS_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

// Edita um projeto de pesquisa.
var putProjetoPesquisa = function putProjetoPesquisa(idProjetoPesquisa, projetoPesquisa) {
  var PROJETO_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa;
  var config = {
    method: 'put',
    url: PROJETO_URL,
    responseType: 'text',
    credentials: true,
    body: projetoPesquisa
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

// Pesquisa órgãos financiadores por nome.
var getPesquisaOrgaosFinanciadoresPorNome = function getPesquisaOrgaosFinanciadoresPorNome(nome) {
  var PESQUISA_ORGAOS_FINANCIADORES_URL = API_URL + '/pesquisa/orgaos-financiadores';
  var config = {
    method: 'get',
    url: PESQUISA_ORGAOS_FINANCIADORES_URL,
    responseType: 'text',
    credentials: true,
    params: { nome: nome }
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

// Pesquisa órgãos financiadores por sigla.
var getPesquisaOrgaosFinanciadoresPorSigla = function getPesquisaOrgaosFinanciadoresPorSigla(sigla) {
  var PESQUISA_ORGAOS_FINANCIADORES_URL = API_URL + '/pesquisa/orgaos-financiadores';
  var config = {
    method: 'get',
    url: PESQUISA_ORGAOS_FINANCIADORES_URL,
    responseType: 'text',
    credentials: true,
    params: { sigla: sigla }
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

// Retorna um determinado órgão financiador.
var getOrgaoFinanciador = function getOrgaoFinanciador(idOrgaoFinanciador) {
  var ORGAO_FINANCIADOR_URL = API_URL + '/pesquisa/orgaos-financiadores/' + idOrgaoFinanciador;
  var config = {
    method: 'get',
    url: ORGAO_FINANCIADOR_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

// Adiciona um órgão financiador a um projeto de pesquisa.
var postOrgaoFinanciadorProjetoPesquisa = function postOrgaoFinanciadorProjetoPesquisa(idProjetoPesquisa, orgaoFinanciadorProjetoPesquisa) {
  var ORGAO_FINANCIADOR_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa + '/orgaos-financiadores';
  var config = {
    method: 'post',
    url: ORGAO_FINANCIADOR_URL,
    responseType: 'text',
    credentials: true,
    body: orgaoFinanciadorProjetoPesquisa
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

// Retorna um determinado órgão financiador de um projeto de pesquisa.
var getOrgaoFinanciadorProjetoPesquisa = function getOrgaoFinanciadorProjetoPesquisa(idProjetoPesquisa, idOrgaoFinanciadorProjetoPesquisa) {
  var ORGAO_FINANCIADOR_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa + '/orgaos-financiadores/' + idOrgaoFinanciadorProjetoPesquisa;
  var config = {
    method: 'get',
    url: ORGAO_FINANCIADOR_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

// Edita um órgão financiador de um projeto de pesquisa.
var putOrgaoFinanciadorProjetoPesquisa = function putOrgaoFinanciadorProjetoPesquisa(idProjetoPesquisa, idOrgaoFinanciadorProjetoPesquisa, orgaoFinanciadorProjetoPesquisa) {
  var ORGAO_FINANCIADOR_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa + '/orgaos-financiadores/' + idOrgaoFinanciadorProjetoPesquisa;
  var config = {
    method: 'put',
    url: ORGAO_FINANCIADOR_URL,
    responseType: 'text',
    credentials: true,
    body: orgaoFinanciadorProjetoPesquisa
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

// Exclui um órgão financiador de um projeto de pesquisa.
var deleteOrgaoFinanciadorProjetoPesquisa = function deleteOrgaoFinanciadorProjetoPesquisa(idProjetoPesquisa, idOrgaoFinanciadorProjetoPesquisa) {
  var ORGAO_FINANCIADOR_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa + '/orgaos-financiadores/' + idOrgaoFinanciadorProjetoPesquisa;
  var config = {
    method: 'delete',
    url: ORGAO_FINANCIADOR_URL,
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

// Cadastra um novo órgão financiador.
var postOrgaoFinanciador = function postOrgaoFinanciador(orgaoFinanciador) {
  var ORGAO_FINANCIADOR_URL = API_URL + '/pesquisa/orgaos-financiadores';
  var config = {
    method: 'post',
    url: ORGAO_FINANCIADOR_URL,
    responseType: 'text',
    credentials: true,
    body: orgaoFinanciador
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

// Pesquisa instituições por nome.
var getPesquisaInstituicoesPorNome = function getPesquisaInstituicoesPorNome(nome) {
  var PESQUISA_INSTITUICOES_URL = API_URL + '/pesquisa/instituicoes';
  var config = {
    method: 'get',
    url: PESQUISA_INSTITUICOES_URL,
    responseType: 'text',
    credentials: true,
    params: { nome: nome }
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

// Pesquisa instituições por sigla.
var getPesquisaInstituicoesPorSigla = function getPesquisaInstituicoesPorSigla(sigla) {
  var PESQUISA_INSTITUICOES_URL = API_URL + '/pesquisa/instituicoes';
  var config = {
    method: 'get',
    url: PESQUISA_INSTITUICOES_URL,
    responseType: 'text',
    credentials: true,
    params: { sigla: sigla }
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

// Retorna uma determinada instituição
var getInstituicao = function getInstituicao(idInstituicao) {
  var INSTITUICAO_URL = API_URL + '/pesquisa/instituicoes/' + idInstituicao;
  var config = {
    method: 'get',
    url: INSTITUICAO_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

// Adiciona uma instituição a um projeto de pesquisa.
var postInstituicaoProjetoPesquisa = function postInstituicaoProjetoPesquisa(idProjetoPesquisa, instituicaoProjetoPesquisa) {
  var INSTITUICAO_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa + '/instituicoes';
  var config = {
    method: 'post',
    url: INSTITUICAO_URL,
    responseType: 'text',
    credentials: true,
    body: instituicaoProjetoPesquisa
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

// Retorna uma determinada instituição de um projeto de pesquisa.
var getInstituicaoProjetoPesquisa = function getInstituicaoProjetoPesquisa(idProjetoPesquisa, idInstituicaoProjetoPesquisa) {
  var INSTITUICAO_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa + '/instituicoes/' + idInstituicaoProjetoPesquisa;
  var config = {
    method: 'get',
    url: INSTITUICAO_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

// Edita uma instituição de um projeto de pesquisa.
var putInstituicaoProjetoPesquisa = function putInstituicaoProjetoPesquisa(idProjetoPesquisa, idInstituicaoProjetoPesquisa, instituicaoProjetoPesquisa) {
  var INSTITUICAO_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa + '/instituicoes/' + idInstituicaoProjetoPesquisa;
  var config = {
    method: 'put',
    url: INSTITUICAO_URL,
    responseType: 'text',
    credentials: true,
    body: instituicaoProjetoPesquisa
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

// Exclui uma instituição de um projeto de pesquisa.
var deleteInstituicaoProjetoPesquisa = function deleteInstituicaoProjetoPesquisa(idProjetoPesquisa, idInstituicaoProjetoPesquisa) {
  var INSTITUICAO_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa + '/instituicoes/' + idInstituicaoProjetoPesquisa;
  var config = {
    method: 'delete',
    url: INSTITUICAO_URL,
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

// Retorna lista de países.
var getPaisesInstituicaoProjetoPesquisa = function getPaisesInstituicaoProjetoPesquisa() {
  var PAISES_INSTITUICAO_URL = API_URL + '/pesquisa/paises-instituicao';
  var config = {
    method: 'get',
    url: PAISES_INSTITUICAO_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

// Retorna lista de estados.
var getEstadosInstituicaoProjetoPesquisa = function getEstadosInstituicaoProjetoPesquisa() {
  var ESTADOS_INSTITUICAO_URL = API_URL + '/pesquisa/estados-instituicao';
  var config = {
    method: 'get',
    url: ESTADOS_INSTITUICAO_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

// Cadastra uma nova instituição.
var postInstituicao = function postInstituicao(instituicao) {
  var INSTITUICAO_URL = API_URL + '/pesquisa/instituicoes';
  var config = {
    method: 'post',
    url: INSTITUICAO_URL,
    responseType: 'text',
    credentials: true,
    body: instituicao
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

// Adiciona um participante a um projeto de pesquisa.
var postParticipanteProjetoPesquisa = function postParticipanteProjetoPesquisa(idProjetoPesquisa, participanteProjetoPesquisa) {
  var PARTICIPANTE_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa + '/participantes';
  var config = {
    method: 'post',
    url: PARTICIPANTE_URL,
    responseType: 'text',
    credentials: true,
    body: participanteProjetoPesquisa
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

// Retorna um determinado participante de um projeto de pesquisa.
var getParticipanteProjetoPesquisa = function getParticipanteProjetoPesquisa(idProjetoPesquisa, idParticipanteProjetoPesquisa) {
  var PARTICIPANTE_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa + '/participantes/' + idParticipanteProjetoPesquisa;
  var config = {
    method: 'get',
    url: PARTICIPANTE_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

// Edita um participante de um projeto de pesquisa.
var putParticipanteProjetoPesquisa = function putParticipanteProjetoPesquisa(idProjetoPesquisa, idParticipanteProjetoPesquisa, participanteProjetoPesquisa) {
  var PARTICIPANTE_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa + '/participantes/' + idParticipanteProjetoPesquisa;
  var config = {
    method: 'put',
    url: PARTICIPANTE_URL,
    responseType: 'text',
    credentials: true,
    body: participanteProjetoPesquisa
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

// Exclui um participante de um projeto de pesquisa.
var deleteParticipanteProjetoPesquisa = function deleteParticipanteProjetoPesquisa(idProjetoPesquisa, idParticipanteProjetoPesquisa) {
  var PARTICIPANTE_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa + '/participantes/' + idParticipanteProjetoPesquisa;
  var config = {
    method: 'delete',
    url: PARTICIPANTE_URL,
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

// Exclui um arquivo de um projeto de pesquisa.
var deleteArquivoProjetoPesquisa = function deleteArquivoProjetoPesquisa(idProjetoPesquisa, idArquivoProjetoPesquisa) {
  var ARQUIVOS_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa + '/arquivos/' + idArquivoProjetoPesquisa;
  var config = {
    method: 'delete',
    url: ARQUIVOS_URL,
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

// Adiciona um arquivo a um projeto de pesquisa.
var postArquivoProjetoPesquisa = function postArquivoProjetoPesquisa(idProjetoPesquisa, arquivo) {
  var ARQUIVOS_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa + '/arquivos';
  var config = {
    method: 'post',
    url: ARQUIVOS_URL,
    responseType: 'json',
    credentials: true,
    body: arquivo
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

// Edita as informações de um determinado arquivo de um projeto de pesquisa.
var putArquivoProjetoPesquisa = function putArquivoProjetoPesquisa(idProjetoPesquisa, idArquivoProjetoPesquisa, arquivo) {
  var ARQUIVOS_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa + '/arquivos/' + idArquivoProjetoPesquisa;
  var config = {
    method: 'put',
    url: ARQUIVOS_URL,
    responseType: 'json',
    credentials: true,
    body: arquivo
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

// Retorna as informações de um determinado arquivo de um projeto de pesquisa.
var getArquivoProjetoPesquisa = function getArquivoProjetoPesquisa(idProjetoPesquisa, idArquivoProjetoPesquisa) {
  var ARQUIVOS_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa + '/arquivos/' + idArquivoProjetoPesquisa + '/informacoes';
  var config = {
    method: 'get',
    url: ARQUIVOS_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getOpcoesTabelaEstruturada: getOpcoesTabelaEstruturada,
  getProjetoSIEX: getProjetoSIEX,
  getRelatorioProjeto: getRelatorioProjeto,
  getMeusProjetos: getMeusProjetos,
  getMeusProjetosAtivos: getMeusProjetosAtivos,
  getConsultaProjetos: getConsultaProjetos,
  getConsultaRelatoriosTecnicos: getConsultaRelatoriosTecnicos,
  getProjeto: getProjeto,
  deleteProjeto: deleteProjeto,
  getClassificacoesPossiveis: getClassificacoesPossiveis,
  getClassificacoesAreasDoConhecimento: getClassificacoesAreasDoConhecimento,
  getClassificacoesClassificacaoSuperior: getClassificacoesClassificacaoSuperior,
  getClassificacoesDoProjeto: getClassificacoesDoProjeto,
  getExtensaoDoProjeto: getExtensaoDoProjeto,
  getContatosDoProjeto: getContatosDoProjeto,
  getIntegrantesDoProjeto: getIntegrantesDoProjeto,
  getVinculosDoProjeto: getVinculosDoProjeto,
  getParceriasDoProjeto: getParceriasDoProjeto,
  getAtividadesDoProjeto: getAtividadesDoProjeto,
  getSuspensoes: getSuspensoes,
  getAtividade: getAtividade,
  deleteAtividade: deleteAtividade,
  getParceria: getParceria,
  putAtividade: putAtividade,
  getBolsasDoProjeto: getBolsasDoProjeto,
  getArquivosDoProjeto: getArquivosDoProjeto,
  getArquivo: getArquivo,
  getPessoasPorNome: getPessoasPorNome,
  getPessoasPorCpf: getPessoasPorCpf,
  getPessoa: getPessoa,
  putPessoa: putPessoa,
  getUnidadesExtensao: getUnidadesExtensao,
  getUnidades: getUnidades,
  postProjeto: postProjeto,
  postClassificacoesDoProjeto: postClassificacoesDoProjeto,
  postParceriasDoProjeto: postParceriasDoProjeto,
  putParceriasDoProjeto: putParceriasDoProjeto,
  postAtividadesDoProjeto: postAtividadesDoProjeto,
  putProjeto: putProjeto,
  getIntegrante: getIntegrante,
  postIntegrante: postIntegrante,
  postImportarProjetoSIEX: postImportarProjetoSIEX,
  putIntegrante: putIntegrante,
  putCoordenador: putCoordenador,
  deleteIntegrante: deleteIntegrante,
  postExtensao: postExtensao,
  postContatos: postContatos,
  postRelatorio: postRelatorio,
  postBolsista: postBolsista,
  postArquivo: postArquivo,
  putArquivo: putArquivo,
  deleteArquivo: deleteArquivo,
  deleteParceria: deleteParceria,
  getListaLocalidade: getListaLocalidade,
  getLocalidade: getLocalidade,
  postLocalidade: postLocalidade,
  putLocalidade: putLocalidade,
  deleteLocalidade: deleteLocalidade,
  getCidades: getCidades,
  getEstados: getEstados,
  postPessoa: postPessoa,
  getAcaoExtensao: getAcaoExtensao,
  postSubmissaoAprovacao: postSubmissaoAprovacao,
  postConcluirImportacao: postConcluirImportacao,
  postAprovarProjeto: postAprovarProjeto,
  postDevolverProjeto: postDevolverProjeto,
  postLiberarRelatorioFinal: postLiberarRelatorioFinal,
  postInabilitarProjeto: postInabilitarProjeto,
  postAlterarClassificacaoSecundaria: postAlterarClassificacaoSecundaria,
  postSuspenderAcaoExtensao: postSuspenderAcaoExtensao,
  postReativarAcaoExtensao: postReativarAcaoExtensao,
  postProrrogarSuspensaoAcaoExtensao: postProrrogarSuspensaoAcaoExtensao,
  postSubmissaoConclusao: postSubmissaoConclusao,
  getParcerias: getParcerias,
  getOcorrenciasIntegrante: getOcorrenciasIntegrante,
  postFinalizarProjeto: postFinalizarProjeto,
  postConcluirProjeto: postConcluirProjeto,
  postCancelarProjeto: postCancelarProjeto,
  getRelatoriosGestao: getRelatoriosGestao,
  postDesfazerFinalizacaoProjeto: postDesfazerFinalizacaoProjeto,
  postDesfazerExclusaoProjeto: postDesfazerExclusaoProjeto,
  postProjetoSuperior: postProjetoSuperior,
  getProjetosVencidos: getProjetosVencidos,
  getProjetosComRelatorioReprovavel: getProjetosComRelatorioReprovavel,
  getRegistrosDeEnvioDeRelatorioDeProjeto: getRegistrosDeEnvioDeRelatorioDeProjeto,
  getListaMensagem: getListaMensagem,
  postMensagem: postMensagem,
  deleteProjetoSuperior: deleteProjetoSuperior,
  getDuplicacao: getDuplicacao,
  postDuplicacao: postDuplicacao,
  getRelatoriosDoProjeto: getRelatoriosDoProjeto,
  getRelatorioExtensao: getRelatorioExtensao,
  postRelatorioExtensao: postRelatorioExtensao,
  putRelatorioExtensao: putRelatorioExtensao,
  postSubmeterRelatorio: postSubmeterRelatorio,
  postAprovarRelatorio: postAprovarRelatorio,
  postDevolverRelatorio: postDevolverRelatorio,
  postReprovarRelatorio: postReprovarRelatorio,
  postReprovarRelatorioComSuspensaoDeCoordenador: postReprovarRelatorioComSuspensaoDeCoordenador,
  postRegistrarEnvioDeRelatorioDeProjeto: postRegistrarEnvioDeRelatorioDeProjeto,
  deleteRegistroEnvioDeRelatorioDeProjeto: deleteRegistroEnvioDeRelatorioDeProjeto,
  putRegistroEnvioDeRelatorioDeProjeto: putRegistroEnvioDeRelatorioDeProjeto,
  postAtivarAdministrador: postAtivarAdministrador,
  postDesativarAdministrador: postDesativarAdministrador,
  getPrazoDias: getPrazoDias,
  getRelatorioTecnicoForaPrazo: getRelatorioTecnicoForaPrazo,
  getVerificarPendenciasRelatorio: getVerificarPendenciasRelatorio,
  getPeriodoRelatorio: getPeriodoRelatorio,
  getEmailCargaHorariaCoordenador: getEmailCargaHorariaCoordenador,
  getExcadServer: getExcadServer,
  getDocumentoProtocolo: getDocumentoProtocolo,
  postProjetoPesquisa: postProjetoPesquisa,
  getConsultaProjetosPesquisa: getConsultaProjetosPesquisa,
  postProjetoPesquisaRegistro: postProjetoPesquisaRegistro,
  getMeusProjetosPesquisa: getMeusProjetosPesquisa,
  getProjetoPesquisa: getProjetoPesquisa,
  getInstituicoesProjetoPesquisa: getInstituicoesProjetoPesquisa,
  getParticipantesProjetoPesquisa: getParticipantesProjetoPesquisa,
  getOrgaosFinanciadoresProjetoPesquisa: getOrgaosFinanciadoresProjetoPesquisa,
  putProjetoPesquisa: putProjetoPesquisa,
  getPesquisaOrgaosFinanciadoresPorNome: getPesquisaOrgaosFinanciadoresPorNome,
  getPesquisaOrgaosFinanciadoresPorSigla: getPesquisaOrgaosFinanciadoresPorSigla,
  getOrgaoFinanciador: getOrgaoFinanciador,
  postOrgaoFinanciadorProjetoPesquisa: postOrgaoFinanciadorProjetoPesquisa,
  getOrgaoFinanciadorProjetoPesquisa: getOrgaoFinanciadorProjetoPesquisa,
  putOrgaoFinanciadorProjetoPesquisa: putOrgaoFinanciadorProjetoPesquisa,
  deleteOrgaoFinanciadorProjetoPesquisa: deleteOrgaoFinanciadorProjetoPesquisa,
  postOrgaoFinanciador: postOrgaoFinanciador,
  getPesquisaInstituicoesPorNome: getPesquisaInstituicoesPorNome,
  getPesquisaInstituicoesPorSigla: getPesquisaInstituicoesPorSigla,
  getInstituicao: getInstituicao,
  postInstituicaoProjetoPesquisa: postInstituicaoProjetoPesquisa,
  getInstituicaoProjetoPesquisa: getInstituicaoProjetoPesquisa,
  putInstituicaoProjetoPesquisa: putInstituicaoProjetoPesquisa,
  deleteInstituicaoProjetoPesquisa: deleteInstituicaoProjetoPesquisa,
  getPaisesInstituicaoProjetoPesquisa: getPaisesInstituicaoProjetoPesquisa,
  getEstadosInstituicaoProjetoPesquisa: getEstadosInstituicaoProjetoPesquisa,
  postInstituicao: postInstituicao,
  postParticipanteProjetoPesquisa: postParticipanteProjetoPesquisa,
  getParticipanteProjetoPesquisa: getParticipanteProjetoPesquisa,
  putParticipanteProjetoPesquisa: putParticipanteProjetoPesquisa,
  deleteParticipanteProjetoPesquisa: deleteParticipanteProjetoPesquisa,
  getArquivosProjetoPesquisa: getArquivosProjetoPesquisa,
  deleteArquivoProjetoPesquisa: deleteArquivoProjetoPesquisa,
  postArquivoProjetoPesquisa: postArquivoProjetoPesquisa,
  putArquivoProjetoPesquisa: putArquivoProjetoPesquisa,
  getArquivoProjetoPesquisa: getArquivoProjetoPesquisa,
  postRegistrarProjetoPesquisa: postRegistrarProjetoPesquisa,
  postDevolverProjetoPesquisa: postDevolverProjetoPesquisa,
  postConcluirProjetoPesquisa: postConcluirProjetoPesquisa,
  postCancelarProjetoPesquisa: postCancelarProjetoPesquisa
});

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(368)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(369),
  /* template */
  __webpack_require__(370),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);

__WEBPACK_IMPORTED_MODULE_0_moment___default.a.locale('pt-br');

var methods = {
  format: function format(date) {
    if (date !== null) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('L'); // DD/MM/AAAA
    } else {
      return '-';
    }
  },
  formatMonthYear: function formatMonthYear(date) {
    if (date !== null) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('MM/YYYY'); // MM/AAAA
    } else {
      return '-';
    }
  },
  formatFirstDayMonth: function formatFirstDayMonth(date) {
    if (date !== null) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).startOf('month').format('L'); // 01/MM/AAAA
    } else {
      return '-';
    }
  },
  formatLastDayMonth: function formatLastDayMonth(date) {
    if (date !== null) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).endOf('month').format('L'); // 28/MM/AAAA ou 29/MM/AAAA ou 30/MM/AAAA ou 31/MM/AAAA (dependendo do mês)
    } else {
      return '-';
    }
  },
  formatDateHour: function formatDateHour(date) {
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('DD/MM/YYYY HH:mm:ss'); // DD/MM/AAAA
  },
  formatStyle: function formatStyle(date, style) {
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format(style);
  },
  APIFormat: function APIFormat(date) {
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('YYYY-MM-DD');
  },
  daysDiff: function daysDiff(startDate, endDate) {
    if (endDate) {
      startDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(startDate);
      endDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(endDate);
      return Math.abs(startDate.diff(endDate, 'days', true));
    } else {
      startDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(startDate);
      endDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(Date.now());
      return Math.abs(startDate.diff(endDate, 'days', true));
    }
  },
  daysDiffInteger: function daysDiffInteger(startDate, endDate) {
    if (endDate) {
      startDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(startDate);
      endDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(endDate);
      return Math.abs(startDate.diff(endDate, 'days'));
    } else {
      startDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(startDate);
      endDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(Date.now());
      return Math.abs(startDate.diff(endDate, 'days'));
    }
  },
  daysDiffSigned: function daysDiffSigned(startDate, endDate) {
    if (endDate) {
      startDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(startDate);
      endDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(endDate);
      return startDate.diff(endDate, 'days', true);
    } else {
      startDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(startDate);
      endDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(Date.now());
      return startDate.diff(endDate, 'days', true);
    }
  },
  subtract: function subtract(date, quantity, type) {
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).subtract(quantity, type).format();
  },
  add: function add(date, quantity, type) {
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).add(quantity, type).format();
  },
  now: function now() {
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()(new Date()).format();
  }
};

/* harmony default export */ __webpack_exports__["a"] = (methods);

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(375),
  /* template */
  __webpack_require__(376),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(429),
  /* template */
  __webpack_require__(430),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(384),
  /* template */
  __webpack_require__(385),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(457),
  /* template */
  __webpack_require__(458),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(418),
  /* template */
  __webpack_require__(419),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(451)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(452),
  /* template */
  __webpack_require__(453),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(29);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);

// URL and endpoint constants
var API_URL = "https://pib-api.prod.uks.ufes.br";

var getPermissoesUnidades = function getPermissoesUnidades() {
  var PERMISSOES_URL = API_URL + '/permissoes-unidades';
  var config = {
    method: 'get',
    url: PERMISSOES_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getBolsa = function getBolsa(idBolsa) {
  var BOLSA_URL = API_URL + '/bolsas/' + idBolsa;
  var config = {
    method: 'get',
    url: BOLSA_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getBolsas = function getBolsas() {
  var BOLSAS_URL = API_URL + '/bolsas';
  var config = {
    method: 'get',
    url: BOLSAS_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getBolsasGerenciadas = function getBolsasGerenciadas() {
  var BOLSAS_GERENCIADAS_URL = API_URL + '/bolsas';
  var config = {
    method: 'get',
    url: BOLSAS_GERENCIADAS_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var postBolsa = function postBolsa(idUnidade, bolsa) {
  var BOLSAS_URL = API_URL + '/unidades/' + idUnidade + '/bolsas';
  var config = {
    method: 'post',
    url: BOLSAS_URL,
    responseType: 'json',
    credentials: true,
    body: bolsa
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var putAlocacao = function putAlocacao(idBolsa, idProjeto, quantidade) {
  var ALOCACAO_URL = API_URL + '/bolsas/' + idBolsa + '/projetos/' + idProjeto;
  var config = {
    method: 'put',
    url: ALOCACAO_URL,
    responseType: 'json',
    credentials: true,
    body: { quantidade: quantidade }
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getFrequencias = function getFrequencias(idProjeto, idParticipante) {
  var FREQUENCIA_URL = API_URL + '/projetos/' + idProjeto + '/participantes/' + idParticipante + '/frequencia';
  var config = {
    method: 'get',
    url: FREQUENCIA_URL,
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var postFrequencia = function postFrequencia(idProjeto, idParticipante, frequencia) {
  var FREQUENCIA_URL = API_URL + '/projetos/' + idProjeto + '/participantes/' + idParticipante + '/frequencia';
  var config = {
    method: 'post',
    url: FREQUENCIA_URL,
    responseType: 'json',
    credentials: true,
    body: frequencia
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getPeriodoFrequencia = function getPeriodoFrequencia() {
  var FREQUENCIA_URL = API_URL + '/periodo-frequencia';
  var config = {
    method: 'get',
    url: FREQUENCIA_URL,
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var postPeriodoFrequencia = function postPeriodoFrequencia(periodoFrequencia) {
  var FREQUENCIA_URL = API_URL + '/periodo-frequencia';
  var config = {
    method: 'post',
    url: FREQUENCIA_URL,
    responseType: 'json',
    credentials: true,
    body: periodoFrequencia
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var getBolsista = function getBolsista() {
  var URL = API_URL + '/bolsista';
  var config = {
    method: 'get',
    url: URL,
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getPermissoesUnidades: getPermissoesUnidades,
  getBolsa: getBolsa,
  getBolsas: getBolsas,
  getBolsasGerenciadas: getBolsasGerenciadas,
  postBolsa: postBolsa,
  putAlocacao: putAlocacao,
  getFrequencias: getFrequencias,
  postFrequencia: postFrequencia,
  getPeriodoFrequencia: getPeriodoFrequencia,
  postPeriodoFrequencia: postPeriodoFrequencia,
  getBolsista: getBolsista
});

/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(608),
  /* template */
  __webpack_require__(615),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var methods = {
  format: function format(assessor, funcaoItem) {
    if (assessor === true) {
      return 'Sim';
    } else if (assessor === false) {
      if (funcaoItem === 1) {
        return '-';
      } else {
        return 'Não';
      }
    } else {
      return 'Inválido';
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (methods);

/***/ }),
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(554),
  /* template */
  __webpack_require__(555),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 49 */,
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var methods = {
  format: function format(situacaoAtividadeItem) {
    if (situacaoAtividadeItem === 1) {
      return 'Não iniciada';
    } else if (situacaoAtividadeItem === 2) {
      return 'Em andamento';
    } else if (situacaoAtividadeItem === 3) {
      return 'Cumprida';
    } else if (situacaoAtividadeItem === 4) {
      return 'Cancelada';
    } else {
      return '-';
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (methods);

/***/ }),
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuex_auth_module__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_ui_module__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);





// Vuex for state management

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */].Store({
  modules: {
    'auth': __WEBPACK_IMPORTED_MODULE_0__vuex_auth_module__["a" /* default */],
    'ui': __WEBPACK_IMPORTED_MODULE_1__vuex_ui_module__["a" /* default */]
  }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var types = {
  SET_LOGGED_IN: 'SET_LOGGED_IN',
  SET_USERNAME: 'SET_USERNAME',
  SET_NOME: 'SET_NOME',
  SET_VINCULO: 'SET_VINCULO',
  SET_ADMINISTRADOR: 'SET_ADMINISTRADOR',
  SET_USUARIO_PROEX: 'SET_USUARIO_PROEX',
  SET_PERMISSAO_CRIAR_PROJETO_EXTENSAO: 'SET_PERMISSAO_CRIAR_PROJETO_EXTENSAO',
  UNSET_LOGGED_IN: 'UNSET_LOGGED_IN',
  UNSET_USERNAME: 'UNSET_USERNAME',
  UNSET_NOME: 'UNSET_NOME',
  UNSET_VINCULO: 'UNSET_VINCULO',
  UNSET_ADMINISTRADOR: 'UNSET_ADMINISTRADOR',
  UNSET_USUARIO_PROEX: 'UNSET_USUARIO_PROEX',
  UNSET_PERMISSAO_CRIAR_PROJETO_EXTENSAO: 'UNSET_PERMISSAO_CRIAR_PROJETO_EXTENSAO',
  SHOW_GLOBAL_LOADING: 'ui/SHOW_GLOBAL_LOADING',
  HIDE_GLOBAL_LOADING: 'ui/HIDE_GLOBAL_LOADING',
  SHOW_SNACKBAR: 'ui/SHOW_SNACKBAR',
  HIDE_SNACKBAR: 'ui/HIDE_SNACKBAR'
};

/* harmony default export */ __webpack_exports__["a"] = (types);

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var types = {
  SHOW_GLOBAL_LOADING: 'SHOW_GLOBAL_LOADING',
  HIDE_GLOBAL_LOADING: 'HIDE_GLOBAL_LOADING',
  SHOW_SNACKBAR: 'SHOW_SNACKBAR',
  HIDE_SNACKBAR: 'HIDE_SNACKBAR',
  SHOW_CONFIRMATION_DIALOG: 'SHOW_CONFIRMATION_DIALOG',
  HIDE_CONFIRMATION_DIALOG: 'HIDE_CONFIRMATION_DIALOG',
  SHOW_MENSAGEM: 'SHOW_MENSAGEM',
  HIDE_MENSAGEM: 'HIDE_MENSAGEM',
  SET_MENSAGEM: 'SET_MENSAGEM'
};

/* harmony default export */ __webpack_exports__["a"] = (types);

/***/ }),
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(399),
  /* template */
  __webpack_require__(400),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var methods = {
  format: function format(nomeUnidade, siglaUnidade) {
    if (siglaUnidade !== null) {
      return nomeUnidade.concat(' - ', siglaUnidade);
    } else {
      return nomeUnidade;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (methods);

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(473),
  /* template */
  __webpack_require__(474),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 211 */,
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_store_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugins_vuetify_mask_js__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_resource__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__(315);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



// Vuex store


// vuetify-mask


// We will use Vuetify to make a gorgeous interface :)

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vuetify___default.a);

/* harmony default export */ __webpack_exports__["default"] = (new __WEBPACK_IMPORTED_MODULE_4_vuetify___default.a({
  theme: {
    themes: {
      light: {
        primary: '#00796b',
        secondary: '#b0bec5'
      }
    }
  }
}));

// Choose either axios + vue-axios or vue-resource. Both use 'this.$http' call,
// but only vue-resource accepts the 'finally' clause. So, if changing from vue-resource
// to axios, be careful about places where the clause 'finally' is being used

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_resource__["a" /* default */]);

// import axios from 'axios'
// import VueAxios from 'vue-axios'
// Vue.use(VueAxios, axios)

// Moment.js for data formatting
// Will add moment to Vue instance so it can be used anywhere without polluting the core scope

__WEBPACK_IMPORTED_MODULE_6_moment___default.a.locale('pt-br');
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.moment = __WEBPACK_IMPORTED_MODULE_6_moment___default.a;

// Router (Vue-router)


// Auth for existent authentication check before creating the app
// import auth from '@/utils/auth'

// Stop the browser from dealing with basic auth (its darn ugly login popup won't popup anymore)
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Redirecting all unauthorized request to the login page, no matter the origin
// Should we create pages for other errors too (like 404)?
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.interceptors.push(function (request, next) {
  next(function (response) {
    if (response.status === 401) {
      __WEBPACK_IMPORTED_MODULE_2__vuex_store_js__["a" /* default */].dispatch('auth/UNSET_LOGGED_IN');
      __WEBPACK_IMPORTED_MODULE_2__vuex_store_js__["a" /* default */].dispatch('auth/UNSET_USERNAME');
      __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */].push({ name: 'Login' });
    }
  });
});

// Vuetify styles
__webpack_require__(934);
__webpack_require__(935);
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  router: __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_2__vuex_store_js__["a" /* default */],
  el: '#app',
  template: '<app/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__app___default.a },
  vuetify: new __WEBPACK_IMPORTED_MODULE_4_vuetify___default.a()
});

/***/ }),
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(217)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(219),
  /* template */
  __webpack_require__(255),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 217 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 218 */,
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_app_layouts_app_responsive_layout__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_app_layouts_app_responsive_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_app_layouts_app_responsive_layout__);
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'app-layout': __WEBPACK_IMPORTED_MODULE_0__components_app_layouts_app_responsive_layout___default.a
  }
});

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(221)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(222),
  /* template */
  __webpack_require__(254),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-19a49244",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 221 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_app_layouts_menu_vue__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_app_layouts_menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_app_layouts_menu_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_app_layouts_content_vue__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_app_layouts_content_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_app_layouts_content_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_footer_vue__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_footer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_footer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_app_layouts_app_snackbar_snackbar__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_app_layouts_app_snackbar_snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_app_layouts_app_snackbar_snackbar__);
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    'app-menu': __WEBPACK_IMPORTED_MODULE_0__components_app_layouts_menu_vue___default.a,
    'app-content': __WEBPACK_IMPORTED_MODULE_1__components_app_layouts_content_vue___default.a,
    'app-footer': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_footer_vue___default.a,
    'app-snackbar': __WEBPACK_IMPORTED_MODULE_3__components_app_layouts_app_snackbar_snackbar___default.a
  }
});

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(224)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(225),
  /* template */
  __webpack_require__(236),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ea57fd3c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 224 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  // Menu items from left to right
  data: function data() {
    return {
      drawer: false,
      items: [{ icon: 'content_paste', text: 'Meus Projetos', link: 'MeusProjetos', publico: false, id: 1 }, { icon: 'search', text: 'Consulta', link: 'ConsultaProjetos', publico: true, id: 2 }, { icon: 'create', text: 'Novo Projeto', link: 'NovoProjeto', publico: false, id: 3 }, { icon: 'create', text: 'Administração', link: 'Administracao', publico: false, id: 4 },
      // { icon: 'account_balance_wallet', text: 'Bolsas', link: 'ListaBolsas', publico: true, id: 4 },
      { icon: 'help', text: 'Ajuda', link: 'Ajuda', publico: true, id: 5
        // { icon: 'help', text: 'Pesquisa', link: 'Pesquisa', publico: true, id: 6 }
      }]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('auth', ['logged', 'username', 'nome', 'vinculo', 'permissaoCriarProjetoExtensao', 'administrador']), {
    isMdAndUp: function isMdAndUp() {
      var mdAndUp = this.$vuetify.breakpoint.mdAndUp;
      if (mdAndUp) {
        this.drawer = false;
      }
      return mdAndUp;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('auth', ['PERFORM_LOGOUT']))
});

/***/ }),
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-navigation-drawer', {
    class: {
      'hidden-md-and-up': _vm.isMdAndUp
    },
    attrs: {
      "temporary": "",
      "absolute": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', [_vm._l((_vm.items), function(item, i) {
    return (item.publico || (_vm.logged && (item.id !== 3 || _vm.permissaoCriarProjetoExtensao === true))) ? _c('v-list-item', {
      key: i,
      attrs: {
        "to": {
          name: item.link
        }
      }
    }, [_c('v-list-item-action', [_c('v-icon', [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(item.text))])], 1)], 1) : _vm._e()
  }), _vm._v(" "), (_vm.logged) ? _c('v-list-item', {
    on: {
      "click": _vm.PERFORM_LOGOUT
    }
  }, [_c('v-list-item-action', [_c('v-icon', [_vm._v("exit_to_app")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Sair")])], 1)], 1) : _vm._e()], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "text": "",
      "fixed": "",
      "dark": ""
    }
  }, [_c('v-avatar', {
    attrs: {
      "tile": true,
      "size": "50px"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(237),
      "alt": "logo"
    }
  })]), _vm._v(" "), _c('v-app-bar-nav-icon', {
    class: {
      'hidden-md-and-up': _vm.isMdAndUp
    },
    attrs: {
      "app": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Portal dos Projetos")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', {
    staticClass: "hidden-sm-and-down text-xs-right"
  }, [_vm._l((_vm.items), function(item, i) {
    return [(item.publico || (_vm.logged && item.id === 1) || (_vm.permissaoCriarProjetoExtensao && item.id === 3) || (_vm.administrador && item.id === 4)) ? _c('v-btn', {
      key: i,
      attrs: {
        "text": "",
        "to": {
          name: item.link
        }
      }
    }, [_vm._v(" " + _vm._s(item.text) + " ")]) : _vm._e()]
  })], 2), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.logged) ? _c('span', [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("account_circle")]), _vm._v("\n      " + _vm._s(_vm.username) + " ("), _c('a', {
    staticClass: "nav_link",
    on: {
      "click": function($event) {
        return _vm.PERFORM_LOGOUT()
      }
    }
  }, [_c('strong', [_vm._v("sair")])]), _vm._v(")\n    ")], 1) : _c('span', [_vm._v("\n      Por favor, realize o "), _c('router-link', {
    staticClass: "nav_link",
    attrs: {
      "to": {
        name: 'Login'
      }
    }
  }, [_vm._v("Login")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo_ufes.d06dd1c.png";

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(239)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(240),
  /* template */
  __webpack_require__(245),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 239 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_app_layouts_app_loading_dialog_loading__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_app_layouts_app_loading_dialog_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_app_layouts_app_loading_dialog_loading__);
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { 'app-loading-dialog': __WEBPACK_IMPORTED_MODULE_0__components_app_layouts_app_loading_dialog_loading___default.a }
});

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(242)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(243),
  /* template */
  __webpack_require__(244),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-59530995",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 242 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      dialog: true
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('ui', ['globalLoadingMessageArray', 'globalLoadingTitle', 'globalLoading', 'exibirMensagem', 'tituloMensagem', 'textoMensagem']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('auth', ['logged'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('ui', ['SHOW_MENSAGEM', 'HIDE_MENSAGEM']), {
    clicouCiente: function clicouCiente() {
      this.HIDE_MENSAGEM();
    }
  })
});

/***/ }),
/* 244 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.logged) ? _c('v-dialog', {
    attrs: {
      "transition": "false",
      "persistent": "",
      "width": "350"
    },
    model: {
      value: (_vm.exibirMensagem),
      callback: function($$v) {
        _vm.exibirMensagem = $$v
      },
      expression: "exibirMensagem"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_vm._v(_vm._s(this.tituloMensagem))])], 1), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_vm._v(_vm._s(this.textoMensagem))])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.clicouCiente()
      }
    }
  }, [_vm._v("Ciente")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "transition": "false",
      "persistent": "",
      "width": "350"
    },
    model: {
      value: (_vm.globalLoading),
      callback: function($$v) {
        _vm.globalLoading = $$v
      },
      expression: "globalLoading"
    }
  }, [_c('v-card', [_c('v-container', {
    attrs: {
      "fill-height": ""
    }
  }, [_c('v-layout', [_c('v-flex', [_c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-progress-circular', {
    staticClass: "blue--text",
    attrs: {
      "indeterminate": "",
      "size": 70,
      "width": 5
    }
  })], 1), _vm._v(" "), _c('h3', {
    staticClass: "headline mb-0",
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Por favor, aguarde.")]), _vm._v(" "), _vm._l((_vm.globalLoadingMessageArray), function(item) {
    return _c('h3', {
      attrs: {
        "align": "center"
      }
    }, [_vm._v(_vm._s(item))])
  })], 2)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 245 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-content', [_c('app-loading-dialog'), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(247)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(248),
  /* template */
  __webpack_require__(249),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-59fed644",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 247 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 249 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-footer', {
    attrs: {
      "app": "",
      "absolute": "",
      "dark": ""
    }
  }, [_c('v-card', {
    staticClass: "flex"
  }, [_c('v-card-actions', {
    staticClass: "justify-center"
  }, [_vm._v("\n      ©" + _vm._s(new Date().getFullYear()) + " — Superintendência de Tecnologia da Informação - UFES\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(251)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(252),
  /* template */
  __webpack_require__(253),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 251 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('ui', ['snackbarType', 'snackbarText', 'snackbar'])),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('ui', ['HIDE_SNACKBAR']))
});

/***/ }),
/* 253 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-snackbar', {
    attrs: {
      "timeout": 0,
      "multi-line": "",
      "color": _vm.snackbarType,
      "default": "",
      "bottom": ""
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.snackbarText) + "\n  "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "text": "",
      "left": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.HIDE_SNACKBAR()
      }
    }
  }, [_vm._v("fechar")])], 1)
},staticRenderFns: []}

/***/ }),
/* 254 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "fill-height": ""
    }
  }, [(!_vm.$route.meta.plainLayout) ? _c('app-menu') : _vm._e(), _vm._v(" "), _c('app-content'), _vm._v(" "), (!_vm.$route.meta.plainLayout) ? _c('app-footer') : _vm._e(), _vm._v(" "), _c('app-snackbar')], 1)
},staticRenderFns: []}

/***/ }),
/* 255 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('app-layout')
},staticRenderFns: []}

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuex_auth_state_js__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_auth_getters_js__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_auth_mutations_js__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_auth_actions_js__ = __webpack_require__(263);





var module = {
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__vuex_auth_state_js__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__vuex_auth_getters_js__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__vuex_auth_mutations_js__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__vuex_auth_actions_js__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  logged: false,
  username: '',
  nome: '',
  vinculo: '',
  administrador: false,
  usuarioPROEX: false,
  permissaoCriarProjetoExtensao: false
};

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getters = {
  logged: function logged(state) {
    return state.logged;
  },
  username: function username(state) {
    return state.username;
  },
  nome: function nome(state) {
    return state.nome;
  },
  vinculo: function vinculo(state) {
    return state.vinculo;
  },
  administrador: function administrador(state) {
    return state.administrador;
  },
  usuarioPROEX: function usuarioPROEX(state) {
    return state.usuarioPROEX;
  },
  permissaoCriarProjetoExtensao: function permissaoCriarProjetoExtensao(state) {
    return state.permissaoCriarProjetoExtensao;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_auth_mutations_types_js__ = __webpack_require__(61);


var _mutations;



var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_auth_mutations_types_js__["a" /* default */].SET_LOGGED_IN, function (state) {
  state.logged = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_auth_mutations_types_js__["a" /* default */].UNSET_LOGGED_IN, function (state) {
  state.logged = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_auth_mutations_types_js__["a" /* default */].SET_USERNAME, function (state, payload) {
  state.username = payload.username;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_auth_mutations_types_js__["a" /* default */].UNSET_USERNAME, function (state) {
  state.username = '';
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_auth_mutations_types_js__["a" /* default */].SET_NOME, function (state, payload) {
  state.nome = payload.nome;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_auth_mutations_types_js__["a" /* default */].UNSET_NOME, function (state) {
  state.nome = '';
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_auth_mutations_types_js__["a" /* default */].SET_VINCULO, function (state, payload) {
  state.vinculo = payload.vinculo;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_auth_mutations_types_js__["a" /* default */].UNSET_VINCULO, function (state) {
  state.vinculo = '';
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_auth_mutations_types_js__["a" /* default */].SET_ADMINISTRADOR, function (state, payload) {
  state.administrador = payload.administrador;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_auth_mutations_types_js__["a" /* default */].UNSET_ADMINISTRADOR, function (state) {
  state.administrador = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_auth_mutations_types_js__["a" /* default */].SET_USUARIO_PROEX, function (state, payload) {
  state.usuarioPROEX = payload.usuarioPROEX;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_auth_mutations_types_js__["a" /* default */].UNSET_USUARIO_PROEX, function (state) {
  state.usuarioPROEX = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_auth_mutations_types_js__["a" /* default */].SET_PERMISSAO_CRIAR_PROJETO_EXTENSAO, function (state, payload) {
  state.permissaoCriarProjetoExtensao = payload.permissaoCriarProjetoExtensao;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_auth_mutations_types_js__["a" /* default */].UNSET_PERMISSAO_CRIAR_PROJETO_EXTENSAO, function (state) {
  state.permissaoCriarProjetoExtensao = '';
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_auth_actions_types__ = __webpack_require__(264);


var _actions;


// import auth from '@/utils/auth'

// URL and endpoint constants
var API_URL = "https://pib-api.prod.uks.ufes.br";

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__vuex_auth_actions_types__["a" /* default */].SET_LOGGED_IN, function (_ref) {
  var commit = _ref.commit;

  commit(__WEBPACK_IMPORTED_MODULE_1__vuex_auth_actions_types__["a" /* default */].SET_LOGGED_IN);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__vuex_auth_actions_types__["a" /* default */].UNSET_LOGGED_IN, function (_ref2) {
  var commit = _ref2.commit;

  commit(__WEBPACK_IMPORTED_MODULE_1__vuex_auth_actions_types__["a" /* default */].UNSET_LOGGED_IN);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__vuex_auth_actions_types__["a" /* default */].SET_USERNAME, function (_ref3, payload) {
  var commit = _ref3.commit;

  commit(__WEBPACK_IMPORTED_MODULE_1__vuex_auth_actions_types__["a" /* default */].SET_USERNAME, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__vuex_auth_actions_types__["a" /* default */].UNSET_USERNAME, function (_ref4) {
  var commit = _ref4.commit;

  commit(__WEBPACK_IMPORTED_MODULE_1__vuex_auth_actions_types__["a" /* default */].UNSET_USERNAME);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__vuex_auth_actions_types__["a" /* default */].SET_NOME, function (_ref5, payload) {
  var commit = _ref5.commit;

  commit(__WEBPACK_IMPORTED_MODULE_1__vuex_auth_actions_types__["a" /* default */].SET_NOME, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__vuex_auth_actions_types__["a" /* default */].UNSET_NOME, function (_ref6) {
  var commit = _ref6.commit;

  commit(__WEBPACK_IMPORTED_MODULE_1__vuex_auth_actions_types__["a" /* default */].UNSET_NOME);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__vuex_auth_actions_types__["a" /* default */].SET_VINCULO, function (_ref7, payload) {
  var commit = _ref7.commit;

  commit(__WEBPACK_IMPORTED_MODULE_1__vuex_auth_actions_types__["a" /* default */].SET_VINCULO, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__vuex_auth_actions_types__["a" /* default */].UNSET_VINCULO, function (_ref8) {
  var commit = _ref8.commit;

  commit(__WEBPACK_IMPORTED_MODULE_1__vuex_auth_actions_types__["a" /* default */].UNSET_VINCULO);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__vuex_auth_actions_types__["a" /* default */].SET_ADMINISTRADOR, function (_ref9, payload) {
  var commit = _ref9.commit;

  commit(__WEBPACK_IMPORTED_MODULE_1__vuex_auth_actions_types__["a" /* default */].SET_ADMINISTRADOR, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__vuex_auth_actions_types__["a" /* default */].UNSET_ADMINISTRADOR, function (_ref10) {
  var commit = _ref10.commit;

  commit(__WEBPACK_IMPORTED_MODULE_1__vuex_auth_actions_types__["a" /* default */].UNSET_ADMINISTRADOR);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__vuex_auth_actions_types__["a" /* default */].SET_USUARIO_PROEX, function (_ref11, payload) {
  var commit = _ref11.commit;

  commit(__WEBPACK_IMPORTED_MODULE_1__vuex_auth_actions_types__["a" /* default */].SET_USUARIO_PROEX, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__vuex_auth_actions_types__["a" /* default */].UNSET_USUARIO_PROEX, function (_ref12) {
  var commit = _ref12.commit;

  commit(__WEBPACK_IMPORTED_MODULE_1__vuex_auth_actions_types__["a" /* default */].UNSET_USUARIO_PROEX);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__vuex_auth_actions_types__["a" /* default */].SET_PERMISSAO_CRIAR_PROJETO_EXTENSAO, function (_ref13, payload) {
  var commit = _ref13.commit;

  commit(__WEBPACK_IMPORTED_MODULE_1__vuex_auth_actions_types__["a" /* default */].SET_PERMISSAO_CRIAR_PROJETO_EXTENSAO, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__vuex_auth_actions_types__["a" /* default */].UNSET_PERMISSAO_CRIAR_PROJETO_EXTENSAO, function (_ref14) {
  var commit = _ref14.commit;

  commit(__WEBPACK_IMPORTED_MODULE_1__vuex_auth_actions_types__["a" /* default */].UNSET_PERMISSAO_CRIAR_PROJETO_EXTENSAO);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__vuex_auth_actions_types__["a" /* default */].PERFORM_LOGOUT, function (_ref15) {
  var commit = _ref15.commit;

  commit(__WEBPACK_IMPORTED_MODULE_1__vuex_auth_actions_types__["a" /* default */].UNSET_USERNAME);
  commit(__WEBPACK_IMPORTED_MODULE_1__vuex_auth_actions_types__["a" /* default */].UNSET_LOGGED_IN);
  commit(__WEBPACK_IMPORTED_MODULE_1__vuex_auth_actions_types__["a" /* default */].UNSET_NOME);
  commit(__WEBPACK_IMPORTED_MODULE_1__vuex_auth_actions_types__["a" /* default */].UNSET_VINCULO);

  window.location = encodeURI(API_URL + '/logout');
}), _actions);

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_auth_mutations_types_js__ = __webpack_require__(61);


var types = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__vuex_auth_mutations_types_js__["a" /* default */], {
  PERFORM_LOGIN: 'PERFORM_LOGIN',
  PERFORM_LOGOUT: 'PERFORM_LOGOUT'
});

/* harmony default export */ __webpack_exports__["a"] = (types);

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuex_ui_state_js__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_ui_getters_js__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_ui_mutations_js__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_ui_actions_js__ = __webpack_require__(269);





var module = {
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__vuex_ui_state_js__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__vuex_ui_getters_js__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__vuex_ui_mutations_js__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__vuex_ui_actions_js__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (module);

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  globalLoading: false,
  globalLoadingMessageArray: [],
  snackbar: false,
  snackbarType: '',
  snackbarText: '',
  confirmationDialog: false,
  confirmationDialogConfig: {},
  exibirMensagem: false,
  tituloMensagem: '',
  textoMensagem: ''
};

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getters = {
  globalLoading: function globalLoading(state) {
    return state.globalLoading;
  },
  globalLoadingMessageArray: function globalLoadingMessageArray(state) {
    return state.globalLoadingMessageArray;
  },
  snackbar: function snackbar(state) {
    return state.snackbar;
  },
  snackbarType: function snackbarType(state) {
    return state.snackbarType;
  },
  snackbarText: function snackbarText(state) {
    return state.snackbarText;
  },
  confirmationDialog: function confirmationDialog(state) {
    return state.confirmationDialog;
  },
  confirmationDialogConfig: function confirmationDialogConfig(state) {
    return state.confirmationDialogConfig;
  },
  exibirMensagem: function exibirMensagem(state) {
    return state.exibirMensagem;
  },
  tituloMensagem: function tituloMensagem(state) {
    return state.tituloMensagem;
  },
  textoMensagem: function textoMensagem(state) {
    return state.textoMensagem;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_ui_mutations_types_js__ = __webpack_require__(62);


var _mutations;



var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_ui_mutations_types_js__["a" /* default */].SHOW_GLOBAL_LOADING, function (state, payload) {
  state.globalLoadingMessageArray.unshift(payload.globalLoadingTitle);
  state.globalLoading = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_ui_mutations_types_js__["a" /* default */].HIDE_GLOBAL_LOADING, function (state, payload) {
  var achou = false;
  if (payload && payload.globalLoadingTitle) {
    for (var i = 0; i < state.globalLoadingMessageArray.length; i++) {
      if (state.globalLoadingMessageArray[i] === payload.globalLoadingTitle) {
        state.globalLoadingMessageArray.splice(i, 1);
        achou = true;
        break;
      }
    }
  }
  // Se não tiver payload ou a mensagem estiver errada, tira uma mensagem
  // qualquer para o loading não ficar rodando infinitamente
  if (achou === false) {
    state.globalLoadingMessageArray.pop();
  }
  if (state.globalLoadingMessageArray.length === 0) {
    state.globalLoading = false;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_ui_mutations_types_js__["a" /* default */].SHOW_SNACKBAR, function (state, payload) {
  state.snackbarType = payload.snackbarType;
  state.snackbarText = payload.snackbarText;
  state.snackbar = true;
  setTimeout(function () {
    state.snackbar = false;
  }, 20000);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_ui_mutations_types_js__["a" /* default */].HIDE_SNACKBAR, function (state) {
  state.snackbar = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_ui_mutations_types_js__["a" /* default */].SHOW_CONFIRMATION_DIALOG, function (state, payload) {
  state.confirmationDialogConfig.textoPergunta = payload.textoPergunta ? payload.textoPergunta : 'Deseja proceder com sua ação?';
  state.confirmationDialogConfig.textoConteudo = payload.textoConteudo ? payload.textoConteudo : 'Ao confirmar, sua ação será executada. Cancele caso não tenha certeza e acesse nossa seção de ajuda.';
  state.confirmationDialogConfig.textoNao = payload.textoNao ? payload.textoNao : 'Não';
  state.confirmationDialogConfig.textoSim = payload.textoSim ? payload.textoSim : 'Sim';
  state.confirmationDialogConfig.confirmacaoCallback = payload.confirmacaoCallback;
  state.confirmationDialog = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_ui_mutations_types_js__["a" /* default */].HIDE_CONFIRMATION_DIALOG, function (state) {
  state.confirmationDialog = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_ui_mutations_types_js__["a" /* default */].SHOW_MENSAGEM, function (state, payload) {
  state.exibirMensagem = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_ui_mutations_types_js__["a" /* default */].HIDE_MENSAGEM, function (state) {
  state.exibirMensagem = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_ui_mutations_types_js__["a" /* default */].SET_MENSAGEM, function (state, payload) {
  state.tituloMensagem = payload.titulo;
  state.textoMensagem = payload.texto;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__vuex_ui_mutations_types_js__["a" /* default */].SET_TEXTO_MENSAGEM, function (state, payload) {
  state.textoMensagem = payload;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_ui_actions_types__ = __webpack_require__(270);


var _actions;



var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__vuex_ui_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, function (_ref, payload) {
  var commit = _ref.commit;

  commit(__WEBPACK_IMPORTED_MODULE_1__vuex_ui_actions_types__["a" /* default */].SHOW_GLOBAL_LOADING, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__vuex_ui_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING, function (_ref2) {
  var commit = _ref2.commit;

  commit(__WEBPACK_IMPORTED_MODULE_1__vuex_ui_actions_types__["a" /* default */].HIDE_GLOBAL_LOADING);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__vuex_ui_actions_types__["a" /* default */].SHOW_SNACKBAR, function (_ref3, payload) {
  var commit = _ref3.commit;

  commit(__WEBPACK_IMPORTED_MODULE_1__vuex_ui_actions_types__["a" /* default */].SHOW_SNACKBAR, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__vuex_ui_actions_types__["a" /* default */].HIDE_SNACKBAR, function (_ref4) {
  var commit = _ref4.commit;

  commit(__WEBPACK_IMPORTED_MODULE_1__vuex_ui_actions_types__["a" /* default */].HIDE_SNACKBAR);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__vuex_ui_actions_types__["a" /* default */].SHOW_CONFIRMATION_DIALOG, function (_ref5, payload) {
  var commit = _ref5.commit;

  commit(__WEBPACK_IMPORTED_MODULE_1__vuex_ui_actions_types__["a" /* default */].SHOW_CONFIRMATION_DIALOG, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__vuex_ui_actions_types__["a" /* default */].HIDE_CONFIRMATION_DIALOG, function (_ref6) {
  var commit = _ref6.commit;

  commit(__WEBPACK_IMPORTED_MODULE_1__vuex_ui_actions_types__["a" /* default */].HIDE_CONFIRMATION_DIALOG);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__vuex_ui_actions_types__["a" /* default */].SET_MENSAGEM, function (_ref7, payload) {
  var commit = _ref7.commit;

  commit(__WEBPACK_IMPORTED_MODULE_1__vuex_ui_actions_types__["a" /* default */].SET_MENSAGEM, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__vuex_ui_actions_types__["a" /* default */].SHOW_MENSAGEM, function (_ref8, payload) {
  var commit = _ref8.commit;

  commit(__WEBPACK_IMPORTED_MODULE_1__vuex_ui_actions_types__["a" /* default */].SHOW_MENSAGEM);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__vuex_ui_actions_types__["a" /* default */].HIDE_MENSAGEM, function (_ref9, payload) {
  var commit = _ref9.commit;

  commit(__WEBPACK_IMPORTED_MODULE_1__vuex_ui_actions_types__["a" /* default */].HIDE_MENSAGEM);
}), _actions);

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_ui_mutations_types_js__ = __webpack_require__(62);


var types = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__vuex_ui_mutations_types_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (types);

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify_mask__ = __webpack_require__(272);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuetify_mask__["a" /* default */]);
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_1_vuetify_mask__["a" /* default */]);

/***/ }),
/* 272 */,
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(274),
  /* template */
  __webpack_require__(278),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  model: { prop: "value", event: "input" },
  props: {
    value: {
      type: [String, Number],
      default: "0"
    },
    label: {
      type: String,
      default: ""
    },
    properties: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    options: {
      type: Object,
      default: function _default() {
        return {
          locale: "pt-BR",
          length: 11,
          precision: 2,
          empty: null
        };
      }
    }
  },
  data: function data() {
    return {};
  },
  /*
   v-model="cmpValue": Dessa forma, ao digitar, o valor é atualizado automaticamente no componente pai.
   O valor digitado entra pelo newValue do Set é emitido para o componente pai, retorna pelo get e pára.
  */
  computed: {
    cmpValue: {
      get: function get() {
        return this.humanFormat(this.value);
      },
      set: function set(newValue) {
        this.$emit("input", this.machineFormat(newValue));
      }
    }
  },
  watch: {},
  methods: {
    humanFormat: function humanFormat(value) {
      if (value || value === 0) {
        value = Number(value).toLocaleString(this.options.locale, {
          maximumFractionDigits: this.options.precision,
          minimumFractionDigits: this.options.precision
        });
      } else {
        value = this.options.empty;
      }
      return value;
    },

    machineFormat: function machineFormat(value) {
      if (value) {
        value = this.clearNumber(value);
        // Ajustar quantidade de zeros à esquerda
        value = value.padStart(parseInt(this.options.precision) + 1, "0");
        // Incluir ponto na casa correta, conforme a precisão configurada
        value = value.substring(0, value.length - parseInt(this.options.precision)) + "." + value.substring(value.length - parseInt(this.options.precision), value.length);
        if (value === "") {
          value = this.options.empty;
        }
      } else {
        value = this.options.empty;
      }
      return value;
    },


    // Retira todos os caracteres não numéricos e zeros à esquerda
    clearNumber: function clearNumber(value) {
      var result = "";
      if (value) {
        var flag = false;
        var arrayValue = value.toString().split("");
        for (var i = 0; i < arrayValue.length; i++) {
          if (this.isInteger(arrayValue[i])) {
            if (!flag) {
              // Retirar zeros à esquerda
              if (arrayValue[i] !== "0") {
                result = result + arrayValue[i];
                flag = true;
              } else {
                // Permitir zero quando valor igual a zero - Tipo 3 (Money or Percent)
                if (Number(value) === 0) {
                  result = result + arrayValue[i];
                }
              }
            } else {
              result = result + arrayValue[i];
            }
          }
        }
      }
      return result;
    },

    keyPress: function keyPress($event) {
      // console.log($event.keyCode); //keyCodes value
      var keyCode = $event.keyCode ? $event.keyCode : $event.which;
      // if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
      if (keyCode < 48 || keyCode > 57) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    isInteger: function isInteger(value) {
      var result = false;
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(parseInt(value))) {
        result = true;
      }
      return result;
    },
    focus: function focus() {
      var _this = this;

      setTimeout(function () {
        _this.$refs.ref.focus();
      }, 500);
    }
  }
});

/***/ }),
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-text-field', _vm._b({
    ref: "ref",
    attrs: {
      "label": _vm.label,
      "maxlength": _vm.options.length + _vm.options.precision
    },
    on: {
      "keypress": _vm.keyPress,
      "blur": function($event) {
        return _vm.$emit('blur')
      },
      "change": function($event) {
        return _vm.$emit('change')
      },
      "click": function($event) {
        return _vm.$emit('click')
      },
      "focus": function($event) {
        return _vm.$emit('focus')
      },
      "keydown": function($event) {
        return _vm.$emit('keydown')
      },
      "mousedown": function($event) {
        return _vm.$emit('mousedown')
      },
      "mouseup": function($event) {
        return _vm.$emit('mouseup')
      }
    },
    model: {
      value: (_vm.cmpValue),
      callback: function($$v) {
        _vm.cmpValue = $$v
      },
      expression: "cmpValue"
    }
  }, 'v-text-field', _vm.properties, false))], 1)
},staticRenderFns: []}

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(280),
  /* template */
  __webpack_require__(281),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  model: { prop: "value", event: "input" },
  props: {
    value: {
      type: [String, Number],
      default: "0"
    },
    label: {
      type: String,
      default: ""
    },
    properties: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    options: {
      type: Object,
      default: function _default() {
        return {
          inputMask: "#########",
          outputMask: "#########",
          empty: "",
          applyAfter: false
        };
      }
    }
  },
  data: function data() {
    return {};
  },
  /*
   v-model="cmpValue": Dessa forma, ao digitar, o valor é atualizado automaticamente no componente pai.
   O valor digitado entra pelo newValue do Set é emitido para o componente pai, retorna pelo get e pára.
  */
  computed: {
    cmpValue: {
      get: function get() {
        return this.humanFormat(String(this.value));
      },
      set: function set(newValue) {
        this.$emit("input", this.machineFormat(newValue));
      }
    }
  },
  watch: {},
  methods: {
    humanFormat: function humanFormat(value) {
      if (value) {
        value = this.formatValue(value, this.options.inputMask);
      } else {
        value = this.options.empty;
      }
      return value;
    },

    machineFormat: function machineFormat(value) {
      if (value) {
        value = this.formatValue(value, this.options.outputMask);
        if (value === "") {
          value = this.options.empty;
        }
        // Apply the mask only only after filling
        if (this.options.applyAfter) {
          if (value.length !== this.options.outputMask.length) {
            value = this.options.empty;
          } else {
            // Event sended after filling the mask
            this.$emit("masked");
          }
        }
      } else {
        value = this.options.empty;
      }
      return value;
    },


    formatValue: function formatValue(value, mask) {
      return this.formatDefault(value, mask);
    },

    formatDefault: function formatDefault(value, mask) {
      value = this.clearValue(value);
      var result = "";
      var count = 0;
      if (value) {
        var arrayValue = value.toString().split("");
        var arrayMask = mask.toString().split("");
        for (var i = 0; i < arrayMask.length; i++) {
          if (i < arrayValue.length + count) {
            if (arrayMask[i] === "#") {
              result = result + arrayValue[i - count];
            } else {
              result = result + arrayMask[i];
              count++;
            }
          }
        }
      }
      return result;
    },

    keyPress: function keyPress($event) {
      // console.log($event.keyCode); //keyCodes value
      var keyCode = $event.keyCode ? $event.keyCode : $event.which;
      // if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
      if (keyCode < 48 || keyCode > 57) {
        // 46 is dot
        $event.preventDefault();
      }
    },


    clearValue: function clearValue(value) {
      var result = "";
      if (value) {
        var arrayValue = value.toString().split("");
        for (var i = 0; i < arrayValue.length; i++) {
          if (this.isInteger(arrayValue[i])) {
            result = result + arrayValue[i];
          }
        }
      }
      return result;
    },

    isInteger: function isInteger(value) {
      var result = false;
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(parseInt(value))) {
        result = true;
      }
      return result;
    },
    focus: function focus() {
      var _this = this;

      setTimeout(function () {
        _this.$refs.ref.focus();
      }, 500);
    }
  }
});

/***/ }),
/* 281 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-text-field', _vm._b({
    ref: "ref",
    attrs: {
      "label": _vm.label,
      "maxlength": _vm.options.inputMask.length
    },
    on: {
      "keypress": _vm.keyPress,
      "blur": function($event) {
        return _vm.$emit('blur')
      },
      "change": function($event) {
        return _vm.$emit('change')
      },
      "click": function($event) {
        return _vm.$emit('click')
      },
      "focus": function($event) {
        return _vm.$emit('focus')
      },
      "keydown": function($event) {
        return _vm.$emit('keydown')
      },
      "mousedown": function($event) {
        return _vm.$emit('mousedown')
      },
      "mouseup": function($event) {
        return _vm.$emit('mouseup')
      }
    },
    model: {
      value: (_vm.cmpValue),
      callback: function($$v) {
        _vm.cmpValue = $$v
      },
      expression: "cmpValue"
    }
  }, 'v-text-field', _vm.properties, false))], 1)
},staticRenderFns: []}

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(283),
  /* template */
  __webpack_require__(291),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  model: { prop: "value", event: "input" },
  props: {
    value: {
      type: [String, Number],
      default: "0"
    },
    label: {
      type: String,
      default: ""
    },
    properties: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    options: {
      type: Object,
      default: function _default() {
        return {
          inputMask: "YYYY-MM-DD HH:mm:ss",
          empty: ""
        };
      }
    }
  },
  data: function data() {
    return {};
  },
  /*
   v-model="cmpValue": Dessa forma, ao digitar, o valor é atualizado automaticamente no componente pai.
   O valor digitado entra pelo newValue do Set é emitido para o componente pai, retorna pelo get e pára.
  */
  computed: {
    cmpValue: {
      get: function get() {
        return this.humanFormat(this.value);
      },
      set: function set(newValue) {
        this.$emit("input", this.machineFormat(newValue));
      }
    }
  },
  watch: {},
  methods: {
    humanFormat: function humanFormat(value) {
      if (value) {
        value = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.toDate(this.toInteger(value))).format(this.options.inputMask);
      } else {
        value = this.options.empty;
      }
      return value;
    },

    machineFormat: function machineFormat(value) {
      if (value) {
        value = this.formatValue(value, this.options.inputMask);
        if (value === "") {
          value = this.options.empty;
        } else {
          // Apply the mask only only after filling
          if (value.length !== this.options.inputMask.length) {
            value = this.options.empty;
          } else {
            var stringDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()(value, this.options.inputMask).format("YYYY-MM-DD HH:mm:ss");
            value = this.toMillisecond(stringDate);
            if (!value) {
              value = this.options.empty;
            } else {
              // Event sended after filling the mask
              this.$emit("masked");
            }
          }
        }
      } else {
        value = this.options.empty;
      }
      return value;
    },


    formatValue: function formatValue(value, mask) {
      return this.formatDate(value, mask);
    },

    formatDate: function formatDate(value, mask) {
      value = this.clearValue(value);
      var result = "";
      var count = 0;
      if (value) {
        var arrayValue = value.toString().split("");
        var arrayMask = mask.toString().split("");
        for (var i = 0; i < arrayMask.length; i++) {
          if (i < arrayValue.length + count) {
            if (arrayMask[i].toLowerCase().includes("y") || arrayMask[i].toLowerCase().includes("m") || arrayMask[i].toLowerCase().includes("d") || arrayMask[i].toLowerCase().includes("h") || arrayMask[i].toLowerCase().includes("m") || arrayMask[i].toLowerCase().includes("s")) {
              result = result + arrayValue[i - count];
            } else {
              result = result + arrayMask[i];
              count++;
            }
          }
        }
      }
      return result;
    },

    keyPress: function keyPress($event) {
      // console.log($event.keyCode); //keyCodes value
      var keyCode = $event.keyCode ? $event.keyCode : $event.which;
      // if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
      if (keyCode < 48 || keyCode > 57) {
        // 46 is dot
        $event.preventDefault();
      }
    },


    clearValue: function clearValue(value) {
      var result = "";
      if (value) {
        var arrayValue = value.toString().split("");
        for (var i = 0; i < arrayValue.length; i++) {
          if (this.isInteger(arrayValue[i])) {
            result = result + arrayValue[i];
          }
        }
      }
      return result;
    },

    isInteger: function isInteger(value) {
      var result = false;
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default()(parseInt(value))) {
        result = true;
      }
      return result;
    },
    toInteger: function toInteger(value) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(value);
    },


    /* String Date to Milliseconds */
    toMillisecond: function toMillisecond(value) {
      return Date.parse(value);
    },

    /* Milliseconds to Date*/
    toDate: function toDate(value) {
      return new Date(value); // Return String
    },

    focus: function focus() {
      var _this = this;

      setTimeout(function () {
        _this.$refs.ref.focus();
      }, 500);
    }
  }
});

/***/ }),
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 64,
	"./af.js": 64,
	"./ar": 65,
	"./ar-dz": 66,
	"./ar-dz.js": 66,
	"./ar-kw": 67,
	"./ar-kw.js": 67,
	"./ar-ly": 68,
	"./ar-ly.js": 68,
	"./ar-ma": 69,
	"./ar-ma.js": 69,
	"./ar-ps": 70,
	"./ar-ps.js": 70,
	"./ar-sa": 71,
	"./ar-sa.js": 71,
	"./ar-tn": 72,
	"./ar-tn.js": 72,
	"./ar.js": 65,
	"./az": 73,
	"./az.js": 73,
	"./be": 74,
	"./be.js": 74,
	"./bg": 75,
	"./bg.js": 75,
	"./bm": 76,
	"./bm.js": 76,
	"./bn": 77,
	"./bn-bd": 78,
	"./bn-bd.js": 78,
	"./bn.js": 77,
	"./bo": 79,
	"./bo.js": 79,
	"./br": 80,
	"./br.js": 80,
	"./bs": 81,
	"./bs.js": 81,
	"./ca": 82,
	"./ca.js": 82,
	"./cs": 83,
	"./cs.js": 83,
	"./cv": 84,
	"./cv.js": 84,
	"./cy": 85,
	"./cy.js": 85,
	"./da": 86,
	"./da.js": 86,
	"./de": 87,
	"./de-at": 88,
	"./de-at.js": 88,
	"./de-ch": 89,
	"./de-ch.js": 89,
	"./de.js": 87,
	"./dv": 90,
	"./dv.js": 90,
	"./el": 91,
	"./el.js": 91,
	"./en-au": 92,
	"./en-au.js": 92,
	"./en-ca": 93,
	"./en-ca.js": 93,
	"./en-gb": 94,
	"./en-gb.js": 94,
	"./en-ie": 95,
	"./en-ie.js": 95,
	"./en-il": 96,
	"./en-il.js": 96,
	"./en-in": 97,
	"./en-in.js": 97,
	"./en-nz": 98,
	"./en-nz.js": 98,
	"./en-sg": 99,
	"./en-sg.js": 99,
	"./eo": 100,
	"./eo.js": 100,
	"./es": 101,
	"./es-do": 102,
	"./es-do.js": 102,
	"./es-mx": 103,
	"./es-mx.js": 103,
	"./es-us": 104,
	"./es-us.js": 104,
	"./es.js": 101,
	"./et": 105,
	"./et.js": 105,
	"./eu": 106,
	"./eu.js": 106,
	"./fa": 107,
	"./fa.js": 107,
	"./fi": 108,
	"./fi.js": 108,
	"./fil": 109,
	"./fil.js": 109,
	"./fo": 110,
	"./fo.js": 110,
	"./fr": 111,
	"./fr-ca": 112,
	"./fr-ca.js": 112,
	"./fr-ch": 113,
	"./fr-ch.js": 113,
	"./fr.js": 111,
	"./fy": 114,
	"./fy.js": 114,
	"./ga": 115,
	"./ga.js": 115,
	"./gd": 116,
	"./gd.js": 116,
	"./gl": 117,
	"./gl.js": 117,
	"./gom-deva": 118,
	"./gom-deva.js": 118,
	"./gom-latn": 119,
	"./gom-latn.js": 119,
	"./gu": 120,
	"./gu.js": 120,
	"./he": 121,
	"./he.js": 121,
	"./hi": 122,
	"./hi.js": 122,
	"./hr": 123,
	"./hr.js": 123,
	"./hu": 124,
	"./hu.js": 124,
	"./hy-am": 125,
	"./hy-am.js": 125,
	"./id": 126,
	"./id.js": 126,
	"./is": 127,
	"./is.js": 127,
	"./it": 128,
	"./it-ch": 129,
	"./it-ch.js": 129,
	"./it.js": 128,
	"./ja": 130,
	"./ja.js": 130,
	"./jv": 131,
	"./jv.js": 131,
	"./ka": 132,
	"./ka.js": 132,
	"./kk": 133,
	"./kk.js": 133,
	"./km": 134,
	"./km.js": 134,
	"./kn": 135,
	"./kn.js": 135,
	"./ko": 136,
	"./ko.js": 136,
	"./ku": 137,
	"./ku-kmr": 138,
	"./ku-kmr.js": 138,
	"./ku.js": 137,
	"./ky": 139,
	"./ky.js": 139,
	"./lb": 140,
	"./lb.js": 140,
	"./lo": 141,
	"./lo.js": 141,
	"./lt": 142,
	"./lt.js": 142,
	"./lv": 143,
	"./lv.js": 143,
	"./me": 144,
	"./me.js": 144,
	"./mi": 145,
	"./mi.js": 145,
	"./mk": 146,
	"./mk.js": 146,
	"./ml": 147,
	"./ml.js": 147,
	"./mn": 148,
	"./mn.js": 148,
	"./mr": 149,
	"./mr.js": 149,
	"./ms": 150,
	"./ms-my": 151,
	"./ms-my.js": 151,
	"./ms.js": 150,
	"./mt": 152,
	"./mt.js": 152,
	"./my": 153,
	"./my.js": 153,
	"./nb": 154,
	"./nb.js": 154,
	"./ne": 155,
	"./ne.js": 155,
	"./nl": 156,
	"./nl-be": 157,
	"./nl-be.js": 157,
	"./nl.js": 156,
	"./nn": 158,
	"./nn.js": 158,
	"./oc-lnc": 159,
	"./oc-lnc.js": 159,
	"./pa-in": 160,
	"./pa-in.js": 160,
	"./pl": 161,
	"./pl.js": 161,
	"./pt": 162,
	"./pt-br": 163,
	"./pt-br.js": 163,
	"./pt.js": 162,
	"./ro": 164,
	"./ro.js": 164,
	"./ru": 165,
	"./ru.js": 165,
	"./sd": 166,
	"./sd.js": 166,
	"./se": 167,
	"./se.js": 167,
	"./si": 168,
	"./si.js": 168,
	"./sk": 169,
	"./sk.js": 169,
	"./sl": 170,
	"./sl.js": 170,
	"./sq": 171,
	"./sq.js": 171,
	"./sr": 172,
	"./sr-cyrl": 173,
	"./sr-cyrl.js": 173,
	"./sr.js": 172,
	"./ss": 174,
	"./ss.js": 174,
	"./sv": 175,
	"./sv.js": 175,
	"./sw": 176,
	"./sw.js": 176,
	"./ta": 177,
	"./ta.js": 177,
	"./te": 178,
	"./te.js": 178,
	"./tet": 179,
	"./tet.js": 179,
	"./tg": 180,
	"./tg.js": 180,
	"./th": 181,
	"./th.js": 181,
	"./tk": 182,
	"./tk.js": 182,
	"./tl-ph": 183,
	"./tl-ph.js": 183,
	"./tlh": 184,
	"./tlh.js": 184,
	"./tr": 185,
	"./tr.js": 185,
	"./tzl": 186,
	"./tzl.js": 186,
	"./tzm": 187,
	"./tzm-latn": 188,
	"./tzm-latn.js": 188,
	"./tzm.js": 187,
	"./ug-cn": 189,
	"./ug-cn.js": 189,
	"./uk": 190,
	"./uk.js": 190,
	"./ur": 191,
	"./ur.js": 191,
	"./uz": 192,
	"./uz-latn": 193,
	"./uz-latn.js": 193,
	"./uz.js": 192,
	"./vi": 194,
	"./vi.js": 194,
	"./x-pseudo": 195,
	"./x-pseudo.js": 195,
	"./yo": 196,
	"./yo.js": 196,
	"./zh-cn": 197,
	"./zh-cn.js": 197,
	"./zh-hk": 198,
	"./zh-hk.js": 198,
	"./zh-mo": 199,
	"./zh-mo.js": 199,
	"./zh-tw": 200,
	"./zh-tw.js": 200
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;

/***/ }),
/* 291 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-text-field', _vm._b({
    ref: "ref",
    attrs: {
      "label": _vm.label,
      "maxlength": _vm.options.inputMask.length,
      "append-icon": (_vm.value) ? 'mdi-check-circle' : '',
      "success": (_vm.value) ? true : false
    },
    on: {
      "keypress": _vm.keyPress,
      "blur": function($event) {
        return _vm.$emit('blur')
      },
      "change": function($event) {
        return _vm.$emit('change')
      },
      "click": function($event) {
        return _vm.$emit('click')
      },
      "focus": function($event) {
        return _vm.$emit('focus')
      },
      "keydown": function($event) {
        return _vm.$emit('keydown')
      },
      "mousedown": function($event) {
        return _vm.$emit('mousedown')
      },
      "mouseup": function($event) {
        return _vm.$emit('mouseup')
      }
    },
    model: {
      value: (_vm.cmpValue),
      callback: function($$v) {
        _vm.cmpValue = $$v
      },
      expression: "cmpValue"
    }
  }, 'v-text-field', _vm.properties, false))], 1)
},staticRenderFns: []}

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(293),
  /* template */
  __webpack_require__(294),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  model: { prop: "value", event: "input" },
  props: {
    value: {
      type: [Number, String],
      default: 0
    },
    label: {
      type: String,
      default: "Label"
    },
    properties: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      modDate: "",
      modTime: "00:00",
      formattedDate: "",
      menu: false,
      readonly: true,
      activeTab: 0
    };
  },
  computed: {
    compShow: {
      get: function get() {
        var THIS = this;
        var mdf = this.value ? THIS.formattedDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(new Date(this.value)).format(this.options.format) : "";
        var mt = this.value ? THIS.modTime = __WEBPACK_IMPORTED_MODULE_0_moment___default()(new Date(this.value)).format(this.options.useSeconds ? "HH:mm:ss" : "HH:mm") : "";
        return mdf + " " + mt;
      },
      set: function set() {
        var THIS = this;
        THIS.modDate = null;
        THIS.modTime = this.options.useSeconds ? "00:00:00" : "00:00";
        THIS.formattedDate = null;
        this.$emit("input", null);
      }
    }
  },
  watch: {
    // When computed.compShow.formattedDate is changed:
    formattedDate: function formattedDate() {
      return this.value ? this.modDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(new Date(this.value)).format("YYYY-MM-DD") : null;
    },

    // Open always on date tab and selected hour
    menu: function menu() {
      if (!this.menu) {
        this.activeTab = 0;
        if (this.$refs.refTimePicker) {
          this.$refs.refTimePicker.selectingHour = true;
        }
      }
    }
  },
  methods: {
    emit: function emit() {
      this.$emit("input", this.stringToMillisecond(this.modDate, this.modTime));
    },

    stringToMillisecond: function stringToMillisecond(date, time) {
      return Date.parse(date + " " + time);
    },
    closingControl: function closingControl() {
      if (this.options.closeOnDateClick === true) {
        this.menu = false;
      } else {
        this.activeTab = 1;
      }
    }
  }
});
// Str to milli
// var d = Date.parse(date);
// milli to date
// this.date = new Date(d);

/***/ }),
/* 294 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "data-app": "true",
      "offset-y": "",
      "max-width": "100%"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "label": _vm.label
          },
          on: {
            "click:append": function($event) {
              (_vm.menu = true), (_vm.activeTab = 1)
            },
            "click:clear": function($event) {
              _vm.menu = false
            }
          },
          model: {
            value: (_vm.compShow),
            callback: function($$v) {
              _vm.compShow = $$v
            },
            expression: "compShow"
          }
        }, 'v-text-field', _vm.properties, false), on))]
      }
    }]),
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_vm._v(" "), _c('v-tabs', {
    staticClass: "elevation-2",
    attrs: {
      "dark": "",
      "background-color": _vm.options.tabBackgroundColor
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab', {
    key: 0
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-calendar-outline")]), _vm._v("\n        " + _vm._s(_vm.options.tabDateTitle) + "\n      ")], 1), _vm._v(" "), _c('v-tab', {
    key: 1
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-calendar-clock")]), _vm._v("\n        " + _vm._s(_vm.options.tabTimeTitle) + "\n      ")], 1), _vm._v(" "), _c('v-tab-item', {
    key: 0
  }, [_c('v-card', {
    staticStyle: {
      "overflow": "auto"
    },
    attrs: {
      "flat": ""
    }
  }, [_c('v-date-picker', {
    attrs: {
      "no-title": "",
      "locale": _vm.options.locale
    },
    on: {
      "change": function($event) {
        _vm.closingControl(), _vm.emit()
      }
    },
    model: {
      value: (_vm.modDate),
      callback: function($$v) {
        _vm.modDate = $$v
      },
      expression: "modDate"
    }
  })], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 1
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-time-picker', {
    ref: "refTimePicker",
    attrs: {
      "landscape": "",
      "format": "24hr",
      "color": _vm.options.tabBackgroundColor,
      "use-seconds": _vm.options.useSeconds,
      "disabled": _vm.formattedDate === null || _vm.formattedDate === ''
    },
    on: {
      "change": function($event) {
        (_vm.menu = false), _vm.emit()
      }
    },
    model: {
      value: (_vm.modTime),
      callback: function($$v) {
        _vm.modTime = $$v
      },
      expression: "modTime"
    }
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(296),
  /* template */
  __webpack_require__(297),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  model: { prop: "value", event: "input" },
  props: {
    value: {
      type: [String, Number],
      default: "0"
    },
    label: {
      type: String,
      default: ""
    },
    properties: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    options: {
      type: Object,
      default: function _default() {
        return {
          inputMask: "#########",
          outputMask: "#########",
          empty: "", // v-model value when v-text-field is empty. You can use "0" or "" or null or other.
          applyAfter: true, // Apply the mask only after filling
          alphanumeric: false,
          lowerCase: false
        };
      }
    }
  },
  data: function data() {
    return {};
  },
  /*
   v-model="cmpValue": Dessa forma, ao digitar, o valor é atualizado automaticamente no componente pai.
   O valor digitado entra pelo newValue do Set é emitido para o componente pai, retorna pelo get e pára.
  */
  computed: {
    cmpValue: {
      get: function get() {
        return this.humanFormat(this.value);
      },
      set: function set(newValue) {
        this.$emit("input", this.machineFormat(newValue));
      }
    }
  },
  watch: {},
  methods: {
    humanFormat: function humanFormat(value) {
      if (value) {
        value = this.formatValue(value, this.options.inputMask);
      } else {
        value = this.options.empty;
      }
      return value;
    },

    machineFormat: function machineFormat(value) {
      if (value) {
        value = this.formatValue(value, this.options.outputMask);
        if (value === "") {
          value = this.options.empty;
        }
        // UpperCase or LowerCase
        if (this.options.lowerCase) {
          value = value ? value.toLowerCase() : value;
        } else {
          value = value ? value.toUpperCase() : value;
        }
        // Apply the mask only after filling
        if (this.options.applyAfter) {
          if (value.length !== this.options.outputMask.length) {
            value = this.options.empty;
          } else {
            // Event sended after filling the mask
            this.$emit("masked");
          }
        }
      } else {
        value = this.options.empty;
      }
      return value;
    },


    formatValue: function formatValue(value, mask) {
      return this.formatDefault(value, mask);
    },

    formatDefault: function formatDefault(value, mask) {
      value = this.clearValue(value);
      var result = "";
      var count = 0;
      if (value) {
        var arrayValue = value.toString().split("");
        var arrayMask = mask.toString().split("");
        for (var i = 0; i < arrayMask.length; i++) {
          if (i < arrayValue.length + count) {
            if (arrayMask[i] === "#") {
              result = result + arrayValue[i - count];
            } else {
              result = result + arrayMask[i];
              count++;
            }
          }
        }
      }
      return result;
    },

    keyPress: function keyPress($event) {
      if (!this.options.alphanumeric) {
        // console.log($event.keyCode); //keyCodes value
        var keyCode = $event.keyCode ? $event.keyCode : $event.which;
        // if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        if (keyCode < 48 || keyCode > 57) {
          // 46 is dot
          $event.preventDefault();
        }
      }
    },


    clearValue: function clearValue(value) {
      var result = "";
      if (value) {
        var arrayValue = value.toString().split("");
        for (var i = 0; i < arrayValue.length; i++) {
          if (this.isValid(arrayValue[i])) {
            result = result + arrayValue[i];
          }
        }
      }
      return result;
    },

    isValid: function isValid(value) {
      if (this.options.alphanumeric) {
        return this.isAlphaNumeric(value);
      } else {
        return this.isInteger(value);
      }
    },
    isInteger: function isInteger(value) {
      var result = false;
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(parseInt(value))) {
        result = true;
      }
      return result;
    },
    isAlphaNumeric: function isAlphaNumeric(value) {
      var letterNumber = /^[0-9a-zA-Z]+$/;
      if (value.match(letterNumber)) {
        return true;
      }
      return false;
    },
    focus: function focus() {
      var _this = this;

      setTimeout(function () {
        _this.$refs.ref.focus();
      }, 500);
    }
  }
});

/***/ }),
/* 297 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-text-field', _vm._b({
    ref: "ref",
    attrs: {
      "label": _vm.label,
      "maxlength": _vm.options.inputMask.length
    },
    on: {
      "keypress": _vm.keyPress,
      "blur": function($event) {
        return _vm.$emit('blur')
      },
      "change": function($event) {
        return _vm.$emit('change')
      },
      "click": function($event) {
        return _vm.$emit('click')
      },
      "focus": function($event) {
        return _vm.$emit('focus')
      },
      "keydown": function($event) {
        return _vm.$emit('keydown')
      },
      "mousedown": function($event) {
        return _vm.$emit('mousedown')
      },
      "mouseup": function($event) {
        return _vm.$emit('mouseup')
      }
    },
    model: {
      value: (_vm.cmpValue),
      callback: function($$v) {
        _vm.cmpValue = $$v
      },
      expression: "cmpValue"
    }
  }, 'v-text-field', _vm.properties, false))], 1)
},staticRenderFns: []}

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(299),
  /* template */
  __webpack_require__(300),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  model: { prop: "value", event: "input" },
  props: {
    value: {
      type: [String, Number],
      default: "0"
    },
    label: {
      type: String,
      default: ""
    },
    properties: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    options: {
      type: Object,
      default: function _default() {
        return {
          outputMask: "###########",
          empty: "",
          applyAfter: false
        };
      }
    }
  },
  data: function data() {
    return {
      inputMask: "###.###.###-##"
    };
  },
  /*
   v-model="cmpValue": Dessa forma, ao digitar, o valor é atualizado automaticamente no componente pai.
   O valor digitado entra pelo newValue do Set é emitido para o componente pai, retorna pelo get e pára.
  */
  computed: {
    cmpValue: {
      get: function get() {
        return this.humanFormat(this.value);
      },
      set: function set(newValue) {
        this.$emit("input", this.machineFormat(newValue));
      }
    }
  },
  watch: {},
  methods: {
    humanFormat: function humanFormat(value) {
      if (value) {
        value = this.formatValue(value, this.inputMask);
      } else {
        value = this.options.empty;
      }
      return value;
    },

    machineFormat: function machineFormat(value) {
      if (value) {
        value = this.formatValue(value, this.options.outputMask);
        if (value === "") {
          value = this.options.empty;
        }
        // Apply the mask only only after filling
        if (this.options.applyAfter) {
          if (value.length !== this.options.outputMask.length) {
            value = this.options.empty;
          } else {
            if (!this.validateCpf(value)) {
              value = this.options.empty;
            } else {
              // Event sended after filling the mask
              this.$emit("masked");
            }
          }
        }
      } else {
        value = this.options.empty;
      }
      return value;
    },


    formatValue: function formatValue(value, mask) {
      return this.formatCpf(value, mask);
    },

    formatCpf: function formatCpf(value, mask) {
      value = this.clearValue(value);
      var result = "";
      var count = 0;
      if (value) {
        var arrayValue = value.toString().split("");
        var arrayMask = mask.toString().split("");
        for (var i = 0; i < arrayMask.length; i++) {
          if (i < arrayValue.length + count) {
            if (arrayMask[i] === "#") {
              result = result + arrayValue[i - count];
            } else {
              result = result + arrayMask[i];
              count++;
            }
          }
        }
      }
      return result;
    },

    keyPress: function keyPress($event) {
      // console.log($event.keyCode); //keyCodes value
      var keyCode = $event.keyCode ? $event.keyCode : $event.which;
      // if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
      if (keyCode < 48 || keyCode > 57) {
        // 46 is dot
        $event.preventDefault();
      }
    },


    clearValue: function clearValue(value) {
      var result = "";
      if (value) {
        var arrayValue = value.toString().split("");
        for (var i = 0; i < arrayValue.length; i++) {
          if (this.isInteger(arrayValue[i])) {
            result = result + arrayValue[i];
          }
        }
      }
      return result;
    },

    isInteger: function isInteger(value) {
      var result = false;
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(parseInt(value))) {
        result = true;
      }
      return result;
    },
    focus: function focus() {
      var _this = this;

      setTimeout(function () {
        _this.$refs.ref.focus();
      }, 500);
    },


    validateCpf: function validateCpf(cpf) {
      cpf = cpf.replace(/[^\d]+/g, "");
      if (cpf == "") return false;
      // Eliminar CPFs invalidos conhecidos
      if (cpf.length != 11 || cpf == "00000000000" || cpf == "11111111111" || cpf == "22222222222" || cpf == "33333333333" || cpf == "44444444444" || cpf == "55555555555" || cpf == "66666666666" || cpf == "77777777777" || cpf == "88888888888" || cpf == "99999999999") return false;
      // Validar 1o digito
      var add = 0;
      for (var i = 0; i < 9; i++) {
        add += parseInt(cpf.charAt(i)) * (10 - i);
      }rev = 11 - add % 11;
      if (rev == 10 || rev == 11) rev = 0;
      if (rev != parseInt(cpf.charAt(9))) return false;
      // Validar 2o digito
      add = 0;
      for (var j = 0; j < 10; j++) {
        add += parseInt(cpf.charAt(j)) * (11 - j);
      }var rev = 11 - add % 11;
      if (rev == 10 || rev == 11) rev = 0;
      if (rev != parseInt(cpf.charAt(10))) return false;
      return true;
    }
  }
});

/***/ }),
/* 300 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-text-field', _vm._b({
    ref: "ref",
    attrs: {
      "label": _vm.label,
      "maxlength": _vm.inputMask.length,
      "append-icon": _vm.options.applyAfter && _vm.value ? 'mdi-check-circle' : '',
      "success": _vm.options.applyAfter && _vm.value ? true : false
    },
    on: {
      "keypress": _vm.keyPress,
      "blur": function($event) {
        return _vm.$emit('blur')
      },
      "change": function($event) {
        return _vm.$emit('change')
      },
      "click": function($event) {
        return _vm.$emit('click')
      },
      "focus": function($event) {
        return _vm.$emit('focus')
      },
      "keydown": function($event) {
        return _vm.$emit('keydown')
      },
      "mousedown": function($event) {
        return _vm.$emit('mousedown')
      },
      "mouseup": function($event) {
        return _vm.$emit('mouseup')
      }
    },
    model: {
      value: (_vm.cmpValue),
      callback: function($$v) {
        _vm.cmpValue = $$v
      },
      expression: "cmpValue"
    }
  }, 'v-text-field', _vm.properties, false))], 1)
},staticRenderFns: []}

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(302),
  /* template */
  __webpack_require__(303),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  model: { prop: "value", event: "input" },
  props: {
    value: {
      type: [String, Number],
      default: "0"
    },
    label: {
      type: String,
      default: ""
    },
    properties: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    options: {
      type: Object,
      default: function _default() {
        return {
          outputMask: "##############",
          empty: "",
          applyAfter: false
        };
      }
    }
  },
  data: function data() {
    return {
      inputMask: "##.###.###/####-##"
    };
  },
  /*
   v-model="cmpValue": Dessa forma, ao digitar, o valor é atualizado automaticamente no componente pai.
   O valor digitado entra pelo newValue do Set é emitido para o componente pai, retorna pelo get e pára.
  */
  computed: {
    cmpValue: {
      get: function get() {
        return this.humanFormat(this.value);
      },
      set: function set(newValue) {
        this.$emit("input", this.machineFormat(newValue));
      }
    }
  },
  watch: {},
  methods: {
    humanFormat: function humanFormat(value) {
      if (value) {
        value = this.formatValue(value, this.inputMask);
      } else {
        value = this.options.empty;
      }
      return value;
    },

    machineFormat: function machineFormat(value) {
      if (value) {
        value = this.formatValue(value, this.options.outputMask);
        if (value === "") {
          value = this.options.empty;
        }
        // Apply the mask only only after filling
        if (this.options.applyAfter) {
          if (value.length !== this.options.outputMask.length) {
            value = this.options.empty;
          } else {
            if (!this.validateCnpj(value)) {
              value = this.options.empty;
            } else {
              // Event sended after filling the mask
              this.$emit("masked");
            }
          }
        }
      } else {
        value = this.options.empty;
      }
      return value;
    },


    formatValue: function formatValue(value, mask) {
      return this.formatCnpj(value, mask);
    },

    formatCnpj: function formatCnpj(value, mask) {
      value = this.clearValue(value);
      var result = "";
      var count = 0;
      if (value) {
        var arrayValue = value.toString().split("");
        var arrayMask = mask.toString().split("");
        for (var i = 0; i < arrayMask.length; i++) {
          if (i < arrayValue.length + count) {
            if (arrayMask[i] === "#") {
              result = result + arrayValue[i - count];
            } else {
              result = result + arrayMask[i];
              count++;
            }
          }
        }
      }
      return result;
    },

    keyPress: function keyPress($event) {
      // console.log($event.keyCode); //keyCodes value
      var keyCode = $event.keyCode ? $event.keyCode : $event.which;
      // if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
      if (keyCode < 48 || keyCode > 57) {
        // 46 is dot
        $event.preventDefault();
      }
    },


    clearValue: function clearValue(value) {
      var result = "";
      if (value) {
        var arrayValue = value.toString().split("");
        for (var i = 0; i < arrayValue.length; i++) {
          if (this.isInteger(arrayValue[i])) {
            result = result + arrayValue[i];
          }
        }
      }
      return result;
    },

    isInteger: function isInteger(value) {
      var result = false;
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(parseInt(value))) {
        result = true;
      }
      return result;
    },
    focus: function focus() {
      var _this = this;

      setTimeout(function () {
        _this.$refs.ref.focus();
      }, 500);
    },


    validateCnpj: function validateCnpj(cnpj) {
      cnpj = cnpj.replace(/[^\d]+/g, "");
      if (cnpj == "") return false;
      if (cnpj.length != 14) return false;
      // Elimina CNPJs invalidos conhecidos
      if (cnpj == "00000000000000" || cnpj == "11111111111111" || cnpj == "22222222222222" || cnpj == "33333333333333" || cnpj == "44444444444444" || cnpj == "55555555555555" || cnpj == "66666666666666" || cnpj == "77777777777777" || cnpj == "88888888888888" || cnpj == "99999999999999") return false;
      // Valida DVs
      var tamanho = cnpj.length - 2;
      var numeros = cnpj.substring(0, tamanho);
      var digitos = cnpj.substring(tamanho);
      var soma = 0;
      var pos = tamanho - 7;
      for (var i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) pos = 9;
      }
      var resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
      if (resultado != digitos.charAt(0)) return false;
      tamanho = tamanho + 1;
      numeros = cnpj.substring(0, tamanho);
      soma = 0;
      pos = tamanho - 7;
      for (i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) pos = 9;
      }
      resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
      if (resultado != digitos.charAt(1)) return false;
      return true;
    }
  }
});

/***/ }),
/* 303 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-text-field', _vm._b({
    ref: "ref",
    attrs: {
      "label": _vm.label,
      "maxlength": _vm.inputMask.length,
      "append-icon": _vm.options.applyAfter && _vm.value ? 'mdi-check-circle' : '',
      "success": _vm.options.applyAfter && _vm.value ? true : false
    },
    on: {
      "keypress": _vm.keyPress,
      "blur": function($event) {
        return _vm.$emit('blur')
      },
      "change": function($event) {
        return _vm.$emit('change')
      },
      "click": function($event) {
        return _vm.$emit('click')
      },
      "focus": function($event) {
        return _vm.$emit('focus')
      },
      "keydown": function($event) {
        return _vm.$emit('keydown')
      },
      "mousedown": function($event) {
        return _vm.$emit('mousedown')
      },
      "mouseup": function($event) {
        return _vm.$emit('mouseup')
      }
    },
    model: {
      value: (_vm.cmpValue),
      callback: function($$v) {
        _vm.cmpValue = $$v
      },
      expression: "cmpValue"
    }
  }, 'v-text-field', _vm.properties, false))], 1)
},staticRenderFns: []}

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(305),
  /* template */
  __webpack_require__(306),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  model: { prop: "value", event: "input" },
  props: {
    value: {
      type: [String, Number],
      default: "0"
    },
    label: {
      type: String,
      default: ""
    },
    properties: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    options: {
      type: Object,
      default: function _default() {
        return {
          outputMask: "########",
          empty: "",
          applyAfter: false
        };
      }
    }
  },
  data: function data() {
    return {
      inputMask: "##.###-###"
    };
  },
  /*
   v-model="cmpValue": Dessa forma, ao digitar, o valor é atualizado automaticamente no componente pai.
   O valor digitado entra pelo newValue do Set é emitido para o componente pai, retorna pelo get e pára.
  */
  computed: {
    cmpValue: {
      get: function get() {
        return this.humanFormat(this.value);
      },
      set: function set(newValue) {
        this.$emit("input", this.machineFormat(newValue));
      }
    }
  },
  watch: {},
  methods: {
    humanFormat: function humanFormat(value) {
      if (value) {
        value = this.formatValue(value, this.inputMask);
      } else {
        value = this.options.empty;
      }
      return value;
    },

    machineFormat: function machineFormat(value) {
      if (value) {
        value = this.formatValue(value, this.options.outputMask);
        if (value === "") {
          value = this.options.empty;
        }
        // Apply the mask only only after filling
        if (this.options.applyAfter) {
          if (value.length !== this.options.outputMask.length) {
            value = this.options.empty;
          } else {
            // Event sended after filling the mask
            this.$emit("masked");
          }
        }
      } else {
        value = this.options.empty;
      }
      return value;
    },


    formatValue: function formatValue(value, mask) {
      return this.formatCpf(value, mask);
    },

    formatCpf: function formatCpf(value, mask) {
      value = this.clearValue(value);
      var result = "";
      var count = 0;
      if (value) {
        var arrayValue = value.toString().split("");
        var arrayMask = mask.toString().split("");
        for (var i = 0; i < arrayMask.length; i++) {
          if (i < arrayValue.length + count) {
            if (arrayMask[i] === "#") {
              result = result + arrayValue[i - count];
            } else {
              result = result + arrayMask[i];
              count++;
            }
          }
        }
      }
      return result;
    },

    keyPress: function keyPress($event) {
      // console.log($event.keyCode); //keyCodes value
      var keyCode = $event.keyCode ? $event.keyCode : $event.which;
      // if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
      if (keyCode < 48 || keyCode > 57) {
        // 46 is dot
        $event.preventDefault();
      }
    },


    clearValue: function clearValue(value) {
      var result = "";
      if (value) {
        var arrayValue = value.toString().split("");
        for (var i = 0; i < arrayValue.length; i++) {
          if (this.isInteger(arrayValue[i])) {
            result = result + arrayValue[i];
          }
        }
      }
      return result;
    },

    isInteger: function isInteger(value) {
      var result = false;
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(parseInt(value))) {
        result = true;
      }
      return result;
    },
    focus: function focus() {
      var _this = this;

      setTimeout(function () {
        _this.$refs.ref.focus();
      }, 500);
    }
  }
});

/***/ }),
/* 306 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-text-field', _vm._b({
    ref: "ref",
    attrs: {
      "label": _vm.label,
      "maxlength": _vm.inputMask.length
    },
    on: {
      "keypress": _vm.keyPress,
      "blur": function($event) {
        return _vm.$emit('blur')
      },
      "change": function($event) {
        return _vm.$emit('change')
      },
      "click": function($event) {
        return _vm.$emit('click')
      },
      "focus": function($event) {
        return _vm.$emit('focus')
      },
      "keydown": function($event) {
        return _vm.$emit('keydown')
      },
      "mousedown": function($event) {
        return _vm.$emit('mousedown')
      },
      "mouseup": function($event) {
        return _vm.$emit('mouseup')
      }
    },
    model: {
      value: (_vm.cmpValue),
      callback: function($$v) {
        _vm.cmpValue = $$v
      },
      expression: "cmpValue"
    }
  }, 'v-text-field', _vm.properties, false))], 1)
},staticRenderFns: []}

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(308),
  /* template */
  __webpack_require__(309),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  model: { prop: "value", event: "input" },
  props: {
    value: {
      type: [String],
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    properties: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    options: {
      type: Object,
      default: function _default() {
        return {
          acceptFile: "image/*,application/pdf"
        };
      }
    }
  },

  data: function data() {
    return {
      imageName: "",
      imageFile: "",
      fileBase64: "",
      showDialog: false
    };
  },

  computed: {
    cmpValue: {
      get: function get() {
        this.setImage(this.value);
        return this.imageName;
      }
    }
  },

  methods: {
    setImage: function setImage(value) {
      this.fileBase64 = value;
    },
    pickFile: function pickFile() {
      this.$refs.refImage.click();
    },
    onFilePicked: function onFilePicked(event) {
      var _this = this;

      var files = event.target.files;
      if (files[0] !== undefined) {
        this.imageName = files[0].name;
        if (this.imageName.lastIndexOf(".") <= 0) {
          return;
        }
        var fileReader = new FileReader();
        fileReader.readAsDataURL(files[0]);
        fileReader.addEventListener("load", function () {
          _this.fileBase64 = fileReader.result;
          _this.imageFile = files[0];
          _this.$emit("input", _this.fileBase64);
          _this.$emit("fileName", _this.imageName);
        });
      } else {
        this.clear();
      }
    },
    clear: function clear() {
      this.imageName = "";
      this.imageFile = "";
      this.fileBase64 = "";
    }
  }
});

/***/ }),
/* 309 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.fileBase64) ? _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "max-width": "30%"
    },
    model: {
      value: (_vm.showDialog),
      callback: function($$v) {
        _vm.showDialog = $$v
      },
      expression: "showDialog"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.fileBase64
    }
  })]) : _vm._e(), _vm._v(" "), _c('v-text-field', _vm._b({
    attrs: {
      "label": _vm.label,
      "readonly": ""
    },
    on: {
      "click": _vm.pickFile,
      "click:append": function($event) {
        _vm.showDialog ? (_vm.showDialog = false) : (_vm.showDialog = true)
      }
    },
    model: {
      value: (_vm.cmpValue),
      callback: function($$v) {
        _vm.cmpValue = $$v
      },
      expression: "cmpValue"
    }
  }, 'v-text-field', _vm.properties, false)), _vm._v(" "), _c('input', {
    ref: "refImage",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": _vm.options.acceptFile
    },
    on: {
      "change": _vm.onFilePicked
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(311),
  /* template */
  __webpack_require__(312),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  model: { prop: "value", event: "input" },
  props: {
    value: {
      type: [String, Number],
      default: "0"
    },
    label: {
      type: String,
      default: ""
    },
    properties: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    options: {
      type: Object,
      default: function _default() {
        return {
          length: 10,
          empty: "",
          applyAfter: false
        };
      }
    }
  },
  data: function data() {
    return {};
  },
  /*
   v-model="cmpValue": Dessa forma, ao digitar, o valor é atualizado automaticamente no componente pai.
   O valor digitado entra pelo newValue do Set é emitido para o componente pai, retorna pelo get e pára.
  */
  computed: {
    cmpValue: {
      get: function get() {
        return this.humanFormat(this.value);
      },
      set: function set(newValue) {
        this.$emit("input", this.machineFormat(newValue));
      }
    }
  },
  watch: {},
  methods: {
    humanFormat: function humanFormat(value) {
      if (value) {
        value = this.formatValue(value);
      } else {
        value = this.options.empty;
      }
      return value;
    },

    machineFormat: function machineFormat(value) {
      if (value) {
        value = this.formatValue(value);
        if (value === "") {
          value = this.options.empty;
        }
        // Apply the mask only only after filling
        if (this.options.applyAfter) {
          if (value.length !== this.options.length) {
            value = this.options.empty;
          } else {
            // Event sended after filling the mask
            this.$emit("masked");
          }
        }
      } else {
        value = this.options.empty;
      }
      return value;
    },


    formatValue: function formatValue(value) {
      return value;
    },

    keyPress: function keyPress($event) {
      // console.log($event.keyCode); //keyCodes value
      var keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // if (keyCode < 48 || keyCode > 57) {
        // 46 is dot
        $event.preventDefault();
      }
    },


    clearValue: function clearValue(value) {
      var result = "";
      if (value) {
        var arrayValue = value.toString().split("");
        for (var i = 0; i < arrayValue.length; i++) {
          if (this.isInteger(arrayValue[i])) {
            result = result + arrayValue[i];
          }
        }
      }
      return result;
    },

    isInteger: function isInteger(value) {
      var result = false;
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(parseInt(value))) {
        result = true;
      }
      return result;
    },
    focus: function focus() {
      var _this = this;

      setTimeout(function () {
        _this.$refs.ref.focus();
      }, 500);
    }
  }
});

/***/ }),
/* 312 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-text-field', _vm._b({
    ref: "ref",
    attrs: {
      "label": _vm.label,
      "maxlength": _vm.options.length
    },
    on: {
      "keypress": _vm.keyPress,
      "blur": function($event) {
        return _vm.$emit('blur')
      },
      "change": function($event) {
        return _vm.$emit('change')
      },
      "click": function($event) {
        return _vm.$emit('click')
      },
      "focus": function($event) {
        return _vm.$emit('focus')
      },
      "keydown": function($event) {
        return _vm.$emit('keydown')
      },
      "mousedown": function($event) {
        return _vm.$emit('mousedown')
      },
      "mouseup": function($event) {
        return _vm.$emit('mouseup')
      }
    },
    model: {
      value: (_vm.cmpValue),
      callback: function($$v) {
        _vm.cmpValue = $$v
      },
      expression: "cmpValue"
    }
  }, 'v-text-field', _vm.properties, false))], 1)
},staticRenderFns: []}

/***/ }),
/* 313 */,
/* 314 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_ajuda_inicio__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_ajuda_inicio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_ajuda_inicio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_ajuda_ajuda__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_ajuda_ajuda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_ajuda_ajuda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_ajuda_faq__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_ajuda_faq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_ajuda_faq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_ajuda_404__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_ajuda_404___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_ajuda_404__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__vuex_store__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_auth__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_bolsas_lista_bolsas__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_bolsas_lista_bolsas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__views_bolsas_lista_bolsas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_bolsas_criar_bolsa__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_bolsas_criar_bolsa___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__views_bolsas_criar_bolsa__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_bolsas_alocar_bolsa__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_bolsas_alocar_bolsa___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__views_bolsas_alocar_bolsa__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_bolsas_alocar_bolsa_tabela__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_bolsas_alocar_bolsa_tabela___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__views_bolsas_alocar_bolsa_tabela__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_bolsas_atribuir_bolsa__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_bolsas_atribuir_bolsa___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__views_bolsas_atribuir_bolsa__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_bolsas_dados_bancarios__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_bolsas_dados_bancarios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__views_bolsas_dados_bancarios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_bolsas_avaliacao_coordenador__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_bolsas_avaliacao_coordenador___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__views_bolsas_avaliacao_coordenador__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_bolsas_avaliacao_bolsista__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_bolsas_avaliacao_bolsista___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__views_bolsas_avaliacao_bolsista__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_consulta_projetos_consulta_projetos__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_consulta_projetos_consulta_projetos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__views_consulta_projetos_consulta_projetos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_consulta_projetos_meus_projetos__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_consulta_projetos_meus_projetos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__views_consulta_projetos_meus_projetos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_projeto_projeto__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_projeto_projeto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__views_projeto_projeto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_editar_projeto_editar_projeto__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_editar_projeto_editar_projeto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__views_editar_projeto_editar_projeto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__views_editar_projeto_novo_projeto__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__views_editar_projeto_novo_projeto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__views_editar_projeto_novo_projeto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__views_editar_projeto_upload_arquivo__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__views_editar_projeto_upload_arquivo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__views_editar_projeto_upload_arquivo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__views_editar_projeto_editar_arquivo__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__views_editar_projeto_editar_arquivo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__views_editar_projeto_editar_arquivo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__views_editar_projeto_importar_projeto__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__views_editar_projeto_importar_projeto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__views_editar_projeto_importar_projeto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__views_editar_projeto_duplicar_projeto__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__views_editar_projeto_duplicar_projeto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__views_editar_projeto_duplicar_projeto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__views_projeto_projeto_formulario__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__views_projeto_projeto_formulario___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__views_projeto_projeto_formulario__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__views_projeto_projeto_classificacoes_tabela__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__views_projeto_projeto_classificacoes_tabela___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__views_projeto_projeto_classificacoes_tabela__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__views_projeto_projeto_extensao__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__views_projeto_projeto_extensao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__views_projeto_projeto_extensao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__views_projeto_projeto_contatos__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__views_projeto_projeto_contatos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__views_projeto_projeto_contatos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__views_projeto_projeto_integrantes_tabela__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__views_projeto_projeto_integrantes_tabela___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__views_projeto_projeto_integrantes_tabela__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__views_projeto_projeto_atividades_tabela__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__views_projeto_projeto_atividades_tabela___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__views_projeto_projeto_atividades_tabela__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__views_projeto_projeto_vinculos_tabela__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__views_projeto_projeto_vinculos_tabela___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__views_projeto_projeto_vinculos_tabela__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__views_projeto_projeto_parcerias_tabela__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__views_projeto_projeto_parcerias_tabela___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__views_projeto_projeto_parcerias_tabela__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__views_projeto_projeto_abrangencia_tabela__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__views_projeto_projeto_abrangencia_tabela___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__views_projeto_projeto_abrangencia_tabela__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__views_projeto_projeto_bolsas_tabela__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__views_projeto_projeto_bolsas_tabela___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__views_projeto_projeto_bolsas_tabela__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__views_projeto_projeto_arquivos_tabela__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__views_projeto_projeto_arquivos_tabela___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__views_projeto_projeto_arquivos_tabela__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__views_projeto_projeto_relatorios_tabela__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__views_projeto_projeto_relatorios_tabela___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__views_projeto_projeto_relatorios_tabela__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__views_editar_projeto_editar_informacoes__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__views_editar_projeto_editar_informacoes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__views_editar_projeto_editar_informacoes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__views_editar_projeto_editar_classificacao__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__views_editar_projeto_editar_classificacao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__views_editar_projeto_editar_classificacao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__views_editar_projeto_editar_extensao__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__views_editar_projeto_editar_extensao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__views_editar_projeto_editar_extensao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__views_editar_projeto_editar_contatos__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__views_editar_projeto_editar_contatos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__views_editar_projeto_editar_contatos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__views_editar_projeto_projeto_editar_integrantes__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__views_editar_projeto_projeto_editar_integrantes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__views_editar_projeto_projeto_editar_integrantes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__views_editar_projeto_projeto_editar_parcerias__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__views_editar_projeto_projeto_editar_parcerias___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__views_editar_projeto_projeto_editar_parcerias__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__views_editar_projeto_projeto_editar_atividades__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__views_editar_projeto_projeto_editar_atividades___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__views_editar_projeto_projeto_editar_atividades__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__views_editar_projeto_projeto_editar_abrangencia__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__views_editar_projeto_projeto_editar_abrangencia___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__views_editar_projeto_projeto_editar_abrangencia__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__views_editar_projeto_projeto_editar_arquivos__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__views_editar_projeto_projeto_editar_arquivos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__views_editar_projeto_projeto_editar_arquivos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__views_editar_projeto_editar_localidade__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__views_editar_projeto_editar_localidade___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__views_editar_projeto_editar_localidade__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__views_editar_projeto_editar_projeto_superior__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__views_editar_projeto_editar_projeto_superior___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__views_editar_projeto_editar_projeto_superior__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__views_integrantes_editar_integrante__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__views_integrantes_editar_integrante___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__views_integrantes_editar_integrante__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__views_integrantes_visualizar_integrante__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__views_integrantes_visualizar_integrante___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__views_integrantes_visualizar_integrante__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__views_integrantes_novo_integrante__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__views_integrantes_novo_integrante___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53__views_integrantes_novo_integrante__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__views_integrantes_adicionar_integrante__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__views_integrantes_adicionar_integrante___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__views_integrantes_adicionar_integrante__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__views_integrantes_encerrar_participacao__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__views_integrantes_encerrar_participacao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55__views_integrantes_encerrar_participacao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__views_integrantes_reativar_participacao__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__views_integrantes_reativar_participacao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56__views_integrantes_reativar_participacao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__views_integrantes_ocorrencias_integrante__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__views_integrantes_ocorrencias_integrante___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57__views_integrantes_ocorrencias_integrante__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__views_integrantes_trocar_coordenador__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__views_integrantes_trocar_coordenador___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58__views_integrantes_trocar_coordenador__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__views_editar_projeto_nova_atividade__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__views_editar_projeto_nova_atividade___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59__views_editar_projeto_nova_atividade__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__views_editar_projeto_nova_parceria__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__views_editar_projeto_nova_parceria___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60__views_editar_projeto_nova_parceria__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__views_editar_projeto_nova_localidade__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__views_editar_projeto_nova_localidade___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61__views_editar_projeto_nova_localidade__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__views_editar_projeto_editar_atividade__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__views_editar_projeto_editar_atividade___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62__views_editar_projeto_editar_atividade__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__views_editar_projeto_editar_parceria__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__views_editar_projeto_editar_parceria___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63__views_editar_projeto_editar_parceria__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__views_editar_projeto_nova_pessoa__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__views_editar_projeto_nova_pessoa___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64__views_editar_projeto_nova_pessoa__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__views_editar_projeto_novo_membro_externo__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__views_editar_projeto_novo_membro_externo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65__views_editar_projeto_novo_membro_externo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__views_editar_projeto_editar_pessoa__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__views_editar_projeto_editar_pessoa___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66__views_editar_projeto_editar_pessoa__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__views_consulta_projetos_relatorio__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__views_consulta_projetos_relatorio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67__views_consulta_projetos_relatorio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__views_administracao_projetos_aprovar_tabela__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__views_administracao_projetos_aprovar_tabela___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68__views_administracao_projetos_aprovar_tabela__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__views_administracao_relatorios_aprovar_tabela__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__views_administracao_relatorios_aprovar_tabela___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69__views_administracao_relatorios_aprovar_tabela__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__views_administracao_projetos_vencidos_tabela__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__views_administracao_projetos_vencidos_tabela___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70__views_administracao_projetos_vencidos_tabela__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__views_administracao_projetos_concluir_tabela__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__views_administracao_projetos_concluir_tabela___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_71__views_administracao_projetos_concluir_tabela__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__views_administracao_administracao__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__views_administracao_administracao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_72__views_administracao_administracao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__views_ajuda_pesquisa__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__views_ajuda_pesquisa___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_73__views_ajuda_pesquisa__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__views_administracao_aprovar_projeto__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__views_administracao_aprovar_projeto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_74__views_administracao_aprovar_projeto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__views_administracao_devolver_projeto__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__views_administracao_devolver_projeto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_75__views_administracao_devolver_projeto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__views_administracao_liberar_relatorio__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__views_administracao_liberar_relatorio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_76__views_administracao_liberar_relatorio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__views_administracao_inabilitar_projeto__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__views_administracao_inabilitar_projeto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_77__views_administracao_inabilitar_projeto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__views_administracao_alterar_classificacao_secundaria__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__views_administracao_alterar_classificacao_secundaria___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_78__views_administracao_alterar_classificacao_secundaria__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__views_administracao_suspender_acao_extensao__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__views_administracao_suspender_acao_extensao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_79__views_administracao_suspender_acao_extensao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__views_administracao_reativar_acao_extensao__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__views_administracao_reativar_acao_extensao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_80__views_administracao_reativar_acao_extensao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__views_editar_projeto_finalizar_projeto__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__views_editar_projeto_finalizar_projeto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_81__views_editar_projeto_finalizar_projeto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__views_administracao_concluir_projeto__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__views_administracao_concluir_projeto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_82__views_administracao_concluir_projeto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__views_administracao_cancelar_projeto__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__views_administracao_cancelar_projeto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_83__views_administracao_cancelar_projeto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__views_administracao_desfazer_finalizacao__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__views_administracao_desfazer_finalizacao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_84__views_administracao_desfazer_finalizacao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__views_administracao_desfazer_exclusao__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__views_administracao_desfazer_exclusao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_85__views_administracao_desfazer_exclusao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__views_administracao_parcerias_tabela__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__views_administracao_parcerias_tabela___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_86__views_administracao_parcerias_tabela__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__views_administracao_relatorios_gestao_tabela__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__views_administracao_relatorios_gestao_tabela___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_87__views_administracao_relatorios_gestao_tabela__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__views_administracao_nova_mensagem__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__views_administracao_nova_mensagem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_88__views_administracao_nova_mensagem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__views_administracao_usuarios_proex__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__views_administracao_usuarios_proex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_89__views_administracao_usuarios_proex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__views_administracao_definir_periodo_frequencia__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__views_administracao_definir_periodo_frequencia___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_90__views_administracao_definir_periodo_frequencia__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__views_administracao_relatorio_seguro__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__views_administracao_relatorio_seguro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_91__views_administracao_relatorio_seguro__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__views_administracao_reprovar_relatorios_suspensao_coordenador__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__views_administracao_reprovar_relatorios_suspensao_coordenador___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_92__views_administracao_reprovar_relatorios_suspensao_coordenador__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__views_administracao_registro_envio_relatorios_projeto__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__views_administracao_registro_envio_relatorios_projeto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_93__views_administracao_registro_envio_relatorios_projeto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__views_relatorio_submeter__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__views_relatorio_submeter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_94__views_relatorio_submeter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__views_relatorio_aprovar__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__views_relatorio_aprovar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_95__views_relatorio_aprovar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__views_relatorio_devolver__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__views_relatorio_devolver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_96__views_relatorio_devolver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__views_relatorio_reprovar__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__views_relatorio_reprovar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_97__views_relatorio_reprovar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__views_relatorio_novo_relatorio_tecnico__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__views_relatorio_novo_relatorio_tecnico___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_98__views_relatorio_novo_relatorio_tecnico__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__views_relatorio_editar_relatorio__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__views_relatorio_editar_relatorio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_99__views_relatorio_editar_relatorio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__views_relatorio_relatorio_tecnico__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__views_relatorio_relatorio_tecnico___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_100__views_relatorio_relatorio_tecnico__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__views_relatorio_relatorio_tecnico_pdf__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__views_relatorio_relatorio_tecnico_pdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_101__views_relatorio_relatorio_tecnico_pdf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__views_frequencia_lista_frequencia__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__views_frequencia_lista_frequencia___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_102__views_frequencia_lista_frequencia__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__views_frequencia_criar_frequencia__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__views_frequencia_criar_frequencia___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_103__views_frequencia_criar_frequencia__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__views_administracao_ativar_desativar_administrador__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__views_administracao_ativar_desativar_administrador___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_104__views_administracao_ativar_desativar_administrador__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__views_pesquisa_novo_projeto_pesquisa__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__views_pesquisa_novo_projeto_pesquisa___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_105__views_pesquisa_novo_projeto_pesquisa__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__views_pesquisa_meus_projetos_pesquisa__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__views_pesquisa_meus_projetos_pesquisa___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_106__views_pesquisa_meus_projetos_pesquisa__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__views_pesquisa_consulta_projetos_pesquisa__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__views_pesquisa_consulta_projetos_pesquisa___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_107__views_pesquisa_consulta_projetos_pesquisa__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__views_pesquisa_projeto_pesquisa__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__views_pesquisa_projeto_pesquisa___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_108__views_pesquisa_projeto_pesquisa__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__views_pesquisa_informacoes_basicas__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__views_pesquisa_informacoes_basicas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_109__views_pesquisa_informacoes_basicas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__views_pesquisa_detalhamento__ = __webpack_require__(811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__views_pesquisa_detalhamento___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_110__views_pesquisa_detalhamento__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__views_pesquisa_instituicoes__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__views_pesquisa_instituicoes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_111__views_pesquisa_instituicoes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__views_pesquisa_pesquisar_instituicao__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__views_pesquisa_pesquisar_instituicao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_112__views_pesquisa_pesquisar_instituicao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__views_pesquisa_adicionar_instituicao__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__views_pesquisa_adicionar_instituicao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_113__views_pesquisa_adicionar_instituicao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__views_pesquisa_cadastrar_instituicao__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__views_pesquisa_cadastrar_instituicao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_114__views_pesquisa_cadastrar_instituicao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__views_pesquisa_equipe__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__views_pesquisa_equipe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_115__views_pesquisa_equipe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__views_pesquisa_pesquisar_pessoas__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__views_pesquisa_pesquisar_pessoas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_116__views_pesquisa_pesquisar_pessoas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__views_pesquisa_adicionar_membro_equipe__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__views_pesquisa_adicionar_membro_equipe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_117__views_pesquisa_adicionar_membro_equipe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__views_pesquisa_cadastrar_membro_externo__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__views_pesquisa_cadastrar_membro_externo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_118__views_pesquisa_cadastrar_membro_externo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__views_pesquisa_orgaos_financiadores__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__views_pesquisa_orgaos_financiadores___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_119__views_pesquisa_orgaos_financiadores__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__views_pesquisa_pesquisar_orgao_financiador__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__views_pesquisa_pesquisar_orgao_financiador___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_120__views_pesquisa_pesquisar_orgao_financiador__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__views_pesquisa_adicionar_orgao_financiador__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__views_pesquisa_adicionar_orgao_financiador___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_121__views_pesquisa_adicionar_orgao_financiador__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__views_pesquisa_cadastrar_orgao_financiador__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__views_pesquisa_cadastrar_orgao_financiador___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_122__views_pesquisa_cadastrar_orgao_financiador__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__views_pesquisa_outras_informacoes__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__views_pesquisa_outras_informacoes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_123__views_pesquisa_outras_informacoes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__views_pesquisa_arquivos__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__views_pesquisa_arquivos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_124__views_pesquisa_arquivos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__views_pesquisa_adicionar_arquivo__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__views_pesquisa_adicionar_arquivo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_125__views_pesquisa_adicionar_arquivo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__views_pesquisa_contatos__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__views_pesquisa_contatos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_126__views_pesquisa_contatos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__views_pesquisa_resultados_obtidos__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__views_pesquisa_resultados_obtidos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_127__views_pesquisa_resultados_obtidos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__views_pesquisa_editar_projeto_pesquisa__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__views_pesquisa_editar_projeto_pesquisa___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_128__views_pesquisa_editar_projeto_pesquisa__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__views_pesquisa_editar_informacoes_basicas__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__views_pesquisa_editar_informacoes_basicas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_129__views_pesquisa_editar_informacoes_basicas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__views_pesquisa_editar_detalhamento__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__views_pesquisa_editar_detalhamento___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_130__views_pesquisa_editar_detalhamento__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__views_pesquisa_editar_instituicao__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__views_pesquisa_editar_instituicao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_131__views_pesquisa_editar_instituicao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__views_pesquisa_editar_orgao_financiador__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__views_pesquisa_editar_orgao_financiador___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_132__views_pesquisa_editar_orgao_financiador__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__views_pesquisa_editar_membro_equipe__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__views_pesquisa_editar_membro_equipe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_133__views_pesquisa_editar_membro_equipe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__views_pesquisa_finalizar_membro_equipe__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__views_pesquisa_finalizar_membro_equipe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_134__views_pesquisa_finalizar_membro_equipe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__views_pesquisa_editar_outras_informacoes__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__views_pesquisa_editar_outras_informacoes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_135__views_pesquisa_editar_outras_informacoes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136__views_pesquisa_editar_contatos__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136__views_pesquisa_editar_contatos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_136__views_pesquisa_editar_contatos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137__views_pesquisa_editar_resultados_obtidos__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137__views_pesquisa_editar_resultados_obtidos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_137__views_pesquisa_editar_resultados_obtidos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138__views_pesquisa_editar_arquivo__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138__views_pesquisa_editar_arquivo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_138__views_pesquisa_editar_arquivo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139__views_pesquisa_ajuda_pesquisa__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139__views_pesquisa_ajuda_pesquisa___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_139__views_pesquisa_ajuda_pesquisa__);



var _this = this;





// import Login from '@/views/ajuda/login'






















































































































































__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);

// const SSO_URL = 'https://sso.ufes.br'
var PIB_API_URL = "https://pib-api.prod.uks.ufes.br";

var router = new __WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]({
  routes: [{
    path: '*',
    redirect: { name: '404' }
  }, {
    path: '/',
    redirect: { name: 'Inicio' }
  }, {
    path: '/inicio',
    name: 'Inicio',
    component: __WEBPACK_IMPORTED_MODULE_4__views_ajuda_inicio___default.a
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_20__views_consulta_projetos_meus_projetos___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/bolsas',
    name: 'ListaBolsas',
    component: __WEBPACK_IMPORTED_MODULE_11__views_bolsas_lista_bolsas___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/criar-bolsa',
    name: 'CriarBolsa',
    component: __WEBPACK_IMPORTED_MODULE_12__views_bolsas_criar_bolsa___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/projetos/:idProjeto/alocar-bolsa',
    name: 'AlocarBolsa',
    component: __WEBPACK_IMPORTED_MODULE_13__views_bolsas_alocar_bolsa___default.a,
    props: function props(route) {
      return { idProjeto: route.params.idProjeto };
    },
    meta: { requiresAuth: true }
  }, {
    path: '/alocar-bolsas-em-massa',
    name: 'AlocarBolsasEmMassa',
    component: __WEBPACK_IMPORTED_MODULE_14__views_bolsas_alocar_bolsa_tabela___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/projetos/:idProjeto/atribuir-bolsa',
    name: 'AtribuirBolsa',
    component: __WEBPACK_IMPORTED_MODULE_15__views_bolsas_atribuir_bolsa___default.a,
    props: function props(route) {
      return { idProjeto: route.params.idProjeto };
    },
    meta: { requiresAuth: true }
  }, {
    path: '/dados-bancarios',
    name: 'DadosBancarios',
    component: __WEBPACK_IMPORTED_MODULE_16__views_bolsas_dados_bancarios___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/avaliacao-coordenador',
    name: 'AvaliacaoCoordenador',
    component: __WEBPACK_IMPORTED_MODULE_17__views_bolsas_avaliacao_coordenador___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/avaliacao-bolsista',
    name: 'AvaliacaoBolsista',
    component: __WEBPACK_IMPORTED_MODULE_18__views_bolsas_avaliacao_bolsista___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/consulta-projetos',
    name: 'ConsultaProjetos',
    component: __WEBPACK_IMPORTED_MODULE_19__views_consulta_projetos_consulta_projetos___default.a
  }, {
    path: '/meus-projetos',
    name: 'MeusProjetos',
    component: __WEBPACK_IMPORTED_MODULE_20__views_consulta_projetos_meus_projetos___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/novo-projeto',
    name: 'NovoProjeto',
    component: __WEBPACK_IMPORTED_MODULE_23__views_editar_projeto_novo_projeto___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/importar-projeto',
    name: 'ImportarProjeto',
    component: __WEBPACK_IMPORTED_MODULE_26__views_editar_projeto_importar_projeto___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/duplicar-projeto',
    name: 'DuplicarProjeto',
    component: __WEBPACK_IMPORTED_MODULE_27__views_editar_projeto_duplicar_projeto___default.a,
    meta: { requiresAuth: true }
  }, { // Página "Novo Projeto de Pesquisa"
    path: '/pesquisa/novo-projeto',
    name: 'NovoProjetoPesquisa',
    component: __WEBPACK_IMPORTED_MODULE_105__views_pesquisa_novo_projeto_pesquisa___default.a,
    meta: { requiresAuth: true }
  }, { // Página "Meus Projetos de Pesquisa"
    path: '/pesquisa/meus-projetos',
    name: 'MeusProjetosPesquisa',
    component: __WEBPACK_IMPORTED_MODULE_106__views_pesquisa_meus_projetos_pesquisa___default.a,
    meta: { requiresAuth: true }
  }, { // Página "Consultar Projetos de Pesquisa"
    path: '/pesquisa/consulta-projetos',
    name: 'ConsultaProjetosPesquisa',
    component: __WEBPACK_IMPORTED_MODULE_107__views_pesquisa_consulta_projetos_pesquisa___default.a,
    meta: { requiresAuth: false }
  },
  // Página de ajuda para o cadastro dos projetos de pesquisa.
  {
    path: '/pesquisa/ajuda',
    name: 'AjudaPesquisa',
    component: __WEBPACK_IMPORTED_MODULE_139__views_pesquisa_ajuda_pesquisa___default.a
  }, { // Visualização de um Projeto de Pesquisa"
    path: '/pesquisa/projetos/:idProjetoPesquisa',
    name: 'ProjetoPesquisa',
    component: __WEBPACK_IMPORTED_MODULE_108__views_pesquisa_projeto_pesquisa___default.a,
    props: function props(route) {
      return { idProjetoPesquisa: route.params.idProjetoPesquisa };
    },
    meta: { requiresAuth: false },
    children: [{ // Aba "Informações Básicas"
      path: 'informacoes-basicas',
      name: 'ProjetoPesquisaInformacoesBasicas',
      component: __WEBPACK_IMPORTED_MODULE_109__views_pesquisa_informacoes_basicas___default.a
    }, { // Aba "Detalhamento"
      path: 'detalhamento',
      name: 'ProjetoPesquisaDetalhamento',
      component: __WEBPACK_IMPORTED_MODULE_110__views_pesquisa_detalhamento___default.a
    }, { // Aba "Instituições"
      path: 'instituicoes',
      name: 'ProjetoPesquisaInstituicoes',
      component: __WEBPACK_IMPORTED_MODULE_111__views_pesquisa_instituicoes___default.a
    }, { // Aba "Equipe"
      path: 'equipe',
      name: 'ProjetoPesquisaEquipe',
      component: __WEBPACK_IMPORTED_MODULE_115__views_pesquisa_equipe___default.a
    }, { // Aba "Órgãos Financiadores"
      path: 'orgaos-financiadores',
      name: 'ProjetoPesquisaOrgaosFinanciadores',
      component: __WEBPACK_IMPORTED_MODULE_119__views_pesquisa_orgaos_financiadores___default.a
    }, { // Aba "Outras Informações"
      path: 'outras-informacoes',
      name: 'ProjetoPesquisaOutrasInformacoes',
      component: __WEBPACK_IMPORTED_MODULE_123__views_pesquisa_outras_informacoes___default.a
    }, { // Aba "Arquivos"
      path: 'arquivos',
      name: 'ProjetoPesquisaArquivos',
      component: __WEBPACK_IMPORTED_MODULE_124__views_pesquisa_arquivos___default.a
    }, { // Aba "Contatos"
      path: 'contatos',
      name: 'ProjetoPesquisaContatos',
      component: __WEBPACK_IMPORTED_MODULE_126__views_pesquisa_contatos___default.a
    }, { // Aba "Resultados Obtidos"
      path: 'resultados-obtidos',
      name: 'ProjetoPesquisaResultadosObtidos',
      component: __WEBPACK_IMPORTED_MODULE_127__views_pesquisa_resultados_obtidos___default.a
    }]
  }, { // Edição de um Projeto de Pesquisa"
    path: '/pesquisa/projetos/:idProjetoPesquisa/editar',
    name: 'EditarProjetoPesquisa',
    component: __WEBPACK_IMPORTED_MODULE_128__views_pesquisa_editar_projeto_pesquisa___default.a,
    props: function props(route) {
      return { idProjetoPesquisa: route.params.idProjetoPesquisa };
    },
    meta: { requiresAuth: true },
    children: [{ // Editar aba "Informações Básicas"
      path: 'informacoes-basicas',
      name: 'EditarProjetoPesquisaInformacoesBasicas',
      component: __WEBPACK_IMPORTED_MODULE_129__views_pesquisa_editar_informacoes_basicas___default.a
    }, { // Editar aba "Detalhamento"
      path: 'detalhamento',
      name: 'EditarProjetoPesquisaDetalhamento',
      component: __WEBPACK_IMPORTED_MODULE_130__views_pesquisa_editar_detalhamento___default.a
    }, { // Editar aba "Outras Informações"
      path: 'outras-informacoes',
      name: 'EditarProjetoPesquisaOutrasInformacoes',
      component: __WEBPACK_IMPORTED_MODULE_135__views_pesquisa_editar_outras_informacoes___default.a
    }, { // Editar aba "Contatos"
      path: 'contatos',
      name: 'EditarProjetoPesquisaContatos',
      component: __WEBPACK_IMPORTED_MODULE_136__views_pesquisa_editar_contatos___default.a
    }, { // Editar aba "Resultados Obtidos"
      path: 'resultados-obtidos',
      name: 'EditarProjetoPesquisaResultadosObtidos',
      component: __WEBPACK_IMPORTED_MODULE_137__views_pesquisa_editar_resultados_obtidos___default.a
    }]
  }, { // Editar Instituição Projeto Pesquisa.
    path: '/pesquisa/projetos/:idProjetoPesquisa/instituicoes/editar/:idInstituicaoProjetoPesquisa',
    name: 'EditarProjetoPesquisaInstituicao',
    component: __WEBPACK_IMPORTED_MODULE_131__views_pesquisa_editar_instituicao___default.a,
    props: function props(route) {
      return { idProjetoPesquisa: route.params.idProjetoPesquisa, idInstituicaoProjetoPesquisa: route.params.idInstituicaoProjetoPesquisa };
    },
    meta: { requiresAuth: true }
  }, { // Pesquisar Instituição.
    path: '/pesquisa/projetos/:idProjetoPesquisa/instituicoes/adicionar',
    name: 'ProjetoPesquisaPesquisarInstituicao',
    component: __WEBPACK_IMPORTED_MODULE_112__views_pesquisa_pesquisar_instituicao___default.a,
    props: function props(route) {
      return { idProjetoPesquisa: route.params.idProjetoPesquisa };
    },
    meta: { requiresAuth: true }
  }, { // Adicionar Instituição Projeto Pesquisa.
    path: '/pesquisa/projetos/:idProjetoPesquisa/instituicoes/adicionar/:idInstituicao',
    name: 'ProjetoPesquisaAdicionarInstituicao',
    component: __WEBPACK_IMPORTED_MODULE_113__views_pesquisa_adicionar_instituicao___default.a,
    props: function props(route) {
      return { idProjetoPesquisa: route.params.idProjetoPesquisa, idInstituicao: route.params.idInstituicao };
    },
    meta: { requiresAuth: true }
  }, { // Cadastrar Instituição.
    path: '/pesquisa/projetos/:idProjetoPesquisa/instituicoes/cadastrar',
    name: 'ProjetoPesquisaCadastrarInstituicao',
    component: __WEBPACK_IMPORTED_MODULE_114__views_pesquisa_cadastrar_instituicao___default.a,
    props: function props(route) {
      return { idProjetoPesquisa: route.params.idProjetoPesquisa };
    },
    meta: { requiresAuth: true }
  }, { // Editar Membro da Equipe.
    path: '/pesquisa/projetos/:idProjetoPesquisa/equipe/editar/:idParticipanteProjetoPesquisa',
    name: 'EditarProjetoPesquisaMembroEquipe',
    component: __WEBPACK_IMPORTED_MODULE_133__views_pesquisa_editar_membro_equipe___default.a,
    props: function props(route) {
      return { idProjetoPesquisa: route.params.idProjetoPesquisa, idParticipanteProjetoPesquisa: route.params.idParticipanteProjetoPesquisa };
    },
    meta: { requiresAuth: true }
  }, { // Finalizar Membro da Equipe.
    path: '/pesquisa/projetos/:idProjetoPesquisa/equipe/finalizar/:idParticipanteProjetoPesquisa',
    name: 'FinalizarParticipacaoProjetoPesquisaMembroEquipe',
    component: __WEBPACK_IMPORTED_MODULE_134__views_pesquisa_finalizar_membro_equipe___default.a,
    props: function props(route) {
      return { idProjetoPesquisa: route.params.idProjetoPesquisa, idParticipanteProjetoPesquisa: route.params.idParticipanteProjetoPesquisa };
    },
    meta: { requiresAuth: true }
  }, { // Pesquisar Pessoas.
    path: '/pesquisa/projetos/:idProjetoPesquisa/equipe/adicionar',
    name: 'ProjetoPesquisaPesquisarPessoas',
    component: __WEBPACK_IMPORTED_MODULE_116__views_pesquisa_pesquisar_pessoas___default.a,
    props: function props(route) {
      return { idProjetoPesquisa: route.params.idProjetoPesquisa };
    },
    meta: { requiresAuth: true }
  }, { // Adicionar Membro da Equipe.
    path: '/pesquisa/projetos/:idProjetoPesquisa/equipe/adicionar/:idPessoa',
    name: 'ProjetoPesquisaAdicionarMembroEquipe',
    component: __WEBPACK_IMPORTED_MODULE_117__views_pesquisa_adicionar_membro_equipe___default.a,
    props: function props(route) {
      return { idProjetoPesquisa: route.params.idProjetoPesquisa, idPessoa: route.params.idPessoa };
    },
    meta: { requiresAuth: true }
  }, { // Cadastrar Membro Externo.
    path: '/pesquisa/projetos/:idProjetoPesquisa/equipe/cadastrar-membro-externo',
    name: 'ProjetoPesquisaCadastrarMembroExterno',
    component: __WEBPACK_IMPORTED_MODULE_118__views_pesquisa_cadastrar_membro_externo___default.a,
    props: function props(route) {
      return { idProjetoPesquisa: route.params.idProjetoPesquisa };
    },
    meta: { requiresAuth: true }
  }, { // Editar Órgão Financiador Projeto Pesquisa.
    path: '/pesquisa/projetos/:idProjetoPesquisa/orgaos-financiadores/editar/:idOrgaoFinanciadorProjetoPesquisa',
    name: 'EditarProjetoPesquisaOrgaoFinanciador',
    component: __WEBPACK_IMPORTED_MODULE_132__views_pesquisa_editar_orgao_financiador___default.a,
    props: function props(route) {
      return { idProjetoPesquisa: route.params.idProjetoPesquisa, idOrgaoFinanciadorProjetoPesquisa: route.params.idOrgaoFinanciadorProjetoPesquisa };
    },
    meta: { requiresAuth: true }
  }, { // Pesquisar Órgão Financiador.
    path: '/pesquisa/projetos/:idProjetoPesquisa/orgaos-financiadores/adicionar',
    name: 'ProjetoPesquisaPesquisarOrgaoFinanciador',
    component: __WEBPACK_IMPORTED_MODULE_120__views_pesquisa_pesquisar_orgao_financiador___default.a,
    props: function props(route) {
      return { idProjetoPesquisa: route.params.idProjetoPesquisa };
    },
    meta: { requiresAuth: true }
  }, { // Adicionar Órgão Financiador Projeto Pesquisa.
    path: '/pesquisa/projetos/:idProjetoPesquisa/orgaos-financiadores/adicionar/:idOrgaoFinanciador',
    name: 'ProjetoPesquisaAdicionarOrgaoFinanciador',
    component: __WEBPACK_IMPORTED_MODULE_121__views_pesquisa_adicionar_orgao_financiador___default.a,
    props: function props(route) {
      return { idProjetoPesquisa: route.params.idProjetoPesquisa, idOrgaoFinanciador: route.params.idOrgaoFinanciador };
    },
    meta: { requiresAuth: true }
  }, { // Cadastrar Órgão Financiador.
    path: '/pesquisa/projetos/:idProjetoPesquisa/orgaos-financiadores/cadastrar',
    name: 'ProjetoPesquisaCadastrarOrgaoFinanciador',
    component: __WEBPACK_IMPORTED_MODULE_122__views_pesquisa_cadastrar_orgao_financiador___default.a,
    props: function props(route) {
      return { idProjetoPesquisa: route.params.idProjetoPesquisa };
    },
    meta: { requiresAuth: true }
  }, { // Editar Arquivo Projeto Pesquisa.
    path: '/pesquisa/projetos/:idProjetoPesquisa/arquivos/editar/:idArquivoProjetoPesquisa',
    name: 'EditarProjetoPesquisaArquivo',
    component: __WEBPACK_IMPORTED_MODULE_138__views_pesquisa_editar_arquivo___default.a,
    props: function props(route) {
      return { idProjetoPesquisa: route.params.idProjetoPesquisa, idArquivoProjetoPesquisa: route.params.idArquivoProjetoPesquisa };
    },
    meta: { requiresAuth: true }
  }, { // Adicionar Arquivo Projeto Pesquisa.
    path: '/pesquisa/projetos/:idProjetoPesquisa/arquivos/adicionar',
    name: 'ProjetoPesquisaAdicionarArquivo',
    component: __WEBPACK_IMPORTED_MODULE_125__views_pesquisa_adicionar_arquivo___default.a,
    props: function props(route) {
      return { idProjetoPesquisa: route.params.idProjetoPesquisa };
    },
    meta: { requiresAuth: true }
  }, {
    path: '/projetos/:idProjeto',
    name: 'Projeto',
    component: __WEBPACK_IMPORTED_MODULE_21__views_projeto_projeto___default.a,
    props: function props(route) {
      return { idProjeto: route.params.idProjeto };
    },
    children: [{
      path: 'informacoes',
      name: 'ProjetoFormulario',
      component: __WEBPACK_IMPORTED_MODULE_28__views_projeto_projeto_formulario___default.a
    }, {
      path: 'classificacoes',
      name: 'ClassificacoesProjeto',
      component: __WEBPACK_IMPORTED_MODULE_29__views_projeto_projeto_classificacoes_tabela___default.a
    }, {
      path: 'extensao',
      name: 'ExtensaoProjeto',
      component: __WEBPACK_IMPORTED_MODULE_30__views_projeto_projeto_extensao___default.a
    }, {
      path: 'contatos',
      name: 'ContatosProjeto',
      component: __WEBPACK_IMPORTED_MODULE_31__views_projeto_projeto_contatos___default.a
    }, {
      path: 'integrantes',
      name: 'IntegrantesProjeto',
      component: __WEBPACK_IMPORTED_MODULE_32__views_projeto_projeto_integrantes_tabela___default.a
    }, {
      path: 'atividades',
      name: 'AtividadesProjeto',
      component: __WEBPACK_IMPORTED_MODULE_33__views_projeto_projeto_atividades_tabela___default.a
    }, {
      path: 'vinculos',
      name: 'VinculosProjeto',
      component: __WEBPACK_IMPORTED_MODULE_34__views_projeto_projeto_vinculos_tabela___default.a
    }, {
      path: 'parcerias',
      name: 'ParceriasProjeto',
      component: __WEBPACK_IMPORTED_MODULE_35__views_projeto_projeto_parcerias_tabela___default.a
    }, {
      path: 'abrangencia',
      name: 'AbrangenciaProjeto',
      component: __WEBPACK_IMPORTED_MODULE_36__views_projeto_projeto_abrangencia_tabela___default.a
    }, {
      path: 'bolsas',
      name: 'BolsasProjeto',
      component: __WEBPACK_IMPORTED_MODULE_37__views_projeto_projeto_bolsas_tabela___default.a
    }, {
      path: 'arquivos',
      name: 'ArquivosProjeto',
      component: __WEBPACK_IMPORTED_MODULE_38__views_projeto_projeto_arquivos_tabela___default.a
    }, {
      path: 'relatorios',
      name: 'RelatoriosProjeto',
      component: __WEBPACK_IMPORTED_MODULE_39__views_projeto_projeto_relatorios_tabela___default.a
    }]
  }, {
    path: '/editar-projetos/:idProjeto',
    name: 'EditarProjeto',
    component: __WEBPACK_IMPORTED_MODULE_22__views_editar_projeto_editar_projeto___default.a,
    props: function props(route) {
      return { idProjeto: route.params.idProjeto };
    },
    meta: { requiresAuth: true },
    children: [{
      path: 'informacoes',
      name: 'EditarInformacoes',
      component: __WEBPACK_IMPORTED_MODULE_40__views_editar_projeto_editar_informacoes___default.a
    }, {
      path: 'editar-classificacao',
      name: 'EditarClassificacao',
      component: __WEBPACK_IMPORTED_MODULE_41__views_editar_projeto_editar_classificacao___default.a
    }, {
      path: 'editar-extensao',
      name: 'EditarExtensao',
      component: __WEBPACK_IMPORTED_MODULE_42__views_editar_projeto_editar_extensao___default.a
    }, {
      path: 'editar-contatos',
      name: 'EditarContatos',
      component: __WEBPACK_IMPORTED_MODULE_43__views_editar_projeto_editar_contatos___default.a
    }, {
      path: 'editar-integrantes',
      name: 'EditarIntegrantes',
      component: __WEBPACK_IMPORTED_MODULE_44__views_editar_projeto_projeto_editar_integrantes___default.a
    }, {
      path: 'editar-atividades',
      name: 'EditarAtividades',
      component: __WEBPACK_IMPORTED_MODULE_46__views_editar_projeto_projeto_editar_atividades___default.a
    }, {
      path: 'editar-parcerias',
      name: 'EditarParcerias',
      component: __WEBPACK_IMPORTED_MODULE_45__views_editar_projeto_projeto_editar_parcerias___default.a
    }, {
      path: 'editar-abrangencia',
      name: 'EditarAbrangencia',
      component: __WEBPACK_IMPORTED_MODULE_47__views_editar_projeto_projeto_editar_abrangencia___default.a
    }, {
      path: 'editar-arquivos',
      name: 'EditarArquivos',
      component: __WEBPACK_IMPORTED_MODULE_48__views_editar_projeto_projeto_editar_arquivos___default.a
    }]
  }, {
    path: '/projetos/:idProjeto/integrantes/novo',
    name: 'NovoIntegrante',
    component: __WEBPACK_IMPORTED_MODULE_53__views_integrantes_novo_integrante___default.a,
    props: function props(route) {
      return { idProjeto: route.params.idProjeto };
    },
    meta: { requiresAuth: true }
  }, {
    path: '/projetos/:idProjeto/integrantes/adicionar/:idPessoa',
    name: 'AdicionarIntegrante',
    component: __WEBPACK_IMPORTED_MODULE_54__views_integrantes_adicionar_integrante___default.a,
    props: function props(route) {
      return { idProjeto: route.params.idProjeto, idPessoa: route.params.idPessoa };
    },
    meta: { requiresAuth: true }
  }, {
    path: '/projetos/:idProjeto/integrantes/:idParticipante/editar',
    name: 'EditarIntegrante',
    component: __WEBPACK_IMPORTED_MODULE_51__views_integrantes_editar_integrante___default.a,
    props: function props(route) {
      return { idProjeto: route.params.idProjeto, idParticipante: route.params.idParticipante };
    },
    meta: { requiresAuth: true }
  }, {
    path: '/projetos/:idProjeto/integrantes/:idParticipante/visualizar',
    name: 'VisualizarIntegrante',
    component: __WEBPACK_IMPORTED_MODULE_52__views_integrantes_visualizar_integrante___default.a,
    props: function props(route) {
      return { idProjeto: route.params.idProjeto, idParticipante: route.params.idParticipante };
    },
    meta: { requiresAuth: true }
  }, {
    path: '/projetos/:idProjeto/integrantes/:idParticipante/encerrar',
    name: 'EncerrarParticipacao',
    component: __WEBPACK_IMPORTED_MODULE_55__views_integrantes_encerrar_participacao___default.a,
    props: function props(route) {
      return { idProjeto: route.params.idProjeto, idParticipante: route.params.idParticipante };
    },
    meta: { requiresAuth: true }
  }, {
    path: '/projetos/:idProjeto/integrantes/:idParticipante/reativar',
    name: 'ReativarParticipacao',
    component: __WEBPACK_IMPORTED_MODULE_56__views_integrantes_reativar_participacao___default.a,
    props: function props(route) {
      return { idProjeto: route.params.idProjeto, idParticipante: route.params.idParticipante };
    },
    meta: { requiresAuth: true }
  }, {
    path: '/projetos/:idProjeto/integrantes/:idParticipante/ocorrencias',
    name: 'OcorrenciasIntegrante',
    component: __WEBPACK_IMPORTED_MODULE_57__views_integrantes_ocorrencias_integrante___default.a,
    props: function props(route) {
      return { idProjeto: route.params.idProjeto, idParticipante: route.params.idParticipante };
    },
    meta: { requiresAuth: true }
  }, {
    path: '/projetos/:idProjeto/integrantes/:idParticipante/trocar-coordenador',
    name: 'TrocarCoordenador',
    component: __WEBPACK_IMPORTED_MODULE_58__views_integrantes_trocar_coordenador___default.a,
    props: function props(route) {
      return { idProjeto: route.params.idProjeto, idParticipante: route.params.idParticipante };
    },
    meta: { requiresAuth: true }
  }, {
    path: '/projetos/:idProjeto/integrantes/:idParticipante/frequencia',
    name: 'FrequenciaIntegrante',
    component: __WEBPACK_IMPORTED_MODULE_102__views_frequencia_lista_frequencia___default.a,
    props: function props(route) {
      return { idProjeto: route.params.idProjeto, idParticipante: route.params.idParticipante };
    },
    meta: { requiresAuth: true }
  }, {
    path: '/projetos/:idProjeto/integrantes/:idParticipante/frequencia/criar',
    name: 'CriarFrequencia',
    component: __WEBPACK_IMPORTED_MODULE_103__views_frequencia_criar_frequencia___default.a,
    props: function props(route) {
      return { idProjeto: route.params.idProjeto, idParticipante: route.params.idParticipante };
    },
    meta: { requiresAuth: true }
  }, {
    path: '/projetos/:idProjeto/nova-atividade',
    name: 'NovaAtividade',
    component: __WEBPACK_IMPORTED_MODULE_59__views_editar_projeto_nova_atividade___default.a,
    props: function props(route) {
      return { idProjeto: route.params.idProjeto };
    },
    meta: { requiresAuth: true }
  }, {
    path: '/projetos/:idProjeto/nova-parceria',
    name: 'NovaParceria',
    component: __WEBPACK_IMPORTED_MODULE_60__views_editar_projeto_nova_parceria___default.a,
    props: function props(route) {
      return { idProjeto: route.params.idProjeto };
    },
    meta: { requiresAuth: true }
  }, {
    path: '/projetos/:idProjeto/nova-localidade',
    name: 'NovaLocalidade',
    component: __WEBPACK_IMPORTED_MODULE_61__views_editar_projeto_nova_localidade___default.a,
    props: function props(route) {
      return { idProjeto: route.params.idProjeto };
    },
    meta: { requiresAuth: true }
  }, {
    path: '/projetos/:idProjeto/upload-arquivo',
    name: 'UploadArquivo',
    component: __WEBPACK_IMPORTED_MODULE_24__views_editar_projeto_upload_arquivo___default.a,
    props: function props(route) {
      return { idProjeto: route.params.idProjeto };
    },
    meta: { requiresAuth: true }
  }, {
    path: '/projetos/:idProjeto/editar-arquivo/:idArquivo',
    name: 'EditarArquivo',
    component: __WEBPACK_IMPORTED_MODULE_25__views_editar_projeto_editar_arquivo___default.a,
    props: function props(route) {
      return { idProjeto: route.params.idProjeto, idArquivo: route.params.idArquivo };
    },
    meta: { requiresAuth: true }
  }, {
    path: '/projetos/:idProjeto/relatorios/:idRelatorioExtensao',
    name: 'RelatorioTecnico',
    component: __WEBPACK_IMPORTED_MODULE_100__views_relatorio_relatorio_tecnico___default.a,
    props: function props(route) {
      return { idProjeto: route.params.idProjeto, idRelatorioExtensao: route.params.idRelatorioExtensao };
    }
  }, {
    path: '/projetos/:idProjeto/relatorios/:idRelatorioExtensao/relatorio-pdf',
    name: 'RelatorioTecnicoPDF',
    component: __WEBPACK_IMPORTED_MODULE_101__views_relatorio_relatorio_tecnico_pdf___default.a,
    props: function props(route) {
      return { idProjeto: route.params.idProjeto, idRelatorioExtensao: route.params.idRelatorioExtensao };
    },
    meta: { requiresAuth: true, plainLayout: true }
  }, {
    path: '/projetos/:idProjeto/novo-relatorio-tecnico',
    name: 'NovoRelatorio',
    component: __WEBPACK_IMPORTED_MODULE_98__views_relatorio_novo_relatorio_tecnico___default.a,
    props: function props(route) {
      return { idProjeto: route.params.idProjeto };
    },
    meta: { requiresAuth: true }
  }, {
    path: '/projetos/:idProjeto/editar-relatorio/:idRelatorioExtensao?',
    name: 'EditarRelatorio',
    component: __WEBPACK_IMPORTED_MODULE_99__views_relatorio_editar_relatorio___default.a,
    props: function props(route) {
      return { idProjeto: route.params.idProjeto, idRelatorioExtensao: route.params.idRelatorioExtensao };
    },
    meta: { requiresAuth: true }
  }, {
    path: '/projetos/:idProjeto/editar-atividade/:idAtividade',
    name: 'EditarAtividade',
    component: __WEBPACK_IMPORTED_MODULE_62__views_editar_projeto_editar_atividade___default.a,
    props: function props(route) {
      return { idProjeto: route.params.idProjeto, idAtividade: route.params.idAtividade };
    },
    meta: { requiresAuth: true }
  }, {
    path: '/projetos/:idProjeto/editar-parceria/:idParceria',
    name: 'EditarParceria',
    component: __WEBPACK_IMPORTED_MODULE_63__views_editar_projeto_editar_parceria___default.a,
    props: function props(route) {
      return { idProjeto: route.params.idProjeto, idParceria: route.params.idParceria };
    },
    meta: { requiresAuth: true }
  }, {
    path: '/projetos/:idProjeto/editar-localidade/:idLocalidade',
    name: 'EditarLocalidade',
    component: __WEBPACK_IMPORTED_MODULE_49__views_editar_projeto_editar_localidade___default.a,
    props: function props(route) {
      return { idProjeto: route.params.idProjeto, idLocalidade: route.params.idLocalidade };
    },
    meta: { requiresAuth: true }
  }, {
    path: '/projetos/:idProjeto/superior',
    name: 'EditarProjetoSuperior',
    component: __WEBPACK_IMPORTED_MODULE_50__views_editar_projeto_editar_projeto_superior___default.a,
    props: function props(route) {
      return { idProjeto: route.params.idProjeto };
    },
    meta: { requiresAuth: true }
  }, {
    path: '/projetos/:idProjeto/nova-pessoa',
    name: 'NovaPessoa',
    component: __WEBPACK_IMPORTED_MODULE_64__views_editar_projeto_nova_pessoa___default.a,
    props: function props(route) {
      return { idProjeto: route.params.idProjeto };
    },
    meta: { requiresAuth: true }
  }, {
    path: '/projetos/:idProjeto/novo-membro-externo',
    name: 'CadastrarMembroExterno',
    component: __WEBPACK_IMPORTED_MODULE_65__views_editar_projeto_novo_membro_externo___default.a,
    props: function props(route) {
      return { idProjeto: route.params.idProjeto };
    },
    meta: { requiresAuth: true }
  }, {
    path: '/projetos/:idProjeto/finalizar',
    name: 'FinalizarAcao',
    component: __WEBPACK_IMPORTED_MODULE_81__views_editar_projeto_finalizar_projeto___default.a,
    props: function props(route) {
      return { idProjeto: route.params.idProjeto };
    },
    meta: { requiresAuth: true }
  }, {
    path: '/editar-pessoa/:idPessoa',
    name: 'EditarPessoa',
    component: __WEBPACK_IMPORTED_MODULE_66__views_editar_projeto_editar_pessoa___default.a,
    props: function props(route) {
      return { idPessoa: route.params.idPessoa };
    },
    meta: { requiresAuth: true }
  }, {
    path: '/projetos/:idProjeto/relatorio',
    name: 'Relatorio',
    component: __WEBPACK_IMPORTED_MODULE_67__views_consulta_projetos_relatorio___default.a,
    props: function props(route) {
      return { idProjeto: route.params.idProjeto };
    },
    meta: { requiresAuth: true, plainLayout: true }
  }, {
    path: '/projetos-aguardando-aprovacao',
    name: 'ProjetosAguardandoAprovacao',
    component: __WEBPACK_IMPORTED_MODULE_68__views_administracao_projetos_aprovar_tabela___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/relatorios-aguardando-aprovacao',
    name: 'RelatoriosAguardandoAprovacao',
    component: __WEBPACK_IMPORTED_MODULE_69__views_administracao_relatorios_aprovar_tabela___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/projetos-vencidos',
    name: 'ProjetosVencidos',
    component: __WEBPACK_IMPORTED_MODULE_70__views_administracao_projetos_vencidos_tabela___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/projetos-concluir',
    name: 'ProjetosConcluir',
    component: __WEBPACK_IMPORTED_MODULE_71__views_administracao_projetos_concluir_tabela___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/aprovar-projeto/:idProjeto',
    name: 'AprovarProjeto',
    component: __WEBPACK_IMPORTED_MODULE_74__views_administracao_aprovar_projeto___default.a,
    props: function props(route) {
      return { idProjeto: route.params.idProjeto };
    },
    meta: { requiresAuth: true }
  }, {
    path: '/devolver-projeto/:idProjeto',
    name: 'DevolverProjeto',
    component: __WEBPACK_IMPORTED_MODULE_75__views_administracao_devolver_projeto___default.a,
    props: function props(route) {
      return { idProjeto: route.params.idProjeto };
    },
    meta: { requiresAuth: true }
  }, {
    path: '/liberar-relatorio/:idProjeto',
    name: 'LiberarRelatorio',
    component: __WEBPACK_IMPORTED_MODULE_76__views_administracao_liberar_relatorio___default.a,
    props: function props(route) {
      return { idProjeto: route.params.idProjeto };
    },
    meta: { requiresAuth: true }
  }, {
    path: '/inabilitar-projeto/:idProjeto',
    name: 'InabilitarProjeto',
    component: __WEBPACK_IMPORTED_MODULE_77__views_administracao_inabilitar_projeto___default.a,
    props: function props(route) {
      return { idProjeto: route.params.idProjeto };
    },
    meta: { requiresAuth: true }
  }, {
    path: '/alterar-classificacao-secundaria/:idProjeto',
    name: 'AlterarClassificacaoSecundaria',
    component: __WEBPACK_IMPORTED_MODULE_78__views_administracao_alterar_classificacao_secundaria___default.a,
    props: function props(route) {
      return { idProjeto: route.params.idProjeto };
    },
    meta: { requiresAuth: true }
  }, {
    path: '/projetos/:idProjeto/suspensao',
    name: 'SuspenderAcaoExtensao',
    component: __WEBPACK_IMPORTED_MODULE_79__views_administracao_suspender_acao_extensao___default.a,
    props: function props(route) {
      return { idProjeto: route.params.idProjeto };
    },
    meta: { requiresAuth: true }
  }, {
    path: '/projetos/:idProjeto/reativacao',
    name: 'ReativarAcaoExtensao',
    component: __WEBPACK_IMPORTED_MODULE_80__views_administracao_reativar_acao_extensao___default.a,
    props: function props(route) {
      return { idProjeto: route.params.idProjeto };
    },
    meta: { requiresAuth: true }
  }, {
    path: '/concluir-projeto/:idProjeto',
    name: 'ConcluirProjeto',
    component: __WEBPACK_IMPORTED_MODULE_82__views_administracao_concluir_projeto___default.a,
    props: function props(route) {
      return { idProjeto: route.params.idProjeto };
    },
    meta: { requiresAuth: true }
  }, {
    path: '/cancelar-projeto/:idProjeto',
    name: 'CancelarProjeto',
    component: __WEBPACK_IMPORTED_MODULE_83__views_administracao_cancelar_projeto___default.a,
    props: function props(route) {
      return { idProjeto: route.params.idProjeto };
    },
    meta: { requiresAuth: true }
  }, {
    path: '/desfazer-finalizacao/:idProjeto',
    name: 'DesfazerFinalizacao',
    component: __WEBPACK_IMPORTED_MODULE_84__views_administracao_desfazer_finalizacao___default.a,
    props: function props(route) {
      return { idProjeto: route.params.idProjeto };
    },
    meta: { requiresAuth: true }
  }, {
    path: '/desfazer-exclusao/:idProjeto',
    name: 'DesfazerExclusao',
    component: __WEBPACK_IMPORTED_MODULE_85__views_administracao_desfazer_exclusao___default.a,
    props: function props(route) {
      return { idProjeto: route.params.idProjeto };
    },
    meta: { requiresAuth: true }
  }, {
    path: '/administracao',
    name: 'Administracao',
    component: __WEBPACK_IMPORTED_MODULE_72__views_administracao_administracao___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/pesquisa',
    name: 'Pesquisa',
    component: __WEBPACK_IMPORTED_MODULE_73__views_ajuda_pesquisa___default.a,
    meta: { requiresAuth: false }
  }, {
    path: '/projetos-parceiros',
    name: 'ProjetosParceiros',
    component: __WEBPACK_IMPORTED_MODULE_86__views_administracao_parcerias_tabela___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/administracao/relatorios-de-gestao',
    name: 'RelatoriosGestao',
    component: __WEBPACK_IMPORTED_MODULE_87__views_administracao_relatorios_gestao_tabela___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/administracao/nova-mensagem',
    name: 'NovaMensagem',
    component: __WEBPACK_IMPORTED_MODULE_88__views_administracao_nova_mensagem___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/administracao/usuarios-proex',
    name: 'UsuariosProex',
    component: __WEBPACK_IMPORTED_MODULE_89__views_administracao_usuarios_proex___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/administracao/definir-periodo-frequencia',
    name: 'DefinirPeriodoFrequencia',
    component: __WEBPACK_IMPORTED_MODULE_90__views_administracao_definir_periodo_frequencia___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/administracao/relatorio-seguro',
    name: 'RelatorioSeguro',
    component: __WEBPACK_IMPORTED_MODULE_91__views_administracao_relatorio_seguro___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/administracao/registro-envio-relatorio',
    name: 'RegistrarEnvioDeRelatorioDeProjeto',
    component: __WEBPACK_IMPORTED_MODULE_93__views_administracao_registro_envio_relatorios_projeto___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/administracao/reprovar-relatorios-suspensao-coordenador',
    name: 'ReprovarRelatorioComSuspensaoDeCoordenador',
    component: __WEBPACK_IMPORTED_MODULE_92__views_administracao_reprovar_relatorios_suspensao_coordenador___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/projetos/:idProjeto/relatorios/:idRelatorio/submeter',
    name: 'SubmeterRelatorio',
    component: __WEBPACK_IMPORTED_MODULE_94__views_relatorio_submeter___default.a,
    props: function props(route) {
      return { idProjeto: route.params.idProjeto, idRelatorio: route.params.idRelatorio };
    },
    meta: { requiresAuth: true }
  }, {
    path: '/projetos/:idProjeto/relatorios/:idRelatorio/aprovar',
    name: 'AprovarRelatorio',
    component: __WEBPACK_IMPORTED_MODULE_95__views_relatorio_aprovar___default.a,
    props: function props(route) {
      return { idProjeto: route.params.idProjeto, idRelatorio: route.params.idRelatorio };
    },
    meta: { requiresAuth: true }
  }, {
    path: '/projetos/:idProjeto/relatorios/:idRelatorio/devolver',
    name: 'DevolverRelatorio',
    component: __WEBPACK_IMPORTED_MODULE_96__views_relatorio_devolver___default.a,
    props: function props(route) {
      return { idProjeto: route.params.idProjeto, idRelatorio: route.params.idRelatorio };
    },
    meta: { requiresAuth: true }
  }, {
    path: '/projetos/:idProjeto/relatorios/:idRelatorio/reprovar',
    name: 'ReprovarRelatorio',
    component: __WEBPACK_IMPORTED_MODULE_97__views_relatorio_reprovar___default.a,
    props: function props(route) {
      return { idProjeto: route.params.idProjeto, idRelatorio: route.params.idRelatorio };
    },
    meta: { requiresAuth: true }
  }, {
    path: '/administrador',
    name: 'AtivarDesativarAdministrador',
    component: __WEBPACK_IMPORTED_MODULE_104__views_administracao_ativar_desativar_administrador___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/ajuda',
    name: 'Ajuda',
    component: __WEBPACK_IMPORTED_MODULE_5__views_ajuda_ajuda___default.a
  }, {
    path: '/faq',
    name: 'Faq',
    component: __WEBPACK_IMPORTED_MODULE_6__views_ajuda_faq___default.a
  }, {
    path: '/404',
    name: '404',
    component: __WEBPACK_IMPORTED_MODULE_7__views_ajuda_404___default.a
  }]
});

router.beforeEach(function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(to, from, next) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            __WEBPACK_IMPORTED_MODULE_10__utils_projetos__["a" /* default */].getListaMensagem().then(function (response) {
              __WEBPACK_IMPORTED_MODULE_8__vuex_store__["a" /* default */].dispatch('ui/SET_MENSAGEM', response.data.pop());
              next();
            }).catch(function () {
              next();
            });

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());

router.beforeEach(function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(to, from, next) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!__WEBPACK_IMPORTED_MODULE_8__vuex_store__["a" /* default */].getters['auth/logged']) {
              __WEBPACK_IMPORTED_MODULE_9__utils_auth__["a" /* default */].authenticated().then(function (response) {
                __WEBPACK_IMPORTED_MODULE_8__vuex_store__["a" /* default */].dispatch('auth/SET_USERNAME', { username: response.data.uid });
                __WEBPACK_IMPORTED_MODULE_8__vuex_store__["a" /* default */].dispatch('auth/SET_NOME', { nome: response.data.nome });
                __WEBPACK_IMPORTED_MODULE_8__vuex_store__["a" /* default */].dispatch('auth/SET_VINCULO', { vinculo: response.data.vinculo });

                __WEBPACK_IMPORTED_MODULE_8__vuex_store__["a" /* default */].dispatch('auth/SET_ADMINISTRADOR', { administrador: response.data.administrador });
                __WEBPACK_IMPORTED_MODULE_8__vuex_store__["a" /* default */].dispatch('auth/SET_USUARIO_PROEX', { usuarioPROEX: response.data.usuarioPROEX });
                __WEBPACK_IMPORTED_MODULE_8__vuex_store__["a" /* default */].dispatch('auth/SET_PERMISSAO_CRIAR_PROJETO_EXTENSAO', { permissaoCriarProjetoExtensao: response.data.permissaoCriarProjetoExtensao });
                // store.dispatch('auth/SET_PERMISSAO_CRIAR_PROJETO_PESQUISA', { permissaoCriarProjetoPesquisa: response.data.permissaoCriarProjetoPesquisa })

                __WEBPACK_IMPORTED_MODULE_8__vuex_store__["a" /* default */].dispatch('auth/SET_LOGGED_IN');
                if (response.data.numeroAcesso < 1) {
                  __WEBPACK_IMPORTED_MODULE_8__vuex_store__["a" /* default */].dispatch('ui/SHOW_MENSAGEM');
                }
                next();
              }).catch(function () {
                next();
              });
            } else {
              next();
            }

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function (_x4, _x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}());

router.beforeEach(function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(to, from, next) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (to.matched.some(function (record) {
              return record.meta.requiresAuth;
            })) {
              if (!__WEBPACK_IMPORTED_MODULE_8__vuex_store__["a" /* default */].getters['auth/logged']) {
                __WEBPACK_IMPORTED_MODULE_9__utils_auth__["a" /* default */].authenticated().then(function (response) {
                  __WEBPACK_IMPORTED_MODULE_8__vuex_store__["a" /* default */].dispatch('auth/SET_USERNAME', { username: response.data.uid });
                  __WEBPACK_IMPORTED_MODULE_8__vuex_store__["a" /* default */].dispatch('auth/SET_NOME', { nome: response.data.nome });
                  __WEBPACK_IMPORTED_MODULE_8__vuex_store__["a" /* default */].dispatch('auth/SET_VINCULO', { vinculo: response.data.vinculo });
                  __WEBPACK_IMPORTED_MODULE_8__vuex_store__["a" /* default */].dispatch('auth/SET_ADMINISTRADOR', { administrador: response.data.administrador });
                  __WEBPACK_IMPORTED_MODULE_8__vuex_store__["a" /* default */].dispatch('auth/SET_USUARIO_PROEX', { usuarioPROEX: response.data.usuarioPROEX });
                  __WEBPACK_IMPORTED_MODULE_8__vuex_store__["a" /* default */].dispatch('auth/SET_PERMISSAO_CRIAR_PROJETO_EXTENSAO', { permissaoCriarProjetoExtensao: response.data.permissaoCriarProjetoExtensao });
                  __WEBPACK_IMPORTED_MODULE_8__vuex_store__["a" /* default */].dispatch('auth/SET_LOGGED_IN');
                  if (response.data.numeroAcesso < 1) {
                    __WEBPACK_IMPORTED_MODULE_8__vuex_store__["a" /* default */].dispatch('ui/SHOW_MENSAGEM');
                  }
                  next();
                }).catch(function () {
                  window.location = encodeURI(PIB_API_URL + '/');
                });
              } else {
                next();
              }
            } else {
              next();
            }

          case 1:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this);
  }));

  return function (_x7, _x8, _x9) {
    return _ref3.apply(this, arguments);
  };
}());

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(347)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(348),
  /* template */
  __webpack_require__(352),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 347 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_toolbars_basic_toolbar__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ajuda',
  methods: {
    cardClick: function cardClick() {
      console.log('Clicou');
    }
  },
  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_0__components_toolbars_basic_toolbar___default.a
  }
});

/***/ }),
/* 349 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['title', 'closeCallback', 'color']
});

/***/ }),
/* 351 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-toolbar', {
    staticClass: "text-xs-center",
    attrs: {
      "text": "",
      "dense": "",
      "color": _vm.color ? _vm.color : 'primary white--text'
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.closeCallback) ? _c('v-btn', {
    attrs: {
      "dark": "",
      "icon": ""
    },
    on: {
      "click": _vm.closeCallback
    }
  }, [_c('v-icon', [_vm._v("close")])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 352 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": "",
      "wrap": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('br'), _c('br'), _vm._v(" "), _c('h2', [_vm._v("Página Inicial")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "10px"
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/consulta-projetos",
      "tag": "button"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "large": ""
    }
  }, [_vm._v("Consulta")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "10px"
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/ajuda",
      "tag": "button"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "large": ""
    }
  }, [_vm._v("Ajuda")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(354),
  /* template */
  __webpack_require__(355),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ajuda'
});

/***/ }),
/* 355 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('v-card-text', [_c('v-container', {
    staticClass: "grey lighten-4",
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('h2', [_vm._v("Os seguintes recursos estão disponíveis em caso de dúvidas:")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', [_c('v-card', [_c('v-card-title', [_vm._v("Perguntas Frequentes:")]), _vm._v(" "), _c('v-card-text', [_c('p', [_vm._v("Respostas para as dúvidas mais comuns sobre o sistema e procedimentos realizados pela PROEX.")]), _vm._v(" "), _c('p', [_vm._v("Em atualização")])])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', [_c('v-card', [_c('v-card-title', [_vm._v("Orientações Gerais:")]), _vm._v(" "), _c('v-card-text', [_c('p', [_vm._v("Para obter maiores informações sobre os Objetivos de Desenvolvimento Sustentável (ODS), clique nos links abaixo:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://ods.ufes.br/",
      "target": "_blank"
    }
  }, [_vm._v("UFES - Objetivos de Desenvolvimento Sustentável")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://brasil.un.org/pt-br/sdgs",
      "target": "_blank"
    }
  }, [_vm._v("Nações Unidas - Objetivos de Desenvolvimento Sustentável no Brasil")])])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', [_c('v-card', [_c('v-card-title', [_vm._v("Fale Conosco:")]), _vm._v(" "), _c('v-card-text', [_c('p', [_vm._v("\n                      Dúvidas sobre preenchimento devem ser encaminhadas para\n                      "), _c('a', {
    attrs: {
      "href": "mailto:suporte.proex@ufes.br"
    }
  }, [_vm._v("suporte.proex@ufes.br")]), _vm._v(".\n                      Já problemas no portal podem ser direcionados para\n                      "), _c('a', {
    attrs: {
      "href": "https://atendimento.ufes.br/",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("\n                        atendimento.ufes.br.\n                      ")])])])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(357)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(358),
  /* template */
  __webpack_require__(359),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 357 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ajuda'
});

/***/ }),
/* 359 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-justify"
  }, [_c('v-card-text', [_c('v-container', [_c('h1', [_vm._v("Perguntas Frequentes")]), _vm._v(" "), _c('h3', [_vm._v("1) Quero cadastrar uma nova atividade de extensão. O que devo fazer?")]), _vm._v("\nAs orientações passo a passo para cadastro estão disponíveis no vídeo "), _c('a', {
    attrs: {
      "href": "https://www.youtube.com/watch?v=rvtSEbetxuw"
    }
  }, [_vm._v("em nosso canal")]), _vm._v(".\n\n\n"), _c('h3', [_vm._v("2) Em que época do ano posso cadastrar uma nova ação de extensão? Preciso aguardar o edital?")]), _vm._v("\nA PROEX recebe os pedidos de registro bem como os relatórios de atividade em fluxo contínuo, durante o ano inteiro.\n\n\n"), _c('h3', [_vm._v("3) Preciso importar meu projeto ativo do SIEX. O que devo fazer?")]), _vm._v("\nAs orientações passo a passo para importação "), _c('a', {
    attrs: {
      "href": "https://www.youtube.com/watch?v=jj2T5ktjbYc"
    }
  }, [_vm._v("em nosso canal")]), _vm._v(".\n\n\n"), _c('h3', [_vm._v("4) Quais são as ações de extensão que devem ser importadas para o Portal de Projetos? Quem faz essa importação?")]), _vm._v("\nTodos os programas e projetos “Ativos” no sistema Siex deverão ser importados para o "), _c('a', {
    attrs: {
      "href": "https://projetos.ufes.br/#/inicio"
    }
  }, [_vm._v("Portal de Projetos")]), _vm._v(". A importação deverá ser feita pelo próprio coordenador com seu login e senha da UFES.\n\n\n"), _c('h3', [_vm._v("5) O meu projeto (e/ou programa) está expirado no Siex, entretanto, continuo desenvolvendo atividades e os meus relatórios estão atualizados. O que fazer para importá-lo para o novo sistema?")]), _vm._v("\nNesse caso, o coordenador deve cadastrar a atividade como “Novo Projeto”, clicar em “submeter à aprovação” e em seguida, abrir um chamado de suporte no botão “Ajuda” (faixa preta na parte superior da tela), informando o precedimento realizado. A PROEX se responsabilizará pela ativação do projeto ou programa.\n\n\n"), _c('h3', [_vm._v("6) Ao importar meu projeto, todos os dados serão migrados?")]), _vm._v("\nDurante a importação, apenas o título da atividade, a data de início, a data de conclusão e o coordenador são importados, os demais dados deverão ser transcritos do Siex ou preenchidos.\n\n\n"), _c('h3', [_vm._v("7) Importei meu projeto para o novo portal, mas ele permanece com a situação “preenchimento incompleto”, o que devo fazer para que ele fique com a situação “ativo”?")]), _vm._v("\nO coordenador deve preencher todos os campos obrigatórios, transcrevendo as informações, conforme constam no Siex e clicar no botão “concluir importação” (abaixo, à esquerda da tela).\n\n\n"), _c('h3', [_vm._v("8) Qual o tamanho máximo dos arquivos que podem ser incluídos na aba “Arquivos”?")]), _vm._v("\nVídeos – até 100 Mega"), _c('br'), _vm._v("\nDemais arquivos – até 5 Mega\n\n\n"), _c('h3', [_vm._v("9) Como faço para imprimir o espelho da proposta?")]), _vm._v("\nO Coordenador deve clicar no botão “Espelho da Proposta” (abaixo, à esquerda da tela). Ao gerar o documento, abrir a caixa de impressão (clicar simultaneamente em ctrl+p ou clicar sobre o documento com o botão direito do mouse e selecionar a opção “imprimir”) e salvar o arquivo como PDF.\n\n\n"), _c('h3', [_vm._v("10) Não consigo alterar a data de conclusão do projeto importado. Como proceder?")]), _vm._v("\nA alteração da data de conclusão é competência da PROEX, mediante aprovação da Câmara de Extensão. A renovação do projeto (ou do programa) deve ser solicitada em campo específico do formulário de relatório. O modelo está disponível em "), _c('a', {
    attrs: {
      "href": "http://proex.ufes.br/formularios"
    }
  }, [_vm._v("formulários")]), _vm._v("."), _c('br'), _vm._v("\nApós o preenchimento, é necessário autuar o relatório como processo digital na secretaria do setor de lotação do coordenador e tramitar para a PROEX."), _c('br'), _vm._v("\nProjetos/Programas de extensão que tenham duração superior a 12 meses, deve-se apresentar relatório anual.\n\n\n\n"), _c('h3', [_vm._v("11) Apareceram mensagens em vermelho indicando algum tipo de erro no sistema. Como devo proceder?")]), _vm._v("\n\nNo próprio "), _c('a', {
    attrs: {
      "href": "https://projetos.ufes.br/#/inicio"
    }
  }, [_vm._v("Portal de Projetos")]), _vm._v(" existe o botão “Ajuda” (faixa preta na parte superior da tela). O coordenador deverá clicar nesse botão e em seguida, clicar no link “sistema de suporte”. Você será direcionado para uma página na qual poderá relatar o problema. Destacamos que o andamento do chamado poderá ser feito através do link "), _c('a', {
    attrs: {
      "href": "https://redmine.ufes.br/#/inicio"
    }
  }, [_vm._v("redmine.ufes.br")]), _vm._v(", e que a resposta será direcionada ao seu e-mail oficial da UFES.\n\n"), _c('h3', [_vm._v("12) Ainda tem Dúvidas?")]), _vm._v("\n\nEntre em contato com a Divisão de Suporte a Projetos: suporte.proex@ufes.br\n\n\n            ")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(361)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(362),
  /* template */
  __webpack_require__(363),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 361 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_toolbars_basic_toolbar__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_0__components_toolbars_basic_toolbar___default.a
  }
});

/***/ }),
/* 363 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": '404'
    }
  }), _vm._v(" "), _c('v-card-text', [_vm._v("\n            Página não encontrada\n          ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "block": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Voltar")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(29);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);

// URL and endpoint constants
var API_URL = "https://pib-api.prod.uks.ufes.br";

// Send a request to the login URL. When using JWT, will just probably uncomment these lines

var authenticated = function authenticated() {
  var AUTH_URL = API_URL + '/auth';
  var config = {
    method: 'get',
    url: AUTH_URL,
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

var logout = function logout() {
  var LOGOUT_URL = API_URL + '/logout';
  var config = {
    method: 'post',
    url: LOGOUT_URL,
    responseType: 'json',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  authenticated: authenticated,
  logout: logout
});

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(366)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(367),
  /* template */
  __webpack_require__(371),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 366 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_bolsas__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      listaBolsas: [],
      dates: __WEBPACK_IMPORTED_MODULE_3__utils_dates__["a" /* default */],
      search: null,
      sortBy: 'dtCriacao',
      sortDesc: true,
      itemsPerPage: 10,
      opcoesPaginacao: [10, 25, 50, { text: 'Todas', value: -1 }],
      headers: [{ text: 'Código', align: 'center', value: 'codigo' }, { text: 'Descrição', align: 'center', value: 'descricao' }, { text: 'Unidade', align: 'center', value: 'valor' }, { text: 'Valor', align: 'center', value: 'valor' }, { text: 'Vagas', align: 'center', value: 'vagasOferecidas' }]
    };
  },
  props: ['items'],
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    truncate: function truncate(string, limit) {
      if (string.length > limit) return string.substring(0, limit) + '...';else return string;
    },

    toCriarBolsa: function toCriarBolsa() {
      this.$router.push({ name: 'CriarBolsa' });
    }
  }),
  mounted: function mounted() {
    var _this = this;

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando bolsas.' });
    __WEBPACK_IMPORTED_MODULE_4__utils_bolsas__["a" /* default */].getBolsas().then(function (response) {
      _this.listaBolsas = response.data.slice();
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando bolsas.' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a
  }
});

/***/ }),
/* 368 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 369 */
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//

/***/ }),
/* 370 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tooltip"
  }, [_vm._t("container"), _vm._v(" "), _c('span', {
    staticClass: "tooltiptext"
  }, [_vm._t("text")], 2)], 2)
},staticRenderFns: []}

/***/ }),
/* 371 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', [_c('basic-toolbar', {
    attrs: {
      "title": 'Bolsas Cadastradas na Universidade'
    }
  }), _vm._v(" "), _c('v-card-title', [_c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "filter_list",
      "label": "Filtrar resultados"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaBolsas,
      "search": _vm.search,
      "no-data-text": 'Nenhuma bolsa encontrada',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', {
          staticClass: "text-xs-center",
          attrs: {
            "width": "10%"
          }
        }, [_vm._v(_vm._s(props.item.codigo))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center",
          attrs: {
            "width": "40%"
          }
        }, [_vm._v(_vm._s(props.item.descricao))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center",
          attrs: {
            "width": "30%"
          }
        }, [_vm._v(_vm._s(props.item.unidade ? props.item.unidade.nome : '-'))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center",
          attrs: {
            "width": "10%"
          }
        }, [_vm._v(_vm._s(props.item.valor))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center",
          attrs: {
            "width": "10%"
          }
        }, [_vm._v(_vm._s(props.item.vagasOcupadas + '/' + props.item.vagasOferecidas))])])]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n            Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaBolsas.length) + " bolsas\n          ")]
      }
    }])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.toCriarBolsa
    }
  }, [_vm._v("Criar bolsa")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(373)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(374),
  /* template */
  __webpack_require__(377),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 373 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_bolsas__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      formularioValido: false,
      listaPermissoesUnidades: [],
      arquivo: undefined,
      bolsa: {
        codigo: '',
        descricao: '',
        valor: undefined,
        vagasOferecidas: undefined,
        unidade: {}
      },
      regrasBasicas: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }],
      assuntoSummaryRules: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }, function (input) {
        return !!input && input.length <= 200 || 'Este campo não pode possuir mais que 200 caracteres';
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    criarBolsa: function criarBolsa() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Criando Bolsa.' });
      __WEBPACK_IMPORTED_MODULE_4__utils_bolsas__["a" /* default */].postBolsa(this.bolsa.unidade.id, this.bolsa).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.$router.push({ name: 'ListaBolsas' });
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Criando Bolsa.' });
      });
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando unidades.' });
    __WEBPACK_IMPORTED_MODULE_4__utils_bolsas__["a" /* default */].getPermissoesUnidades().then(function (response) {
      _this2.listaPermissoesUnidades = response.data.slice();
    }).catch(function (error) {
      _this2.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando unidades.' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a,
    'c-date-menu': __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default.a
  }
});

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_dates__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['label', 'value', 'rules', 'clearable', 'required', 'disabled'],
  data: function data() {
    return {
      dates: __WEBPACK_IMPORTED_MODULE_0__utils_dates__["a" /* default */],
      data: '',
      dataFormatada: '',
      menuData: false
    };
  },
  watch: {
    value: function value(val) {
      if (!val) {
        this.data = '';
        this.dataFormatada = '';
      } else {
        this.data = val;
        this.dataFormatada = this.dates.format(val);
      }
    },
    dataFormatada: function dataFormatada(val) {
      if (val === null) {
        this.data = '';
        this.$emit('input', undefined);
      }
    }
  },
  methods: {
    setData: function setData() {
      this.$emit('input', this.data);
    }
  }
});

/***/ }),
/* 376 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-menu', {
    attrs: {
      "transition": "scroll-y-transition",
      "max-width": "290px",
      "offset-y": "",
      "close-on-content-click": false,
      "nudge-left": -40,
      "nudge-top": 25
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "label": _vm.label,
            "rules": _vm.rules,
            "clearable": _vm.clearable,
            "required": _vm.required,
            "readonly": "",
            "prepend-icon": "event",
            "disabled": _vm.disabled
          },
          model: {
            value: (_vm.dataFormatada),
            callback: function($$v) {
              _vm.dataFormatada = $$v
            },
            expression: "dataFormatada"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menuData),
      callback: function($$v) {
        _vm.menuData = $$v
      },
      expression: "menuData"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "pt-br",
      "scrollable": "",
      "autosave": ""
    },
    on: {
      "input": function($event) {
        return _vm.setData()
      }
    },
    model: {
      value: (_vm.data),
      callback: function($$v) {
        _vm.data = $$v
      },
      expression: "data"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 377 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Criar novo tipo de bolsa'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Código",
      "required": "",
      "rules": _vm.regrasBasicas,
      "max-height": "20"
    },
    model: {
      value: (_vm.bolsa.codigo),
      callback: function($$v) {
        _vm.$set(_vm.bolsa, "codigo", $$v)
      },
      expression: "bolsa.codigo"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm8": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Unidade",
      "items": _vm.listaPermissoesUnidades,
      "item-text": "nome",
      "item-value": "id",
      "max-height": "400",
      "required": "",
      "autocomplete": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.bolsa.unidade.id),
      callback: function($$v) {
        _vm.$set(_vm.bolsa.unidade, "id", $$v)
      },
      expression: "bolsa.unidade.id"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Descrição",
      "required": "",
      "rules": _vm.regrasBasicas,
      "max-height": "400"
    },
    model: {
      value: (_vm.bolsa.descricao),
      callback: function($$v) {
        _vm.$set(_vm.bolsa, "descricao", $$v)
      },
      expression: "bolsa.descricao"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Valor (R$)",
      "required": "",
      "rules": _vm.regrasBasicas,
      "max-height": "20"
    },
    model: {
      value: (_vm.bolsa.valor),
      callback: function($$v) {
        _vm.$set(_vm.bolsa, "valor", $$v)
      },
      expression: "bolsa.valor"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Número de bolsas disponibilizadas",
      "required": "",
      "rules": _vm.regrasBasicas,
      "max-height": "20"
    },
    model: {
      value: (_vm.bolsa.vagasOferecidas),
      callback: function($$v) {
        _vm.$set(_vm.bolsa, "vagasOferecidas", $$v)
      },
      expression: "bolsa.vagasOferecidas"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-date-menu', {
    attrs: {
      "label": "Data inicial de vigência da bolsa",
      "clearable": "",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.bolsa.dtInicio),
      callback: function($$v) {
        _vm.$set(_vm.bolsa, "dtInicio", $$v)
      },
      expression: "bolsa.dtInicio"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-date-menu', {
    attrs: {
      "label": "Data final de vigência da bolsa",
      "clearable": "",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.bolsa.dtFim),
      callback: function($$v) {
        _vm.$set(_vm.bolsa, "dtFim", $$v)
      },
      expression: "bolsa.dtFim"
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-file-input', {
    attrs: {
      "label": "Anexar arquivo comprobatório da concessão das bolsas (pdf)",
      "accept": ".pdf",
      "show-size": "",
      "outlined": "",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.arquivo),
      callback: function($$v) {
        _vm.arquivo = $$v
      },
      expression: "arquivo"
    }
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": _vm.criarBolsa
    }
  }, [_vm._v("Criar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(379)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(380),
  /* template */
  __webpack_require__(381),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 379 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_bolsas__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto'],
  data: function data() {
    return {
      projeto: {},
      listaBolsas: [],
      idBolsa: undefined,
      quantidadeBolsas: 1,
      formularioValido: false,
      regrasBasicas: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    confirmar: function confirmar() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Alocando bolsa.' });
      __WEBPACK_IMPORTED_MODULE_2__utils_bolsas__["a" /* default */].putAlocacao(this.idBolsa, this.idProjeto, this.quantidadeBolsas).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: 'Alocação feita com sucesso!' });
        _this.$router.push({ name: 'BolsasProjeto', params: { idProjeto: _this.idProjeto } });
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Alocando bolsa.' });
      });
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando bolsas.' });
    __WEBPACK_IMPORTED_MODULE_2__utils_bolsas__["a" /* default */].getBolsasGerenciadas().then(function (response) {
      _this2.listaBolsas = response.data.slice();
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando bolsas.' });
    });

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    __WEBPACK_IMPORTED_MODULE_3__utils_projetos__["a" /* default */].getProjeto(this.idProjeto).then(function (response) {
      _this2.projeto = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a
  }
});

/***/ }),
/* 381 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Alocar bolsa para projeto'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-container', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Projeto",
      "value": _vm.projeto.titulo,
      "readonly": "",
      "max-height": "400"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm9": "",
      "xs11": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Bolsa",
      "items": _vm.listaBolsas,
      "item-text": "descricao",
      "item-value": "idBolsa",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "required": "",
      "autocomplete": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.idBolsa),
      callback: function($$v) {
        _vm.idBolsa = $$v
      },
      expression: "idBolsa"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm2": "",
      "xs11": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Quantidade",
      "max-height": "400",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.quantidadeBolsas),
      callback: function($$v) {
        _vm.quantidadeBolsas = $$v
      },
      expression: "quantidadeBolsas"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": _vm.confirmar
    }
  }, [_vm._v("Alocar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(383),
  /* template */
  __webpack_require__(386),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_tooltip_btn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_tooltip_btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_tooltip_btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_date_menu__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_date_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_c_date_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bolsas__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto'],
  data: function data() {
    return {
      listaBolsas: [],
      bolsa: {},
      idBolsa: undefined,
      formularioValido: false,
      dates: __WEBPACK_IMPORTED_MODULE_5__utils_dates__["a" /* default */],
      pesquisaAvancada: false,
      pesquisa: {
        situacao: [18]
      },
      listaProjetos: [],
      regrasBasicas: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }],
      search: null,
      sortBy: 'dtCriacao',
      sortDesc: true,
      itemsPerPage: -1,
      opcoesPaginacao: [10, 25, 50, { text: 'Todas', value: -1 }],
      headers: [{ text: 'Número', align: 'center', value: 'idProjeto' }, { text: 'Título', align: 'center', value: 'titulo' }, { text: 'Classificação Primária', align: 'center', value: 'classificacaoPrimaria' }, { text: 'Classificação Secundária', align: 'center', value: 'classificacaoSecundaria' }, { text: 'Situação', align: 'center', value: 'situacao' }, { text: 'Coordenador', align: 'center', value: 'nomeCoordenador' }, { text: 'Opções', align: 'center', value: 'opcoes' }]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])('auth', ['logged', 'username', 'nome', 'administrador', 'usuarioPROEX', 'permissaoCriarProjetoExtensao'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    limpar: function limpar() {
      this.pesquisa = { tipoProjeto: 39725 };
    },
    pesquisar: function pesquisar() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ações de extensão.' });
      __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].getConsultaProjetos(this.pesquisa).then(function (response) {
        _this.listaProjetos = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this.listaProjetos = [];
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ações de extensão.' });
      });
    },
    adicionarBolsa: function adicionarBolsa(idProjeto) {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Alocando bolsa.' });
      __WEBPACK_IMPORTED_MODULE_7__utils_bolsas__["a" /* default */].putAlocacao(this.idBolsa, idProjeto, 1).then(function (response) {
        _this2.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: 'Alocação feita com sucesso!' });
      }).catch(function (error) {
        _this2.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Alocando bolsa.' });
      });
    },
    truncate: function truncate(string, limit) {
      if (string.length > limit) return string.substring(0, limit) + '...';else return string;
    },

    obterClassificacoes: function obterClassificacoes(itemTabela, aqui, atributo) {
      var _this3 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando classificação ' + atributo });
      __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].getClassificacoesPossiveis(itemTabela).then(function (response) {
        aqui[atributo] = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this3.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando classificação ' + atributo });
      });
    }
  }),
  mounted: function mounted() {
    var _this4 = this;

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando bolsas.' });
    __WEBPACK_IMPORTED_MODULE_7__utils_bolsas__["a" /* default */].getBolsasGerenciadas().then(function (response) {
      _this4.listaBolsas = response.data.slice();
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this4.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando bolsas.' });
    });

    // this.obterClassificacoes(90, this, 'listaTipo')
    this.obterClassificacoes(91, this, 'listaSubtipo');
    this.pesquisar();
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a,
    'c-tooltip-btn': __WEBPACK_IMPORTED_MODULE_3__components_c_tooltip_btn___default.a,
    'c-date-menu': __WEBPACK_IMPORTED_MODULE_4__components_c_date_menu___default.a
  }
});

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['icon', 'tooltip', 'disabled-tooltip', 'disabled', 'color'],
  data: function data() {
    return {
      focus: false,
      texto: ''
    };
  },
  computed: {
    couterRules: function couterRules(val) {
      var _this = this;

      var area = [function (input) {
        return _this.required === undefined || !!input || 'Este campo é obrigatório';
      }, function (input) {
        return input == null || input.length <= _this.counter || 'Este campo não pode possuir mais que ' + _this.counter + ' caracteres';
      }];
      return area;
    }
  },
  watch: {
    value: function value(val) {
      this.texto = val;
    }
  },
  methods: {
    setTexto: function setTexto() {
      console.log(!this.required);
      this.$emit('input', this.texto);
    },
    click: function click() {
      this.$emit('click');
    }
  }
});

/***/ }),
/* 385 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('div', _vm._g({
          staticStyle: {
            "float": "left"
          }
        }, on), [_c('v-btn', {
          attrs: {
            "color": _vm.color,
            "icon": "",
            "text": "",
            "disabled": _vm.disabled
          },
          on: {
            "click": function($event) {
              return _vm.click()
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "dark": ""
          }
        }, [_vm._v(_vm._s(_vm.icon))])], 1)], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [(_vm.disabled !== '' && !_vm.disabled) ? _c('div', [_vm._v(_vm._s(_vm.tooltip))]) : _c('div', [_vm._v(_vm._s(_vm.disabledTooltip))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 386 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": "Alocar bolsas"
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Bolsa",
      "items": _vm.listaBolsas,
      "item-text": "descricao",
      "item-value": "idBolsa",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "required": "",
      "autocomplete": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.idBolsa),
      callback: function($$v) {
        _vm.idBolsa = $$v
      },
      expression: "idBolsa"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm3": ""
    }
  }, [_c('c-date-menu', {
    attrs: {
      "label": "Data inicial de vigência da bolsa",
      "clearable": "",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.bolsa.dtInicio),
      callback: function($$v) {
        _vm.$set(_vm.bolsa, "dtInicio", $$v)
      },
      expression: "bolsa.dtInicio"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm3": ""
    }
  }, [_c('c-date-menu', {
    attrs: {
      "label": "Data final de vigência da bolsa",
      "clearable": "",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.bolsa.dtFim),
      callback: function($$v) {
        _vm.$set(_vm.bolsa, "dtFim", $$v)
      },
      expression: "bolsa.dtFim"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "filter_list",
      "label": "Filtrar resultados"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaProjetos,
      "search": _vm.search,
      "no-data-text": 'Nenhum projeto encontrado',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.titulo",
      fn: function(props) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'ProjetoFormulario',
              params: {
                idProjeto: props.item.idProjeto
              }
            }
          }
        }, [_vm._v(_vm._s(props.item.titulo))])]
      }
    }, {
      key: "item.opcoes",
      fn: function(props) {
        return [_c('c-tooltip-btn', {
          attrs: {
            "icon": "add_box",
            "color": "green",
            "disabled": !_vm.idBolsa || !_vm.bolsa.dtInicio || !_vm.bolsa.dtFim,
            "tooltip": "Adicionar uma bolsa a esta ação",
            "disabled-tooltip": "Selecione uma bolsa e informe as datas"
          },
          on: {
            "click": function($event) {
              return _vm.adicionarBolsa(props.item.idProjeto)
            }
          }
        })]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n              Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaProjetos.length) + " projetos\n            ")]
      }
    }])
  }), _vm._v(" "), _c('br')], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(388)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(389),
  /* template */
  __webpack_require__(393),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 388 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_month_menu__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_month_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_date_month_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto'],
  data: function data() {
    return {
      dates: __WEBPACK_IMPORTED_MODULE_4__utils_dates__["a" /* default */],
      formularioValido: false,
      pessoa: {},
      projeto: {},
      bolsista: {
        idBolsa: '',
        idPessoa: '',
        dataInicio: '',
        dataFim: ''
      },
      concordo: false,
      listaBolsas: [],
      listaIntegrantes: [],
      regrasBasicas: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    atribuirBolsa: function atribuirBolsa() {
      var _this = this;

      this.bolsista.idPessoa = this.pessoa.idPessoa;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Atribuindo bolsa.' });
      __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].postBolsista(this.idProjeto, this.bolsista).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.$router.push({ name: 'BolsasProjeto', params: { idProjeto: _this.idProjeto } });
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Atribuindo bolsa.' });
      });
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ação de extensão.' });
    __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getProjeto(this.idProjeto).then(function (response) {
      _this2.projeto = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ação de extensão.' });
    });

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando bolsas do projeto.' });
    __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getBolsasDoProjeto(this.idProjeto).then(function (response) {
      _this2.listaBolsas = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando bolsas do projeto.' });
    });

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando integrantes.' });
    __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getIntegrantesDoProjeto(this.idProjeto).then(function (response) {
      _this2.listaIntegrantes = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando integrantes.' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a,
    'c-date-month-menu': __WEBPACK_IMPORTED_MODULE_3__components_c_date_month_menu___default.a
  }
});

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(391),
  /* template */
  __webpack_require__(392),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_dates__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['label', 'value', 'rules', 'clearable', 'required', 'disabled'],
  data: function data() {
    return {
      dates: __WEBPACK_IMPORTED_MODULE_0__utils_dates__["a" /* default */],
      data: '',
      dataFormatada: '',
      menuData: false
    };
  },
  watch: {
    value: function value(val) {
      if (!val) {
        this.data = '';
        this.dataFormatada = '';
      } else {
        this.data = val;
        this.dataFormatada = this.dates.formatMonthYear(val); // MM/AAAA
      }
    },
    dataFormatada: function dataFormatada(val) {
      if (val === null) {
        this.data = '';
        this.$emit('input', undefined);
      }
    }
  },
  methods: {
    setData: function setData() {
      this.$emit('input', this.data);
    }
  }
});

/***/ }),
/* 392 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-menu', {
    attrs: {
      "transition": "scroll-y-transition",
      "max-width": "290px",
      "offset-y": "",
      "close-on-content-click": false,
      "nudge-left": -40,
      "nudge-top": 25
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "label": _vm.label,
            "rules": _vm.rules,
            "clearable": _vm.clearable,
            "required": _vm.required,
            "readonly": "",
            "prepend-icon": "event",
            "disabled": _vm.disabled
          },
          model: {
            value: (_vm.dataFormatada),
            callback: function($$v) {
              _vm.dataFormatada = $$v
            },
            expression: "dataFormatada"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menuData),
      callback: function($$v) {
        _vm.menuData = $$v
      },
      expression: "menuData"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "month",
      "locale": "pt-br",
      "scrollable": "",
      "autosave": ""
    },
    on: {
      "input": function($event) {
        return _vm.setData()
      }
    },
    model: {
      value: (_vm.data),
      callback: function($$v) {
        _vm.data = $$v
      },
      expression: "data"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 393 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Atribuir uma bolsa a um integrante'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Bolsa",
      "items": _vm.listaBolsas,
      "item-text": "descricao",
      "item-value": "idBolsa",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "required": "",
      "autocomplete": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.bolsista.idBolsa),
      callback: function($$v) {
        _vm.$set(_vm.bolsista, "idBolsa", $$v)
      },
      expression: "bolsista.idBolsa"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Integrante",
      "items": _vm.listaIntegrantes,
      "return-object": "",
      "item-text": "nome",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "required": "",
      "autocomplete": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.pessoa),
      callback: function($$v) {
        _vm.pessoa = $$v
      },
      expression: "pessoa"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-date-month-menu', {
    attrs: {
      "label": "Mês inicial",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.bolsista.dataInicio),
      callback: function($$v) {
        _vm.$set(_vm.bolsista, "dataInicio", $$v)
      },
      expression: "bolsista.dataInicio"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-date-month-menu', {
    attrs: {
      "label": "Mês final",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.bolsista.dataFim),
      callback: function($$v) {
        _vm.$set(_vm.bolsista, "dataFim", $$v)
      },
      expression: "bolsista.dataFim"
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.formularioValido) ? _c('div', {
    staticClass: "black--text text-justify text-h6"
  }, [_vm._v("\n\n              Eu, " + _vm._s(_vm.projeto.nomeCoordenador.toUpperCase()) + ", comprometo-me a orientar o bolsista " + _vm._s(_vm.pessoa.nome) + "  no desenvolvimento da ação de extensão\n              " + _vm._s(_vm.projeto.titulo.toUpperCase()) + " pelo período de " + _vm._s(this.dates.formatFirstDayMonth(_vm.bolsista.dataInicio)) + " a " + _vm._s(this.dates.formatLastDayMonth(_vm.bolsista.dataFim)) + ",\n              prestando as avaliações semestrais obrigatórias do bolsista e de acordo com as normas vigentes no edital.\n\n              "), _c('v-layout', {
    staticClass: "justify-center",
    attrs: {
      "row": "",
      "wrap": "",
      "center": ""
    }
  }, [_c('v-radio-group', {
    attrs: {
      "row": "",
      "center": ""
    },
    model: {
      value: (_vm.concordo),
      callback: function($$v) {
        _vm.concordo = $$v
      },
      expression: "concordo"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Concordo",
      "value": true
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Não concordo",
      "value": false
    }
  })], 1)], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido || !_vm.concordo
    },
    on: {
      "click": _vm.atribuirBolsa
    }
  }, [_vm._v("Atribuir")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(395),
  /* template */
  __webpack_require__(396),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_bolsas__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      dates: __WEBPACK_IMPORTED_MODULE_4__utils_dates__["a" /* default */],
      formularioValido: false,
      concordo: false,
      dadosBancarios: {},
      bolsista: {},
      regrasBasicas: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    criarBolsa: function criarBolsa() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Criando Bolsa.' });
      __WEBPACK_IMPORTED_MODULE_3__utils_bolsas__["a" /* default */].postBolsa(this.bolsa.unidade.id, this.bolsa).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.$router.push({ name: 'ListaBolsas' });
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Criando Bolsa.' });
      });
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando bolsista.' });
    __WEBPACK_IMPORTED_MODULE_3__utils_bolsas__["a" /* default */].getBolsista().then(function (response) {
      _this2.bolsista = response.data;
    }).catch(function (error) {
      _this2.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando bolsista.' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a
  }
});

/***/ }),
/* 396 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Cadastrar dados bancários'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome do banco",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.dadosBancarios.nomeBanco),
      callback: function($$v) {
        _vm.$set(_vm.dadosBancarios, "nomeBanco", $$v)
      },
      expression: "dadosBancarios.nomeBanco"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Número do banco",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.dadosBancarios.numeroBanco),
      callback: function($$v) {
        _vm.$set(_vm.dadosBancarios, "numeroBanco", $$v)
      },
      expression: "dadosBancarios.numeroBanco"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Agência",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.dadosBancarios.agencia),
      callback: function($$v) {
        _vm.$set(_vm.dadosBancarios, "agencia", $$v)
      },
      expression: "dadosBancarios.agencia"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Conta",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.dadosBancarios.conta),
      callback: function($$v) {
        _vm.$set(_vm.dadosBancarios, "conta", $$v)
      },
      expression: "dadosBancarios.conta"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Código de Operação",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.dadosBancarios.codigoOperacao),
      callback: function($$v) {
        _vm.$set(_vm.dadosBancarios, "codigoOperacao", $$v)
      },
      expression: "dadosBancarios.codigoOperacao"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-radio-group', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "label": "Tipo de conta:",
      "required": "",
      "rules": _vm.regrasBasicas,
      "row": ""
    },
    model: {
      value: (_vm.dadosBancarios.tipoConta),
      callback: function($$v) {
        _vm.$set(_vm.dadosBancarios, "tipoConta", $$v)
      },
      expression: "dadosBancarios.tipoConta"
    }
  }, [_c('v-radio', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "label": "Conta Corrente",
      "value": "C"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Poupança",
      "value": "P"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "black--text text-justify text-h6"
  }, [_vm._v("\n\n                  Eu, " + _vm._s(_vm.bolsista.nomePessoa.toUpperCase()) + ", comprometo-me a cumprir as atividades relacionadas à bolsa vinculada a ação de extensão " + _vm._s(_vm.bolsista.nomeProjeto.toUpperCase()) + " pelo\n                  período de " + _vm._s(this.dates.format(_vm.bolsista.dataInicio)) + " a " + _vm._s(this.dates.format(_vm.bolsista.dataFim)) + ", apresentando os relatórios semestrais de atividade obrigatórias\n                  do bolsista e de acordo com as normas vigentes no edital.\n\n                  "), _c('v-layout', {
    staticClass: "justify-center",
    attrs: {
      "row": "",
      "wrap": "",
      "center": ""
    }
  }, [_c('v-radio-group', {
    attrs: {
      "row": "",
      "center": ""
    },
    model: {
      value: (_vm.concordo),
      callback: function($$v) {
        _vm.concordo = $$v
      },
      expression: "concordo"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Concordo",
      "value": true
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Não concordo",
      "value": false
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido || !_vm.concordo
    },
    on: {
      "click": _vm.salvar
    }
  }, [_vm._v("Salvar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(398),
  /* template */
  __webpack_require__(401),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_selecionar_nota__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_selecionar_nota___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_selecionar_nota__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_bolsas__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      formularioValido: false,
      avaliacao: {
        relatorio: ''
      },
      regrasBasicas: [function (input) {
        return input !== undefined || 'Este campo é obrigatório';
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    criarBolsa: function criarBolsa() {
      console.log(this.avaliacao.nota);
    }
  }),
  mounted: function mounted() {
    var _this = this;

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando unidades.' });
    __WEBPACK_IMPORTED_MODULE_4__utils_bolsas__["a" /* default */].getPermissoesUnidades().then(function (response) {
      _this.listaPermissoesUnidades = response.data.slice();
    }).catch(function (error) {
      _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
    }).finally(function () {
      _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando unidades.' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a,
    'c-selecionar-nota': __WEBPACK_IMPORTED_MODULE_3__components_c_selecionar_nota___default.a
  }
});

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['label', 'value', 'rules', 'clearable', 'required', 'disabled'],
  data: function data() {
    return {
      nota: undefined
    };
  },
  watch: {
    value: function value(val) {
      this.nota = val;
    }
  },
  methods: {
    setData: function setData() {
      this.$emit('input', this.nota);
    }
  }
});

/***/ }),
/* 400 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "lg8": ""
    }
  }, [_c('div', {
    staticStyle: {
      "display": "overlay",
      "background-color": "white",
      "float": "left"
    }
  }, [_c('label', {
    staticClass: "black--text",
    staticStyle: {
      "margin-top": "0px",
      "margin-bottom": "5px"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.label) + "\n      ")]), _vm._v(" "), _c('v-radio-group', {
    staticStyle: {
      "margin-top": "0px",
      "margin-bottom": "0px"
    },
    attrs: {
      "disabled": _vm.disabled,
      "required": _vm.required,
      "rules": _vm.rules,
      "row": "",
      "dense": ""
    },
    on: {
      "change": _vm.setData
    },
    model: {
      value: (_vm.nota),
      callback: function($$v) {
        _vm.nota = $$v
      },
      expression: "nota"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "0",
      "value": 0
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "1",
      "value": 1
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "2",
      "value": 2
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "3",
      "value": 3
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "4",
      "value": 4
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "5",
      "value": 5
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "6",
      "value": 6
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "7",
      "value": 7
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "8",
      "value": 8
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "9",
      "value": 9
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "10",
      "value": 10
    }
  })], 1), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-top": "-5px",
      "margin-bottom": "0px"
    }
  }), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-top": "0px",
      "margin-bottom": "50px"
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 401 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": "Avalicação do bolsista pelo coordenador"
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "lg8": ""
    }
  }, [_c('c-selecionar-nota', {
    attrs: {
      "label": "Inteiração do aluno com o Plano de Trabalho a ser cumprir",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Atuação do bolsista na execução do Plano de Trabalho estabelecido",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Assiduidade",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Iniciativa",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Responsabilidade",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Capacidade de Interação com o público-atingido ",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Participação nas atividades do programa/projeto vinculado",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Integração com a equipe",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Capacidade de organização e gerenciamento de rotina",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Participação em eventos",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Desenvolver-se do ponto de vista pessoal",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Desenvolver-se do ponto de vista acadêmico.",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Adquirir novos conhecimentos",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Confrontar a formação acadêmica com a prática",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Vivenciar ações que integram ensino, pesquisa e extensão",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Vivenciar práticas político-sociais",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Perceber a inserção social de sua profissão",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Ajudar a solucionar problemas identificados",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Avaliar criticamente seu processo de formação",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Desenvolver ações multidisciplinares/interdisciplinaresInfluir na inserção de outros alunos no programa/projeto vinculado",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Influir na inserção de outros alunos no programa/projeto vinculado",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Ser autor ou co-autor de publicação ou outro produto acadêmico",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Conhecer o Plano Nacional de Extensão",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Conhecer a política de extensão da Universidade",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Adquirir capacidade de organização e gerenciamento de rotina",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Vivenciar a dinâmica de ações interinstitucionais",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('v-layout', [_c('label', {
    staticClass: "black--text",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n                    Relatório parcial de atividades desempenhada pelo bolsista no período (descrição sucinta).\n                  ")])]), _vm._v(" "), _c('v-layout', [_c('v-textarea', {
    attrs: {
      "rows": 5,
      "multi-line": "",
      "counter": "500",
      "rules": _vm.couterRules,
      "required": "",
      "outlined": ""
    },
    model: {
      value: (_vm.avaliacao.relatorio),
      callback: function($$v) {
        _vm.$set(_vm.avaliacao, "relatorio", $$v)
      },
      expression: "avaliacao.relatorio"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": _vm.criarBolsa
    }
  }, [_vm._v("Salvar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(403),
  /* template */
  __webpack_require__(404),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_selecionar_nota__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_selecionar_nota___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_selecionar_nota__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_bolsas__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_c_date_menu__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_c_date_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_c_date_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      formularioValido: false,
      avaliacao: {
        relatorio: ''
      },
      regrasBasicas: [function (input) {
        return input !== undefined || 'Este campo é obrigatório';
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    criarBolsa: function criarBolsa() {
      console.log(this.avaliacao.nota);
    }
  }),
  mounted: function mounted() {
    var _this = this;

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando unidades.' });
    __WEBPACK_IMPORTED_MODULE_4__utils_bolsas__["a" /* default */].getPermissoesUnidades().then(function (response) {
      _this.listaPermissoesUnidades = response.data.slice();
    }).catch(function (error) {
      _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
    }).finally(function () {
      _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando unidades.' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a,
    'c-selecionar-nota': __WEBPACK_IMPORTED_MODULE_3__components_c_selecionar_nota___default.a,
    'c-date-menu': __WEBPACK_IMPORTED_MODULE_5__components_c_date_menu___default.a
  }
});

/***/ }),
/* 404 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": "Avalicação de participação e relatório de atividades na ação pelo bolsista"
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "lg8": ""
    }
  }, [_c('br'), _c('br'), _vm._v("\n\n                Atendendo à Instrução Normativa No 01/2017-PROEX, ao final do seu período de atuação como\n                bolsista, o aluno deverá proceder à sua “AVALIAÇÃO DE PARTICIPAÇÃO E RELATÓRIO DE ATIVI-\n                DADES” na ação de extensão “NOME DA AÇÃO DE EXTENSAO”, referente ao período de XX/XX/XXXX\n                a XX/XX/XXXX, respondendo o seguinte questionário a seguir.\n                Obs.: Caso a atuação do bolsista seja finalizada antes do prazo previsto inicialmente, ele deverá realizar a\n                avaliação da mesma forma, mesmo que por um mês de atividade.\n\n                "), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome da ação de extensão",
      "required": "",
      "rules": _vm.regrasBasicas,
      "max-height": "400"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm8": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome do aluno",
      "required": "",
      "rules": _vm.regrasBasicas,
      "max-height": "400"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Matrícula",
      "required": "",
      "rules": _vm.regrasBasicas,
      "max-height": "20"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm8": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome do orientador",
      "required": "",
      "rules": _vm.regrasBasicas,
      "max-height": "400"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Tipo de bolsa",
      "required": "",
      "rules": _vm.regrasBasicas,
      "max-height": "20"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm4": ""
    }
  }, [_c('c-date-menu', {
    attrs: {
      "label": "Data inicial de atuação",
      "clearable": "",
      "required": "",
      "rules": _vm.regrasBasicas
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm4": ""
    }
  }, [_c('c-date-menu', {
    attrs: {
      "label": "Data final de atuação",
      "clearable": "",
      "required": "",
      "rules": _vm.regrasBasicas
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Carga horária",
      "type": "number",
      "required": "",
      "rules": _vm.chRules
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Desenvolvimento do ponto de vista pessoal e acadêmico",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Interação da formação acadêmica com a prática",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Vivência prática da integração ensino, pesquisa e extensão",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Contribuição com a melhoria da sociedade",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Desenvolvimento de senso de cidadania",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Desenvolvimento da autonomia",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Orientação recebida da coordenação",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('c-selecionar-nota', {
    attrs: {
      "label": "Pontuação média obtida (ou avaliação qualitativa geral atribuída)",
      "rules": _vm.regrasBasicas
    }
  }), _vm._v(" "), _c('v-layout', [_c('label', {
    staticClass: "black--text",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n                    Relatório de atividades desenvolvidas pelo bolsista na ação (descrição sucinta).\n                  ")])]), _vm._v(" "), _c('v-layout', [_c('v-textarea', {
    attrs: {
      "rows": 5,
      "multi-line": "",
      "counter": "500",
      "rules": _vm.couterRules,
      "required": "",
      "outlined": ""
    },
    model: {
      value: (_vm.avaliacao.relatorio),
      callback: function($$v) {
        _vm.$set(_vm.avaliacao, "relatorio", $$v)
      },
      expression: "avaliacao.relatorio"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": _vm.criarBolsa
    }
  }, [_vm._v("Salvar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(406)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(407),
  /* template */
  __webpack_require__(408),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 406 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_unidade__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto'],
  data: function data() {
    return {
      formularioValido: false,
      dates: __WEBPACK_IMPORTED_MODULE_4__utils_dates__["a" /* default */],
      unidade: __WEBPACK_IMPORTED_MODULE_5__utils_unidade__["a" /* default */],
      pesquisaAvancada: false,
      listaSituacao: [],
      listaSituacao2: [{ 'item': 18, 'descricao': 'Ativo' }, { 'item': 4, 'descricao': 'Suspenso' },
      // { 'item': 20, 'descricao': 'Aguardando envio de relatório' },
      // { 'item': 22, 'descricao': 'Relatório aguardando aprovação' },
      { 'item': 19, 'descricao': 'Concluído' }],
      listaTipoPublico: [],
      listaUnidades: [],
      listaTipo: [{
        'id': 39725,
        'classificacaoItem': 90,
        'tipoClassificacao': 'Classificação Primária',
        'descricao': 'Extensão'
      }],
      listaSubtipo: [{
        'id': 39730,
        'classificacaoItem': 91,
        'tipoClassificacao': 'Classificação Secundária',
        'descricao': 'Evento de Extensão'
      }, {
        'id': 39731,
        'classificacaoItem': 91,
        'tipoClassificacao': 'Classificação Secundária',
        'descricao': 'Prestação de Serviço'
      }, {
        'id': 39733,
        'classificacaoItem': 91,
        'tipoClassificacao': 'Classificação Secundária',
        'descricao': 'Programa de Extensão'
      }, {
        'id': 39734,
        'classificacaoItem': 91,
        'tipoClassificacao': 'Classificação Secundária',
        'descricao': 'Projeto de Extensão'
      }, {
        'id': 44194,
        'classificacaoItem': 91,
        'tipoClassificacao': 'Classificação Secundária',
        'descricao': 'Curso de Extensão'
      }, {
        'id': 44195,
        'classificacaoItem': 91,
        'tipoClassificacao': 'Classificação Secundária',
        'descricao': 'Oficina de Extensão'
      }, {
        'id': 39729,
        'classificacaoItem': 91,
        'tipoClassificacao': 'Classificação Secundária',
        'descricao': 'Curso/Oficina (antigo)'
      }],
      listaFuncaoParticipante: [],
      listaAreaTematica: [],
      listaAreaTematicaAfim: [],
      listaODS: [],
      listaODSAfim: [],
      listaLinhaExtensao: [],
      listaGrandeArea: [],
      pesquisa: {
        numero: null,
        titulo: '',
        membroEquipe: '',
        funcaoParticipante: null,
        situacao: null,
        palavraChave: '',
        tipoProjeto: 39725,
        subtipoProjeto: null,
        principalAreaTematicaExtensao: null,
        areaTematicaExtensaoAfim: null,
        linhaExtensao: null,
        grandeAreaConhecimento: null,
        periodoInicio: '',
        periodoTermino: '',
        observacoes: '',
        tipoPublico: null,
        hierarquica: true
      },
      listaProjetos: [],
      regrasBasicas: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }],
      search: null,
      sortBy: 'dtCriacao',
      sortDesc: true,
      itemsPerPage: 25,
      simples: false,
      opcoesPaginacao: [10, 25, 50, { text: 'Todas', value: -1 }],
      headers: [{ text: 'Número', align: 'center', value: 'idProjeto' }, { text: 'Título', align: 'center', value: 'titulo' }, { text: 'Unidade', align: 'center', value: 'nomeUnidade' }, { text: 'Classificação Secundária', align: 'center', value: 'classificacaoSecundaria' }, { text: 'Início', align: 'center', value: 'dataInicio' }, { text: 'Término', align: 'center', value: 'dataConclusao' }, { text: 'Situação', align: 'center', value: 'situacao' }, { text: 'Coordenador', align: 'center', value: 'nomeCoordenador' }]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])('auth', ['logged', 'username', 'nome', 'administrador', 'usuarioPROEX', 'permissaoCriarProjetoExtensao'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    limpar: function limpar() {
      this.pesquisa = { tipoProjeto: 39725 };
    },
    pesquisar: function pesquisar() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ações.' });
      this.pesquisa.hierarquica = !this.simples;
      __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].getConsultaProjetos(this.pesquisa).then(function (response) {
        _this.listaProjetos = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
        _this.listaProjetos = [];
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ações.' });
      });
    },
    truncate: function truncate(string, limit) {
      if (string.length > limit) return string.substring(0, limit) + '...';else return string;
    },

    carregarUnidades: function carregarUnidades() {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando unidades.' });
      __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].getUnidadesExtensao().then(function (response) {
        _this2.listaUnidades = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this2.listaUnidades = [];
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando unidades.' });
      });
    },
    opcoesTabelaEstruturada: function opcoesTabelaEstruturada(codTabela, aqui, atributo) {
      var _this3 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' });
      __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].getOpcoesTabelaEstruturada(codTabela).then(function (response) {
        aqui[atributo] = response.data.slice();

        if (atributo === 'listaSituacao') {
          // exclui Aguardando envio de relatório (20), Relatório aguardando aprovação (22)
          aqui[atributo] = aqui[atributo].filter(function (item) {
            return item.item !== 20 && item.item !== 22;
          });
        }
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this3.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' });
      });
    },
    obterClassificacoes: function obterClassificacoes(itemTabela, aqui, atributo) {
      var _this4 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando classificação ' + atributo });
      __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].getClassificacoesPossiveis(itemTabela).then(function (response) {
        aqui[atributo] = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this4.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando classificação ' + atributo });
      });
    },
    carregarCampos: function carregarCampos() {
      this.opcoesTabelaEstruturada(6002, this, 'listaTipoPublico');
      this.carregarUnidades();
      this.obterClassificacoes(100, this, 'listaAreaTematica');
      this.obterClassificacoes(110, this, 'listaAreaTematicaAfim');
      this.obterClassificacoes(111, this, 'listaLinhaExtensao');
      this.obterClassificacoes(112, this, 'listaGrandeArea');
      this.obterClassificacoes(103, this, 'listaODS');
      this.obterClassificacoes(104, this, 'listaODSAfim');
    },
    abrirPesquisaAvancada: function abrirPesquisaAvancada() {
      this.carregarCampos();
      this.pesquisaAvancada = true;
    },
    fecharPesquisaAvancada: function fecharPesquisaAvancada() {
      this.pesquisaAvancada = false;
    }
  }),
  mounted: function mounted() {
    // this.obterClassificacoes(90, this, 'listaTipo')
    // this.obterClassificacoes(91, this, 'listaSubtipo')
    this.opcoesTabelaEstruturada(6011, this, 'listaSituacao');
    this.opcoesTabelaEstruturada(6003, this, 'listaFuncaoParticipante');
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a,
    'c-date-menu': __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default.a
  }
});

/***/ }),
/* 408 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Pesquisar Projetos'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', {
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.pesquisar()
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Número",
      "max-height": "400",
      "clearable": ""
    },
    model: {
      value: (_vm.pesquisa.numero),
      callback: function($$v) {
        _vm.$set(_vm.pesquisa, "numero", $$v)
      },
      expression: "pesquisa.numero"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm9": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Título",
      "max-height": "400",
      "clearable": ""
    },
    model: {
      value: (_vm.pesquisa.titulo),
      callback: function($$v) {
        _vm.$set(_vm.pesquisa, "titulo", $$v)
      },
      expression: "pesquisa.titulo"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Classificação Primária",
      "items": _vm.listaTipo,
      "item-text": "descricao",
      "item-value": "id",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "readonly": "",
      "autocomplete": ""
    },
    model: {
      value: (_vm.pesquisa.tipoProjeto),
      callback: function($$v) {
        _vm.$set(_vm.pesquisa, "tipoProjeto", $$v)
      },
      expression: "pesquisa.tipoProjeto"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Classificação Secundária",
      "items": _vm.listaSubtipo,
      "item-text": "descricao",
      "item-value": "id",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "clearable": "",
      "autocomplete": "",
      "chips": "",
      "multiple": ""
    },
    model: {
      value: (_vm.pesquisa.subtipoProjeto),
      callback: function($$v) {
        _vm.$set(_vm.pesquisa, "subtipoProjeto", $$v)
      },
      expression: "pesquisa.subtipoProjeto"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Palavra-chave",
      "max-height": "400",
      "clearable": ""
    },
    model: {
      value: (_vm.pesquisa.palavraChave),
      callback: function($$v) {
        _vm.$set(_vm.pesquisa, "palavraChave", $$v)
      },
      expression: "pesquisa.palavraChave"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Membro da equipe",
      "max-height": "400",
      "clearable": ""
    },
    model: {
      value: (_vm.pesquisa.membroEquipe),
      callback: function($$v) {
        _vm.$set(_vm.pesquisa, "membroEquipe", $$v)
      },
      expression: "pesquisa.membroEquipe"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [(_vm.administrador === true || _vm.usuarioPROEX === true) ? _c('v-select', {
    attrs: {
      "label": "Situação",
      "items": _vm.listaSituacao,
      "item-text": "descricao",
      "item-value": "item",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "chips": "",
      "multiple": ""
    },
    model: {
      value: (_vm.pesquisa.situacao),
      callback: function($$v) {
        _vm.$set(_vm.pesquisa, "situacao", $$v)
      },
      expression: "pesquisa.situacao"
    }
  }) : _c('v-select', {
    attrs: {
      "label": "Situação",
      "items": _vm.listaSituacao2,
      "item-text": "descricao",
      "item-value": "item",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "chips": "",
      "multiple": ""
    },
    model: {
      value: (_vm.pesquisa.situacao),
      callback: function($$v) {
        _vm.$set(_vm.pesquisa, "situacao", $$v)
      },
      expression: "pesquisa.situacao"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Função do membro da equipe",
      "items": _vm.listaFuncaoParticipante,
      "item-text": "descricao",
      "item-value": "item",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "clearable": "",
      "autocomplete": "",
      "chips": "",
      "multiple": ""
    },
    model: {
      value: (_vm.pesquisa.funcaoParticipante),
      callback: function($$v) {
        _vm.$set(_vm.pesquisa, "funcaoParticipante", $$v)
      },
      expression: "pesquisa.funcaoParticipante"
    }
  })], 1)], 1), _vm._v(" "), (_vm.pesquisaAvancada) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Pesquisa ampliada",
      "max-height": "400",
      "hint": "A pesquisa é realizada nos campos Título, Palavras-chave, Resumo, Apresentação, Justificativa, Caracterização do público-alvo, Objetivo geral, Objetivos específicos, Metodologia, Forma de avaliação, Infraestrutura física e Informações adicionais.",
      "persistent-hint": "",
      "clearable": ""
    },
    model: {
      value: (_vm.pesquisa.multiplosCampos),
      callback: function($$v) {
        _vm.$set(_vm.pesquisa, "multiplosCampos", $$v)
      },
      expression: "pesquisa.multiplosCampos"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  }), _vm._v(" "), (_vm.pesquisaAvancada) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Unidade",
      "items": _vm.listaUnidades,
      "eager": "",
      "item-text": "nomeSigla",
      "item-value": "id",
      "prepend-icon": "account_balance",
      "max-height": "400",
      "clearable": "",
      "autocomplete": "",
      "chips": "",
      "multiple": ""
    },
    model: {
      value: (_vm.pesquisa.unidade),
      callback: function($$v) {
        _vm.$set(_vm.pesquisa, "unidade", $$v)
      },
      expression: "pesquisa.unidade"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Tipo de público-alvo",
      "items": _vm.listaTipoPublico,
      "eager": "",
      "item-text": "descricao",
      "item-value": "item",
      "prepend-icon": "people",
      "max-height": "400",
      "clearable": "",
      "autocomplete": "",
      "chips": "",
      "multiple": ""
    },
    model: {
      value: (_vm.pesquisa.tipoPublico),
      callback: function($$v) {
        _vm.$set(_vm.pesquisa, "tipoPublico", $$v)
      },
      expression: "pesquisa.tipoPublico"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.pesquisaAvancada && _vm.pesquisa.unidade) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Consulta simples por unidade  ")]), _vm._v(" "), _c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;
              var attrs = ref.attrs;

              return [_c('v-icon', _vm._g(_vm._b({}, 'v-icon', attrs, false), on), [_vm._v("info")])]
            }
          }], null, false, 3628108049)
        }, [_vm._v(" "), _c('span', [_vm._v("Na consulta simples, são retornadas apenas as ações de extensão que estão imediatamente vinculadas à unidade selecionada.")])])]
      },
      proxy: true
    }], null, false, 1596774693),
    model: {
      value: (_vm.simples),
      callback: function($$v) {
        _vm.simples = $$v
      },
      expression: "simples"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.pesquisaAvancada) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Principal Área Temática de Extensão",
      "items": _vm.listaAreaTematica,
      "eager": "",
      "item-text": "descricao",
      "item-value": "id",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "clearable": "",
      "autocomplete": "",
      "chips": "",
      "multiple": ""
    },
    model: {
      value: (_vm.pesquisa.principalAreaTematicaExtensao),
      callback: function($$v) {
        _vm.$set(_vm.pesquisa, "principalAreaTematicaExtensao", $$v)
      },
      expression: "pesquisa.principalAreaTematicaExtensao"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Área Temática de Extensão Afim",
      "items": _vm.listaAreaTematicaAfim.slice(1),
      "eager": "",
      "item-text": "descricao",
      "item-value": "id",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "clearable": "",
      "autocomplete": "",
      "chips": "",
      "multiple": ""
    },
    model: {
      value: (_vm.pesquisa.areaTematicaExtensaoAfim),
      callback: function($$v) {
        _vm.$set(_vm.pesquisa, "areaTematicaExtensaoAfim", $$v)
      },
      expression: "pesquisa.areaTematicaExtensaoAfim"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.pesquisaAvancada) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Linha de Extensão",
      "items": _vm.listaLinhaExtensao,
      "eager": "",
      "item-text": "descricao",
      "item-value": "id",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "clearable": "",
      "autocomplete": "",
      "chips": "",
      "multiple": ""
    },
    model: {
      value: (_vm.pesquisa.linhaExtensao),
      callback: function($$v) {
        _vm.$set(_vm.pesquisa, "linhaExtensao", $$v)
      },
      expression: "pesquisa.linhaExtensao"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Grande Área do Conhecimento",
      "items": _vm.listaGrandeArea,
      "eager": "",
      "item-text": "descricao",
      "item-value": "id",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "clearable": "",
      "autocomplete": "",
      "chips": "",
      "multiple": ""
    },
    model: {
      value: (_vm.pesquisa.grandeAreaConhecimento),
      callback: function($$v) {
        _vm.$set(_vm.pesquisa, "grandeAreaConhecimento", $$v)
      },
      expression: "pesquisa.grandeAreaConhecimento"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.pesquisaAvancada) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', [_c('v-select', {
    attrs: {
      "label": "Principal Objetivo de Desenvolvimento Sustentável",
      "items": _vm.listaODS.slice(0, 17),
      "eager": "",
      "item-text": "descricao",
      "item-value": "id",
      "prepend-icon": "dashboard",
      "clearable": "",
      "autocomplete": "",
      "chips": "",
      "multiple": ""
    },
    model: {
      value: (_vm.pesquisa.principalObjetivoDesenvolvimentoSustentavel),
      callback: function($$v) {
        _vm.$set(_vm.pesquisa, "principalObjetivoDesenvolvimentoSustentavel", $$v)
      },
      expression: "pesquisa.principalObjetivoDesenvolvimentoSustentavel"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.pesquisaAvancada) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', [_c('v-select', {
    attrs: {
      "label": "Objetivo de Desenvolvimento Sustentável Afim",
      "items": _vm.listaODSAfim.slice(0, 17),
      "eager": "",
      "item-text": "descricao",
      "item-value": "id",
      "prepend-icon": "dashboard",
      "clearable": "",
      "autocomplete": "",
      "chips": "",
      "multiple": ""
    },
    model: {
      value: (_vm.pesquisa.objetivoDesenvolvimentoSustentavelAfim),
      callback: function($$v) {
        _vm.$set(_vm.pesquisa, "objetivoDesenvolvimentoSustentavelAfim", $$v)
      },
      expression: "pesquisa.objetivoDesenvolvimentoSustentavelAfim"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.pesquisaAvancada) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-date-menu', {
    attrs: {
      "label": "Período - Início",
      "clearable": ""
    },
    model: {
      value: (_vm.pesquisa.periodoInicio),
      callback: function($$v) {
        _vm.$set(_vm.pesquisa, "periodoInicio", $$v)
      },
      expression: "pesquisa.periodoInicio"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-date-menu', {
    attrs: {
      "label": "Período - Término",
      "clearable": ""
    },
    model: {
      value: (_vm.pesquisa.periodoTermino),
      callback: function($$v) {
        _vm.$set(_vm.pesquisa, "periodoTermino", $$v)
      },
      expression: "pesquisa.periodoTermino"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": ""
    }
  }, [(!_vm.pesquisaAvancada) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.abrirPesquisaAvancada
    }
  }, [_vm._v("Pesquisa avançada")]) : _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.fecharPesquisaAvancada
    }
  }, [_vm._v("Pesquisa simples")])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "padding-top": "15px"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-btn', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.limpar
    }
  }, [_vm._v("Limpar")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.pesquisar
    }
  }, [_vm._v("Pesquisar")])], 1)])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Resultados da Pesquisa'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaProjetos,
      "search": _vm.search,
      "no-data-text": 'Nenhum projeto encontrado',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.titulo",
      fn: function(props) {
        return [_c('router-link', {
          attrs: {
            "target": "_blank",
            "to": {
              name: 'ProjetoFormulario',
              params: {
                idProjeto: props.item.idProjeto
              }
            }
          }
        }, [_vm._v(_vm._s(props.item.titulo))])]
      }
    }, {
      key: "item.nomeUnidade",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.unidade.format(props.item.nomeUnidade, props.item.siglaUnidade)))]
      }
    }, {
      key: "item.dataInicio",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dataInicio)))]
      }
    }, {
      key: "item.dataConclusao",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dataConclusao)))]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n              Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaProjetos.length) + " projetos\n            ")]
      }
    }])
  }), _vm._v(" "), _c('br')], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(410)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(411),
  /* template */
  __webpack_require__(412),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 410 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_unidade__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      listaMeusProjetos: [],
      dates: __WEBPACK_IMPORTED_MODULE_3__utils_dates__["a" /* default */],
      participacoesAtivas: false,
      unidade: __WEBPACK_IMPORTED_MODULE_4__utils_unidade__["a" /* default */],
      search: null,
      sortBy: 'dtCriacao',
      sortDesc: true,
      itemsPerPage: 25,
      opcoesPaginacao: [10, 25, 50, { text: 'Todas', value: -1 }],
      headers: [{ text: 'Número', align: 'center', value: 'idProjeto' }, { text: 'Título', align: 'center', value: 'titulo' }, { text: 'Unidade', align: 'center', value: 'nomeUnidade' }, { text: 'Classificação Secundária', align: 'center', value: 'classificacaoSecundaria' }, { text: 'Início', align: 'center', value: 'dataInicio' }, { text: 'Término', align: 'center', value: 'dataConclusao' }, { text: 'Situação', align: 'center', value: 'situacao' }, { text: 'Coordenador', align: 'center', value: 'nomeCoordenador' }]
    };
  },
  props: ['items'],
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING']), {
    // Controla a exibição das ações de extensão do usuário.
    controlaParticipacoesAtivas: function controlaParticipacoesAtivas() {
      if (this.participacoesAtivas) {
        this.carregaParticipacoesAtivas();
      } else {
        this.carregaParticipacoes();
      }
    },
    truncate: function truncate(string, limit) {
      if (string.length > limit) return string.substring(0, limit) + '...';else return string;
    },

    importarProjeto: function importarProjeto() {
      this.$router.push({ name: 'ImportarProjeto' });
    },
    duplicarProjeto: function duplicarProjeto() {
      this.$router.push({ name: 'DuplicarProjeto' });
    },
    carregaParticipacoes: function carregaParticipacoes() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projetos.' });
      __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getMeusProjetos().then(function (response) {
        _this.listaMeusProjetos = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projetos.' });
      });
    },
    carregaParticipacoesAtivas: function carregaParticipacoesAtivas() {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projetos.' });
      __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getMeusProjetosAtivos().then(function (response) {
        _this2.listaMeusProjetos = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projetos.' });
      });
    }
  }),
  mounted: function mounted() {
    this.carregaParticipacoes();
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a
  }
});

/***/ }),
/* 412 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('basic-toolbar', {
    attrs: {
      "title": 'Meus Projetos'
    }
  }), _vm._v(" "), _c('v-card-title', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.importarProjeto
    }
  }, [_vm._v("Importar do SIEX")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "5px"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.duplicarProjeto
    }
  }, [_vm._v("Duplicar Ação")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "30px"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Mostrar apenas participações ativas"
    },
    on: {
      "change": _vm.controlaParticipacoesAtivas
    },
    model: {
      value: (_vm.participacoesAtivas),
      callback: function($$v) {
        _vm.participacoesAtivas = $$v
      },
      expression: "participacoesAtivas"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "filter_list",
      "label": "Filtrar resultados"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaMeusProjetos,
      "search": _vm.search,
      "no-data-text": 'Você não participa de nenhum projeto',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.titulo",
      fn: function(props) {
        return [_c('router-link', {
          attrs: {
            "target": "_blank",
            "to": {
              name: 'ProjetoFormulario',
              params: {
                idProjeto: props.item.idProjeto
              }
            }
          }
        }, [_vm._v(_vm._s(props.item.titulo))])]
      }
    }, {
      key: "item.nomeUnidade",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.unidade.format(props.item.nomeUnidade, props.item.siglaUnidade)))]
      }
    }, {
      key: "item.dataInicio",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dataInicio)))]
      }
    }, {
      key: "item.dataConclusao",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dataConclusao)))]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n            Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaMeusProjetos.length) + " projetos\n          ")]
      }
    }])
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(414)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(415),
  /* template */
  __webpack_require__(421),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5ae8fa64",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 414 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_barra_administrador__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_barra_administrador___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_c_barra_administrador__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto'],
  data: function data() {
    return {
      projeto: {},
      extensao: {},
      acaoExtensao: {},
      contatos: {},
      curso: null
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])('auth', ['logged', 'username', 'nome', 'administrador', 'usuarioPROEX', 'permissaoCriarProjetoExtensao']), {
    habilitaBolsas: function habilitaBolsas() {
      if (!this.administrador) {
        return 'router_disable';
      } else {
        return '';
      }
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING']), {
    carregaAcaoExtensao: function carregaAcaoExtensao(registro) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_4__utils_projetos__["a" /* default */].getAcaoExtensao(registro).then(function (response) {
        var listaAcaoExtensao = response.data.slice();
        _this.acaoExtensao = listaAcaoExtensao[0];
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {});
    },
    // Verifica se a ação de extensão é um curso/oficina (antigo).
    acaoCursoOficina: function acaoCursoOficina() {
      if (this.projeto.classificacaoSecundaria.id === 39729) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se a ação de extensão é um curso.
    acaoCurso: function acaoCurso() {
      if (this.projeto.classificacaoSecundaria.id === 44194) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se a ação de extensão é uma oficina.
    acaoOficina: function acaoOficina() {
      if (this.projeto.classificacaoSecundaria.id === 44195) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se a ação de extensão é um evento.
    acaoEvento: function acaoEvento() {
      if (this.projeto.classificacaoSecundaria.id === 39730) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se o tipo de ação de extensão está habilitado a ter a aba Relatórios.
    tipoAcaoExtensaoHabilitado: function tipoAcaoExtensaoHabilitado() {
      if (this.acaoCursoOficina() || this.acaoCurso() || this.acaoOficina() || this.acaoEvento()) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se a ação de extensão está na situação "Ativo".
    situacaoAtivo: function situacaoAtivo() {
      if (this.projeto.situacao.item === 18) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se a ação de extensão está na situação "Inadimplente".
    situacaoInadimplente: function situacaoInadimplente() {
      if (this.projeto.situacao.item === 3) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se a ação de extensão está na situação "Aguardando relatório".
    situacaoAguardandoRelatorio: function situacaoAguardandoRelatorio() {
      if (this.projeto.situacao.item === 20) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se a ação de extensão está na situação "Relatório aguardando aprovação".
    situacaoRelatorioAguardandoAprovacao: function situacaoRelatorioAguardandoAprovacao() {
      if (this.projeto.situacao.item === 22) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se a ação de extensão está na situação "Concluído".
    situacaoConcluido: function situacaoConcluido() {
      if (this.projeto.situacao.item === 19) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se a ação de extensão está na situação "Cancelado".
    situacaoCancelado: function situacaoCancelado() {
      if (this.projeto.situacao.item === 5) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se a situação da ação de extensão está habilitada a ter a aba Relatórios.
    situacaoAcaoExtensaoHabilitado: function situacaoAcaoExtensaoHabilitado() {
      if (this.situacaoAtivo() || this.situacaoAguardandoRelatorio() || this.situacaoRelatorioAguardandoAprovacao() || this.situacaoConcluido() || this.situacaoCancelado() || this.situacaoInadimplente()) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se o usuário logado é administrador.
    usuarioAdministrador: function usuarioAdministrador() {
      if (this.administrador === true) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se o usuário logado é o coordenador da ação de extensão.
    usuarioCoordenador: function usuarioCoordenador() {
      if (this.projeto.funcao != null && this.projeto.funcao.item === 1) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se o usuário logado é assessor da ação de extensão.
    usuarioAssessor: function usuarioAssessor() {
      if (this.projeto.assessor === true) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se o usuário logado é usuário Proex.
    usuarioProex: function usuarioProex() {
      if (this.usuarioPROEX === true) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se o usuário logado está habilitado para a aba Relatórios.
    usuarioHabilitado: function usuarioHabilitado() {
      if (this.usuarioAdministrador() || this.usuarioCoordenador() || this.usuarioAssessor() || this.usuarioProex()) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se o preenchimento do relatório final está habilitado para ações de extensão com registro tardio.
    relatorioHabilitadoAcaoRegistroTardio: function relatorioHabilitadoAcaoRegistroTardio() {
      if (this.projeto.relatorioFinalHabilitado === true) {
        return true;
      } else {
        return false;
      }
    },
    habilitaRelatorio: function habilitaRelatorio() {
      if (this.tipoAcaoExtensaoHabilitado() && this.situacaoAcaoExtensaoHabilitado() || this.relatorioHabilitadoAcaoRegistroTardio()) {
        return true;
      } else {
        return false;
      }
    },
    verificaSeAbaDeveSerDesabilitadaDevidoAcaoNaoTerAlunos: function verificaSeAbaDeveSerDesabilitadaDevidoAcaoNaoTerAlunos() {
      if (this.situacaoAtivo() || this.situacaoAguardandoRelatorio()) {
        if (this.usuarioCoordenador() || this.usuarioAssessor()) {
          if (this.projeto.possuiAlunos === false && this.projeto.idProjeto !== 1278) {
            // Tarefa #13468.
            return 'router_disable';
          }
        }
      } else {
        return '';
      }
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    __WEBPACK_IMPORTED_MODULE_4__utils_projetos__["a" /* default */].getProjeto(this.idProjeto).then(function (response) {
      _this2.projeto = response.data;
      _this2.projeto.dataInicio = __WEBPACK_IMPORTED_MODULE_3__utils_dates__["a" /* default */].format(_this2.projeto.dataInicio);
      _this2.projeto.dataConclusao = __WEBPACK_IMPORTED_MODULE_3__utils_dates__["a" /* default */].format(_this2.projeto.dataConclusao);
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    });

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações.' });
    __WEBPACK_IMPORTED_MODULE_4__utils_projetos__["a" /* default */].getExtensaoDoProjeto(this.idProjeto).then(function (response) {
      _this2.extensao = response.data;
      _this2.carregaAcaoExtensao(_this2.extensao.registroSIEX);
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações.' });
    });

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando contatos.' });
    __WEBPACK_IMPORTED_MODULE_4__utils_projetos__["a" /* default */].getContatosDoProjeto(this.idProjeto).then(function (response) {
      _this2.contatos = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando contatos.' });
    });
  },
  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar___default.a,
    'c-barra-administrador': __WEBPACK_IMPORTED_MODULE_1__components_c_barra_administrador___default.a
  }
});

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(417),
  /* template */
  __webpack_require__(420),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_confirm_dialog__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_confirm_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_c_confirm_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_tooltip_btn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_tooltip_btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_tooltip_btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['projeto', 'extensao'],
  data: function data() {
    return {
      dialogExclusao: false,
      dialogFinalizar: false,
      data: '',
      dataFormatada: '',
      menuData: false
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('auth', ['administrador', 'usuarioPROEX'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    goAprovarProjeto: function goAprovarProjeto() {
      this.$router.push({ name: 'AprovarProjeto', params: { idProjeto: this.projeto.idProjeto } });
    },
    goDevolverProjeto: function goDevolverProjeto() {
      this.$router.push({ name: 'DevolverProjeto', params: { idProjeto: this.projeto.idProjeto } });
    },
    goLiberarRelatorio: function goLiberarRelatorio() {
      this.$router.push({ name: 'LiberarRelatorio', params: { idProjeto: this.projeto.idProjeto } });
    },
    goInabilitarProjeto: function goInabilitarProjeto() {
      this.$router.push({ name: 'InabilitarProjeto', params: { idProjeto: this.projeto.idProjeto } });
    },
    goSuspenderAcaoExtensao: function goSuspenderAcaoExtensao() {
      this.$router.push({ name: 'SuspenderAcaoExtensao', params: { idProjeto: this.projeto.idProjeto } });
    },
    goReativarAcaoExtensao: function goReativarAcaoExtensao() {
      this.$router.push({ name: 'ReativarAcaoExtensao', params: { idProjeto: this.projeto.idProjeto } });
    },
    goAlterarClassificacaoSecundaria: function goAlterarClassificacaoSecundaria() {
      this.$router.push({ name: 'AlterarClassificacaoSecundaria', params: { idProjeto: this.projeto.idProjeto } });
    },
    goConcluirProjeto: function goConcluirProjeto() {
      this.$router.push({ name: 'ConcluirProjeto', params: { idProjeto: this.projeto.idProjeto } });
    },
    goCancelarProjeto: function goCancelarProjeto() {
      this.$router.push({ name: 'CancelarProjeto', params: { idProjeto: this.projeto.idProjeto } });
    },
    goDesfazerExclusao: function goDesfazerExclusao() {
      this.$router.push({ name: 'DesfazerExclusao', params: { idProjeto: this.projeto.idProjeto } });
    },
    goDesfazerFinalizacao: function goDesfazerFinalizacao() {
      this.$router.push({ name: 'DesfazerFinalizacao', params: { idProjeto: this.projeto.idProjeto } });
    },

    botaoFinalizarAcao: function botaoFinalizarAcao() {
      this.dialogFinalizar = true;
    },
    finalizarAcao: function finalizarAcao() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Finalizando ação...' });
      __WEBPACK_IMPORTED_MODULE_3__utils_projetos__["a" /* default */].postSubmissaoConclusao(this.projeto.idProjeto).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        window.location.reload();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Finalizando ação...' });
      });
    },
    botaoExcluirAcao: function botaoExcluirAcao() {
      this.dialogExclusao = true;
    },
    excluirAcao: function excluirAcao() {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo ação...' });
      __WEBPACK_IMPORTED_MODULE_3__utils_projetos__["a" /* default */].deleteProjeto(this.projeto.idProjeto).then(function (response) {
        _this2.$router.push({ name: 'MeusProjetos' });
        _this2.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this2.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo ação...' });
      });
    },
    renovarAcao: function renovarAcao() {
      var _this3 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo ação...' });
      __WEBPACK_IMPORTED_MODULE_3__utils_projetos__["a" /* default */].deleteProjeto(this.projeto.idProjeto).then(function (response) {
        _this3.$router.push({ name: 'MeusProjetos' });
        _this3.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this3.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this3.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo ação...' });
      });
    },
    concluirAcao: function concluirAcao() {
      var _this4 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Concluindo ação...' });
      __WEBPACK_IMPORTED_MODULE_3__utils_projetos__["a" /* default */].postConcluirProjeto(this.projeto.idProjeto).then(function (response) {
        _this4.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this4.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this4.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Concluindo ação...' });
      });
    },
    cancelarAcao: function cancelarAcao() {
      var _this5 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Cancelando ação...' });
      __WEBPACK_IMPORTED_MODULE_3__utils_projetos__["a" /* default */].postCancelarProjeto(this.projeto.idProjeto).then(function (response) {
        _this5.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this5.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this5.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Cancelando ação...' });
      });
    },
    toRelatorio: function toRelatorio() {
      this.$router.push({ name: 'Relatorio', params: { idProjeto: this.projeto.idProjeto } });
    },
    toEditar: function toEditar() {
      this.$router.push({ name: this.editar, params: { idProjeto: this.projeto.idProjeto } });
    },
    toAvancar: function toAvancar() {
      this.$router.push({ name: this.proxima, params: { idProjeto: this.projeto.idProjeto } });
    }
  }),
  components: {
    'c-confirm-dialog': __WEBPACK_IMPORTED_MODULE_1__components_c_confirm_dialog___default.a,
    'c-tooltip-btn': __WEBPACK_IMPORTED_MODULE_2__components_c_tooltip_btn___default.a
  }
});

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['value', 'titulo'],
  data: function data() {
    return {
      show: false
    };
  },
  watch: {
    value: function value(val) {
      this.show = val;
    }
  },
  methods: {
    setShow: function setShow(val) {
      this.$emit('input', val);
    },
    clicouSim: function clicouSim() {
      this.setShow(false);
      this.$emit('yes');
    },
    clicouNao: function clicouNao() {
      this.setShow(false);
      this.$emit('no');
    }
  }
});

/***/ }),
/* 419 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "width": "600"
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v(_vm._s(_vm.titulo))]), _vm._v(" "), _c('v-card-text', {
    staticClass: "title",
    staticStyle: {
      "word-break": "break-word",
      "margin-top": "10px"
    },
    attrs: {
      "align": "justify"
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.clicouNao()
      }
    }
  }, [_vm._v("Não")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.clicouSim()
      }
    }
  }, [_vm._v("Sim")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 420 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('c-confirm-dialog', {
    attrs: {
      "titulo": "Deseja realmente excluir a ação?"
    },
    on: {
      "yes": function($event) {
        return _vm.excluirAcao()
      }
    },
    model: {
      value: (_vm.dialogExclusao),
      callback: function($$v) {
        _vm.dialogExclusao = $$v
      },
      expression: "dialogExclusao"
    }
  }, [_vm._v("\n    Essa ação será excluída após clicar na opção \"Sim\".\n  ")]), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "color": "white"
    }
  }, [_c('v-toolbar-title', [_vm._v("Barra do administrador")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', {
    staticClass: "text-xs-right"
  }, [_c('c-tooltip-btn', {
    attrs: {
      "icon": "done_outline",
      "color": "green",
      "disabled": _vm.projeto.situacao.item != 16,
      "tooltip": "Aprovar",
      "disabled-tooltip": "Apenas uma ação na situação \"Aguardando aprovação\" pode ser aprovada"
    },
    on: {
      "click": function($event) {
        return _vm.goAprovarProjeto()
      }
    }
  }), _vm._v(" "), _c('c-tooltip-btn', {
    attrs: {
      "icon": "not_interested",
      "color": "red",
      "disabled": _vm.projeto.situacao.item != 16,
      "tooltip": "Devolver para o coordenador",
      "disabled-tooltip": "Apenas uma ação na situação \"Aguardando aprovação\" pode ser devolvida para o coordenador"
    },
    on: {
      "click": function($event) {
        return _vm.goDevolverProjeto()
      }
    }
  }), _vm._v(" "), (_vm.projeto.situacao.item === 15 && _vm.projeto.registroTardio === true) ? _c('div', [_c('c-tooltip-btn', {
    attrs: {
      "icon": "post_add",
      "color": "primary",
      "disabled": _vm.projeto.relatorioFinalHabilitado === true,
      "tooltip": "Liberar preenchimento do relatório técnico final",
      "disabled-tooltip": "O preenchimento do relatório técnico final já foi liberado"
    },
    on: {
      "click": function($event) {
        return _vm.goLiberarRelatorio()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('c-tooltip-btn', {
    attrs: {
      "icon": "autorenew",
      "color": "primary",
      "disabled": _vm.projeto.situacao.item != 20,
      "tooltip": "Desfazer Finalização (A ação volta a ficar ativa)",
      "disabled-tooltip": "Apenas uma ação na situação \"Aguardando relatório\" pode ter sua finalização desfeita"
    },
    on: {
      "click": function($event) {
        return _vm.goDesfazerFinalizacao()
      }
    }
  }), _vm._v(" "), _c('c-tooltip-btn', {
    attrs: {
      "icon": "pause_circle",
      "color": "primary",
      "disabled": _vm.projeto.situacao.item != 18 && _vm.projeto.situacao.item != 4 && _vm.projeto.situacao.item != 3,
      "tooltip": (_vm.projeto.situacao.item === 18 || _vm.projeto.situacao.item === 3) ? 'Suspender' : 'Prorrogar suspensão',
      "disabled-tooltip": "Para ser suspensa, a ação de extensão deve estar na situação \"Ativo\" ou \"Inadimplente\". Para prorrogar a suspensão, a ação de extensão deve estar na situação \"Suspenso\""
    },
    on: {
      "click": function($event) {
        return _vm.goSuspenderAcaoExtensao()
      }
    }
  }), _vm._v(" "), _c('c-tooltip-btn', {
    attrs: {
      "icon": "play_circle",
      "color": "primary",
      "disabled": _vm.projeto.situacao.item != 4 && _vm.projeto.situacao.item != 3,
      "tooltip": "Reativar",
      "disabled-tooltip": "Para ser reativada, a ação de extensão deve estar na situação \"Suspenso\" ou \"Inadimplente\""
    },
    on: {
      "click": function($event) {
        return _vm.goReativarAcaoExtensao()
      }
    }
  }), _vm._v(" "), _c('c-tooltip-btn', {
    attrs: {
      "icon": "folder",
      "color": "brown lighten-1",
      "disabled": _vm.projeto.situacao.item != 20 && _vm.projeto.situacao.item != 4 && _vm.projeto.situacao.item != 3,
      "tooltip": "Concluir",
      "disabled-tooltip": "Apenas uma ação na situação \"Suspenso\", \"Inadimplente\" ou \"Aguardando envio de relatório\" pode ser concluída"
    },
    on: {
      "click": function($event) {
        return _vm.goConcluirProjeto()
      }
    }
  }), _vm._v(" "), _c('c-tooltip-btn', {
    attrs: {
      "icon": "cancel_presentation",
      "color": "red",
      "disabled": _vm.projeto.situacao.item != 18 && _vm.projeto.situacao.item != 20 && _vm.projeto.situacao.item != 4 && _vm.projeto.situacao.item != 3,
      "tooltip": "Cancelar",
      "disabled-tooltip": "Apenas uma ação na situação \"Ativo\", \"Inadimplente\", \"Suspenso\" ou \"Aguardando envio de relatório\" pode ser cancelada"
    },
    on: {
      "click": function($event) {
        return _vm.goCancelarProjeto()
      }
    }
  }), _vm._v(" "), _c('c-tooltip-btn', {
    attrs: {
      "icon": "cancel",
      "color": "black",
      "disabled": _vm.projeto.situacao.item != 16,
      "tooltip": "Inabilitar",
      "disabled-tooltip": "Apenas uma ação na situação \"Aguardando aprovação\" pode ser inabilitada"
    },
    on: {
      "click": function($event) {
        return _vm.goInabilitarProjeto()
      }
    }
  }), _vm._v(" "), _c('c-tooltip-btn', {
    attrs: {
      "icon": "mode",
      "color": "primary",
      "disabled": _vm.projeto.situacao.item != 18 && _vm.projeto.situacao.item != 15,
      "tooltip": "Alterar classificação secundária",
      "disabled-tooltip": "A ação de extensão deve estar na situação \"Ativo\" ou \"Preenchimento incompleto\" para ter sua classificação secundária alterada"
    },
    on: {
      "click": function($event) {
        return _vm.goAlterarClassificacaoSecundaria()
      }
    }
  }), _vm._v(" "), (_vm.projeto.situacao.item != 21) ? _c('c-tooltip-btn', {
    attrs: {
      "icon": "delete",
      "color": "primary",
      "disabled": _vm.projeto.situacao.item != 15 && _vm.projeto.situacao.item != 16,
      "tooltip": "Excluir ação",
      "disabled-tooltip": "Apenas uma ação na situação \"Preenchimento incompleto\" ou \"Aguardando aprovação\" pode ser excluída"
    },
    on: {
      "click": function($event) {
        return _vm.botaoExcluirAcao()
      }
    }
  }) : _c('c-tooltip-btn', {
    attrs: {
      "icon": "restore_from_trash",
      "color": "primary",
      "tooltip": "Desfazer Exclusão"
    },
    on: {
      "click": function($event) {
        return _vm.goDesfazerExclusao()
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 421 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-10"
  }, [_c('v-toolbar', {
    attrs: {
      "color": 'primary white--text',
      "dense": _vm.projeto.titulo.length > 130,
      "prominent": _vm.projeto.titulo.length > 130
    }
  }, [_c('v-spacer'), _vm._v(" "), (_vm.projeto.titulo.length > 130) ? _c('v-card', {
    attrs: {
      "flat": "",
      "color": "primary"
    }
  }, [_c('v-card-title', {
    attrs: {
      "color": "primary white--text"
    }
  }, [_c('div', {
    staticClass: "titulo"
  }, [_vm._v("\n                " + _vm._s(_vm.projeto.classificacaoSecundaria.descricao) + " nº " + _vm._s(_vm.idProjeto) + " - " + _vm._s(_vm.projeto.titulo) + "\n                "), (_vm.extensao.registroSIEX) ? _c('a', {
    staticStyle: {
      "color": "white",
      "text-decoration": "underline"
    },
    attrs: {
      "href": 'http://siex1.ufes.br/siex/AuditarAcaoExtensao.do?id=' + this.acaoExtensao.id,
      "target": "_blank"
    }
  }, [_vm._v("SIEX #" + _vm._s(_vm.extensao.registroSIEX))]) : _vm._e(), _vm._v("\n                " + _vm._s(_vm.administrador && _vm.extensao.idProjetoDuplicacao ? '(duplicada)' : '') + "\n              ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.projeto.titulo.length <= 130) ? _c('v-toolbar-title', [_vm._v("\n            " + _vm._s(_vm.projeto.classificacaoSecundaria.descricao) + " nº " + _vm._s(_vm.idProjeto) + " - " + _vm._s(_vm.projeto.titulo) + "\n            "), (_vm.extensao.registroSIEX) ? _c('a', {
    staticStyle: {
      "color": "white",
      "text-decoration": "underline"
    },
    attrs: {
      "href": 'http://siex1.ufes.br/siex/AuditarAcaoExtensao.do?id=' + this.acaoExtensao.id,
      "target": "_blank"
    }
  }, [_vm._v("SIEX #" + _vm._s(_vm.extensao.registroSIEX))]) : _vm._e(), _vm._v("\n            " + _vm._s(_vm.administrador && _vm.extensao.idProjetoDuplicacao ? '(duplicada)' : '') + "\n          ")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-tabs', {
    attrs: {
      "slot": "extension",
      "centered": "",
      "show-arrows": "",
      "dark": "",
      "next-icon": "mdi-arrow-right-bold-box-outline",
      "prev-icon": "mdi-arrow-left-bold-box-outline",
      "color": "primary",
      "hide-slider": ""
    },
    slot: "extension"
  }, [_c('router-link', {
    class: _vm.verificaSeAbaDeveSerDesabilitadaDevidoAcaoNaoTerAlunos(),
    attrs: {
      "exact": "",
      "to": {
        name: 'ProjetoFormulario'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Informações")]), _vm._v(" "), _c('router-link', {
    class: _vm.verificaSeAbaDeveSerDesabilitadaDevidoAcaoNaoTerAlunos(),
    attrs: {
      "exact": "",
      "to": {
        name: 'ClassificacoesProjeto'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Classificações")]), _vm._v(" "), _c('router-link', {
    class: _vm.verificaSeAbaDeveSerDesabilitadaDevidoAcaoNaoTerAlunos(),
    attrs: {
      "exact": "",
      "to": {
        name: 'ExtensaoProjeto'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Extensão")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "exact": "",
      "to": {
        name: 'IntegrantesProjeto'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Equipe")]), _vm._v(" "), _c('router-link', {
    class: _vm.verificaSeAbaDeveSerDesabilitadaDevidoAcaoNaoTerAlunos(),
    attrs: {
      "exact": "",
      "to": {
        name: 'AtividadesProjeto'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Atividades")]), _vm._v(" "), _c('router-link', {
    class: _vm.verificaSeAbaDeveSerDesabilitadaDevidoAcaoNaoTerAlunos(),
    attrs: {
      "exact": "",
      "to": {
        name: 'VinculosProjeto'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Vínculos")]), _vm._v(" "), _c('router-link', {
    class: _vm.verificaSeAbaDeveSerDesabilitadaDevidoAcaoNaoTerAlunos(),
    attrs: {
      "exact": "",
      "to": {
        name: 'ParceriasProjeto'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Parcerias")]), _vm._v(" "), _c('router-link', {
    class: _vm.verificaSeAbaDeveSerDesabilitadaDevidoAcaoNaoTerAlunos(),
    attrs: {
      "exact": "",
      "to": {
        name: 'AbrangenciaProjeto'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Abrangência")]), _vm._v(" "), _c('router-link', {
    class: _vm.verificaSeAbaDeveSerDesabilitadaDevidoAcaoNaoTerAlunos(),
    attrs: {
      "exact": "",
      "to": {
        name: 'ArquivosProjeto'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Arquivos")]), _vm._v(" "), _c('router-link', {
    class: _vm.verificaSeAbaDeveSerDesabilitadaDevidoAcaoNaoTerAlunos(),
    attrs: {
      "exact": "",
      "to": {
        name: 'ContatosProjeto'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Contatos")]), _vm._v(" "), (_vm.habilitaRelatorio() || (_vm.username === 'athelson.bittencourt' && _vm.idProjeto == 102)) ? _c('router-link', {
    class: _vm.verificaSeAbaDeveSerDesabilitadaDevidoAcaoNaoTerAlunos(),
    attrs: {
      "exact": "",
      "to": {
        name: 'RelatoriosProjeto'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Relatórios")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('router-view', {
    attrs: {
      "idProjeto": _vm.idProjeto,
      "projeto": this.projeto,
      "extensao": this.extensao
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.administrador) ? _c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-10"
  }, [_c('c-barra-administrador', {
    attrs: {
      "projeto": this.projeto
    }
  })], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(423)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(424),
  /* template */
  __webpack_require__(425),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a37ff3b4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 423 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto'],
  data: function data() {
    return {
      projeto: {
        situacao: {},
        tipoPublico: {},
        classificacoesPrimariaSecundaria: [{}, {}]
      },
      extensao: {},
      acaoExtensao: {},
      contatos: {}
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('auth', ['logged', 'username', 'nome', 'administrador', 'usuarioPROEX', 'permissaoCriarProjetoExtensao'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING']), {
    carregaAcaoExtensao: function carregaAcaoExtensao(registro) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3__utils_projetos__["a" /* default */].getAcaoExtensao(registro).then(function (response) {
        var listaAcaoExtensao = response.data.slice();
        _this.acaoExtensao = listaAcaoExtensao[0];
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {});
    },
    // Verifica se a ação de extensão é um curso/oficina (antigo).
    acaoCursoOficina: function acaoCursoOficina() {
      if (this.projeto.classificacaoSecundaria.id === 39729) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se a ação de extensão é um curso.
    acaoCurso: function acaoCurso() {
      if (this.projeto.classificacaoSecundaria.id === 44194) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se a ação de extensão é um oficina.
    acaoOficina: function acaoOficina() {
      if (this.projeto.classificacaoSecundaria.id === 44195) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se a ação de extensão é um evento.
    acaoEvento: function acaoEvento() {
      if (this.projeto.classificacaoSecundaria.id === 39730) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se o tipo de ação de extensão está habilitado a ter a aba Relatórios.
    tipoAcaoExtensaoHabilitado: function tipoAcaoExtensaoHabilitado() {
      if (this.acaoCursoOficina() || this.acaoCurso() || this.acaoOficina() || this.acaoEvento()) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se a ação de extensão está na situação "Ativo".
    situacaoAtivo: function situacaoAtivo() {
      if (this.projeto.situacao.item === 18) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se a ação de extensão está na situação "Aguardando relatório".
    situacaoAguardandoRelatorio: function situacaoAguardandoRelatorio() {
      if (this.projeto.situacao.item === 20) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se a ação de extensão está na situação "Relatório aguardando aprovação".
    situacaoRelatorioAguardandoAprovacao: function situacaoRelatorioAguardandoAprovacao() {
      if (this.projeto.situacao.item === 22) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se a ação de extensão está na situação "Concluído".
    situacaoConcluido: function situacaoConcluido() {
      if (this.projeto.situacao.item === 19) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se a ação de extensão está na situação "Cancelado".
    situacaoCancelado: function situacaoCancelado() {
      if (this.projeto.situacao.item === 5) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se a situação da ação de extensão está habilitada a ter a aba Relatórios.
    situacaoAcaoExtensaoHabilitado: function situacaoAcaoExtensaoHabilitado() {
      if (this.situacaoAtivo() || this.situacaoAguardandoRelatorio() || this.situacaoRelatorioAguardandoAprovacao() || this.situacaoConcluido() || this.situacaoCancelado()) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se o usuário logado é administrador.
    usuarioAdministrador: function usuarioAdministrador() {
      if (this.administrador === true) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se o usuário logado é o coordenador da ação de extensão.
    usuarioCoordenador: function usuarioCoordenador() {
      if (this.projeto.funcao != null && this.projeto.funcao.item === 1) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se o usuário logado é assessor da ação de extensão.
    usuarioAssessor: function usuarioAssessor() {
      if (this.projeto.assessor === true) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se o usuário logado é usuário Proex.
    usuarioProex: function usuarioProex() {
      if (this.usuarioPROEX === true) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se o usuário logado está habilitado para a aba Relatórios.
    usuarioHabilitado: function usuarioHabilitado() {
      if (this.usuarioAdministrador() || this.usuarioCoordenador() || this.usuarioAssessor() || this.usuarioProex()) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se o preenchimento do relatório final está habilitado para ações de extensão com registro tardio.
    relatorioHabilitadoAcaoRegistroTardio: function relatorioHabilitadoAcaoRegistroTardio() {
      if (this.projeto.relatorioFinalHabilitado === true) {
        return true;
      } else {
        return false;
      }
    },
    habilitaRelatorio: function habilitaRelatorio() {
      if (this.tipoAcaoExtensaoHabilitado() && this.situacaoAcaoExtensaoHabilitado() || this.relatorioHabilitadoAcaoRegistroTardio()) {
        return true;
      } else {
        return false;
      }
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    __WEBPACK_IMPORTED_MODULE_3__utils_projetos__["a" /* default */].getProjeto(this.idProjeto).then(function (response) {
      _this2.projeto = response.data;
      _this2.projeto.dataInicio = __WEBPACK_IMPORTED_MODULE_2__utils_dates__["a" /* default */].format(_this2.projeto.dataInicio);
      _this2.projeto.dataConclusao = __WEBPACK_IMPORTED_MODULE_2__utils_dates__["a" /* default */].format(_this2.projeto.dataConclusao);
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    });

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações.' });
    __WEBPACK_IMPORTED_MODULE_3__utils_projetos__["a" /* default */].getExtensaoDoProjeto(this.idProjeto).then(function (response) {
      _this2.extensao = response.data;
      _this2.carregaAcaoExtensao(_this2.extensao.registroSIEX);
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações.' });
    });

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando contatos.' });
    __WEBPACK_IMPORTED_MODULE_3__utils_projetos__["a" /* default */].getContatosDoProjeto(this.idProjeto).then(function (response) {
      _this2.contatos = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando contatos.' });
    });
  },
  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a
  }
});

/***/ }),
/* 425 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-10"
  }, [_c('v-toolbar', {
    attrs: {
      "color": 'primary white--text',
      "dense": _vm.projeto.titulo.length > 130,
      "prominent": _vm.projeto.titulo.length > 130
    }
  }, [_c('v-spacer'), _vm._v(" "), (_vm.projeto.titulo.length > 130) ? _c('v-card', {
    attrs: {
      "flat": "",
      "color": "primary"
    }
  }, [_c('v-card-title', {
    attrs: {
      "color": "primary white--text"
    }
  }, [_c('div', {
    staticClass: "titulo"
  }, [_vm._v("\n                Editar " + _vm._s(_vm.projeto.classificacaoSecundaria.descricao) + " nº " + _vm._s(_vm.idProjeto) + " - " + _vm._s(_vm.projeto.titulo) + "\n                "), (_vm.extensao.registroSIEX) ? _c('a', {
    staticStyle: {
      "color": "white",
      "text-decoration": "underline"
    },
    attrs: {
      "href": 'http://siex1.ufes.br/siex/AuditarAcaoExtensao.do?id=' + this.acaoExtensao.id,
      "target": "_blank"
    }
  }, [_vm._v("SIEX #" + _vm._s(_vm.extensao.registroSIEX))]) : _vm._e(), _vm._v("\n                " + _vm._s(_vm.administrador && _vm.extensao.idProjetoDuplicacao ? '(duplicada)' : '') + "\n              ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.projeto.titulo.length <= 130) ? _c('v-toolbar-title', [_vm._v("\n            Editar " + _vm._s(_vm.projeto.classificacaoSecundaria.descricao) + " nº " + _vm._s(_vm.idProjeto) + " - " + _vm._s(_vm.projeto.titulo) + "\n            "), (_vm.extensao.registroSIEX) ? _c('a', {
    staticStyle: {
      "color": "white",
      "text-decoration": "underline"
    },
    attrs: {
      "href": 'http://siex1.ufes.br/siex/AuditarAcaoExtensao.do?id=' + this.acaoExtensao.id,
      "target": "_blank"
    }
  }, [_vm._v("SIEX #" + _vm._s(_vm.extensao.registroSIEX))]) : _vm._e(), _vm._v("\n            " + _vm._s(_vm.administrador && _vm.extensao.idProjetoDuplicacao ? '(duplicada)' : '') + "\n          ")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-tabs', {
    attrs: {
      "slot": "extension",
      "centered": "",
      "show-arrows": "",
      "dark": "",
      "next-icon": "mdi-arrow-right-bold-box-outline",
      "prev-icon": "mdi-arrow-left-bold-box-outline",
      "color": "primary",
      "hide-slider": ""
    },
    slot: "extension"
  }, [_c('router-link', {
    staticClass: "router_disable",
    attrs: {
      "exact": "",
      "to": {
        name: 'EditarInformacoes'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Informações")]), _vm._v(" "), _c('router-link', {
    staticClass: "router_disable",
    attrs: {
      "exact": "",
      "to": {
        name: 'EditarClassificacao'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Classificações")]), _vm._v(" "), _c('router-link', {
    staticClass: "router_disable",
    attrs: {
      "exact": "",
      "to": {
        name: 'EditarExtensao'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Extensão")]), _vm._v(" "), _c('router-link', {
    staticClass: "router_disable",
    attrs: {
      "exact": "",
      "to": {
        name: 'IntegrantesProjeto'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Equipe")]), _vm._v(" "), _c('router-link', {
    staticClass: "router_disable",
    attrs: {
      "exact": "",
      "to": {
        name: 'AtividadesProjeto'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Atividades")]), _vm._v(" "), _c('router-link', {
    staticClass: "router_disable",
    attrs: {
      "exact": "",
      "to": {
        name: 'VinculosProjeto'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Vínculos")]), _vm._v(" "), _c('router-link', {
    staticClass: "router_disable",
    attrs: {
      "exact": "",
      "to": {
        name: 'ParceriasProjeto'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Parcerias")]), _vm._v(" "), _c('router-link', {
    staticClass: "router_disable",
    attrs: {
      "exact": "",
      "to": {
        name: 'AbrangenciaProjeto'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Abrangência")]), _vm._v(" "), _c('router-link', {
    staticClass: "router_disable",
    attrs: {
      "exact": "",
      "to": {
        name: 'ArquivosProjeto'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Arquivos")]), _vm._v(" "), _c('router-link', {
    staticClass: "router_disable",
    attrs: {
      "exact": "",
      "to": {
        name: 'EditarContatos'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Contatos")]), _vm._v(" "), (_vm.habilitaRelatorio() || (_vm.username === 'athelson.bittencourt' && _vm.idProjeto == 102)) ? _c('router-link', {
    staticClass: "router_disable",
    attrs: {
      "exact": "",
      "to": {
        name: 'RelatoriosProjeto'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Relatórios")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('router-view', {
    attrs: {
      "idProjeto": _vm.idProjeto,
      "projeto": this.projeto
    }
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(427)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(428),
  /* template */
  __webpack_require__(431),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 427 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_textarea__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_c_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(3);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      formularioValido: false,
      aceiteTermoCompromisso: false,
      termoCompromissoTexto: 'Declaro, na qualidade de coordenador(a), ter pleno conhecimento das normativas institucionais vigentes\n    que regem a extens\xE3o universit\xE1ria na UFES e que a presente proposta est\xE1 condizente com essas normativas e diretrizes.\n    Comprometo-me a cumpri-las integralmente em todas as etapas da a\xE7\xE3o \u2014 desde a elabora\xE7\xE3o at\xE9 a certifica\xE7\xE3o e relat\xF3rios finais \u2014,\n    garantindo o respeito e o atendimento ao interesse p\xFAblico. Declaro tamb\xE9m que esta proposta de a\xE7\xE3o de extens\xE3o encontrar\xE1,\n    na sociedade, uma oportunidade de constru\xE7\xE3o conjunta de pr\xE1ticas baseadas no interc\xE2mbio de saberes, contribuindo para uma\n    sociedade mais inclusiva, dial\xF3gica e respons\xE1vel. Declaro ainda estar ciente de que o descumprimento das normas poder\xE1 acarretar\n    san\xE7\xF5es conforme previsto nos regulamentos da UFES.',
      dialogConfirmaCadastro: false,
      cursoOuEvento: false,
      registroTardio: false,
      dates: __WEBPACK_IMPORTED_MODULE_6__utils_dates__["a" /* default */],
      dataConclusaoSemLimite: false,
      projeto: {
        titulo: '',
        projetoSup: undefined,
        dataInicio: '',
        dataConclusao: '',
        resumo: '',
        termoCompromisso: '',
        tipoPublico: undefined,
        cargaHoraria: null,
        publicoAlvo: null,
        classificacaoPrimaria: null,
        classificacaoSecundaria: null,
        classificacoesPrimariaSecundaria: []
      },
      pesquisa: {
        titulo: ''
      },
      listaTipoPublico: [],
      listaTipoEvento: [],
      listaSituacao: [],
      listaClassificacaoPrimaria: [{
        'id': 39725,
        'classificacaoItem': 90,
        'tipoClassificacao': 'Tipo de Projeto',
        'descricao': 'Extensão'
      }],
      listaClassificacaoSecundaria: [],
      dialog: false,
      regrasBasicas: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }],
      dataConclusaoRules: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }],
      tituloRules: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }, function (input) {
        return !!input && input.length <= 150 || 'Este campo não pode possuir mais que 150 caracteres';
      }],
      resumoRules: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }, function (input) {
        return !!input && input.length <= 1000 || 'Este campo não pode possuir mais que 1000 caracteres';
      }],
      publicoAlvoEstimadoRules: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }, function (input) {
        return !isNaN(parseFloat(input)) && input > 0 && input <= 10000000 || 'Público-alvo estimado inválido';
      }],
      assuntoSummaryRules: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }, function (input) {
        return !!input && input.length <= 200 || 'Este campo não pode possuir mais que 200 caracteres';
      }],
      numerico: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }, function (input) {
        return !isNaN(input) || 'Este campo deve ser numérico';
      }, function (input) {
        return input.length === 0 || Number(input) !== 0 || 'Este campo não pode ser nulo';
      }, function (input) {
        return input.length === 0 || Number(input) >= 0 || 'Este campo não pode ter valor negativo';
      }],
      search: null,
      sortBy: 'dtCriacao',
      sortDesc: true,
      itemsPerPage: 25,
      opcoesPaginacao: [10, 25, 50, { text: 'Todas', value: -1 }],
      headers: [{ text: 'Número', align: 'center', value: 'idProjeto' }, { text: 'Título', align: 'center', value: 'titulo' }, { text: 'Classificação primária', align: 'center', value: 'classificacaoPrimaria.descricao' }, { text: 'Classificação secundária', align: 'center', value: 'classificacaoSecundaria.descricao' }, { text: 'Situação', align: 'center', value: 'situacao.descricao' }, { text: 'Início', align: 'center', value: 'dataCriacao' }]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])('autuacao', ['listaTipoDocumento', 'tipoDocumento', 'listaUnidadeProcedencia', 'unidadeProcedencia', 'listaTipoInteressado', 'tipoInteressado', 'listaEntidadeInteressada', 'entidadeInteressada', 'assunto']), {
    entidadeInteressadaComCodigo: function entidadeInteressadaComCodigo() {
      return this.entidadeInteressada.codigo && this.entidadeInteressada.nome ? '[' + this.entidadeInteressada.codigo + '] ' + this.entidadeInteressada.nome : null;
    },
    concatenatedSubject: function concatenatedSubject() {
      return this.assunto.codigo && this.assunto.descricao ? '[' + this.assunto.codigo + '] ' + this.assunto.descricao : null;
    },
    temVinculo: function temVinculo() {
      if (this.projeto && this.projeto.classificacaoSecundaria) {
        return this.projeto.classificacaoSecundaria.id !== 39733;
      } else {
        return false;
      }
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    truncate: function truncate(string, limit) {
      if (string.length > limit) return string.substring(0, limit) + '...';else return string;
    },
    onChangeDataSemLimite: function onChangeDataSemLimite() {
      this.projeto.dataConclusao = undefined;
      if (this.dataConclusaoSemLimite) {
        this.dataConclusaoRules = [true];
      } else {
        this.dataConclusaoRules = [function (input) {
          return !!input || 'Este campo é obrigatório';
        }];
      }
    },
    abreDialogCadastroAcaoExtensao: function abreDialogCadastroAcaoExtensao() {
      this.dialogConfirmaCadastro = true;
      // Curso/Oficina (39729) ou Curso (44194) ou Oficina (44195) ou Evento (39730)
      if (this.projeto.classificacaoSecundaria.id === 39729 || this.projeto.classificacaoSecundaria.id === 44194 || this.projeto.classificacaoSecundaria.id === 44195 || this.projeto.classificacaoSecundaria.id === 39730) {
        this.cursoOuEvento = true;
        this.verificaCursoEventoRegistroTardio();
      } else {
        this.cursoOuEvento = false;
      }
    },
    limparProjetoSup: function limparProjetoSup() {
      this.projeto.projetoSup = undefined;
    },
    limparDataConclusaoSemLimite: function limparDataConclusaoSemLimite() {
      this.dataConclusaoSemLimite = false;
      this.dataConclusaoRules = [function (input) {
        return !!input || 'Este campo é obrigatório';
      }];
    },
    // Verifica se o registro do curso ou evento é tardio.
    verificaCursoEventoRegistroTardio: function verificaCursoEventoRegistroTardio() {
      if (this.cursoOuEvento) {
        // Obtém a data atual.
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0');
        var yyyy = today.getFullYear();
        today = yyyy + '-' + mm + '-' + dd;
        var dataAtual = new Date(today);
        // Obtém a data de conclusão do curso ou evento.
        var dataConclusao = new Date(this.projeto.dataConclusao);
        // Verifica se o registro é tardio.
        if (dataConclusao.getTime() < dataAtual.getTime()) {
          this.registroTardio = true;
        } else {
          this.registroTardio = false;
        }
      }
    },
    selecionarProjeto: function selecionarProjeto(projeto) {
      this.projeto.projetoSup = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.projetoSup, { idProjeto: projeto.idProjeto, titulo: projeto.titulo });
      this.dialog = false;
    },
    criarNovoProjeto: function criarNovoProjeto() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Criando Projeto.' });
      this.projeto.classificacoesPrimariaSecundaria = [this.projeto.classificacaoPrimaria, this.projeto.classificacaoSecundaria];
      this.projeto.termoCompromisso = this.termoCompromissoTexto;
      __WEBPACK_IMPORTED_MODULE_7__utils_projetos__["a" /* default */].postProjeto(this.projeto).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        var idProjetoNovo = response.body.link.split('/').pop();
        _this.$router.push({ name: 'ProjetoFormulario', params: { idProjeto: idProjetoNovo } });
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
      });
    },
    obterClassificacoes: function obterClassificacoes(itemTabela, aqui, atributo) {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando classificações.' });
      __WEBPACK_IMPORTED_MODULE_7__utils_projetos__["a" /* default */].getClassificacoesPossiveis(itemTabela).then(function (response) {
        aqui[atributo] = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando classificações.' });
      });
    },
    opcoesTabelaEstruturada: function opcoesTabelaEstruturada(codTabela, aqui, atributo) {
      var _this3 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' });
      return __WEBPACK_IMPORTED_MODULE_7__utils_projetos__["a" /* default */].getOpcoesTabelaEstruturada(codTabela).then(function (response) {
        aqui[atributo] = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this3.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
      });
    }
  }),
  mounted: function mounted() {
    var _this4 = this;

    this.opcoesTabelaEstruturada(6011, this, 'listaSituacao');
    this.opcoesTabelaEstruturada(6002, this, 'listaTipoPublico').then(function () {
      // mantém apenas itens 14 e 15
      _this4.listaTipoPublico = _this4.listaTipoPublico.filter(function (item) {
        return item.item === 14 || item.item === 15;
      });
    });
    this.opcoesTabelaEstruturada(6028, this, 'listaTipoEvento');
    //      this.obterClassificacoes(90, this, 'listaClassificacaoPrimaria')
    this.obterClassificacoes(91, this, 'listaClassificacaoSecundaria');
    this.projeto.classificacaoPrimaria = {
      'id': 39725,
      'classificacaoItem': 90,
      'tipoClassificacao': 'Tipo de Projeto',
      'descricao': 'Extensão'
    };
  },
  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_5__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a,
    'c-date-menu': __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default.a,
    'c-textarea': __WEBPACK_IMPORTED_MODULE_4__components_c_textarea___default.a
  }
});

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['label', 'value', 'counter', 'rules', 'clearable', 'required', 'rows', 'disabled'],
  data: function data() {
    return {
      texto: ''
    };
  },
  computed: {
    couterRules: function couterRules() {
      var _this = this;

      var area = [function (input) {
        return _this.required === undefined || !!input || 'Este campo é obrigatório';
      }, function (input) {
        return _this.counter === undefined || input == null || input.length <= _this.counter || 'Este campo não pode possuir mais que ' + _this.counter + ' caracteres';
      }];
      return area;
    }
  },
  watch: {
    value: {
      handler: function handler(val, oldVal) {
        this.texto = val;
      },
      immediate: true
    }
  },
  methods: {
    setTexto: function setTexto() {
      this.$emit('input', this.texto);
    }
  }
});

/***/ }),
/* 430 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-textarea', {
    attrs: {
      "label": _vm.required != null ? (_vm.label + '*') : _vm.label,
      "rows": _vm.rows,
      "auto-grow": true,
      "multi-line": "",
      "counter": _vm.counter,
      "rules": _vm.couterRules,
      "required": _vm.required,
      "disabled": _vm.disabled
    },
    on: {
      "input": function($event) {
        return _vm.setTexto()
      }
    },
    model: {
      value: (_vm.texto),
      callback: function($$v) {
        _vm.texto = $$v
      },
      expression: "texto"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 431 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-dialog', {
    attrs: {
      "width": "550",
      "persistent": ""
    },
    model: {
      value: (_vm.dialogConfirmaCadastro),
      callback: function($$v) {
        _vm.dialogConfirmaCadastro = $$v
      },
      expression: "dialogConfirmaCadastro"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("Confirma o cadastro da ação de\n        extensão?")]), _vm._v(" "), (_vm.cursoOuEvento && _vm.registroTardio) ? _c('div', [_c('v-card-text', {
    staticClass: "title",
    staticStyle: {
      "word-break": "break-word",
      "margin-top": "10px"
    },
    attrs: {
      "align": "justify"
    }
  }, [_vm._v("\n          A submissão de uma proposta de ação retroativa deve ser acompanhada, obrigatoriamente, do relatório da\n          respectiva ação.\n        ")])], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogConfirmaCadastro = false
      }
    }
  }, [_vm._v("Não")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.criarNovoProjeto()
      }
    }
  }, [_vm._v("Sim")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Novo Projeto'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Título",
      "required": "",
      "rules": _vm.tituloRules,
      "max-height": "400",
      "counter": "150"
    },
    model: {
      value: (_vm.projeto.titulo),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "titulo", $$v)
      },
      expression: "projeto.titulo"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Classificação primária",
      "items": _vm.listaClassificacaoPrimaria,
      "item-text": "descricao",
      "item-value": "id",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "return-object": "",
      "required": "",
      "autocomplete": "",
      "readonly": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.projeto.classificacaoPrimaria),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "classificacaoPrimaria", $$v)
      },
      expression: "projeto.classificacaoPrimaria"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Classificação secundária",
      "items": _vm.listaClassificacaoSecundaria,
      "item-text": "descricao",
      "item-value": "id",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "return-object": "",
      "required": "",
      "autocomplete": "",
      "rules": _vm.regrasBasicas
    },
    on: {
      "change": function($event) {
        return _vm.limparDataConclusaoSemLimite()
      }
    },
    model: {
      value: (_vm.projeto.classificacaoSecundaria),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "classificacaoSecundaria", $$v)
      },
      expression: "projeto.classificacaoSecundaria"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Tipo de público-alvo",
      "items": _vm.listaTipoPublico,
      "item-text": "descricao",
      "item-value": "id",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "return-object": "",
      "required": "",
      "autocomplete": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.projeto.tipoPublico),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "tipoPublico", $$v)
      },
      expression: "projeto.tipoPublico"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field-integer', {
    attrs: {
      "label": "Público-alvo estimado",
      "properties": {
        rules: _vm.numerico
      }
    },
    model: {
      value: (_vm.projeto.publicoAlvo),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "publicoAlvo", $$v)
      },
      expression: "projeto.publicoAlvo"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [(_vm.projeto.classificacaoSecundaria && _vm.projeto.classificacaoSecundaria.id === 44194) ? _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field-integer', {
    attrs: {
      "label": "Carga horária do curso",
      "properties": {
        rules: _vm.numerico
      }
    },
    model: {
      value: (_vm.projeto.cargaHoraria),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "cargaHoraria", $$v)
      },
      expression: "projeto.cargaHoraria"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-layout', [(_vm.projeto.classificacaoSecundaria && _vm.projeto.classificacaoSecundaria.id === 44195) ? _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field-integer', {
    attrs: {
      "label": "Carga horária da oficina",
      "properties": {
        rules: _vm.numerico
      }
    },
    model: {
      value: (_vm.projeto.cargaHoraria),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "cargaHoraria", $$v)
      },
      expression: "projeto.cargaHoraria"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-layout', [(_vm.projeto.classificacaoSecundaria && _vm.projeto.classificacaoSecundaria.id === 39730) ? _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field-integer', {
    attrs: {
      "label": "Carga horária do evento",
      "properties": {
        rules: _vm.numerico
      }
    },
    model: {
      value: (_vm.projeto.cargaHoraria),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "cargaHoraria", $$v)
      },
      expression: "projeto.cargaHoraria"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [((_vm.projeto.classificacaoSecundaria && _vm.projeto.classificacaoSecundaria.id === 39733)) ? _c('v-checkbox', {
    attrs: {
      "value": true
    },
    on: {
      "change": _vm.onChangeDataSemLimite
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("Essa é uma ação contínua, sem data limite")])]
      },
      proxy: true
    }], null, false, 3659365439),
    model: {
      value: (_vm.dataConclusaoSemLimite),
      callback: function($$v) {
        _vm.dataConclusaoSemLimite = $$v
      },
      expression: "dataConclusaoSemLimite"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-date-menu', {
    attrs: {
      "label": "Data de início",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.projeto.dataInicio),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "dataInicio", $$v)
      },
      expression: "projeto.dataInicio"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-date-menu', {
    attrs: {
      "label": "Data de conclusão",
      "rules": _vm.dataConclusaoRules,
      "disabled": _vm.dataConclusaoSemLimite
    },
    model: {
      value: (_vm.projeto.dataConclusao),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "dataConclusao", $$v)
      },
      expression: "projeto.dataConclusao"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Palavra-chave 1",
      "required": "",
      "rules": _vm.regrasBasicas,
      "max-height": "400"
    },
    model: {
      value: (_vm.projeto.palavraChave01),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "palavraChave01", $$v)
      },
      expression: "projeto.palavraChave01"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Palavra-chave 2",
      "required": "",
      "rules": _vm.regrasBasicas,
      "max-height": "400"
    },
    model: {
      value: (_vm.projeto.palavraChave02),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "palavraChave02", $$v)
      },
      expression: "projeto.palavraChave02"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Palavra-chave 3",
      "required": "",
      "rules": _vm.regrasBasicas,
      "max-height": "400"
    },
    model: {
      value: (_vm.projeto.palavraChave03),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "palavraChave03", $$v)
      },
      expression: "projeto.palavraChave03"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Palavra-chave 4",
      "max-height": "400"
    },
    model: {
      value: (_vm.projeto.palavraChave04),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "palavraChave04", $$v)
      },
      expression: "projeto.palavraChave04"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Resumo",
      "required": "",
      "rules": _vm.resumoRules,
      "rows": 3,
      "auto-grow": true,
      "multi-line": "",
      "counter": "1000"
    },
    model: {
      value: (_vm.projeto.resumo),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "resumo", $$v)
      },
      expression: "projeto.resumo"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "value": true
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticStyle: {
            "text-align": "justify"
          }
        }, [_vm._v("\n                        " + _vm._s(_vm.termoCompromissoTexto) + "\n                      ")])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.aceiteTermoCompromisso),
      callback: function($$v) {
        _vm.aceiteTermoCompromisso = $$v
      },
      expression: "aceiteTermoCompromisso"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido || !_vm.aceiteTermoCompromisso
    },
    on: {
      "click": function($event) {
        return _vm.abreDialogCadastroAcaoExtensao()
      }
    }
  }, [_vm._v("Criar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(433)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(434),
  /* template */
  __webpack_require__(435),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 433 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_textarea__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_c_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto', 'idAtividade'],
  data: function data() {
    return {
      formularioValido: false,
      arquivo: {
        conteudo: {},
        nome: '',
        observacao: '',
        tipoArquivo: undefined,
        nivelAcesso: 'P',
        tipoCopia: 'S'
      },
      listaTipoArquivo: [],
      listaNivelAcesso: [{ descricao: 'Público', item: 'P' }, { descricao: 'Restrito', item: 'R' }],
      listaTipoCopia: [{ descricao: 'Digitalização de cópia simples', item: 'S' }, { descricao: 'Digitalização de cópia autenticada', item: 'A' }, { descricao: 'Digitalização do original', item: 'O' }],
      regrasBasicas: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }],
      assuntoSummaryRules: [function (input) {
        return input.length <= 200 || 'Este campo não pode possuir mais que 200 caracteres';
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    cancelar: function cancelar() {
      this.$router.push({ name: 'ArquivosProjeto', params: { idProjeto: this.idProjeto } });
    },
    adicionarArquivos: function adicionarArquivos(arquivos) {
      /*
      let nome = arquivos[0].name.toLowerCase()
      let video = false
      video = nome.endsWith('.avi') ||
              nome.endsWith('.mov') ||
              nome.endsWith('.wmv') ||
              nome.endsWith('.mp4') ||
              nome.endsWith('.3gp') ||
              nome.endsWith('.3g2') ||
              nome.endsWith('.flv') ||
              nome.endsWith('.mkv') ||
              nome.endsWith('.rm')
      if (video && arquivos[0].size > 104857600) {
        this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: 'Arquivos de vídeo devem ser menores que 100 MB.'})
        return
      }
      if (!video && arquivos[0].size > 5242880) {
        this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: 'Arquivos adicionados devem ser menores que 5 MB.'})
        return
      }
      */

      if (arquivos[0].name.length > 100) {
        this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: 'O nome do arquivo deve ser menor do que 100 caracteres.' });
        document.getElementById('uploadFileInput').value = '';
        return;
      }

      this.arquivo.conteudo = arquivos[0];
      this.arquivo.nome = arquivos[0].name;
    },
    enviarArquivo: function enviarArquivo() {
      var _this = this;

      var body = new FormData();
      body.append('arquivo', this.arquivo.conteudo);
      body.append('nome', this.arquivo.nome);
      body.append('observacao', this.arquivo.observacao);
      body.append('tipoArquivoItem', this.arquivo.tipoArquivo.item);
      body.append('nivelAcesso', this.arquivo.nivelAcesso);
      body.append('tipoCopia', this.arquivo.tipoCopia);

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Salvando arquivo.' });
      __WEBPACK_IMPORTED_MODULE_3__utils_projetos__["a" /* default */].postArquivo(this.idProjeto, body).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.$router.push({ name: 'ArquivosProjeto', params: { idProjeto: _this.idProjeto } });
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Salvando arquivo.' });
      });
    },

    opcoesTabelaEstruturada: function opcoesTabelaEstruturada(codTabela, aqui, atributo) {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' });
      __WEBPACK_IMPORTED_MODULE_3__utils_projetos__["a" /* default */].getOpcoesTabelaEstruturada(codTabela).then(function (response) {
        aqui[atributo] = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
      });
    }
  }),
  mounted: function mounted() {
    this.opcoesTabelaEstruturada(1150, this, 'listaTipoArquivo');
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a,
    'c-textarea': __WEBPACK_IMPORTED_MODULE_4__components_c_textarea___default.a
  }
});

/***/ }),
/* 435 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Adicionar arquivo'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-left",
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('input', {
    ref: "arquivoInput",
    staticStyle: {
      "padding-top": "20px"
    },
    attrs: {
      "id": "uploadFileInput",
      "type": "file",
      "accept": _vm.tiposArquivosPermitidos
    },
    on: {
      "change": function($event) {
        return _vm.adicionarArquivos($event.target.files)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Tipo do arquivo",
      "items": _vm.listaTipoArquivo,
      "item-text": "descricao",
      "item-value": "item",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "return-object": "",
      "autocomplete": "",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.arquivo.tipoArquivo),
      callback: function($$v) {
        _vm.$set(_vm.arquivo, "tipoArquivo", $$v)
      },
      expression: "arquivo.tipoArquivo"
    }
  })], 1)], 1), _vm._v(" "), (false) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Nível de acesso",
      "items": _vm.listaNivelAcesso,
      "item-text": "descricao",
      "item-value": "item",
      "prepend-icon": "vpn_key",
      "max-height": "400",
      "autocomplete": "",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.arquivo.nivelAcesso),
      callback: function($$v) {
        _vm.$set(_vm.arquivo, "nivelAcesso", $$v)
      },
      expression: "arquivo.nivelAcesso"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Tipo de cópia",
      "items": _vm.listaTipoCopia,
      "item-text": "descricao",
      "item-value": "item",
      "prepend-icon": "file_copy",
      "max-height": "400",
      "autocomplete": ""
    },
    model: {
      value: (_vm.arquivo.tipoCopia),
      callback: function($$v) {
        _vm.$set(_vm.arquivo, "tipoCopia", $$v)
      },
      expression: "arquivo.tipoCopia"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-textarea', {
    attrs: {
      "label": "Observação",
      "rules": _vm.assuntoSummaryRules,
      "rows": 2,
      "auto-grow": true,
      "multi-line": "",
      "counter": "200"
    },
    model: {
      value: (_vm.arquivo.observacao),
      callback: function($$v) {
        _vm.$set(_vm.arquivo, "observacao", $$v)
      },
      expression: "arquivo.observacao"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.cancelar
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": _vm.enviarArquivo
    }
  }, [_vm._v("Salvar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(437)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(438),
  /* template */
  __webpack_require__(439),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 437 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_textarea__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_c_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto', 'idArquivo'],
  data: function data() {
    return {
      formularioValido: false,
      arquivo: {
        conteudo: {},
        nome: '',
        observacao: '',
        tipoArquivo: undefined,
        nivelAcesso: 'P',
        tipoCopia: 'S'
      },
      listaTipoArquivo: [],
      listaNivelAcesso: [{ descricao: 'Público', item: 'P' }, { descricao: 'Restrito', item: 'R' }],
      listaTipoCopia: [{ descricao: 'Digitalização de cópia simples', item: 'S' }, { descricao: 'Digitalização de cópia autenticada', item: 'A' }, { descricao: 'Digitalização do original', item: 'O' }],
      regrasBasicas: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }],
      assuntoSummaryRules: [function (input) {
        return input.length <= 200 || 'Este campo não pode possuir mais que 200 caracteres';
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    cancelar: function cancelar() {
      this.$router.push({ name: 'ArquivosProjeto', params: { idProjeto: this.idProjeto } });
    },
    adicionarArquivos: function adicionarArquivos(arquivos) {
      this.arquivo.conteudo = arquivos[0];
      this.arquivo.nome = arquivos[0].name;
    },
    editarArquivo: function editarArquivo() {
      var _this = this;

      var body = new FormData();
      body.append('nome', this.arquivo.nome);
      body.append('tipoArquivoItem', this.arquivo.tipoArquivo.item);
      body.append('nivelAcesso', this.arquivo.nivelAcesso);
      body.append('tipoCopia', this.arquivo.tipoCopia);
      body.append('observacao', this.arquivo.observacao);

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Salvando arquivo.' });
      __WEBPACK_IMPORTED_MODULE_3__utils_projetos__["a" /* default */].putArquivo(this.idProjeto, this.idArquivo, this.arquivo).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.$router.push({ name: 'ArquivosProjeto', params: { idProjeto: _this.idProjeto } });
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Salvando arquivo.' });
      });
    },

    opcoesTabelaEstruturada: function opcoesTabelaEstruturada(codTabela, aqui, atributo) {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' });
      __WEBPACK_IMPORTED_MODULE_3__utils_projetos__["a" /* default */].getOpcoesTabelaEstruturada(codTabela).then(function (response) {
        aqui[atributo] = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
      });
    }
  }),
  mounted: function mounted() {
    var _this3 = this;

    this.opcoesTabelaEstruturada(1150, this, 'listaTipoArquivo');

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações do arquivo.' });
    __WEBPACK_IMPORTED_MODULE_3__utils_projetos__["a" /* default */].getArquivo(this.idProjeto, this.idArquivo).then(function (response) {
      _this3.arquivo = response.data;
      console.log(_this3.arguivo);
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this3.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações do arquivo.' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a,
    'c-textarea': __WEBPACK_IMPORTED_MODULE_4__components_c_textarea___default.a
  }
});

/***/ }),
/* 439 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Editar arquivo'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-left",
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome do arquivo",
      "readonly": ""
    },
    model: {
      value: (_vm.arquivo.nome),
      callback: function($$v) {
        _vm.$set(_vm.arquivo, "nome", $$v)
      },
      expression: "arquivo.nome"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Tipo do arquivo",
      "items": _vm.listaTipoArquivo,
      "item-text": "descricao",
      "item-value": "item",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "return-object": "",
      "autocomplete": "",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.arquivo.tipoArquivo),
      callback: function($$v) {
        _vm.$set(_vm.arquivo, "tipoArquivo", $$v)
      },
      expression: "arquivo.tipoArquivo"
    }
  })], 1)], 1), _vm._v(" "), (false) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Nível de acesso",
      "items": _vm.listaNivelAcesso,
      "item-text": "descricao",
      "item-value": "item",
      "prepend-icon": "vpn_key",
      "max-height": "400",
      "autocomplete": "",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.arquivo.nivelAcesso),
      callback: function($$v) {
        _vm.$set(_vm.arquivo, "nivelAcesso", $$v)
      },
      expression: "arquivo.nivelAcesso"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Tipo de cópia",
      "items": _vm.listaTipoCopia,
      "item-text": "descricao",
      "item-value": "item",
      "prepend-icon": "file_copy",
      "max-height": "400",
      "autocomplete": ""
    },
    model: {
      value: (_vm.arquivo.tipoCopia),
      callback: function($$v) {
        _vm.$set(_vm.arquivo, "tipoCopia", $$v)
      },
      expression: "arquivo.tipoCopia"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-textarea', {
    attrs: {
      "label": "Observação",
      "rules": _vm.assuntoSummaryRules,
      "rows": 2,
      "auto-grow": true,
      "multi-line": "",
      "counter": "200"
    },
    model: {
      value: (_vm.arquivo.observacao),
      callback: function($$v) {
        _vm.$set(_vm.arquivo, "observacao", $$v)
      },
      expression: "arquivo.observacao"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.cancelar
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": _vm.editarArquivo
    }
  }, [_vm._v("Salvar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(441)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(442),
  /* template */
  __webpack_require__(443),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 441 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_date_menu__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_date_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_date_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_textarea__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      formularioValido: false,
      dates: __WEBPACK_IMPORTED_MODULE_5__utils_dates__["a" /* default */],
      listaTipoPublico: [],
      projetoSIEX: {
        classificacoesPrimariaSecundaria: [{}, {}]
      },
      pesquisa: {
        registroSIEX: ''
      },
      regrasBasicas: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }],
      resumoRules: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }, function (input) {
        return !!input && input.length <= 1000 || 'Este campo não pode possuir mais que 1000 caracteres';
      }],
      assuntoSummaryRules: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }, function (input) {
        return !!input && input.length <= 200 || 'Este campo não pode possuir mais que 200 caracteres';
      }],
      search: null,
      sortBy: 'dtCriacao',
      sortDesc: true,
      itemsPerPage: 25,
      opcoesPaginacao: [10, 25, 50, { text: 'Todas', value: -1 }],
      headers: [{ text: 'Número', align: 'center', value: 'idProjeto' }, { text: 'Título', align: 'center', value: 'titulo' }, { text: 'Classificação primária', align: 'center', value: 'classificacaoPrimaria.descricao' }, { text: 'Classificação secundária', align: 'center', value: 'classificacaoSecundaria.descricao' }, { text: 'Situação', align: 'center', value: 'situacao.descricao' }, { text: 'Início', align: 'center', value: 'dataCriacao' }]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])('autuacao', ['listaTipoDocumento', 'tipoDocumento', 'listaUnidadeProcedencia', 'unidadeProcedencia', 'listaTipoInteressado', 'tipoInteressado', 'listaEntidadeInteressada', 'entidadeInteressada', 'assunto']), {
    entidadeInteressadaComCodigo: function entidadeInteressadaComCodigo() {
      return this.entidadeInteressada.codigo && this.entidadeInteressada.nome ? '[' + this.entidadeInteressada.codigo + '] ' + this.entidadeInteressada.nome : null;
    },
    concatenatedSubject: function concatenatedSubject() {
      return this.assunto.codigo && this.assunto.descricao ? '[' + this.assunto.codigo + '] ' + this.assunto.descricao : null;
    },
    temVinculo: function temVinculo() {
      if (this.projeto && this.projeto.classificacaoSecundaria) {
        return this.projeto.classificacaoSecundaria.id !== 39733;
      } else {
        return false;
      }
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    truncate: function truncate(string, limit) {
      if (string.length > limit) return string.substring(0, limit) + '...';else return string;
    },
    pesquisarProjetoSIEX: function pesquisarProjetoSIEX() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
      __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].getProjetoSIEX(this.pesquisa.registroSIEX).then(function (response) {
        _this.projetoSIEX = response.data;
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
      });
    },
    importarProjetoSIEX: function importarProjetoSIEX() {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Importando projeto.' });
      __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].postImportarProjetoSIEX(this.pesquisa.registroSIEX, this.projetoSIEX).then(function (response) {
        alert('Atenção! Serão importados apenas os dados de identificação da ação de extensão. Os demais campos deverão ser preenchidos pelo coordenador. Após preenchimento, clicar no botão "concluir importação".');
        _this2.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        var link = response.body.link;
        var idProjetoAux = link.split('/')[5];
        console.log('id:');
        console.log(idProjetoAux);
        _this2.$router.push({ name: 'EditarClassificacao', params: { idProjeto: idProjetoAux } });
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this2.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Importando projeto.' });
      });
    },
    opcoesTabelaEstruturada: function opcoesTabelaEstruturada(codTabela, aqui, atributo) {
      var _this3 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' });
      __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].getOpcoesTabelaEstruturada(codTabela).then(function (response) {
        aqui[atributo] = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this3.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
      });
    }
  }),
  mounted: function mounted() {
    this.opcoesTabelaEstruturada(6002, this, 'listaTipoPublico');
  },
  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_4__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_1__components_app_layouts_app_tooltip_tooltip___default.a,
    'c-date-menu': __WEBPACK_IMPORTED_MODULE_2__components_c_date_menu___default.a,
    'c-textarea': __WEBPACK_IMPORTED_MODULE_3__components_c_textarea___default.a
  }
});

/***/ }),
/* 443 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Importar Projeto'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Registro do projeto no SIEX",
      "required": "",
      "rules": _vm.regrasBasicas,
      "max-height": "400"
    },
    model: {
      value: (_vm.pesquisa.registroSIEX),
      callback: function($$v) {
        _vm.$set(_vm.pesquisa, "registroSIEX", $$v)
      },
      expression: "pesquisa.registroSIEX"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.pesquisarProjetoSIEX
    }
  }, [_vm._v("Pesquisar")])], 1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projetoSIEX && _vm.projetoSIEX.titulo),
      expression: "projetoSIEX && projetoSIEX.titulo"
    }]
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Título",
      "value": this.projetoSIEX.titulo
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Classificação Primária",
      "value": this.projetoSIEX.classificacaoPrimaria.descricao
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Classificação Secundária",
      "value": this.projetoSIEX.classificacaoSecundaria.descricao
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Data de início",
      "value": this.projetoSIEX.dataInicio || '-'
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Data de conclusão",
      "value": this.projetoSIEX.dataConclusao || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Tipo de público-alvo",
      "items": _vm.listaTipoPublico,
      "item-text": "descricao",
      "item-value": "id",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "return-object": "",
      "required": "",
      "autocomplete": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.projetoSIEX.tipoPublico),
      callback: function($$v) {
        _vm.$set(_vm.projetoSIEX, "tipoPublico", $$v)
      },
      expression: "projetoSIEX.tipoPublico"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Público-alvo estimado",
      "mask": "#########",
      "required": "",
      "rules": _vm.regrasBasicas,
      "max-height": "20"
    },
    model: {
      value: (_vm.projetoSIEX.publicoAlvo),
      callback: function($$v) {
        _vm.$set(_vm.projetoSIEX, "publicoAlvo", $$v)
      },
      expression: "projetoSIEX.publicoAlvo"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [(_vm.projetoSIEX.classificacaoSecundaria && (_vm.projetoSIEX.classificacaoSecundaria.id === 39729 || _vm.projetoSIEX.classificacaoSecundaria.id === 44194 || _vm.projetoSIEX.classificacaoSecundaria.id === 44195)) ? _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Carga horária",
      "required": "",
      "rules": _vm.regrasBasicas,
      "max-height": "20"
    },
    model: {
      value: (_vm.projetoSIEX.cargaHoraria),
      callback: function($$v) {
        _vm.$set(_vm.projetoSIEX, "cargaHoraria", $$v)
      },
      expression: "projetoSIEX.cargaHoraria"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Palavra-chave 1",
      "required": "",
      "rules": _vm.regrasBasicas,
      "max-height": "400"
    },
    model: {
      value: (_vm.projetoSIEX.palavraChave01),
      callback: function($$v) {
        _vm.$set(_vm.projetoSIEX, "palavraChave01", $$v)
      },
      expression: "projetoSIEX.palavraChave01"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Palavra-chave 2",
      "required": "",
      "rules": _vm.regrasBasicas,
      "max-height": "400"
    },
    model: {
      value: (_vm.projetoSIEX.palavraChave02),
      callback: function($$v) {
        _vm.$set(_vm.projetoSIEX, "palavraChave02", $$v)
      },
      expression: "projetoSIEX.palavraChave02"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Palavra-chave 3",
      "required": "",
      "rules": _vm.regrasBasicas,
      "max-height": "400"
    },
    model: {
      value: (_vm.projetoSIEX.palavraChave03),
      callback: function($$v) {
        _vm.$set(_vm.projetoSIEX, "palavraChave03", $$v)
      },
      expression: "projetoSIEX.palavraChave03"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Palavra-chave 4",
      "max-height": "400"
    },
    model: {
      value: (_vm.projetoSIEX.palavraChave04),
      callback: function($$v) {
        _vm.$set(_vm.projetoSIEX, "palavraChave04", $$v)
      },
      expression: "projetoSIEX.palavraChave04"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-textarea', {
    attrs: {
      "label": "Resumo",
      "required": "",
      "rules": _vm.resumoRules,
      "rows": 3,
      "auto-grow": true,
      "multi-line": "",
      "counter": "1000"
    },
    model: {
      value: (_vm.projetoSIEX.resumo),
      callback: function($$v) {
        _vm.$set(_vm.projetoSIEX, "resumo", $$v)
      },
      expression: "projetoSIEX.resumo"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": _vm.importarProjetoSIEX
    }
  }, [_vm._v("Importar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(445)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(446),
  /* template */
  __webpack_require__(447),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 445 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_confirm_dialog__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_confirm_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_c_confirm_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      dialogDuplicar: false,
      formularioValido: false,
      dates: __WEBPACK_IMPORTED_MODULE_5__utils_dates__["a" /* default */],
      listaTipoPublico: [],
      tituloAnterior: '',
      duplicacao: {
        titulo: '',
        tipoPublico: {},
        publicoAlvo: undefined,
        dataInicio: undefined,
        dataConclusao: undefined
      },
      pesquisa: {
        numero: undefined
      },
      regrasBasicas: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }],
      tituloRules: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }, function (input) {
        return !!input && input.length <= 150 || 'Este campo não pode possuir mais que 150 caracteres';
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    truncate: function truncate(string, limit) {
      if (string.length > limit) return string.substring(0, limit) + '...';else return string;
    },

    pesquisarProjetoSIEX: function pesquisarProjetoSIEX() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ação.' });
      __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].getDuplicacao(this.pesquisa.numero).then(function (response) {
        _this.duplicacao = response.data;
        _this.tituloAnterior = _this.duplicacao.titulo;
        _this.duplicacao.tipoPublico = undefined;
        _this.duplicacao.publicoAlvo = undefined;
        _this.duplicacao.dataInicio = undefined;
        _this.duplicacao.dataConclusao = undefined;
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ação.' });
      });
    },
    botaoDuplicarAcao: function botaoDuplicarAcao() {
      if (this.duplicacao.titulo === this.tituloAnterior) {
        this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: 'O título da ação duplicada deve ser diferente do título da ação original!' });
        return;
      }
      this.dialogDuplicar = true;
    },
    duplicarAcao: function duplicarAcao() {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Duplicando ação.' });
      __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].postDuplicacao(this.pesquisa.numero, this.duplicacao).then(function (response) {
        _this2.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        var link = response.body.link;
        var idProjetoAux = link.split('/')[5];
        _this2.$router.push({ name: 'ProjetoFormulario', params: { idProjeto: idProjetoAux } });
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this2.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Duplicando ação.' });
      });
    },
    opcoesTabelaEstruturada: function opcoesTabelaEstruturada(codTabela, aqui, atributo) {
      var _this3 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' });
      __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].getOpcoesTabelaEstruturada(codTabela).then(function (response) {
        aqui[atributo] = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this3.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
      });
    }
  }),
  mounted: function mounted() {
    this.opcoesTabelaEstruturada(6002, this, 'listaTipoPublico');
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a,
    'c-date-menu': __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default.a,
    'c-confirm-dialog': __WEBPACK_IMPORTED_MODULE_4__components_c_confirm_dialog___default.a
  }
});

/***/ }),
/* 447 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('c-confirm-dialog', {
    attrs: {
      "titulo": "Duplicar ação?"
    },
    on: {
      "yes": function($event) {
        return _vm.duplicarAcao()
      }
    },
    model: {
      value: (_vm.dialogDuplicar),
      callback: function($$v) {
        _vm.dialogDuplicar = $$v
      },
      expression: "dialogDuplicar"
    }
  }, [_vm._v("\n    A duplicação importa somente parte do conteúdo. Ressaltamos a necessidade de revisão, atualização e complementação das informações da nova ação.\n  ")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Duplicar Ação de Extensão'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Número da ação de extensão a ser duplicada",
      "required": "",
      "rules": _vm.regrasBasicas,
      "max-height": "400"
    },
    model: {
      value: (_vm.pesquisa.numero),
      callback: function($$v) {
        _vm.$set(_vm.pesquisa, "numero", $$v)
      },
      expression: "pesquisa.numero"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.pesquisarProjetoSIEX
    }
  }, [_vm._v("Pesquisar")])], 1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.duplicacao && _vm.duplicacao.titulo),
      expression: "duplicacao && duplicacao.titulo"
    }]
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Título (atualizar o título da ação para que a duplicação seja realizada)",
      "required": "",
      "rules": _vm.tituloRules,
      "max-height": "400",
      "counter": "150"
    },
    model: {
      value: (_vm.duplicacao.titulo),
      callback: function($$v) {
        _vm.$set(_vm.duplicacao, "titulo", $$v)
      },
      expression: "duplicacao.titulo"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Tipo de público-alvo",
      "items": _vm.listaTipoPublico,
      "item-text": "descricao",
      "item-value": "item",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "return-object": "",
      "required": "",
      "autocomplete": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.duplicacao.tipoPublico),
      callback: function($$v) {
        _vm.$set(_vm.duplicacao, "tipoPublico", $$v)
      },
      expression: "duplicacao.tipoPublico"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Público-alvo estimado",
      "mask": "#########",
      "required": "",
      "rules": _vm.regrasBasicas,
      "max-height": "20"
    },
    model: {
      value: (_vm.duplicacao.publicoAlvo),
      callback: function($$v) {
        _vm.$set(_vm.duplicacao, "publicoAlvo", $$v)
      },
      expression: "duplicacao.publicoAlvo"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-date-menu', {
    attrs: {
      "label": "Data de início",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.duplicacao.dataInicio),
      callback: function($$v) {
        _vm.$set(_vm.duplicacao, "dataInicio", $$v)
      },
      expression: "duplicacao.dataInicio"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-date-menu', {
    attrs: {
      "label": "Data de conclusão",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.duplicacao.dataConclusao),
      callback: function($$v) {
        _vm.$set(_vm.duplicacao, "dataConclusao", $$v)
      },
      expression: "duplicacao.dataConclusao"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  })], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": _vm.botaoDuplicarAcao
    }
  }, [_vm._v("Duplicar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(449)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(450),
  /* template */
  __webpack_require__(459),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9e7561fe",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 449 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_card_footer__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_card_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_c_card_footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_confirm_dialog_alunos__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_confirm_dialog_alunos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_confirm_dialog_alunos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_readonly_field__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_readonly_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_readonly_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto', 'projeto', 'extensao'],
  data: function data() {
    return {
      dates: __WEBPACK_IMPORTED_MODULE_5__utils_dates__["a" /* default */],
      dialogAusenciaAlunos: false,
      formularioValido: false,
      observacoesRules: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }, function (input) {
        return !!input && input.length <= 60 || 'Este campo não pode possuir mais que 60 caracteres';
      }]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])('auth', ['administrador', 'usuarioPROEX'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    permissaoEditar: function permissaoEditar(situacaoAcaoExtensao) {
      // Coordenador ou assessor
      if ((this.usuarioCoordenador() || this.usuarioAssessor()) && situacaoAcaoExtensao === 15) {
        return true;
      } else if (this.usuarioAdministrador() && [3, 4, 15, 16, 18, 19, 20, 22].includes(situacaoAcaoExtensao)) {
        // Administrador - inclusao da situacao 'Inadimplente' (3)
        return true;
      } else {
        return false;
      }
    },
    // Verifica se a ação de extensão está na situação "Ativo".
    situacaoAtivo: function situacaoAtivo() {
      if (this.projeto.situacao.item === 18) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se a ação de extensão está na situação "Aguardando relatório".
    situacaoAguardandoRelatorio: function situacaoAguardandoRelatorio() {
      if (this.projeto.situacao.item === 20) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se o usuário logado é o coordenador da ação de extensão.
    usuarioCoordenador: function usuarioCoordenador() {
      if (this.projeto.funcao != null && this.projeto.funcao.item === 1) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se o usuário logado é assessor da ação de extensão.
    usuarioAssessor: function usuarioAssessor() {
      if (this.projeto.assessor === true) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se o usuário logado é administrador.
    usuarioAdministrador: function usuarioAdministrador() {
      if (this.administrador === true) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se a ação de extensão possui alunos de graduação ou pós-graduação cadastrados.
    acaoExtensaoNaoPossuiAlunosCadastrados: function acaoExtensaoNaoPossuiAlunosCadastrados() {
      if (this.projeto.possuiAlunos === false) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se a ação deve ser redirecionada para a aba EQUIPE.
    verificaSeAcaoDeveSerRedirecionadaParaAbaEquipe: function verificaSeAcaoDeveSerRedirecionadaParaAbaEquipe() {
      if (this.situacaoAtivo() || this.situacaoAguardandoRelatorio()) {
        if (this.usuarioCoordenador() || this.usuarioAssessor()) {
          if (this.acaoExtensaoNaoPossuiAlunosCadastrados()) {
            return true;
          }
        }
      } else {
        return false;
      }
    },
    // Redireciona para a aba EQUIPE.
    redirecionaAbaEquipe: function redirecionaAbaEquipe() {
      this.$router.push({ name: 'IntegrantesProjeto', params: { idProjeto: this.idProjeto } });
    }
  }),
  mounted: function mounted() {
    if (this.verificaSeAcaoDeveSerRedirecionadaParaAbaEquipe() && this.projeto.idProjeto !== 2785) {
      // Tarefa #13468.
      this.dialogAusenciaAlunos = true;
    }
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_4__components_toolbars_basic_toolbar___default.a,
    'c-confirm-dialog-alunos': __WEBPACK_IMPORTED_MODULE_2__components_c_confirm_dialog_alunos___default.a,
    'c-card-footer': __WEBPACK_IMPORTED_MODULE_1__components_c_card_footer___default.a,
    'c-readonly-field': __WEBPACK_IMPORTED_MODULE_3__components_c_readonly_field___default.a
  }
});

/***/ }),
/* 451 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_confirm_dialog__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_confirm_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_c_confirm_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['projeto', 'extensao', 'proxima', 'editar', 'nome_editar', 'habilitaBotaoGerarPDFAcao', 'habilitaBotaoFinalizarAcao'],
  data: function data() {
    return {
      api_url: "https://pib-api.prod.uks.ufes.br",
      dialogSubmeterAprovacao: false,
      dialogSubmeterAprovacaoAcaoRegistroTardio: false,
      dialogConcluirImportacao: false,
      dialogExclusao: false,
      dialogFinalizar: false,
      data: '',
      dataFormatada: '',
      menuData: false
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('auth', ['administrador', 'usuarioPROEX'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    botaoSubmeterAprovacao: function botaoSubmeterAprovacao() {
      if (this.projeto.registroTardio === true) {
        this.dialogSubmeterAprovacaoAcaoRegistroTardio = true;
      } else {
        this.dialogSubmeterAprovacao = true;
      }
    },
    submeterAprovacao: function submeterAprovacao() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Submetendo Ação.' });
      __WEBPACK_IMPORTED_MODULE_2__utils_projetos__["a" /* default */].postSubmissaoAprovacao(this.projeto.idProjeto).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        if (_this.relatorioHabilitadoAcaoRegistroTardio() === false) {
          _this.$router.push({ name: 'ProjetoFormulario', params: { idProjeto: _this.projeto.idProjeto } });
        } else {
          _this.$router.push({ name: 'RelatoriosProjeto', params: { idProjeto: _this.projeto.idProjeto } });
        }
        window.location.reload();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Submetendo Ação.' });
      });
    },
    botaoConcluirImportacao: function botaoConcluirImportacao() {
      this.dialogConcluirImportacao = true;
    },
    // Verifica se o preenchimento do relatório final está habilitado para ações de extensão com registro tardio.
    relatorioHabilitadoAcaoRegistroTardio: function relatorioHabilitadoAcaoRegistroTardio() {
      if (this.projeto.relatorioFinalHabilitado === true) {
        return true;
      } else {
        return false;
      }
    },
    concluirImportacao: function concluirImportacao() {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Concluindo importação...' });
      __WEBPACK_IMPORTED_MODULE_2__utils_projetos__["a" /* default */].postConcluirImportacao(this.projeto.idProjeto).then(function (response) {
        _this2.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this2.$router.push({ name: 'ProjetoFormulario', params: { idProjeto: _this2.projeto.idProjeto } });
        window.location.reload();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this2.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Concluindo importação...' });
      });
    },
    botaoFinalizarAcao: function botaoFinalizarAcao() {
      this.$router.push({ name: 'FinalizarAcao', params: { idProjeto: this.projeto.idProjeto } });
    },
    botaoExcluirAcao: function botaoExcluirAcao() {
      this.dialogExclusao = true;
    },
    excluirAcao: function excluirAcao() {
      var _this3 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo ação...' });
      __WEBPACK_IMPORTED_MODULE_2__utils_projetos__["a" /* default */].deleteProjeto(this.projeto.idProjeto).then(function (response) {
        _this3.$router.push({ name: 'MeusProjetos' });
        _this3.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this3.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this3.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo ação...' });
      });
    },
    toRelatorio: function toRelatorio() {
      this.$router.push({ name: 'Relatorio', params: { idProjeto: this.projeto.idProjeto } });
    },
    toEditar: function toEditar() {
      this.$router.push({ name: this.editar, params: { idProjeto: this.projeto.idProjeto } });
    },
    toAvancar: function toAvancar() {
      this.$router.push({ name: this.proxima, params: { idProjeto: this.projeto.idProjeto } });
    }
  }),
  components: {
    'c-confirm-dialog': __WEBPACK_IMPORTED_MODULE_1__components_c_confirm_dialog___default.a
  }
});

/***/ }),
/* 453 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('c-confirm-dialog', {
    attrs: {
      "titulo": "Submeter a ação para aprovação?"
    },
    on: {
      "yes": function($event) {
        return _vm.submeterAprovacao()
      }
    },
    model: {
      value: (_vm.dialogSubmeterAprovacao),
      callback: function($$v) {
        _vm.dialogSubmeterAprovacao = $$v
      },
      expression: "dialogSubmeterAprovacao"
    }
  }, [_vm._v("\n    O cadastro da ação nesta plataforma não garante o registro! É necessário autuar um processo digital (com PDF da ação em anexo) na secretaria do setor de lotação do coordenador e aguardar deliberação da Câmara de Extensão. Maiores informações entre em contato através do e-mail suporte.proex@ufes.br\n  ")]), _vm._v(" "), _c('c-confirm-dialog', {
    attrs: {
      "titulo": "Submeter a ação e o relatório para aprovação?"
    },
    on: {
      "yes": function($event) {
        return _vm.submeterAprovacao()
      }
    },
    model: {
      value: (_vm.dialogSubmeterAprovacaoAcaoRegistroTardio),
      callback: function($$v) {
        _vm.dialogSubmeterAprovacaoAcaoRegistroTardio = $$v
      },
      expression: "dialogSubmeterAprovacaoAcaoRegistroTardio"
    }
  }, [_vm._v("\n    O cadastro da ação e o preenchimento do relatório nesta plataforma não garantem o registro! É necessário autuar um processo digital contendo o PDF da ação, o PDF do relatório e a documentação comprobatória na secretaria do setor de lotação do coordenador e aguardar deliberação da Câmara de Extensão. Maiores informações entre em contato através do e-mail suporte.proex@ufes.br\n  ")]), _vm._v(" "), _c('c-confirm-dialog', {
    attrs: {
      "titulo": "Concluir importação?"
    },
    on: {
      "yes": function($event) {
        return _vm.concluirImportacao()
      }
    },
    model: {
      value: (_vm.dialogConcluirImportacao),
      callback: function($$v) {
        _vm.dialogConcluirImportacao = $$v
      },
      expression: "dialogConcluirImportacao"
    }
  }, [_vm._v("\n    Depois que a importação for concluída a ação de extensão importada do SIEX passará para a situação \"Ativa\" no novo portal de projetos.\n  ")]), _vm._v(" "), _c('c-confirm-dialog', {
    attrs: {
      "titulo": "Deseja realmente excluir a ação?"
    },
    on: {
      "yes": function($event) {
        return _vm.excluirAcao()
      }
    },
    model: {
      value: (_vm.dialogExclusao),
      callback: function($$v) {
        _vm.dialogExclusao = $$v
      },
      expression: "dialogExclusao"
    }
  }, [_vm._v("\n    Essa ação será excluída após clicar na opção \"Sim\".\n  ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.administrador === true || _vm.projeto.assessor === true || (_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1)) ? _c('v-card-actions', [(_vm.projeto.situacao.item === 15 && (_vm.projeto.registroTardio === false || _vm.projeto.registroTardio === true && _vm.projeto.relatorioFinalHabilitado === true) && !_vm.extensao.registroSIEX) ? _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "disabled": _vm.administrador === false && _vm.projeto.assessor === true,
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.botaoSubmeterAprovacao()
      }
    }
  }, [_vm._v("Submeter para aprovação")]) : _vm._e(), _vm._v(" "), (_vm.projeto.situacao.item === 15 && _vm.extensao.registroSIEX) ? _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "disabled": _vm.administrador === false && _vm.projeto.assessor === true,
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.botaoConcluirImportacao()
      }
    }
  }, [_vm._v("Concluir Importação")]) : _vm._e(), _vm._v(" "), (_vm.projeto.situacao.item === 16 && !_vm.extensao.registroSIEX) ? _c('v-tooltip', {
    attrs: {
      "top": ""
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "slot": "activator",
      "disabled": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.botaoSubmeterAprovacao()
      }
    },
    slot: "activator"
  }, [_vm._v("Submeter para aprovação")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "button"
    },
    slot: "button"
  }), _vm._v(" "), _c('span', [_vm._v("Essa ação já foi submetida para aprovação!")])], 1) : _vm._e(), _vm._v(" "), (_vm.projeto.situacao.item === 15 && _vm.projeto.registroTardio === true && _vm.projeto.relatorioFinalHabilitado === false) ? _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('div', _vm._g({
          staticStyle: {
            "float": "left"
          }
        }, on), [_c('v-btn', {
          staticClass: "text-xs-right, botaoSubmeterAprovacaoDesabilitado",
          attrs: {
            "disabled": "",
            "color": "primary"
          }
        }, [_vm._v("Submeter para aprovação")])], 1)]
      }
    }], null, false, 3586984127)
  }, [_vm._v(" "), _c('span', [_vm._v("O administrador (PROEX) precisa primeiramente liberar o preenchimento do relatório técnico final!")])]) : _vm._e(), _vm._v(" "), (_vm.projeto.situacao.item === 16 && _vm.extensao.registroSIEX) ? _c('v-tooltip', {
    attrs: {
      "top": ""
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "slot": "activator",
      "disabled": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.botaoConcluirImportacao()
      }
    },
    slot: "activator"
  }, [_vm._v("Concluir Importação")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "button"
    },
    slot: "button"
  }), _vm._v(" "), _c('span', [_vm._v("A importação já foi submetida!")])], 1) : _vm._e(), _vm._v(" "), (_vm.habilitaBotaoFinalizarAcao === true && _vm.projeto.situacao.item === 18) ? _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "disabled": _vm.administrador === false && _vm.projeto.assessor === true,
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.botaoFinalizarAcao()
      }
    }
  }, [_vm._v("Finalizar Ação")]) : _vm._e(), _vm._v(" "), (_vm.habilitaBotaoGerarPDFAcao === true && _vm.projeto.situacao.item !== 15) ? _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.toRelatorio
    }
  }, [_vm._v("Gerar PDF da Ação")]) : _vm._e(), _vm._v(" "), ((_vm.administrador === true && (_vm.projeto.situacao.item === 15 || _vm.projeto.situacao.item === 16)) || ((_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1 || _vm.projeto.assessor === true) && _vm.projeto.situacao.item === 15)) ? _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "disabled": _vm.administrador === false && _vm.projeto.assessor === true,
      "color": "red lighten-1 white--text"
    },
    on: {
      "click": function($event) {
        return _vm.botaoExcluirAcao()
      }
    }
  }, [_vm._v("Excluir ação")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _vm._t("default"), _vm._v(" "), (_vm.editar != null) ? _c('div', [(_vm.administrador === true || _vm.projeto.situacao.item !== 16) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.toEditar
    }
  }, [_vm._v(_vm._s(this.nome_editar == null ? 'Editar' : this.nome_editar))]) : _vm._e(), _vm._v(" "), (_vm.administrador !== true && _vm.projeto.situacao.item === 16) ? _c('v-tooltip', {
    attrs: {
      "top": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "disabled": "",
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.toEditar
    },
    slot: "activator"
  }, [_vm._v(_vm._s(this.nome_editar == null ? 'Editar' : this.nome_editar))]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "button"
    },
    slot: "button"
  }), _vm._v(" "), _c('span', [_vm._v("Não é possível editar uma ação aguardando aprovação!")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.proxima != null) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.toAvancar
    }
  }, [_vm._v("Avançar")]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.habilitaBotaoGerarPDFAcao === true && _vm.administrador === false && (_vm.projeto.funcao == null || _vm.projeto.funcao.item !== 1) && _vm.projeto.assessor === false) ? _c('v-card-actions', [(_vm.usuarioPROEX === true && _vm.projeto.situacao.item !== 15 && _vm.projeto.situacao.item !== 16) ? _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.toRelatorio
    }
  }, [_vm._v("Gerar PDF da Ação")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.proxima != null) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.toAvancar
    }
  }, [_vm._v("Avançar")]) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(455),
  /* template */
  __webpack_require__(456),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['value', 'titulo'],
  data: function data() {
    return {
      show: false
    };
  },
  watch: {
    value: function value(val) {
      this.show = val;
    }
  },
  methods: {
    setShow: function setShow(val) {
      this.$emit('input', val);
    },
    clicouOK: function clicouOK() {
      this.setShow(false);
      this.$emit('yes');
    }
  }
});

/***/ }),
/* 456 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "750"
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v(_vm._s(_vm.titulo))]), _vm._v(" "), _c('v-card-text', {
    staticClass: "title",
    staticStyle: {
      "word-break": "break-word",
      "margin-top": "10px"
    },
    attrs: {
      "align": "justify"
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.clicouOK()
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['label', 'value', 'align', 'required']
});

/***/ }),
/* 458 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticClass: "gray--text"
  }, [_vm._v(_vm._s(_vm.label) + _vm._s(this.required !== undefined ? '*' : ''))]), _vm._v(" "), _c('p', {
    staticClass: "black--text body-1",
    attrs: {
      "align": _vm.align
    }
  }, [_vm._v(_vm._s(_vm.value))])])
},staticRenderFns: []}

/***/ }),
/* 459 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "lg8": ""
    }
  }, [_c('c-confirm-dialog-alunos', {
    attrs: {
      "titulo": "Ausência de alunos de graduação e/ou pós-graduação na equipe"
    },
    on: {
      "yes": function($event) {
        return _vm.redirecionaAbaEquipe()
      }
    },
    model: {
      value: (_vm.dialogAusenciaAlunos),
      callback: function($$v) {
        _vm.dialogAusenciaAlunos = $$v
      },
      expression: "dialogAusenciaAlunos"
    }
  }, [_vm._v("\n        A ação de extensão ainda não possui estudantes de graduação e/ou pós-graduação cadastrados, o que é necessário para que a ação possa ser atualizada no sistema. Realize o cadastro na aba EQUIPE.\n      ")]), _vm._v(" "), ((this.administrador === true || this.usuarioPROEX === true) && this.projeto.suspensoes === true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    staticClass: "alertaSuspensao",
    attrs: {
      "dense": "",
      "type": "info",
      "color": "#00796b",
      "outlined": ""
    }
  }, [_vm._v("\n            Esta ação possui períodos de suspensão cadastrados, para maiores detalhes verificar a aba EXTENSÃO.\n          ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Título",
      "value": this.projeto.titulo
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Número",
      "value": this.projeto.idProjeto
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Situação",
      "value": this.projeto.situacao.descricao
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Tipo de público-alvo",
      "value": this.projeto.tipoPublico.descricao
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Público-alvo estimado",
      "value": this.projeto.publicoAlvo || ' '
    }
  })], 1)], 1), _vm._v(" "), (_vm.projeto.classificacaoSecundaria.id === 39729) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Carga horária do curso",
      "value": this.projeto.cargaHoraria || ' '
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.projeto.classificacaoSecundaria.id === 44194) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Carga horária do curso",
      "value": this.projeto.cargaHoraria || ' '
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.projeto.classificacaoSecundaria.id === 44195) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Carga horária da oficina",
      "value": this.projeto.cargaHoraria || ' '
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.projeto.classificacaoSecundaria.id === 39730) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Carga horária do evento",
      "value": this.projeto.cargaHoraria || ' '
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Data de início",
      "value": this.projeto.dataInicio
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Data de conclusão",
      "value": this.projeto.dataConclusao
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Palavra-chave 1",
      "value": this.projeto.palavraChave01 || ' '
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Palavra-chave 2",
      "value": this.projeto.palavraChave02 || ' '
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Palavra-chave 3",
      "value": this.projeto.palavraChave03 || ' '
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Palavra-chave 4",
      "value": this.projeto.palavraChave04 || ' '
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Resumo",
      "value": this.projeto.resumo,
      "align": "justify"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('c-card-footer', {
    attrs: {
      "projeto": this.projeto,
      "extensao": this.extensao,
      "proxima": "ClassificacoesProjeto",
      "editar": this.permissaoEditar(this.projeto.situacao.item) ? 'EditarInformacoes' : null,
      "nome_editar": "Editar",
      "habilitaBotaoGerarPDFAcao": true,
      "habilitaBotaoFinalizarAcao": true
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(461)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(462),
  /* template */
  __webpack_require__(463),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 461 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_card_footer__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_card_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_c_card_footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto', 'projeto', 'extensao'],
  data: function data() {
    return {
      listaClassificacoes: [],
      dates: __WEBPACK_IMPORTED_MODULE_3__utils_dates__["a" /* default */],
      search: null,
      sortBy: 'funcao.descricao',
      sortDesc: false,
      itemsPerPage: 25,
      opcoesPaginacao: [10, 25, 50, { text: 'Todas', value: -1 }],
      headers: [{ text: 'Tipo', align: 'left', width: '50%', value: 'tipoClassificacao' }, { text: 'Classificação', align: 'left', width: '50%', value: 'descricao' }]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])('auth', ['administrador', 'usuarioPROEX'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING']), {
    truncate: function truncate(string, limit) {
      if (string.length > limit) return string.substring(0, limit) + '...';else return string;
    }
  }),
  mounted: function mounted() {
    var _this = this;

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando classificações.' });
    __WEBPACK_IMPORTED_MODULE_4__utils_projetos__["a" /* default */].getClassificacoesDoProjeto(this.idProjeto).then(function (response) {
      /* Ticket #315808 - Resolução CEPE/UFES nº 127/2025  */
      _this.listaClassificacoes = response.data.filter(function (c) {
        return c.classificacaoItem !== 125;
      });
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando classificações.' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar___default.a,
    'c-card-footer': __WEBPACK_IMPORTED_MODULE_1__components_c_card_footer___default.a
  }
});

/***/ }),
/* 463 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaClassificacoes,
      "search": _vm.search,
      "no-data-text": 'Este projeto não possui classificações.',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n      Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaClassificacoes.length) + " classificações\n    ")]
      }
    }])
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('c-card-footer', {
    attrs: {
      "projeto": this.projeto,
      "extensao": this.extensao,
      "proxima": "ExtensaoProjeto",
      "editar": "EditarClassificacao",
      "nome_editar": "Editar",
      "habilitaBotaoGerarPDFAcao": true,
      "habilitaBotaoFinalizarAcao": true
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(465)
  __webpack_require__(466)
  __webpack_require__(467)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(468),
  /* template */
  __webpack_require__(469),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3219b534",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 465 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 466 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 467 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_card_footer__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_card_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_c_card_footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_readonly_field__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_readonly_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_readonly_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto', 'projeto', 'extensao'],
  data: function data() {
    return {
      dates: __WEBPACK_IMPORTED_MODULE_5__utils_dates__["a" /* default */],
      listaSuspensoes: [],
      listaRegistroRelatoriosEnviados: [],
      headersSuspensoes: [{ text: 'Início', align: 'left', value: 'dtInicioSuspensao' }, { text: 'Fim', align: 'left', value: 'dtFimSuspensao' }, { text: 'Processo', left: 'left', value: 'processo' }],
      headersRegistroRelatoriosEnviados: [{ text: 'Data de envio', align: 'left', value: 'dtEnvio' }, { text: 'Número do relatório', align: 'left', value: 'numRelatorio' }],
      objetivosEspecificosTopicos: [],
      listaTiposPrestacaoServicoSelecionados: [],
      listaTiposPrestacaoServico: ['Atendimento ao público em espaços de cultura, ciência e tecnologia', 'Serviço eventual', 'Atividades de propriedade intelectual', 'Exames e laudos técnicos', 'Atendimento jurídico', 'Atendimento em saúde humana', 'Atendimento em saúde animal'],
      listaAtendimentoPublicoEspacosSelecionados: [],
      prazo: 30,
      extensaoe: {}
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])('auth', ['administrador', 'usuarioPROEX'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING'])),
  mounted: function mounted() {
    var _this = this;

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações.' });
    __WEBPACK_IMPORTED_MODULE_4__utils_projetos__["a" /* default */].getExtensaoDoProjeto(this.idProjeto).then(function (response) {
      _this.extensaoe = response.data;
      var aux = _this.extensaoe.objetivosEspecificos.split(';;');
      for (var item in aux) {
        _this.objetivosEspecificosTopicos.push({ id: item, nome: aux[item] });
      }

      // Tipo de Prestação de Serviço (Atendimento ao público em espaços de cultura, ciência e tecnologia)
      if (_this.extensaoe.atendimentoPublicoEspacos === 'S') {
        _this.listaTiposPrestacaoServicoSelecionados.push('Atendimento ao público em espaços de cultura, ciência e tecnologia');
      }

      // Tipo de Prestação de Serviço (Serviço eventual)
      if (_this.extensaoe.servicoEventual === 'S') {
        _this.listaTiposPrestacaoServicoSelecionados.push('Serviço eventual');
      }

      // Tipo de Prestação de Serviço (Atividades de propriedade intelectual)
      if (_this.extensaoe.atividadesPropriedadeIntelectual === 'S') {
        _this.listaTiposPrestacaoServicoSelecionados.push('Atividades de propriedade intelectual');
      }

      // Tipo de Prestação de Serviço (Exames e laudos técnicos)
      if (_this.extensaoe.examesLaudosTecnicos === 'S') {
        _this.listaTiposPrestacaoServicoSelecionados.push('Exames e laudos técnicos');
      }

      // Tipo de Prestação de Serviço (Atendimento jurídico)
      if (_this.extensaoe.atendimentoJuridico === 'S') {
        _this.listaTiposPrestacaoServicoSelecionados.push('Atendimento jurídico');
      }

      // Tipo de Prestação de Serviço (Atendimento em saúde humana)
      if (_this.extensaoe.atendimentoSaudeHumana === 'S') {
        _this.listaTiposPrestacaoServicoSelecionados.push('Atendimento em saúde humana');
      }

      // Tipo de Prestação de Serviço (Atendimento em saúde animal)
      if (_this.extensaoe.atendimentoSaudeAnimal === 'S') {
        _this.listaTiposPrestacaoServicoSelecionados.push('Atendimento em saúde animal');
      }

      // Atendimento ao público em espaços de cultura, ciência e tecnologia (Espaços e Museus Culturais)
      if (_this.extensaoe.espacosMuseusCulturais === 'S') {
        _this.listaAtendimentoPublicoEspacosSelecionados.push('Espaços e Museus Culturais');
      }

      // Atendimento ao público em espaços de cultura, ciência e tecnologia (Espaços e Museus de Ciência e Tecnologia)
      if (_this.extensaoe.espacosMuseusCT === 'S') {
        _this.listaAtendimentoPublicoEspacosSelecionados.push('Espaços e Museus de Ciência e Tecnologia');
      }

      // Atendimento ao público em espaços de cultura, ciência e tecnologia (Cines-clube)
      if (_this.extensaoe.cinesClube === 'S') {
        _this.listaAtendimentoPublicoEspacosSelecionados.push('Cines-clube');
      }

      // Atendimento ao público em espaços de cultura, ciência e tecnologia (Outros)
      if (_this.extensaoe.outrosEspacos === 'S') {
        _this.listaAtendimentoPublicoEspacosSelecionados.push('Outros');
      }
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações.' });
    });

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações adicionais.' });
    __WEBPACK_IMPORTED_MODULE_4__utils_projetos__["a" /* default */].getPrazoDias(this.idProjeto).then(function (response) {
      _this.prazo = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações adicionais.' });
    });

    // Carrega as suspensões de uma ação de extensão.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando suspensões...' });
    __WEBPACK_IMPORTED_MODULE_4__utils_projetos__["a" /* default */].getSuspensoes(this.idProjeto).then(function (response) {
      _this.listaSuspensoes = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando suspensões...' });
    });

    // Carrega os registros de envio de relatórios
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando registros de envios de relatórios...' });
    __WEBPACK_IMPORTED_MODULE_4__utils_projetos__["a" /* default */].getRegistrosDeEnvioDeRelatorioDeProjeto(this.idProjeto).then(function (response) {
      _this.listaRegistroRelatoriosEnviados = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando registros de envios de relatórios...' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_3__components_toolbars_basic_toolbar___default.a,
    'c-card-footer': __WEBPACK_IMPORTED_MODULE_1__components_c_card_footer___default.a,
    'c-readonly-field': __WEBPACK_IMPORTED_MODULE_2__components_c_readonly_field___default.a
  }
});

/***/ }),
/* 469 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "lg8": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Unidade",
      "value": _vm.extensaoe.unidade ? (_vm.extensaoe.unidade.nome + (_vm.extensaoe.unidade.siglaUnidade == null ? '' : ' - ' + _vm.extensao.unidade.siglaUnidade)) : '-'
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Órgão competente pela aprovação",
      "value": _vm.extensaoe.orgaoCompetente ? _vm.extensaoe.orgaoCompetente : '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Coordenado por",
      "value": _vm.extensaoe.coordenadoPor ? _vm.extensaoe.coordenadoPor.descricao : '-'
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Data da primeira apresentação",
      "value": _vm.extensaoe.dtPrimeiraApresentacao ? _vm.dates.format(_vm.extensaoe.dtPrimeiraApresentacao) || '-' : '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Data da última revisão",
      "value": _vm.extensaoe.dtRevisao ? _vm.dates.format(_vm.extensaoe.dtRevisao) || '-' : '-'
    }
  })], 1)], 1), _vm._v(" "), (_vm.projeto.situacao.item === 17) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Data de inabilitação pela Câmara de Extensão",
      "value": _vm.extensaoe.dtInabilitacao ? _vm.dates.format(_vm.extensaoe.dtInabilitacao) || '-' : '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensaoe.evento) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Tipo de Evento",
      "value": _vm.extensaoe.tipoEvento ? _vm.extensaoe.tipoEvento.descricao : '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.projeto.classificacaoSecundaria.id === 39733) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "O programa é uma Empresa Júnior?",
      "value": _vm.extensaoe.empresaJunior != null ? (_vm.extensaoe.empresaJunior ? 'Sim' : 'Não') : '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.projeto.classificacaoSecundaria.id === 39733) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    staticClass: "alerta",
    attrs: {
      "color": "#00796b",
      "type": "info",
      "dense": "",
      "outlined": ""
    }
  }, [_vm._v("\n            Conforme os Artigos 03, 06 e 10 da Resolução nº.10/2019 do Conselho Universitário, as empresas juniores deverão ser cadastradas na Pró-Reitoria de Extensão – PROEX como Programa de Extensão.\n          ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Apresentação",
      "value": this.extensaoe.apresentacao || '-',
      "align": "justify"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Justificativa / Mérito extensionista",
      "value": this.extensaoe.justificativa || '-',
      "align": "justify"
    }
  })], 1)], 1), _vm._v(" "), (this.extensaoe.caracterizacaoPublicoAlvo) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Caracterização do público-alvo",
      "value": this.extensaoe.caracterizacaoPublicoAlvo || '-',
      "align": "justify"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!this.extensaoe.caracterizacaoPublicoAlvo) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    staticClass: "publicoAlvo",
    attrs: {
      "xs12": ""
    }
  }, [_c('label', [_vm._v("Caracterização do público-alvo")])])], 1) : _vm._e(), _vm._v(" "), (!this.extensaoe.caracterizacaoPublicoAlvo && _vm.projeto.tipoPublico.item === 1) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "• Interno:",
      "value": this.extensaoe.publicoAlvoInterno || '-',
      "align": "justify"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!this.extensaoe.caracterizacaoPublicoAlvo) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "• Externo:",
      "value": this.extensaoe.publicoAlvoExterno || '-',
      "align": "justify"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Objetivo geral",
      "value": this.extensaoe.objetivosGerais || '-',
      "align": "justify"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "labelObjetivosEspecificos"
  }, [_vm._v("Objetivos específicos")]), _vm._v(" "), _c('v-list', {
    staticClass: "listObjetivosEspecificos"
  }, _vm._l((_vm.objetivosEspecificosTopicos), function(item, index) {
    return _c('v-list-item', {
      key: item.id,
      staticStyle: {
        "padding": "0px"
      }
    }, [_c('v-list-item-content', {
      attrs: {
        "align": "justify"
      }
    }, [_vm._v("\n                " + _vm._s(index + 1) + ". " + _vm._s(item.nome) + "\n              ")]), _vm._v(" "), _c('p', {
      staticClass: "mt-3"
    })], 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Metodologia",
      "value": this.extensaoe.metodologia || '-',
      "align": "justify"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.extensaoe.curso || _vm.extensaoe.oficina) ? _c('c-readonly-field', {
    attrs: {
      "label": "Formas de avaliação dos cursistas",
      "value": this.extensaoe.formaAvaliacao || '-',
      "align": "justify"
    }
  }) : _c('c-readonly-field', {
    attrs: {
      "label": "Forma de avaliação",
      "value": this.extensaoe.formaAvaliacao || '-',
      "align": "justify"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Infraestrutura física",
      "value": this.extensaoe.infraestruturaFisica || '-',
      "align": "justify"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Informações adicionais",
      "value": this.extensaoe.informacoesAdicionais || '-',
      "align": "justify"
    }
  })], 1)], 1), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.length === 0) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Tipo de Prestação de Serviço",
      "value": '-',
      "align": "justify"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.length !== 0) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.listaTiposPrestacaoServico,
      "chips": "",
      "multiple": "",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticStyle: {
            "font-size": "1.2em"
          }
        }, [_vm._v("Tipo de Prestação de Serviço")])]
      },
      proxy: true
    }], null, false, 4110279761),
    model: {
      value: (_vm.listaTiposPrestacaoServicoSelecionados),
      callback: function($$v) {
        _vm.listaTiposPrestacaoServicoSelecionados = $$v
      },
      expression: "listaTiposPrestacaoServicoSelecionados"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento ao público em espaços de cultura, ciência e tecnologia')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "tipoPrestacaoServico"
  }, [_vm._v("Tipo: Atendimento ao público em espaços de cultura, ciência e tecnologia")]), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "value": "Espaços e Museus Culturais",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("Espaços e Museus Culturais")])]
      },
      proxy: true
    }], null, false, 1352582964),
    model: {
      value: (_vm.listaAtendimentoPublicoEspacosSelecionados),
      callback: function($$v) {
        _vm.listaAtendimentoPublicoEspacosSelecionados = $$v
      },
      expression: "listaAtendimentoPublicoEspacosSelecionados"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento ao público em espaços de cultura, ciência e tecnologia')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "value": "Espaços e Museus de Ciência e Tecnologia",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("Espaços e Museus de Ciência e Tecnologia")])]
      },
      proxy: true
    }], null, false, 820644792),
    model: {
      value: (_vm.listaAtendimentoPublicoEspacosSelecionados),
      callback: function($$v) {
        _vm.listaAtendimentoPublicoEspacosSelecionados = $$v
      },
      expression: "listaAtendimentoPublicoEspacosSelecionados"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento ao público em espaços de cultura, ciência e tecnologia')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "value": "Cines-clube",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("Cines-clube")])]
      },
      proxy: true
    }], null, false, 2587689909),
    model: {
      value: (_vm.listaAtendimentoPublicoEspacosSelecionados),
      callback: function($$v) {
        _vm.listaAtendimentoPublicoEspacosSelecionados = $$v
      },
      expression: "listaAtendimentoPublicoEspacosSelecionados"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento ao público em espaços de cultura, ciência e tecnologia')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "value": "Outros",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("Outros")])]
      },
      proxy: true
    }], null, false, 900719639),
    model: {
      value: (_vm.listaAtendimentoPublicoEspacosSelecionados),
      callback: function($$v) {
        _vm.listaAtendimentoPublicoEspacosSelecionados = $$v
      },
      expression: "listaAtendimentoPublicoEspacosSelecionados"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Serviço eventual')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('p', {
    staticClass: "tipoPrestacaoServico"
  }, [_vm._v("Tipo: Serviço eventual")]), _vm._v(" "), _c('c-readonly-field', {
    attrs: {
      "label": "Nº de assessorias",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.extensaoe.numAssessorias),
      callback: function($$v) {
        _vm.$set(this.extensaoe, "numAssessorias", $$v)
      },
      expression: "this.extensaoe.numAssessorias"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Serviço eventual')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Nº de consultorias",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.extensaoe.numConsultorias),
      callback: function($$v) {
        _vm.$set(this.extensaoe, "numConsultorias", $$v)
      },
      expression: "this.extensaoe.numConsultorias"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Serviço eventual')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Nº de curadorias",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.extensaoe.numCuradorias),
      callback: function($$v) {
        _vm.$set(this.extensaoe, "numCuradorias", $$v)
      },
      expression: "this.extensaoe.numCuradorias"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Serviço eventual')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Nº de outros",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.extensaoe.numOutrosServicos),
      callback: function($$v) {
        _vm.$set(this.extensaoe, "numOutrosServicos", $$v)
      },
      expression: "this.extensaoe.numOutrosServicos"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atividades de propriedade intelectual')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('p', {
    staticClass: "tipoPrestacaoServico"
  }, [_vm._v("Tipo: Atividades de propriedade intelectual")]), _vm._v(" "), _c('c-readonly-field', {
    attrs: {
      "label": "Nº de depósito de patentes e modelos de utilidades",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.extensaoe.numPatentesModelos),
      callback: function($$v) {
        _vm.$set(this.extensaoe, "numPatentesModelos", $$v)
      },
      expression: "this.extensaoe.numPatentesModelos"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atividades de propriedade intelectual')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Nº de registro de marcas e softwares",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.extensaoe.numMarcasSoftwares),
      callback: function($$v) {
        _vm.$set(this.extensaoe, "numMarcasSoftwares", $$v)
      },
      expression: "this.extensaoe.numMarcasSoftwares"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atividades de propriedade intelectual')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Nº de contratos de transferência de tecnologia",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.extensaoe.numTransferenciaTecnologia),
      callback: function($$v) {
        _vm.$set(this.extensaoe, "numTransferenciaTecnologia", $$v)
      },
      expression: "this.extensaoe.numTransferenciaTecnologia"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atividades de propriedade intelectual')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Nº de registros de direitos autorais",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.extensaoe.numDireitosAutorais),
      callback: function($$v) {
        _vm.$set(this.extensaoe, "numDireitosAutorais", $$v)
      },
      expression: "this.extensaoe.numDireitosAutorais"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Exames e laudos técnicos')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('p', {
    staticClass: "tipoPrestacaoServico"
  }, [_vm._v("Tipo: Exames e laudos técnicos")]), _vm._v(" "), _c('c-readonly-field', {
    attrs: {
      "label": "Nº de laudos emitidos",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.extensaoe.numLaudosEmitidos),
      callback: function($$v) {
        _vm.$set(this.extensaoe, "numLaudosEmitidos", $$v)
      },
      expression: "this.extensaoe.numLaudosEmitidos"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento jurídico')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('p', {
    staticClass: "tipoPrestacaoServico"
  }, [_vm._v("Tipo: Atendimento jurídico")]), _vm._v(" "), _c('c-readonly-field', {
    attrs: {
      "label": "Nº de atendimentos",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.extensaoe.numAtendimentosJuridicos),
      callback: function($$v) {
        _vm.$set(this.extensaoe, "numAtendimentosJuridicos", $$v)
      },
      expression: "this.extensaoe.numAtendimentosJuridicos"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('p', {
    staticClass: "tipoPrestacaoServico"
  }, [_vm._v("Tipo: Atendimento em saúde humana")]), _vm._v(" "), _c('c-readonly-field', {
    attrs: {
      "label": "Nº de consultas ambulatoriais (programadas)",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.extensaoe.numConsultasAmbulatoriais),
      callback: function($$v) {
        _vm.$set(this.extensaoe, "numConsultasAmbulatoriais", $$v)
      },
      expression: "this.extensaoe.numConsultasAmbulatoriais"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Nº de consultas de emergência e urgência",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.extensaoe.numConsultasEmergencia),
      callback: function($$v) {
        _vm.$set(this.extensaoe, "numConsultasEmergencia", $$v)
      },
      expression: "this.extensaoe.numConsultasEmergencia"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Nº de internações",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.extensaoe.numInternacoes),
      callback: function($$v) {
        _vm.$set(this.extensaoe, "numInternacoes", $$v)
      },
      expression: "this.extensaoe.numInternacoes"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Nº de cirurgias",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.extensaoe.numCirurgias),
      callback: function($$v) {
        _vm.$set(this.extensaoe, "numCirurgias", $$v)
      },
      expression: "this.extensaoe.numCirurgias"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Nº de exames laboratoriais",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.extensaoe.numExamesLaboratoriais),
      callback: function($$v) {
        _vm.$set(this.extensaoe, "numExamesLaboratoriais", $$v)
      },
      expression: "this.extensaoe.numExamesLaboratoriais"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Nº de exames complementares",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.extensaoe.numExamesComplementares),
      callback: function($$v) {
        _vm.$set(this.extensaoe, "numExamesComplementares", $$v)
      },
      expression: "this.extensaoe.numExamesComplementares"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Nº de outros atendimentos",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.extensaoe.numOutrosAtendimentosSH),
      callback: function($$v) {
        _vm.$set(this.extensaoe, "numOutrosAtendimentosSH", $$v)
      },
      expression: "this.extensaoe.numOutrosAtendimentosSH"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde animal')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('p', {
    staticClass: "tipoPrestacaoServico"
  }, [_vm._v("Tipo: Atendimento em saúde animal")]), _vm._v(" "), _c('c-readonly-field', {
    attrs: {
      "label": "Nº de atendimentos veterinários ambulatoriais",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.extensaoe.numAtendimentosVeterinarios),
      callback: function($$v) {
        _vm.$set(this.extensaoe, "numAtendimentosVeterinarios", $$v)
      },
      expression: "this.extensaoe.numAtendimentosVeterinarios"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde animal')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Nº de internações veterinárias",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.extensaoe.numInternacoesVeterinarias),
      callback: function($$v) {
        _vm.$set(this.extensaoe, "numInternacoesVeterinarias", $$v)
      },
      expression: "this.extensaoe.numInternacoesVeterinarias"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde animal')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Nº de cirurgias veterinárias",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.extensaoe.numCirurgiasVeterinarias),
      callback: function($$v) {
        _vm.$set(this.extensaoe, "numCirurgiasVeterinarias", $$v)
      },
      expression: "this.extensaoe.numCirurgiasVeterinarias"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde animal')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Nº de exames laboratoriais e complementares em veterinária",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.extensaoe.numExamesVeterinaria),
      callback: function($$v) {
        _vm.$set(this.extensaoe, "numExamesVeterinaria", $$v)
      },
      expression: "this.extensaoe.numExamesVeterinaria"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.extensaoe.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.length !== 0) ? _c('p', {
    staticClass: "mt-3"
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Possui vínculo com ensino",
      "value": _vm.extensaoe.vinculoEnsino != null ? (_vm.extensaoe.vinculoEnsino ? 'Sim' : 'Não') : '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Possui vínculo com pesquisa",
      "value": _vm.extensaoe.vinculoPesquisa != null ? (_vm.extensaoe.vinculoPesquisa ? 'Sim' : 'Não') : '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Esta ação realiza divulgação científica",
      "value": _vm.extensaoe.divulgacaoCientifica != null ? (_vm.extensaoe.divulgacaoCientifica ? 'Sim' : 'Não') : '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Esta é uma ação direcionada às escolas públicas (alunos, professores, servidores ou processo de formação continuada)",
      "value": _vm.extensaoe.direcionadaEscolaPublica != null ? (_vm.extensaoe.direcionadaEscolaPublica ? 'Sim' : 'Não') : '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Esta ação será utilizada para a creditação da extensão nos cursos de graduação da UFES",
      "value": _vm.extensaoe.creditacaoGraduacao != null ? (_vm.extensaoe.creditacaoGraduacao ? 'Sim' : 'Não') : '-'
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Data inicial da creditação",
      "value": _vm.extensaoe.dtInicialCreditacao ? _vm.dates.format(_vm.extensaoe.dtInicialCreditacao) || '-' : '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Envolve captação de recursos financeiros ou bens duráveis",
      "value": _vm.extensaoe.captacaoRecursosBensDuraveis != null ? (_vm.extensaoe.captacaoRecursosBensDuraveis ? 'Sim' : 'Não') : '-'
    }
  })], 1)], 1), _vm._v(" "), (_vm.extensao.captacaoRecursosBensDuraveis === true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', [_vm._v("Por meio de:")])])], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.captacaoRecursosBensDuraveis === true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("UFES")])]
      },
      proxy: true
    }], null, false, 4124160677),
    model: {
      value: (_vm.extensao.captacaoRecursosUfes),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "captacaoRecursosUfes", $$v)
      },
      expression: "extensao.captacaoRecursosUfes"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("CAPES")])]
      },
      proxy: true
    }], null, false, 3158995236),
    model: {
      value: (_vm.extensao.captacaoRecursosCapes),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "captacaoRecursosCapes", $$v)
      },
      expression: "extensao.captacaoRecursosCapes"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("FEST")])]
      },
      proxy: true
    }], null, false, 1101797796),
    model: {
      value: (_vm.extensao.captacaoRecursosFest),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "captacaoRecursosFest", $$v)
      },
      expression: "extensao.captacaoRecursosFest"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.captacaoRecursosBensDuraveis === true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("CNPq")])]
      },
      proxy: true
    }], null, false, 1739938252),
    model: {
      value: (_vm.extensao.captacaoRecursosCnpq),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "captacaoRecursosCnpq", $$v)
      },
      expression: "extensao.captacaoRecursosCnpq"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("FAPES")])]
      },
      proxy: true
    }], null, false, 4155422625),
    model: {
      value: (_vm.extensao.captacaoRecursosFapes),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "captacaoRecursosFapes", $$v)
      },
      expression: "extensao.captacaoRecursosFapes"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("FUCAM")])]
      },
      proxy: true
    }], null, false, 1966598076),
    model: {
      value: (_vm.extensao.captacaoRecursosFucam),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "captacaoRecursosFucam", $$v)
      },
      expression: "extensao.captacaoRecursosFucam"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.captacaoRecursosBensDuraveis === true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Outros")])]
      },
      proxy: true
    }], null, false, 1698063712),
    model: {
      value: (_vm.extensao.captacaoRecursosOutros),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "captacaoRecursosOutros", $$v)
      },
      expression: "extensao.captacaoRecursosOutros"
    }
  })], 1), _vm._v(" "), (_vm.extensao.captacaoRecursosBensDuraveis === true) ? _c('v-flex', {
    attrs: {
      "xs8": "",
      "sm8": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Especifique:"
    },
    model: {
      value: (_vm.extensao.especCaptacaoRecursosOutros),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "especCaptacaoRecursosOutros", $$v)
      },
      expression: "extensao.especCaptacaoRecursosOutros"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Envolve liberação de carga horária do coordenador aprovada em Departamento/Centro/Setor de lotação",
      "value": _vm.extensaoe.liberacaoCargaHoraria != null ? (_vm.extensaoe.liberacaoCargaHoraria ? 'Sim' : 'Não') : '-'
    }
  })], 1)], 1), _vm._v(" "), (_vm.extensaoe.liberacaoCargaHoraria === true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Carga horária aprovada",
      "value": this.extensaoe.cargaHorariaCoordenadorAprovada || '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensaoe.curso || _vm.extensaoe.oficina || _vm.extensaoe.evento) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Gratuito para o público",
      "value": _vm.extensaoe.gratuito != null ? (_vm.extensaoe.gratuito ? 'Sim' : 'Não') : '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.gratuito === false) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', [_vm._v("Os recursos financeiros obtidos serão administrados por:")])])], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.gratuito === false) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("UFES")])]
      },
      proxy: true
    }], null, false, 4124160677),
    model: {
      value: (_vm.extensao.gratuitoUfes),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "gratuitoUfes", $$v)
      },
      expression: "extensao.gratuitoUfes"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.gratuito === false) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("FEST")])]
      },
      proxy: true
    }], null, false, 1101797796),
    model: {
      value: (_vm.extensao.gratuitoFest),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "gratuitoFest", $$v)
      },
      expression: "extensao.gratuitoFest"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.gratuito === false) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("FUCAM")])]
      },
      proxy: true
    }], null, false, 1966598076),
    model: {
      value: (_vm.extensao.gratuitoFucam),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "gratuitoFucam", $$v)
      },
      expression: "extensao.gratuitoFucam"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.gratuito === false) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Outros")])]
      },
      proxy: true
    }], null, false, 1698063712),
    model: {
      value: (_vm.extensao.gratuitoOutros),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "gratuitoOutros", $$v)
      },
      expression: "extensao.gratuitoOutros"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": "",
      "sm8": ""
    }
  }, [(_vm.extensao.gratuito === false) ? _c('c-readonly-field', {
    attrs: {
      "label": "Especifique:"
    },
    model: {
      value: (_vm.extensao.especGratuitoOutros),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "especGratuitoOutros", $$v)
      },
      expression: "extensao.especGratuitoOutros"
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensaoe.curso || _vm.extensaoe.oficina) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Modalidade",
      "value": _vm.extensaoe.modalidade != null ? (_vm.extensaoe.modalidade == 'P' ? 'Presencial' : (_vm.extensaoe.modalidade == 'S' ? 'Semipresencial' : 'EAD')) : '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensaoe.curso || _vm.extensaoe.oficina) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Utiliza o AVA Extensão",
      "value": _vm.extensaoe.utilizaAvaExtensao != null ? (_vm.extensaoe.utilizaAvaExtensao ? 'Sim' : 'Não') : '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensaoe.curso || _vm.extensaoe.oficina) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Outra plataforma AVA",
      "value": _vm.extensaoe.plataforma || '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.listaSuspensoes.length !== 0) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', [_vm._v("Suspensões")])])], 1) : _vm._e(), _vm._v(" "), (_vm.listaSuspensoes.length !== 0) ? _c('v-data-table', {
    staticClass: "elevation-1 suspensoes",
    attrs: {
      "headers": _vm.headersSuspensoes,
      "header-props": {
        sortIcon: null
      },
      "items": _vm.listaSuspensoes,
      "items-per-page": -1,
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "item.dtInicioSuspensao",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dtInicioSuspensao)))]
      }
    }, {
      key: "item.dtFimSuspensao",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dtFimSuspensao)))]
      }
    }], null, false, 4036453385)
  }) : _vm._e(), _vm._v(" "), (_vm.listaSuspensoes.length === 0) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Suspensões",
      "value": "-",
      "align": "justify"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.listaRegistroRelatoriosEnviados.length !== 0) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', [_vm._v("Registro de relatórios enviados")])])], 1) : _vm._e(), _vm._v(" "), (_vm.listaRegistroRelatoriosEnviados.length !== 0) ? _c('v-data-table', {
    staticClass: "elevation-1 suspensoes",
    attrs: {
      "headers": _vm.headersRegistroRelatoriosEnviados,
      "header-props": {
        sortIcon: null
      },
      "items": _vm.listaRegistroRelatoriosEnviados,
      "items-per-page": -1,
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "item.dtEnvio",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dtEnvio)))]
      }
    }], null, false, 1802811833)
  }) : _vm._e(), _vm._v(" "), (_vm.listaRegistroRelatoriosEnviados.length === 0) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Registro de relatórios enviados",
      "value": "-",
      "align": "justify"
    }
  })], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('c-card-footer', {
    attrs: {
      "projeto": this.projeto,
      "extensao": this.extensao,
      "proxima": "IntegrantesProjeto",
      "editar": "EditarExtensao",
      "nome_editar": "Editar",
      "habilitaBotaoGerarPDFAcao": true,
      "habilitaBotaoFinalizarAcao": true
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(471)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(472),
  /* template */
  __webpack_require__(475),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 471 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_card_footer__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_card_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_c_card_footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_readonly_field__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_readonly_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_readonly_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_readonly_field_pre_format__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_readonly_field_pre_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_readonly_field_pre_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto', 'projeto', 'extensao'],
  data: function data() {
    return {
      contatos: {},
      dates: __WEBPACK_IMPORTED_MODULE_5__utils_dates__["a" /* default */],
      formularioValido: false,
      observacoesRules: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }, function (input) {
        return !!input && input.length <= 60 || 'Este campo não pode possuir mais que 60 caracteres';
      }]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])('auth', ['logged', 'username', 'nome', 'administrador', 'usuarioPROEX', 'permissaoCriarProjetoExtensao'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    // Verifica se a ação de extensão é um curso/oficina (antigo).
    acaoCursoOficina: function acaoCursoOficina() {
      if (this.projeto.classificacaoSecundaria.id === 39729) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se a ação de extensão é um curso.
    acaoCurso: function acaoCurso() {
      if (this.projeto.classificacaoSecundaria.id === 44194) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se a ação de extensão é um oficina.
    acaoOficina: function acaoOficina() {
      if (this.projeto.classificacaoSecundaria.id === 44195) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se a ação de extensão é um evento.
    acaoEvento: function acaoEvento() {
      if (this.projeto.classificacaoSecundaria.id === 39730) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se o tipo de ação de extensão está habilitado a ter a aba Relatórios.
    tipoAcaoExtensaoHabilitado: function tipoAcaoExtensaoHabilitado() {
      if (this.acaoCursoOficina() || this.acaoCurso() || this.acaoOficina() || this.acaoEvento()) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se a ação de extensão está na situação "Ativo".
    situacaoAtivo: function situacaoAtivo() {
      if (this.projeto.situacao.item === 18) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se a ação de extensão está na situação "Aguardando relatório".
    situacaoAguardandoRelatorio: function situacaoAguardandoRelatorio() {
      if (this.projeto.situacao.item === 20) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se a ação de extensão está na situação "Relatório aguardando aprovação".
    situacaoRelatorioAguardandoAprovacao: function situacaoRelatorioAguardandoAprovacao() {
      if (this.projeto.situacao.item === 22) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se a ação de extensão está na situação "Concluído".
    situacaoConcluido: function situacaoConcluido() {
      if (this.projeto.situacao.item === 19) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se a ação de extensão está na situação "Cancelado".
    situacaoCancelado: function situacaoCancelado() {
      if (this.projeto.situacao.item === 5) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se a situação da ação de extensão está habilitada a ter a aba Relatórios.
    situacaoAcaoExtensaoHabilitado: function situacaoAcaoExtensaoHabilitado() {
      if (this.situacaoAtivo() || this.situacaoAguardandoRelatorio() || this.situacaoRelatorioAguardandoAprovacao() || this.situacaoConcluido() || this.situacaoCancelado()) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se o usuário logado é administrador.
    usuarioAdministrador: function usuarioAdministrador() {
      if (this.administrador === true) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se o usuário logado é o coordenador da ação de extensão.
    usuarioCoordenador: function usuarioCoordenador() {
      if (this.projeto.funcao != null && this.projeto.funcao.item === 1) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se o usuário logado é assessor da ação de extensão.
    usuarioAssessor: function usuarioAssessor() {
      if (this.projeto.assessor === true) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se o usuário logado é usuário Proex.
    usuarioProex: function usuarioProex() {
      if (this.usuarioPROEX === true) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se o usuário logado está habilitado para a aba Relatórios.
    usuarioHabilitado: function usuarioHabilitado() {
      if (this.usuarioAdministrador() || this.usuarioCoordenador() || this.usuarioAssessor() || this.usuarioProex()) {
        return true;
      } else {
        return false;
      }
    },
    habilitaRelatorio: function habilitaRelatorio() {
      if (this.tipoAcaoExtensaoHabilitado() && this.situacaoAcaoExtensaoHabilitado()) {
        return true;
      } else {
        return false;
      }
    }
  }),
  mounted: function mounted() {
    var _this = this;

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando contatos.' });
    __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].getContatosDoProjeto(this.idProjeto).then(function (response) {
      _this.contatos = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando contatos.' });
    });
  },
  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_4__components_toolbars_basic_toolbar___default.a,
    'c-card-footer': __WEBPACK_IMPORTED_MODULE_1__components_c_card_footer___default.a,
    'c-readonly-field': __WEBPACK_IMPORTED_MODULE_2__components_c_readonly_field___default.a,
    'c-readonly-field-pre-format': __WEBPACK_IMPORTED_MODULE_3__components_c_readonly_field_pre_format___default.a
  }
});

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['label', 'value', 'align', 'required']
});

/***/ }),
/* 474 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticClass: "gray--text"
  }, [_vm._v(_vm._s(_vm.label) + _vm._s(this.required !== undefined ? '*' : ''))]), _vm._v(" "), _c('p', {
    staticClass: "black--text body-1",
    attrs: {
      "align": _vm.align
    }
  }, [_c('pre', {
    staticClass: "black--text body-1"
  }, [_vm._v(_vm._s(_vm.value))])])])
},staticRenderFns: []}

/***/ }),
/* 475 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "lg8": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.administrador === true || _vm.usuarioPROEX === true || (_vm.projeto.funcao !== null && _vm.projeto.funcao.item === 1) || _vm.projeto.assessor === true) ? _c('div', {
    staticClass: "tituloSecao"
  }, [_c('label', [_vm._v("Contatos do coordenador")])]) : _vm._e()])], 1), _vm._v(" "), (_vm.administrador === true || _vm.usuarioPROEX === true || (_vm.projeto.funcao !== null && _vm.projeto.funcao.item === 1) || _vm.projeto.assessor === true) ? _c('div', [_c('br')]) : _vm._e(), _vm._v(" "), (_vm.administrador === true || _vm.usuarioPROEX === true || (_vm.projeto.funcao !== null && _vm.projeto.funcao.item === 1) || _vm.projeto.assessor === true) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "readonly": "",
      "label": "E-mail",
      "value": this.contatos.emailCoordenador || '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.administrador === true || _vm.usuarioPROEX === true || (_vm.projeto.funcao !== null && _vm.projeto.funcao.item === 1) || _vm.projeto.assessor === true) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "readonly": "",
      "label": "Telefone",
      "value": this.contatos.telefoneCoordenador || '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.administrador === true || _vm.usuarioPROEX === true || (_vm.projeto.funcao !== null && _vm.projeto.funcao.item === 1) || _vm.projeto.assessor === true) ? _c('div', [_c('br')]) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.administrador === true || _vm.usuarioPROEX === true || (_vm.projeto.funcao !== null && _vm.projeto.funcao.item === 1) || _vm.projeto.assessor === true) ? _c('div', {
    staticClass: "tituloSecao"
  }, [_c('label', [_vm._v("Contatos da ação de extensão")])]) : _vm._e()])], 1), _vm._v(" "), (_vm.administrador === true || _vm.usuarioPROEX === true || (_vm.projeto.funcao !== null && _vm.projeto.funcao.item === 1) || _vm.projeto.assessor === true) ? _c('div', [_c('br')]) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "readonly": "",
      "label": "Site",
      "value": this.contatos.site || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "readonly": "",
      "label": "Instagram",
      "value": this.contatos.instagram || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "readonly": "",
      "label": "Facebook",
      "value": this.contatos.facebook || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "readonly": "",
      "label": "Youtube",
      "value": this.contatos.youtube || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field-pre-format', {
    attrs: {
      "readonly": "",
      "label": "Outras mídias sociais",
      "value": this.contatos.midiasSociais || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "readonly": "",
      "label": "Nome do contato",
      "value": this.contatos.nomeContato || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "readonly": "",
      "label": "E-mail",
      "value": this.contatos.email || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "readonly": "",
      "label": "Telefone",
      "value": this.contatos.telefone || '-'
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('c-card-footer', {
    attrs: {
      "projeto": this.projeto,
      "extensao": this.extensao,
      "proxima": _vm.habilitaRelatorio() ? 'RelatoriosProjeto' : null,
      "editar": "EditarContatos",
      "nome_editar": "Editar",
      "habilitaBotaoGerarPDFAcao": true,
      "habilitaBotaoFinalizarAcao": true
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(477)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(478),
  /* template */
  __webpack_require__(479),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 477 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_card_footer__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_card_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_c_card_footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_tooltip_btn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_tooltip_btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_tooltip_btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_assessor__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto', 'projeto', 'extensao'],
  data: function data() {
    return {
      mostrarInativos: false,
      botaoFinalizarAcao: true,
      botaoAvancar: true,
      listaIntegrantes: [],
      dates: __WEBPACK_IMPORTED_MODULE_4__utils_dates__["a" /* default */],
      formatAssessor: __WEBPACK_IMPORTED_MODULE_5__utils_assessor__["a" /* default */],
      search: 'ativos',
      sortBy: null,
      sortDesc: false,
      itemsPerPage: 25,
      opcoesPaginacao: [10, 25, 50, { text: 'Todas', value: -1 }],
      headers: [{ text: 'Nome', align: 'left', width: '20%', value: 'nome' }, { text: 'Função', align: 'left', width: '12.5%', value: 'funcao.descricao' }, { text: 'Assessor', align: 'left', width: '10%', value: 'assessor' }, { text: 'Vínculo', align: 'left', width: '15%', value: 'vinculo' }, { text: 'CH semanal', align: 'left', width: '10%', value: 'cargaHoraria' }, { text: 'Data inicial', align: 'left', width: '10%', value: 'dataInicial' }, { text: 'Data final', align: 'left', width: '10%', value: 'dataFinal' }, { text: 'Opções', align: 'left', width: '12.5%', value: 'opcoes' }]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])('auth', ['administrador', 'usuarioPROEX'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    // Verifica se a ação de extensão está na situação "Ativo".
    situacaoAtivo: function situacaoAtivo() {
      if (this.projeto.situacao.item === 18) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se a ação de extensão está na situação "Aguardando relatório".
    situacaoAguardandoRelatorio: function situacaoAguardandoRelatorio() {
      if (this.projeto.situacao.item === 20) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se o usuário logado é o coordenador da ação de extensão.
    usuarioCoordenador: function usuarioCoordenador() {
      if (this.projeto.funcao != null && this.projeto.funcao.item === 1) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se o usuário logado é assessor da ação de extensão.
    usuarioAssessor: function usuarioAssessor() {
      if (this.projeto.assessor === true) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se a ação de extensão possui alunos de graduação ou pós-graduação cadastrados.
    acaoExtensaoNaoPossuiAlunosCadastrados: function acaoExtensaoNaoPossuiAlunosCadastrados() {
      if (this.projeto.possuiAlunos === false) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se a edição dos integrantes não pode ser realizada.
    verificaSeEdicaoIntegrantesNaoPodeSerRealizada: function verificaSeEdicaoIntegrantesNaoPodeSerRealizada() {
      if (this.situacaoAtivo() || this.situacaoAguardandoRelatorio()) {
        if (this.usuarioCoordenador() || this.usuarioAssessor()) {
          if (this.acaoExtensaoNaoPossuiAlunosCadastrados()) {
            this.botaoFinalizarAcao = false;
            this.botaoAvancar = false;
            return true;
          }
        }
      }
      return false;
    },
    controlaBotaoAvancar: function controlaBotaoAvancar() {
      if (this.botaoAvancar === true) {
        return 'AtividadesProjeto';
      } else {
        return null;
      }
    },
    truncate: function truncate(string, limit) {
      if (string.length > limit) return string.substring(0, limit) + '...';else return string;
    },
    filtroInativos: function filtroInativos(value, search, item) {
      return this.mostrarInativos || item.situacao === 'A';
    },

    toFrequenciaIntegrante: function toFrequenciaIntegrante(idParticipante) {
      this.$router.push({ name: 'FrequenciaIntegrante', params: { idProjeto: this.projeto.idProjeto, idParticipante: idParticipante } });
    },
    toOcorrenciasIntegrante: function toOcorrenciasIntegrante(idParticipante) {
      this.$router.push({ name: 'OcorrenciasIntegrante', params: { idProjeto: this.projeto.idProjeto, idParticipante: idParticipante } });
    },
    toEncerrarParticipacao: function toEncerrarParticipacao(idParticipante) {
      this.$router.push({ name: 'EncerrarParticipacao', params: { idProjeto: this.projeto.idProjeto, idParticipante: idParticipante } });
    },
    toReativarParticipacao: function toReativarParticipacao(idParticipante) {
      this.$router.push({ name: 'ReativarParticipacao', params: { idProjeto: this.projeto.idProjeto, idParticipante: idParticipante } });
    },
    toTrocarCoordenacao: function toTrocarCoordenacao(idParticipante) {
      this.$router.push({ name: 'TrocarCoordenador', params: { idProjeto: this.projeto.idProjeto, idParticipante: idParticipante } });
    },
    carregaIntegrantes: function carregaIntegrantes(idProjeto) {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando integrantes.' });
      __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].getIntegrantesDoProjeto(idProjeto).then(function (response) {
        var listaIntegrantesAux = [];
        listaIntegrantesAux = response.data.slice();
        listaIntegrantesAux = listaIntegrantesAux.sort(function (a, b) {
          if (a.situacao === 'A' && b.situacao !== 'A') {
            return -1;
          }if (a.situacao !== 'A' && b.situacao === 'A') {
            return 1;
          }
          return 0;
        });
        _this.listaIntegrantes = listaIntegrantesAux.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando integrantes.' });
      });
    },
    excluirIntegrante: function excluirIntegrante(idIntegrante) {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo integrante.' });
      __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].deleteIntegrante(this.idProjeto, idIntegrante).then(function (response) {
        _this2.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        // this.carregaIntegrantes(this.idProjeto)
        window.location.reload();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this2.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo integrante.' });
      });
    }
  }),
  mounted: function mounted() {
    this.carregaIntegrantes(this.idProjeto);
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar___default.a,
    'c-card-footer': __WEBPACK_IMPORTED_MODULE_1__components_c_card_footer___default.a,
    'c-tooltip-btn': __WEBPACK_IMPORTED_MODULE_3__components_c_tooltip_btn___default.a
  }
});

/***/ }),
/* 479 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "text-center": "",
      "d-flex": "",
      "align-center": ""
    }
  }, [(_vm.administrador === true || (_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1) || _vm.projeto.assessor === true || _vm.usuarioPROEX === true) ? _c('v-layout', {
    attrs: {
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "instrucao"
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-text', {
    staticClass: "black--text font-weight-bold"
  }, [_vm._v("\n            Todas as ações de extensão devem ter como membros da equipe de trabalho estudantes de graduação e/ou pós-graduação. Caso seja necessário, o coordenador poderá cadastrá-los após a aprovação da ação.\n          ")])], 1)], 1)])], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-right": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Mostrar integrantes inativos"
    },
    model: {
      value: (_vm.mostrarInativos),
      callback: function($$v) {
        _vm.mostrarInativos = $$v
      },
      expression: "mostrarInativos"
    }
  })], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaIntegrantes,
      "search": _vm.search,
      "custom-filter": _vm.filtroInativos,
      "no-data-text": 'Este projeto não possui integrantes.',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.nome",
      fn: function(props) {
        return [(_vm.verificaSeEdicaoIntegrantesNaoPodeSerRealizada() === false && (_vm.administrador === true || (_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1) || _vm.projeto.assessor === true || _vm.usuarioPROEX === true)) ? _c('div', [(_vm.administrador === true || (_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1) || _vm.projeto.assessor === true) ? _c('router-link', {
          class: props.item.situacao === 'A' ? 'primary--text' : 'grey--text text--darken-2',
          attrs: {
            "to": {
              name: 'EditarIntegrante',
              params: {
                idProjeto: _vm.idProjeto,
                idParticipante: props.item.idParticipante
              }
            }
          }
        }, [_vm._v("\n          " + _vm._s(props.item.nome) + "\n        ")]) : _c('router-link', {
          class: props.item.situacao === 'A' ? 'primary--text' : 'grey--text text--darken-2',
          attrs: {
            "to": {
              name: 'VisualizarIntegrante',
              params: {
                idProjeto: _vm.idProjeto,
                idParticipante: props.item.idParticipante
              }
            }
          }
        }, [_vm._v("\n          " + _vm._s(props.item.nome) + "\n        ")])], 1) : _c('div', [_vm._v("\n        " + _vm._s(props.item.nome) + "\n      ")])]
      }
    }, {
      key: "item.assessor",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.formatAssessor.format(props.item.assessor, props.item.funcao.item)))]
      }
    }, {
      key: "item.dataInicial",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dataInicial)))]
      }
    }, {
      key: "item.dataFinal",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dataFinal)))]
      }
    }, {
      key: "item.opcoes",
      fn: function(props) {
        return [(_vm.verificaSeEdicaoIntegrantesNaoPodeSerRealizada() === false) ? _c('div', [(_vm.usuarioPROEX === true || _vm.administrador === true || (_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1) || _vm.projeto.assessor === true) ? _c('c-tooltip-btn', {
          attrs: {
            "icon": "history",
            "color": "primary",
            "tooltip": "Histórico do integrante"
          },
          on: {
            "click": function($event) {
              return _vm.toOcorrenciasIntegrante(props.item.idParticipante)
            }
          }
        }) : _vm._e(), _vm._v(" "), ((_vm.administrador === true || (_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1) || _vm.projeto.assessor === true) && (props.item.funcao != null && props.item.funcao.item === 1)) ? _c('c-tooltip-btn', {
          attrs: {
            "icon": "autorenew",
            "color": "primary",
            "tooltip": "Trocar coordenador",
            "disabled": _vm.administrador === false,
            "disabled-tooltip": "Somente o administrador pode alterar o coordenador"
          },
          on: {
            "click": function($event) {
              return _vm.toTrocarCoordenacao(props.item.idParticipante)
            }
          }
        }) : _vm._e(), _vm._v(" "), ((_vm.administrador === true || (_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1) || _vm.projeto.assessor === true) && (props.item.funcao.item !== 1 && props.item.situacao === 'A')) ? _c('c-tooltip-btn', {
          attrs: {
            "icon": "transfer_within_a_station",
            "color": "primary",
            "tooltip": "Finalizar participação"
          },
          on: {
            "click": function($event) {
              return _vm.toEncerrarParticipacao(props.item.idParticipante)
            }
          }
        }) : _vm._e(), _vm._v(" "), ((_vm.administrador === true || (_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1) || _vm.projeto.assessor === true) && (props.item.funcao.item !== 1 && props.item.situacao !== 'A')) ? _c('c-tooltip-btn', {
          attrs: {
            "icon": "undo",
            "color": "primary",
            "tooltip": "Reativar participação"
          },
          on: {
            "click": function($event) {
              return _vm.toReativarParticipacao(props.item.idParticipante)
            }
          }
        }) : _vm._e(), _vm._v(" "), (_vm.administrador === true || (_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1) || _vm.projeto.assessor === true) ? _c('c-tooltip-btn', {
          attrs: {
            "icon": "delete",
            "color": "primary",
            "disabled": props.item.funcao != null && props.item.funcao.item === 1,
            "tooltip": "Excluir integrante",
            "disabled-tooltip": "O coordenador não pode ser excluído"
          },
          on: {
            "click": function($event) {
              return _vm.excluirIntegrante(props.item.idParticipante)
            }
          }
        }) : _vm._e()], 1) : _vm._e()]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n      Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaIntegrantes.length) + " integrantes\n    ")]
      }
    }])
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('c-card-footer', {
    attrs: {
      "projeto": this.projeto,
      "extensao": this.extensao,
      "proxima": this.controlaBotaoAvancar(),
      "editar": "NovoIntegrante",
      "nome_editar": "Novo integrante",
      "habilitaBotaoGerarPDFAcao": true,
      "habilitaBotaoFinalizarAcao": this.botaoFinalizarAcao
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(481)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(482),
  /* template */
  __webpack_require__(483),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 481 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_confirm_dialog__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_confirm_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_c_confirm_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_card_footer__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_card_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_card_footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto', 'projeto', 'extensao'],
  data: function data() {
    return {
      dialogConfirmaExclusao: false,
      idAtividadeExclusao: 0,
      descriaoAtividadeExclusao: '',
      listaAtividades: [],
      dates: __WEBPACK_IMPORTED_MODULE_4__utils_dates__["a" /* default */],
      search: null,
      sortBy: 'funcao.descricao',
      sortDesc: false,
      itemsPerPage: 25,
      opcoesPaginacao: [10, 25, 50, { text: 'Todas', value: -1 }],
      headers: [{ text: 'Nome e descrição sucinta da atividade', align: 'left', width: '58%', value: 'nomeDescricao' }, { text: 'Início previsto', align: 'left', width: '9%', value: 'dtInicioPrevisto' }, { text: 'Conclusão prevista', align: 'left', width: '9%', value: 'dtFimPrevisto' }, { text: 'Início efetivo', align: 'left', width: '9%', value: 'dtInicioEfetivo' }, { text: 'Conclusão efetiva', align: 'left', width: '9%', value: 'dtFimEfetivo' }, { text: 'Opções', align: 'left', width: '6%', value: 'opcoes' }]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])('auth', ['administrador', 'usuarioPROEX'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    truncate: function truncate(string, limit) {
      if (string.length > limit) return string.substring(0, limit) + '...';else return string;
    },

    carregaAtividades: function carregaAtividades(idProjeto) {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando atividades.' });
      __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getAtividadesDoProjeto(idProjeto).then(function (response) {
        _this.listaAtividades = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando atividades.' });
      });
    },
    botaoExcluirAtividade: function botaoExcluirAtividade(idAtividade, descricao) {
      this.idAtividadeExclusao = idAtividade;
      this.descricaoAtividadeExclusao = descricao;
      this.dialogConfirmaExclusao = true;
    },
    excluirAtividade: function excluirAtividade() {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo atividade.' });
      __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].deleteAtividade(this.idProjeto, this.idAtividadeExclusao).then(function (response) {
        _this2.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this2.carregaAtividades(_this2.idProjeto);
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this2.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo atividade.' });
      });
    },
    botaoEditarAtividade: function botaoEditarAtividade(idProjeto, idAtividade) {
      this.$router.push({ name: 'EditarAtividade', params: { idProjeto: idProjeto, idAtividade: idAtividade } });
    }
  }),
  mounted: function mounted() {
    this.carregaAtividades(this.idProjeto);
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_3__components_toolbars_basic_toolbar___default.a,
    'c-card-footer': __WEBPACK_IMPORTED_MODULE_2__components_c_card_footer___default.a,
    'c-confirm-dialog': __WEBPACK_IMPORTED_MODULE_1__components_c_confirm_dialog___default.a
  }
});

/***/ }),
/* 483 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('c-confirm-dialog', {
    attrs: {
      "titulo": "Deseja realmente excluir a atividade?"
    },
    on: {
      "yes": function($event) {
        return _vm.excluirAtividade()
      }
    },
    model: {
      value: (_vm.dialogConfirmaExclusao),
      callback: function($$v) {
        _vm.dialogConfirmaExclusao = $$v
      },
      expression: "dialogConfirmaExclusao"
    }
  }, [_vm._v("\n    A atividade \"" + _vm._s(this.descricaoAtividadeExclusao) + "\" será excluída após clicar na opção \"Sim\".\n  ")]), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaAtividades,
      "search": _vm.search,
      "no-data-text": 'Este projeto não possui atividades.',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.opcoes",
      fn: function(props) {
        return [(_vm.administrador === true || (_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1) || _vm.projeto.assessor === true) ? _c('v-btn', {
          attrs: {
            "color": "primary",
            "text": "",
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.botaoEditarAtividade(_vm.idProjeto, props.item.id)
            }
          }
        }, [_c('v-icon', [_vm._v("edit")])], 1) : _vm._e(), _vm._v(" "), (_vm.administrador === true || (_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1 && _vm.projeto.situacao.item === 15) || (_vm.projeto.assessor === true && _vm.projeto.situacao.item === 15)) ? _c('v-btn', {
          attrs: {
            "color": "primary",
            "text": "",
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.botaoExcluirAtividade(props.item.id, props.item.descricao)
            }
          }
        }, [_c('v-icon', [_vm._v("delete")])], 1) : _vm._e()]
      }
    }, {
      key: "item.nomeDescricao",
      fn: function(props) {
        return [(props.item.detalhamento !== null && props.item.detalhamento !== '') ? _c('div', [_vm._v(_vm._s(props.item.descricao)), _c('br'), _c('br'), _vm._v(_vm._s(props.item.detalhamento))]) : _c('div', [_vm._v(_vm._s(props.item.descricao))])]
      }
    }, {
      key: "item.dtInicioPrevisto",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dtInicioPrevisto)))]
      }
    }, {
      key: "item.dtFimPrevisto",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dtFimPrevisto)))]
      }
    }, {
      key: "item.dtInicioEfetivo",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dtInicioEfetivo)))]
      }
    }, {
      key: "item.dtFimEfetivo",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dtFimEfetivo)))]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n      Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaAtividades.length) + " atividades\n    ")]
      }
    }])
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('c-card-footer', {
    attrs: {
      "projeto": this.projeto,
      "extensao": this.extensao,
      "proxima": "VinculosProjeto",
      "editar": "NovaAtividade",
      "nome_editar": "Nova Atividade",
      "habilitaBotaoGerarPDFAcao": true,
      "habilitaBotaoFinalizarAcao": true
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(485)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(486),
  /* template */
  __webpack_require__(487),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 485 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_card_footer__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_card_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_c_card_footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto', 'extensao'],
  data: function data() {
    return {
      dialog: false,
      vinculoParaExclusao: {},
      listaVinculos: [],
      projeto: {},
      projetoSuperior: {},
      dates: __WEBPACK_IMPORTED_MODULE_4__utils_dates__["a" /* default */],
      search: null,
      sortBy: 'funcao.descricao',
      sortDesc: false,
      itemsPerPage: 25,
      opcoesPaginacao: [10, 25, 50, { text: 'Todas', value: -1 }],
      headers: [{ text: 'Número', align: 'left', value: 'idProjeto' }, { text: 'Título', align: 'left', value: 'titulo' }, { text: 'Classificação Primária', align: 'left', value: 'classificacaoPrimaria.descricao' }, { text: 'Classificação Secundária', align: 'left', value: 'classificacaoSecundaria.descricao' }, { text: 'Situação', align: 'left', value: 'situacao.descricao' }, { text: 'Coordenador', align: 'left', value: 'nomeCoordenador' }, { text: 'Opções', align: 'left', value: 'opcoes' }]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])('auth', ['administrador', 'usuarioPROEX'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    truncate: function truncate(string, limit) {
      if (string.length > limit) return string.substring(0, limit) + '...';else return string;
    },

    toVincular: function toVincular() {
      this.$router.push({ name: 'EditarProjetoSuperior', params: { idProjeto: this.projeto.idProjeto } });
    },
    toAvancar: function toAvancar() {
      this.$router.push({ name: 'ParceriasProjeto', params: { idProjeto: this.projeto.idProjeto } });
    },
    botaoExcluirVinculo: function botaoExcluirVinculo(item) {
      this.$set(this.vinculoParaExclusao, 'idProjeto', item.idProjeto);
      this.$set(this.vinculoParaExclusao, 'idProjetoSuperior', this.idProjeto);
      this.$set(this.vinculoParaExclusao, 'tipoVinculo', item.tipoVinculo);
      this.dialog = true;
    },
    deleteVinculo: function deleteVinculo() {
      var _this = this;

      this.dialog = false;
      var idProjeto = this.vinculoParaExclusao.idProjeto;
      var idProjetoSuperior = this.vinculoParaExclusao.idProjetoSuperior;
      if (this.vinculoParaExclusao.tipoVinculo === 'superior') {
        idProjeto = this.vinculoParaExclusao.idProjetoSuperior;
        idProjetoSuperior = this.vinculoParaExclusao.idProjeto;
      }
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo vínculo.' });
      __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].deleteProjetoSuperior(idProjeto, idProjetoSuperior).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.carregarVinculos();
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo vínculo.' });
      });
    },
    carregarProjeto: function carregarProjeto() {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
      __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getProjeto(this.idProjeto).then(function (response) {
        _this2.projeto = response.data;
        _this2.projeto.dataInicio = __WEBPACK_IMPORTED_MODULE_4__utils_dates__["a" /* default */].format(_this2.projeto.dataInicio);
        _this2.projeto.dataConclusao = __WEBPACK_IMPORTED_MODULE_4__utils_dates__["a" /* default */].format(_this2.projeto.dataConclusao);
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
      });
    },
    carregarVinculos: function carregarVinculos() {
      var _this3 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projetos vinculados.' });
      __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getVinculosDoProjeto(this.idProjeto).then(function (response) {
        _this3.listaVinculos = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this3.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projetos vinculados.' });
      });
    }
  }),
  mounted: function mounted() {
    this.carregarProjeto();
    this.carregarVinculos();
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_3__components_app_layouts_app_tooltip_tooltip___default.a,
    'c-card-footer': __WEBPACK_IMPORTED_MODULE_1__components_c_card_footer___default.a
  }
});

/***/ }),
/* 487 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "width": "400"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n        Confirma a exclusão do vínculo?\n      ")]), _vm._v(" "), _c('v-card-text', [(this.vinculoParaExclusao.tipoVinculo !== 'superior') ? _c('div', [_vm._v("\n          Este vinculo foi feito pelo coordenador da ação " + _vm._s(this.vinculoParaExclusao.idProjeto) + ".\n          Se ele for excluído apenas o coordenador desta ação poderá refazê-lo.\n        ")]) : _vm._e()]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Não")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.deleteVinculo()
      }
    }
  }, [_vm._v("Sim")])], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaVinculos,
      "search": _vm.search,
      "no-data-text": 'Esta ação não possui ações vinculadas.',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.titulo",
      fn: function(props) {
        return [_c('router-link', {
          attrs: {
            "target": "_blank",
            "to": {
              name: 'ProjetoFormulario',
              params: {
                idProjeto: props.item.idProjeto
              }
            }
          }
        }, [_vm._v("\n        " + _vm._s(_vm.truncate(props.item.titulo, 100)) + "\n      ")])]
      }
    }, {
      key: "item.opcoes",
      fn: function(props) {
        return [(_vm.administrador === true || (_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1) || _vm.projeto.assessor === true) ? _c('v-btn', {
          attrs: {
            "color": "red darken-3",
            "text": "",
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.botaoExcluirVinculo(props.item)
            }
          }
        }, [_c('v-icon', [_vm._v("close")])], 1) : _vm._e()]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n      Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaVinculos.length) + " projetos\n    ")]
      }
    }])
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('c-card-footer', {
    attrs: {
      "projeto": this.projeto,
      "extensao": this.extensao,
      "proxima": "ParceriasProjeto",
      "editar": "EditarProjetoSuperior",
      "nome_editar": "Vincular",
      "habilitaBotaoGerarPDFAcao": true,
      "habilitaBotaoFinalizarAcao": true
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(489)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(490),
  /* template */
  __webpack_require__(491),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 489 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_confirm_dialog__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_confirm_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_c_confirm_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_card_footer__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_card_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_card_footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto', 'projeto', 'extensao'],
  data: function data() {
    return {
      dialogConfirmaExclusao: false,
      idParceriaExclusao: null,
      descricaoParceriaExclusao: '',
      listaParcerias: [],
      dates: __WEBPACK_IMPORTED_MODULE_4__utils_dates__["a" /* default */],
      search: null,
      sortBy: 'funcao.descricao',
      sortDesc: false,
      itemsPerPage: 25,
      opcoesPaginacao: [10, 25, 50, { text: 'Todas', value: -1 }],
      headers: [{ text: 'Nome do parceiro institucional/colaborador', align: 'left', value: 'descricao' }, { text: 'Descrição da parceria/colaboração', align: 'left', value: 'detalhamento' }, { text: 'Opções', align: 'left', value: 'opcoes' }]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])('auth', ['administrador', 'usuarioPROEX'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    truncate: function truncate(string, limit) {
      if (string.length > limit) return string.substring(0, limit) + '...';else return string;
    },

    carregaParcerias: function carregaParcerias(idProjeto) {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando parcerias.' });
      __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getParceriasDoProjeto(this.idProjeto).then(function (response) {
        _this.listaParcerias = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando parcerias.' });
      });
    },
    botaoExcluirParceria: function botaoExcluirParceria(idParceria, descricao) {
      this.idParceriaExclusao = idParceria;
      this.descricaoParceriaExclusao = descricao;
      this.dialogConfirmaExclusao = true;
    },
    excluirParceria: function excluirParceria() {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo parceria.' });
      __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].deleteParceria(this.idProjeto, this.idParceriaExclusao).then(function (response) {
        _this2.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this2.carregaParcerias(_this2.idProjeto);
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this2.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo parceria.' });
      });
    }
  }),
  mounted: function mounted() {
    this.carregaParcerias(this.idProjeto);
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_3__components_toolbars_basic_toolbar___default.a,
    'c-card-footer': __WEBPACK_IMPORTED_MODULE_2__components_c_card_footer___default.a,
    'c-confirm-dialog': __WEBPACK_IMPORTED_MODULE_1__components_c_confirm_dialog___default.a
  }
});

/***/ }),
/* 491 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('c-confirm-dialog', {
    attrs: {
      "titulo": "Deseja realmente excluir a parceria?"
    },
    on: {
      "yes": function($event) {
        return _vm.excluirParceria()
      }
    },
    model: {
      value: (_vm.dialogConfirmaExclusao),
      callback: function($$v) {
        _vm.dialogConfirmaExclusao = $$v
      },
      expression: "dialogConfirmaExclusao"
    }
  }, [_vm._v("\n  A parceria \"" + _vm._s(this.descricaoParceriaExclusao) + "\" será excluída após clicar na opção \"Sim\".\n")]), _vm._v(" "), (_vm.administrador === true || (_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1) || _vm.projeto.assessor === true || _vm.usuarioPROEX === true) ? _c('v-layout', {
    attrs: {
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "instrucao"
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-text', {
    staticClass: "black--text font-weight-bold"
  }, [_vm._v("\n            Informar as parcerias/colaborações: contatos Nacionais e Internacionais efetivamente ocorridos em função da atividade, como convênios, acordos de colaboração, etc.\n          ")])], 1)], 1)])], 1) : _vm._e(), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaParcerias,
      "search": _vm.search,
      "no-data-text": 'Este projeto não possui parcerias.',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.descricao",
      fn: function(props) {
        return [(_vm.administrador === true || (_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1) || _vm.projeto.assessor === true) ? _c('div', [_c('router-link', {
          attrs: {
            "to": {
              name: 'EditarParceria',
              params: {
                idProjeto: _vm.idProjeto,
                idParceria: props.item.id
              }
            }
          }
        }, [_vm._v("\n          " + _vm._s(props.item.nome) + "\n        ")])], 1) : _c('div', [_vm._v("\n        " + _vm._s(props.item.nome) + "\n      ")])]
      }
    }, {
      key: "item.opcoes",
      fn: function(props) {
        return [(_vm.administrador === true || (_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1) || _vm.projeto.assessor === true) ? _c('v-btn', {
          attrs: {
            "color": "primary",
            "text": "",
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.botaoExcluirParceria(props.item.id, props.item.nome)
            }
          }
        }, [_c('v-icon', [_vm._v("delete")])], 1) : _vm._e()]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n      Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaParcerias.length) + " parcerias\n    ")]
      }
    }])
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('c-card-footer', {
    attrs: {
      "projeto": this.projeto,
      "extensao": this.extensao,
      "proxima": "AbrangenciaProjeto",
      "editar": "NovaParceria",
      "nome_editar": "Nova parceria",
      "habilitaBotaoGerarPDFAcao": true,
      "habilitaBotaoFinalizarAcao": true
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(493)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(494),
  /* template */
  __webpack_require__(495),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 493 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_card_footer__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_card_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_c_card_footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto', 'projeto', 'extensao'],
  data: function data() {
    return {
      listaLocalidades: [],
      dates: __WEBPACK_IMPORTED_MODULE_3__utils_dates__["a" /* default */],
      search: null,
      sortBy: 'funcao.descricao',
      sortDesc: false,
      itemsPerPage: 25,
      opcoesPaginacao: [10, 25, 50, { text: 'Todas', value: -1 }],
      headers: [{ text: 'Nome da localidade ou instituição', align: 'left', value: 'nome' }, { text: 'Estado', align: 'left', value: 'ufCidade.descricao' }, { text: 'Município', align: 'left', value: 'cidade.nomeCidade' }, { text: 'CEP', align: 'left', value: 'cep' }, { text: 'Informações adicionais', align: 'left', value: 'detalhes' }, { text: 'Opções', align: 'left', value: 'opcoes' }]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])('auth', ['administrador', 'usuarioPROEX'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    truncate: function truncate(string, limit) {
      if (string.length > limit) return string.substring(0, limit) + '...';else return string;
    },

    toLimparLocalidades: function toLimparLocalidades() {
      var _this = this;

      if (confirm('Deseja realmente exluir todas as localidades cadastradas?')) {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo localidade.' });
        this.listaLocalidades.forEach(function (item) {
          _this.excluirLocalidade(item.id);
        });
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo localidade.' });
      }
    },
    carregaLocalidades: function carregaLocalidades(idProjeto) {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando localidades.' });
      __WEBPACK_IMPORTED_MODULE_4__utils_projetos__["a" /* default */].getListaLocalidade(this.idProjeto).then(function (response) {
        _this2.listaLocalidades = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando localidades.' });
      });
    },
    excluirLocalidade: function excluirLocalidade(idLocalidade) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_4__utils_projetos__["a" /* default */].deleteLocalidade(this.idProjeto, idLocalidade).then(function (response) {
        _this3.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this3.carregaLocalidades(_this3.idProjeto);
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this3.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {});
    }
  }),
  mounted: function mounted() {
    this.carregaLocalidades(this.idProjeto);
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar___default.a,
    'c-card-footer': __WEBPACK_IMPORTED_MODULE_1__components_c_card_footer___default.a
  }
});

/***/ }),
/* 495 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaLocalidades,
      "search": _vm.search,
      "no-data-text": 'Este projeto não possui localidades.',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.nome",
      fn: function(props) {
        return [(_vm.administrador === true || (_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1) || _vm.projeto.assessor === true) ? _c('div', [_c('router-link', {
          attrs: {
            "to": {
              name: 'EditarLocalidade',
              params: {
                idProjeto: _vm.idProjeto,
                idLocalidade: props.item.id
              }
            }
          }
        }, [_vm._v("\n          " + _vm._s(props.item.nome) + "\n        ")])], 1) : _c('div', [_vm._v("\n        " + _vm._s(props.item.nome) + "\n      ")])]
      }
    }, {
      key: "item.opcoes",
      fn: function(props) {
        return [(_vm.administrador === true || (_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1) || _vm.projeto.assessor === true) ? _c('v-btn', {
          attrs: {
            "color": "primary",
            "text": "",
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.excluirLocalidade(props.item.id)
            }
          }
        }, [_c('v-icon', [_vm._v("delete")])], 1) : _vm._e()]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n      Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaLocalidades.length) + " localidades\n    ")]
      }
    }])
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('c-card-footer', {
    attrs: {
      "projeto": this.projeto,
      "extensao": this.extensao,
      "proxima": "ArquivosProjeto",
      "editar": "NovaLocalidade",
      "nome_editar": "Nova Localidade",
      "habilitaBotaoGerarPDFAcao": true,
      "habilitaBotaoFinalizarAcao": true
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.toLimparLocalidades
    }
  }, [_vm._v("Limpar")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(497)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(498),
  /* template */
  __webpack_require__(502),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 497 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_hint_btn__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_hint_btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_hint_btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto', 'projeto', 'extensao'],
  data: function data() {
    return {
      listaBolsas: [],
      dates: __WEBPACK_IMPORTED_MODULE_4__utils_dates__["a" /* default */],
      search: null,
      sortBy: 'total',
      sortDesc: false,
      itemsPerPage: 10,
      opcoesPaginacao: [10, 20, 30, { text: 'Todas', value: -1 }],
      headers: [{ text: 'Número', align: 'center', value: 'idBolsa' }, { text: 'Código', align: 'center', value: 'codigo' }, { text: 'Descrição', align: 'center', value: 'descricao' }, { text: 'Bolsistas', align: 'center', value: 'ocupadas' }, { text: 'Bolsas', align: 'center', value: 'total' }]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])('auth', ['logged', 'administrador'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING']), {
    truncate: function truncate(string, limit) {
      if (string.length > limit) return string.substring(0, limit) + '...';else return string;
    },

    toAtribuir: function toAtribuir() {
      this.$router.push({ name: 'AtribuirBolsa', params: { idProjeto: this.idProjeto } });
    },
    toAlocar: function toAlocar() {
      this.$router.push({ name: 'AlocarBolsa', params: { idProjeto: this.idProjeto } });
    },
    toAvancar: function toAvancar() {
      this.$router.push({ name: 'ArquivosProjeto', params: { idProjeto: this.idProjeto } });
    },
    submissaoAprovacao: function submissaoAprovacao() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Submetendo Projeto.' });
      __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].postSubmissaoAprovacao(this.idProjeto).then(function (response) {
        alert('O cadastro da ação nesta plataforma não garante o registro! É necessário autuar um processo digital (com PDF do Projeto em anexo) na secretaria do setor de lotação do coordenador e aguardar deliberação da Câmara de Extensão. Maiores informações entre em contato através do e-mail suporte.proex@ufes.br');
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Submetendo Projeto.' });
      });
    },
    concluirImportacao: function concluirImportacao() {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Concluindo importação...' });
      __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].postConcluirImportacao(this.idProjeto).then(function (response) {
        _this2.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this2.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Concluindo importação...' });
      });
    },
    toRelatorio: function toRelatorio() {
      this.$router.push({ name: 'Relatorio', params: { idProjeto: this.idProjeto } });
    }
  }),
  mounted: function mounted() {
    var _this3 = this;

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando bolsas.' });
    __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getBolsasDoProjeto(this.idProjeto).then(function (response) {
      _this3.listaBolsas = response.data.slice();
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this3.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando bolsas.' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a,
    'c-hint-btn': __WEBPACK_IMPORTED_MODULE_3__components_c_hint_btn___default.a
  }
});

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(500),
  /* template */
  __webpack_require__(501),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['tooltip', 'disabled-tooltip', 'disabled', 'color'],
  data: function data() {
    return {
      focus: false
    };
  },
  methods: {
    click: function click() {
      this.$emit('click');
    }
  }
});

/***/ }),
/* 501 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('div', _vm._g({
          staticStyle: {
            "float": "left"
          }
        }, on), [_c('v-btn', {
          attrs: {
            "color": _vm.color,
            "text": "",
            "disabled": _vm.disabled
          },
          on: {
            "click": function($event) {
              return _vm.click()
            }
          }
        }, [_vm._t("default")], 2)], 1)]
      }
    }], null, true)
  }, [_vm._v(" "), _c('span', [(_vm.disabled !== '' && !_vm.disabled) ? _c('div', [_vm._v(_vm._s(_vm.tooltip))]) : _c('div', [_vm._v(_vm._s(_vm.disabledTooltip))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 502 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaBolsas,
      "search": _vm.search,
      "no-data-text": 'Este projeto não possui bolsas.',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n      Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaBolsas.length) + " bolsas\n    ")]
      }
    }])
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.administrador === true || (_vm.projeto.situacao.item !== 16 && _vm.projeto.funcao != null && _vm.projeto.funcao.item === 1)) ? _c('v-card-actions', [(!_vm.extensao.registroSIEX) ? _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.submissaoAprovacao
    }
  }, [_vm._v("Submeter para aprovação")]) : _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.concluirImportacao
    }
  }, [_vm._v("Concluir Importação")]), _vm._v(" "), _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.toRelatorio
    }
  }, [_vm._v("Gerar PDF da Ação")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.administrador) ? _c('c-hint-btn', {
    attrs: {
      "color": "primary",
      "tooltip": "Alocar uma ou mais bolsas em ação de extensão"
    },
    on: {
      "click": _vm.toAlocar
    }
  }, [_vm._v("Alocar bolsa")]) : _vm._e(), _vm._v(" "), _c('c-hint-btn', {
    attrs: {
      "disabled": _vm.listaBolsas.length === 0,
      "color": "primary",
      "tooltip": "Indicar um estudante de graduação da Ufes como bolsista"
    },
    on: {
      "click": _vm.toAtribuir
    }
  }, [_vm._v("Indicar bolsista")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.toAvancar
    }
  }, [_vm._v("Avançar")])], 1) : _c('v-card-actions', [(_vm.usuarioPROEX === true || _vm.administrador === true || (_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1)) ? _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.toRelatorio
    }
  }, [_vm._v("Gerar PDF da Ação")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(504)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(505),
  /* template */
  __webpack_require__(506),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 504 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_confirm_dialog__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_confirm_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_c_confirm_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_card_footer__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_card_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_card_footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto', 'projeto', 'extensao'],
  data: function data() {
    return {
      dialogConfirmaExclusao: false,
      idArquivoExclusao: 0,
      descricaoArquivoExclusao: '',
      api_url: "https://pib-api.prod.uks.ufes.br",
      listaArquivos: [],
      dates: __WEBPACK_IMPORTED_MODULE_4__utils_dates__["a" /* default */],
      search: null,
      sortBy: 'dtInclusao',
      sortDesc: false,
      itemsPerPage: 25,
      opcoesPaginacao: [10, 25, 50, { text: 'Todas', value: -1 }],
      headers: [{ text: 'Nome', align: 'left', value: 'nome' }, { text: 'Tipo', align: 'left', value: 'tipoArquivo.descricao' }, { text: 'Data de inclusão', align: 'left', value: 'dtInclusao' }, { text: 'Observação', align: 'left', value: 'observacao' }, { text: 'Opções', align: 'left', value: 'opcoes' }]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])('auth', ['administrador', 'usuarioPROEX'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    truncate: function truncate(string, limit) {
      if (string.length > limit) return string.substring(0, limit) + '...';else return string;
    },

    carregarArquivos: function carregarArquivos() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando arquivos.' });
      __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getArquivosDoProjeto(this.idProjeto).then(function (response) {
        _this.listaArquivos = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando arquivos.' });
      });
    },
    botaoExcluirArquivo: function botaoExcluirArquivo(idArquivo, descricao) {
      this.idArquivoExclusao = idArquivo;
      this.descricaoArquivoExclusao = descricao;
      this.dialogConfirmaExclusao = true;
    },
    excluirArquivo: function excluirArquivo() {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo arquivo.' });
      __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].deleteArquivo(this.idProjeto, this.idArquivoExclusao).then(function (response) {
        _this2.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this2.carregarArquivos();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this2.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo arquivo.' });
      });
    },
    editarArquivo: function editarArquivo(idProjeto, idArquivo) {
      this.$router.push({ name: 'EditarArquivo', params: { idProjeto: idProjeto, idArquivo: idArquivo } });
    }
  }),
  mounted: function mounted() {
    this.carregarArquivos();
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_3__components_toolbars_basic_toolbar___default.a,
    'c-card-footer': __WEBPACK_IMPORTED_MODULE_2__components_c_card_footer___default.a,
    'c-confirm-dialog': __WEBPACK_IMPORTED_MODULE_1__components_c_confirm_dialog___default.a
  }
});

/***/ }),
/* 506 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('c-confirm-dialog', {
    attrs: {
      "titulo": "Deseja realmente excluir o arquivo?"
    },
    on: {
      "yes": function($event) {
        return _vm.excluirArquivo()
      }
    },
    model: {
      value: (_vm.dialogConfirmaExclusao),
      callback: function($$v) {
        _vm.dialogConfirmaExclusao = $$v
      },
      expression: "dialogConfirmaExclusao"
    }
  }, [_vm._v("\n    \"" + _vm._s(this.descricaoArquivoExclusao) + "\" será excluído após clicar na opção \"Sim\".\n  ")]), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaArquivos,
      "search": _vm.search,
      "no-data-text": 'Este projeto não possui arquivos.',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.nome",
      fn: function(props) {
        return [_c('a', {
          attrs: {
            "href": _vm.api_url + '/projetos/' + _vm.idProjeto + '/arquivos/' + props.item.idArquivo
          }
        }, [_c('v-icon', [_vm._v("vertical_align_bottom")]), _vm._v(_vm._s(props.item.nome.trim()) + "\n      ")], 1)]
      }
    }, {
      key: "item.dtInclusao",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dtInclusao)))]
      }
    }, {
      key: "item.opcoes",
      fn: function(props) {
        return [(_vm.administrador === true || (_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1) || _vm.projeto.assessor === true) ? _c('div', [_c('v-btn', {
          staticStyle: {
            "margin": "1px"
          },
          attrs: {
            "color": "primary",
            "text": "",
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.editarArquivo(_vm.idProjeto, props.item.idArquivo)
            }
          }
        }, [_c('v-icon', [_vm._v("edit")])], 1), _vm._v(" "), (_vm.administrador === true) ? _c('v-btn', {
          staticStyle: {
            "margin": "1px"
          },
          attrs: {
            "color": "primary",
            "text": "",
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.botaoExcluirArquivo(props.item.idArquivo, props.item.nome.trim())
            }
          }
        }, [_c('v-icon', [_vm._v("delete")])], 1) : _vm._e()], 1) : _vm._e()]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n      Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaArquivos.length) + " arquivos\n    ")]
      }
    }])
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('c-card-footer', {
    attrs: {
      "projeto": this.projeto,
      "extensao": this.extensao,
      "proxima": "ContatosProjeto",
      "editar": "UploadArquivo",
      "nome_editar": "Adicionar",
      "habilitaBotaoGerarPDFAcao": true,
      "habilitaBotaoFinalizarAcao": true
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(508)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(509),
  /* template */
  __webpack_require__(511),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 508 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_card_footer__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_card_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_card_footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_confirm_dialog__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_confirm_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_confirm_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_tooltip_btn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_tooltip_btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_c_tooltip_btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_relatorioTecnico__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto', 'projeto', 'extensao'],
  data: function data() {
    return {
      dialogConfirmaInformacoes: false,
      listaRelatorios: [],
      periodoRelatorio: {},
      possivelAdicionar: null,
      motivo: null,
      dates: __WEBPACK_IMPORTED_MODULE_6__utils_dates__["a" /* default */],
      relatorioTecnico: __WEBPACK_IMPORTED_MODULE_8__utils_relatorioTecnico__["a" /* default */],
      search: null,
      sortBy: 'funcao.descricao',
      sortDesc: false,
      itemsPerPage: 25,
      opcoesPaginacao: [10, 25, 50, { text: 'Todas', value: -1 }],
      // Nome das colunas da aba.
      headers: [{ text: 'Número', align: 'left', width: '15%', value: 'id' }, { text: 'Início', align: 'left', width: '10%', value: 'dtInicial' }, { text: 'Fim', align: 'left', width: '10%', value: 'dtFinal' }, { text: 'Tipo', align: 'left', width: '15%', value: 'tipoRelatorioTecnicoItem' }, { text: 'Situação', align: 'left', width: '15%', value: 'situacaoRelatorioTecnicoItem' }, { text: 'Submissão', align: 'left', width: '10%', value: 'dtSubmissaoRelatorio' }, { text: 'Decisão', align: 'left', width: '10%', value: 'dtDecisaoRelatorio' }, { text: 'Opções', align: 'left', width: '15%', value: 'opcoes' }]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["c" /* mapGetters */])('auth', ['administrador', 'usuarioPROEX'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING']), {
    truncate: function truncate(string, limit) {
      if (string.length > limit) return string.substring(0, limit) + '...';else return string;
    },
    btnNovoRelatorio: function btnNovoRelatorio() {
      if (this.relatorioHabilitadoAcaoRegistroTardio()) {
        this.toAdicionarRelatorio();
      } else {
        this.dialogConfirmaInformacoes = true;
      }
    },
    toSubmeter: function toSubmeter(idRelatorioExtensao) {
      this.$router.push({ name: 'SubmeterRelatorio', params: { idProjeto: this.idProjeto, idRelatorio: idRelatorioExtensao } });
    },
    toAprovar: function toAprovar(idRelatorioExtensao) {
      this.$router.push({ name: 'AprovarRelatorio', params: { idProjeto: this.idProjeto, idRelatorio: idRelatorioExtensao } });
    },
    toDevolver: function toDevolver(idRelatorioExtensao) {
      this.$router.push({ name: 'DevolverRelatorio', params: { idProjeto: this.idProjeto, idRelatorio: idRelatorioExtensao } });
    },
    toReprovar: function toReprovar(idRelatorioExtensao) {
      this.$router.push({ name: 'ReprovarRelatorio', params: { idProjeto: this.idProjeto, idRelatorio: idRelatorioExtensao } });
    },
    toRelatorio: function toRelatorio() {
      this.$router.push({ name: 'Relatorio', params: { idProjeto: this.idProjeto } });
    },
    toAtualizar: function toAtualizar() {
      this.$router.push({ name: 'EditarExtensao', params: { idProjeto: this.idProjeto } });
    },
    toAdicionarRelatorio: function toAdicionarRelatorio() {
      this.$router.push({ name: 'NovoRelatorio', params: { idProjeto: this.projeto.idProjeto } });
    },
    toGerarPDF: function toGerarPDF(idRelatorioExtensao) {
      this.$router.push({ name: 'RelatorioTecnicoPDF', params: { idProjeto: this.idProjeto, idRelatorioExtensao: idRelatorioExtensao } });
    },
    // Verifica se a ação de extensão está na situação "Preenchimento incompleto".
    situacaoPreenchimentoIncompleto: function situacaoPreenchimentoIncompleto() {
      if (this.projeto.situacao.item === 15) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se a ação de extensão está na situação "Aguardando aprovação".
    situacaoAguardandoAprovacao: function situacaoAguardandoAprovacao() {
      if (this.projeto.situacao.item === 16) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se a ação de extensão está na situação "Ativo".
    situacaoAtivo: function situacaoAtivo() {
      if (this.projeto.situacao.item === 18) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se a ação de extensão está na situação "Aguardando relatório".
    situacaoAguardandoRelatorio: function situacaoAguardandoRelatorio() {
      if (this.projeto.situacao.item === 20) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se a ação de extensão está na situação "Inadimplente".
    situacaoInadimplente: function situacaoInadimplente() {
      if (this.projeto.situacao.item === 3) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se a ação de extensão está na situação "Relatório aguardando aprovação".
    situacaoRelatorioAguardandoAprovacao: function situacaoRelatorioAguardandoAprovacao() {
      if (this.projeto.situacao.item === 22) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se a ação de extensão está na situação "Concluído".
    situacaoConcluido: function situacaoConcluido() {
      if (this.projeto.situacao.item === 19) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se a ação de extensão está na situação "Cancelado".
    situacaoCancelado: function situacaoCancelado() {
      if (this.projeto.situacao.item === 5) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se a situação da ação de extensão permite adicionar um novo relatório.
    situacaoAcaoExtensaoHabilitada: function situacaoAcaoExtensaoHabilitada() {
      if (this.situacaoAtivo() || this.situacaoAguardandoRelatorio() || this.situacaoInadimplente()) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se o usuário logado é administrador.
    usuarioAdministrador: function usuarioAdministrador() {
      if (this.administrador === true) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se o usuário logado é o coordenador da ação de extensão.
    usuarioCoordenador: function usuarioCoordenador() {
      if (this.projeto.funcao != null && this.projeto.funcao.item === 1) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se o usuário logado é assessor da ação de extensão.
    usuarioAssessor: function usuarioAssessor() {
      if (this.projeto.assessor === true) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se o usuário logado é usuário Proex.
    usuarioProex: function usuarioProex() {
      if (this.usuarioPROEX === true) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se o usuário logado está habilitado para adicionar um novo relatório.
    usuarioHabilitado: function usuarioHabilitado() {
      if (this.usuarioAdministrador() || this.usuarioCoordenador() || this.usuarioAssessor()) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se o preenchimento do relatório final está habilitado para ações de extensão com registro tardio.
    relatorioHabilitadoAcaoRegistroTardio: function relatorioHabilitadoAcaoRegistroTardio() {
      if (this.projeto.relatorioFinalHabilitado === true) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se o botão 'Novo Relatório' deve ser habilitado.
    habilitaNovoRelatorio: function habilitaNovoRelatorio() {
      if (this.situacaoAcaoExtensaoHabilitada() && this.usuarioHabilitado()) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se o usuário logado possui permissão para visualizar o espelho do relatório.
    usuarioPermissaoEspelhoRelatorio: function usuarioPermissaoEspelhoRelatorio() {
      if (this.situacaoInadimplente() || this.situacaoAtivo() || this.situacaoAguardandoRelatorio() || this.situacaoRelatorioAguardandoAprovacao() || this.situacaoConcluido() || this.situacaoCancelado() || this.relatorioHabilitadoAcaoRegistroTardio() && this.situacaoAguardandoAprovacao()) {
        if (this.usuarioAdministrador() || this.usuarioCoordenador() || this.usuarioAssessor() || this.usuarioProex()) {
          return true;
        } else {
          return false;
        }
      }
    },
    // Verifica se o usuário logado possui permissão para aprovar um relatório técnico.
    usuarioPermissaoAprovarRelatorio: function usuarioPermissaoAprovarRelatorio(situacaoRelatorio) {
      //if (this.situacaoRelatorioAguardandoAprovacao()) {
      if (situacaoRelatorio === 2) {
        if (this.usuarioAdministrador()) {
          return true;
        } else {
          return false;
        }
      }
      //}
    },
    // Verifica se o usuário logado possui permissão para devolver ou reprovar um relatório técnico.
    usuarioPermissaoDevolverReprovarRelatorio: function usuarioPermissaoDevolverReprovarRelatorio(situacaoRelatorio) {
      if (this.relatorioHabilitadoAcaoRegistroTardio() === false) {
        //this.situacaoRelatorioAguardandoAprovacao() &&
        if (situacaoRelatorio === 2) {
          if (this.usuarioAdministrador()) {
            return true;
          } else {
            return false;
          }
        }
      }
    }
  }),
  mounted: function mounted() {
    var _this = this;

    // Busca os relatórios técnicos.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando relatórios.' });
    __WEBPACK_IMPORTED_MODULE_7__utils_projetos__["a" /* default */].getRelatoriosDoProjeto(this.idProjeto).then(function (response) {
      _this.listaRelatorios = response.data.slice();
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando relatórios.' });
    });

    // Endpoint chamado para verificar se é possível adicionar um novo relatório técnico.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Verificando se é possível adicionar um novo relatório.' });
    __WEBPACK_IMPORTED_MODULE_7__utils_projetos__["a" /* default */].getPeriodoRelatorio(this.idProjeto).then(function (response) {
      _this.periodoRelatorio = response.data;
      _this.possivelAdicionar = _this.periodoRelatorio.possivelAdicionar;
      _this.motivo = _this.periodoRelatorio.motivo;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando período do relatório.' });
    });
  },
  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_5__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_1__components_app_layouts_app_tooltip_tooltip___default.a,
    'c-card-footer': __WEBPACK_IMPORTED_MODULE_2__components_c_card_footer___default.a,
    'c-tooltip-btn': __WEBPACK_IMPORTED_MODULE_4__components_c_tooltip_btn___default.a,
    'c-confirm-dialog': __WEBPACK_IMPORTED_MODULE_3__components_c_confirm_dialog___default.a
  }
});

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var methods = {
  formataDataDecisao: function formataDataDecisao(situacaoRelatorioItem, dtAprovacao, dtReprovacao) {
    if (situacaoRelatorioItem === 3) {
      // Relatório aprovado.
      return dtAprovacao;
    } else if (situacaoRelatorioItem === 4) {
      // Relatório reprovado.
      return dtReprovacao;
    } else {
      return null;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (methods);

/***/ }),
/* 511 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "width": "450"
    },
    model: {
      value: (_vm.dialogConfirmaInformacoes),
      callback: function($$v) {
        _vm.dialogConfirmaInformacoes = $$v
      },
      expression: "dialogConfirmaInformacoes"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("Confirma as informações da ação?")]), _vm._v(" "), (_vm.projeto.classificacaoSecundaria.id === 39729 || _vm.projeto.classificacaoSecundaria.id === 44194 || _vm.projeto.classificacaoSecundaria.id === 44195 || _vm.projeto.classificacaoSecundaria.id === 39730) ? _c('div', [_c('v-card-text', {
    staticClass: "title",
    staticStyle: {
      "word-break": "break-word",
      "margin-top": "10px"
    },
    attrs: {
      "align": "justify"
    }
  }, [_vm._v("Para preenchimento\n          do relatório técnico é necessário que todas as informações estejam atualizadas no sistema , incluindo:\n        ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "title",
    staticStyle: {
      "word-break": "break-word",
      "margin-top": "10px"
    },
    attrs: {
      "align": "left"
    }
  }, [_vm._v("- Finalizar a\n          participação dos membros da equipe;\n        ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "title",
    staticStyle: {
      "word-break": "break-word",
      "margin-top": "10px"
    },
    attrs: {
      "align": "left"
    }
  }, [_vm._v("- Preencher a aba\n          Atividades;\n        ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "title",
    staticStyle: {
      "word-break": "break-word",
      "margin-top": "10px"
    },
    attrs: {
      "align": "left"
    }
  }, [_vm._v("- Anexar documentação\n          comprobatória da ação na aba Arquivos.\n        ")])], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.toAtualizar()
      }
    }
  }, [_vm._v("Atualizar as informações da ação")])], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.toAdicionarRelatorio()
      }
    }
  }, [_vm._v("As informações já estão atualizadas")])], 1)], 1)], 1), _vm._v(" "), (_vm.administrador === true || (_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1) || _vm.projeto.assessor === true || _vm.usuarioPROEX === true) ? _c('v-layout', {
    attrs: {
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "instrucao"
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-text', {
    staticClass: "black--text font-weight-bold"
  }, [_vm._v("\n            Em caso de dúvidas ou sugestões entrar em contato pelo e-mail "), _c('a', {
    attrs: {
      "href": "mailto:suporte.proex@ufes.br"
    }
  }, [_vm._v("suporte.proex@ufes.br")]), _vm._v(". Já em caso de problemas com o sistema\n            entrar em contato pelo "), _c('a', {
    attrs: {
      "href": "https://redmine.ufes.br/projects/suporte-projetos-extensao/issues/new",
      "target": "_blank"
    }
  }, [_vm._v("Sistema de Suporte")]), _vm._v(".\n          ")])], 1)], 1)])], 1) : _vm._e(), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaRelatorios,
      "search": _vm.search,
      "no-data-text": 'Nenhum relatório encontrado.',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.id",
      fn: function(props) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'RelatorioTecnico',
              params: {
                idProjeto: _vm.idProjeto,
                idRelatorioExtensao: props.item.id
              }
            }
          }
        }, [_vm._v("\n        Relatório " + _vm._s(props.item.ordem) + "\n      ")])]
      }
    }, {
      key: "item.dtInicial",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dtInicial)))]
      }
    }, {
      key: "item.dtFinal",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dtFinal)))]
      }
    }, {
      key: "item.tipoRelatorioTecnicoItem",
      fn: function(props) {
        return [_vm._v("\n      " + _vm._s(props.item.tipoRelatorioTecnicoItem === 1 ? "Relatório Parcial" :
          props.item.tipoRelatorioTecnicoItem === 2 ? "Relatório Parcial com Renovação" :
          props.item.tipoRelatorioTecnicoItem === 3 ? "Relatório Final" : "Tipo Inválido") + "\n    ")]
      }
    }, {
      key: "item.situacaoRelatorioTecnicoItem",
      fn: function(props) {
        return [_vm._v("\n      " + _vm._s(props.item.situacaoRelatorioTecnicoItem === 1 ? "Em elaboração" :
          props.item.situacaoRelatorioTecnicoItem === 2 ? "Aguardando aprovação" :
          props.item.situacaoRelatorioTecnicoItem === 3 ? "Aprovado" :
          props.item.situacaoRelatorioTecnicoItem === 4 ? "Reprovado" : "Situação inválida") + "\n    ")]
      }
    }, {
      key: "item.dtSubmissaoRelatorio",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dtSubmissaoRelatorio)))]
      }
    }, {
      key: "item.dtDecisaoRelatorio",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(_vm.relatorioTecnico.formataDataDecisao(props.item.situacaoRelatorioTecnicoItem,
          props.item.dtAprovacaoRelatorio, props.item.dtReprovacaoRelatorio))))]
      }
    }, {
      key: "item.opcoes",
      fn: function(props) {
        return [(props.item.situacaoRelatorioTecnicoItem === 1 && (_vm.relatorioHabilitadoAcaoRegistroTardio() === false) && (_vm.situacaoAtivo() || _vm.situacaoAguardandoRelatorio()) && (_vm.usuarioCoordenador() || _vm.usuarioAdministrador())) ? _c('c-tooltip-btn', {
          attrs: {
            "icon": "open_in_browser",
            "color": "primary",
            "disabled": _vm.situacaoAtivo() === true,
            "tooltip": "Submeter para aprovação",
            "disabled-tooltip": "É possível submeter o relatório para aprovação apenas quando a ação de extensão está na situação Aguardando envio de relatório"
          },
          on: {
            "click": function($event) {
              return _vm.toSubmeter(props.item.id)
            }
          }
        }) : _vm._e(), _vm._v(" "), ((props.item.situacaoRelatorioTecnicoItem === 2 || props.item.situacaoRelatorioTecnicoItem === 3) && _vm.usuarioPermissaoEspelhoRelatorio()) ? _c('c-tooltip-btn', {
          attrs: {
            "icon": "picture_as_pdf",
            "color": "primary",
            "tooltip": "Gerar PDF"
          },
          on: {
            "click": function($event) {
              return _vm.toGerarPDF(props.item.id)
            }
          }
        }) : _vm._e(), _vm._v(" "), (_vm.usuarioPermissaoAprovarRelatorio(props.item.situacaoRelatorioTecnicoItem)) ? _c('c-tooltip-btn', {
          attrs: {
            "icon": "done_outline",
            "color": "green",
            "tooltip": "Aprovar"
          },
          on: {
            "click": function($event) {
              return _vm.toAprovar(props.item.id)
            }
          }
        }) : _vm._e(), _vm._v(" "), (_vm.usuarioPermissaoDevolverReprovarRelatorio(props.item.situacaoRelatorioTecnicoItem)) ? _c('c-tooltip-btn', {
          attrs: {
            "icon": "not_interested",
            "color": "red",
            "tooltip": "Devolver"
          },
          on: {
            "click": function($event) {
              return _vm.toDevolver(props.item.id)
            }
          }
        }) : _vm._e(), _vm._v(" "), (_vm.usuarioPermissaoDevolverReprovarRelatorio(props.item.situacaoRelatorioTecnicoItem)) ? _c('c-tooltip-btn', {
          attrs: {
            "icon": "cancel",
            "color": "black",
            "tooltip": "Reprovar"
          },
          on: {
            "click": function($event) {
              return _vm.toReprovar(props.item.id)
            }
          }
        }) : _vm._e()]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n      Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaRelatorios.length) + " relatórios\n    ")]
      }
    }])
  }), _vm._v(" "), _c('c-card-footer', {
    attrs: {
      "projeto": this.projeto,
      "extensao": this.extensao,
      "habilitaBotaoGerarPDFAcao": false
    }
  }, [((_vm.habilitaNovoRelatorio() && (_vm.possivelAdicionar === true)) || (_vm.relatorioHabilitadoAcaoRegistroTardio() && (_vm.possivelAdicionar === true))) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.btnNovoRelatorio
    }
  }, [_vm._v("\n      Novo relatório\n    ")]) : _vm._e(), _vm._v(" "), (_vm.habilitaNovoRelatorio() && _vm.possivelAdicionar === false) ? _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('div', _vm._g({
          staticStyle: {
            "float": "left"
          }
        }, on), [_c('v-btn', {
          attrs: {
            "disabled": "",
            "color": "primary",
            "text": ""
          },
          on: {
            "click": _vm.btnNovoRelatorio
          }
        }, [_vm._v("Novo relatório")])], 1)]
      }
    }], null, false, 236574399)
  }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.motivo))])]) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(513)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(514),
  /* template */
  __webpack_require__(515),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 513 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_date_menu__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_date_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_date_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_textarea__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto'],
  data: function data() {
    return {
      formularioValido: false,
      dates: __WEBPACK_IMPORTED_MODULE_5__utils_dates__["a" /* default */],
      maiorQue150: false,
      dataConclusaoSemLimite: false,
      projeto: {
        titulo: '',
        projetoSup: undefined,
        resumo: '',
        dataInicial: '',
        dataFinal: '',
        situacao: {},
        tipoPublico: {},
        tipoEvento: {},
        classificacoesPrimariaSecundaria: [{}, {}]
      },
      pesquisa: {
        titulo: undefined
      },
      listaTipoPublico: [],
      listaTipoEvento: [],
      listaSituacao: [],
      regrasBasicas: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }],
      tituloRules: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }, function (input) {
        return !!input && input.length <= 150 || 'Este campo não pode possuir mais que 150 caracteres';
      }],
      publicoAlvoEstimadoRules: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }, function (input) {
        return !isNaN(parseFloat(input)) && input > 0 && input <= 10000000 || 'Público-alvo estimado inválido';
      }],
      dataConclusaoRules: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }],
      resumoRules: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }, function (input) {
        return !!input && input.length <= 1000 || 'Este campo não pode possuir mais que 1000 caracteres';
      }],
      numerico: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }, function (input) {
        return !isNaN(input) || 'Este campo deve ser numérico';
      }, function (input) {
        return input.length === 0 || Number(input) !== 0 || 'Este campo não pode ser nulo';
      }, function (input) {
        return input.length === 0 || Number(input) >= 0 || 'Este campo não pode ter valor negativo';
      }]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])('auth', ['administrador', 'usuarioPROEX'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    onChangeDataSemLimite: function onChangeDataSemLimite() {
      this.projeto.dataConclusao = undefined;
      if (this.dataConclusaoSemLimite) {
        this.dataConclusaoRules = [true];
      } else {
        this.dataConclusaoRules = [function (input) {
          return !!input || 'Este campo é obrigatório';
        }];
      }
    },
    permissaoEditar: function permissaoEditar(situacaoAcaoExtensao) {
      // Coordenador ou assessor
      if ((this.usuarioCoordenador() || this.usuarioAssessor()) && situacaoAcaoExtensao === 15) {
        return true;
      } else if (this.usuarioAdministrador() && [3, 4, 15, 16, 18, 19, 20, 22].includes(situacaoAcaoExtensao)) {
        // Administrador
        return true;
      } else {
        return false;
      }
    },
    // Verifica se o usuário logado é o coordenador da ação de extensão.
    usuarioCoordenador: function usuarioCoordenador() {
      if (this.projeto.funcao != null && this.projeto.funcao.item === 1) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se o usuário logado é assessor da ação de extensão.
    usuarioAssessor: function usuarioAssessor() {
      if (this.projeto.assessor === true) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se o usuário logado é administrador.
    usuarioAdministrador: function usuarioAdministrador() {
      if (this.administrador === true) {
        return true;
      } else {
        return false;
      }
    },
    cancelar: function cancelar() {
      this.$router.push({ name: 'ProjetoFormulario', params: { idProjeto: this.idProjeto } });
    },
    editarProjeto: function editarProjeto(avancar) {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Editando Projeto.' });
      this.projeto.idProjeto = undefined;
      this.projeto.dataRegistro = undefined;
      this.projeto.situacao = undefined;
      __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].putProjeto(this.idProjeto, this.projeto).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        if (avancar === false) {
          _this.$router.push({ name: 'ProjetoFormulario', params: { idProjeto: _this.idProjeto } });
        } else {
          _this.$router.push({ name: 'EditarClassificacao', params: { idProjeto: _this.idProjeto } });
        }
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Editando projeto.' });
      });
    },
    opcoesTabelaEstruturada: function opcoesTabelaEstruturada(codTabela, aqui, atributo) {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' });
      __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].getOpcoesTabelaEstruturada(codTabela).then(function (response) {
        aqui[atributo] = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' });
      });
    }
  }),
  mounted: function mounted() {
    var _this3 = this;

    this.opcoesTabelaEstruturada(6011, this, 'listaSituacao');
    this.opcoesTabelaEstruturada(6002, this, 'listaTipoPublico');
    this.opcoesTabelaEstruturada(6028, this, 'listaTipoEvento');

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].getProjeto(this.idProjeto).then(function (response) {
      _this3.projeto = response.data;
      if (_this3.projeto.titulo.length > 150) {
        _this3.maiorQue150 = true;
      }
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this3.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    });
  },
  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_4__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_1__components_app_layouts_app_tooltip_tooltip___default.a,
    'c-date-menu': __WEBPACK_IMPORTED_MODULE_2__components_c_date_menu___default.a,
    'c-textarea': __WEBPACK_IMPORTED_MODULE_3__components_c_textarea___default.a
  }
});

/***/ }),
/* 515 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [(this.permissaoEditar(this.projeto.situacao.item)) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Título",
      "required": "",
      "rules": this.maiorQue150 ? _vm.regrasBasicas : _vm.tituloRules,
      "max-height": "400",
      "counter": "150"
    },
    model: {
      value: (_vm.projeto.titulo),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "titulo", $$v)
      },
      expression: "projeto.titulo"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.permissaoEditar(this.projeto.situacao.item)) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Tipo de público-alvo",
      "items": _vm.listaTipoPublico,
      "item-text": "descricao",
      "item-value": "item",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "return-object": "",
      "required": "",
      "autocomplete": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.projeto.tipoPublico),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "tipoPublico", $$v)
      },
      expression: "projeto.tipoPublico"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field-integer', {
    attrs: {
      "label": "Público-alvo estimado",
      "properties": {
        rules: _vm.numerico
      }
    },
    model: {
      value: (_vm.projeto.publicoAlvo),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "publicoAlvo", $$v)
      },
      expression: "projeto.publicoAlvo"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.permissaoEditar(this.projeto.situacao.item)) ? _c('v-layout', [(_vm.projeto.classificacaoSecundaria.id === 39729) ? _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field-integer', {
    attrs: {
      "label": "Carga horária do curso",
      "properties": {
        rules: _vm.numerico
      }
    },
    model: {
      value: (_vm.projeto.cargaHoraria),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "cargaHoraria", $$v)
      },
      expression: "projeto.cargaHoraria"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (this.permissaoEditar(this.projeto.situacao.item)) ? _c('v-layout', [(_vm.projeto.classificacaoSecundaria.id === 44194) ? _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field-integer', {
    attrs: {
      "label": "Carga horária do curso",
      "properties": {
        rules: _vm.numerico
      }
    },
    model: {
      value: (_vm.projeto.cargaHoraria),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "cargaHoraria", $$v)
      },
      expression: "projeto.cargaHoraria"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (this.permissaoEditar(this.projeto.situacao.item)) ? _c('v-layout', [(_vm.projeto.classificacaoSecundaria.id === 44195) ? _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field-integer', {
    attrs: {
      "label": "Carga horária da oficina",
      "properties": {
        rules: _vm.numerico
      }
    },
    model: {
      value: (_vm.projeto.cargaHoraria),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "cargaHoraria", $$v)
      },
      expression: "projeto.cargaHoraria"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (this.permissaoEditar(this.projeto.situacao.item)) ? _c('v-layout', [(_vm.projeto.classificacaoSecundaria.id === 39730) ? _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field-integer', {
    attrs: {
      "label": "Carga horária do evento",
      "properties": {
        rules: _vm.numerico
      }
    },
    model: {
      value: (_vm.projeto.cargaHoraria),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "cargaHoraria", $$v)
      },
      expression: "projeto.cargaHoraria"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.projeto.classificacaoSecundaria.id !== 39729 && _vm.projeto.classificacaoSecundaria.id !== 44194 && _vm.projeto.classificacaoSecundaria.id !== 44195) ? _c('p', {
    staticClass: "mt-3"
  }) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [((_vm.projeto.classificacaoSecundaria && _vm.projeto.classificacaoSecundaria.id === 39733)) ? _c('v-checkbox', {
    attrs: {
      "value": true
    },
    on: {
      "change": _vm.onChangeDataSemLimite
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("Essa é uma ação contínua, sem data limite")])]
      },
      proxy: true
    }], null, false, 3659365439),
    model: {
      value: (_vm.dataConclusaoSemLimite),
      callback: function($$v) {
        _vm.dataConclusaoSemLimite = $$v
      },
      expression: "dataConclusaoSemLimite"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (this.permissaoEditar(this.projeto.situacao.item)) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Data de início",
      "required": "",
      "type": "date",
      "rules": _vm.regrasBasicas,
      "disabled": _vm.projeto.relatorioFinalHabilitado === true
    },
    model: {
      value: (_vm.projeto.dataInicio),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "dataInicio", $$v)
      },
      expression: "projeto.dataInicio"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Data de conclusão",
      "required": "",
      "type": "date",
      "rules": _vm.dataConclusaoRules,
      "disabled": _vm.projeto.relatorioFinalHabilitado === true
    },
    model: {
      value: (_vm.projeto.dataConclusao),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "dataConclusao", $$v)
      },
      expression: "projeto.dataConclusao"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.permissaoEditar(this.projeto.situacao.item)) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Palavra-chave 1",
      "required": "",
      "rules": _vm.regrasBasicas,
      "max-height": "400"
    },
    model: {
      value: (_vm.projeto.palavraChave01),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "palavraChave01", $$v)
      },
      expression: "projeto.palavraChave01"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Palavra-chave 2",
      "required": "",
      "rules": _vm.regrasBasicas,
      "max-height": "400"
    },
    model: {
      value: (_vm.projeto.palavraChave02),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "palavraChave02", $$v)
      },
      expression: "projeto.palavraChave02"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Palavra-chave 3",
      "required": "",
      "rules": _vm.regrasBasicas,
      "max-height": "400"
    },
    model: {
      value: (_vm.projeto.palavraChave03),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "palavraChave03", $$v)
      },
      expression: "projeto.palavraChave03"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Palavra-chave 4",
      "max-height": "400"
    },
    model: {
      value: (_vm.projeto.palavraChave04),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "palavraChave04", $$v)
      },
      expression: "projeto.palavraChave04"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.permissaoEditar(this.projeto.situacao.item)) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Resumo",
      "required": "",
      "rules": _vm.resumoRules,
      "rows": 5,
      "counter": "1000"
    },
    model: {
      value: (_vm.projeto.resumo),
      callback: function($$v) {
        _vm.$set(_vm.projeto, "resumo", $$v)
      },
      expression: "projeto.resumo"
    }
  })], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.cancelar
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.editarProjeto(false)
      }
    }
  }, [_vm._v("Salvar")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.editarProjeto(true)
      }
    }
  }, [_vm._v("Salvar e Avançar")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(517)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(518),
  /* template */
  __webpack_require__(519),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 517 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto'],
  data: function data() {
    return {
      formularioValido: false,
      dates: __WEBPACK_IMPORTED_MODULE_3__utils_dates__["a" /* default */],
      projeto: {
        titulo: '',
        dataInicio: '',
        dataConclusao: '',
        observacoes: '',
        situacao: {},
        tipoPublico: {},
        tipoEvento: {}
      },
      teste: [{ id: 639 }, { id: 653 }],
      listaClassificacoesDoProjeto: [],
      listaTipoClassificacao: [],
      regrasBasicas: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])('auth', ['logged', 'username', 'nome', 'administrador', 'usuarioPROEX', 'permissaoCriarProjetoExtensao'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    cancelar: function cancelar() {
      this.$router.push({ name: 'ClassificacoesProjeto', params: { idProjeto: this.idProjeto } });
    },
    editarClassificacoes: function editarClassificacoes(avancar) {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Salvando classificações.' });
      __WEBPACK_IMPORTED_MODULE_4__utils_projetos__["a" /* default */].postClassificacoesDoProjeto(this.idProjeto, this.listaClassificacoesDoProjeto).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        if (avancar === false) {
          _this.$router.push({ name: 'ClassificacoesProjeto', params: { idProjeto: _this.idProjeto } });
        } else {
          _this.$router.push({ name: 'EditarExtensao', params: { idProjeto: _this.idProjeto } });
        }
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Salvando classificações.' });
      });
    },
    obterClassificacoes: function obterClassificacoes(itemTabela, aqui, atributo) {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando classificação ' + atributo });
      __WEBPACK_IMPORTED_MODULE_4__utils_projetos__["a" /* default */].getClassificacoesPossiveis(itemTabela).then(function (response) {
        aqui.splice(atributo, 1, response.data.slice());
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando classificação ' + atributo });
      });
    },
    opcoesTabelaEstruturada: function opcoesTabelaEstruturada(codTabela, aqui, atributo) {
      var _this3 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' });
      __WEBPACK_IMPORTED_MODULE_4__utils_projetos__["a" /* default */].getOpcoesTabelaEstruturada(codTabela).then(function (response) {
        aqui[atributo] = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this3.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' });
      });
    },
    desabilitaClassificacoes: function desabilitaClassificacoes(classificacaoItem) {
      if ((classificacaoItem === 100 || classificacaoItem === 110 || classificacaoItem === 111 || classificacaoItem === 112) && this.projeto.situacao.item !== 15 && this.administrador === false) {
        return true;
      } else {
        return false;
      }
    }
  }),
  mounted: function mounted() {
    var _this4 = this;

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando classificações do projeto.' });
    __WEBPACK_IMPORTED_MODULE_4__utils_projetos__["a" /* default */].getClassificacoesDoProjeto(this.idProjeto).then(function (response) {
      /* Ticket #315808 - Resolução CEPE/UFES nº 127/2025  */
      _this4.listaClassificacoesDoProjeto = response.data.filter(function (c) {
        return c.classificacaoItem !== 125;
      });
      for (var i = 0; i < _this4.listaClassificacoesDoProjeto.length; i++) {
        _this4.listaTipoClassificacao.push([{}]);
      }
      for (var e in _this4.listaClassificacoesDoProjeto) {
        _this4.obterClassificacoes(_this4.listaClassificacoesDoProjeto[e].classificacaoItem, _this4.listaTipoClassificacao, e);
      }
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this4.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando classificações do projeto.' });
    });

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    __WEBPACK_IMPORTED_MODULE_4__utils_projetos__["a" /* default */].getProjeto(this.idProjeto).then(function (response) {
      _this4.projeto = response.data;
      _this4.dataInicioFormatada = _this4.dates.format(_this4.projeto.dataInicio);
      _this4.dataConclusaoFormatada = _this4.dates.format(_this4.projeto.dataConclusao);
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this4.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a
  }
});

/***/ }),
/* 519 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', [_c('div', {
    staticClass: "center"
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-text', {
    staticClass: "black--text font-weight-bold"
  }, [_vm._v("\n                Para obter maiores informações sobre os Objetivos de Desenvolvimento Sustentável (ODS), clique no link a seguir: "), _c('a', {
    attrs: {
      "href": "https://ods.ufes.br/",
      "target": "_blank"
    }
  }, [_vm._v("UFES - Objetivos de Desenvolvimento Sustentável")]), _vm._v(".\n              ")])], 1)], 1)])], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  }), _vm._v(" "), _vm._l((this.listaTipoClassificacao), function(lista, index) {
    return _c('v-layout', {
      key: lista[0].tipoClassificacao,
      attrs: {
        "row": "",
        "wrap": "",
        "justify-space-between": ""
      }
    }, [_c('v-flex', [(lista[0].classificacaoItem === 90 || lista[0].classificacaoItem === 91 || _vm.desabilitaClassificacoes(lista[0].classificacaoItem)) ? _c('v-text-field', {
      attrs: {
        "label": lista[0].tipoClassificacao,
        "prepend-icon": "dashboard",
        "readonly": "",
        "max-height": "400"
      },
      model: {
        value: (_vm.listaClassificacoesDoProjeto[index].descricao),
        callback: function($$v) {
          _vm.$set(_vm.listaClassificacoesDoProjeto[index], "descricao", $$v)
        },
        expression: "listaClassificacoesDoProjeto[index].descricao"
      }
    }) : _c('v-select', {
      attrs: {
        "label": lista[0].tipoClassificacao,
        "items": lista,
        "item-text": "descricao",
        "item-value": "id",
        "return-object": "",
        "prepend-icon": "dashboard",
        "max-height": "400",
        "required": "",
        "readonly": lista[0].classificacaoItem === 90 || lista[0].classificacaoItem === 91 || _vm.desabilitaClassificacoes(lista[0].classificacaoItem),
        "autocomplete": ""
      },
      model: {
        value: (_vm.listaClassificacoesDoProjeto[index]),
        callback: function($$v) {
          _vm.$set(_vm.listaClassificacoesDoProjeto, index, $$v)
        },
        expression: "listaClassificacoesDoProjeto[index]"
      }
    })], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.cancelar
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.editarClassificacoes(false)
      }
    }
  }, [_vm._v("Salvar")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.editarClassificacoes(true)
      }
    }
  }, [_vm._v("Salvar e Avançar")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(521)
  __webpack_require__(522)
  __webpack_require__(523)
  __webpack_require__(524)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(525),
  /* template */
  __webpack_require__(526),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ffb0bcb8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 521 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 522 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 523 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 524 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_date_menu__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_date_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_date_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_textarea__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_tooltip_btn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_tooltip_btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_c_tooltip_btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto', 'projeto'],
  data: function data() {
    return {
      dates: __WEBPACK_IMPORTED_MODULE_6__utils_dates__["a" /* default */],
      objetivosEspecificosTopicos: [],
      prazo: 30,
      extensao: {
        captacaoRecursosBensDuraveis: false,
        liberacaoCargaHoraria: false,
        vinculoEnsino: false,
        vinculoPesquisa: false,
        dtPrimeiraApresentacao: '',
        discenteCoordenador: false,
        curso: false,
        oficina: false,
        evento: false,
        gratuito: false,
        modalidade: 'P',
        plataforma: '',
        publicoAlvoInterno: '',
        publicoAlvoExterno: '',
        creditacaoGraduacao: false, // Valor inicial do radio group
        dtInicialCreditacao: null // Valor inicial da data
      },
      listaTiposPrestacaoServicoSelecionados: [],
      listaTiposPrestacaoServico: ['Atendimento ao público em espaços de cultura, ciência e tecnologia', 'Serviço eventual', 'Atividades de propriedade intelectual', 'Exames e laudos técnicos', 'Atendimento jurídico', 'Atendimento em saúde humana', 'Atendimento em saúde animal'],
      listaAtendimentoPublicoEspacosSelecionados: [],
      listaCoordenadoPor: [],
      listaTipoEvento: [],
      listaUnidades: [],
      listaDepartamentos: [],
      formularioValido: false,
      itensCampoEmpresaJunior: [{ descricao: 'Sim', item: true }, { descricao: 'Não', item: false }],
      campoNumericoRules: [function (input) {
        return !isNaN(input) || 'O campo deve ser numérico';
      }, function (input) {
        return input.length === 0 || Number(input) >= 0 || 'O campo não pode ter valor negativo';
      }],
      regrasBasicas: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }],
      AreaDeTextoRules100: [function (input) {
        return input == null || input.length <= 100 || 'Este campo não pode possuir mais que 100 caracteres';
      }],
      rules200: [function (input) {
        return input.length <= 200 || 'Este campo não pode possuir mais que 200 caracteres';
      }],
      AreaDeTextoRules500: [function (input) {
        return input == null || input.length <= 500 || 'Este campo não pode possuir mais que 500 caracteres';
      }],
      AreaDeTextoRulesN1000: [function (input) {
        return input == null || input.length <= 1000 || 'Este campo não pode possuir mais que 1000 caracteres';
      }],
      AreaDeTextoRules1000: [function (input) {
        return input == null || input.length <= 1000 || 'Este campo não pode possuir mais que 1000 caracteres';
      }],
      AreaDeTextoRules1500: [function (input) {
        return input == null || input.length <= 1500 || 'Este campo não pode possuir mais que 1500 caracteres';
      }],
      AreaDeTextoRules2000: [function (input) {
        return input == null || input.length <= 2000 || 'Este campo não pode possuir mais que 2000 caracteres';
      }],
      AreaDeTextoRules3000: [function (input) {
        return input == null || input.length <= 3000 || 'Este campo não pode possuir mais que 3000 caracteres';
      }],
      CargaHorariaCoordenadorAprovadaRules: [function (input) {
        return !isNaN(input) || 'A carga horária deve ser numérica';
      }, function (input) {
        return input.length === 0 || Number(input) !== 0 || 'A carga horária não pode ser nula';
      }, function (input) {
        return input.length === 0 || Number(input) > 0 || 'A carga horária não pode ser negativa';
      }]
    };
  },
  watch: {
    // Watcher para monitorar mudanças em extensao.creditacaoGraduacao
    'extensao.creditacaoGraduacao': function extensaoCreditacaoGraduacao(newValue) {
      if (newValue === false) {
        // Se "Não" for selecionado, define dtInicialCreditacao como null
        this.extensao.dtInicialCreditacao = null;
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])('auth', ['administrador'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    cancelar: function cancelar() {
      this.$router.push({ name: 'ExtensaoProjeto', params: { idProjeto: this.idProjeto } });
    },
    editarExtensao: function editarExtensao(avancar) {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Salvando informações de extensão.' });
      this.extensao.objetivosEspecificos = '';
      for (var item in this.objetivosEspecificosTopicos) {
        this.extensao.objetivosEspecificos += this.objetivosEspecificosTopicos[item].nome;
        if (item < this.objetivosEspecificosTopicos.length - 1) {
          this.extensao.objetivosEspecificos += ';;';
        }
      }

      // Verificações para Prestações de Serviço.
      if (this.extensao.prestacaoServico === true) {
        // Tipo de Prestação de Serviço (Atendimento ao público em espaços de cultura, ciência e tecnologia)
        if (this.listaTiposPrestacaoServicoSelecionados.includes('Atendimento ao público em espaços de cultura, ciência e tecnologia')) {
          this.extensao.atendimentoPublicoEspacos = 'S';
        } else {
          this.extensao.atendimentoPublicoEspacos = 'N';
        }
        // Tipo de Prestação de Serviço (Serviço eventual)
        if (this.listaTiposPrestacaoServicoSelecionados.includes('Serviço eventual')) {
          this.extensao.servicoEventual = 'S';
        } else {
          this.extensao.servicoEventual = 'N';
        }
        // Tipo de Prestação de Serviço (Atividades de propriedade intelectual)
        if (this.listaTiposPrestacaoServicoSelecionados.includes('Atividades de propriedade intelectual')) {
          this.extensao.atividadesPropriedadeIntelectual = 'S';
        } else {
          this.extensao.atividadesPropriedadeIntelectual = 'N';
        }
        // Tipo de Prestação de Serviço (Exames e laudos técnicos)
        if (this.listaTiposPrestacaoServicoSelecionados.includes('Exames e laudos técnicos')) {
          this.extensao.examesLaudosTecnicos = 'S';
        } else {
          this.extensao.examesLaudosTecnicos = 'N';
        }
        // Tipo de Prestação de Serviço (Atendimento jurídico)
        if (this.listaTiposPrestacaoServicoSelecionados.includes('Atendimento jurídico')) {
          this.extensao.atendimentoJuridico = 'S';
        } else {
          this.extensao.atendimentoJuridico = 'N';
        }
        // Tipo de Prestação de Serviço (Atendimento em saúde humana)
        if (this.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')) {
          this.extensao.atendimentoSaudeHumana = 'S';
        } else {
          this.extensao.atendimentoSaudeHumana = 'N';
        }
        // Tipo de Prestação de Serviço (Atendimento em saúde animal)
        if (this.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde animal')) {
          this.extensao.atendimentoSaudeAnimal = 'S';
        } else {
          this.extensao.atendimentoSaudeAnimal = 'N';
        }
        // Atendimento ao público em espaços de cultura, ciência e tecnologia (Espaços e Museus Culturais)
        if (this.listaAtendimentoPublicoEspacosSelecionados.includes('Espaços e Museus Culturais')) {
          this.extensao.espacosMuseusCulturais = 'S';
        } else {
          this.extensao.espacosMuseusCulturais = 'N';
        }
        // Atendimento ao público em espaços de cultura, ciência e tecnologia (Espaços e Museus de Ciência e Tecnologia)
        if (this.listaAtendimentoPublicoEspacosSelecionados.includes('Espaços e Museus de Ciência e Tecnologia')) {
          this.extensao.espacosMuseusCT = 'S';
        } else {
          this.extensao.espacosMuseusCT = 'N';
        }
        // Atendimento ao público em espaços de cultura, ciência e tecnologia (Cines-clube)
        if (this.listaAtendimentoPublicoEspacosSelecionados.includes('Cines-clube')) {
          this.extensao.cinesClube = 'S';
        } else {
          this.extensao.cinesClube = 'N';
        }
        // Atendimento ao público em espaços de cultura, ciência e tecnologia (Outros)
        if (this.listaAtendimentoPublicoEspacosSelecionados.includes('Outros')) {
          this.extensao.outrosEspacos = 'S';
        } else {
          this.extensao.outrosEspacos = 'N';
        }

        // Limpa campos caso o tipo "Atendimento ao público em espaços de cultura, ciência e tecnologia" não seja escolhido.
        if (this.listaTiposPrestacaoServicoSelecionados.includes('Atendimento ao público em espaços de cultura, ciência e tecnologia') === false) {
          this.listaAtendimentoPublicoEspacosSelecionados = [];
        }

        // Limpa campos caso o tipo "Serviço eventual" não seja escolhido.
        if (this.listaTiposPrestacaoServicoSelecionados.includes('Serviço eventual') === false) {
          this.extensao.numAssessorias = null;
          this.extensao.numConsultorias = null;
          this.extensao.numCuradorias = null;
          this.extensao.numOutrosServicos = null;
        }

        // Limpa campos caso o tipo "Atividades de propriedade intelectual" não seja escolhido.
        if (this.listaTiposPrestacaoServicoSelecionados.includes('Atividades de propriedade intelectual') === false) {
          this.extensao.numPatentesModelos = null;
          this.extensao.numMarcasSoftwares = null;
          this.extensao.numTransferenciaTecnologia = null;
          this.extensao.numDireitosAutorais = null;
        }

        // Limpa campos caso o tipo "Exames e laudos técnicos" não seja escolhido.
        if (this.listaTiposPrestacaoServicoSelecionados.includes('Exames e laudos técnicos') === false) {
          this.extensao.numLaudosEmitidos = null;
        }

        // Limpa campos caso o tipo "Atendimento jurídico" não seja escolhido.
        if (this.listaTiposPrestacaoServicoSelecionados.includes('Atendimento jurídico') === false) {
          this.extensao.numAtendimentosJuridicos = null;
        }

        // Limpa campos caso o tipo "Atendimento em saúde humana" não seja escolhido.
        if (this.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana') === false) {
          this.extensao.numConsultasAmbulatoriais = null;
          this.extensao.numConsultasEmergencia = null;
          this.extensao.numInternacoes = null;
          this.extensao.numCirurgias = null;
          this.extensao.numExamesLaboratoriais = null;
          this.extensao.numExamesComplementares = null;
          this.extensao.numOutrosAtendimentosSH = null;
        }

        // Limpa campos caso o tipo "Atendimento em saúde animal" não seja escolhido.
        if (this.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde animal') === false) {
          this.extensao.numAtendimentosVeterinarios = null;
          this.extensao.numInternacoesVeterinarias = null;
          this.extensao.numCirurgiasVeterinarias = null;
          this.extensao.numExamesVeterinaria = null;
        }
      }

      // Limpa campos caso a opção "Envolve captação de recursos financeiros ou bens duráveis" seja 'Não'.
      if (this.extensao.captacaoRecursosBensDuraveis === false) {
        this.extensao.captacaoRecursosUfes = null;
        this.extensao.captacaoRecursosCapes = null;
        this.extensao.captacaoRecursosFest = null;
        this.extensao.captacaoRecursosCnpq = null;
        this.extensao.captacaoRecursosFapes = null;
        this.extensao.captacaoRecursosFucam = null;
        this.extensao.captacaoRecursosOutros = null;
        this.extensao.especCaptacaoRecursosOutros = null;
      }

      // Limpa campos caso a opção "Envolve captação de recursos financeiros ou bens duráveis" seja 'Sim', mas a opção "Outros" não seja marcada.
      if (this.extensao.captacaoRecursosBensDuraveis === true) {
        if (this.extensao.captacaoRecursosOutros === null || this.extensao.captacaoRecursosOutros === false) {
          this.extensao.especCaptacaoRecursosOutros = null;
        }
      }

      // Limpa campos caso a opção "Gratuito para o público" seja 'Sim'.
      if (this.extensao.gratuito === true) {
        this.extensao.gratuitoUfes = null;
        this.extensao.gratuitoFest = null;
        this.extensao.gratuitoFucam = null;
        this.extensao.gratuitoOutros = null;
        this.extensao.especGratuitoOutros = null;
      }

      // Limpa campos caso a opção "Gratuito para o público" seja 'Não', mas a opção "Outros" não seja marcada.
      if (this.extensao.gratuito === false) {
        if (this.extensao.gratuitoOutros === null || this.extensao.gratuitoOutros === false) {
          this.extensao.especGratuitoOutros = null;
        }
      }

      // Limpa campos caso a opção "Envolve liberação de carga horária do coordenador aprovada em Departamento/Centro/Setor de lotação" seja 'Não'.
      if (this.extensao.liberacaoCargaHoraria === false) {
        this.extensao.cargaHorariaCoordenadorAprovada = null;
      }

      __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].postExtensao(this.idProjeto, this.extensao).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        if (avancar === false) {
          // this.$router.push({name: 'ExtensaoProjeto', params: {idProjeto: this.idProjeto}})
        } else {
          _this.$router.push({ name: 'IntegrantesProjeto', params: { idProjeto: _this.idProjeto } });
        }
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Salvando informações de extensão.' });
      });
    },
    opcoesTabelaEstruturada: function opcoesTabelaEstruturada(codTabela, aqui, atributo) {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' });
      __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getOpcoesTabelaEstruturada(codTabela).then(function (response) {
        aqui[atributo] = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' });
      });
    }
  }),
  mounted: function mounted() {
    var _this3 = this;

    this.opcoesTabelaEstruturada(990, this, 'listaCoordenadoPor');
    this.opcoesTabelaEstruturada(6028, this, 'listaTipoEvento');

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações.' });
    __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getExtensaoDoProjeto(this.idProjeto).then(function (response) {
      _this3.extensao = response.data;

      var aux = _this3.extensao.objetivosEspecificos.split(';;');
      for (var item in aux) {
        _this3.objetivosEspecificosTopicos.push({ id: item, nome: aux[item] });
      }

      _this3.dataPrimeiraApresentacaoFormatada = _this3.dates.format(_this3.extensao.dtPrimeiraApresentacao);

      // Tipo de Prestação de Serviço (Atendimento ao público em espaços de cultura, ciência e tecnologia)
      if (_this3.extensao.atendimentoPublicoEspacos === 'S') {
        _this3.listaTiposPrestacaoServicoSelecionados.push('Atendimento ao público em espaços de cultura, ciência e tecnologia');
      }

      // Tipo de Prestação de Serviço (Serviço eventual)
      if (_this3.extensao.servicoEventual === 'S') {
        _this3.listaTiposPrestacaoServicoSelecionados.push('Serviço eventual');
      }

      // Tipo de Prestação de Serviço (Atividades de propriedade intelectual)
      if (_this3.extensao.atividadesPropriedadeIntelectual === 'S') {
        _this3.listaTiposPrestacaoServicoSelecionados.push('Atividades de propriedade intelectual');
      }

      // Tipo de Prestação de Serviço (Exames e laudos técnicos)
      if (_this3.extensao.examesLaudosTecnicos === 'S') {
        _this3.listaTiposPrestacaoServicoSelecionados.push('Exames e laudos técnicos');
      }

      // Tipo de Prestação de Serviço (Atendimento jurídico)
      if (_this3.extensao.atendimentoJuridico === 'S') {
        _this3.listaTiposPrestacaoServicoSelecionados.push('Atendimento jurídico');
      }

      // Tipo de Prestação de Serviço (Atendimento em saúde humana)
      if (_this3.extensao.atendimentoSaudeHumana === 'S') {
        _this3.listaTiposPrestacaoServicoSelecionados.push('Atendimento em saúde humana');
      }

      // Tipo de Prestação de Serviço (Atendimento em saúde animal)
      if (_this3.extensao.atendimentoSaudeAnimal === 'S') {
        _this3.listaTiposPrestacaoServicoSelecionados.push('Atendimento em saúde animal');
      }

      // Atendimento ao público em espaços de cultura, ciência e tecnologia (Espaços e Museus Culturais)
      if (_this3.extensao.espacosMuseusCulturais === 'S') {
        _this3.listaAtendimentoPublicoEspacosSelecionados.push('Espaços e Museus Culturais');
      }

      // Atendimento ao público em espaços de cultura, ciência e tecnologia (Espaços e Museus de Ciência e Tecnologia)
      if (_this3.extensao.espacosMuseusCT === 'S') {
        _this3.listaAtendimentoPublicoEspacosSelecionados.push('Espaços e Museus de Ciência e Tecnologia');
      }

      // Atendimento ao público em espaços de cultura, ciência e tecnologia (Cines-clube)
      if (_this3.extensao.cinesClube === 'S') {
        _this3.listaAtendimentoPublicoEspacosSelecionados.push('Cines-clube');
      }

      // Atendimento ao público em espaços de cultura, ciência e tecnologia (Outros)
      if (_this3.extensao.outrosEspacos === 'S') {
        _this3.listaAtendimentoPublicoEspacosSelecionados.push('Outros');
      }
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this3.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações.' });
    });

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando unidades.' });
    __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getUnidadesExtensao().then(function (response) {
      _this3.listaUnidades = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this3.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando unidades.' });
    });

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações adicionais.' });
    __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getPrazoDias(this.idProjeto).then(function (response) {
      _this3.prazo = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this3.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações adicionais.' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'c-date-menu': __WEBPACK_IMPORTED_MODULE_2__components_c_date_menu___default.a,
    'c-textarea': __WEBPACK_IMPORTED_MODULE_3__components_c_textarea___default.a,
    'c-tooltip-btn': __WEBPACK_IMPORTED_MODULE_4__components_c_tooltip_btn___default.a
  }
});

/***/ }),
/* 526 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('br'), _vm._v(" "), (_vm.administrador === false && ((_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1 && _vm.projeto.situacao.item === 18) || (_vm.projeto.assessor === true && _vm.projeto.situacao.item === 18))) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "center"
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-text', {
    staticClass: "black--text font-weight-bold"
  }, [_vm._v("\n                Como a ação de extensão está na situação \"Ativo\", é possível alterar apenas os campos \"Objetivos específicos\" e \"Informações adicionais\".\n              ")])], 1)], 1)])], 1) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [(_vm.administrador === true) ? _c('v-select', {
    attrs: {
      "items": _vm.listaUnidades,
      "eager": "",
      "item-text": "nomeSigla",
      "item-value": "id",
      "label": "Unidade",
      "return-object": "",
      "autocomplete": "",
      "required": ""
    },
    model: {
      value: (_vm.extensao.unidade),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "unidade", $$v)
      },
      expression: "extensao.unidade"
    }
  }) : _c('v-select', {
    attrs: {
      "items": _vm.listaUnidades,
      "item-text": "nomeSigla",
      "item-value": "id",
      "label": "Unidade",
      "return-object": "",
      "readonly": "",
      "autocomplete": "",
      "required": "",
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    model: {
      value: (_vm.extensao.unidade),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "unidade", $$v)
      },
      expression: "extensao.unidade"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.listaCoordenadoPor,
      "item-text": "descricao",
      "item-value": "item",
      "return-object": "",
      "label": "Coordenado por",
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    model: {
      value: (_vm.extensao.coordenadoPor),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "coordenadoPor", $$v)
      },
      expression: "extensao.coordenadoPor"
    }
  })], 1)], 1), _vm._v(" "), (_vm.extensao.evento) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.listaTipoEvento,
      "item-text": "descricao",
      "item-value": "item",
      "return-object": "",
      "label": "Tipo de Evento",
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    model: {
      value: (_vm.extensao.tipoEvento),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "tipoEvento", $$v)
      },
      expression: "extensao.tipoEvento"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Data da primeira apresentação",
      "type": "date",
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    model: {
      value: (_vm.extensao.dtPrimeiraApresentacao),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "dtPrimeiraApresentacao", $$v)
      },
      expression: "extensao.dtPrimeiraApresentacao"
    }
  })], 1)], 1), _vm._v(" "), (_vm.projeto.classificacaoSecundaria.id === 39733) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.itensCampoEmpresaJunior,
      "item-text": "descricao",
      "item-value": "item",
      "label": "O programa é uma Empresa Júnior?",
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    model: {
      value: (_vm.extensao.empresaJunior),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "empresaJunior", $$v)
      },
      expression: "extensao.empresaJunior"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.projeto.classificacaoSecundaria.id === 39733) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-alert', {
    staticClass: "alerta",
    attrs: {
      "color": "#00796b",
      "type": "info",
      "dense": "",
      "outlined": ""
    }
  }, [_vm._v("\n            Conforme os Artigos 03, 06 e 10 da Resolução nº.10/2019 do Conselho Universitário, as empresas juniores deverão ser cadastradas na Pró-Reitoria de Extensão – PROEX como Programa de Extensão.\n          ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-textarea', {
    attrs: {
      "rows": 2,
      "auto-grow": true,
      "multi-line": "",
      "counter": "2000",
      "label": "Apresentação",
      "rules": _vm.AreaDeTextoRules2000,
      "disabled": !(_vm.administrador === true || (_vm.projeto.funcao !== null && _vm.projeto.funcao.item === 1))
    },
    model: {
      value: (_vm.extensao.apresentacao),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "apresentacao", $$v)
      },
      expression: "extensao.apresentacao"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-textarea', {
    attrs: {
      "rows": 2,
      "auto-grow": true,
      "multi-line": "",
      "counter": "2000",
      "label": "Justificativa / Mérito extensionista",
      "rules": _vm.AreaDeTextoRules2000,
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    model: {
      value: (_vm.extensao.justificativa),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "justificativa", $$v)
      },
      expression: "extensao.justificativa"
    }
  })], 1)], 1), _vm._v(" "), (_vm.extensao.caracterizacaoPublicoAlvo) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('div', _vm._g({}, on), [_c('c-textarea', _vm._g({
          attrs: {
            "rows": 2,
            "auto-grow": true,
            "multi-line": "",
            "counter": "500",
            "label": "Caracterização do público-alvo",
            "rules": _vm.AreaDeTextoRules500,
            "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
          },
          model: {
            value: (_vm.extensao.caracterizacaoPublicoAlvo),
            callback: function($$v) {
              _vm.$set(_vm.extensao, "caracterizacaoPublicoAlvo", $$v)
            },
            expression: "extensao.caracterizacaoPublicoAlvo"
          }
        }, on))], 1)]
      }
    }], null, false, 3992814955)
  }, [_vm._v(" "), _c('span', [_c('div', [_vm._v("As atividades de extensão devem envolver diretamente as comunidades externas às instituições de ensino superior e estarem vinculadas à formação do estudante (Resolução CNE 07/2018, Art. 7°).")])])])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.extensao.caracterizacaoPublicoAlvo && _vm.projeto.tipoPublico.item === 1) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-textarea', _vm._g({
    attrs: {
      "rows": 2,
      "auto-grow": true,
      "multi-line": "",
      "counter": "500",
      "label": "Caracterização do público-alvo interno (membros da comunidade acadêmica)",
      "rules": _vm.AreaDeTextoRules500,
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    model: {
      value: (_vm.extensao.publicoAlvoInterno),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "publicoAlvoInterno", $$v)
      },
      expression: "extensao.publicoAlvoInterno"
    }
  }, _vm.on))], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.extensao.caracterizacaoPublicoAlvo) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-textarea', _vm._g({
    attrs: {
      "rows": 2,
      "auto-grow": true,
      "multi-line": "",
      "counter": "500",
      "label": "Caracterização do público-alvo externo (membros da sociedade)",
      "rules": _vm.AreaDeTextoRules500,
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    model: {
      value: (_vm.extensao.publicoAlvoExterno),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "publicoAlvoExterno", $$v)
      },
      expression: "extensao.publicoAlvoExterno"
    }
  }, _vm.on))], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-textarea', {
    attrs: {
      "rows": 2,
      "auto-grow": true,
      "multi-line": "",
      "counter": "500",
      "label": "Objetivo geral",
      "rules": _vm.AreaDeTextoRules500,
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    model: {
      value: (_vm.extensao.objetivosGerais),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "objetivosGerais", $$v)
      },
      expression: "extensao.objetivosGerais"
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "id": "label"
    }
  }, [_vm._v("Objetivos específicos (Liste os objetivos separadamente em tópicos. Para abrir um novo tópico, clique no ícone +)")]), _vm._v(" "), _c('v-list', {
    staticClass: "label",
    attrs: {
      "id": "label",
      "two-line": "",
      "dense": ""
    }
  }, [_vm._l((_vm.objetivosEspecificosTopicos), function(item, index) {
    return _c('v-list-item', {
      key: item.id,
      staticStyle: {
        "padding": "0px"
      }
    }, [_c('v-list-item-avatar', [_vm._v("\n                " + _vm._s(index + 1) + ".\n              ")]), _vm._v(" "), _c('v-list-item-content', [_c('v-text-field', {
      attrs: {
        "auto-grow": true,
        "placeholder": "Digite o objetivo específico",
        "rules": _vm.AreaDeTextoRulesN1000
      },
      model: {
        value: (item.nome),
        callback: function($$v) {
          _vm.$set(item, "nome", $$v)
        },
        expression: "item.nome"
      }
    })], 1), _vm._v(" "), (_vm.administrador === true || (_vm.projeto.funcao !== null && _vm.projeto.funcao.item === 1)) ? _c('v-list-item-action', [_c('c-tooltip-btn', {
      attrs: {
        "icon": "remove_circle",
        "color": "red",
        "tooltip": "Adicionar objetivo específico"
      },
      on: {
        "click": function($event) {
          return _vm.objetivosEspecificosTopicos.splice(index, 1)
        }
      }
    })], 1) : _vm._e()], 1)
  }), _vm._v(" "), _c('v-list-item', {
    staticStyle: {
      "padding": "0px"
    }
  }, [(_vm.administrador === true || (_vm.projeto.funcao !== null && _vm.projeto.funcao.item === 1)) ? _c('v-list-item-action', [_c('c-tooltip-btn', {
    attrs: {
      "icon": "add_box",
      "color": "green",
      "tooltip": "Adicionar objetivo específico"
    },
    on: {
      "click": function($event) {
        return _vm.objetivosEspecificosTopicos.push({
          nome: ''
        })
      }
    }
  })], 1) : _vm._e()], 1)], 2)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-textarea', {
    attrs: {
      "rows": 2,
      "auto-grow": true,
      "multi-line": "",
      "counter": "3000",
      "label": "Metodologia",
      "rules": _vm.AreaDeTextoRules3000,
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    model: {
      value: (_vm.extensao.metodologia),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "metodologia", $$v)
      },
      expression: "extensao.metodologia"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.extensao.curso || _vm.extensao.oficina) ? _c('c-textarea', {
    attrs: {
      "rows": 2,
      "auto-grow": true,
      "multi-line": "",
      "counter": "1000",
      "label": "Formas de avaliação dos cursistas (descrever os meios avaliativos, o peso das avaliações e a frequência mínima para a aprovação dos cursistas)",
      "rules": _vm.AreaDeTextoRules1000,
      "disabled": !(_vm.administrador === true || (_vm.projeto.funcao !== null && _vm.projeto.funcao.item === 1))
    },
    model: {
      value: (_vm.extensao.formaAvaliacao),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "formaAvaliacao", $$v)
      },
      expression: "extensao.formaAvaliacao"
    }
  }) : _c('c-textarea', {
    attrs: {
      "rows": 2,
      "auto-grow": true,
      "multi-line": "",
      "counter": "1000",
      "label": "Forma de avaliação",
      "rules": _vm.AreaDeTextoRules1000,
      "disabled": !(_vm.administrador === true || (_vm.projeto.funcao !== null && _vm.projeto.funcao.item === 1))
    },
    model: {
      value: (_vm.extensao.formaAvaliacao),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "formaAvaliacao", $$v)
      },
      expression: "extensao.formaAvaliacao"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-textarea', {
    attrs: {
      "rows": 2,
      "auto-grow": true,
      "multi-line": "",
      "counter": "1000",
      "label": "Infraestrutura física",
      "rules": _vm.AreaDeTextoRules1000,
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    model: {
      value: (_vm.extensao.infraestruturaFisica),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "infraestruturaFisica", $$v)
      },
      expression: "extensao.infraestruturaFisica"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-textarea', {
    attrs: {
      "rows": 2,
      "auto-grow": true,
      "multi-line": "",
      "counter": "1000",
      "label": "Informações adicionais",
      "disabled": !(_vm.administrador === true || (_vm.projeto.funcao !== null && _vm.projeto.funcao.item === 1))
    },
    model: {
      value: (_vm.extensao.informacoesAdicionais),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "informacoesAdicionais", $$v)
      },
      expression: "extensao.informacoesAdicionais"
    }
  })], 1)], 1), _vm._v(" "), (_vm.extensao.prestacaoServico) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.listaTiposPrestacaoServico,
      "chips": "",
      "label": "Tipo de Prestação de Serviço",
      "multiple": ""
    },
    model: {
      value: (_vm.listaTiposPrestacaoServicoSelecionados),
      callback: function($$v) {
        _vm.listaTiposPrestacaoServicoSelecionados = $$v
      },
      expression: "listaTiposPrestacaoServicoSelecionados"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento ao público em espaços de cultura, ciência e tecnologia')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "tipoPrestacaoServico"
  }, [_vm._v("Tipo: Atendimento ao público em espaços de cultura, ciência e tecnologia")]), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "value": "Espaços e Museus Culturais"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("Espaços e Museus Culturais")])]
      },
      proxy: true
    }], null, false, 1352582964),
    model: {
      value: (_vm.listaAtendimentoPublicoEspacosSelecionados),
      callback: function($$v) {
        _vm.listaAtendimentoPublicoEspacosSelecionados = $$v
      },
      expression: "listaAtendimentoPublicoEspacosSelecionados"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento ao público em espaços de cultura, ciência e tecnologia')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "value": "Espaços e Museus de Ciência e Tecnologia"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("Espaços e Museus de Ciência e Tecnologia")])]
      },
      proxy: true
    }], null, false, 820644792),
    model: {
      value: (_vm.listaAtendimentoPublicoEspacosSelecionados),
      callback: function($$v) {
        _vm.listaAtendimentoPublicoEspacosSelecionados = $$v
      },
      expression: "listaAtendimentoPublicoEspacosSelecionados"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento ao público em espaços de cultura, ciência e tecnologia')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "value": "Cines-clube"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("Cines-clube")])]
      },
      proxy: true
    }], null, false, 2587689909),
    model: {
      value: (_vm.listaAtendimentoPublicoEspacosSelecionados),
      callback: function($$v) {
        _vm.listaAtendimentoPublicoEspacosSelecionados = $$v
      },
      expression: "listaAtendimentoPublicoEspacosSelecionados"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento ao público em espaços de cultura, ciência e tecnologia')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "value": "Outros"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("Outros")])]
      },
      proxy: true
    }], null, false, 900719639),
    model: {
      value: (_vm.listaAtendimentoPublicoEspacosSelecionados),
      callback: function($$v) {
        _vm.listaAtendimentoPublicoEspacosSelecionados = $$v
      },
      expression: "listaAtendimentoPublicoEspacosSelecionados"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Serviço eventual')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('p', {
    staticClass: "tipoPrestacaoServico"
  }, [_vm._v("Tipo: Serviço eventual")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Nº de assessorias",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (_vm.extensao.numAssessorias),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "numAssessorias", $$v)
      },
      expression: "extensao.numAssessorias"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Serviço eventual')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nº de consultorias",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (_vm.extensao.numConsultorias),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "numConsultorias", $$v)
      },
      expression: "extensao.numConsultorias"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Serviço eventual')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nº de curadorias",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (_vm.extensao.numCuradorias),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "numCuradorias", $$v)
      },
      expression: "extensao.numCuradorias"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Serviço eventual')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nº de outros",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (_vm.extensao.numOutrosServicos),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "numOutrosServicos", $$v)
      },
      expression: "extensao.numOutrosServicos"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atividades de propriedade intelectual')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('p', {
    staticClass: "tipoPrestacaoServico"
  }, [_vm._v("Tipo: Atividades de propriedade intelectual")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Nº de depósito de patentes e modelos de utilidades",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (_vm.extensao.numPatentesModelos),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "numPatentesModelos", $$v)
      },
      expression: "extensao.numPatentesModelos"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atividades de propriedade intelectual')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nº de registro de marcas e softwares",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (_vm.extensao.numMarcasSoftwares),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "numMarcasSoftwares", $$v)
      },
      expression: "extensao.numMarcasSoftwares"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atividades de propriedade intelectual')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nº de contratos de transferência de tecnologia",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (_vm.extensao.numTransferenciaTecnologia),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "numTransferenciaTecnologia", $$v)
      },
      expression: "extensao.numTransferenciaTecnologia"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atividades de propriedade intelectual')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nº de registros de direitos autorais",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (_vm.extensao.numDireitosAutorais),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "numDireitosAutorais", $$v)
      },
      expression: "extensao.numDireitosAutorais"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Exames e laudos técnicos')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('p', {
    staticClass: "tipoPrestacaoServico"
  }, [_vm._v("Tipo: Exames e laudos técnicos")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Nº de laudos emitidos",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (_vm.extensao.numLaudosEmitidos),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "numLaudosEmitidos", $$v)
      },
      expression: "extensao.numLaudosEmitidos"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento jurídico')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('p', {
    staticClass: "tipoPrestacaoServico"
  }, [_vm._v("Tipo: Atendimento jurídico")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Nº de atendimentos",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (_vm.extensao.numAtendimentosJuridicos),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "numAtendimentosJuridicos", $$v)
      },
      expression: "extensao.numAtendimentosJuridicos"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('p', {
    staticClass: "tipoPrestacaoServico"
  }, [_vm._v("Tipo: Atendimento em saúde humana")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Nº de consultas ambulatoriais (programadas)",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (_vm.extensao.numConsultasAmbulatoriais),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "numConsultasAmbulatoriais", $$v)
      },
      expression: "extensao.numConsultasAmbulatoriais"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nº de consultas de emergência e urgência",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (_vm.extensao.numConsultasEmergencia),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "numConsultasEmergencia", $$v)
      },
      expression: "extensao.numConsultasEmergencia"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nº de internações",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (_vm.extensao.numInternacoes),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "numInternacoes", $$v)
      },
      expression: "extensao.numInternacoes"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nº de cirurgias",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (_vm.extensao.numCirurgias),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "numCirurgias", $$v)
      },
      expression: "extensao.numCirurgias"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nº de exames laboratoriais",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (_vm.extensao.numExamesLaboratoriais),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "numExamesLaboratoriais", $$v)
      },
      expression: "extensao.numExamesLaboratoriais"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nº de exames complementares",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (_vm.extensao.numExamesComplementares),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "numExamesComplementares", $$v)
      },
      expression: "extensao.numExamesComplementares"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nº de outros atendimentos",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (_vm.extensao.numOutrosAtendimentosSH),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "numOutrosAtendimentosSH", $$v)
      },
      expression: "extensao.numOutrosAtendimentosSH"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde animal')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('p', {
    staticClass: "tipoPrestacaoServico"
  }, [_vm._v("Tipo: Atendimento em saúde animal")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Nº de atendimentos veterinários ambulatoriais",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (_vm.extensao.numAtendimentosVeterinarios),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "numAtendimentosVeterinarios", $$v)
      },
      expression: "extensao.numAtendimentosVeterinarios"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde animal')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nº de internações veterinárias",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (_vm.extensao.numInternacoesVeterinarias),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "numInternacoesVeterinarias", $$v)
      },
      expression: "extensao.numInternacoesVeterinarias"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde animal')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nº de cirurgias veterinárias",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (_vm.extensao.numCirurgiasVeterinarias),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "numCirurgiasVeterinarias", $$v)
      },
      expression: "extensao.numCirurgiasVeterinarias"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde animal')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nº de exames laboratoriais e complementares em veterinária",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (_vm.extensao.numExamesVeterinaria),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "numExamesVeterinaria", $$v)
      },
      expression: "extensao.numExamesVeterinaria"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "v-radio-group_label",
    attrs: {
      "label": "Possui vínculo com ensino",
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    model: {
      value: (_vm.extensao.vinculoEnsino),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "vinculoEnsino", $$v)
      },
      expression: "extensao.vinculoEnsino"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Sim",
      "value": true
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Não",
      "value": false
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "v-radio-group_label",
    attrs: {
      "label": "Possui vínculo com pesquisa",
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    model: {
      value: (_vm.extensao.vinculoPesquisa),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "vinculoPesquisa", $$v)
      },
      expression: "extensao.vinculoPesquisa"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Sim",
      "value": true
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Não",
      "value": false
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "v-radio-group_label",
    attrs: {
      "label": "Esta ação realiza divulgação científica",
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    model: {
      value: (_vm.extensao.divulgacaoCientifica),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "divulgacaoCientifica", $$v)
      },
      expression: "extensao.divulgacaoCientifica"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Sim",
      "value": true
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Não",
      "value": false
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "v-radio-group_label",
    attrs: {
      "label": "Esta é uma ação direcionada às escolas públicas (alunos, professores, servidores ou processo de formação continuada)",
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    model: {
      value: (_vm.extensao.direcionadaEscolaPublica),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "direcionadaEscolaPublica", $$v)
      },
      expression: "extensao.direcionadaEscolaPublica"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Sim",
      "value": true
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Não",
      "value": false
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm5": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "v-radio-group_label",
    attrs: {
      "label": "Esta ação será utilizada para a creditação da extensão nos cursos de graduação da UFES",
      "disabled": !(_vm.administrador === true || (_vm.projeto.funcao !== null && _vm.projeto.funcao.item === 1 && _vm.projeto.situacao.item === 15))
    },
    model: {
      value: (_vm.extensao.creditacaoGraduacao),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "creditacaoGraduacao", $$v)
      },
      expression: "extensao.creditacaoGraduacao"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Sim",
      "value": true
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Não",
      "value": false
    }
  })], 1)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Data inicial da creditação",
      "type": "date",
      "disabled": !_vm.extensao.creditacaoGraduacao
    },
    model: {
      value: (_vm.extensao.dtInicialCreditacao),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "dtInicialCreditacao", $$v)
      },
      expression: "extensao.dtInicialCreditacao"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "v-radio-group_label",
    attrs: {
      "label": "Envolve captação de recursos financeiros ou bens duráveis",
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    model: {
      value: (_vm.extensao.captacaoRecursosBensDuraveis),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "captacaoRecursosBensDuraveis", $$v)
      },
      expression: "extensao.captacaoRecursosBensDuraveis"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Sim",
      "value": true
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Não",
      "value": false
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.extensao.captacaoRecursosBensDuraveis === true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', [_vm._v("Por meio de:")])])], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.captacaoRecursosBensDuraveis === true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("UFES")])]
      },
      proxy: true
    }], null, false, 566531570),
    model: {
      value: (_vm.extensao.captacaoRecursosUfes),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "captacaoRecursosUfes", $$v)
      },
      expression: "extensao.captacaoRecursosUfes"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("CAPES")])]
      },
      proxy: true
    }], null, false, 433251667),
    model: {
      value: (_vm.extensao.captacaoRecursosCapes),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "captacaoRecursosCapes", $$v)
      },
      expression: "extensao.captacaoRecursosCapes"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("Fundação de apoio")])]
      },
      proxy: true
    }], null, false, 3770891229),
    model: {
      value: (_vm.extensao.captacaoRecursosFest),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "captacaoRecursosFest", $$v)
      },
      expression: "extensao.captacaoRecursosFest"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.captacaoRecursosBensDuraveis === true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("CNPq")])]
      },
      proxy: true
    }], null, false, 623129403),
    model: {
      value: (_vm.extensao.captacaoRecursosCnpq),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "captacaoRecursosCnpq", $$v)
      },
      expression: "extensao.captacaoRecursosCnpq"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("FAPES")])]
      },
      proxy: true
    }], null, false, 300731254),
    model: {
      value: (_vm.extensao.captacaoRecursosFapes),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "captacaoRecursosFapes", $$v)
      },
      expression: "extensao.captacaoRecursosFapes"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.captacaoRecursosBensDuraveis === true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("Outros")])]
      },
      proxy: true
    }], null, false, 900719639),
    model: {
      value: (_vm.extensao.captacaoRecursosOutros),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "captacaoRecursosOutros", $$v)
      },
      expression: "extensao.captacaoRecursosOutros"
    }
  })], 1), _vm._v(" "), (_vm.extensao.captacaoRecursosBensDuraveis === true) ? _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm5": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "disabled": _vm.extensao.captacaoRecursosOutros !== true || (_vm.administrador !== true && _vm.projeto.situacao.item !== 15),
      "label": "Especifique:",
      "rows": "1",
      "auto-grow": "",
      "counter": "200",
      "rules": _vm.rules200,
      "placeholder": " "
    },
    model: {
      value: (_vm.extensao.especCaptacaoRecursosOutros),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "especCaptacaoRecursosOutros", $$v)
      },
      expression: "extensao.especCaptacaoRecursosOutros"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "v-radio-group_label",
    attrs: {
      "label": "Envolve liberação de carga horária do coordenador aprovada em Departamento/Centro/Setor de lotação",
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    model: {
      value: (_vm.extensao.liberacaoCargaHoraria),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "liberacaoCargaHoraria", $$v)
      },
      expression: "extensao.liberacaoCargaHoraria"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Sim",
      "value": true
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Não",
      "value": false
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.extensao.liberacaoCargaHoraria === true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "rows": 1,
      "label": "Carga horária aprovada",
      "rules": _vm.CargaHorariaCoordenadorAprovadaRules,
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    model: {
      value: (_vm.extensao.cargaHorariaCoordenadorAprovada),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "cargaHorariaCoordenadorAprovada", $$v)
      },
      expression: "extensao.cargaHorariaCoordenadorAprovada"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.curso || _vm.extensao.oficina || _vm.extensao.evento) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "v-radio-group_label",
    attrs: {
      "label": "Gratuito para o público",
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    model: {
      value: (_vm.extensao.gratuito),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "gratuito", $$v)
      },
      expression: "extensao.gratuito"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Sim",
      "value": true
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Não",
      "value": false
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.gratuito === false) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', [_vm._v("Os recursos financeiros obtidos serão administrados por:")])])], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.gratuito === false) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("UFES")])]
      },
      proxy: true
    }], null, false, 566531570),
    model: {
      value: (_vm.extensao.gratuitoUfes),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "gratuitoUfes", $$v)
      },
      expression: "extensao.gratuitoUfes"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.gratuito === false) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("FEST")])]
      },
      proxy: true
    }], null, false, 1159691731),
    model: {
      value: (_vm.extensao.gratuitoFest),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "gratuitoFest", $$v)
      },
      expression: "extensao.gratuitoFest"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.gratuito === false) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("FUCAM")])]
      },
      proxy: true
    }], null, false, 2822406859),
    model: {
      value: (_vm.extensao.gratuitoFucam),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "gratuitoFucam", $$v)
      },
      expression: "extensao.gratuitoFucam"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "center": ""
    }
  }, [(_vm.extensao.gratuito === false) ? _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("Outros")])]
      },
      proxy: true
    }], null, false, 900719639),
    model: {
      value: (_vm.extensao.gratuitoOutros),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "gratuitoOutros", $$v)
      },
      expression: "extensao.gratuitoOutros"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.gratuito === false) ? _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm5": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "disabled": _vm.extensao.gratuitoOutros !== true || (_vm.administrador !== true && _vm.projeto.situacao.item !== 15),
      "label": "Especifique:",
      "rows": "1",
      "auto-grow": "",
      "counter": "200",
      "rules": _vm.rules200,
      "placeholder": " "
    },
    model: {
      value: (_vm.extensao.especGratuitoOutros),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "especGratuitoOutros", $$v)
      },
      expression: "extensao.especGratuitoOutros"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.extensao.curso || _vm.extensao.oficina) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "v-radio-group_label",
    attrs: {
      "label": "Modalidade",
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    model: {
      value: (_vm.extensao.modalidade),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "modalidade", $$v)
      },
      expression: "extensao.modalidade"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Presencial",
      "value": "P"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Semipresencial",
      "value": "S"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "EAD",
      "value": "D"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.curso || _vm.extensao.oficina) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "v-radio-group_label",
    attrs: {
      "label": "Utiliza o AVA Extensão",
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    model: {
      value: (_vm.extensao.utilizaAvaExtensao),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "utilizaAvaExtensao", $$v)
      },
      expression: "extensao.utilizaAvaExtensao"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Sim",
      "value": true
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Não",
      "value": false
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.curso || _vm.extensao.oficina) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Em caso de utilização de outro Ambiente Virtual de Aprendizagem (AVA), indique a plataforma",
      "counter": "100",
      "rules": _vm.AreaDeTextoRules100,
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    model: {
      value: (_vm.extensao.plataforma),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "plataforma", $$v)
      },
      expression: "extensao.plataforma"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.cancelar
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.editarExtensao(false)
      }
    }
  }, [_vm._v("Salvar")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.editarExtensao(true)
      }
    }
  }, [_vm._v("Salvar e Avançar")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(528)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(529),
  /* template */
  __webpack_require__(530),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 528 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto', 'projeto'],
  data: function data() {
    return {
      formularioValido: false,
      dates: __WEBPACK_IMPORTED_MODULE_4__utils_dates__["a" /* default */],
      contatos: {
        site: '',
        midiasSociais: '',
        nomeContato: '',
        email: '',
        telefone: ''
      },
      projeto: {
        titulo: '',
        projetoSup: undefined,
        resumo: '',
        dataInicial: '',
        dataFinal: '',
        situacao: {},
        tipoPublico: {},
        tipoEvento: {},
        classificacoesPrimariaSecundaria: [{}, {}]
      },
      pesquisa: {
        titulo: undefined
      },
      listaTipoPublico: [],
      listaTipoEvento: [],
      listaSituacao: [],
      regras100: [function (input) {
        return input.length <= 100 || 'Este campo não pode possuir mais que 100 caracteres';
      }],
      regras200: [function (input) {
        return input.length <= 200 || 'Este campo não pode possuir mais que 200 caracteres';
      }],
      regras60: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }, function (input) {
        return input.length <= 60 || 'Este campo não pode possuir mais que 60 caracteres';
      }],
      regras30: [function (input) {
        return input.length <= 30 || 'Este campo não pode possuir mais que 30 caracteres';
      }],
      regras50: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }, function (input) {
        return !!input && input.length <= 50 || 'Este campo não pode possuir mais que 50 caracteres';
      }]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])('auth', ['administrador', 'usuarioPROEX'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    cancelar: function cancelar() {
      this.$router.push({ name: 'ContatosProjeto', params: { idProjeto: this.idProjeto } });
    },
    editarContatos: function editarContatos(avancar) {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Editando Contatos..' });
      __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].postContatos(this.idProjeto, this.contatos).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        if (avancar === false) {
          _this.$router.push({ name: 'ContatosProjeto', params: { idProjeto: _this.idProjeto } });
        } else {
          _this.$router.push({ name: 'IntegrantesProjeto', params: { idProjeto: _this.idProjeto } });
        }
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Editando Contatos..' });
      });
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando contatos.' });
    __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getContatosDoProjeto(this.idProjeto).then(function (response) {
      _this2.contatos = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando contatos.' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a,
    'c-date-menu': __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default.a
  }
});

/***/ }),
/* 530 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.administrador === true || _vm.usuarioPROEX === true || _vm.projeto.funcao.item === 1 || _vm.projeto.assessor === true) ? _c('div', {
    staticClass: "tituloSecao"
  }, [_c('label', [_vm._v("Contatos do coordenador (disponíveis apenas para os administradores do sistema e para os usuários PROEX)")])]) : _vm._e()])], 1), _vm._v(" "), (_vm.administrador === true || _vm.usuarioPROEX === true || _vm.projeto.funcao.item === 1 || _vm.projeto.assessor === true) ? _c('div', [_c('br')]) : _vm._e(), _vm._v(" "), (_vm.administrador === true || _vm.usuarioPROEX === true || _vm.projeto.funcao.item === 1 || _vm.projeto.assessor === true) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "E-mail*",
      "counter": "50",
      "rules": _vm.regras50
    },
    model: {
      value: (_vm.contatos.emailCoordenador),
      callback: function($$v) {
        _vm.$set(_vm.contatos, "emailCoordenador", $$v)
      },
      expression: "contatos.emailCoordenador"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.administrador === true || _vm.usuarioPROEX === true || _vm.projeto.funcao.item === 1 || _vm.projeto.assessor === true) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Telefone*",
      "counter": "50",
      "rules": _vm.regras50
    },
    model: {
      value: (_vm.contatos.telefoneCoordenador),
      callback: function($$v) {
        _vm.$set(_vm.contatos, "telefoneCoordenador", $$v)
      },
      expression: "contatos.telefoneCoordenador"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.administrador === true || _vm.usuarioPROEX === true || _vm.projeto.funcao.item === 1 || _vm.projeto.assessor === true) ? _c('div', [_c('br')]) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.administrador === true || _vm.usuarioPROEX === true || _vm.projeto.funcao.item === 1 || _vm.projeto.assessor === true) ? _c('div', {
    staticClass: "tituloSecao"
  }, [_c('label', [_vm._v("Contatos da ação de extensão (as informações de contato abaixo ficarão disponíveis para a consulta pública)")])]) : _vm._e()])], 1), _vm._v(" "), (_vm.administrador === true || _vm.usuarioPROEX === true || _vm.projeto.funcao.item === 1 || _vm.projeto.assessor === true) ? _c('div', [_c('br')]) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Site",
      "counter": "100",
      "rules": _vm.regras100
    },
    model: {
      value: (_vm.contatos.site),
      callback: function($$v) {
        _vm.$set(_vm.contatos, "site", $$v)
      },
      expression: "contatos.site"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Instagram",
      "counter": "100",
      "rules": _vm.regras100
    },
    model: {
      value: (_vm.contatos.instagram),
      callback: function($$v) {
        _vm.$set(_vm.contatos, "instagram", $$v)
      },
      expression: "contatos.instagram"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Facebook",
      "counter": "100",
      "rules": _vm.regras100
    },
    model: {
      value: (_vm.contatos.facebook),
      callback: function($$v) {
        _vm.$set(_vm.contatos, "facebook", $$v)
      },
      expression: "contatos.facebook"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Youtube",
      "counter": "100",
      "rules": _vm.regras100
    },
    model: {
      value: (_vm.contatos.youtube),
      callback: function($$v) {
        _vm.$set(_vm.contatos, "youtube", $$v)
      },
      expression: "contatos.youtube"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Outras mídias sociais",
      "rows": "1",
      "auto-grow": "",
      "counter": "100",
      "rules": _vm.regras100
    },
    model: {
      value: (_vm.contatos.midiasSociais),
      callback: function($$v) {
        _vm.$set(_vm.contatos, "midiasSociais", $$v)
      },
      expression: "contatos.midiasSociais"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome do contato",
      "counter": "200",
      "rules": _vm.regras200
    },
    model: {
      value: (_vm.contatos.nomeContato),
      callback: function($$v) {
        _vm.$set(_vm.contatos, "nomeContato", $$v)
      },
      expression: "contatos.nomeContato"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "E-mail*",
      "counter": "60",
      "rules": _vm.regras60
    },
    model: {
      value: (_vm.contatos.email),
      callback: function($$v) {
        _vm.$set(_vm.contatos, "email", $$v)
      },
      expression: "contatos.email"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Telefone",
      "counter": "30",
      "rules": _vm.regras30
    },
    model: {
      value: (_vm.contatos.telefone),
      callback: function($$v) {
        _vm.$set(_vm.contatos, "telefone", $$v)
      },
      expression: "contatos.telefone"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.cancelar
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.editarContatos(false)
      }
    }
  }, [_vm._v("Salvar")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(532)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(533),
  /* template */
  __webpack_require__(534),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 532 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto', 'projeto'],
  data: function data() {
    return {
      listaIntegrantes: [],
      dates: __WEBPACK_IMPORTED_MODULE_3__utils_dates__["a" /* default */],
      search: null,
      sortBy: 'funcao.descricao',
      sortDesc: false,
      itemsPerPage: 25,
      opcoesPaginacao: [10, 25, 50, { text: 'Todas', value: -1 }],
      headers: [{ text: 'Nome', align: 'center', value: 'nome' }, { text: 'Função', align: 'center', value: 'funcao.descricao' }, { text: 'Vínculo', align: 'center', value: 'vinculo' }, { text: 'CH semanal', align: 'center', value: 'cargaHoraria' }, { text: 'Data de entrada', align: 'center', value: 'dataEntrada' }, { text: 'Data de saída', align: 'center', value: 'dataSaida' }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING']), {
    truncate: function truncate(string, limit) {
      if (string.length > limit) return string.substring(0, limit) + '...';else return string;
    },

    toNovoIntegrante: function toNovoIntegrante() {
      this.$router.push({ name: 'NovoIntegrante', params: { idProjeto: this.idProjeto } });
    },
    toAvancar: function toAvancar() {
      this.$router.push({ name: 'EditarAtividades', params: { idProjeto: this.projeto.idProjeto } });
    }
  }),
  mounted: function mounted() {
    var _this = this;

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando integrantes.' });
    __WEBPACK_IMPORTED_MODULE_4__utils_projetos__["a" /* default */].getIntegrantesDoProjeto(this.idProjeto).then(function (response) {
      _this.listaIntegrantes = response.data.slice();
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando integrantes.' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a
  }
});

/***/ }),
/* 534 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaIntegrantes,
      "search": _vm.search,
      "no-data-text": 'Este projeto não possui integrantes.',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.nome",
      fn: function(props) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'EditarIntegrante',
              params: {
                idProjeto: _vm.idProjeto,
                idParticipante: props.item.idParticipante
              }
            }
          }
        }, [_vm._v("\n        " + _vm._s(props.item.nome) + "\n      ")])]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n      Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaIntegrantes.length) + " integrantes\n    ")]
      }
    }])
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1) ? _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.toNovoIntegrante
    }
  }, [_vm._v("Adicionar")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.toAvancar
    }
  }, [_vm._v("Avançar")])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(536)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(537),
  /* template */
  __webpack_require__(538),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 536 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto', 'projeto'],
  data: function data() {
    return {
      listaParcerias: [],
      dates: __WEBPACK_IMPORTED_MODULE_3__utils_dates__["a" /* default */],
      search: null,
      sortBy: 'funcao.descricao',
      sortDesc: false,
      itemsPerPage: 25,
      opcoesPaginacao: [10, 25, 50, { text: 'Todas', value: -1 }],
      headers: [{ text: 'Nome do parceiro', align: 'left', value: 'descricao' }, { text: 'Detalhamento', align: 'left', value: 'detalhamento' }, { text: 'Excluir', align: 'left', value: 'opcoes' }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    truncate: function truncate(string, limit) {
      if (string.length > limit) return string.substring(0, limit) + '...';else return string;
    },

    toCriarParceria: function toCriarParceria() {
      this.$router.push({ name: 'NovaParceria', params: { idProjeto: this.idProjeto } });
    },
    toAvancar: function toAvancar() {
      this.$router.push({ name: 'EditarAbrangencia', params: { idProjeto: this.projeto.idProjeto } });
    },
    carregaParcerias: function carregaParcerias(idProjeto) {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando parcerias.' });
      __WEBPACK_IMPORTED_MODULE_4__utils_projetos__["a" /* default */].getParceriasDoProjeto(this.idProjeto).then(function (response) {
        _this.listaParcerias = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando parcerias.' });
      });
    },
    excluirParceria: function excluirParceria(idParceria) {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo parceria.' });
      __WEBPACK_IMPORTED_MODULE_4__utils_projetos__["a" /* default */].deleteParceria(this.idProjeto, idParceria).then(function (response) {
        _this2.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this2.carregaParcerias(_this2.idProjeto);
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this2.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo parceria.' });
      });
    }
  }),
  mounted: function mounted() {
    this.carregaParcerias(this.idProjeto);
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a
  }
});

/***/ }),
/* 538 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaParcerias,
      "search": _vm.search,
      "no-data-text": 'Este projeto não possui parcerias.',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.opcoes",
      fn: function(props) {
        return [_c('v-btn', {
          attrs: {
            "color": "primary",
            "text": "",
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.excluirParceria(props.item.id)
            }
          }
        }, [_c('v-icon', [_vm._v("delete")])], 1)]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n      Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaParcerias.length) + " parcerias\n    ")]
      }
    }])
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1) ? _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.toCriarParceria
    }
  }, [_vm._v("Nova Parceria")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.toAvancar
    }
  }, [_vm._v("Avançar")])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(540)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(541),
  /* template */
  __webpack_require__(542),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 540 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto', 'projeto'],
  data: function data() {
    return {
      listaAtividades: [],
      dates: __WEBPACK_IMPORTED_MODULE_3__utils_dates__["a" /* default */],
      search: null,
      sortBy: 'funcao.descricao',
      sortDesc: false,
      itemsPerPage: 25,
      opcoesPaginacao: [10, 25, 50, { text: 'Todas', value: -1 }],
      headers: [{ text: 'Descrição', align: 'left', value: 'descricao' }, { text: 'Detalhamento', align: 'left', value: 'detalhamento' }, { text: 'Início', align: 'left', value: 'dtInicioPrevisto' }, { text: 'Fim', align: 'left', value: 'dtFimPrevisto' }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING']), {
    truncate: function truncate(string, limit) {
      if (string.length > limit) return string.substring(0, limit) + '...';else return string;
    },

    toCriarAtividade: function toCriarAtividade() {
      this.$router.push({ name: 'NovaAtividade', params: { idProjeto: this.idProjeto } });
    },
    toAvancar: function toAvancar() {
      this.$router.push({ name: 'EditarParcerias', params: { idProjeto: this.projeto.idProjeto } });
    }
  }),
  mounted: function mounted() {
    var _this = this;

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando atividades.' });
    __WEBPACK_IMPORTED_MODULE_4__utils_projetos__["a" /* default */].getAtividadesDoProjeto(this.idProjeto).then(function (response) {
      _this.listaAtividades = response.data.slice();
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando atividades.' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a
  }
});

/***/ }),
/* 542 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaAtividades,
      "search": _vm.search,
      "no-data-text": 'Este projeto não possui atividades.',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.descricao",
      fn: function(props) {
        return [(_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1) ? _c('div', [_c('router-link', {
          attrs: {
            "to": {
              name: 'EditarAtividade',
              params: {
                idProjeto: _vm.idProjeto,
                idAtividade: props.item.id
              }
            }
          }
        }, [_vm._v("\n          " + _vm._s(props.item.descricao) + "\n        ")])], 1) : _c('div', [_vm._v("\n        " + _vm._s(props.item.descricao) + "\n      ")])]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n      Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaAtividades.length) + " atividades\n    ")]
      }
    }])
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1) ? _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.toCriarAtividade
    }
  }, [_vm._v("Nova Atividade")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.toAvancar
    }
  }, [_vm._v("Avançar")])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(544)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(545),
  /* template */
  __webpack_require__(546),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 544 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto', 'projeto'],
  data: function data() {
    return {
      listaLocalidades: [],
      dates: __WEBPACK_IMPORTED_MODULE_3__utils_dates__["a" /* default */],
      search: null,
      sortBy: 'funcao.descricao',
      sortDesc: false,
      itemsPerPage: 25,
      opcoesPaginacao: [10, 25, 50, { text: 'Todas', value: -1 }],
      headers: [{ text: 'Descrição', align: 'left', value: 'nome' }, { text: 'Cidade', align: 'left', value: 'cidade.nomeCidade' }, { text: 'Detalhes', align: 'left', value: 'detalhamento' }, { text: 'CEP', align: 'left', value: 'cep' }, { text: 'Excluir', align: 'left' }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    truncate: function truncate(string, limit) {
      if (string.length > limit) return string.substring(0, limit) + '...';else return string;
    },

    toNovaLocalidade: function toNovaLocalidade() {
      this.$router.push({ name: 'NovaLocalidade', params: { idProjeto: this.idProjeto } });
    },
    toAvancar: function toAvancar() {
      this.$router.push({ name: 'EditarArquivos', params: { idProjeto: this.idProjeto } });
    },
    toLimparLocalidades: function toLimparLocalidades() {
      var _this = this;

      if (confirm('Deseja realmente exluir todas as localidades cadastradas?')) {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo localidade.' });
        this.listaLocalidades.forEach(function (item) {
          _this.excluirLocalidade(item.id);
        });
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo localidade.' });
      }
    },
    carregaLocalidades: function carregaLocalidades(idProjeto) {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando localidades.' });
      __WEBPACK_IMPORTED_MODULE_4__utils_projetos__["a" /* default */].getListaLocalidade(this.idProjeto).then(function (response) {
        _this2.listaLocalidades = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando localidades.' });
      });
    },
    excluirLocalidade: function excluirLocalidade(idLocalidade) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_4__utils_projetos__["a" /* default */].deleteLocalidade(this.idProjeto, idLocalidade).then(function (response) {
        _this3.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this3.carregaLocalidades(_this3.idProjeto);
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this3.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {});
    }
  }),
  mounted: function mounted() {
    this.carregaLocalidades(this.idProjeto);
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a
  }
});

/***/ }),
/* 546 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaLocalidades,
      "search": _vm.search,
      "no-data-text": 'Este projeto não possui localidades.',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.opcoes",
      fn: function(props) {
        return [_c('v-btn', {
          attrs: {
            "color": "primary",
            "text": "",
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.excluirLocalidade(props.item.id)
            }
          }
        }, [_c('v-icon', [_vm._v("delete")])], 1)]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n      Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaLocalidades.length) + " localidades\n    ")]
      }
    }])
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1) ? _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.toLimparLocalidades
    }
  }, [_vm._v("Limpar")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.toNovaLocalidade
    }
  }, [_vm._v("Nova Localidade")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.toAvancar
    }
  }, [_vm._v("Avançar")])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(548)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(549),
  /* template */
  __webpack_require__(550),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 548 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto', 'projeto'],
  data: function data() {
    return {
      api_url: "https://pib-api.prod.uks.ufes.br",
      listaArquivos: [],
      dates: __WEBPACK_IMPORTED_MODULE_3__utils_dates__["a" /* default */],
      search: null,
      sortBy: 'dtInclusao',
      sortDesc: false,
      itemsPerPage: 25,
      opcoesPaginacao: [10, 25, 50, { text: 'Todas', value: -1 }],
      headers: [{ text: 'Nome', align: 'center', value: 'nome' }, { text: 'Tipo', align: 'center', value: 'tipoArquivo.descricao' }, { text: 'Acesso', align: 'center', value: 'nivelAcesso' }, { text: 'Data de inclusão', align: 'center', value: 'dtInclusao' }, { text: 'Observação', align: 'center', value: 'observacao' }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING']), {
    truncate: function truncate(string, limit) {
      if (string.length > limit) return string.substring(0, limit) + '...';else return string;
    },

    toUploadArquivo: function toUploadArquivo() {
      this.$router.push({ name: 'UploadArquivo', params: { idProjeto: this.idProjeto } });
    },
    toAvancar: function toAvancar() {
      this.$router.push({ name: 'RelatoriosProjeto', params: { idProjeto: this.idProjeto } });
    }
  }),
  mounted: function mounted() {
    var _this = this;

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando arquivos.' });
    __WEBPACK_IMPORTED_MODULE_4__utils_projetos__["a" /* default */].getArquivosDoProjeto(this.idProjeto).then(function (response) {
      _this.listaArquivos = response.data.slice();
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando arquivos.' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a
  }
});

/***/ }),
/* 550 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaArquivos,
      "search": _vm.search,
      "no-data-text": 'Este projeto não possui arquivos.',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.nome",
      fn: function(props) {
        return [_c('a', {
          attrs: {
            "href": _vm.api_url + 'projetos/' + _vm.idProjeto + '/arquivos/' + props.item.idArquivo
          }
        }, [_c('v-icon', [_vm._v("fa fa-fw fa-download")]), _vm._v(_vm._s(props.item.nome.trim()) + "\n      ")], 1)]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n      Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaArquivos.length) + " arquivos\n    ")]
      }
    }])
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1) ? _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.toUploadArquivo
    }
  }, [_vm._v("Adicionar")])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(552)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(553),
  /* template */
  __webpack_require__(556),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 552 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_textarea__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_c_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_c_checkbox_table__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_c_checkbox_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_c_checkbox_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto', 'idLocalidade'],
  data: function data() {
    return {
      search: null,
      headers: [{ checkbox: true, sortable: false }, { text: 'Nome', align: 'center', value: 'nomeCidade' }],
      sortDesc: false,
      itemsPerPage: 5,
      opcoesPaginacao: [5, 10, 25, 50, { text: 'Todas', value: -1 }],
      formularioValido: false,
      localidade: {
        nome: '',
        detalhamento: '',
        ufCidade: {}
      },
      contador: 0,
      projeto: {
        titulo: '',
        dataInicio: '',
        dataConclusao: '',
        observacoes: '',
        situacao: {},
        tipoPublico: {},
        tipoEvento: {}
      },
      listaEstados: [],
      listaCidades: [],
      listaCidadesSelecionadas: [],
      regrasBasicas: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }],
      assuntoSummaryRules: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }, function (input) {
        return !!input && input.length <= 200 || 'Este campo não pode possuir mais que 200 caracteres';
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    cancelar: function cancelar() {
      this.$router.push({ name: 'AbrangenciaProjeto', params: { idProjeto: this.idProjeto } });
    },
    editarLocalidade: function editarLocalidade() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].putLocalidade(this.idProjeto, this.idLocalidade, this.localidade).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.$router.push({ name: 'AbrangenciaProjeto', params: { idProjeto: _this.idProjeto } });
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {});
    },
    atualizaCidades: function atualizaCidades(event) {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando cidades.' });
      __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].getCidades(event.item).then(function (response) {
        _this2.listaCidades = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando cidades.' });
      });
    },
    atualizaListaCidadesSelecionadas: function atualizaListaCidadesSelecionadas(cidade) {
      console.log(this.listaCidadesSelecionadas);
    },
    opcoesTabelaEstruturada: function opcoesTabelaEstruturada(codTabela, aqui, atributo) {
      var _this3 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' });
      __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].getOpcoesTabelaEstruturada(codTabela).then(function (response) {
        aqui[atributo] = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this3.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' });
      });
    }
  }),
  mounted: function mounted() {
    var _this4 = this;

    console.log(this.idLocalidade);

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].getProjeto(this.idProjeto).then(function (response) {
      _this4.projeto = response.data;
      _this4.dataInicioFormatada = _this4.dates.format(_this4.projeto.dataInicio);
      _this4.dataConclusaoFormatada = _this4.dates.format(_this4.projeto.dataConclusao);
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this4.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    });

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando estados.' });
    __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].getEstados(1).then(function (response) {
      _this4.listaEstados = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this4.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando estados.' });
    });

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando localidade.' });
    __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].getLocalidade(this.idProjeto, this.idLocalidade).then(function (response) {
      _this4.localidade = response.data;

      _this4.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando estado.' });
      __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].getCidades(_this4.localidade.ufCidade.item).then(function (response) {
        _this4.listaCidades = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this4.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando estado.' });
      });
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this4.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando localidade.' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a,
    'c-date-menu': __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default.a,
    'c-checkbox-table': __WEBPACK_IMPORTED_MODULE_5__components_c_checkbox_table___default.a,
    'c-textarea': __WEBPACK_IMPORTED_MODULE_4__components_c_textarea___default.a
  }
});

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_dates__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['items', 'headers', 'search', 'opcoesPaginacao', 'value', 'itemKey', 'selecionarTudo', 'hideDefaultFooter', 'headerProps'],
  data: function data() {
    return {
      dates: __WEBPACK_IMPORTED_MODULE_0__utils_dates__["a" /* default */],
      todosSelecionados: false,
      checkboxes: []
    };
  },
  watch: {
    value: function value(val) {
      this.checkboxes = val.slice();
      console.log(this.checkboxes);
    },
    dataFormatada: function dataFormatada(val) {
      if (val === null) {
        this.data = '';
        this.$emit('input', undefined);
      }
    }
  },
  methods: {
    atualizaSelecionado: function atualizaSelecionado(cidade) {
      if (this.checkboxes.includes(cidade[this.itemKey])) {
        this.checkboxes.splice(this.checkboxes.indexOf(cidade[this.itemKey]), 1);
      } else {
        this.checkboxes.push(cidade[this.itemKey]);
      }
      this.$emit('input', this.checkboxes);
    },
    selecionarTodos: function selecionarTodos() {
      var _this = this;

      this.todosSelecionados = !this.todosSelecionados;
      if (this.todosSelecionados === true) {
        this.items.forEach(function (unidade) {
          _this.checkboxes.push(unidade[_this.itemKey]);
        });
      } else {
        this.checkboxes.splice(0, this.checkboxes.length);
      }
      this.$emit('input', this.checkboxes);
    }
  },
  mounted: function mounted() {
    this.checkboxes = this.value;
  }
});

/***/ }),
/* 555 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "search": _vm.search,
      "hide-default-footer": _vm.hideDefaultFooter,
      "header-props": _vm.headerProps,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      },
      "item-key": _vm.itemKey
    },
    on: {
      "click:row": _vm.atualizaSelecionado
    },
    scopedSlots: _vm._u([{
      key: "header.checkbox",
      fn: function(ref) {
        var header = ref.header;

        return [(_vm.selecionarTudo === true) ? _c('v-checkbox', {
          attrs: {
            "color": "primary",
            "input-value": _vm.todosSelecionados
          },
          on: {
            "change": _vm.selecionarTodos
          }
        }) : _vm._e()]
      }
    }, {
      key: "item.checkbox",
      fn: function(props) {
        return [_c('v-checkbox', {
          attrs: {
            "color": "primary",
            "input-value": _vm.checkboxes.includes(props.item[_vm.itemKey]),
            "readonly": ""
          }
        })]
      }
    }])
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 556 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Editar Localidade'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome da localidade ou instituição",
      "required": "",
      "rules": _vm.regrasBasicas,
      "max-height": "400"
    },
    model: {
      value: (_vm.localidade.nome),
      callback: function($$v) {
        _vm.$set(_vm.localidade, "nome", $$v)
      },
      expression: "localidade.nome"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Estado",
      "items": _vm.listaEstados,
      "item-text": "descricao",
      "item-value": "item",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "return-object": "",
      "required": "",
      "autocomplete": "",
      "rules": _vm.regrasBasicas
    },
    on: {
      "change": function($event) {
        return _vm.atualizaCidades($event)
      }
    },
    model: {
      value: (_vm.localidade.ufCidade),
      callback: function($$v) {
        _vm.$set(_vm.localidade, "ufCidade", $$v)
      },
      expression: "localidade.ufCidade"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Município",
      "items": _vm.listaCidades,
      "item-text": "nomeCidade",
      "item-value": "id",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "return-object": "",
      "autocomplete": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.localidade.cidade),
      callback: function($$v) {
        _vm.$set(_vm.localidade, "cidade", $$v)
      },
      expression: "localidade.cidade"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.listaCidadesSelecionadas.length < 2) ? _c('v-text-field', {
    attrs: {
      "label": "CEP",
      "max-height": "400"
    },
    model: {
      value: (_vm.localidade.cep),
      callback: function($$v) {
        _vm.$set(_vm.localidade, "cep", $$v)
      },
      expression: "localidade.cep"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-textarea', {
    attrs: {
      "label": "Informações adicionais",
      "rows": 3,
      "auto-grow": true,
      "multi-line": "",
      "counter": "200"
    },
    model: {
      value: (_vm.localidade.detalhes),
      callback: function($$v) {
        _vm.$set(_vm.localidade, "detalhes", $$v)
      },
      expression: "localidade.detalhes"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.cancelar
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.editarLocalidade()
      }
    }
  }, [_vm._v("Salvar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(558)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(559),
  /* template */
  __webpack_require__(560),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 558 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto'],
  data: function data() {
    return {
      dialog: false,
      formularioValido: false,
      idProjetoSuperior: undefined,
      pesquisa: {
        numero: null,
        titulo: '',
        membroEquipe: '',
        palavraChave: ''
      },
      listaProjetos: [],
      regrasBasicas: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }],
      search: null,
      sortBy: 'dtCriacao',
      sortDesc: true,
      itemsPerPage: 25,
      opcoesPaginacao: [10, 25, 50, { text: 'Todas', value: -1 }],
      headers: [{ text: 'Número', align: 'center', value: 'idProjeto' }, { text: 'Título', align: 'center', value: 'titulo' }, { text: 'Classificação Primária', align: 'center', value: 'classificacaoPrimaria' }, { text: 'Classificação Secundária', align: 'center', value: 'classificacaoSecundaria' }, { text: 'Situação', align: 'center', value: 'situacao' }, { text: 'Coordenador', align: 'center', value: 'nomeCoordenador' }, { text: 'Opções', align: 'center', value: 'opcoes' }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    cancelar: function cancelar() {
      this.$router.go(-1);
    },
    limpar: function limpar() {
      this.pesquisa = { tipoProjeto: 39725 };
    },
    pesquisar: function pesquisar() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projetos.' });
      __WEBPACK_IMPORTED_MODULE_3__utils_projetos__["a" /* default */].getConsultaProjetos(this.pesquisa).then(function (response) {
        _this.listaProjetos = response.data.slice();
        console.log(_this.listaProjetos);
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
        _this.listaProjetos = [];
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projetos.' });
      });
    },

    projetoSuperior: function projetoSuperior(idProjetoSuperior) {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Definindo ação superior...' });
      __WEBPACK_IMPORTED_MODULE_3__utils_projetos__["a" /* default */].postProjetoSuperior(this.idProjeto, idProjetoSuperior).then(function (response) {
        _this2.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this2.$router.go(-1);
      }).catch(function (error) {
        _this2.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Definindo ação superior...' });
      });
    }
  }),
  mounted: function mounted() {
    var _this3 = this;

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    __WEBPACK_IMPORTED_MODULE_3__utils_projetos__["a" /* default */].getProjeto(this.idProjeto).then(function (response) {
      _this3.projeto = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this3.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a
  }
});

/***/ }),
/* 560 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Pesquisar Ações de Extensão'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', {
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.pesquisar()
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Número",
      "max-height": "400",
      "clearable": ""
    },
    model: {
      value: (_vm.pesquisa.numero),
      callback: function($$v) {
        _vm.$set(_vm.pesquisa, "numero", $$v)
      },
      expression: "pesquisa.numero"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm9": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Título",
      "max-height": "400",
      "clearable": ""
    },
    model: {
      value: (_vm.pesquisa.titulo),
      callback: function($$v) {
        _vm.$set(_vm.pesquisa, "titulo", $$v)
      },
      expression: "pesquisa.titulo"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Palavra-chave",
      "max-height": "400",
      "clearable": ""
    },
    model: {
      value: (_vm.pesquisa.palavraChave),
      callback: function($$v) {
        _vm.$set(_vm.pesquisa, "palavraChave", $$v)
      },
      expression: "pesquisa.palavraChave"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Membro da equipe",
      "max-height": "400",
      "clearable": ""
    },
    model: {
      value: (_vm.pesquisa.membroEquipe),
      callback: function($$v) {
        _vm.$set(_vm.pesquisa, "membroEquipe", $$v)
      },
      expression: "pesquisa.membroEquipe"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "padding-top": "15px"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-btn', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.limpar
    }
  }, [_vm._v("Limpar")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.pesquisar
    }
  }, [_vm._v("Pesquisar")])], 1)])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Selecionar Ação de Extensão'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "instrucao"
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-text', {
    staticClass: "black--text font-weight-bold"
  }, [_vm._v("\n                    A vinculação das ações de extensão deve ser feita do menor para o maior nível hierárquico. \n                    Exemplo: projetos podem ser vinculados a programas; cursos/eventos/prestações de serviço podem ser vinculados a projetos ou programas.\n                  ")])], 1)], 1)])], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaProjetos,
      "search": _vm.search,
      "no-data-text": 'Nenhum projeto encontrado',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.titulo",
      fn: function(props) {
        return [_c('router-link', {
          attrs: {
            "target": "_blank",
            "to": {
              name: 'ProjetoFormulario',
              params: {
                idProjeto: props.item.idProjeto
              }
            }
          }
        }, [_vm._v(_vm._s(props.item.titulo))])]
      }
    }, {
      key: "item.opcoes",
      fn: function(props) {
        return [_c('v-btn', {
          attrs: {
            "color": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.projetoSuperior(props.item.idProjeto)
            }
          }
        }, [_vm._v("Selecionar")])]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n              Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaProjetos.length) + " projetos\n            ")]
      }
    }])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Cancelar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(562)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(563),
  /* template */
  __webpack_require__(565),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 562 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_date_menu__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_date_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_c_date_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_c_textarea__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_c_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_c_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(3);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto', 'idParticipante'],
  data: function data() {
    return {
      formularioValido: false,
      projeto: {},
      integrante: {
        nome: '',
        dataInicial: '',
        dataFinal: '',
        funcao: {},
        titulacao: {},
        ativo: true,
        cargaHoraria: 0,
        obsParticipante: ''
      },
      listaFuncao: [],
      listaTitulacao: [],
      listaAssessor: [{ 'item': true, 'descricao': 'Sim' }, { 'item': false, 'descricao': 'Não' }],
      regrasCargaHoraria: [function (input) {
        return input !== undefined && input !== null && input !== '' || 'Este campo é obrigatório';
      }, function (input) {
        return !isNaN(input) || 'A carga horária deve ser numérica';
      }, function (input) {
        return input.length === 0 || Number(input) >= 0 || 'A carga horária não pode ser negativa';
      }],
      regrasInstituicao: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }, function (input) {
        return input.length <= 100 || 'Este campo não pode possuir mais que 100 caracteres';
      }],
      regrasBasicas: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])('auth', ['administrador', 'usuarioPROEX'])),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    editarIntegrante: function editarIntegrante() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Editando integrante.' });

      // Limpa campo caso a opção "Aluno de Pós-Graduação da Ufes" seja "Sim".
      if (this.integrante.alunoPosUfes === 'S') {
        this.integrante.instituicao = null;
      }

      var aux = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.integrante));
      aux.idParticipante = undefined;
      aux.idPessoa = undefined;
      aux.nome = undefined;
      aux.vinculo = undefined;
      __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].putIntegrante(this.idProjeto, this.idParticipante, aux).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.$router.push({ name: 'IntegrantesProjeto', params: { idProjeto: _this.idProjeto } });
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Editando integrante.' });
      });
    },
    opcoesTabelaEstruturada: function opcoesTabelaEstruturada(codTabela, aqui, atributo) {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' });
      __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].getOpcoesTabelaEstruturada(codTabela).then(function (response) {
        aqui[atributo] = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' });
      });
    }
  }),
  mounted: function mounted() {
    var _this3 = this;

    this.opcoesTabelaEstruturada(6003, this, 'listaFuncao');
    this.opcoesTabelaEstruturada(168, this, 'listaTitulacao');

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].getProjeto(this.idProjeto).then(function (response) {
      _this3.projeto = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this3.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    });

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando integrante.' });
    __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].getIntegrante(this.idProjeto, this.idParticipante).then(function (response) {
      _this3.integrante = response.data;

      // Quando o integrante é o coordenador.
      if (response.data.funcao.item === 1) {
        _this3.listaFuncao.splice(0, 1); // Remove a função "Bolsista-PROEX".
        _this3.listaFuncao.splice(1, 3); // Remove as funções "Discente-coordenador", "Integrante" e "Subcoordenador".
      }

      // Quando o integrante não é o coordenador.
      if (response.data.funcao.item !== 1) {
        _this3.listaFuncao.splice(1, 1); // Remove a função "Coordenador".
      }
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this3.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando integrante.' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_3__components_app_layouts_app_tooltip_tooltip___default.a,
    'c-date-menu': __WEBPACK_IMPORTED_MODULE_4__components_c_date_menu___default.a,
    'c-textarea': __WEBPACK_IMPORTED_MODULE_5__components_c_textarea___default.a
  }
});

/***/ }),
/* 564 */,
/* 565 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Editar Integrante'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome",
      "readonly": "",
      "max-height": "400"
    },
    model: {
      value: (_vm.integrante.nome),
      callback: function($$v) {
        _vm.$set(_vm.integrante, "nome", $$v)
      },
      expression: "integrante.nome"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-1"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Vínculo",
      "value": _vm.integrante.vinculo,
      "max-height": "400",
      "readonly": ""
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-1"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Função",
      "items": _vm.listaFuncao,
      "item-text": "descricao",
      "item-value": "item",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "return-object": "",
      "required": "",
      "autocomplete": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.integrante.funcao),
      callback: function($$v) {
        _vm.$set(_vm.integrante, "funcao", $$v)
      },
      expression: "integrante.funcao"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.integrante.funcao.item !== 1) ? _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Assessor",
      "items": _vm.listaAssessor,
      "item-text": "descricao",
      "item-value": "item",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "required": "",
      "disabled": _vm.projeto.assessor === true && _vm.administrador === false,
      "autocomplete": ""
    },
    model: {
      value: (_vm.integrante.assessor),
      callback: function($$v) {
        _vm.$set(_vm.integrante, "assessor", $$v)
      },
      expression: "integrante.assessor"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.integrante.funcao.item === 1) ? _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Assessor",
      "value": "-",
      "disabled": "",
      "max-height": "400",
      "readonly": ""
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-1"
  }), _vm._v(" "), (_vm.integrante.assessor === true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "center"
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-text', {
    staticClass: "black--text font-weight-bold"
  }, [_vm._v("\n                      O assessor deve ser um único integrante da equipe e terá apenas a permissão de preenchimento, não sendo autorizado a ele submeter para aprovação, excluir ou finalizar a ação.\n                    ")])], 1)], 1)])], 1) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "mt-1"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Carga horária semanal",
      "prepend-icon": "dashboard",
      "rules": _vm.regrasCargaHoraria,
      "disabled": _vm.integrante.funcao.item === 1,
      "max-height": "400"
    },
    model: {
      value: (_vm.integrante.cargaHoraria),
      callback: function($$v) {
        _vm.$set(_vm.integrante, "cargaHoraria", $$v)
      },
      expression: "integrante.cargaHoraria"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Escolaridade",
      "items": _vm.listaTitulacao,
      "item-text": "descricao",
      "item-value": "item",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "return-object": "",
      "required": "",
      "autocomplete": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.integrante.titulacao),
      callback: function($$v) {
        _vm.$set(_vm.integrante, "titulacao", $$v)
      },
      expression: "integrante.titulacao"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-1"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-date-menu', {
    attrs: {
      "label": "Data inicial",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.integrante.dataInicial),
      callback: function($$v) {
        _vm.$set(_vm.integrante, "dataInicial", $$v)
      },
      expression: "integrante.dataInicial"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (this.integrante.situacao !== 'A') ? _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-date-menu', {
    attrs: {
      "label": "Data final",
      "clearable": ""
    },
    model: {
      value: (_vm.integrante.dataFinal),
      callback: function($$v) {
        _vm.$set(_vm.integrante, "dataFinal", $$v)
      },
      expression: "integrante.dataFinal"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), ((_vm.integrante.vinculo === 'Externo' || _vm.integrante.vinculo === 'Aluno de pós-graduação')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Instituição que o membro da equipe representa",
      "counter": "100",
      "rules": _vm.regrasInstituicao
    },
    model: {
      value: (_vm.integrante.instituicao),
      callback: function($$v) {
        _vm.$set(_vm.integrante, "instituicao", $$v)
      },
      expression: "integrante.instituicao"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.integrante.alunoPosUfes === 'N') ? _c('p', {
    staticClass: "mt-1"
  }) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', [_c('c-textarea', {
    attrs: {
      "rows": 2,
      "auto-grow": true,
      "label": "Observação"
    },
    model: {
      value: (_vm.integrante.obsParticipante),
      callback: function($$v) {
        _vm.$set(_vm.integrante, "obsParticipante", $$v)
      },
      expression: "integrante.obsParticipante"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido || (_vm.integrante.alunoPosUfes === 'N' && _vm.integrante.instituicao === null)
    },
    on: {
      "click": _vm.editarIntegrante
    }
  }, [_vm._v("Salvar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(567)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(568),
  /* template */
  __webpack_require__(569),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 567 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_readonly_field__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_readonly_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_readonly_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_date_menu__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_date_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_c_date_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_c_textarea__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_c_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_c_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_assessor__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto', 'idParticipante'],
  data: function data() {
    return {
      formularioValido: false,
      dates: __WEBPACK_IMPORTED_MODULE_7__utils_dates__["a" /* default */],
      formatAssessor: __WEBPACK_IMPORTED_MODULE_8__utils_assessor__["a" /* default */],
      projeto: {},
      integrante: {
        nome: '',
        dataInicial: '',
        dataFinal: '',
        funcao: {},
        titulacao: {},
        ativo: true,
        cargaHoraria: 0,
        obsParticipante: ''
      },
      listaFuncao: [],
      listaTitulacao: [],
      listaAssessor: [{ 'item': true, 'descricao': 'Sim' }, { 'item': false, 'descricao': 'Não' }],
      regrasCargaHoraria: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }, function (input) {
        return !isNaN(input) || 'A carga horária deve ser numérica';
      }, function (input) {
        return input.length === 0 || Number(input) !== 0 || 'A carga horária não pode ser nula';
      }, function (input) {
        return input.length === 0 || Number(input) > 0 || 'A carga horária não pode ser negativa';
      }],
      regrasInstituicao: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }, function (input) {
        return input.length <= 100 || 'Este campo não pode possuir mais que 100 caracteres';
      }],
      regrasBasicas: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["c" /* mapGetters */])('auth', ['administrador', 'usuarioPROEX'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR'])),
  mounted: function mounted() {
    var _this = this;

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].getProjeto(this.idProjeto).then(function (response) {
      _this.projeto = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    });

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando integrante.' });
    __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].getIntegrante(this.idProjeto, this.idParticipante).then(function (response) {
      _this.integrante = response.data;

      // Quando o integrante é o coordenador.
      if (response.data.funcao.item === 1) {
        _this.listaFuncao.splice(0, 1); // Remove a função "Bolsista-PROEX".
        _this.listaFuncao.splice(1, 3); // Remove as funções "Discente-coordenador", "Integrante" e "Subcoordenador".
      }

      // Quando o integrante não é o coordenador.
      if (response.data.funcao.item !== 1) {
        _this.listaFuncao.splice(1, 1); // Remove a função "Coordenador".
      }
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando integrante.' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_3__components_app_layouts_app_tooltip_tooltip___default.a,
    'c-date-menu': __WEBPACK_IMPORTED_MODULE_4__components_c_date_menu___default.a,
    'c-textarea': __WEBPACK_IMPORTED_MODULE_5__components_c_textarea___default.a,
    'c-readonly-field': __WEBPACK_IMPORTED_MODULE_2__components_c_readonly_field___default.a
  }
});

/***/ }),
/* 569 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Visualizar Integrante'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Nome",
      "value": _vm.integrante.nome,
      "align": "justify"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-1"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Vínculo",
      "value": _vm.integrante.vinculo,
      "align": "justify"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-1"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Função",
      "value": _vm.integrante.funcao ? _vm.integrante.funcao.descricao : '-'
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Assessor",
      "value": _vm.formatAssessor.format(_vm.integrante.assessor, _vm.integrante.funcao.item)
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-1"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Carga horária semanal",
      "value": _vm.integrante.cargaHoraria,
      "align": "justify"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Escolaridade",
      "value": _vm.integrante.titulacao ? _vm.integrante.titulacao.descricao : '-'
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-1"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Data inicial",
      "value": _vm.integrante.dataInicial ? _vm.dates.format(_vm.integrante.dataInicial) || '-' : '-'
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (this.integrante.situacao !== 'A') ? _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Data final",
      "value": _vm.integrante.dataFinal ? _vm.dates.format(_vm.integrante.dataFinal) || '-' : '-'
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), ((_vm.integrante.vinculo === 'Externo' || _vm.integrante.vinculo === 'Aluno de pós-graduação')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', [_c('c-readonly-field', {
    attrs: {
      "label": "Instituição que o membro da equipe representa",
      "value": _vm.integrante.instituicao || '-',
      "align": "justify"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', [_c('c-readonly-field', {
    attrs: {
      "label": "Observação",
      "value": _vm.integrante.obsParticipante || '-',
      "align": "justify"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Voltar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(571)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(572),
  /* template */
  __webpack_require__(573),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 571 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto'],
  data: function data() {
    return {
      tipoBusca: 'nome',
      integrante: {
        nome: '',
        cpf: ''
      },
      listaPessoas: [],
      projeto: {},
      regrasBasicas: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }],
      search: null,
      sortBy: 'dtCriacao',
      sortDesc: true,
      itemsPerPage: 25,
      opcoesPaginacao: [10, 25, 50, { text: 'Todas', value: -1 }],
      headers: [{ text: 'Nome', align: 'center', value: 'nomePessoaUp' }, { text: 'Vínculo', align: 'center', value: 'vinculo' }, { text: 'Matrícula', align: 'center', value: 'matricula' }, { text: 'CPF', align: 'center', value: 'cpf' }, { text: 'Opções', align: 'center', value: 'opcoes' }]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('auth', ['administrador'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    pesquisaPessoasPorNome: function pesquisaPessoasPorNome() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando pessoas.' });
      __WEBPACK_IMPORTED_MODULE_3__utils_projetos__["a" /* default */].getPessoasPorNome(this.integrante.nome).then(function (response) {
        _this.listaPessoas = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando pessoas.' });
      });
    },
    pesquisaPessoasPorCpf: function pesquisaPessoasPorCpf() {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando pessoas.' });
      __WEBPACK_IMPORTED_MODULE_3__utils_projetos__["a" /* default */].getPessoasPorCpf(this.integrante.cpf).then(function (response) {
        _this2.listaPessoas = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this2.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando pessoas.' });
      });
    },
    adicionarIntegrante: function adicionarIntegrante(idPessoa) {
      // Redireciona para a página de adicionar um integrante.
      this.$router.push({ name: 'AdicionarIntegrante', params: { idProjeto: this.idProjeto, idPessoa: idPessoa } });
    },
    cadastrarMembroExterno: function cadastrarMembroExterno(idPessoa) {
      this.$router.push({ name: 'CadastrarMembroExterno', params: { idProjeto: this.idProjeto } });
    },
    editarPessoa: function editarPessoa(idPessoa) {
      this.$router.push({ name: 'EditarPessoa', params: { idPessoa: idPessoa } });
    }
  }),
  mounted: function mounted() {
    var _this3 = this;

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    __WEBPACK_IMPORTED_MODULE_3__utils_projetos__["a" /* default */].getProjeto(this.idProjeto).then(function (response) {
      _this3.projeto = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this3.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a
  }
});

/***/ }),
/* 573 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Pesquisar Pessoa'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "center"
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-text', {
    staticClass: "black--text font-weight-bold"
  }, [_vm._v("\n                        Para adicionar um novo integrante, realize a pesquisa pelo nome ou CPF da pessoa. Caso a pessoa desejada não seja encontrada, clique no botão \"CADASTRAR MEMBRO EXTERNO\" localizado no canto inferior direito.\n                      ")])], 1)], 1)])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.tipoBusca),
      callback: function($$v) {
        _vm.tipoBusca = $$v
      },
      expression: "tipoBusca"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Nome",
      "value": "nome"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "CPF",
      "value": "cpf"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipoBusca === 'nome'),
      expression: "tipoBusca==='nome'"
    }],
    attrs: {
      "label": "Nome",
      "required": "",
      "rules": _vm.regrasBasicas,
      "max-height": "400"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.pesquisaPessoasPorNome($event)
      }
    },
    model: {
      value: (_vm.integrante.nome),
      callback: function($$v) {
        _vm.$set(_vm.integrante, "nome", $$v)
      },
      expression: "integrante.nome"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipoBusca !== 'nome'),
      expression: "tipoBusca!=='nome'"
    }],
    attrs: {
      "label": "CPF",
      "mask": "###.###.###-##",
      "return-masked-value": "",
      "required": "",
      "rules": _vm.regrasBasicas,
      "max-height": "400"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.pesquisaPessoasPorCpf($event)
      }
    },
    model: {
      value: (_vm.integrante.cpf),
      callback: function($$v) {
        _vm.$set(_vm.integrante, "cpf", $$v)
      },
      expression: "integrante.cpf"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding-top": "15px"
    },
    attrs: {
      "xs4": ""
    }
  }, [(_vm.tipoBusca === 'nome') ? _c('v-btn', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.pesquisaPessoasPorNome
    }
  }, [_vm._v("Pesquisar")]) : _c('v-btn', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.pesquisaPessoasPorCpf
    }
  }, [_vm._v("Pesquisar")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaPessoas,
      "search": _vm.search,
      "no-data-text": 'Nenhuma pessoa encontrada',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.opcoes",
      fn: function(props) {
        return [_c('v-btn', {
          attrs: {
            "color": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.adicionarIntegrante(props.item.idPessoa)
            }
          }
        }, [_vm._v("Selecionar")]), _vm._v(" "), (_vm.administrador === true) ? _c('v-btn', {
          attrs: {
            "color": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.editarPessoa(props.item.idPessoa)
            }
          }
        }, [_vm._v("Editar")]) : _vm._e()]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n              Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaPessoas.length) + " pessoas\n            ")]
      }
    }])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.cadastrarMembroExterno()
      }
    }
  }, [_vm._v("Cadastrar Membro Externo")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(575)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(576),
  /* template */
  __webpack_require__(577),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 575 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_textarea__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_c_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto', 'idPessoa'],
  data: function data() {
    return {
      formularioValido: false,
      projeto: {},
      pessoa: {},
      integrante: {
        idPessoa: '',
        dataInicial: '',
        cargaHoraria: 0,
        funcao: '',
        titulacao: '',
        situacao: 'A',
        assessor: false,
        instituicao: '',
        obsParticipante: ''
      },
      listaFuncao: [],
      listaTitulacao: [],
      listaAssessor: [{ 'item': true, 'descricao': 'Sim' }, { 'item': false, 'descricao': 'Não' }],
      numerico: [function (input) {
        return input !== undefined && input !== null && input !== '' || 'Este campo é obrigatório';
      }, function (input) {
        return !isNaN(input) || 'A carga horária deve ser numérica';
      }, function (input) {
        return input.length === 0 || Number(input) >= 0 || 'A carga horária não pode ser negativa';
      }],
      regrasInstituicao: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }, function (input) {
        return input.length <= 100 || 'Este campo não pode possuir mais que 100 caracteres';
      }],
      regrasBasicas: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])('auth', ['administrador', 'usuarioPROEX'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    // Adiciona um integrante.
    adicionarIntegrante: function adicionarIntegrante() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Adicionando integrante...' });
      __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].postIntegrante(this.$props.idProjeto, this.integrante).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: 'Integrante adicionado com sucesso!' });
        _this.$router.push({ name: 'IntegrantesProjeto', params: { idProjeto: _this.idProjeto } });
      }).catch(function (error) {
        console.log('Erro ao mandar a requisição' + error);
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Adicionando integrante...' });
      });
    },


    // Carrega uma tabela estruturada.
    opcoesTabelaEstruturada: function opcoesTabelaEstruturada(codTabela, aqui, atributo) {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' });
      return __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getOpcoesTabelaEstruturada(codTabela).then(function (response) {
        aqui[atributo] = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' });
      });
    }
  }),
  mounted: function mounted() {
    var _this3 = this;

    // Carrega lista de funções para um membro da equipe.
    this.opcoesTabelaEstruturada(6003, this, 'listaFuncao').then(function () {
      // exclui o item 21 (discente-coordenador)
      _this3.listaFuncao = _this3.listaFuncao.filter(function (item) {
        return item.item !== 21;
      });
    });

    // Carrega lista de escolaridade.
    this.opcoesTabelaEstruturada(168, this, 'listaTitulacao');

    // Carrega a ação de extensão.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getProjeto(this.idProjeto).then(function (response) {
      // Preenche dados da ação de extensão.
      _this3.projeto = response.data;

      // Preenche dado inicial do integrante.
      _this3.integrante.dataInicial = _this3.projeto.dataInicio;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this3.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    });

    // Carrega a pessoa.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando pessoa.' });
    __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getPessoa(this.idPessoa).then(function (response) {
      // Preenche dados da pessoa.
      _this3.pessoa = response.data;

      // Preenche dados iniciais do integrante.
      _this3.integrante.idPessoa = _this3.pessoa.idPessoa;
      _this3.integrante.nome = _this3.pessoa.nomeSocial;
      _this3.integrante.vinculo = _this3.pessoa.vinculo;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this3.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando pessoa.' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a,
    'c-date-menu': __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default.a,
    'c-textarea': __WEBPACK_IMPORTED_MODULE_4__components_c_textarea___default.a
  }
});

/***/ }),
/* 577 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Adicionar Integrante'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome",
      "readonly": "",
      "max-height": "400"
    },
    model: {
      value: (_vm.integrante.nome),
      callback: function($$v) {
        _vm.$set(_vm.integrante, "nome", $$v)
      },
      expression: "integrante.nome"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-1"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Vínculo",
      "value": _vm.integrante.vinculo,
      "max-height": "400",
      "readonly": ""
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-1"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Função",
      "items": _vm.listaFuncao,
      "item-text": "descricao",
      "item-value": "item",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "return-object": "",
      "required": "",
      "autocomplete": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.integrante.funcao),
      callback: function($$v) {
        _vm.$set(_vm.integrante, "funcao", $$v)
      },
      expression: "integrante.funcao"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.integrante.funcao.item !== 1) ? _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Assessor",
      "items": _vm.listaAssessor,
      "item-text": "descricao",
      "item-value": "item",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "required": "",
      "disabled": _vm.projeto.assessor === true && _vm.administrador === false,
      "autocomplete": ""
    },
    model: {
      value: (_vm.integrante.assessor),
      callback: function($$v) {
        _vm.$set(_vm.integrante, "assessor", $$v)
      },
      expression: "integrante.assessor"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.integrante.funcao.item === 1) ? _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Assessor",
      "value": "-",
      "disabled": "",
      "max-height": "400",
      "readonly": ""
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-1"
  }), _vm._v(" "), (_vm.integrante.assessor === true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "center"
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-text', {
    staticClass: "black--text font-weight-bold"
  }, [_vm._v("\n                      O assessor deve ser um único integrante da equipe e terá apenas a permissão de preenchimento, não sendo autorizado a ele submeter para aprovação, excluir ou finalizar a ação.\n                    ")])], 1)], 1)])], 1) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "mt-1"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field-integer', {
    attrs: {
      "label": "Carga horária semanal",
      "disabled": _vm.administrador !== true,
      "properties": {
        prependIcon: 'dashboard',
        rules: _vm.numerico
      }
    },
    model: {
      value: (_vm.integrante.cargaHoraria),
      callback: function($$v) {
        _vm.$set(_vm.integrante, "cargaHoraria", $$v)
      },
      expression: "integrante.cargaHoraria"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Escolaridade",
      "items": _vm.listaTitulacao,
      "item-text": "descricao",
      "item-value": "item",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "return-object": "",
      "required": "",
      "autocomplete": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.integrante.titulacao),
      callback: function($$v) {
        _vm.$set(_vm.integrante, "titulacao", $$v)
      },
      expression: "integrante.titulacao"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-1"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-date-menu', {
    attrs: {
      "label": "Data inicial",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.integrante.dataInicial),
      callback: function($$v) {
        _vm.$set(_vm.integrante, "dataInicial", $$v)
      },
      expression: "integrante.dataInicial"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (this.integrante.situacao !== 'A') ? _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-date-menu', {
    attrs: {
      "label": "Data final",
      "clearable": ""
    },
    model: {
      value: (_vm.integrante.dataFinal),
      callback: function($$v) {
        _vm.$set(_vm.integrante, "dataFinal", $$v)
      },
      expression: "integrante.dataFinal"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), ((_vm.integrante.vinculo === 'Externo' || _vm.integrante.vinculo === 'Aluno de pós-graduação')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Instituição que o membro da equipe representa",
      "counter": "100",
      "required": "",
      "rules": _vm.regrasInstituicao
    },
    model: {
      value: (_vm.integrante.instituicao),
      callback: function($$v) {
        _vm.$set(_vm.integrante, "instituicao", $$v)
      },
      expression: "integrante.instituicao"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.integrante.alunoPosUfes === 'N') ? _c('p', {
    staticClass: "mt-1"
  }) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', [_c('c-textarea', {
    attrs: {
      "rows": 2,
      "auto-grow": true,
      "label": "Observação"
    },
    model: {
      value: (_vm.integrante.obsParticipante),
      callback: function($$v) {
        _vm.$set(_vm.integrante, "obsParticipante", $$v)
      },
      expression: "integrante.obsParticipante"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": _vm.adicionarIntegrante
    }
  }, [_vm._v("Adicionar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(579)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(580),
  /* template */
  __webpack_require__(581),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 579 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_date_menu__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_date_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_c_date_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_c_textarea__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_c_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_c_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(3);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto', 'idParticipante'],
  data: function data() {
    return {
      formularioValido: false,
      integrante: {
        nome: '',
        dataInicial: '',
        dataFinal: '',
        funcao: {},
        titulacao: {},
        ativo: true,
        cargaHoraria: 0,
        obsParticipante: ''
      },
      listaFuncao: [],
      listaTitulacao: [],
      regrasBasicas: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    editarIntegrante: function editarIntegrante() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Editando integrante.' });
      var aux = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.integrante));
      aux.idParticipante = undefined;
      aux.idPessoa = undefined;
      aux.nome = undefined;
      aux.vinculo = undefined;
      aux.situacao = 'I';
      __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].putIntegrante(this.idProjeto, this.idParticipante, aux).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.$router.push({ name: 'IntegrantesProjeto', params: { idProjeto: _this.idProjeto } });
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Editando integrante.' });
      });
    },
    opcoesTabelaEstruturada: function opcoesTabelaEstruturada(codTabela, aqui, atributo) {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' });
      __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].getOpcoesTabelaEstruturada(codTabela).then(function (response) {
        aqui[atributo] = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' });
      });
    }
  }),
  mounted: function mounted() {
    var _this3 = this;

    this.opcoesTabelaEstruturada(6003, this, 'listaFuncao');
    this.opcoesTabelaEstruturada(168, this, 'listaTitulacao');

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando integrante.' });
    __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].getIntegrante(this.idProjeto, this.idParticipante).then(function (response) {
      _this3.integrante = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this3.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando integrante.' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_3__components_app_layouts_app_tooltip_tooltip___default.a,
    'c-date-menu': __WEBPACK_IMPORTED_MODULE_4__components_c_date_menu___default.a,
    'c-textarea': __WEBPACK_IMPORTED_MODULE_5__components_c_textarea___default.a
  }
});

/***/ }),
/* 581 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Encerrar participação de integrante da equipe'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome",
      "readonly": "",
      "max-height": "400"
    },
    model: {
      value: (_vm.integrante.nome),
      callback: function($$v) {
        _vm.$set(_vm.integrante, "nome", $$v)
      },
      expression: "integrante.nome"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-1"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-date-menu', {
    attrs: {
      "label": "Data inicial",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.integrante.dataInicial),
      callback: function($$v) {
        _vm.$set(_vm.integrante, "dataInicial", $$v)
      },
      expression: "integrante.dataInicial"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-date-menu', {
    attrs: {
      "label": "Data final",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.integrante.dataFinal),
      callback: function($$v) {
        _vm.$set(_vm.integrante, "dataFinal", $$v)
      },
      expression: "integrante.dataFinal"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-1"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', [_c('c-textarea', {
    attrs: {
      "rows": 2,
      "auto-grow": true,
      "label": "Observação"
    },
    model: {
      value: (_vm.integrante.obsParticipante),
      callback: function($$v) {
        _vm.$set(_vm.integrante, "obsParticipante", $$v)
      },
      expression: "integrante.obsParticipante"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": _vm.editarIntegrante
    }
  }, [_vm._v("Encerrar Participação")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(583)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(584),
  /* template */
  __webpack_require__(585),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 583 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_date_menu__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_date_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_c_date_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_c_textarea__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_c_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_c_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(3);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto', 'idParticipante'],
  data: function data() {
    return {
      formularioValido: false,
      integrante: {
        nome: '',
        dataInicial: '',
        dataFinal: '',
        funcao: {},
        titulacao: {},
        ativo: true,
        cargaHoraria: 0,
        obsParticipante: ''
      },
      listaFuncao: [],
      listaTitulacao: [],
      listaAssessor: [{ 'item': true, 'descricao': 'Sim' }, { 'item': false, 'descricao': 'Não' }],
      regrasCargaHoraria: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }, function (input) {
        return !isNaN(input) || 'A carga horária deve ser numérica';
      }, function (input) {
        return input.length === 0 || Number(input) !== 0 || 'A carga horária não pode ser nula';
      }, function (input) {
        return input.length === 0 || Number(input) > 0 || 'A carga horária não pode ser negativa';
      }],
      regrasInstituicao: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }, function (input) {
        return input.length <= 100 || 'Este campo não pode possuir mais que 100 caracteres';
      }],
      regrasBasicas: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    editarIntegrante: function editarIntegrante() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Editando integrante.' });

      var aux = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.integrante));
      aux.idParticipante = undefined;
      aux.idPessoa = undefined;
      aux.nome = undefined;
      aux.vinculo = undefined;
      aux.situacao = 'A';
      aux.dataFinal = null;
      __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].putIntegrante(this.idProjeto, this.idParticipante, aux).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.$router.push({ name: 'IntegrantesProjeto', params: { idProjeto: _this.idProjeto } });
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Editando integrante.' });
      });
    },
    opcoesTabelaEstruturada: function opcoesTabelaEstruturada(codTabela, aqui, atributo) {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' });
      __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].getOpcoesTabelaEstruturada(codTabela).then(function (response) {
        aqui[atributo] = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' });
      });
    }
  }),
  mounted: function mounted() {
    var _this3 = this;

    this.opcoesTabelaEstruturada(6003, this, 'listaFuncao');
    this.opcoesTabelaEstruturada(168, this, 'listaTitulacao');

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando integrante.' });
    __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].getIntegrante(this.idProjeto, this.idParticipante).then(function (response) {
      _this3.integrante = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this3.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando integrante.' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_3__components_app_layouts_app_tooltip_tooltip___default.a,
    'c-date-menu': __WEBPACK_IMPORTED_MODULE_4__components_c_date_menu___default.a,
    'c-textarea': __WEBPACK_IMPORTED_MODULE_5__components_c_textarea___default.a
  }
});

/***/ }),
/* 585 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Reativar participação de integrante da equipe'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome",
      "readonly": "",
      "max-height": "400"
    },
    model: {
      value: (_vm.integrante.nome),
      callback: function($$v) {
        _vm.$set(_vm.integrante, "nome", $$v)
      },
      expression: "integrante.nome"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-1"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Vínculo",
      "value": _vm.integrante.vinculo,
      "max-height": "400",
      "readonly": ""
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-1"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Função",
      "items": _vm.listaFuncao,
      "item-text": "descricao",
      "item-value": "item",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "return-object": "",
      "required": "",
      "autocomplete": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.integrante.funcao),
      callback: function($$v) {
        _vm.$set(_vm.integrante, "funcao", $$v)
      },
      expression: "integrante.funcao"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Assessor",
      "items": _vm.listaAssessor,
      "item-text": "descricao",
      "item-value": "item",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "required": "",
      "autocomplete": ""
    },
    model: {
      value: (_vm.integrante.assessor),
      callback: function($$v) {
        _vm.$set(_vm.integrante, "assessor", $$v)
      },
      expression: "integrante.assessor"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-1"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Carga horária semanal",
      "prepend-icon": "dashboard",
      "rules": _vm.regrasCargaHoraria,
      "max-height": "400"
    },
    model: {
      value: (_vm.integrante.cargaHoraria),
      callback: function($$v) {
        _vm.$set(_vm.integrante, "cargaHoraria", $$v)
      },
      expression: "integrante.cargaHoraria"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Escolaridade",
      "items": _vm.listaTitulacao,
      "item-text": "descricao",
      "item-value": "item",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "return-object": "",
      "required": "",
      "autocomplete": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.integrante.titulacao),
      callback: function($$v) {
        _vm.$set(_vm.integrante, "titulacao", $$v)
      },
      expression: "integrante.titulacao"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-1"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-date-menu', {
    attrs: {
      "label": "Data inicial",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.integrante.dataInicial),
      callback: function($$v) {
        _vm.$set(_vm.integrante, "dataInicial", $$v)
      },
      expression: "integrante.dataInicial"
    }
  })], 1)], 1), _vm._v(" "), ((_vm.integrante.vinculo === 'Externo' || _vm.integrante.vinculo === 'Aluno de pós-graduação')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Instituição que o membro da equipe representa",
      "counter": "100",
      "rules": _vm.regrasInstituicao
    },
    model: {
      value: (_vm.integrante.instituicao),
      callback: function($$v) {
        _vm.$set(_vm.integrante, "instituicao", $$v)
      },
      expression: "integrante.instituicao"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', [_c('c-textarea', {
    attrs: {
      "rows": 2,
      "auto-grow": true,
      "label": "Observação"
    },
    model: {
      value: (_vm.integrante.obsParticipante),
      callback: function($$v) {
        _vm.$set(_vm.integrante, "obsParticipante", $$v)
      },
      expression: "integrante.obsParticipante"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido || (_vm.integrante.alunoPosUfes === 'N' && _vm.integrante.instituicao === null)
    },
    on: {
      "click": _vm.editarIntegrante
    }
  }, [_vm._v("Reativar integrante")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(587)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(588),
  /* template */
  __webpack_require__(589),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 587 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_assessor__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      integrante: {},
      listaOcorrenciasIntegrante: [],
      dates: __WEBPACK_IMPORTED_MODULE_3__utils_dates__["a" /* default */],
      formatAssessor: __WEBPACK_IMPORTED_MODULE_4__utils_assessor__["a" /* default */],
      search: null,
      sortBy: 'dtCriacao',
      sortDesc: true,
      itemsPerPage: 25,
      opcoesPaginacao: [10, 25, 50, { text: 'Todas', value: -1 }],
      headers: [{ text: 'Data', align: 'center', value: 'dtOcorrencia' }, { text: 'Usuário', align: 'center', value: 'loginResponsavel' }, { text: 'Data Inicial', align: 'center', value: 'dataInicial' }, { text: 'Data Final', align: 'center', value: 'dataFinal' }, { text: 'Função', align: 'center', value: 'funcao.descricao' }, { text: 'Assessor', align: 'center', value: 'assessor' }, { text: 'Titulação', align: 'center', value: 'titulacao.descricao' }, { text: 'Carga Horária', align: 'center', value: 'cargaHoraria' }, { text: 'Situação', align: 'center', value: 'situacao' }, { text: 'Observações', align: 'center', value: 'obsParticipante' }]
    };
  },
  props: ['items', 'idProjeto', 'idParticipante'],
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING']), {
    truncate: function truncate(string, limit) {
      if (string.length > limit) return string.substring(0, limit) + '...';else return string;
    }
  }),
  mounted: function mounted() {
    var _this = this;

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando integrante.' });
    __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getIntegrante(this.idProjeto, this.idParticipante).then(function (response) {
      _this.integrante = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando integrante.' });
    });

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ocorrências.' });
    __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getOcorrenciasIntegrante(this.idProjeto, this.idParticipante).then(function (response) {
      _this.listaOcorrenciasIntegrante = response.data.slice();
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ocorrências.' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a
  }
});

/***/ }),
/* 589 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', [_c('basic-toolbar', {
    attrs: {
      "title": 'Ocorrências do integrante ' + this.integrante.nome
    }
  }), _vm._v(" "), _c('v-card-title', [_c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "filter_list",
      "label": "Filtrar resultados"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaOcorrenciasIntegrante,
      "search": _vm.search,
      "no-data-text": 'Esse integrante não possui ocorrências',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n            Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaOcorrenciasIntegrante.length) + " ocorrências\n          ")]
      }
    }, {
      key: "item.dtOcorrencia",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dtOcorrencia)))]
      }
    }, {
      key: "item.dataInicial",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dataInicial)))]
      }
    }, {
      key: "item.dataFinal",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dataFinal)))]
      }
    }, {
      key: "item.assessor",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.formatAssessor.format(props.item.assessor, props.item.funcao.item)))]
      }
    }])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Voltar")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(591),
  /* template */
  __webpack_require__(592),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto', 'idParticipante'],
  data: function data() {
    return {
      formularioValido: false,
      listaIntegrantes: [],
      novoCoordenador: {},
      integrante: {
        nome: '',
        dataInicial: '',
        dataFinal: '',
        funcao: {},
        titulacao: {},
        ativo: true,
        cargaHoraria: 0,
        obsParticipante: ''
      },
      regrasBasicas: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    trocarCoordenador: function trocarCoordenador() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Trocando coordenador.' });
      __WEBPACK_IMPORTED_MODULE_4__utils_projetos__["a" /* default */].putCoordenador(this.idProjeto, this.novoCoordenador.idParticipante).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.$router.push({ name: 'IntegrantesProjeto', params: { idProjeto: _this.idProjeto } });
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Trocando coordenador.' });
      });
    },
    carregaListaIntegrantes: function carregaListaIntegrantes(idProjeto) {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando integrantes.' });
      __WEBPACK_IMPORTED_MODULE_4__utils_projetos__["a" /* default */].getIntegrantesDoProjeto(idProjeto).then(function (response) {
        var listaIntegrantesAux = [];
        listaIntegrantesAux = response.data.slice();
        listaIntegrantesAux = listaIntegrantesAux.filter(function (el) {
          return el != null && el.situacao === 'A' && el.idParticipante !== this.idParticipante;
        }, _this2);
        _this2.listaIntegrantes = listaIntegrantesAux.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando integrantes.' });
      });
    },
    carregaIntegrante: function carregaIntegrante(idProjeto, idIntegrante) {
      var _this3 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando integrante.' });
      __WEBPACK_IMPORTED_MODULE_4__utils_projetos__["a" /* default */].getIntegrante(idProjeto, idIntegrante).then(function (response) {
        _this3.integrante = response.data;
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this3.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando integrante.' });
      });
    }
  }),
  mounted: function mounted() {
    this.carregaListaIntegrantes(this.idProjeto);
    this.carregaIntegrante(this.idProjeto, this.idParticipante);
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a,
    'c-date-menu': __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default.a
  }
});

/***/ }),
/* 592 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Trocar coordenador da ação'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Coordenador atual",
      "readonly": "",
      "max-height": "400"
    },
    model: {
      value: (_vm.integrante.nome),
      callback: function($$v) {
        _vm.$set(_vm.integrante, "nome", $$v)
      },
      expression: "integrante.nome"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-1"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Novo coordenador",
      "items": _vm.listaIntegrantes,
      "eager": "",
      "item-text": "nome",
      "item-value": "idParticipante",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "return-object": "",
      "required": "",
      "autocomplete": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.novoCoordenador),
      callback: function($$v) {
        _vm.novoCoordenador = $$v
      },
      expression: "novoCoordenador"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": _vm.trocarCoordenador
    }
  }, [_vm._v("Trocar coordenador")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(594)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(595),
  /* template */
  __webpack_require__(596),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 594 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto'],
  data: function data() {
    return {
      formularioValido: false,
      atividade: {
        descricao: '',
        detalhamento: '',
        situacaoAtividade: { item: 1, descricao: 'Não iniciada' },
        dtInicioPrevisto: '',
        dtInicioEfetivo: '',
        dtFimPrevisto: '',
        dtFimEfetivo: ''
      },
      projeto: {
        titulo: '',
        dataInicio: '',
        dataConclusao: '',
        observacoes: '',
        situacao: {},
        tipoPublico: {},
        tipoEvento: {}
      },
      objetivosEspecificosTopicos: [],
      listaSituacaoAtividade: [{ item: 1, descricao: 'Não iniciada' }, { item: 2, descricao: 'Em andamento' }, { item: 3, descricao: 'Cumprida' }],
      obrigatorio: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }],
      nomeDescricaoAtividadeRules: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }, function (input) {
        return !!input && input.length <= 250 || 'Este campo não pode possuir mais que 250 caracteres';
      }],
      resultadosRules: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }, function (input) {
        return !!input && input.length <= 1000 || 'Este campo não pode possuir mais que 1000 caracteres';
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    limpaDatasResultados: function limpaDatasResultados() {
      this.atividade.dtInicioPrevisto = null;
      this.atividade.dtFimPrevisto = null;
      this.atividade.dtInicioEfetivo = null;
      this.atividade.dtFimEfetivo = null;
      this.atividade.resultados = null;
    },
    cancelar: function cancelar() {
      this.$router.push({ name: 'AtividadesProjeto', params: { idProjeto: this.idProjeto } });
    },
    criarAtividade: function criarAtividade(avancar) {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Criando nova atividade.' });
      // Atividade "Em andamento"
      if (this.atividade.situacaoAtividade.item === 2) {
        this.atividade.dtInicioPrevisto = this.atividade.dtInicioEfetivo;
      }
      // Atividade "Cumprida"
      if (this.atividade.situacaoAtividade.item === 3) {
        this.atividade.dtInicioPrevisto = this.atividade.dtInicioEfetivo;
        this.atividade.dtFimPrevisto = this.atividade.dtFimEfetivo;
      }
      __WEBPACK_IMPORTED_MODULE_4__utils_projetos__["a" /* default */].postAtividadesDoProjeto(this.idProjeto, this.atividade).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        if (avancar === false) {
          _this.atividade.descricao = '';
          _this.$router.push({ name: 'AtividadesProjeto', params: { idProjeto: _this.idProjeto } });
        } else {
          _this.$router.push({ name: 'NovaParceria', params: { idProjeto: _this.idProjeto } });
        }
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Criando nova atividade.' });
      });
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    __WEBPACK_IMPORTED_MODULE_4__utils_projetos__["a" /* default */].getProjeto(this.idProjeto).then(function (response) {
      _this2.projeto = response.data;
      _this2.dataInicioFormatada = _this2.dates.format(_this2.projeto.dataInicio);
      _this2.dataConclusaoFormatada = _this2.dates.format(_this2.projeto.dataConclusao);
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    });

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações.' });
    __WEBPACK_IMPORTED_MODULE_4__utils_projetos__["a" /* default */].getExtensaoDoProjeto(this.idProjeto).then(function (response) {
      _this2.extensao = response.data;
      var aux = _this2.extensao.objetivosEspecificos.split(';;');
      for (var item in aux) {
        _this2.objetivosEspecificosTopicos.push({ id: item, nome: aux[item] });
      }
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações.' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a,
    'c-date-menu': __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default.a
  }
});

/***/ }),
/* 596 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Criar Atividade'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Nome e descrição sucinta da atividade",
      "rows": "1",
      "auto-grow": "",
      "rules": _vm.nomeDescricaoAtividadeRules,
      "counter": "250"
    },
    model: {
      value: (_vm.atividade.descricao),
      callback: function($$v) {
        _vm.$set(_vm.atividade, "descricao", $$v)
      },
      expression: "atividade.descricao"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Principal objetivo específico ao qual esta atividade está vinculada",
      "items": _vm.objetivosEspecificosTopicos,
      "item-text": "nome",
      "item-value": "nome",
      "prepend-icon": "dashboard",
      "rules": _vm.obrigatorio,
      "autocomplete": ""
    },
    model: {
      value: (_vm.atividade.objetivoEspecifico),
      callback: function($$v) {
        _vm.$set(_vm.atividade, "objetivoEspecifico", $$v)
      },
      expression: "atividade.objetivoEspecifico"
    }
  }, [_c('template', {
    slot: "no-data"
  }, [_vm._v("\n                      Não existem objetivos específicos cadastrados.\n                    ")])], 2)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Situação da atividade",
      "items": _vm.listaSituacaoAtividade,
      "item-text": "descricao",
      "item-value": "item",
      "prepend-icon": "dashboard",
      "rules": _vm.obrigatorio,
      "autocomplete": "",
      "return-object": ""
    },
    on: {
      "change": function($event) {
        return _vm.limpaDatasResultados()
      }
    },
    model: {
      value: (_vm.atividade.situacaoAtividade),
      callback: function($$v) {
        _vm.$set(_vm.atividade, "situacaoAtividade", $$v)
      },
      expression: "atividade.situacaoAtividade"
    }
  })], 1)], 1), _vm._v(" "), (_vm.atividade.situacaoAtividade.item === 1) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-date-menu', {
    attrs: {
      "label": "Data de início prevista",
      "rules": _vm.atividade.situacaoAtividade.item === 1 ? _vm.obrigatorio : null
    },
    model: {
      value: (_vm.atividade.dtInicioPrevisto),
      callback: function($$v) {
        _vm.$set(_vm.atividade, "dtInicioPrevisto", $$v)
      },
      expression: "atividade.dtInicioPrevisto"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-date-menu', {
    attrs: {
      "label": "Data de conclusão prevista",
      "rules": _vm.atividade.situacaoAtividade.item === 1 ? _vm.obrigatorio : null
    },
    model: {
      value: (_vm.atividade.dtFimPrevisto),
      callback: function($$v) {
        _vm.$set(_vm.atividade, "dtFimPrevisto", $$v)
      },
      expression: "atividade.dtFimPrevisto"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.atividade.situacaoAtividade.item === 2) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-date-menu', {
    attrs: {
      "label": "Data de início efetiva",
      "rules": _vm.atividade.situacaoAtividade.item === 2 ? _vm.obrigatorio : null
    },
    model: {
      value: (_vm.atividade.dtInicioEfetivo),
      callback: function($$v) {
        _vm.$set(_vm.atividade, "dtInicioEfetivo", $$v)
      },
      expression: "atividade.dtInicioEfetivo"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-date-menu', {
    attrs: {
      "label": "Data de conclusão prevista",
      "rules": _vm.atividade.situacaoAtividade.item === 2 ? _vm.obrigatorio : null
    },
    model: {
      value: (_vm.atividade.dtFimPrevisto),
      callback: function($$v) {
        _vm.$set(_vm.atividade, "dtFimPrevisto", $$v)
      },
      expression: "atividade.dtFimPrevisto"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.atividade.situacaoAtividade.item === 3) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-date-menu', {
    attrs: {
      "label": "Data de início efetiva",
      "rules": _vm.atividade.situacaoAtividade.item === 3 ? _vm.obrigatorio : null
    },
    model: {
      value: (_vm.atividade.dtInicioEfetivo),
      callback: function($$v) {
        _vm.$set(_vm.atividade, "dtInicioEfetivo", $$v)
      },
      expression: "atividade.dtInicioEfetivo"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-date-menu', {
    attrs: {
      "label": "Data de conclusão efetiva",
      "rules": _vm.atividade.situacaoAtividade.item === 3 ? _vm.obrigatorio : null
    },
    model: {
      value: (_vm.atividade.dtFimEfetivo),
      callback: function($$v) {
        _vm.$set(_vm.atividade, "dtFimEfetivo", $$v)
      },
      expression: "atividade.dtFimEfetivo"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.atividade.situacaoAtividade.item === 2 || _vm.atividade.situacaoAtividade.item === 3) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Resultados",
      "rows": "3",
      "auto-grow": "",
      "rules": _vm.resultadosRules,
      "counter": "1000"
    },
    model: {
      value: (_vm.atividade.resultados),
      callback: function($$v) {
        _vm.$set(_vm.atividade, "resultados", $$v)
      },
      expression: "atividade.resultados"
    }
  })], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.cancelar
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.criarAtividade(false)
      }
    }
  }, [_vm._v("Criar")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.criarAtividade(true)
      }
    }
  }, [_vm._v("Criar e Avançar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(598)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(599),
  /* template */
  __webpack_require__(600),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 598 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_textarea__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_c_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto'],
  data: function data() {
    return {
      formularioValido: false,
      parceria: {
        nome: '',
        detalhamento: ''
      },
      projeto: {
        titulo: '',
        dataInicio: '',
        dataConclusao: '',
        observacoes: '',
        situacao: {},
        tipoPublico: {},
        tipoEvento: {}
      },
      regrasBasicas: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }],
      assuntoSummaryRules255: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }, function (input) {
        return !!input && input.length <= 255 || 'Este campo não pode possuir mais que 255 caracteres';
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    cancelar: function cancelar() {
      this.$router.push({ name: 'ParceriasProjeto', params: { idProjeto: this.idProjeto } });
    },
    criarParceria: function criarParceria(avancar) {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Criando nova parceria.' });
      __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].postParceriasDoProjeto(this.idProjeto, this.parceria).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        if (avancar === false) {
          _this.parceria.nome = '';
          _this.parceria.detalhamento = '';
          _this.$router.push({ name: 'ParceriasProjeto', params: { idProjeto: _this.idProjeto } });
        } else {
          _this.$router.push({ name: 'NovaLocalidade', params: { idProjeto: _this.idProjeto } });
        }
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Criando nova parceria.' });
      });
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getProjeto(this.idProjeto).then(function (response) {
      _this2.projeto = response.data;
      _this2.dataInicioFormatada = _this2.dates.format(_this2.projeto.dataInicio);
      _this2.dataConclusaoFormatada = _this2.dates.format(_this2.projeto.dataConclusao);
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a,
    'c-date-menu': __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default.a,
    'c-textarea': __WEBPACK_IMPORTED_MODULE_4__components_c_textarea___default.a
  }
});

/***/ }),
/* 600 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Nova Parceria'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome do parceiro institucional/colaborador",
      "required": "",
      "rules": _vm.assuntoSummaryRules255,
      "max-height": "400"
    },
    model: {
      value: (_vm.parceria.nome),
      callback: function($$v) {
        _vm.$set(_vm.parceria, "nome", $$v)
      },
      expression: "parceria.nome"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-textarea', {
    attrs: {
      "label": "Descrição da parceria/colaboração",
      "required": "",
      "rules": _vm.assuntoSummaryRules255,
      "rows": 3,
      "auto-grow": true,
      "multi-line": "",
      "counter": "255"
    },
    model: {
      value: (_vm.parceria.detalhamento),
      callback: function($$v) {
        _vm.$set(_vm.parceria, "detalhamento", $$v)
      },
      expression: "parceria.detalhamento"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.cancelar
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.criarParceria(false)
      }
    }
  }, [_vm._v("Criar")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.criarParceria(true)
      }
    }
  }, [_vm._v("Criar e Avançar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(602)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(603),
  /* template */
  __webpack_require__(604),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 602 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_textarea__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_c_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_c_checkbox_table__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_c_checkbox_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_c_checkbox_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto'],
  data: function data() {
    return {
      search: null,
      headers: [{ checkbox: true, sortable: false, value: 'checkbox' }, { text: 'Nome', align: 'center', value: 'nomeCidade' }],
      sortDesc: false,
      itemsPerPage: 5,
      opcoesPaginacao: [5, 10, 25, 50, { text: 'Todas', value: -1 }],
      formularioValido: false,
      localidade: {
        nome: '',
        detalhamento: '',
        ufCidade: {}
      },
      contador: 0,
      projeto: {
        titulo: '',
        dataInicio: '',
        dataConclusao: '',
        observacoes: '',
        situacao: {},
        tipoPublico: {},
        tipoEvento: {}
      },
      listaEstados: [],
      listaCidades: [],
      listaCidadesSelecionadas: [],
      regrasBasicas: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }],
      assuntoSummaryRules: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }, function (input) {
        return !!input && input.length <= 200 || 'Este campo não pode possuir mais que 200 caracteres';
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    cancelar: function cancelar() {
      this.$router.push({ name: 'AbrangenciaProjeto', params: { idProjeto: this.idProjeto } });
    },
    criarLocalidade: function criarLocalidade(localidade, avancar) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].postLocalidade(this.idProjeto, localidade).then(function (response) {
        if (_this.contador === 1) {
          _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Salvando localidades.' });
          if (avancar === false) {
            _this.$router.push({ name: 'AbrangenciaProjeto', params: { idProjeto: _this.idProjeto } });
          } else {
            _this.$router.push({ name: 'ArquivosProjeto', params: { idProjeto: _this.idProjeto } });
          }
          _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        }
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.contador--;
        if (_this.contador === 0) {
          _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Salvando localidades.' });
        }
      });
    },
    criarLocalidades: function criarLocalidades(avancar) {
      var _this2 = this;

      this.contador = this.listaCidadesSelecionadas.length;
      if (this.contador === 0) {
        this.contador = 1;
        var aux = {
          nome: this.localidade.nome,
          cep: this.localidade.cep,
          detalhes: this.localidade.detalhes,
          ufCidade: this.localidade.ufCidade,
          cidade: null
        };
        this.criarLocalidade(aux, avancar);
      } else {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Salvando localidades.' });
        if (this.listaCidadesSelecionadas.length > 1) {
          this.localidade.cep = null;
        }
        this.listaCidadesSelecionadas.forEach(function (item) {
          var aux = {
            nome: _this2.localidade.nome,
            cep: _this2.localidade.cep,
            detalhes: _this2.localidade.detalhes,
            ufCidade: _this2.localidade.ufCidade,
            cidade: { id: item }
          };
          _this2.criarLocalidade(aux, avancar);
        });
      }
    },
    atualizaCidades: function atualizaCidades(event) {
      var _this3 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando cidades.' });
      __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].getCidades(event.item).then(function (response) {
        _this3.listaCidades = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this3.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando cidades.' });
      });
    },
    atualizaListaCidadesSelecionadas: function atualizaListaCidadesSelecionadas(cidade) {
      console.log(this.listaCidadesSelecionadas);
    },
    opcoesTabelaEstruturada: function opcoesTabelaEstruturada(codTabela, aqui, atributo) {
      var _this4 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' });
      __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].getOpcoesTabelaEstruturada(codTabela).then(function (response) {
        aqui[atributo] = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this4.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' });
      });
    }
  }),
  mounted: function mounted() {
    var _this5 = this;

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].getProjeto(this.idProjeto).then(function (response) {
      _this5.projeto = response.data;
      _this5.dataInicioFormatada = _this5.dates.format(_this5.projeto.dataInicio);
      _this5.dataConclusaoFormatada = _this5.dates.format(_this5.projeto.dataConclusao);
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this5.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    });

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando estados.' });
    __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].getEstados(1).then(function (response) {
      _this5.listaEstados = response.data.slice();
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this5.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando estados.' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a,
    'c-date-menu': __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default.a,
    'c-checkbox-table': __WEBPACK_IMPORTED_MODULE_5__components_c_checkbox_table___default.a,
    'c-textarea': __WEBPACK_IMPORTED_MODULE_4__components_c_textarea___default.a
  }
});

/***/ }),
/* 604 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Novas Localidades'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Estado",
      "items": _vm.listaEstados,
      "item-text": "descricao",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "return-object": "",
      "required": "",
      "autocomplete": "",
      "rules": _vm.regrasBasicas
    },
    on: {
      "change": function($event) {
        return _vm.atualizaCidades($event)
      }
    },
    model: {
      value: (_vm.localidade.ufCidade),
      callback: function($$v) {
        _vm.$set(_vm.localidade, "ufCidade", $$v)
      },
      expression: "localidade.ufCidade"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "filter_list",
      "label": "Filtrar resultados"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "d-block": "",
      "xs12": ""
    }
  }, [_c('c-checkbox-table', {
    attrs: {
      "items": _vm.listaCidades,
      "headers": _vm.headers,
      "opcoesPaginacao": _vm.opcoesPaginacao,
      "search": _vm.search,
      "item-key": "id",
      "selecionarTudo": true
    },
    model: {
      value: (_vm.listaCidadesSelecionadas),
      callback: function($$v) {
        _vm.listaCidadesSelecionadas = $$v
      },
      expression: "listaCidadesSelecionadas"
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome da localidade ou instituição",
      "required": "",
      "rules": _vm.regrasBasicas,
      "max-height": "400"
    },
    model: {
      value: (_vm.localidade.nome),
      callback: function($$v) {
        _vm.$set(_vm.localidade, "nome", $$v)
      },
      expression: "localidade.nome"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.listaCidadesSelecionadas.length < 2) ? _c('v-text-field', {
    attrs: {
      "label": "CEP",
      "max-height": "400"
    },
    model: {
      value: (_vm.localidade.cep),
      callback: function($$v) {
        _vm.$set(_vm.localidade, "cep", $$v)
      },
      expression: "localidade.cep"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-textarea', {
    attrs: {
      "label": "Informações adicionais",
      "rows": 3,
      "auto-grow": true,
      "multi-line": "",
      "counter": "200"
    },
    model: {
      value: (_vm.localidade.detalhes),
      callback: function($$v) {
        _vm.$set(_vm.localidade, "detalhes", $$v)
      },
      expression: "localidade.detalhes"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.cancelar
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.criarLocalidades(false)
      }
    }
  }, [_vm._v("Adicionar")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.criarLocalidades(true)
      }
    }
  }, [_vm._v("Adicionar e Avançar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(606)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(607),
  /* template */
  __webpack_require__(616),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 606 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_date_dialog__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_date_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_c_date_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_c_textarea__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_c_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_c_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto', 'idAtividade'],
  data: function data() {
    return {
      formularioValido: false,
      atividade: {},
      projeto: {
        titulo: '',
        dataInicio: '',
        dataConclusao: '',
        observacoes: '',
        situacao: {},
        tipoPublico: {},
        tipoEvento: {}
      },
      extensao: {},
      objetivosEspecificosTopicos: [],
      listaSituacaoAtividade: null,
      listaSituacaoAtividadeNaoPreenchida: [{ item: 1, descricao: 'Não iniciada' }, { item: 2, descricao: 'Em andamento' }, { item: 3, descricao: 'Cumprida' }],
      listaSituacaoAtividadeNaoIniciada: [{ item: 1, descricao: 'Não iniciada' }, { item: 2, descricao: 'Em andamento' }, { item: 3, descricao: 'Cumprida' }, { item: 4, descricao: 'Cancelada' }],
      listaSituacaoAtividadeEmAndamento: [{ item: 2, descricao: 'Em andamento' }, { item: 3, descricao: 'Cumprida' }, { item: 4, descricao: 'Cancelada' }],
      listaSituacaoAtividadeCumprida: [{ item: 3, descricao: 'Cumprida' }],
      listaSituacaoAtividadeCancelada: [{ item: 4, descricao: 'Cancelada' }],
      obrigatorio: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }],
      assuntoSummaryRules: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }, function (input) {
        return !!input && input.length <= 200 || 'Este campo não pode possuir mais que 200 caracteres';
      }],
      nomeAtividadeRules: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }, function (input) {
        return !!input && input.length <= 250 || 'Este campo não pode possuir mais que 250 caracteres';
      }],
      resultadosRules: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }, function (input) {
        return !!input && input.length <= 1000 || 'Este campo não pode possuir mais que 1000 caracteres';
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    cancelar: function cancelar() {
      this.$router.push({ name: 'AtividadesProjeto', params: { idProjeto: this.idProjeto } });
    },
    editarAtividade: function editarAtividade() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Salvando atividade.' });
      // Não iniciada ou cancelada
      if (this.atividade.situacaoAtividade !== null && (this.atividade.situacaoAtividade.item === 1 || this.atividade.situacaoAtividade.item === 4)) {
        this.atividade.dtInicioEfetivo = null;
        this.atividade.dtFimEfetivo = null;
        this.atividade.resultados = null;
      }
      // Em andamento
      if (this.atividade.situacaoAtividade !== null && this.atividade.situacaoAtividade.item === 2) {
        this.atividade.dtFimEfetivo = null;
      }
      __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].putAtividade(this.idProjeto, this.idAtividade, this.atividade).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.$router.push({ name: 'AtividadesProjeto', params: { idProjeto: _this.idProjeto } });
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Salvando atividade.' });
      });
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações.' });
    __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].getExtensaoDoProjeto(this.idProjeto).then(function (response) {
      _this2.extensao = response.data;
      var aux = _this2.extensao.objetivosEspecificos.split(';;');
      for (var item in aux) {
        _this2.objetivosEspecificosTopicos.push({ id: item, nome: aux[item] });
      }
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações.' });
    });

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando atividade.' });
    __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].getAtividade(this.idProjeto, this.idAtividade).then(function (response) {
      _this2.atividade = response.data;
      // Não iniciada
      if (_this2.atividade.situacaoAtividade !== null && _this2.atividade.situacaoAtividade.item === 1) {
        _this2.listaSituacaoAtividade = _this2.listaSituacaoAtividadeNaoIniciada;
      }
      // Em andamento
      if (_this2.atividade.situacaoAtividade !== null && _this2.atividade.situacaoAtividade.item === 2) {
        _this2.listaSituacaoAtividade = _this2.listaSituacaoAtividadeEmAndamento;
      }
      // Cumprida
      if (_this2.atividade.situacaoAtividade !== null && _this2.atividade.situacaoAtividade.item === 3) {
        _this2.listaSituacaoAtividade = _this2.listaSituacaoAtividadeCumprida;
      }
      // Cancelada
      if (_this2.atividade.situacaoAtividade !== null && _this2.atividade.situacaoAtividade.item === 4) {
        _this2.listaSituacaoAtividade = _this2.listaSituacaoAtividadeCancelada;
      }
      // Situação da atividade não preenchida
      if (_this2.atividade.situacaoAtividade === null) {
        _this2.listaSituacaoAtividade = _this2.listaSituacaoAtividadeNaoPreenchida;
      }
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando atividade.' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a,
    'c-date-menu': __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default.a,
    'c-date-dialog': __WEBPACK_IMPORTED_MODULE_4__components_c_date_dialog___default.a,
    'c-textarea': __WEBPACK_IMPORTED_MODULE_5__components_c_textarea___default.a
  }
});

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['label', 'value', 'rules', 'clearable', 'required', 'disabled'],
  data: function data() {
    return {
      date: '',
      dateFormatted: '',
      dialogMenu: false
    };
  },

  computed: {
    computedDateFormatted: function computedDateFormatted() {
      return this.formatDate(this.date);
    }
  },
  watch: {
    date: function date(val) {
      this.dateFormatted = this.formatDate(this.date);
    },
    value: function value(val) {
      if (!val) {
        this.date = '';
        this.dateFormatted = '';
      } else {
        this.date = val;
        this.dateFormatted = this.formatDate(val);
      }
    }
  },
  methods: {
    formatDate: function formatDate(date) {
      if (!date) return null;

      var _date$split = date.split('-'),
          _date$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split, 3),
          year = _date$split2[0],
          month = _date$split2[1],
          day = _date$split2[2];

      return day + '/' + month + '/' + year;
    },
    parseDate: function parseDate(date) {
      if (!date) return null;

      var _date$split3 = date.split('/'),
          _date$split4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split3, 3),
          month = _date$split4[0],
          day = _date$split4[1],
          year = _date$split4[2];

      return year + '-' + month.padStart(2, '0') + '-' + day.padStart(2, '0');
    },
    setData: function setData() {
      this.$emit('input', this.date);
    }
  }
});

/***/ }),
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    ref: "dialog",
    attrs: {
      "return-value": _vm.date,
      "persistent": "",
      "width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "label": _vm.label,
            "rules": _vm.rules,
            "readonly": "",
            "prepend-icon": "event"
          },
          model: {
            value: (_vm.dateFormatted),
            callback: function($$v) {
              _vm.dateFormatted = $$v
            },
            expression: "dateFormatted"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.dialogMenu),
      callback: function($$v) {
        _vm.dialogMenu = $$v
      },
      expression: "dialogMenu"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "pt-br",
      "scrollable": "",
      "autosave": ""
    },
    on: {
      "input": function($event) {
        return _vm.setData()
      }
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogMenu = false
      }
    }
  }, [_vm._v("\n            Cancelar\n          ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dialog.save(_vm.date)
      }
    }
  }, [_vm._v("\n            OK\n          ")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 616 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Editar Atividade'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": _vm.atividade.detalhamento !== null && _vm.atividade.detalhamento !== '' ? 'Nome da atividade' : 'Nome e descrição sucinta da atividade',
      "rows": "1",
      "auto-grow": "",
      "required": "",
      "rules": _vm.nomeAtividadeRules,
      "counter": "250",
      "max-height": "400"
    },
    model: {
      value: (_vm.atividade.descricao),
      callback: function($$v) {
        _vm.$set(_vm.atividade, "descricao", $$v)
      },
      expression: "atividade.descricao"
    }
  })], 1)], 1), _vm._v(" "), (_vm.atividade.detalhamento !== null && _vm.atividade.detalhamento !== '') ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-textarea', {
    attrs: {
      "label": "Descrição sucinta da atividade",
      "required": "",
      "rules": _vm.assuntoSummaryRules,
      "rows": 3,
      "auto-grow": true,
      "multi-line": "",
      "counter": "200"
    },
    model: {
      value: (_vm.atividade.detalhamento),
      callback: function($$v) {
        _vm.$set(_vm.atividade, "detalhamento", $$v)
      },
      expression: "atividade.detalhamento"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Principal objetivo específico ao qual esta atividade está vinculada",
      "items": _vm.objetivosEspecificosTopicos,
      "item-text": "nome",
      "item-value": "nome",
      "prepend-icon": "dashboard",
      "rules": _vm.obrigatorio,
      "autocomplete": ""
    },
    model: {
      value: (_vm.atividade.objetivoEspecifico),
      callback: function($$v) {
        _vm.$set(_vm.atividade, "objetivoEspecifico", $$v)
      },
      expression: "atividade.objetivoEspecifico"
    }
  }, [_c('template', {
    slot: "no-data"
  }, [_vm._v("\n                      Não existem objetivos específicos cadastrados.\n                    ")])], 2)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Situação da atividade",
      "items": _vm.listaSituacaoAtividade,
      "item-text": "descricao",
      "item-value": "item",
      "prepend-icon": "dashboard",
      "rules": _vm.obrigatorio,
      "autocomplete": "",
      "return-object": ""
    },
    model: {
      value: (_vm.atividade.situacaoAtividade),
      callback: function($$v) {
        _vm.$set(_vm.atividade, "situacaoAtividade", $$v)
      },
      expression: "atividade.situacaoAtividade"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Data de início prevista",
      "rules": _vm.obrigatorio,
      "type": "date"
    },
    model: {
      value: (_vm.atividade.dtInicioPrevisto),
      callback: function($$v) {
        _vm.$set(_vm.atividade, "dtInicioPrevisto", $$v)
      },
      expression: "atividade.dtInicioPrevisto"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Data de conclusão prevista",
      "rules": _vm.obrigatorio,
      "type": "date"
    },
    model: {
      value: (_vm.atividade.dtFimPrevisto),
      callback: function($$v) {
        _vm.$set(_vm.atividade, "dtFimPrevisto", $$v)
      },
      expression: "atividade.dtFimPrevisto"
    }
  })], 1)], 1), _vm._v(" "), (_vm.atividade.situacaoAtividade !== null && (_vm.atividade.situacaoAtividade.item === 2 || _vm.atividade.situacaoAtividade.item === 3)) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.atividade.situacaoAtividade !== null && (_vm.atividade.situacaoAtividade.item === 2 || _vm.atividade.situacaoAtividade.item === 3)) ? _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Data de início efetiva",
      "rules": _vm.atividade.situacaoAtividade !== null && (_vm.atividade.situacaoAtividade.item === 2 || _vm.atividade.situacaoAtividade.item === 3) ? _vm.obrigatorio : null,
      "type": "date"
    },
    model: {
      value: (_vm.atividade.dtInicioEfetivo),
      callback: function($$v) {
        _vm.$set(_vm.atividade, "dtInicioEfetivo", $$v)
      },
      expression: "atividade.dtInicioEfetivo"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.atividade.situacaoAtividade !== null && _vm.atividade.situacaoAtividade.item === 3) ? _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Data de conclusão efetiva",
      "rules": _vm.atividade.situacaoAtividade !== null && _vm.atividade.situacaoAtividade.item === 3 ? _vm.obrigatorio : null,
      "type": "date"
    },
    model: {
      value: (_vm.atividade.dtFimEfetivo),
      callback: function($$v) {
        _vm.$set(_vm.atividade, "dtFimEfetivo", $$v)
      },
      expression: "atividade.dtFimEfetivo"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.atividade.situacaoAtividade !== null && (_vm.atividade.situacaoAtividade.item === 2 || _vm.atividade.situacaoAtividade.item === 3)) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Resultados",
      "rows": "3",
      "auto-grow": "",
      "rules": _vm.resultadosRules,
      "counter": "1000"
    },
    model: {
      value: (_vm.atividade.resultados),
      callback: function($$v) {
        _vm.$set(_vm.atividade, "resultados", $$v)
      },
      expression: "atividade.resultados"
    }
  })], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.cancelar
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": _vm.editarAtividade
    }
  }, [_vm._v("Salvar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(618)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(619),
  /* template */
  __webpack_require__(620),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 618 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_textarea__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_c_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto', 'idParceria'],
  data: function data() {
    return {
      formularioValido: false,
      parceria: {
        nome: '',
        detalhamento: ''
      },
      projeto: {
        titulo: '',
        dataInicio: '',
        dataConclusao: '',
        observacoes: '',
        situacao: {},
        tipoPublico: {},
        tipoEvento: {}
      },
      regrasBasicas: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }],
      assuntoSummaryRules255: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }, function (input) {
        return !!input && input.length <= 255 || 'Este campo não pode possuir mais que 255 caracteres';
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    cancelar: function cancelar() {
      this.$router.push({ name: 'ParceriasProjeto', params: { idProjeto: this.idProjeto } });
    },
    editarParceria: function editarParceria(avancar) {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Salvando parceria.' });
      __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].putParceriasDoProjeto(this.idProjeto, this.idParceria, this.parceria).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.parceria.nome = '';
        _this.parceria.detalhamento = '';
        _this.$router.push({ name: 'ParceriasProjeto', params: { idProjeto: _this.idProjeto } });
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Salvando parceria.' });
      });
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getProjeto(this.idProjeto).then(function (response) {
      _this2.projeto = response.data;
      _this2.dataInicioFormatada = _this2.dates.format(_this2.projeto.dataInicio);
      _this2.dataConclusaoFormatada = _this2.dates.format(_this2.projeto.dataConclusao);
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    });
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando parceria.' });
    __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getParceria(this.idProjeto, this.idParceria).then(function (response) {
      _this2.parceria = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando parceria.' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a,
    'c-date-menu': __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default.a,
    'c-textarea': __WEBPACK_IMPORTED_MODULE_4__components_c_textarea___default.a
  }
});

/***/ }),
/* 620 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Editar Parceria'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome do parceiro institucional/colaborador",
      "required": "",
      "rules": _vm.assuntoSummaryRules255,
      "max-height": "400"
    },
    model: {
      value: (_vm.parceria.nome),
      callback: function($$v) {
        _vm.$set(_vm.parceria, "nome", $$v)
      },
      expression: "parceria.nome"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-textarea', {
    attrs: {
      "label": "Descrição da parceria/colaboração",
      "required": "",
      "rules": _vm.assuntoSummaryRules255,
      "rows": 3,
      "auto-grow": true,
      "multi-line": "",
      "counter": "255"
    },
    model: {
      value: (_vm.parceria.detalhamento),
      callback: function($$v) {
        _vm.$set(_vm.parceria, "detalhamento", $$v)
      },
      expression: "parceria.detalhamento"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.cancelar
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.editarParceria(false)
      }
    }
  }, [_vm._v("Salvar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(622)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(623),
  /* template */
  __webpack_require__(624),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 622 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto'],
  data: function data() {
    return {
      formularioValido: false,
      temNomeSocial: false,
      pessoa: {
        nome: '',
        nomeSocial: '',
        cpf: ''
      },
      regrasBasicas: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }],
      assuntoSummaryRules255: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }, function (input) {
        return !!input && input.length <= 255 || 'Este campo não pode possuir mais que 255 caracteres';
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    cancelar: function cancelar() {
      this.$router.push({ name: 'ParceriasProjeto', params: { idProjeto: this.idProjeto } });
    },
    criarPessoa: function criarPessoa(avancar) {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Criando novo membro externo.' });

      if (!this.temNomeSocial) {
        this.pessoa.nomeSocial = this.pessoa.nome;
      }

      __WEBPACK_IMPORTED_MODULE_4__utils_projetos__["a" /* default */].postPessoa(this.pessoa).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        var link = response.body.link;
        var idPessoa = link.split('/')[5];
        if (confirm('Deseja adicionar essa pessoa como integrante do projeto?')) {
          _this.adicionarIntegrante(idPessoa);
        } else {
          _this.$router.go(-1);
        }
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Criando novo membro externo.' });
      });
    },
    adicionarIntegrante: function adicionarIntegrante(idPessoa) {
      var _this2 = this;

      console.log('Entrou aqui');
      // let hoje = new Date()
      // let dd = hoje.getDate()
      // let mm = hoje.getMonth() + 1
      // let yyyy = hoje.getFullYear()
      var data = this.projeto.dataInicio;
      var integrante = {
        idPessoa: idPessoa,
        funcao: { item: 18, descricao: 'Integrante' },
        titulacao: { item: 99, descricao: 'Escolaridade/Titulação Indefinida' },
        cargaHoraria: 0,
        dataInicial: data,
        situacao: 'A'
      };
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Adicionando integrante...' });
      __WEBPACK_IMPORTED_MODULE_4__utils_projetos__["a" /* default */].postIntegrante(this.$props.idProjeto, integrante).then(function (response) {
        _this2.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: 'Integrante adicionado com sucesso!' });
        var listaLink = response.body.link.split('/');
        var idIntegranteAux = listaLink[listaLink.length - 1];
        _this2.$router.push({ name: 'EditarIntegrante', params: { idProjeto: _this2.idProjeto, idParticipante: idIntegranteAux } });
      }).catch(function (error) {
        console.log('Erro ao mandar a requisição' + error);
        _this2.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Adicionando integrante...' });
      });
    }
  }),
  mounted: function mounted() {
    var _this3 = this;

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    __WEBPACK_IMPORTED_MODULE_4__utils_projetos__["a" /* default */].getProjeto(this.idProjeto).then(function (response) {
      _this3.projeto = response.data;
      _this3.dataInicioFormatada = _this3.dates.format(_this3.projeto.dataInicio);
      _this3.dataConclusaoFormatada = _this3.dates.format(_this3.projeto.dataConclusao);
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this3.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a,
    'c-date-menu': __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default.a
  }
});

/***/ }),
/* 624 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Novo Membro Externo'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm10": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome",
      "required": "",
      "rules": _vm.assuntoSummaryRules255,
      "max-height": "400"
    },
    model: {
      value: (_vm.pessoa.nome),
      callback: function($$v) {
        _vm.$set(_vm.pessoa, "nome", $$v)
      },
      expression: "pessoa.nome"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm10": "",
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Possui nome social?"
    },
    model: {
      value: (_vm.temNomeSocial),
      callback: function($$v) {
        _vm.temNomeSocial = $$v
      },
      expression: "temNomeSocial"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm10": "",
      "xs12": ""
    }
  }, [(_vm.temNomeSocial) ? _c('v-text-field', {
    attrs: {
      "label": "Nome Social",
      "required": "",
      "rules": _vm.assuntoSummaryRules255,
      "max-height": "400"
    },
    model: {
      value: (_vm.pessoa.nomeSocial),
      callback: function($$v) {
        _vm.$set(_vm.pessoa, "nomeSocial", $$v)
      },
      expression: "pessoa.nomeSocial"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm10": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "CPF",
      "mask": "###.###.###-##",
      "return-masked-value": "",
      "required": ""
    },
    model: {
      value: (_vm.pessoa.cpf),
      callback: function($$v) {
        _vm.$set(_vm.pessoa, "cpf", $$v)
      },
      expression: "pessoa.cpf"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.criarPessoa(false)
      }
    }
  }, [_vm._v("Cadastrar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(626)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(627),
  /* template */
  __webpack_require__(628),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 626 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_date_menu__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_date_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_date_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto'],
  data: function data() {
    return {
      formularioValido: false,
      temNomeSocial: false,
      listaSexo: [{ descricao: 'Masculino', item: 'M' }, { descricao: 'Feminino', item: 'F' }],
      pessoa: {
        nome: '',
        nomeSocial: '',
        cpf: '',
        passaporte: '',
        estrangeiro: false
      },
      assuntoSummaryRules255: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }, function (input) {
        return !!input && input.length <= 255 || 'Este campo não pode possuir mais que 255 caracteres';
      }],
      cpfRules: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }],
      passaporteRules: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }],
      excadServer: {}
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    cancelar: function cancelar() {
      this.$router.push({ name: 'ParceriasProjeto', params: { idProjeto: this.idProjeto } });
    },
    criarPessoa: function criarPessoa(avancar) {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Criando novo membro externo.' });

      if (!this.temNomeSocial || this.pessoa.estrangeiro === true) {
        this.pessoa.nomeSocial = this.pessoa.nome;
      }

      __WEBPACK_IMPORTED_MODULE_3__utils_projetos__["a" /* default */].postPessoa(this.pessoa).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        var link = response.body.link;
        var idPessoa = link.split('/')[5];
        if (confirm('Deseja adicionar essa pessoa como integrante do projeto?')) {
          _this.adicionarIntegrante(idPessoa);
        } else {
          _this.$router.go(-1);
        }
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Criando novo membro externo.' });
      });
    },
    adicionarIntegrante: function adicionarIntegrante(idPessoa) {
      var _this2 = this;

      console.log('Entrou aqui');
      // let hoje = new Date()
      // let dd = hoje.getDate()
      // let mm = hoje.getMonth() + 1
      // let yyyy = hoje.getFullYear()
      var data = this.projeto.dataInicio;
      var integrante = {
        idPessoa: idPessoa,
        funcao: { item: 18, descricao: 'Integrante' },
        titulacao: { item: 99, descricao: 'Escolaridade/Titulação Indefinida' },
        cargaHoraria: 0,
        dataInicial: data,
        situacao: 'A'
      };
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Adicionando integrante...' });
      __WEBPACK_IMPORTED_MODULE_3__utils_projetos__["a" /* default */].postIntegrante(this.$props.idProjeto, integrante).then(function (response) {
        _this2.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: 'Integrante adicionado com sucesso!' });
        var listaLink = response.body.link.split('/');
        var idIntegranteAux = listaLink[listaLink.length - 1];
        _this2.$router.push({ name: 'EditarIntegrante', params: { idProjeto: _this2.idProjeto, idParticipante: idIntegranteAux } });
      }).catch(function (error) {
        console.log('Erro ao mandar a requisição' + error);
        _this2.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Adicionando integrante...' });
      });
    }
  }),
  mounted: function mounted() {
    var _this3 = this;

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    __WEBPACK_IMPORTED_MODULE_3__utils_projetos__["a" /* default */].getProjeto(this.idProjeto).then(function (response) {
      _this3.projeto = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this3.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    });

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando endereço do servidor do ExCAD.' });
    __WEBPACK_IMPORTED_MODULE_3__utils_projetos__["a" /* default */].getExcadServer().then(function (response) {
      _this3.excadServer = response.data;
      // Preenche o link com a URL do ExCAD.
      var excadServerUrl = _this3.excadServer.url;
      document.getElementById('excadLink').setAttribute('href', excadServerUrl);
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this3.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando endereço do servidor do ExCAD.' });
    });
  },


  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'c-date-menu': __WEBPACK_IMPORTED_MODULE_2__components_c_date_menu___default.a
  }
});

/***/ }),
/* 628 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Cadastrar Membro Externo'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "center"
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-text', {
    staticClass: "black--text font-weight-bold"
  }, [_vm._v("\n                        Cadastre o membro externo preenchendo os dados do formulário abaixo. Caso o membro externo necessite ter acesso aos sistemas corporativos da UFES ou ao\n                        "), _c('a', {
    attrs: {
      "href": "http://nti.ufes.br/eduroam",
      "target": "_blank"
    }
  }, [_vm._v("Eduroam")]), _vm._v(", o cadastro deve ser realizado por meio do sistema "), _c('a', {
    attrs: {
      "href": "url",
      "id": "excadLink",
      "target": "_blank"
    }
  }, [_vm._v("ExCAD - Extensão do Cadastro")]), _vm._v(".\n                        Para obter maiores informações sobre o sistema ExCAD, clique no link a seguir: "), _c('a', {
    attrs: {
      "href": "http://www.sti.ufes.br/excad-extensao-de-cadastro-de-pessoas-sem-vinculo",
      "target": "_blank"
    }
  }, [_vm._v("STI - Serviços web - ExCAD")]), _vm._v(".\n                      ")])], 1)], 1)])], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm10": "",
      "xs12": ""
    }
  }, [_c('v-radio-group', {
    attrs: {
      "mandatory": "",
      "label": "O membro externo é estrangeiro?"
    },
    model: {
      value: (_vm.pessoa.estrangeiro),
      callback: function($$v) {
        _vm.$set(_vm.pessoa, "estrangeiro", $$v)
      },
      expression: "pessoa.estrangeiro"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Sim",
      "value": true
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Não",
      "value": false
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm10": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome",
      "required": "",
      "rules": _vm.assuntoSummaryRules255,
      "max-height": "400"
    },
    model: {
      value: (_vm.pessoa.nome),
      callback: function($$v) {
        _vm.$set(_vm.pessoa, "nome", $$v)
      },
      expression: "pessoa.nome"
    }
  })], 1)], 1), _vm._v(" "), (_vm.pessoa.estrangeiro === false) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm10": "",
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Possui nome social?"
    },
    model: {
      value: (_vm.temNomeSocial),
      callback: function($$v) {
        _vm.temNomeSocial = $$v
      },
      expression: "temNomeSocial"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm10": "",
      "xs12": ""
    }
  }, [(_vm.temNomeSocial) ? _c('v-text-field', {
    attrs: {
      "label": "Nome Social",
      "required": "",
      "rules": _vm.assuntoSummaryRules255,
      "max-height": "400"
    },
    model: {
      value: (_vm.pessoa.nomeSocial),
      callback: function($$v) {
        _vm.$set(_vm.pessoa, "nomeSocial", $$v)
      },
      expression: "pessoa.nomeSocial"
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.pessoa.estrangeiro === false) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm10": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "CPF",
      "mask": "###.###.###-##",
      "return-masked-value": "",
      "required": "",
      "rules": _vm.cpfRules
    },
    model: {
      value: (_vm.pessoa.cpf),
      callback: function($$v) {
        _vm.$set(_vm.pessoa, "cpf", $$v)
      },
      expression: "pessoa.cpf"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.pessoa.estrangeiro === true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm10": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Passaporte",
      "required": "",
      "rules": _vm.passaporteRules
    },
    model: {
      value: (_vm.pessoa.passaporte),
      callback: function($$v) {
        _vm.$set(_vm.pessoa, "passaporte", $$v)
      },
      expression: "pessoa.passaporte"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm4": "",
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Sexo",
      "items": _vm.listaSexo,
      "item-text": "descricao",
      "item-value": "item",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.pessoa.sexo),
      callback: function($$v) {
        _vm.$set(_vm.pessoa, "sexo", $$v)
      },
      expression: "pessoa.sexo"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm2": "",
      "xs0": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm4": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Data de nascimento",
      "required": "",
      "type": "date",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.pessoa.dtNascimento),
      callback: function($$v) {
        _vm.$set(_vm.pessoa, "dtNascimento", $$v)
      },
      expression: "pessoa.dtNascimento"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.criarPessoa(false)
      }
    }
  }, [_vm._v("Cadastrar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(630)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(631),
  /* template */
  __webpack_require__(632),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 630 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idPessoa'],
  data: function data() {
    return {
      formularioValido: false,
      temNomeSocial: false,
      pessoa: {
        nome: '',
        nomeSocial: ''
      },
      regrasBasicas: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }],
      assuntoSummaryRules255: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }, function (input) {
        return !!input && input.length <= 255 || 'Este campo não pode possuir mais que 255 caracteres';
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    cancelar: function cancelar() {
      this.$router.push({ name: 'ParceriasProjeto', params: { idProjeto: this.idProjeto } });
    },
    editarPessoa: function editarPessoa() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Editando pessoa.' });

      if (!this.temNomeSocial) {
        this.pessoa.nomeSocial = this.pessoa.nome;
      }

      __WEBPACK_IMPORTED_MODULE_4__utils_projetos__["a" /* default */].putPessoa(this.idPessoa, this.pessoa).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.$router.go(-1);
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Editando pessoa.' });
      });
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando pessoa.' });
    __WEBPACK_IMPORTED_MODULE_4__utils_projetos__["a" /* default */].getPessoa(this.idPessoa).then(function (response) {
      _this2.pessoa = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando pessoa.' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a,
    'c-date-menu': __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default.a
  }
});

/***/ }),
/* 632 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Editar Pessoa'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm10": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome",
      "required": "",
      "rules": _vm.assuntoSummaryRules255,
      "max-height": "400"
    },
    model: {
      value: (_vm.pessoa.nome),
      callback: function($$v) {
        _vm.$set(_vm.pessoa, "nome", $$v)
      },
      expression: "pessoa.nome"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm10": "",
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Possui nome social?"
    },
    model: {
      value: (_vm.temNomeSocial),
      callback: function($$v) {
        _vm.temNomeSocial = $$v
      },
      expression: "temNomeSocial"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm10": "",
      "xs12": ""
    }
  }, [(_vm.temNomeSocial) ? _c('v-text-field', {
    attrs: {
      "label": "Nome Social",
      "required": "",
      "rules": _vm.assuntoSummaryRules255,
      "max-height": "400"
    },
    model: {
      value: (_vm.pessoa.nomeSocial),
      callback: function($$v) {
        _vm.$set(_vm.pessoa, "nomeSocial", $$v)
      },
      expression: "pessoa.nomeSocial"
    }
  }) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.editarPessoa()
      }
    }
  }, [_vm._v("Salvar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(634)
  __webpack_require__(635)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(636),
  /* template */
  __webpack_require__(637),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-24eef6a5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 634 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 635 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_readonly_field__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_readonly_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_c_readonly_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_readonly_field_pre_format__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_readonly_field_pre_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_readonly_field_pre_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_assessor__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto', 'projeto'],
  data: function data() {
    return {
      dates: __WEBPACK_IMPORTED_MODULE_4__utils_dates__["a" /* default */],
      formatAssessor: __WEBPACK_IMPORTED_MODULE_3__utils_assessor__["a" /* default */],
      prazo: 30,
      show: false,
      headers0: [{ text: 'Nome', align: 'left', width: '50%', value: 'tipoClassificacao' }, { text: 'Descrição', left: 'left', width: '50%', value: 'descricao' }],
      headers1: [{ text: 'Nome', align: 'left', value: 'nome' }, { text: 'Função', align: 'left', value: 'funcao.descricao' }, { text: 'Assessor', align: 'left', value: 'assessor' }, { text: 'Vínculo', align: 'left', value: 'vinculo' }, { text: 'CH semanal', align: 'left', value: 'cargaHoraria' }, { text: 'Data inicial', align: 'left', value: 'dataInicial' }, { text: 'Data final', align: 'left', value: 'dataFinal' }],
      headers2: [{ text: 'Nome e descrição sucinta da atividade', align: 'left', width: '60%', value: 'nomeDescricao' }, { text: 'Início previsto', align: 'left', width: '10%', value: 'dtInicioPrevisto' }, { text: 'Conclusão prevista', align: 'left', width: '10%', value: 'dtFimPrevisto' }, { text: 'Início efetivo', align: 'left', width: '10%', value: 'dtInicioEfetivo' }, { text: 'Conclusão efetiva', align: 'left', width: '10%', value: 'dtFimEfetivo' }],
      headers2b: [{ text: 'Número', align: 'left', value: 'idProjeto' }, { text: 'Título', align: 'left', value: 'titulo' }, { text: 'Classificação Primária', align: 'left', value: 'classificacaoPrimaria.descricao' }, { text: 'Classificação Secundária', align: 'left', value: 'classificacaoSecundaria.descricao' }, { text: 'Situação', align: 'left', value: 'situacao.descricao' }, { text: 'Coordenador', align: 'left', value: 'nomeCoordenador' }],
      headers3: [{ text: 'Nome do parceiro institucional/colaborador', align: 'left', value: 'nome' }, { text: 'Descrição da parceria/colaboração', align: 'left', value: 'detalhamento' }],
      headers4: [{ text: 'Nome da localidade ou instituição', align: 'left', value: 'nome' }, { text: 'Estado', align: 'left', value: 'ufCidade.descricao' }, { text: 'Município', align: 'left', value: 'cidade.nomeCidade' }, { text: 'CEP', align: 'left', value: 'cep' }, { text: 'Informações adicionais', align: 'left', value: 'detalhes' }],
      headers5: [{ text: 'Nome', align: 'left', value: 'nome' }, { text: 'Tipo', align: 'left', value: 'tipoArquivo.descricao' }, { text: 'Data de inclusão', align: 'left', value: 'dtInclusao' }, { text: 'Observação', align: 'left', value: 'observacao' }],
      objetivosEspecificosTopicos: [],
      listaTiposPrestacaoServicoSelecionados: [],
      listaTiposPrestacaoServico: ['Atendimento ao público em espaços de cultura, ciência e tecnologia', 'Serviço eventual', 'Atividades de propriedade intelectual', 'Exames e laudos técnicos', 'Atendimento jurídico', 'Atendimento em saúde humana', 'Atendimento em saúde animal'],
      listaAtendimentoPublicoEspacosSelecionados: [],
      relatorio: {
        informacoes: {
          idProjeto: 0,
          titulo: '',
          dataInicio: '',
          dataConclusao: '',
          tipoPublico: {
            item: 0,
            descricao: ''
          },
          publicoAlvo: 0,
          cargaHoraria: null,
          resumo: '',
          situacao: {
            item: 0,
            descricao: ''
          },
          palavraChave01: '',
          palavraChave02: '',
          palavraChave03: '',
          palavraChave04: null
        },
        extensao: {
          unidade: null
        },
        contatos: {}
      }
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])('auth', ['administrador', 'usuarioPROEX'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING']), {
    truncate: function truncate(string, limit) {
      if (string.length > limit) return string.substring(0, limit) + '...';else return string;
    },
    toEditar: function toEditar() {
      this.$router.push({ name: 'EditarInformacoes', params: { idProjeto: this.projeto.idProjeto } });
    },
    toAvancar: function toAvancar() {
      this.$router.push({ name: 'ClassificacoesProjeto', params: { idProjeto: this.projeto.idProjeto } });
    }
  }),
  mounted: function mounted() {
    var _this = this;

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getProjeto(this.idProjeto).then(function (response) {
      _this.projeto = response.data;
      _this.projeto.dataInicio = __WEBPACK_IMPORTED_MODULE_4__utils_dates__["a" /* default */].format(_this.projeto.dataInicio);
      _this.projeto.dataConclusao = __WEBPACK_IMPORTED_MODULE_4__utils_dates__["a" /* default */].format(_this.projeto.dataConclusao);
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    });

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando relatório.' });
    __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getRelatorioProjeto(this.idProjeto).then(function (response) {
      _this.relatorio = response.data;
      var aux = _this.relatorio.extensao.objetivosEspecificos.split(';;');
      for (var item in aux) {
        _this.objetivosEspecificosTopicos.push({ nome: aux[item] });
      }
      _this.show = true;

      // Tipo de Prestação de Serviço (Atendimento ao público em espaços de cultura, ciência e tecnologia)
      if (_this.relatorio.extensao.atendimentoPublicoEspacos === 'S') {
        _this.listaTiposPrestacaoServicoSelecionados.push('Atendimento ao público em espaços de cultura, ciência e tecnologia');
      }

      // Tipo de Prestação de Serviço (Serviço eventual)
      if (_this.relatorio.extensao.servicoEventual === 'S') {
        _this.listaTiposPrestacaoServicoSelecionados.push('Serviço eventual');
      }

      // Tipo de Prestação de Serviço (Atividades de propriedade intelectual)
      if (_this.relatorio.extensao.atividadesPropriedadeIntelectual === 'S') {
        _this.listaTiposPrestacaoServicoSelecionados.push('Atividades de propriedade intelectual');
      }

      // Tipo de Prestação de Serviço (Exames e laudos técnicos)
      if (_this.relatorio.extensao.examesLaudosTecnicos === 'S') {
        _this.listaTiposPrestacaoServicoSelecionados.push('Exames e laudos técnicos');
      }

      // Tipo de Prestação de Serviço (Atendimento jurídico)
      if (_this.relatorio.extensao.atendimentoJuridico === 'S') {
        _this.listaTiposPrestacaoServicoSelecionados.push('Atendimento jurídico');
      }

      // Tipo de Prestação de Serviço (Atendimento em saúde humana)
      if (_this.relatorio.extensao.atendimentoSaudeHumana === 'S') {
        _this.listaTiposPrestacaoServicoSelecionados.push('Atendimento em saúde humana');
      }

      // Tipo de Prestação de Serviço (Atendimento em saúde animal)
      if (_this.relatorio.extensao.atendimentoSaudeAnimal === 'S') {
        _this.listaTiposPrestacaoServicoSelecionados.push('Atendimento em saúde animal');
      }

      // Atendimento ao público em espaços de cultura, ciência e tecnologia (Espaços e Museus Culturais)
      if (_this.relatorio.extensao.espacosMuseusCulturais === 'S') {
        _this.listaAtendimentoPublicoEspacosSelecionados.push('Espaços e Museus Culturais');
      }

      // Atendimento ao público em espaços de cultura, ciência e tecnologia (Espaços e Museus de Ciência e Tecnologia)
      if (_this.relatorio.extensao.espacosMuseusCT === 'S') {
        _this.listaAtendimentoPublicoEspacosSelecionados.push('Espaços e Museus de Ciência e Tecnologia');
      }

      // Atendimento ao público em espaços de cultura, ciência e tecnologia (Cines-clube)
      if (_this.relatorio.extensao.cinesClube === 'S') {
        _this.listaAtendimentoPublicoEspacosSelecionados.push('Cines-clube');
      }

      // Atendimento ao público em espaços de cultura, ciência e tecnologia (Outros)
      if (_this.relatorio.extensao.outrosEspacos === 'S') {
        _this.listaAtendimentoPublicoEspacosSelecionados.push('Outros');
      }
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
      _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
    }).finally(function () {
      _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando relatório.' });
    });

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações adicionais.' });
    __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getPrazoDias(this.idProjeto).then(function (response) {
      _this.prazo = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações adicionais.' });
    });
  },
  components: {
    'c-readonly-field': __WEBPACK_IMPORTED_MODULE_1__components_c_readonly_field___default.a,
    'c-readonly-field-pre-format': __WEBPACK_IMPORTED_MODULE_2__components_c_readonly_field_pre_format___default.a
  }
});

/***/ }),
/* 637 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding-top": "0",
      "margin-top": "0"
    }
  }, [_c('div', {
    ref: "espelhoDaProposta"
  }, [_c('v-layout', {
    staticStyle: {
      "position": "absolute",
      "z-index": "1",
      "left": "40px",
      "top": "40px"
    }
  }, [_c('v-btn', {
    staticClass: "btnGerarPDF",
    attrs: {
      "color": "primary",
      "onclick": "window.print()"
    }
  }, [_vm._v("Gerar PDF")])], 1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('h2', {
    staticStyle: {
      "align": "center",
      "margin": "0px 20px"
    }
  }, [_vm._v(_vm._s(_vm.relatorio.classificacoes[1].descricao) + " nº\n        " + _vm._s(this.relatorio.informacoes.idProjeto) + " - " + _vm._s(this.relatorio.informacoes.titulo))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-toolbar', {
    staticClass: "text-xs-center",
    attrs: {
      "text": "",
      "dense": "",
      "color": 'primary white--text'
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v("Informações")])], 1)], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Título",
      "value": this.relatorio.informacoes.titulo
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Número",
      "value": this.relatorio.informacoes.idProjeto
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Situação",
      "value": this.relatorio.informacoes.situacao.descricao
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Tipo de público-alvo",
      "value": this.relatorio.informacoes.tipoPublico.descricao
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Público-alvo estimado",
      "value": this.relatorio.informacoes.publicoAlvo || ' '
    }
  })], 1)], 1), _vm._v(" "), (_vm.relatorio.classificacoes && (_vm.relatorio.classificacoes[1].id === 39729 || _vm.relatorio.classificacoes[1].id === 44194 || _vm.relatorio.classificacoes[1].id === 44195)) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Carga horária do curso",
      "value": this.relatorio.informacoes.cargaHoraria || ' '
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Data de início",
      "value": _vm.relatorio.informacoes.dataInicio ? _vm.dates.format(_vm.relatorio.informacoes.dataInicio) || '-' : '-'
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Data de conclusão",
      "value": _vm.relatorio.informacoes.dataConclusao ? _vm.dates.format(_vm.relatorio.informacoes.dataConclusao) || '-' : '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Palavra-chave 1",
      "value": this.relatorio.informacoes.palavraChave01 || ' '
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Palavra-chave 2",
      "value": this.relatorio.informacoes.palavraChave02 || ' '
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Palavra-chave 3",
      "value": this.relatorio.informacoes.palavraChave03 || ' '
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Palavra-chave 4",
      "value": this.relatorio.informacoes.palavraChave04 || ' '
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "align": "justify",
      "label": "Resumo",
      "value": this.relatorio.informacoes.resumo || '-'
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-toolbar', {
    staticClass: "text-xs-center",
    attrs: {
      "text": "",
      "dense": "",
      "color": 'primary white--text'
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v("Classificações")])], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers0,
      "items": _vm.relatorio.classificacoes,
      "items-per-page": -1,
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n        Total de " + _vm._s(_vm.relatorio.classificacoes.length) + " classificações\n      ")]
      }
    }])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-toolbar', {
    staticClass: "text-xs-center",
    attrs: {
      "text": "",
      "dense": "",
      "color": 'primary white--text'
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v("Extensão")])], 1)], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Unidade",
      "value": _vm.relatorio.extensao.unidade ? _vm.relatorio.extensao.unidade.nome : '-'
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Órgão competente pela aprovação",
      "value": _vm.relatorio.extensao.orgaoCompetente ? _vm.relatorio.extensao.orgaoCompetente : '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Coordenado por",
      "value": _vm.relatorio.extensao.coordenadoPor ? _vm.relatorio.extensao.coordenadoPor.descricao : '-'
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Data da primeira apresentação",
      "value": _vm.relatorio.extensao.dtPrimeiraApresentacao ? _vm.dates.format(_vm.relatorio.extensao.dtPrimeiraApresentacao) || '-' : '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Data da última revisão",
      "value": _vm.relatorio.extensao.dtRevisao ? _vm.dates.format(_vm.relatorio.extensao.dtRevisao) || '-' : '-'
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Data de aprovação pela Câmara de Extensão",
      "value": _vm.relatorio.extensao.dtAprovacao ? _vm.dates.format(_vm.relatorio.extensao.dtAprovacao) || '-' : '-'
    }
  })], 1)], 1), _vm._v(" "), (_vm.relatorio.informacoes.situacao.item === 17) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Data de inabilitação pela Câmara de Extensão",
      "value": _vm.relatorio.extensao.dtInabilitacao ? _vm.dates.format(_vm.relatorio.extensao.dtInabilitacao) || '-' : '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.relatorio.extensao.discenteCoordenador) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Discente Coordenador",
      "value": _vm.relatorio.extensao.nomeDiscenteCoordenador || '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.relatorio.extensao.evento) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Tipo de Evento",
      "value": _vm.relatorio.extensao.tipoEvento ? _vm.relatorio.extensao.tipoEvento.descricao : '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.relatorio.classificacoes[1].id === 39733) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "O programa é uma Empresa Júnior?",
      "value": _vm.relatorio.extensao.empresaJunior != null ? (_vm.relatorio.extensao.empresaJunior ? 'Sim' : 'Não') : '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.relatorio.classificacoes[1].id === 39733) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    staticClass: "alertaEmpresaJunior",
    attrs: {
      "color": "#00796b",
      "type": "info",
      "dense": "",
      "outlined": ""
    }
  }, [_vm._v("\n          Conforme os Artigos 03, 06 e 10 da Resolução nº.10/2019 do Conselho Universitário, as empresas juniores\n          deverão ser cadastradas na Pró-Reitoria de Extensão – PROEX como Programa de Extensão.\n        ")]), _vm._v(" "), _c('br')], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "align": "justify",
      "label": "Apresentação",
      "value": this.relatorio.extensao.apresentacao || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "align": "justify",
      "label": "Justificativa / Mérito extensionista",
      "value": this.relatorio.extensao.justificativa || '-'
    }
  })], 1)], 1), _vm._v(" "), (this.relatorio.extensao.caracterizacaoPublicoAlvo) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "align": "justify",
      "label": "Caracterização do público-alvo",
      "value": this.relatorio.extensao.caracterizacaoPublicoAlvo || '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!this.relatorio.extensao.caracterizacaoPublicoAlvo && this.relatorio.informacoes.tipoPublico.item === 1) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "align": "justify",
      "label": "Caracterização do público-alvo interno",
      "value": this.relatorio.extensao.publicoAlvoInterno || '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!this.relatorio.extensao.caracterizacaoPublicoAlvo) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "align": "justify",
      "label": "Caracterização do público-alvo externo",
      "value": this.relatorio.extensao.publicoAlvoExterno || '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "align": "justify",
      "label": "Objetivo geral",
      "value": this.relatorio.extensao.objetivosGerais || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "16px",
      "margin": "0px 30px"
    }
  }, [_vm._v("Objetivos específicos")]), _vm._v(" "), _vm._l((_vm.objetivosEspecificosTopicos), function(item, index) {
    return _c('p', {
      key: item.id,
      staticStyle: {
        "font-size": "16px",
        "margin": "0px 30px",
        "overflow-wrap": "break-word"
      },
      attrs: {
        "align": "justify"
      }
    }, [_vm._v("\n          " + _vm._s(index + 1) + ". " + _vm._s(item.nome) + "\n          "), _c('br')])
  })], 2)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Metodologia",
      "align": "justify",
      "value": this.relatorio.extensao.metodologia || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.relatorio.extensao.curso) ? _c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "align": "justify",
      "label": "Formas de avaliação dos cursistas",
      "value": this.relatorio.extensao.formaAvaliacao || '-'
    }
  }) : _c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "align": "justify",
      "label": "Forma de avaliação",
      "value": this.relatorio.extensao.formaAvaliacao || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "align": "justify",
      "label": "Infraestrutura física",
      "value": this.relatorio.extensao.infraestruturaFisica || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "align": "justify",
      "label": "Informações adicionais",
      "value": this.relatorio.extensao.informacoesAdicionais || '-'
    }
  })], 1)], 1), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.length !== 0) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticStyle: {
      "margin": "0px 30px"
    }
  }, [_vm._v("Tipo de Prestação de Serviço")]), _vm._v(" "), _c('v-select', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "items": _vm.listaTiposPrestacaoServico,
      "chips": "",
      "multiple": "",
      "readonly": ""
    },
    model: {
      value: (_vm.listaTiposPrestacaoServicoSelecionados),
      callback: function($$v) {
        _vm.listaTiposPrestacaoServicoSelecionados = $$v
      },
      expression: "listaTiposPrestacaoServicoSelecionados"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.length === 0) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Tipo de Prestação de Serviço",
      "value": '-',
      "align": "justify"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento ao público em espaços de cultura, ciência e tecnologia')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "tipoPrestacaoServico"
  }, [_vm._v("Tipo: Atendimento ao público em espaços de cultura, ciência e tecnologia")]), _vm._v(" "), _c('v-checkbox', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "value": "Espaços e Museus Culturais",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("Espaços e Museus Culturais")])]
      },
      proxy: true
    }], null, false, 1352582964),
    model: {
      value: (_vm.listaAtendimentoPublicoEspacosSelecionados),
      callback: function($$v) {
        _vm.listaAtendimentoPublicoEspacosSelecionados = $$v
      },
      expression: "listaAtendimentoPublicoEspacosSelecionados"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento ao público em espaços de cultura, ciência e tecnologia')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "value": "Espaços e Museus de Ciência e Tecnologia",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("Espaços e Museus de Ciência e Tecnologia")])]
      },
      proxy: true
    }], null, false, 820644792),
    model: {
      value: (_vm.listaAtendimentoPublicoEspacosSelecionados),
      callback: function($$v) {
        _vm.listaAtendimentoPublicoEspacosSelecionados = $$v
      },
      expression: "listaAtendimentoPublicoEspacosSelecionados"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento ao público em espaços de cultura, ciência e tecnologia')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "value": "Cines-clube",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("Cines-clube")])]
      },
      proxy: true
    }], null, false, 2587689909),
    model: {
      value: (_vm.listaAtendimentoPublicoEspacosSelecionados),
      callback: function($$v) {
        _vm.listaAtendimentoPublicoEspacosSelecionados = $$v
      },
      expression: "listaAtendimentoPublicoEspacosSelecionados"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento ao público em espaços de cultura, ciência e tecnologia')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "value": "Outros",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("Outros")])]
      },
      proxy: true
    }], null, false, 900719639),
    model: {
      value: (_vm.listaAtendimentoPublicoEspacosSelecionados),
      callback: function($$v) {
        _vm.listaAtendimentoPublicoEspacosSelecionados = $$v
      },
      expression: "listaAtendimentoPublicoEspacosSelecionados"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Serviço eventual')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('p', {
    staticClass: "tipoPrestacaoServico"
  }, [_vm._v("Tipo: Serviço eventual")]), _vm._v(" "), _c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Nº de assessorias",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.relatorio.extensao.numAssessorias),
      callback: function($$v) {
        _vm.$set(this.relatorio.extensao, "numAssessorias", $$v)
      },
      expression: "this.relatorio.extensao.numAssessorias"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Serviço eventual')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Nº de consultorias",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.relatorio.extensao.numConsultorias),
      callback: function($$v) {
        _vm.$set(this.relatorio.extensao, "numConsultorias", $$v)
      },
      expression: "this.relatorio.extensao.numConsultorias"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Serviço eventual')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Nº de curadorias",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.relatorio.extensao.numCuradorias),
      callback: function($$v) {
        _vm.$set(this.relatorio.extensao, "numCuradorias", $$v)
      },
      expression: "this.relatorio.extensao.numCuradorias"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Serviço eventual')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Nº de outros",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.relatorio.extensao.numOutrosServicos),
      callback: function($$v) {
        _vm.$set(this.relatorio.extensao, "numOutrosServicos", $$v)
      },
      expression: "this.relatorio.extensao.numOutrosServicos"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atividades de propriedade intelectual')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('p', {
    staticClass: "tipoPrestacaoServico"
  }, [_vm._v("Tipo: Atividades de propriedade intelectual")]), _vm._v(" "), _c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Nº de depósito de patentes e modelos de utilidades",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.relatorio.extensao.numPatentesModelos),
      callback: function($$v) {
        _vm.$set(this.relatorio.extensao, "numPatentesModelos", $$v)
      },
      expression: "this.relatorio.extensao.numPatentesModelos"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atividades de propriedade intelectual')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Nº de registro de marcas e softwares",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.relatorio.extensao.numMarcasSoftwares),
      callback: function($$v) {
        _vm.$set(this.relatorio.extensao, "numMarcasSoftwares", $$v)
      },
      expression: "this.relatorio.extensao.numMarcasSoftwares"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atividades de propriedade intelectual')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Nº de contratos de transferência de tecnologia",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.relatorio.extensao.numTransferenciaTecnologia),
      callback: function($$v) {
        _vm.$set(this.relatorio.extensao, "numTransferenciaTecnologia", $$v)
      },
      expression: "this.relatorio.extensao.numTransferenciaTecnologia"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atividades de propriedade intelectual')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Nº de registros de direitos autorais",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.relatorio.extensao.numDireitosAutorais),
      callback: function($$v) {
        _vm.$set(this.relatorio.extensao, "numDireitosAutorais", $$v)
      },
      expression: "this.relatorio.extensao.numDireitosAutorais"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Exames e laudos técnicos')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('p', {
    staticClass: "tipoPrestacaoServico"
  }, [_vm._v("Tipo: Exames e laudos técnicos")]), _vm._v(" "), _c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Nº de laudos emitidos",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.relatorio.extensao.numLaudosEmitidos),
      callback: function($$v) {
        _vm.$set(this.relatorio.extensao, "numLaudosEmitidos", $$v)
      },
      expression: "this.relatorio.extensao.numLaudosEmitidos"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento jurídico')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('p', {
    staticClass: "tipoPrestacaoServico"
  }, [_vm._v("Tipo: Atendimento jurídico")]), _vm._v(" "), _c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Nº de atendimentos",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.relatorio.extensao.numAtendimentosJuridicos),
      callback: function($$v) {
        _vm.$set(this.relatorio.extensao, "numAtendimentosJuridicos", $$v)
      },
      expression: "this.relatorio.extensao.numAtendimentosJuridicos"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('p', {
    staticClass: "tipoPrestacaoServico"
  }, [_vm._v("Tipo: Atendimento em saúde humana")]), _vm._v(" "), _c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Nº de consultas ambulatoriais (programadas)",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.relatorio.extensao.numConsultasAmbulatoriais),
      callback: function($$v) {
        _vm.$set(this.relatorio.extensao, "numConsultasAmbulatoriais", $$v)
      },
      expression: "this.relatorio.extensao.numConsultasAmbulatoriais"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Nº de consultas de emergência e urgência",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.relatorio.extensao.numConsultasEmergencia),
      callback: function($$v) {
        _vm.$set(this.relatorio.extensao, "numConsultasEmergencia", $$v)
      },
      expression: "this.relatorio.extensao.numConsultasEmergencia"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Nº de internações",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.relatorio.extensao.numInternacoes),
      callback: function($$v) {
        _vm.$set(this.relatorio.extensao, "numInternacoes", $$v)
      },
      expression: "this.relatorio.extensao.numInternacoes"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Nº de cirurgias",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.relatorio.extensao.numCirurgias),
      callback: function($$v) {
        _vm.$set(this.relatorio.extensao, "numCirurgias", $$v)
      },
      expression: "this.relatorio.extensao.numCirurgias"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Nº de exames laboratoriais",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.relatorio.extensao.numExamesLaboratoriais),
      callback: function($$v) {
        _vm.$set(this.relatorio.extensao, "numExamesLaboratoriais", $$v)
      },
      expression: "this.relatorio.extensao.numExamesLaboratoriais"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Nº de exames complementares",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.relatorio.extensao.numExamesComplementares),
      callback: function($$v) {
        _vm.$set(this.relatorio.extensao, "numExamesComplementares", $$v)
      },
      expression: "this.relatorio.extensao.numExamesComplementares"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Nº de outros atendimentos",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.relatorio.extensao.numOutrosAtendimentosSH),
      callback: function($$v) {
        _vm.$set(this.relatorio.extensao, "numOutrosAtendimentosSH", $$v)
      },
      expression: "this.relatorio.extensao.numOutrosAtendimentosSH"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde animal')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('p', {
    staticClass: "tipoPrestacaoServico"
  }, [_vm._v("Tipo: Atendimento em saúde animal")]), _vm._v(" "), _c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Nº de atendimentos veterinários ambulatoriais",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.relatorio.extensao.numAtendimentosVeterinarios),
      callback: function($$v) {
        _vm.$set(this.relatorio.extensao, "numAtendimentosVeterinarios", $$v)
      },
      expression: "this.relatorio.extensao.numAtendimentosVeterinarios"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde animal')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Nº de internações veterinárias",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.relatorio.extensao.numInternacoesVeterinarias),
      callback: function($$v) {
        _vm.$set(this.relatorio.extensao, "numInternacoesVeterinarias", $$v)
      },
      expression: "this.relatorio.extensao.numInternacoesVeterinarias"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde animal')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Nº de cirurgias veterinárias",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.relatorio.extensao.numCirurgiasVeterinarias),
      callback: function($$v) {
        _vm.$set(this.relatorio.extensao, "numCirurgiasVeterinarias", $$v)
      },
      expression: "this.relatorio.extensao.numCirurgiasVeterinarias"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde animal')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Nº de exames laboratoriais e complementares em veterinária",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (this.relatorio.extensao.numExamesVeterinaria),
      callback: function($$v) {
        _vm.$set(this.relatorio.extensao, "numExamesVeterinaria", $$v)
      },
      expression: "this.relatorio.extensao.numExamesVeterinaria"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.relatorio.extensao.prestacaoServico) ? _c('p', {
    staticStyle: {
      "margin": "2em"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Possui vínculo com ensino",
      "value": _vm.relatorio.extensao.vinculoEnsino != null ? (_vm.relatorio.extensao.vinculoEnsino ? 'Sim' : 'Não') : '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Possui vínculo com pesquisa",
      "value": _vm.relatorio.extensao.vinculoPesquisa != null ? (_vm.relatorio.extensao.vinculoPesquisa ? 'Sim' : 'Não') : '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Esta ação realiza divulgação científica",
      "value": _vm.relatorio.extensao.divulgacaoCientifica != null ? (_vm.relatorio.extensao.divulgacaoCientifica ? 'Sim' : 'Não') : '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Envolve captação de recursos financeiros ou bens duráveis",
      "value": _vm.relatorio.extensao.captacaoRecursosBensDuraveis != null ? (_vm.relatorio.extensao.captacaoRecursosBensDuraveis ? 'Sim' : 'Não') : '-'
    }
  })], 1)], 1), _vm._v(" "), (_vm.relatorio.extensao.captacaoRecursosBensDuraveis === true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0px 30px"
    }
  }, [_c('label', [_vm._v("Por meio de:")])])])], 1) : _vm._e(), _vm._v(" "), (_vm.relatorio.extensao.captacaoRecursosBensDuraveis === true) ? _c('div', [_c('br')]) : _vm._e(), _vm._v(" "), (_vm.relatorio.extensao.captacaoRecursosBensDuraveis === true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("UFES")])]
      },
      proxy: true
    }], null, false, 4124160677),
    model: {
      value: (_vm.relatorio.extensao.captacaoRecursosUfes),
      callback: function($$v) {
        _vm.$set(_vm.relatorio.extensao, "captacaoRecursosUfes", $$v)
      },
      expression: "relatorio.extensao.captacaoRecursosUfes"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("CAPES")])]
      },
      proxy: true
    }], null, false, 3158995236),
    model: {
      value: (_vm.relatorio.extensao.captacaoRecursosCapes),
      callback: function($$v) {
        _vm.$set(_vm.relatorio.extensao, "captacaoRecursosCapes", $$v)
      },
      expression: "relatorio.extensao.captacaoRecursosCapes"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("FEST")])]
      },
      proxy: true
    }], null, false, 1101797796),
    model: {
      value: (_vm.relatorio.extensao.captacaoRecursosFest),
      callback: function($$v) {
        _vm.$set(_vm.relatorio.extensao, "captacaoRecursosFest", $$v)
      },
      expression: "relatorio.extensao.captacaoRecursosFest"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.relatorio.extensao.captacaoRecursosBensDuraveis === true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("CNPq")])]
      },
      proxy: true
    }], null, false, 1739938252),
    model: {
      value: (_vm.relatorio.extensao.captacaoRecursosCnpq),
      callback: function($$v) {
        _vm.$set(_vm.relatorio.extensao, "captacaoRecursosCnpq", $$v)
      },
      expression: "relatorio.extensao.captacaoRecursosCnpq"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("FAPES")])]
      },
      proxy: true
    }], null, false, 4155422625),
    model: {
      value: (_vm.relatorio.extensao.captacaoRecursosFapes),
      callback: function($$v) {
        _vm.$set(_vm.relatorio.extensao, "captacaoRecursosFapes", $$v)
      },
      expression: "relatorio.extensao.captacaoRecursosFapes"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("FUCAM")])]
      },
      proxy: true
    }], null, false, 1966598076),
    model: {
      value: (_vm.relatorio.extensao.captacaoRecursosFucam),
      callback: function($$v) {
        _vm.$set(_vm.relatorio.extensao, "captacaoRecursosFucam", $$v)
      },
      expression: "relatorio.extensao.captacaoRecursosFucam"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.relatorio.extensao.captacaoRecursosBensDuraveis === true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Outros")])]
      },
      proxy: true
    }], null, false, 1698063712),
    model: {
      value: (_vm.relatorio.extensao.captacaoRecursosOutros),
      callback: function($$v) {
        _vm.$set(_vm.relatorio.extensao, "captacaoRecursosOutros", $$v)
      },
      expression: "relatorio.extensao.captacaoRecursosOutros"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": "",
      "sm8": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Especifique:"
    },
    model: {
      value: (_vm.relatorio.extensao.especCaptacaoRecursosOutros),
      callback: function($$v) {
        _vm.$set(_vm.relatorio.extensao, "especCaptacaoRecursosOutros", $$v)
      },
      expression: "relatorio.extensao.especCaptacaoRecursosOutros"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Envolve liberação de carga horária do coordenador aprovada em Departamento/Centro/Setor de lotação",
      "value": _vm.relatorio.extensao.liberacaoCargaHoraria != null ? (_vm.relatorio.extensao.liberacaoCargaHoraria ? 'Sim' : 'Não') : '-'
    }
  })], 1)], 1), _vm._v(" "), (_vm.relatorio.extensao.liberacaoCargaHoraria === true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Carga horária aprovada",
      "value": this.relatorio.extensao.cargaHorariaCoordenadorAprovada || '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.relatorio.extensao.curso || _vm.relatorio.extensao.evento) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Gratuito para o público",
      "value": _vm.relatorio.extensao.gratuito != null ? (_vm.relatorio.extensao.gratuito ? 'Sim' : 'Não') : '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.relatorio.extensao.gratuito === false) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0px 30px"
    }
  }, [_c('label', [_vm._v("Os recursos financeiros obtidos serão administrados por:")])])])], 1) : _vm._e(), _vm._v(" "), (_vm.relatorio.extensao.gratuito === false) ? _c('div', [_c('br')]) : _vm._e(), _vm._v(" "), (_vm.relatorio.extensao.gratuito === false) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("UFES")])]
      },
      proxy: true
    }], null, false, 4124160677),
    model: {
      value: (_vm.relatorio.extensao.gratuitoUfes),
      callback: function($$v) {
        _vm.$set(_vm.relatorio.extensao, "gratuitoUfes", $$v)
      },
      expression: "relatorio.extensao.gratuitoUfes"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.relatorio.extensao.gratuito === false) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("FEST")])]
      },
      proxy: true
    }], null, false, 1101797796),
    model: {
      value: (_vm.relatorio.extensao.gratuitoFest),
      callback: function($$v) {
        _vm.$set(_vm.relatorio.extensao, "gratuitoFest", $$v)
      },
      expression: "relatorio.extensao.gratuitoFest"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.relatorio.extensao.gratuito === false) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("FUCAM")])]
      },
      proxy: true
    }], null, false, 1966598076),
    model: {
      value: (_vm.relatorio.extensao.gratuitoFucam),
      callback: function($$v) {
        _vm.$set(_vm.relatorio.extensao, "gratuitoFucam", $$v)
      },
      expression: "relatorio.extensao.gratuitoFucam"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.relatorio.extensao.gratuito === false) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Outros")])]
      },
      proxy: true
    }], null, false, 1698063712),
    model: {
      value: (_vm.relatorio.extensao.gratuitoOutros),
      callback: function($$v) {
        _vm.$set(_vm.relatorio.extensao, "gratuitoOutros", $$v)
      },
      expression: "relatorio.extensao.gratuitoOutros"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": "",
      "sm8": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Especifique:"
    },
    model: {
      value: (_vm.relatorio.extensao.especGratuitoOutros),
      callback: function($$v) {
        _vm.$set(_vm.relatorio.extensao, "especGratuitoOutros", $$v)
      },
      expression: "relatorio.extensao.especGratuitoOutros"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.relatorio.extensao.curso) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Modalidade",
      "value": _vm.relatorio.extensao.modalidade != null ? (_vm.relatorio.extensao.modalidade == 'P' ? 'Presencial' : (_vm.relatorio.extensao.modalidade == 'S' ? 'Semipresencial' : 'EAD')) : '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.relatorio.extensao.curso) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Utiliza o AVA Extensão",
      "value": _vm.relatorio.extensao.utilizaAvaExtensao != null ? (_vm.relatorio.extensao.utilizaAvaExtensao ? 'Sim' : 'Não') : '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.relatorio.extensao.curso) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Outra plataforma AVA",
      "value": _vm.relatorio.extensao.plataforma || '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-toolbar', {
    staticClass: "text-xs-center",
    attrs: {
      "text": "",
      "dense": "",
      "color": 'primary white--text'
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v("Equipe")])], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers1,
      "items": _vm.relatorio.equipe,
      "items-per-page": -1,
      "hide-default-footer": "",
      "no-data-text": 'Este projeto não possui integrantes.'
    },
    scopedSlots: _vm._u([{
      key: "item.assessor",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.formatAssessor.format(props.item.assessor,
          props.item.funcao.item)))]
      }
    }, {
      key: "item.dataInicial",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dataInicial)))]
      }
    }, {
      key: "item.dataFinal",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dataFinal)))]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n        Total de " + _vm._s(_vm.relatorio.equipe.length) + " integrantes\n      ")]
      }
    }])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-toolbar', {
    staticClass: "text-xs-center",
    attrs: {
      "text": "",
      "dense": "",
      "color": 'primary white--text'
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v("Atividades")])], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers2,
      "items": _vm.relatorio.atividades,
      "items-per-page": -1,
      "hide-default-footer": "",
      "no-data-text": 'Este projeto não possui atividades.'
    },
    scopedSlots: _vm._u([{
      key: "item.nomeDescricao",
      fn: function(props) {
        return [(props.item.detalhamento !== null && props.item.detalhamento !== '') ? _c('div', [_vm._v("\n          " + _vm._s(props.item.descricao)), _c('br'), _c('br'), _vm._v(_vm._s(props.item.detalhamento))]) : _c('div', [_vm._v(_vm._s(props.item.descricao))])]
      }
    }, {
      key: "item.dtInicioPrevisto",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dtInicioPrevisto)))]
      }
    }, {
      key: "item.dtFimPrevisto",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dtFimPrevisto)))]
      }
    }, {
      key: "item.dtInicioEfetivo",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dtInicioEfetivo)))]
      }
    }, {
      key: "item.dtFimEfetivo",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dtFimEfetivo)))]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n        Total de " + _vm._s(_vm.relatorio.atividades.length) + " atividades\n      ")]
      }
    }])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-toolbar', {
    staticClass: "text-xs-center",
    attrs: {
      "text": "",
      "dense": "",
      "color": 'primary white--text'
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v("Vínculos")])], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers2b,
      "items": _vm.relatorio.vinculos,
      "items-per-page": -1,
      "hide-default-footer": "",
      "no-data-text": 'Este projeto não possui vínculos.'
    },
    scopedSlots: _vm._u([{
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n        Total de " + _vm._s(_vm.relatorio.vinculos.length) + " vínculos\n      ")]
      }
    }])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-toolbar', {
    staticClass: "text-xs-center",
    attrs: {
      "text": "",
      "dense": "",
      "color": 'primary white--text'
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v("Parcerias")])], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers3,
      "items": _vm.relatorio.parcerias,
      "items-per-page": -1,
      "hide-default-footer": "",
      "no-data-text": 'Este projeto não possui parcerias.'
    },
    scopedSlots: _vm._u([{
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n        Total de de " + _vm._s(_vm.relatorio.parcerias.length) + " parcerias\n      ")]
      }
    }])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-toolbar', {
    staticClass: "text-xs-center",
    attrs: {
      "text": "",
      "dense": "",
      "color": 'primary white--text'
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v("Abrangência")])], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers4,
      "items": _vm.relatorio.abrangencia,
      "items-per-page": -1,
      "hide-default-footer": "",
      "no-data-text": 'Este projeto não possui localidades.'
    },
    scopedSlots: _vm._u([{
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n        Total de " + _vm._s(_vm.relatorio.abrangencia.length) + " localidades\n      ")]
      }
    }])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-toolbar', {
    staticClass: "text-xs-center",
    attrs: {
      "text": "",
      "dense": "",
      "color": 'primary white--text'
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v("Arquivos")])], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers5,
      "items": _vm.relatorio.arquivos,
      "items-per-page": -1,
      "hide-default-footer": "",
      "no-data-text": 'Este projeto não possui arquivos.'
    },
    scopedSlots: _vm._u([{
      key: "item.dtInclusao",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dtInclusao)))]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n        Total de " + _vm._s(_vm.relatorio.arquivos.length) + " arquivos\n      ")]
      }
    }])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-toolbar', {
    staticClass: "text-xs-center",
    attrs: {
      "text": "",
      "dense": "",
      "color": 'primary white--text'
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v("Contatos")])], 1)], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Site",
      "value": _vm.relatorio.contatos.site || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field-pre-format', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Mídias sociais",
      "value": _vm.relatorio.contatos.midiasSociais || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Nome do contato",
      "value": _vm.relatorio.contatos.nomeContato || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "E-mail",
      "value": _vm.relatorio.contatos.email || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticStyle: {
      "margin": "0px 30px"
    },
    attrs: {
      "label": "Telefone",
      "value": _vm.relatorio.contatos.telefone || '-'
    }
  })], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(639)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(640),
  /* template */
  __webpack_require__(641),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 639 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_tooltip_btn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_tooltip_btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_tooltip_btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_date_menu__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_date_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_c_date_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto'],
  data: function data() {
    return {
      formularioValido: false,
      dates: __WEBPACK_IMPORTED_MODULE_5__utils_dates__["a" /* default */],
      pesquisaAvancada: false,
      pesquisa: {
        situacao: [16]
      },
      listaProjetos: [],
      regrasBasicas: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }],
      search: null,
      sortBy: 'dtCriacao',
      sortDesc: true,
      itemsPerPage: -1,
      opcoesPaginacao: [10, 25, 50, { text: 'Todas', value: -1 }],
      headers: [{ text: 'Número', align: 'center', value: 'idProjeto' }, { text: 'Título', align: 'center', value: 'titulo' }, { text: 'Classificação Primária', align: 'center', value: 'classificacaoPrimaria' }, { text: 'Classificação Secundária', align: 'center', value: 'classificacaoSecundaria' }, { text: 'Situação', align: 'center', value: 'situacao' }, { text: 'Coordenador', align: 'center', value: 'nomeCoordenador' }, { text: 'Opções', align: 'center', value: 'opcoes' }]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])('auth', ['logged', 'username', 'nome', 'administrador', 'usuarioPROEX', 'permissaoCriarProjetoExtensao'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    limpar: function limpar() {
      this.pesquisa = { tipoProjeto: 39725 };
    },
    pesquisar: function pesquisar() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projetos.' });
      __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].getConsultaProjetos(this.pesquisa).then(function (response) {
        _this.listaProjetos = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this.listaProjetos = [];
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projetos.' });
      });
    },
    goAprovarProjeto: function goAprovarProjeto(idProjetoParam) {
      this.$router.push({ name: 'AprovarProjeto', params: { idProjeto: idProjetoParam } });
    },
    goDevolverProjeto: function goDevolverProjeto(idProjetoParam) {
      this.$router.push({ name: 'DevolverProjeto', params: { idProjeto: idProjetoParam } });
    },
    goInabilitarProjeto: function goInabilitarProjeto(idProjetoParam) {
      this.$router.push({ name: 'InabilitarProjeto', params: { idProjeto: idProjetoParam } });
    },
    truncate: function truncate(string, limit) {
      if (string.length > limit) return string.substring(0, limit) + '...';else return string;
    },

    carregarUnidades: function carregarUnidades() {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando unidades.' });
      __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].getUnidadesExtensao().then(function (response) {
        _this2.listaUnidades = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this2.listaUnidades = [];
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando unidades.' });
      });
    },
    opcoesTabelaEstruturada: function opcoesTabelaEstruturada(codTabela, aqui, atributo) {
      var _this3 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' });
      __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].getOpcoesTabelaEstruturada(codTabela).then(function (response) {
        aqui[atributo] = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this3.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' });
      });
    },
    obterClassificacoes: function obterClassificacoes(itemTabela, aqui, atributo) {
      var _this4 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando classificação ' + atributo });
      __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].getClassificacoesPossiveis(itemTabela).then(function (response) {
        aqui[atributo] = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this4.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando classificação ' + atributo });
      });
    },
    carregarCampos: function carregarCampos() {
      this.opcoesTabelaEstruturada(6011, this, 'listaSituacao');
      this.opcoesTabelaEstruturada(6002, this, 'listaTipoPublico');
      this.carregarUnidades();
      this.obterClassificacoes(100, this, 'listaAreatematica');
      this.obterClassificacoes(110, this, 'listaAreatematicaAfim');
      this.obterClassificacoes(111, this, 'listaLinhaExtensao');
      this.obterClassificacoes(112, this, 'listaGrandeArea');
    },
    abrirPesquisaAvancada: function abrirPesquisaAvancada() {
      this.carregarCampos();
      this.pesquisaAvancada = true;
    },
    fecharPesquisaAvancada: function fecharPesquisaAvancada() {
      this.pesquisaAvancada = false;
    }
  }),
  mounted: function mounted() {
    // this.obterClassificacoes(90, this, 'listaTipo')
    this.obterClassificacoes(91, this, 'listaSubtipo');
    this.pesquisar();
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a,
    'c-tooltip-btn': __WEBPACK_IMPORTED_MODULE_3__components_c_tooltip_btn___default.a,
    'c-date-menu': __WEBPACK_IMPORTED_MODULE_4__components_c_date_menu___default.a
  }
});

/***/ }),
/* 641 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [(_vm.administrador === true) ? _c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Aprovar, devolver para o coordenador ou inabilitar ações de extensão aguardando aprovação'
    }
  }), _vm._v(" "), _c('v-card-title', [_c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "filter_list",
      "label": "Filtrar resultados"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-card-text', [_c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaProjetos,
      "search": _vm.search,
      "no-data-text": 'Nenhum projeto encontrado',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.titulo",
      fn: function(props) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'ProjetoFormulario',
              params: {
                idProjeto: props.item.idProjeto
              }
            }
          }
        }, [_vm._v(_vm._s(props.item.titulo))])]
      }
    }, {
      key: "item.opcoes",
      fn: function(props) {
        return [_c('c-tooltip-btn', {
          attrs: {
            "icon": "done_outline",
            "color": "green",
            "tooltip": "Aprovar"
          },
          on: {
            "click": function($event) {
              return _vm.goAprovarProjeto(props.item.idProjeto)
            }
          }
        }), _vm._v(" "), _c('c-tooltip-btn', {
          attrs: {
            "icon": "not_interested",
            "color": "red",
            "tooltip": "Devolver"
          },
          on: {
            "click": function($event) {
              return _vm.goDevolverProjeto(props.item.idProjeto)
            }
          }
        }), _vm._v(" "), _c('c-tooltip-btn', {
          attrs: {
            "icon": "cancel",
            "color": "black",
            "tooltip": "Inabilitar"
          },
          on: {
            "click": function($event) {
              return _vm.goInabilitarProjeto(props.item.idProjeto)
            }
          }
        })]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n              Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaProjetos.length) + " projetos\n            ")]
      }
    }], null, false, 1682397262)
  }), _vm._v(" "), _c('br')], 1)], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(643)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(644),
  /* template */
  __webpack_require__(645),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 643 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_tooltip_btn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_tooltip_btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_tooltip_btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_date_menu__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_date_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_c_date_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto'],
  data: function data() {
    return {
      formularioValido: false,
      dates: __WEBPACK_IMPORTED_MODULE_5__utils_dates__["a" /* default */],
      listaRelatorios: [],
      pesquisa: {
        situacao: 2 // Aguardando aprovação
      },
      search: null,
      sortBy: 'dtCriacao',
      sortDesc: true,
      itemsPerPage: -1,
      opcoesPaginacao: [10, 25, 50, { text: 'Todas', value: -1 }],
      headers: [{ text: 'Número da ação', align: 'left', value: 'numeroAcaoExtensao' }, { text: 'Título da ação', align: 'left', value: 'tituloAcaoExtensao' }, { text: 'Coordenador', align: 'left', value: 'nomeCoordenador' }, { text: 'Relatório', align: 'left', value: 'id' }, { text: 'Tipo do relatório', align: 'left', value: 'tipoRelatorioTecnicoItem' }, { text: 'Início', align: 'left', value: 'dtInicial' }, { text: 'Fim', align: 'left', value: 'dtFinal' }, { text: 'Situação do relatório', align: 'left', value: 'situacaoRelatorioTecnicoItem' }, { text: 'Opções', align: 'left', value: 'opcoes' }]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])('auth', ['logged', 'username', 'nome', 'administrador', 'usuarioPROEX', 'permissaoCriarProjetoExtensao'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    // Busca os relatórios técnicos aguardando aprovação.
    pesquisarRelatoriosTecnicosAguardandoAprovacao: function pesquisarRelatoriosTecnicosAguardandoAprovacao() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando relatórios.' });
      __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].getConsultaRelatoriosTecnicos(this.pesquisa).then(function (response) {
        _this.listaRelatorios = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this.listaRelatorios = [];
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando relatórios.' });
      });
    },

    // Verifica se o usuário logado é administrador.
    usuarioAdministrador: function usuarioAdministrador() {
      if (this.administrador === true) {
        return true;
      } else {
        return false;
      }
    },
    // Redireciona para a página de aprovação de um relatório técnico.
    toAprovar: function toAprovar(idProjeto, idRelatorioExtensao) {
      this.$router.push({ name: 'AprovarRelatorio', params: { idProjeto: idProjeto, idRelatorio: idRelatorioExtensao } });
    },
    // Redireciona para a página de devolução de um relatório técnico.
    toDevolver: function toDevolver(idProjeto, idRelatorioExtensao) {
      this.$router.push({ name: 'DevolverRelatorio', params: { idProjeto: idProjeto, idRelatorio: idRelatorioExtensao } });
    },
    // Redireciona para a página de reprovação de um relatório técnico.
    toReprovar: function toReprovar(idProjeto, idRelatorioExtensao) {
      this.$router.push({ name: 'ReprovarRelatorio', params: { idProjeto: idProjeto, idRelatorio: idRelatorioExtensao } });
    }
  }),
  mounted: function mounted() {
    // Busca os relatórios técnicos aguardando aprovação.
    this.pesquisarRelatoriosTecnicosAguardandoAprovacao();
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a,
    'c-tooltip-btn': __WEBPACK_IMPORTED_MODULE_3__components_c_tooltip_btn___default.a,
    'c-date-menu': __WEBPACK_IMPORTED_MODULE_4__components_c_date_menu___default.a
  }
});

/***/ }),
/* 645 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [(_vm.administrador === true) ? _c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Aprovar, devolver para o coordenador ou reprovar relatórios técnicos aguardando aprovação'
    }
  }), _vm._v(" "), _c('v-card-title', [_c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "filter_list",
      "label": "Filtrar resultados"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-card-text', [_c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaRelatorios,
      "search": _vm.search,
      "no-data-text": 'Nenhum relatório encontrado',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.id",
      fn: function(props) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'RelatorioTecnico',
              params: {
                idProjeto: props.item.numeroAcaoExtensao,
                idRelatorioExtensao: props.item.id
              }
            }
          }
        }, [_vm._v("\n                Relatório " + _vm._s(props.item.ordem) + "\n              ")])]
      }
    }, {
      key: "item.dtInicial",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dtInicial)))]
      }
    }, {
      key: "item.dtFinal",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dtFinal)))]
      }
    }, {
      key: "item.tipoRelatorioTecnicoItem",
      fn: function(props) {
        return [_vm._v("\n              " + _vm._s(props.item.tipoRelatorioTecnicoItem === 1 ? "Relatório Parcial" :
          props.item.tipoRelatorioTecnicoItem === 2 ? "Relatório Parcial com Renovação" :
          props.item.tipoRelatorioTecnicoItem === 3 ? "Relatório Final" : "Tipo Inválido") + "\n            ")]
      }
    }, {
      key: "item.situacaoRelatorioTecnicoItem",
      fn: function(props) {
        return [_vm._v("\n              " + _vm._s(props.item.situacaoRelatorioTecnicoItem === 1 ? "Em elaboração" :
          props.item.situacaoRelatorioTecnicoItem === 2 ? "Aguardando aprovação" :
          props.item.situacaoRelatorioTecnicoItem === 3 ? "Aprovado" :
          props.item.situacaoRelatorioTecnicoItem === 4 ? "Reprovado" : "Situação inválida") + "\n            ")]
      }
    }, {
      key: "item.opcoes",
      fn: function(props) {
        return [(_vm.usuarioAdministrador()) ? _c('c-tooltip-btn', {
          attrs: {
            "icon": "done_outline",
            "color": "green",
            "tooltip": "Aprovar"
          },
          on: {
            "click": function($event) {
              return _vm.toAprovar(props.item.numeroAcaoExtensao, props.item.id)
            }
          }
        }) : _vm._e(), _vm._v(" "), (_vm.usuarioAdministrador()) ? _c('c-tooltip-btn', {
          attrs: {
            "icon": "not_interested",
            "color": "red",
            "tooltip": "Devolver"
          },
          on: {
            "click": function($event) {
              return _vm.toDevolver(props.item.numeroAcaoExtensao, props.item.id)
            }
          }
        }) : _vm._e(), _vm._v(" "), (_vm.usuarioAdministrador()) ? _c('c-tooltip-btn', {
          attrs: {
            "icon": "cancel",
            "color": "black",
            "tooltip": "Reprovar"
          },
          on: {
            "click": function($event) {
              return _vm.toReprovar(props.item.numeroAcaoExtensao, props.item.id)
            }
          }
        }) : _vm._e()]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n              Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaRelatorios.length) + " relatórios\n            ")]
      }
    }], null, false, 1552141823)
  }), _vm._v(" "), _c('br')], 1)], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(647),
  /* template */
  __webpack_require__(648),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto'],
  data: function data() {
    return {
      listaProjetos: [],
      search: null,
      sortBy: 'dtCriacao',
      sortDesc: true,
      itemsPerPage: -1,
      opcoesPaginacao: [10, 25, 50, { text: 'Todas', value: -1 }],
      headers: [{ text: 'Número', align: 'center', value: 'idProjeto' }, { text: 'Título', align: 'center', value: 'titulo' }, { text: 'Classificação Primária', align: 'center', value: 'classificacaoPrimaria' }, { text: 'Classificação Secundária', align: 'center', value: 'classificacaoSecundaria' }, { text: 'Situação', align: 'center', value: 'situacao' }, { text: 'Coordenador', align: 'center', value: 'nomeCoordenador' }, { text: 'Opções', align: 'center', value: 'opcoes' }]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('auth', ['logged', 'username', 'nome', 'administrador', 'usuarioPROEX'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    excluirAcao: function excluirAcao(idProjeto) {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo ação...' });
      __WEBPACK_IMPORTED_MODULE_3__utils_projetos__["a" /* default */].deleteProjeto(idProjeto).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        for (var i = 0; i < _this.listaProjetos.length; i++) {
          if (_this.listaProjetos[i].idProjeto === idProjeto) {
            _this.listaProjetos.splice(i, 1);
            i--;
          }
        }
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo ação...' });
      });
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ações.' });
    __WEBPACK_IMPORTED_MODULE_3__utils_projetos__["a" /* default */].getProjetosVencidos().then(function (response) {
      _this2.listaProjetos = response.data.slice();
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
      _this2.listaProjetos = [];
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ações.' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a
  }
});

/***/ }),
/* 648 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [(_vm.administrador === true) ? _c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Ações de extensão com mais de 6 meses em preenchimento incompleto'
    }
  }), _vm._v(" "), _c('v-card-title', [_c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "filter_list",
      "label": "Filtrar resultados"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-card-text', [_c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaProjetos,
      "search": _vm.search,
      "no-data-text": 'Nenhuma ação com mais de 6 meses em preenchimento incompleto',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.titulo",
      fn: function(props) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'ProjetoFormulario',
              params: {
                idProjeto: props.item.idProjeto
              }
            }
          }
        }, [_vm._v(_vm._s(props.item.titulo))])]
      }
    }, {
      key: "item.opcoes",
      fn: function(props) {
        return [_c('v-btn', {
          attrs: {
            "color": "primary",
            "text": "",
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.excluirAcao(props.item.idProjeto)
            }
          }
        }, [_c('v-icon', [_vm._v("delete")])], 1)]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n              Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaProjetos.length) + " ações\n            ")]
      }
    }], null, false, 1876049107)
  }), _vm._v(" "), _c('br')], 1)], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(650),
  /* template */
  __webpack_require__(651),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_tooltip_btn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_tooltip_btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_tooltip_btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto'],
  data: function data() {
    return {
      formularioValido: false,
      dates: __WEBPACK_IMPORTED_MODULE_4__utils_dates__["a" /* default */],
      pesquisa: {
        situacao: [20]
      },
      listaProjetos: [],
      search: null,
      sortBy: 'dtCriacao',
      sortDesc: true,
      itemsPerPage: -1,
      opcoesPaginacao: [10, 25, 50, { text: 'Todas', value: -1 }],
      headers: [{ text: 'Número', align: 'center', value: 'idProjeto' }, { text: 'Título', align: 'center', value: 'titulo' }, { text: 'Classificação Primária', align: 'center', value: 'classificacaoPrimaria' }, { text: 'Classificação Secundária', align: 'center', value: 'classificacaoSecundaria' }, { text: 'Situação', align: 'center', value: 'situacao' }, { text: 'Coordenador', align: 'center', value: 'nomeCoordenador' }, { text: 'Opções', align: 'center', value: 'opcoes' }]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])('auth', ['logged', 'username', 'nome', 'administrador', 'usuarioPROEX', 'permissaoCriarProjetoExtensao'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING']), {
    goConcluirAcao: function goConcluirAcao(idProjeto) {
      this.$router.push({ name: 'ConcluirProjeto', params: { idProjeto: idProjeto } });
    },
    goDesfazerFinalizacao: function goDesfazerFinalizacao(idProjeto) {
      this.$router.push({ name: 'DesfazerFinalizacao', params: { idProjeto: idProjeto } });
    },
    pesquisar: function pesquisar() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ações.' });
      __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getConsultaProjetos(this.pesquisa).then(function (response) {
        _this.listaProjetos = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this.listaProjetos = [];
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ações.' });
      });
    }
  }),
  mounted: function mounted() {
    this.pesquisar();
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a,
    'c-tooltip-btn': __WEBPACK_IMPORTED_MODULE_3__components_c_tooltip_btn___default.a
  }
});

/***/ }),
/* 651 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [(_vm.administrador === true) ? _c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Concluir ou desfazer a finalização de ações de extensão aguardando relatório'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaProjetos,
      "search": _vm.search,
      "no-data-text": 'Não há nenhuma ação aguardando relatório',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.titulo",
      fn: function(props) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'ProjetoFormulario',
              params: {
                idProjeto: props.item.idProjeto
              }
            }
          }
        }, [_vm._v(_vm._s(props.item.titulo))])]
      }
    }, {
      key: "item.opcoes",
      fn: function(props) {
        return [_c('c-tooltip-btn', {
          attrs: {
            "icon": "folder",
            "color": "brown lighten-1",
            "tooltip": "Concluir"
          },
          on: {
            "click": function($event) {
              return _vm.goConcluirAcao(props.item.idProjeto)
            }
          }
        }), _vm._v(" "), _c('c-tooltip-btn', {
          attrs: {
            "icon": "undo",
            "color": "primary",
            "tooltip": "Desfazer Finalização"
          },
          on: {
            "click": function($event) {
              return _vm.goDesfazerFinalizacao(props.item.idProjeto)
            }
          }
        })]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n              Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaProjetos.length) + " projetos\n            ")]
      }
    }], null, false, 128512275)
  }), _vm._v(" "), _c('br')], 1)], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(653)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(654),
  /* template */
  __webpack_require__(655),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 653 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto'],
  data: function data() {
    return {
      dialog: false,
      formularioValido: false,
      projeto: {
        situacao: {},
        tipoPublico: {},
        classificacoesPrimariaSecundaria: [{}, {}]
      },
      aprovacao: {
        dataAprovacaoCamaraExtensao: '',
        justificativaObservacao: ''
      },
      regrasBasicas: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }],
      assuntoSummaryRules: [function (input) {
        return input.length <= 2000 || 'Este campo não pode possuir mais que 2000 caracteres';
      }]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])('auth', ['logged', 'username', 'nome', 'administrador', 'usuarioPROEX', 'permissaoCriarProjetoExtensao'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    cancelar: function cancelar() {
      this.$router.push({ name: 'ProjetosAguardandoAprovacao' });
    },
    aprovarProjeto: function aprovarProjeto() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Aprovando projeto...' });
      __WEBPACK_IMPORTED_MODULE_4__utils_projetos__["a" /* default */].postAprovarProjeto(this.idProjeto, this.aprovacao).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.$router.push({ name: 'ProjetosAguardandoAprovacao' });
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Aprovando projeto...' });
      });
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    __WEBPACK_IMPORTED_MODULE_4__utils_projetos__["a" /* default */].getProjeto(this.idProjeto).then(function (response) {
      _this2.projeto = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a,
    'c-date-menu': __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default.a
  }
});

/***/ }),
/* 655 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.administrador === true) ? _c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Administração'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-layout', [_c('router-link', {
    staticClass: "opcaoAdministrador",
    attrs: {
      "to": "/administrador"
    }
  }, [_c('a', [_vm._v("Ativar ou desativar permissão de administrador")])])], 1), _vm._v(" "), _c('v-layout', [_c('router-link', {
    staticClass: "opcaoAdministrador",
    attrs: {
      "to": "/projetos-aguardando-aprovacao"
    }
  }, [_c('a', [_vm._v("Aprovar, devolver para o coordenador ou inabilitar ações de extensão aguardando aprovação")])])], 1), _vm._v(" "), _c('v-layout', [_c('router-link', {
    staticClass: "opcaoAdministrador",
    attrs: {
      "to": "/projetos-concluir"
    }
  }, [_c('a', [_vm._v("Concluir ou desfazer a finalização de ações de extensão aguardando relatório")])])], 1), _vm._v(" "), _c('v-layout', [_c('router-link', {
    staticClass: "opcaoAdministrador",
    attrs: {
      "to": "/relatorios-aguardando-aprovacao"
    }
  }, [_c('a', [_vm._v("Aprovar, devolver para o coordenador ou reprovar relatórios técnicos aguardando aprovação")])])], 1), _vm._v(" "), _c('v-layout', [_c('router-link', {
    staticClass: "opcaoAdministrador",
    attrs: {
      "to": "/projetos-vencidos"
    }
  }, [_c('a', [_vm._v("Ações com mais de 6 meses em preenchimento incompleto")])])], 1), _vm._v(" "), _c('v-layout', [_c('router-link', {
    staticClass: "opcaoAdministrador",
    attrs: {
      "to": "/projetos-parceiros"
    }
  }, [_c('a', [_vm._v("Lista de projetos que possuem parceiros")])])], 1), _vm._v(" "), _c('v-layout', [_c('router-link', {
    staticClass: "opcaoAdministrador",
    attrs: {
      "to": "/administracao/relatorios-de-gestao"
    }
  }, [_c('a', [_vm._v("Gerar relatórios de gestão")])])], 1), _vm._v(" "), _c('v-layout', [_c('router-link', {
    staticClass: "opcaoAdministrador",
    attrs: {
      "to": "/administracao/nova-mensagem"
    }
  }, [_c('a', [_vm._v("Alterar mensagem inicial")])])], 1), _vm._v(" "), _c('v-layout', [_c('router-link', {
    staticClass: "opcaoAdministrador",
    attrs: {
      "to": "/administracao/usuarios-proex"
    }
  }, [_c('a', [_vm._v("Lista de Usuários-Proex")])])], 1), _vm._v(" "), _c('v-layout', [_c('router-link', {
    staticClass: "opcaoAdministrador",
    attrs: {
      "to": "/administracao/relatorio-seguro"
    }
  }, [_c('a', [_vm._v("Relatório de seguro")])])], 1), _vm._v(" "), _c('v-layout', [_c('router-link', {
    staticClass: "opcaoAdministrador",
    attrs: {
      "to": "/administracao/reprovar-relatorios-suspensao-coordenador"
    }
  }, [_c('a', [_vm._v("Reprovação de Relatório com Suspensão de Coordenador")])])], 1), _vm._v(" "), _c('v-layout', [_c('router-link', {
    staticClass: "opcaoAdministrador",
    attrs: {
      "to": "/administracao/registro-envio-relatorio"
    }
  }, [_c('a', [_vm._v("Registro de Envio de Relatórios de Projeto")])])], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(657)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(658),
  /* template */
  __webpack_require__(659),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 657 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto'],
  data: function data() {
    return {
      dialog: false,
      formularioValido: false,
      projeto: {
        situacao: {},
        tipoPublico: {},
        classificacoesPrimariaSecundaria: [{}, {}]
      },
      aprovacao: {
        dataAprovacaoCamaraExtensao: '',
        justificativaObservacao: ''
      },
      regrasBasicas: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }],
      assuntoSummaryRules: [function (input) {
        return input.length <= 2000 || 'Este campo não pode possuir mais que 2000 caracteres';
      }]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])('auth', ['logged', 'username', 'nome', 'administrador', 'usuarioPROEX', 'permissaoCriarProjetoExtensao', 'permissaoCriarProjetoPesquisa'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    cancelar: function cancelar() {
      this.$router.push({ name: 'ProjetosAguardandoAprovacao' });
    },
    aprovarProjeto: function aprovarProjeto() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Aprovando projeto...' });
      __WEBPACK_IMPORTED_MODULE_4__utils_projetos__["a" /* default */].postAprovarProjeto(this.idProjeto, this.aprovacao).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.$router.push({ name: 'ProjetosAguardandoAprovacao' });
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Aprovando projeto...' });
      });
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    __WEBPACK_IMPORTED_MODULE_4__utils_projetos__["a" /* default */].getProjeto(this.idProjeto).then(function (response) {
      _this2.projeto = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a,
    'c-date-menu': __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default.a
  }
});

/***/ }),
/* 659 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Pesquisa'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-layout', [_c('router-link', {
    staticClass: "opcaoAdministrador",
    attrs: {
      "to": "/pesquisa/consulta-projetos"
    }
  }, [_c('a', [_vm._v("Consultar Projetos de Pesquisa")])])], 1), _vm._v(" "), _c('v-layout', [_c('router-link', {
    staticClass: "opcaoAdministrador",
    attrs: {
      "to": "pesquisa/novo-projeto"
    }
  }, [_c('a', [_vm._v("Novo Projeto de Pesquisa")])])], 1), _vm._v(" "), _c('v-layout', [_c('router-link', {
    staticClass: "opcaoAdministrador",
    attrs: {
      "to": "pesquisa/meus-projetos"
    }
  }, [_c('a', [_vm._v("Meus Projetos de Pesquisa")])])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(661)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(662),
  /* template */
  __webpack_require__(663),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 661 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_textarea__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_c_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto'],
  data: function data() {
    return {
      dialog: false,
      formularioValido: false,
      projeto: {
        situacao: {},
        tipoPublico: {},
        classificacoesPrimariaSecundaria: [{}, {}]
      },
      aprovacao: {
        dataAprovacaoCamaraExtensao: '',
        justificativaObservacao: ''
      },
      regrasBasicas: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }],
      assuntoSummaryRules: [function (input) {
        return input.length <= 2000 || 'Este campo não pode possuir mais que 2000 caracteres';
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    cancelar: function cancelar() {
      this.$router.push({ name: 'ProjetosAguardandoAprovacao' });
    },
    aprovarProjeto: function aprovarProjeto() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Aprovando projeto...' });
      __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].postAprovarProjeto(this.idProjeto, this.aprovacao).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.$router.go(-1);
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Aprovando projeto...' });
      });
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getProjeto(this.idProjeto).then(function (response) {
      _this2.projeto = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a,
    'c-date-menu': __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default.a,
    'c-textarea': __WEBPACK_IMPORTED_MODULE_4__components_c_textarea___default.a
  }
});

/***/ }),
/* 663 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Aprovar Projeto'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-dialog', {
    attrs: {
      "width": "420"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n                    Confirma a aprovação do projeto?\n                  ")]), _vm._v(" "), _c('v-card-text'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Não")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.aprovarProjeto
    }
  }, [_vm._v("Sim")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Título do projeto",
      "value": this.projeto.titulo
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Número",
      "value": this.projeto.idProjeto
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Situação",
      "value": this.projeto.situacao.descricao
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm8": ""
    }
  }, [_c('c-date-menu', {
    attrs: {
      "label": "Data de aprovação pela Câmara de Extensão",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.aprovacao.dataAprovacaoCamaraExtensao),
      callback: function($$v) {
        _vm.$set(_vm.aprovacao, "dataAprovacaoCamaraExtensao", $$v)
      },
      expression: "aprovacao.dataAprovacaoCamaraExtensao"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-textarea', {
    attrs: {
      "label": "Justificativa/Observação",
      "rules": _vm.assuntoSummaryRules,
      "rows": 3,
      "auto-grow": true,
      "multi-line": "",
      "counter": "2000"
    },
    model: {
      value: (_vm.aprovacao.justificativaObservacao),
      callback: function($$v) {
        _vm.$set(_vm.aprovacao, "justificativaObservacao", $$v)
      },
      expression: "aprovacao.justificativaObservacao"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.cancelar
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        _vm.dialog = true
      }
    }
  }, [_vm._v("Aprovar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(665)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(666),
  /* template */
  __webpack_require__(667),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 665 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_textarea__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_c_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto'],
  data: function data() {
    return {
      dialog: false,
      formularioValido: false,
      listaClassificacaoSecundaria: [],
      projeto: {
        situacao: {},
        tipoPublico: {},
        classificacoesPrimariaSecundaria: [{}, {}]
      },
      devolucao: {
        classificacaoSecundaria: {},
        justificativaObservacao: ''
      },
      regrasBasicas: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }],
      assuntoSummaryRules: [function (input) {
        return input.length <= 2000 || 'Este campo não pode possuir mais que 2000 caracteres';
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    cancelar: function cancelar() {
      this.$router.go(-1);
    },
    devolverProjeto: function devolverProjeto() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Devolvendo projeto...' });
      __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].postDevolverProjeto(this.idProjeto, this.devolucao).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.$router.go(-1);
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Devolvendo projeto...' });
      });
    },
    obterClassificacoes: function obterClassificacoes(itemTabela, aqui, atributo) {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando classificações.' });
      __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getClassificacoesPossiveis(itemTabela).then(function (response) {
        aqui[atributo] = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando classificações.' });
      });
    }
  }),
  mounted: function mounted() {
    var _this3 = this;

    this.obterClassificacoes(91, this, 'listaClassificacaoSecundaria');
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getProjeto(this.idProjeto).then(function (response) {
      _this3.projeto = response.data;
      _this3.devolucao.classificacaoSecundaria = _this3.projeto.classificacaoSecundaria;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this3.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a,
    'c-date-menu': __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default.a,
    'c-textarea': __WEBPACK_IMPORTED_MODULE_4__components_c_textarea___default.a
  }
});

/***/ }),
/* 667 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Devolver Projeto'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-dialog', {
    attrs: {
      "width": "450"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n                    Confirma a devolução do projeto?\n                  ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                    O projeto devolvido voltará para a situação \"Preenchimento incompleto\" e deverá ser editado pelo coordenador, que enviará o projeto para aprovação novamente.\n                  ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Não")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.devolverProjeto
    }
  }, [_vm._v("Sim")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Título do projeto",
      "value": this.projeto.titulo
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Número",
      "value": this.projeto.idProjeto
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Situação",
      "value": this.projeto.situacao.descricao
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Classificação secundária",
      "items": _vm.listaClassificacaoSecundaria,
      "item-text": "descricao",
      "item-value": "id",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "return-object": "",
      "required": "",
      "autocomplete": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.devolucao.classificacaoSecundaria),
      callback: function($$v) {
        _vm.$set(_vm.devolucao, "classificacaoSecundaria", $$v)
      },
      expression: "devolucao.classificacaoSecundaria"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-textarea', {
    attrs: {
      "label": "Justificativa/Observação",
      "rules": _vm.assuntoSummaryRules,
      "rows": 3,
      "auto-grow": true,
      "multi-line": "",
      "counter": "2000"
    },
    model: {
      value: (_vm.devolucao.justificativaObservacao),
      callback: function($$v) {
        _vm.$set(_vm.devolucao, "justificativaObservacao", $$v)
      },
      expression: "devolucao.justificativaObservacao"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.cancelar
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        _vm.dialog = true
      }
    }
  }, [_vm._v("Devolver")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(669)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(670),
  /* template */
  __webpack_require__(671),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 669 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_textarea__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_c_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto'],
  data: function data() {
    return {
      dialog: false,
      formularioValido: false,
      dates: __WEBPACK_IMPORTED_MODULE_6__utils_dates__["a" /* default */],
      projeto: {
        situacao: {},
        tipoPublico: {},
        classificacoesPrimariaSecundaria: [{}, {}]
      }
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    // Cancelar.
    cancelar: function cancelar() {
      this.$router.go(-1);
    },
    // Endpoint para liberar o preenchimento do relatório técnico final.
    liberarRelatorio: function liberarRelatorio() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Liberando preenchimento do relatório técnico final...' });
      __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].postLiberarRelatorioFinal(this.idProjeto).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.$router.go(-1);
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Liberando preenchimento do relatório técnico final...' });
      });
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    // Carrega ação de extensão.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ação de extensão...' });
    __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getProjeto(this.idProjeto).then(function (response) {
      _this2.projeto = response.data;
      _this2.devolucao.classificacaoSecundaria = _this2.projeto.classificacaoSecundaria;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ação de extensão...' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a,
    'c-date-menu': __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default.a,
    'c-textarea': __WEBPACK_IMPORTED_MODULE_4__components_c_textarea___default.a
  }
});

/***/ }),
/* 671 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Liberar preenchimento do relatório técnico final'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-dialog', {
    attrs: {
      "width": "650"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n                    Confirma a liberação do preenchimento do relatório?\n                  ")]), _vm._v(" "), _c('v-card-text'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Não")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.liberarRelatorio
    }
  }, [_vm._v("Sim")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Título",
      "value": this.projeto.titulo
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Número",
      "value": this.projeto.idProjeto
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Situação",
      "value": this.projeto.situacao.descricao
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Data de início",
      "value": _vm.dates.format(this.projeto.dataInicio)
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Data de conclusão",
      "value": _vm.dates.format(this.projeto.dataConclusao)
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.cancelar
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        _vm.dialog = true
      }
    }
  }, [_vm._v("Liberar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(673)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(674),
  /* template */
  __webpack_require__(675),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 673 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_textarea__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_c_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto'],
  data: function data() {
    return {
      dialog: false,
      formularioValido: false,
      projeto: {
        situacao: {},
        tipoPublico: {},
        classificacoesPrimariaSecundaria: [{}, {}]
      },
      inabilitacao: {
        dataInabilitacaoCamaraExtensao: '',
        justificativaObservacao: ''
      },
      regras: {
        required: function required(input) {
          return !!input || 'Este campo é obrigatório';
        },
        counter: function counter(input) {
          return input.length <= 2000 || 'Este campo não pode possuir mais que 2000 caracteres';
        }
      }
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    cancelar: function cancelar() {
      this.$router.push({ name: 'ProjetosAguardandoAprovacao' });
    },
    inabilitarProjeto: function inabilitarProjeto() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Inabilitando projeto...' });
      __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].postInabilitarProjeto(this.idProjeto, this.inabilitacao).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.$router.go(-1);
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Inabilitando projeto...' });
      });
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getProjeto(this.idProjeto).then(function (response) {
      _this2.projeto = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a,
    'c-date-menu': __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default.a,
    'c-textarea': __WEBPACK_IMPORTED_MODULE_4__components_c_textarea___default.a
  }
});

/***/ }),
/* 675 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Inabilitar Projeto'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-dialog', {
    attrs: {
      "width": "420"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n                    Confirma a inabilitação do projeto?\n                  ")]), _vm._v(" "), _c('v-card-text'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Não")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.inabilitarProjeto
    }
  }, [_vm._v("Sim")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Título do projeto",
      "value": this.projeto.titulo
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Número",
      "value": this.projeto.idProjeto
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Situação",
      "value": this.projeto.situacao.descricao
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm8": ""
    }
  }, [_c('c-date-menu', {
    attrs: {
      "label": "Data de inabilitação pela Câmara de Extensão",
      "required": "",
      "rules": [_vm.regras.required]
    },
    model: {
      value: (_vm.inabilitacao.dataInabilitacaoCamaraExtensao),
      callback: function($$v) {
        _vm.$set(_vm.inabilitacao, "dataInabilitacaoCamaraExtensao", $$v)
      },
      expression: "inabilitacao.dataInabilitacaoCamaraExtensao"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-textarea', {
    attrs: {
      "label": "Justificativa/Observação",
      "required": "",
      "rules": [_vm.regras.required, _vm.regras.counter],
      "rows": 3,
      "auto-grow": true,
      "multi-line": "",
      "counter": "2000"
    },
    model: {
      value: (_vm.inabilitacao.justificativaObservacao),
      callback: function($$v) {
        _vm.$set(_vm.inabilitacao, "justificativaObservacao", $$v)
      },
      expression: "inabilitacao.justificativaObservacao"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.cancelar
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        _vm.dialog = true
      }
    }
  }, [_vm._v("Inabilitar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(677)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(678),
  /* template */
  __webpack_require__(679),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 677 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_textarea__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto'],
  data: function data() {
    return {
      dialog: false,
      formularioValido: false,
      listaClassificacaoSecundaria: [],
      projeto: {
        situacao: {},
        tipoPublico: {},
        classificacoesPrimariaSecundaria: [{}, {}]
      },
      alteracao: {
        classificacaoSecundaria: {},
        justificativaObservacao: ''
      },
      obrigatorio: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }],
      tamanho2000caracteres: [function (input) {
        return input.length <= 2000 || 'Este campo não pode possuir mais que 2000 caracteres';
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    // Cancelar.
    cancelar: function cancelar() {
      this.$router.go(-1);
    },
    // Alterar classificação secundária.
    alterarClassificacaoSecundaria: function alterarClassificacaoSecundaria() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Alterando classificação secundária...' });
      __WEBPACK_IMPORTED_MODULE_3__utils_projetos__["a" /* default */].postAlterarClassificacaoSecundaria(this.idProjeto, this.alteracao).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.$router.push({ name: 'ProjetoFormulario', params: { idProjeto: _this.idProjeto } });
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Alterando classificação secundária...' });
      });
    },
    // Obtém as classificações.
    obterClassificacoes: function obterClassificacoes(itemTabela, aqui, atributo) {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando classificações.' });
      __WEBPACK_IMPORTED_MODULE_3__utils_projetos__["a" /* default */].getClassificacoesPossiveis(itemTabela).then(function (response) {
        aqui[atributo] = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando classificações.' });
      });
    }
  }),
  mounted: function mounted() {
    var _this3 = this;

    // Obtém as classificações secundárias.
    this.obterClassificacoes(91, this, 'listaClassificacaoSecundaria');
    // Carrega o projeto.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    __WEBPACK_IMPORTED_MODULE_3__utils_projetos__["a" /* default */].getProjeto(this.idProjeto).then(function (response) {
      _this3.projeto = response.data;
      _this3.alteracao.classificacaoSecundaria = _this3.projeto.classificacaoSecundaria;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this3.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'c-textarea': __WEBPACK_IMPORTED_MODULE_2__components_c_textarea___default.a
  }
});

/***/ }),
/* 679 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Alterar Classificação Secundária'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-dialog', {
    attrs: {
      "width": "600"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n                    Confirma a alteração da classificação secundária?\n                  ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Não")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.alterarClassificacaoSecundaria
    }
  }, [_vm._v("Sim")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Título do projeto",
      "value": this.projeto.titulo
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Número",
      "value": this.projeto.idProjeto
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Situação",
      "value": this.projeto.situacao.descricao
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Classificação secundária",
      "items": _vm.listaClassificacaoSecundaria,
      "item-text": "descricao",
      "item-value": "id",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "return-object": "",
      "required": "",
      "autocomplete": "",
      "rules": _vm.obrigatorio
    },
    model: {
      value: (_vm.alteracao.classificacaoSecundaria),
      callback: function($$v) {
        _vm.$set(_vm.alteracao, "classificacaoSecundaria", $$v)
      },
      expression: "alteracao.classificacaoSecundaria"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-textarea', {
    attrs: {
      "label": "Justificativa/Observação",
      "rules": _vm.tamanho2000caracteres,
      "rows": 3,
      "auto-grow": true,
      "multi-line": "",
      "counter": "2000",
      "required": ""
    },
    model: {
      value: (_vm.alteracao.justificativaObservacao),
      callback: function($$v) {
        _vm.$set(_vm.alteracao, "justificativaObservacao", $$v)
      },
      expression: "alteracao.justificativaObservacao"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.cancelar
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        _vm.dialog = true
      }
    }
  }, [_vm._v("Alterar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(681)
  __webpack_require__(682)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(683),
  /* template */
  __webpack_require__(684),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-45a00cc2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 681 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 682 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_textarea__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_dialog__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_date_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto'],
  data: function data() {
    return {
      dialog: false,
      dates: __WEBPACK_IMPORTED_MODULE_4__utils_dates__["a" /* default */],
      listaSuspensoes: [],
      headersSuspensoes: [{ text: 'Início', align: 'left', value: 'dtInicioSuspensao' }, { text: 'Fim', align: 'left', value: 'dtFimSuspensao' }, { text: 'Processo', left: 'left', value: 'processo' }],
      formularioValido: false,
      projeto: {
        situacao: {},
        tipoPublico: {},
        classificacoesPrimariaSecundaria: [{}, {}]
      },
      suspensao: {
        processo: '',
        dtInicioSuspensao: '',
        dtFimSuspensao: '',
        justificativaObservacao: ''
      },
      obrigatorio: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }],
      tamanho2000caracteres: [function (input) {
        return input.length <= 2000 || 'Este campo não pode possuir mais que 2000 caracteres';
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    // Cancelar.
    cancelar: function cancelar() {
      this.$router.go(-1);
    },
    // Suspender ou prorrogar.
    suspenderProrrogarAcaoExtensao: function suspenderProrrogarAcaoExtensao() {
      if (this.projeto.situacao.item === 18 || this.projeto.situacao.item === 3) {
        this.suspenderAcaoExtensao();
      } else {
        this.prorrogarSuspensaoAcaoExtensao();
      }
    },
    // Suspender ação de extensão.
    suspenderAcaoExtensao: function suspenderAcaoExtensao() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Suspendendo ação de extensão...' });
      __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].postSuspenderAcaoExtensao(this.idProjeto, this.suspensao).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.$router.go(-1);
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Suspendendo ação de extensão...' });
      });
    },
    // Prorrogar suspensão da ação de extensão.
    prorrogarSuspensaoAcaoExtensao: function prorrogarSuspensaoAcaoExtensao() {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Prorrogando suspensão da ação de extensão...' });
      __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].postProrrogarSuspensaoAcaoExtensao(this.idProjeto, this.suspensao).then(function (response) {
        _this2.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this2.$router.go(-1);
      }).catch(function (error) {
        _this2.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Prorrogando suspensão da ação de extensão...' });
      });
    }
  }),
  mounted: function mounted() {
    var _this3 = this;

    // Carrega ação de extensão.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ação de extensão...' });
    __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getProjeto(this.idProjeto).then(function (response) {
      _this3.projeto = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this3.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ação de extensão...' });
    });

    // Carrega as suspensões de uma ação de extensão.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando suspensões...' });
    __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getSuspensoes(this.idProjeto).then(function (response) {
      _this3.listaSuspensoes = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this3.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando suspensões...' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'c-date-dialog': __WEBPACK_IMPORTED_MODULE_3__components_c_date_dialog___default.a,
    'c-textarea': __WEBPACK_IMPORTED_MODULE_2__components_c_textarea___default.a
  }
});

/***/ }),
/* 684 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": (this.projeto.situacao.item === 18 || this.projeto.situacao.item === 3) ? 'Suspender Ação de Extensão' : 'Prorrogar suspensão da ação de extensão'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-dialog', {
    attrs: {
      "width": "550"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n                    " + _vm._s((this.projeto.situacao.item === 18 || this.projeto.situacao.item === 3) ? 'Confirma a suspensão da ação de extensão?' : 'Confirma a prorrogação da suspensão da ação de extensão?') + "\n                  ")]), _vm._v(" "), _c('v-card-text'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Não")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.suspenderProrrogarAcaoExtensao()
      }
    }
  }, [_vm._v("Sim")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Título",
      "value": this.projeto.titulo
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Número",
      "value": this.projeto.idProjeto
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Situação",
      "value": this.projeto.situacao.descricao
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Data de início da ação de extensão",
      "value": _vm.dates.format(this.projeto.dataInicio)
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Data de conclusão da ação de extensão",
      "value": _vm.dates.format(this.projeto.dataConclusao)
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Coordenador",
      "value": this.projeto.nomeCoordenador
    }
  })], 1)], 1), _vm._v(" "), (this.projeto.situacao.item === 4) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "labelSuspensoes"
  }, [_vm._v("Suspensões")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.listaSuspensoes.length !== 0) ? _c('v-data-table', {
    staticClass: "elevation-1 suspensoes",
    attrs: {
      "headers": _vm.headersSuspensoes,
      "header-props": {
        sortIcon: null
      },
      "items": _vm.listaSuspensoes,
      "items-per-page": -1,
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "item.dtInicioSuspensao",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dtInicioSuspensao)))]
      }
    }, {
      key: "item.dtFimSuspensao",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dtFimSuspensao)))]
      }
    }], null, false, 4036453385)
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Processo*",
      "rules": _vm.obrigatorio,
      "prepend-icon": "feed"
    },
    model: {
      value: (_vm.suspensao.processo),
      callback: function($$v) {
        _vm.$set(_vm.suspensao, "processo", $$v)
      },
      expression: "suspensao.processo"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('c-date-dialog', {
    attrs: {
      "label": (this.projeto.situacao.item === 18 || this.projeto.situacao.item === 3) ? 'Data de início da suspensão*' : 'Data de início da nova suspensão*',
      "rules": _vm.obrigatorio
    },
    model: {
      value: (_vm.suspensao.dtInicioSuspensao),
      callback: function($$v) {
        _vm.$set(_vm.suspensao, "dtInicioSuspensao", $$v)
      },
      expression: "suspensao.dtInicioSuspensao"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('c-date-dialog', {
    attrs: {
      "label": (this.projeto.situacao.item === 18 || this.projeto.situacao.item === 3) ? 'Data de fim da suspensão*' : 'Data de fim da nova suspensão*',
      "rules": _vm.obrigatorio
    },
    model: {
      value: (_vm.suspensao.dtFimSuspensao),
      callback: function($$v) {
        _vm.$set(_vm.suspensao, "dtFimSuspensao", $$v)
      },
      expression: "suspensao.dtFimSuspensao"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-textarea', {
    attrs: {
      "label": "Justificativa/Observação",
      "rules": _vm.tamanho2000caracteres,
      "rows": 3,
      "auto-grow": true,
      "multi-line": "",
      "counter": "2000",
      "required": ""
    },
    model: {
      value: (_vm.suspensao.justificativaObservacao),
      callback: function($$v) {
        _vm.$set(_vm.suspensao, "justificativaObservacao", $$v)
      },
      expression: "suspensao.justificativaObservacao"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.cancelar
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        _vm.dialog = true
      }
    }
  }, [_vm._v("\n              " + _vm._s((this.projeto.situacao.item === 18 || this.projeto.situacao.item === 3) ? 'Suspender' : 'Prorrogar') + "\n            ")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(686)
  __webpack_require__(687)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(688),
  /* template */
  __webpack_require__(689),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-85cdd428",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 686 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 687 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_textarea__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_dialog__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_date_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto'],
  data: function data() {
    return {
      dialog: false,
      dates: __WEBPACK_IMPORTED_MODULE_4__utils_dates__["a" /* default */],
      listaSuspensoes: [],
      headersSuspensoes: [{ text: 'Início', align: 'left', value: 'dtInicioSuspensao' }, { text: 'Fim', align: 'left', value: 'dtFimSuspensao' }, { text: 'Processo', left: 'left', value: 'processo' }],
      formularioValido: false,
      projeto: {
        situacao: {},
        tipoPublico: {},
        classificacoesPrimariaSecundaria: [{}, {}]
      },
      reativacao: {
        processo: '',
        dataReativacao: '',
        justificativaObservacao: ''
      },
      obrigatorio: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }],
      tamanho2000caracteres: [function (input) {
        return input.length <= 2000 || 'Este campo não pode possuir mais que 2000 caracteres';
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    // Cancelar.
    cancelar: function cancelar() {
      this.$router.go(-1);
    },
    // Reativar ação de extensão.
    ReativarAcaoExtensao: function ReativarAcaoExtensao() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Reativando ação de extensão...' });
      __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].postReativarAcaoExtensao(this.idProjeto, this.reativacao).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.$router.go(-1);
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Reativando ação de extensão...' });
      });
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    // Carrega ação de extensão.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ação de extensão...' });
    __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getProjeto(this.idProjeto).then(function (response) {
      _this2.projeto = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ação de extensão...' });
    });

    // Carrega as suspensões de uma ação de extensão.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando suspensões...' });
    __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getSuspensoes(this.idProjeto).then(function (response) {
      _this2.listaSuspensoes = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando suspensões...' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'c-date-dialog': __WEBPACK_IMPORTED_MODULE_3__components_c_date_dialog___default.a,
    'c-textarea': __WEBPACK_IMPORTED_MODULE_2__components_c_textarea___default.a
  }
});

/***/ }),
/* 689 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": "Reativar Ação de Extensão"
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-dialog', {
    attrs: {
      "width": "600"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n                    Confirma a reativação da ação de extensão?\n                  ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                    Em caso de interrupção da suspensão atual, a data de fim da suspensão será atualizada.\n                  ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Não")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.ReativarAcaoExtensao()
      }
    }
  }, [_vm._v("Sim")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Título",
      "value": this.projeto.titulo
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Número",
      "value": this.projeto.idProjeto
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Situação",
      "value": this.projeto.situacao.descricao
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Data de início da ação de extensão",
      "value": _vm.dates.format(this.projeto.dataInicio)
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Data de conclusão da ação de extensão",
      "value": _vm.dates.format(this.projeto.dataConclusao)
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Coordenador",
      "value": this.projeto.nomeCoordenador
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "labelSuspensoes"
  }, [_vm._v("Suspensões")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.listaSuspensoes.length !== 0) ? _c('v-data-table', {
    staticClass: "elevation-1 suspensoes",
    attrs: {
      "headers": _vm.headersSuspensoes,
      "header-props": {
        sortIcon: null
      },
      "items": _vm.listaSuspensoes,
      "items-per-page": -1,
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "item.dtInicioSuspensao",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dtInicioSuspensao)))]
      }
    }, {
      key: "item.dtFimSuspensao",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dtFimSuspensao)))]
      }
    }], null, false, 4036453385)
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Processo*",
      "rules": _vm.obrigatorio,
      "prepend-icon": "feed"
    },
    model: {
      value: (_vm.reativacao.processo),
      callback: function($$v) {
        _vm.$set(_vm.reativacao, "processo", $$v)
      },
      expression: "reativacao.processo"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('c-date-dialog', {
    attrs: {
      "label": "Data de reativação*",
      "rules": _vm.obrigatorio
    },
    model: {
      value: (_vm.reativacao.dataReativacao),
      callback: function($$v) {
        _vm.$set(_vm.reativacao, "dataReativacao", $$v)
      },
      expression: "reativacao.dataReativacao"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-textarea', {
    attrs: {
      "label": "Justificativa/Observação",
      "rules": _vm.tamanho2000caracteres,
      "rows": 3,
      "auto-grow": true,
      "multi-line": "",
      "counter": "2000",
      "required": ""
    },
    model: {
      value: (_vm.reativacao.justificativaObservacao),
      callback: function($$v) {
        _vm.$set(_vm.reativacao, "justificativaObservacao", $$v)
      },
      expression: "reativacao.justificativaObservacao"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.cancelar()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        _vm.dialog = true
      }
    }
  }, [_vm._v("\n              Reativar\n            ")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(691)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(692),
  /* template */
  __webpack_require__(693),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 691 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_textarea__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_c_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto'],
  data: function data() {
    return {
      dialog: false,
      formularioValido: false,
      projeto: {
        situacao: {},
        tipoPublico: {},
        classificacoesPrimariaSecundaria: [{}, {}]
      },
      finalizacao: {
        justificativaObservacao: ''
      },
      regrasBasicas: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }],
      assuntoSummaryRules: [function (input) {
        return input.length <= 2000 || 'Este campo não pode possuir mais que 2000 caracteres';
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    cancelar: function cancelar() {
      this.$router.go(-1);
    },
    finalizarAcao: function finalizarAcao() {
      var _this = this;

      this.dialog = false;
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Finalizando ação de extensão...' });
      __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].postFinalizarProjeto(this.idProjeto, this.finalizacao).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.$router.go(-1);
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Finalizando ação de extensão...' });
      });
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ação de extensão.' });
    __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getProjeto(this.idProjeto).then(function (response) {
      _this2.projeto = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ação de extensão.' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a,
    'c-date-menu': __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default.a,
    'c-textarea': __WEBPACK_IMPORTED_MODULE_4__components_c_textarea___default.a
  }
});

/***/ }),
/* 693 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Finalizar Ação de Extensão'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-dialog', {
    attrs: {
      "width": "400"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n                    Confirma a finalização da ação?\n                  ")]), _vm._v(" "), _c('v-card-text'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Não")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.finalizarAcao()
      }
    }
  }, [_vm._v("Sim")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Título do projeto",
      "value": this.projeto.titulo
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Número",
      "value": this.projeto.idProjeto
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Situação",
      "value": this.projeto.situacao.descricao
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-date-menu', {
    attrs: {
      "label": "Data de finalização",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.finalizacao.dataMudancaSituacao),
      callback: function($$v) {
        _vm.$set(_vm.finalizacao, "dataMudancaSituacao", $$v)
      },
      expression: "finalizacao.dataMudancaSituacao"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-textarea', {
    attrs: {
      "label": "Justificativa/Observação",
      "rules": _vm.assuntoSummaryRules,
      "rows": 3,
      "auto-grow": true,
      "multi-line": "",
      "counter": "2000"
    },
    model: {
      value: (_vm.finalizacao.justificativaObservacao),
      callback: function($$v) {
        _vm.$set(_vm.finalizacao, "justificativaObservacao", $$v)
      },
      expression: "finalizacao.justificativaObservacao"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.cancelar
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        _vm.dialog = true
      }
    }
  }, [_vm._v("Finalizar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(695)
  __webpack_require__(696)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(697),
  /* template */
  __webpack_require__(698),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-643c3cea",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 695 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 696 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_textarea__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_date_dialog__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_date_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_c_date_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto'],
  data: function data() {
    return {
      dialog: false,
      dates: __WEBPACK_IMPORTED_MODULE_2__utils_dates__["a" /* default */],
      listaSuspensoes: [],
      headersSuspensoes: [{ text: 'Início', align: 'left', value: 'dtInicioSuspensao' }, { text: 'Fim', align: 'left', value: 'dtFimSuspensao' }, { text: 'Processo', left: 'left', value: 'processo' }],
      formularioValido: false,
      projeto: {
        situacao: {},
        tipoPublico: {},
        classificacoesPrimariaSecundaria: [{}, {}]
      },
      conclusao: {
        justificativaObservacao: ''
      },
      obrigatorio: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }],
      tamanho2000caracteres: [function (input) {
        return input.length <= 2000 || 'Este campo não pode possuir mais que 2000 caracteres';
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {

    // Cancelar.
    cancelar: function cancelar() {
      this.$router.go(-1);
    },

    // Concluir ação de extensão.
    concluirAcaoExtensao: function concluirAcaoExtensao() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Concluindo ação de extensão...' });
      __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].postConcluirProjeto(this.idProjeto, this.conclusao).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.$router.go(-1);
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Concluindo ação de extensão...' });
      });
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    // Carrega ação de extensão.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ação de extensão...' });
    __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getProjeto(this.idProjeto).then(function (response) {
      _this2.projeto = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ação de extensão...' });
    });

    // Carrega as suspensões de uma ação de extensão.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando suspensões...' });
    __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getSuspensoes(this.idProjeto).then(function (response) {
      _this2.listaSuspensoes = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando suspensões...' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'c-date-dialog': __WEBPACK_IMPORTED_MODULE_4__components_c_date_dialog___default.a,
    'c-textarea': __WEBPACK_IMPORTED_MODULE_3__components_c_textarea___default.a
  }
});

/***/ }),
/* 698 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Concluir Ação de Extensão'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-dialog', {
    attrs: {
      "width": "550"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n                    Confirma a conclusão da ação de extensão?\n                  ")]), _vm._v(" "), _c('v-card-text'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Não")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.concluirAcaoExtensao()
      }
    }
  }, [_vm._v("Sim")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Título",
      "value": this.projeto.titulo
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Número",
      "value": this.projeto.idProjeto
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Situação",
      "value": this.projeto.situacao.descricao
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Data de início da ação de extensão",
      "value": _vm.dates.format(this.projeto.dataInicio)
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Data de conclusão da ação de extensão",
      "value": _vm.dates.format(this.projeto.dataConclusao)
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Coordenador",
      "value": this.projeto.nomeCoordenador
    }
  })], 1)], 1), _vm._v(" "), (this.projeto.situacao.item === 4) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "labelSuspensoes"
  }, [_vm._v("Suspensões")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.listaSuspensoes.length !== 0) ? _c('v-data-table', {
    staticClass: "elevation-1 suspensoes",
    attrs: {
      "headers": _vm.headersSuspensoes,
      "header-props": {
        sortIcon: null
      },
      "items": _vm.listaSuspensoes,
      "items-per-page": -1,
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "item.dtInicioSuspensao",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dtInicioSuspensao)))]
      }
    }, {
      key: "item.dtFimSuspensao",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dtFimSuspensao)))]
      }
    }], null, false, 4036453385)
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Processo*",
      "rules": _vm.obrigatorio,
      "prepend-icon": "feed"
    },
    model: {
      value: (_vm.conclusao.processo),
      callback: function($$v) {
        _vm.$set(_vm.conclusao, "processo", $$v)
      },
      expression: "conclusao.processo"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('c-date-dialog', {
    attrs: {
      "label": "Data de conclusão*",
      "rules": _vm.obrigatorio
    },
    model: {
      value: (_vm.conclusao.dataConclusao),
      callback: function($$v) {
        _vm.$set(_vm.conclusao, "dataConclusao", $$v)
      },
      expression: "conclusao.dataConclusao"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-textarea', {
    staticClass: "justificativa",
    attrs: {
      "label": "Justificativa/Observação",
      "rules": _vm.tamanho2000caracteres,
      "rows": 3,
      "auto-grow": true,
      "multi-line": "",
      "counter": "2000",
      "required": ""
    },
    model: {
      value: (_vm.conclusao.justificativaObservacao),
      callback: function($$v) {
        _vm.$set(_vm.conclusao, "justificativaObservacao", $$v)
      },
      expression: "conclusao.justificativaObservacao"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.cancelar()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        _vm.dialog = true
      }
    }
  }, [_vm._v("Confirmar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(700)
  __webpack_require__(701)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(702),
  /* template */
  __webpack_require__(703),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7b6e6bfc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 700 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 701 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_textarea__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto'],
  data: function data() {
    return {
      dialog: false,
      dates: __WEBPACK_IMPORTED_MODULE_2__utils_dates__["a" /* default */],
      formularioValido: false,
      listaSuspensoes: [],
      headersSuspensoes: [{ text: 'Início', align: 'left', value: 'dtInicioSuspensao' }, { text: 'Fim', align: 'left', value: 'dtFimSuspensao' }, { text: 'Processo', left: 'left', value: 'processo' }],
      projeto: {
        situacao: {},
        tipoPublico: {},
        classificacoesPrimariaSecundaria: [{}, {}]
      },
      cancelamento: {
        justificativaObservacao: ''
      },
      obrigatorio: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }],
      tamanho2000caracteres: [function (input) {
        return input.length <= 2000 || 'Este campo não pode possuir mais que 2000 caracteres';
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {

    // Cancelar.
    cancelar: function cancelar() {
      this.$router.go(-1);
    },

    // Cancelar ação de extensão.
    cancelarAcaoExtensao: function cancelarAcaoExtensao() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Cancelando ação de extensão...' });
      __WEBPACK_IMPORTED_MODULE_4__utils_projetos__["a" /* default */].postCancelarProjeto(this.idProjeto, this.cancelamento).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.$router.go(-1);
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Cancelando ação de extensão...' });
      });
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    // Carrega ação de extensão.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ação de extensão...' });
    __WEBPACK_IMPORTED_MODULE_4__utils_projetos__["a" /* default */].getProjeto(this.idProjeto).then(function (response) {
      _this2.projeto = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ação de extensão...' });
    });

    // Carrega as suspensões de uma ação de extensão.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando suspensões...' });
    __WEBPACK_IMPORTED_MODULE_4__utils_projetos__["a" /* default */].getSuspensoes(this.idProjeto).then(function (response) {
      _this2.listaSuspensoes = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando suspensões...' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'c-textarea': __WEBPACK_IMPORTED_MODULE_3__components_c_textarea___default.a
  }
});

/***/ }),
/* 703 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Cancelar Ação de Extensão'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-dialog', {
    attrs: {
      "width": "600"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n                    Confirma o cancelamento da ação de extensão?\n                  ")]), _vm._v(" "), _c('v-card-text'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Não")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.cancelarAcaoExtensao()
      }
    }
  }, [_vm._v("Sim")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Título",
      "value": this.projeto.titulo
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Número",
      "value": this.projeto.idProjeto
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Situação",
      "value": this.projeto.situacao.descricao
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Data de início da ação de extensão",
      "value": _vm.dates.format(this.projeto.dataInicio)
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Data de conclusão da ação de extensão",
      "value": _vm.dates.format(this.projeto.dataConclusao)
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Coordenador",
      "value": this.projeto.nomeCoordenador
    }
  })], 1)], 1), _vm._v(" "), (this.projeto.situacao.item === 4) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "labelSuspensoes"
  }, [_vm._v("Suspensões")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.listaSuspensoes.length !== 0) ? _c('v-data-table', {
    staticClass: "elevation-1 suspensoes",
    attrs: {
      "headers": _vm.headersSuspensoes,
      "header-props": {
        sortIcon: null
      },
      "items": _vm.listaSuspensoes,
      "items-per-page": -1,
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "item.dtInicioSuspensao",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dtInicioSuspensao)))]
      }
    }, {
      key: "item.dtFimSuspensao",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dtFimSuspensao)))]
      }
    }], null, false, 4036453385)
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Processo*",
      "rules": _vm.obrigatorio,
      "prepend-icon": "feed"
    },
    model: {
      value: (_vm.cancelamento.processo),
      callback: function($$v) {
        _vm.$set(_vm.cancelamento, "processo", $$v)
      },
      expression: "cancelamento.processo"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-textarea', {
    staticClass: "justificativa",
    attrs: {
      "label": "Justificativa/Observação",
      "rules": _vm.tamanho2000caracteres,
      "rows": 3,
      "auto-grow": true,
      "multi-line": "",
      "counter": "2000",
      "required": ""
    },
    model: {
      value: (_vm.cancelamento.justificativaObservacao),
      callback: function($$v) {
        _vm.$set(_vm.cancelamento, "justificativaObservacao", $$v)
      },
      expression: "cancelamento.justificativaObservacao"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.cancelar()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        _vm.dialog = true
      }
    }
  }, [_vm._v("Confirmar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(705)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(706),
  /* template */
  __webpack_require__(707),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 705 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_textarea__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_c_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto'],
  data: function data() {
    return {
      dialog: false,
      formularioValido: false,
      projeto: {
        situacao: {},
        tipoPublico: {},
        classificacoesPrimariaSecundaria: [{}, {}]
      },
      desfazer: {
        justificativaObservacao: ''
      },
      regrasBasicas: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }],
      assuntoSummaryRules: [function (input) {
        return input.length <= 2000 || 'Este campo não pode possuir mais que 2000 caracteres';
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    cancelar: function cancelar() {
      this.$router.go(-1);
    },
    desfazerFinalizacao: function desfazerFinalizacao() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Desfazendo finalização...' });
      __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].postDesfazerFinalizacaoProjeto(this.idProjeto, this.desfazer).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.$router.go(-1);
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Desfazendo finalização...' });
      });
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ação de extensão.' });
    __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getProjeto(this.idProjeto).then(function (response) {
      _this2.projeto = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ação de extensão.' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a,
    'c-date-menu': __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default.a,
    'c-textarea': __WEBPACK_IMPORTED_MODULE_4__components_c_textarea___default.a
  }
});

/***/ }),
/* 707 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Desfazer Finalização'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-dialog', {
    attrs: {
      "width": "300"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n                    Desfazer a finalização?\n                  ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                    A ação voltará para a situação \"Ativo\".\n                  ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Não")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.desfazerFinalizacao()
      }
    }
  }, [_vm._v("Sim")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Título do projeto",
      "value": this.projeto.titulo
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Número",
      "value": this.projeto.idProjeto
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Situação",
      "value": this.projeto.situacao.descricao
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-textarea', {
    attrs: {
      "label": "Justificativa/Observação",
      "rules": _vm.assuntoSummaryRules,
      "rows": 3,
      "auto-grow": true,
      "multi-line": "",
      "counter": "2000"
    },
    model: {
      value: (_vm.desfazer.justificativaObservacao),
      callback: function($$v) {
        _vm.$set(_vm.desfazer, "justificativaObservacao", $$v)
      },
      expression: "desfazer.justificativaObservacao"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.cancelar
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        _vm.dialog = true
      }
    }
  }, [_vm._v("Confirmar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(709)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(710),
  /* template */
  __webpack_require__(711),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 709 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_textarea__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_c_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto'],
  data: function data() {
    return {
      dialog: false,
      formularioValido: false,
      projeto: {
        situacao: {},
        tipoPublico: {},
        classificacoesPrimariaSecundaria: [{}, {}]
      },
      cancelamento: {
        justificativaObservacao: ''
      },
      regrasBasicas: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }],
      assuntoSummaryRules: [function (input) {
        return input.length <= 2000 || 'Este campo não pode possuir mais que 2000 caracteres';
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    cancelar: function cancelar() {
      this.$router.go(-1);
    },
    desfazerExclusao: function desfazerExclusao() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Cancelando ação de extensão...' });
      __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].postDesfazerExclusaoProjeto(this.idProjeto, this.cancelamento).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.$router.go(-1);
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Cancelando ação de extensão...' });
      });
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ação de extensão.' });
    __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getProjeto(this.idProjeto).then(function (response) {
      _this2.projeto = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ação de extensão.' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a,
    'c-date-menu': __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default.a,
    'c-textarea': __WEBPACK_IMPORTED_MODULE_4__components_c_textarea___default.a
  }
});

/***/ }),
/* 711 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Desfazer Exclusão'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-dialog', {
    attrs: {
      "width": "400"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n                    Desfazer a exclusão?\n                  ")]), _vm._v(" "), _c('v-card-text'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Não")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.desfazerExclusao
    }
  }, [_vm._v("Sim")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Título do projeto",
      "value": this.projeto.titulo
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Número",
      "value": this.projeto.idProjeto
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Situação",
      "value": this.projeto.situacao.descricao
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-textarea', {
    attrs: {
      "label": "Justificativa/Observação",
      "rules": _vm.assuntoSummaryRules,
      "rows": 3,
      "auto-grow": true,
      "multi-line": "",
      "counter": "2000"
    },
    model: {
      value: (_vm.cancelamento.justificativaObservacao),
      callback: function($$v) {
        _vm.$set(_vm.cancelamento, "justificativaObservacao", $$v)
      },
      expression: "cancelamento.justificativaObservacao"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.cancelar
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        _vm.dialog = true
      }
    }
  }, [_vm._v("Confirmar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(713),
  /* template */
  __webpack_require__(714),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto'],
  data: function data() {
    return {
      listaParcerias: [],
      search: null,
      sortBy: 'idProjeto',
      sortDesc: false,
      itemsPerPage: 25,
      opcoesPaginacao: [10, 25, 50, { text: 'Todas', value: -1 }],
      headers: [{ text: 'Número', align: 'center', value: 'idProjeto' }, { text: 'Título', align: 'center', value: 'tituloProjeto' }, { text: 'Coordenador', align: 'center', value: 'nomeCoordenador' }, { text: 'Nome do parceiro institucional/colaborador', align: 'center', value: 'nomeParceiro' }]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])('auth', ['logged', 'username', 'nome', 'administrador', 'usuarioPROEX', 'permissaoCriarProjetoExtensao'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    pesquisar: function pesquisar() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando parcerias.' });
      __WEBPACK_IMPORTED_MODULE_4__utils_projetos__["a" /* default */].getParcerias().then(function (response) {
        _this.listaParcerias = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this.listaParcerias = [];
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando parcerias.' });
      });
    }
  }),
  mounted: function mounted() {
    this.pesquisar();
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a,
    'c-date-menu': __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default.a
  }
});

/***/ }),
/* 714 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [(_vm.administrador === true) ? _c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Lista de projetos que possuem parceiros'
    }
  }), _vm._v(" "), _c('v-card-title', [_c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "filter_list",
      "label": "Filtrar resultados"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-card-text', [_c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaParcerias,
      "search": _vm.search,
      "no-data-text": 'Nenhuma parceria encontrada',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.tituloProjeto",
      fn: function(props) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'ProjetoFormulario',
              params: {
                idProjeto: props.item.idProjeto
              }
            }
          }
        }, [_vm._v(_vm._s(props.item.tituloProjeto))])]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n              Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaParcerias.length) + " parcerias\n            ")]
      }
    }], null, false, 3914888436)
  }), _vm._v(" "), _c('br')], 1)], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(716)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(717),
  /* template */
  __webpack_require__(718),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 716 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      api_url: "https://pib-api.prod.uks.ufes.br",
      formularioValido: false,
      dates: __WEBPACK_IMPORTED_MODULE_3__utils_dates__["a" /* default */],
      listaRelatoriosGestao: [],
      regrasBasicas: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }],
      search: null,
      sortBy: 'dtCriacao',
      sortDesc: true,
      itemsPerPage: -1,
      opcoesPaginacao: [10, 25, 50, { text: 'Todas', value: -1 }],
      headers: [{ text: 'Número', align: 'center', value: 'id' }, { text: 'Nome', align: 'center', value: 'nome' }, { text: 'Descrição', align: 'center', value: 'descricao' }, { text: 'Opções', align: 'center', value: 'opcoes' }]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])('auth', ['logged', 'username', 'nome', 'administrador', 'usuarioPROEX', 'permissaoCriarProjetoExtensao'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    goPlanilhaRelatorio: function goPlanilhaRelatorio(id, nome) {
      console.log('asdfahsudfhu');
      window.location = this.api_url + '/gestao/relatorios/' + id + '/' + nome + '.xlsx';
    },
    truncate: function truncate(string, limit) {
      if (string.length > limit) return string.substring(0, limit) + '...';else return string;
    },

    carregarRelatoriosGestao: function carregarRelatoriosGestao() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando relatórios de gestão.' });
      __WEBPACK_IMPORTED_MODULE_4__utils_projetos__["a" /* default */].getRelatoriosGestao().then(function (response) {
        _this.listaRelatoriosGestao = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this.listaRelatoriosGestao = [];
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando relatórios de gestão.' });
      });
    }
  }),
  mounted: function mounted() {
    this.carregarRelatoriosGestao();
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a
  }
});

/***/ }),
/* 718 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [(_vm.administrador === true) ? _c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Relatórios de gestão'
    }
  }), _vm._v(" "), _c('v-card-title', [_c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "filter_list",
      "label": "Filtrar resultados"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-card-text', [_c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaRelatoriosGestao,
      "search": _vm.search,
      "no-data-text": 'Nenhum projeto encontrado',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.opcoes",
      fn: function(props) {
        return [_c('c-tooltip-btn', {
          attrs: {
            "icon": "grid_on",
            "color": "primary",
            "tooltip": "Baixar planilha"
          },
          on: {
            "click": function($event) {
              return _vm.goPlanilhaRelatorio(props.item.id, props.item.nome)
            }
          }
        })]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n              Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaRelatoriosGestao.length) + " projetos\n            ")]
      }
    }], null, false, 3359232442)
  }), _vm._v(" "), _c('br')], 1)], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(720),
  /* template */
  __webpack_require__(721),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_textarea__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_c_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto'],
  data: function data() {
    return {
      dialog: false,
      formularioValido: false,
      mensagem: {
        titulo: '',
        texto: ''
      },
      regrasBasicas: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])('auth', ['logged', 'username', 'nome', 'administrador', 'usuarioPROEX', 'permissaoCriarProjetoExtensao'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    cancelar: function cancelar() {
      this.$router.push({ name: 'Administracao' });
    },
    novaMensagem: function novaMensagem() {
      var _this = this;

      this.mensagem.ativo = 'S';
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Salvando Mensagem...' });
      __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].postMensagem(this.mensagem).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.$router.go(-1);
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Salvando Mensagem...' });
      });
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando mensagem.' });
    __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getListaMensagem().then(function (response) {
      _this2.mensagem = response.data.pop();
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando mensagem.' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a,
    'c-date-menu': __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default.a,
    'c-textarea': __WEBPACK_IMPORTED_MODULE_4__components_c_textarea___default.a
  }
});

/***/ }),
/* 721 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [(_vm.administrador === true) ? _c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Nova Mensagem'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-dialog', {
    attrs: {
      "width": "400"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n                    Confirma a mensagem inicial?\n                  ")]), _vm._v(" "), _c('v-card-text'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Não")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.novaMensagem
    }
  }, [_vm._v("Sim")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Título",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.mensagem.titulo),
      callback: function($$v) {
        _vm.$set(_vm.mensagem, "titulo", $$v)
      },
      expression: "mensagem.titulo"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-textarea', {
    attrs: {
      "label": "Texto",
      "rules": _vm.regrasBasicas,
      "rows": 3,
      "auto-grow": true,
      "multi-line": "",
      "counter": "2000"
    },
    model: {
      value: (_vm.mensagem.texto),
      callback: function($$v) {
        _vm.$set(_vm.mensagem, "texto", $$v)
      },
      expression: "mensagem.texto"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.cancelar
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        _vm.dialog = true
      }
    }
  }, [_vm._v("Salvar")])], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(723)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(724),
  /* template */
  __webpack_require__(726),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 723 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_usuariosProex__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      listaUsuariosProex: [],
      search: null,
      itemsPerPage: -1,
      opcoesPaginacao: [10, 25, 50, { text: 'Todas', value: -1 }],
      headers: [{ text: 'Nome', align: 'left', value: 'nomeUsuario' }]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('auth', ['logged', 'username', 'nome', 'administrador', 'usuarioPROEX', 'permissaoCriarProjetoExtensao'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    voltar: function voltar() {
      this.$router.push({ name: 'Administracao' });
    },
    listarUsuariosProex: function listarUsuariosProex() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando Usuários-Proex.' });
      __WEBPACK_IMPORTED_MODULE_2__utils_usuariosProex__["a" /* default */].getUsuariosProex().then(function (response) {
        _this.listaUsuariosProex = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this.listaUsuariosProex = [];
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando Usuários-Proex.' });
      });
    }
  }),
  mounted: function mounted() {
    this.listarUsuariosProex();
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a
  }
});

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(29);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);

// URL and endpoint constants
var API_URL = "https://pib-api.prod.uks.ufes.br";

var getUsuariosProex = function getUsuariosProex() {
  var USUARIOS_PROEX_URL = API_URL + '/usuarios-proex';
  var config = {
    method: 'get',
    url: USUARIOS_PROEX_URL,
    responseType: 'text',
    credentials: true
  };
  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http(config);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getUsuariosProex: getUsuariosProex
});

/***/ }),
/* 726 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [(_vm.administrador === true) ? _c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Lista de Usuários-Proex'
    }
  }), _vm._v(" "), _c('v-card-title', [_c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "filter_list",
      "label": "Filtrar resultados"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-card-text', [_c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaUsuariosProex,
      "search": _vm.search,
      "no-data-text": 'Nenhum usuário encontrado',
      "must-sort": "",
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    scopedSlots: _vm._u([{
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n              Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaUsuariosProex.length) + " usuários\n            ")]
      }
    }], null, false, 1307634636)
  }), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.voltar
    }
  }, [_vm._v("Voltar")])], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(728),
  /* template */
  __webpack_require__(729),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_bolsas__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      periodoFrequencia: {},
      diaDoMesRules: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }, function (input) {
        return !isNaN(parseFloat(input)) && input >= 1 && input <= 31 || 'Dia do mês inválido';
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    cancelar: function cancelar() {
      this.$router.push({ name: 'ProjetosAguardandoAprovacao' });
    },
    definirPeriodoFrequencia: function definirPeriodoFrequencia() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Salvando período de frequência.' });
      __WEBPACK_IMPORTED_MODULE_4__utils_bolsas__["a" /* default */].postPeriodoFrequencia(this.periodoFrequencia).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: 'Período de atribuição da frequência alterado com sucesso!' });
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Salvando período de frequência.' });
      });
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando período de frequência.' });
    __WEBPACK_IMPORTED_MODULE_4__utils_bolsas__["a" /* default */].getPeriodoFrequencia().then(function (response) {
      _this2.periodoFrequencia = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando período de frequência.' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a,
    'c-date-menu': __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default.a
  }
});

/***/ }),
/* 729 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Definir período do mês '
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Início (Dia do mês)",
      "type": "number",
      "required": "",
      "rules": _vm.diaDoMesRules
    },
    model: {
      value: (_vm.periodoFrequencia.diaInicial),
      callback: function($$v) {
        _vm.$set(_vm.periodoFrequencia, "diaInicial", $$v)
      },
      expression: "periodoFrequencia.diaInicial"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Fim (Dia do mês)",
      "type": "number",
      "required": "",
      "rules": _vm.diaDoMesRules
    },
    model: {
      value: (_vm.periodoFrequencia.diaFinal),
      callback: function($$v) {
        _vm.$set(_vm.periodoFrequencia, "diaFinal", $$v)
      },
      expression: "periodoFrequencia.diaFinal"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.cancelar
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.definirPeriodoFrequencia()
      }
    }
  }, [_vm._v("Salvar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(731),
  /* template */
  __webpack_require__(732),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto'],
  data: function data() {
    return {
      api_url: "https://pib-api.prod.uks.ufes.br",
      formularioValido: false,
      relatorio: {
        tipo: [],
        dataInicial: null,
        dataFinal: null
      },
      regrasBasicas: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    cancelar: function cancelar() {
      this.$router.go(-1);
    },
    baixar: function baixar() {
      var urlRelatorio = new URL(this.api_url + '/gestao/seguro.xlsx');
      urlRelatorio.searchParams.append('tipo', this.relatorio.tipo);
      urlRelatorio.searchParams.append('dataInicial', this.relatorio.dataInicial);
      urlRelatorio.searchParams.append('dataFinal', this.relatorio.dataFinal);

      window.location = urlRelatorio.href;
    }
  }),
  mounted: function mounted() {},

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a
  }
});

/***/ }),
/* 732 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": "Relatório para seguro"
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Alunos",
      "value": 1
    },
    model: {
      value: (_vm.relatorio.tipo),
      callback: function($$v) {
        _vm.$set(_vm.relatorio, "tipo", $$v)
      },
      expression: "relatorio.tipo"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Externos",
      "value": 2
    },
    model: {
      value: (_vm.relatorio.tipo),
      callback: function($$v) {
        _vm.$set(_vm.relatorio, "tipo", $$v)
      },
      expression: "relatorio.tipo"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "date",
      "label": "Data de início",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.relatorio.dataInicial),
      callback: function($$v) {
        _vm.$set(_vm.relatorio, "dataInicial", $$v)
      },
      expression: "relatorio.dataInicial"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "date",
      "label": "Data de conclusão",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.relatorio.dataFinal),
      callback: function($$v) {
        _vm.$set(_vm.relatorio, "dataFinal", $$v)
      },
      expression: "relatorio.dataFinal"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.cancelar()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.baixar()
      }
    }
  }, [_vm._v("Baixar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(734),
  /* template */
  __webpack_require__(735),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_tooltip_btn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_tooltip_btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_tooltip_btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto'],
  data: function data() {
    return {
      dialogConfirmaReprovacao: false,
      dataInicioSuspensao: null,
      projetoSelecionado: null,
      listaProjetos: [],
      search: null,
      sortBy: 'dtCriacao',
      sortDesc: true,
      itemsPerPage: -1,
      opcoesPaginacao: [10, 25, 50, { text: 'Todas', value: -1 }],
      headers: [{ text: 'Número', align: 'center', value: 'idProjeto' }, { text: 'Título', align: 'center', value: 'titulo' }, { text: 'Classificação Primária', align: 'center', value: 'classificacaoPrimaria' }, { text: 'Classificação Secundária', align: 'center', value: 'classificacaoSecundaria' }, { text: 'Situação', align: 'center', value: 'situacao' }, { text: 'Coordenador', align: 'center', value: 'nomeCoordenador' }, { text: 'Opções', align: 'center', value: 'opcoes' }]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])('auth', ['logged', 'username', 'nome', 'administrador', 'usuarioPROEX'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    reprovarRelatorioESuspenderCoordenador: function reprovarRelatorioESuspenderCoordenador(idProjeto) {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Reprovando relatório...' });

      var payload = {
        dtInicioSuspensao: this.dataInicioSuspensao
      };

      __WEBPACK_IMPORTED_MODULE_4__utils_projetos__["a" /* default */].postReprovarRelatorioComSuspensaoDeCoordenador(idProjeto, payload).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        for (var i = 0; i < _this.listaProjetos.length; i++) {
          if (_this.listaProjetos[i].idProjeto === idProjeto) {
            _this.listaProjetos.splice(i, 1);
            i--;
          }
        }
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Reprovando Relatório...' });
        _this.dialogConfirmaReprovacao = false;
      });
    },
    abreDialog: function abreDialog(projeto) {
      this.projetoSelecionado = projeto;
      this.dataInicioSuspensao = null;
      this.dialogConfirmaReprovacao = true;
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ações.' });
    __WEBPACK_IMPORTED_MODULE_4__utils_projetos__["a" /* default */].getProjetosComRelatorioReprovavel().then(function (response) {
      _this2.listaProjetos = response.data.slice();
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
      _this2.listaProjetos = [];
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ações.' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'c-tooltip-btn': __WEBPACK_IMPORTED_MODULE_3__components_c_tooltip_btn___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a
  }
});

/***/ }),
/* 735 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-dialog', {
    attrs: {
      "max-width": "600px",
      "persistent": ""
    },
    model: {
      value: (_vm.dialogConfirmaReprovacao),
      callback: function($$v) {
        _vm.dialogConfirmaReprovacao = $$v
      },
      expression: "dialogConfirmaReprovacao"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline font-weight-medium grey lighten-4"
  }, [_vm._v("\n        Confirmação de Reprovação\n      ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-4"
  }, [_c('p', {
    staticClass: "text-body-1 mb-4"
  }, [(_vm.projetoSelecionado) ? [_vm._v("\n            Deseja reprovar o relatório do projeto "), _c('strong', [_vm._v(_vm._s(_vm.projetoSelecionado.titulo))]), _vm._v("?"), _c('br'), _c('br'), _vm._v("\n            O(a) coordenador(a) "), _c('strong', [_vm._v(_vm._s(_vm.projetoSelecionado.nomeCoordenador))]), _vm._v(" será suspenso(a) por 1 ano.\n          ")] : [_c('p', [_vm._v("Carregando informações do projeto...")])]], 2), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Data de início da suspensão",
      "type": "date",
      "outlined": "",
      "dense": "",
      "required": "",
      "prepend-icon": "event"
    },
    model: {
      value: (_vm.dataInicioSuspensao),
      callback: function($$v) {
        _vm.dataInicioSuspensao = $$v
      },
      expression: "dataInicioSuspensao"
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "justify-end"
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "color": "grey darken-1"
    },
    on: {
      "click": function($event) {
        _vm.dialogConfirmaReprovacao = false
      }
    }
  }, [_vm._v("\n          Não\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red darken-1",
      "dark": "",
      "disabled": !_vm.dataInicioSuspensao
    },
    on: {
      "click": function($event) {
        return _vm.reprovarRelatorioESuspenderCoordenador(_vm.projetoSelecionado.idProjeto)
      }
    }
  }, [_vm._v("\n          Sim, reprovar\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [(_vm.administrador === true) ? _c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Reprovação de Relatório com Suspensão de Coordenador'
    }
  }), _vm._v(" "), _c('v-card-title', [_c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "filter_list",
      "label": "Filtrar resultados"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-card-text', [_c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaProjetos,
      "search": _vm.search,
      "no-data-text": 'Nenhuma ação',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.titulo",
      fn: function(props) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'ProjetoFormulario',
              params: {
                idProjeto: props.item.idProjeto
              }
            }
          }
        }, [_vm._v(_vm._s(props.item.titulo))])]
      }
    }, {
      key: "item.opcoes",
      fn: function(props) {
        return [_c('c-tooltip-btn', {
          attrs: {
            "icon": "not_interested",
            "color": "red",
            "tooltip": "Reprovar Relatório"
          },
          on: {
            "click": function($event) {
              return _vm.abreDialog(props.item)
            }
          }
        })]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n              Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaProjetos.length) + " ações\n            ")]
      }
    }], null, false, 480955877)
  }), _vm._v(" "), _c('br')], 1)], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(737),
  /* template */
  __webpack_require__(738),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_tooltip_btn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_tooltip_btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_c_tooltip_btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      idProjetoDigitado: null,
      idProjetoBuscado: null,

      listaRegistros: [],

      listaSituacoesPossiveis: [],

      dialogAdicionar: false,

      idRegistroEditando: null,

      novoRegistro: {
        dtEnvio: null,
        numRelatorio: null,
        numProcesso: null,
        situacao: null
      },

      headers: [{ text: 'Data final do período', value: 'dtEnvio', align: 'center' }, { text: 'Número do Relatório', value: 'numRelatorio', align: 'center' }, { text: 'Processo', value: 'numProcesso', align: 'center' }, { text: 'Nova Situação', value: 'situacao.descricao', align: 'center' }, { text: 'Ações', value: 'acoes', align: 'center', sortable: false }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])('auth', ['logged', 'username', 'nome', 'administrador', 'usuarioPROEX'])),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    buscarRegistros: function buscarRegistros() {
      var _this = this;

      if (!this.idProjetoDigitado) return;
      this.listaRegistros = [];
      this.idProjetoBuscado = this.idProjetoDigitado;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Buscando registros...' });

      __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getRegistrosDeEnvioDeRelatorioDeProjeto(this.idProjetoDigitado).then(function (response) {
        _this.listaRegistros = response.data;
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem || 'Erro ao buscar' });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Registrando Envio de Relatório...' });
      });
    },
    abrirDialogAdicionar: function abrirDialogAdicionar() {
      this.idRegistroEditando = null; // estamos criando
      this.novoRegistro = { dtEnvio: null, numRelatorio: null, numProcesso: null, situacao: null // limpa o formulário
      };this.dialogAdicionar = true;
    },


    opcoesTabelaEstruturada: function opcoesTabelaEstruturada(codTabela, aqui, atributo) {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' });
      return __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getOpcoesTabelaEstruturada(codTabela).then(function (response) {
        aqui[atributo] = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
      });
    },

    registrarEnvio: function registrarEnvio() {
      var _this3 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Salvando registro...' });

      var payload = {
        dtEnvio: this.novoRegistro.dtEnvio,
        numRelatorio: this.novoRegistro.numRelatorio,
        numProcesso: this.novoRegistro.numProcesso,
        situacao: this.novoRegistro.situacao
      };

      var requisicao = void 0;

      if (this.idRegistroEditando) {
        requisicao = __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].putRegistroEnvioDeRelatorioDeProjeto(this.idProjetoBuscado, this.idRegistroEditando, payload);
      } else {
        requisicao = __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].postRegistrarEnvioDeRelatorioDeProjeto(this.idProjetoBuscado, payload);
      }

      requisicao.then(function (response) {
        _this3.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this3.buscarRegistros();
      }).catch(function (error) {
        _this3.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this3.dialogAdicionar = false;
        _this3.idRegistroEditando = null;
        _this3.HIDE_GLOBAL_LOADING();
      });
    },
    formatarData: function formatarData(data) {
      if (!data) return '';

      var _data$split = data.split('-'),
          _data$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_data$split, 3),
          ano = _data$split2[0],
          mes = _data$split2[1],
          dia = _data$split2[2];

      return dia + '/' + mes + '/' + ano;
    },
    restaurarFormatoOriginal: function restaurarFormatoOriginal(data) {
      if (!data) return null;

      // Se já estiver no formato yyyy-MM-dd, mantenha
      if (/^\d{4}-\d{2}-\d{2}$/.test(data)) {
        return data;
      }

      // Se estiver no formato dd/MM/yyyy → converter

      var _data$split3 = data.split('/'),
          _data$split4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_data$split3, 3),
          dia = _data$split4[0],
          mes = _data$split4[1],
          ano = _data$split4[2];

      return ano + '-' + mes + '-' + dia;
    },
    editarRegistro: function editarRegistro(item) {
      // Seta o ID que será editado
      this.idRegistroEditando = item.idRegistroRelatorioProjeto;

      this.novoRegistro = {
        // dtEnvio: this.restaurarFormatoOriginal(item.dtEnvio),
        dtEnvio: item.dtEnvio,
        numRelatorio: item.numRelatorio,
        numProcesso: item.numProcesso,
        // situacao: this.listaSituacoesPossiveis.find(s => s.id === item.situacao)
        situacao: item.situacao
      };
      this.dialogAdicionar = true;
    },
    excluirRegistro: function excluirRegistro(item) {
      var _this4 = this;

      if (!confirm('Tem certeza que deseja excluir este registro?')) return;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo...' });

      __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].deleteRegistroEnvioDeRelatorioDeProjeto(this.idProjetoDigitado, item.idRegistroRelatorioProjeto).then(function () {
        _this4.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: 'Registro excluído com sucesso.' });
        _this4.buscarRegistros();
      }).catch(function (error) {
        _this4.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this4.HIDE_GLOBAL_LOADING();
      });
    }
  }),
  mounted: function mounted() {
    var _this5 = this;

    this.opcoesTabelaEstruturada(6011, this, 'listaSituacoesPossiveis').then(function () {
      // mantém apenas itens 18,19,4,5,20 - apos Ticket #715925 mantém apenas itens 18(ATIVO), 19(CONCLUIDO), 4(SUSPENSO), 5(CANCELADO), 3(INADIMPLENTE))
      _this5.listaSituacoesPossiveis = _this5.listaSituacoesPossiveis.filter(function (item) {
        return item.item === 18 || item.item === 19 || item.item === 4 || item.item === 5 || item.item === 3;
      });
    });
  },
  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar___default.a,
    'c-tooltip-btn': __WEBPACK_IMPORTED_MODULE_4__components_c_tooltip_btn___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_3__components_app_layouts_app_tooltip_tooltip___default.a
  }
});

/***/ }),
/* 738 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-dialog', {
    attrs: {
      "max-width": "500px",
      "persistent": ""
    },
    model: {
      value: (_vm.dialogAdicionar),
      callback: function($$v) {
        _vm.dialogAdicionar = $$v
      },
      expression: "dialogAdicionar"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-4"
  }, [_vm._v("\n        Registrar Envio de Relatório do Projeto\n      ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-4"
  }, [_c('v-text-field', {
    attrs: {
      "label": "Id do Projeto",
      "type": "number",
      "outlined": "",
      "dense": "",
      "required": "",
      "disabled": ""
    },
    model: {
      value: (_vm.idProjetoDigitado),
      callback: function($$v) {
        _vm.idProjetoDigitado = $$v
      },
      expression: "idProjetoDigitado"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Data final do período",
      "type": "date",
      "outlined": "",
      "dense": "",
      "required": ""
    },
    model: {
      value: (_vm.novoRegistro.dtEnvio),
      callback: function($$v) {
        _vm.$set(_vm.novoRegistro, "dtEnvio", $$v)
      },
      expression: "novoRegistro.dtEnvio"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Número do relatório",
      "type": "number",
      "outlined": "",
      "dense": "",
      "required": ""
    },
    model: {
      value: (_vm.novoRegistro.numRelatorio),
      callback: function($$v) {
        _vm.$set(_vm.novoRegistro, "numRelatorio", $$v)
      },
      expression: "novoRegistro.numRelatorio"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Número do Processo",
      "outlined": "",
      "dense": "",
      "required": ""
    },
    model: {
      value: (_vm.novoRegistro.numProcesso),
      callback: function($$v) {
        _vm.$set(_vm.novoRegistro, "numProcesso", $$v)
      },
      expression: "novoRegistro.numProcesso"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": "Nova Situação do Projeto",
      "items": _vm.listaSituacoesPossiveis,
      "item-text": "descricao",
      "item-value": "item",
      "max-height": "400",
      "return-object": "",
      "required": ""
    },
    model: {
      value: (_vm.novoRegistro.situacao),
      callback: function($$v) {
        _vm.$set(_vm.novoRegistro, "situacao", $$v)
      },
      expression: "novoRegistro.situacao"
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "justify-end"
  }, [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogAdicionar = false
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "dark": "",
      "disabled": !_vm.novoRegistro.dtEnvio || !_vm.novoRegistro.numRelatorio || !_vm.novoRegistro.numProcesso || !_vm.novoRegistro.situacao
    },
    on: {
      "click": _vm.registrarEnvio
    }
  }, [_vm._v("\n          Salvar\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Registros de Envio de Relatório de Projeto'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "ID do Projeto",
      "type": "number",
      "outlined": ""
    },
    model: {
      value: (_vm.idProjetoDigitado),
      callback: function($$v) {
        _vm.idProjetoDigitado = $$v
      },
      expression: "idProjetoDigitado"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-btn', {
    staticClass: "mt-4",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.buscarRegistros
    }
  }, [_vm._v("\n                Buscar Registros\n              ")])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-btn', {
    staticClass: "mt-4",
    attrs: {
      "color": "success",
      "disabled": !_vm.idProjetoDigitado || _vm.idProjetoDigitado != _vm.idProjetoBuscado
    },
    on: {
      "click": _vm.abrirDialogAdicionar
    }
  }, [_vm._v("\n                Adicionar Registro\n              ")])], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaRegistros,
      "no-data-text": 'Nenhum registro encontrado'
    },
    scopedSlots: _vm._u([{
      key: "item.dtEnvio",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n              " + _vm._s(_vm.formatarData(item.dtEnvio)) + "\n            ")]
      }
    }, {
      key: "item.acoes",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-btn', {
          attrs: {
            "icon": "",
            "small": "",
            "color": "primary",
            "disabled": _vm.idProjetoDigitado != _vm.idProjetoBuscado
          },
          on: {
            "click": function($event) {
              return _vm.editarRegistro(item)
            }
          }
        }, [_c('v-icon', [_vm._v("edit")])], 1), _vm._v(" "), _c('v-btn', {
          attrs: {
            "icon": "",
            "small": "",
            "color": "red",
            "disabled": _vm.idProjetoDigitado != _vm.idProjetoBuscado
          },
          on: {
            "click": function($event) {
              return _vm.excluirRegistro(item)
            }
          }
        }, [_c('v-icon', [_vm._v("delete")])], 1)]
      }
    }])
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(740),
  /* template */
  __webpack_require__(741),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_confirm_dialog__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_confirm_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_c_confirm_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_textarea__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_c_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_c_readonly_field__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_c_readonly_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_c_readonly_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto', 'idRelatorio'],
  data: function data() {
    return {
      relatorio: {},
      submissao: {},
      dialogSubmeterRelatorioAprovacao: false,
      formularioValido: false,
      regrasBasicas: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    botaoSubmeterRelatorioAprovacao: function botaoSubmeterRelatorioAprovacao() {
      this.dialogSubmeterRelatorioAprovacao = true;
    },
    cancelar: function cancelar() {
      this.$router.push({ name: 'RelatoriosProjeto', params: { idProjeto: this.idProjeto } });
    },
    submeterRelatorioAprovacao: function submeterRelatorioAprovacao() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Submetendo relatório de extensão para aprovação.' });
      __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].postSubmeterRelatorio(this.idProjeto, this.idRelatorio, this.submissao).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.$router.push({ name: 'RelatoriosProjeto', params: { idProjeto: _this.idProjeto } });
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Submetendo relatório de extensão para aprovação.' });
      });
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    // Carrega o relatório.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando relatório de extensão.' });
    __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].getRelatorioExtensao(this.idProjeto, this.idRelatorio).then(function (response) {
      _this2.relatorio = response.data;
      _this2.relatorio.dtInicialFormatada = __WEBPACK_IMPORTED_MODULE_7__utils_dates__["a" /* default */].format(_this2.relatorio.dtInicial);
      _this2.relatorio.dtFinalFormatada = __WEBPACK_IMPORTED_MODULE_7__utils_dates__["a" /* default */].format(_this2.relatorio.dtFinal);
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
      _this2.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando relatório de extensão.' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar___default.a,
    'c-date-menu': __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default.a,
    'c-textarea': __WEBPACK_IMPORTED_MODULE_4__components_c_textarea___default.a,
    'c-readonly-field': __WEBPACK_IMPORTED_MODULE_5__components_c_readonly_field___default.a,
    'c-confirm-dialog': __WEBPACK_IMPORTED_MODULE_1__components_c_confirm_dialog___default.a
  }
});

/***/ }),
/* 741 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('c-confirm-dialog', {
    attrs: {
      "titulo": "Submeter o relatório para aprovação?"
    },
    on: {
      "yes": function($event) {
        return _vm.submeterRelatorioAprovacao()
      }
    },
    model: {
      value: (_vm.dialogSubmeterRelatorioAprovacao),
      callback: function($$v) {
        _vm.dialogSubmeterRelatorioAprovacao = $$v
      },
      expression: "dialogSubmeterRelatorioAprovacao"
    }
  }, [_vm._v("\n    Submeter o relatório para aprovação nesta plataforma não garante o seu recebimento pela ProEx!\n    É necessário autuar um processo digital (com o espelho do relatório em anexo), \n    encaminhá-lo à ProEx (seguir o procedimento do Anexo II, disponível no Menu AJUDA deste portal) e aguardar deliberação da Câmara de Extensão.\n    Maiores informações entre em contato através do e-mail "), _c('a', {
    attrs: {
      "href": "mailto:suporte.proex@ufes.br"
    }
  }, [_vm._v("suporte.proex@ufes.br")]), _vm._v(".\n  ")]), _vm._v(" "), _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": "Submeter relatório técnico para aprovação"
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm11": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Título",
      "value": this.relatorio.tituloAcaoExtensao
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm11": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Número",
      "value": this.relatorio.numeroAcaoExtensao
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(this.relatorio.nomeCoordenador !== null) ? _c('c-readonly-field', {
    attrs: {
      "label": "Coordenador",
      "value": this.relatorio.nomeCoordenador
    }
  }) : _c('c-readonly-field', {
    attrs: {
      "label": "Coordenador",
      "value": "-"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm11": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Relatório",
      "value": 'Relatório Técnico de Extensão ' + _vm.relatorio.ordem
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm11": ""
    }
  }, [(_vm.relatorio.tipoRelatorioTecnicoItem === 1) ? _c('c-readonly-field', {
    attrs: {
      "label": "Tipo do relatório",
      "value": "Relatório Parcial: Deverá ser apresentado a cada 12 meses de atividade e encaminhado à ProEx no prazo máximo de 60 dias após o término do interstício."
    }
  }) : _vm._e(), _vm._v(" "), (_vm.relatorio.tipoRelatorioTecnicoItem === 2) ? _c('c-readonly-field', {
    attrs: {
      "label": "Tipo do relatório",
      "value": "Relatório Parcial com Renovação: Deverá ser apresentado no prazo máximo de até 60 dias do último interstício da ação indicando o período de renovação."
    }
  }) : _vm._e(), _vm._v(" "), (_vm.relatorio.tipoRelatorioTecnicoItem === 3) ? _c('c-readonly-field', {
    attrs: {
      "label": "Tipo do relatório",
      "value": "Relatório Final: Deverá ser apresentado no prazo máximo de até 60 dias após a data prevista de conclusão da ação extensionista ou do término das atividades, no caso de encerramento antes do previsto."
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.relatorio.tipoRelatorioTecnicoItem) ? _c('c-readonly-field', {
    attrs: {
      "label": "Tipo do relatório",
      "value": "-"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', [_vm._v("Período a que se refere o relatório")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md5": "",
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Início:",
      "value": _vm.relatorio.dtInicialFormatada
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md1": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md5": "",
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Fim:",
      "value": _vm.relatorio.dtFinalFormatada
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md1": ""
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.cancelar
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.botaoSubmeterRelatorioAprovacao()
      }
    }
  }, [_vm._v("Submeter")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(743),
  /* template */
  __webpack_require__(744),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_date_menu__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_date_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_date_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_textarea__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_readonly_field__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_readonly_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_c_readonly_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto', 'idRelatorio'],
  data: function data() {
    return {
      dialog: false,
      relatorio: {},
      aprovacao: {},
      observacao: '',
      formularioValido: false,
      regrasBasicas: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    cancelar: function cancelar() {
      this.$router.go(-1);
    },
    aprovar: function aprovar() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Aprovando relatório de extensão.' });
      __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].postAprovarRelatorio(this.idProjeto, this.idRelatorio, this.aprovacao).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.$router.push({ name: 'RelatoriosProjeto', params: { idProjeto: _this.idProjeto } });
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
        _this.dialog = false;
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Aprovando relatório de extensão.' });
      });
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    // Carrega o relatório.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando relatório de extensão.' });
    __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getRelatorioExtensao(this.idProjeto, this.idRelatorio).then(function (response) {
      _this2.relatorio = response.data;
      _this2.relatorio.dtInicialFormatada = __WEBPACK_IMPORTED_MODULE_6__utils_dates__["a" /* default */].format(_this2.relatorio.dtInicial);
      _this2.relatorio.dtFinalFormatada = __WEBPACK_IMPORTED_MODULE_6__utils_dates__["a" /* default */].format(_this2.relatorio.dtFinal);
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
      _this2.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando relatório de extensão.' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'c-date-menu': __WEBPACK_IMPORTED_MODULE_2__components_c_date_menu___default.a,
    'c-textarea': __WEBPACK_IMPORTED_MODULE_3__components_c_textarea___default.a,
    'c-readonly-field': __WEBPACK_IMPORTED_MODULE_4__components_c_readonly_field___default.a
  }
});

/***/ }),
/* 744 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": "Aprovar relatório técnico"
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-dialog', {
    attrs: {
      "width": "540"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n                    Confirma a aprovação do relatório técnico?\n                  ")]), _vm._v(" "), _c('v-card-text'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Não")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.aprovar
    }
  }, [_vm._v("Sim")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm11": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Título",
      "value": this.relatorio.tituloAcaoExtensao
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm11": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Número",
      "value": this.relatorio.numeroAcaoExtensao
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(this.relatorio.nomeCoordenador !== null) ? _c('c-readonly-field', {
    attrs: {
      "label": "Coordenador",
      "value": this.relatorio.nomeCoordenador
    }
  }) : _c('c-readonly-field', {
    attrs: {
      "label": "Coordenador",
      "value": "-"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm11": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Relatório",
      "value": 'Relatório Técnico de Extensão ' + _vm.relatorio.ordem
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm11": ""
    }
  }, [(_vm.relatorio.tipoRelatorioTecnicoItem === 1) ? _c('c-readonly-field', {
    attrs: {
      "label": "Tipo do relatório",
      "value": "Relatório Parcial: Deverá ser apresentado a cada 12 meses de atividade e encaminhado à ProEx no prazo máximo de 60 dias após o término do interstício."
    }
  }) : _vm._e(), _vm._v(" "), (_vm.relatorio.tipoRelatorioTecnicoItem === 2) ? _c('c-readonly-field', {
    attrs: {
      "label": "Tipo do relatório",
      "value": "Relatório Parcial com Renovação: Deverá ser apresentado no prazo máximo de até 60 dias do último interstício da ação indicando o período de renovação."
    }
  }) : _vm._e(), _vm._v(" "), (_vm.relatorio.tipoRelatorioTecnicoItem === 3) ? _c('c-readonly-field', {
    attrs: {
      "label": "Tipo do relatório",
      "value": "Relatório Final: Deverá ser apresentado no prazo máximo de até 60 dias após a data prevista de conclusão da ação extensionista ou do término das atividades, no caso de encerramento antes do previsto."
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.relatorio.tipoRelatorioTecnicoItem) ? _c('c-readonly-field', {
    attrs: {
      "label": "Tipo do relatório",
      "value": "-"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', [_vm._v("Período a que se refere o relatório")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md5": "",
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Início:",
      "value": _vm.relatorio.dtInicialFormatada
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md1": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md5": "",
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Fim:",
      "value": _vm.relatorio.dtFinalFormatada
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md1": ""
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-date-menu', {
    attrs: {
      "label": "Data de aprovação pela Câmara de Extensão*",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.aprovacao.dataAprovacaoRelatorioExtensao),
      callback: function($$v) {
        _vm.$set(_vm.aprovacao, "dataAprovacaoRelatorioExtensao", $$v)
      },
      expression: "aprovacao.dataAprovacaoRelatorioExtensao"
    }
  })], 1), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Processo*",
      "rules": _vm.regrasBasicas,
      "prepend-icon": "feed"
    },
    model: {
      value: (_vm.aprovacao.processo),
      callback: function($$v) {
        _vm.$set(_vm.aprovacao, "processo", $$v)
      },
      expression: "aprovacao.processo"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-textarea', {
    attrs: {
      "rows": 2,
      "auto-grow": true,
      "multi-line": "",
      "counter": "2000",
      "label": "Justificativa / Observação"
    },
    model: {
      value: (_vm.aprovacao.justificativaObservacao),
      callback: function($$v) {
        _vm.$set(_vm.aprovacao, "justificativaObservacao", $$v)
      },
      expression: "aprovacao.justificativaObservacao"
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.cancelar
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        _vm.dialog = true
      }
    }
  }, [_vm._v("Aprovar")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(746),
  /* template */
  __webpack_require__(747),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_date_menu__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_date_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_date_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_textarea__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_readonly_field__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_readonly_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_c_readonly_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto', 'idRelatorio'],
  data: function data() {
    return {
      dialog: false,
      relatorio: {},
      devolucao: {},
      observacao: '',
      formularioValido: false,
      regrasBasicas: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    cancelar: function cancelar() {
      this.$router.go(-1);
    },
    devolver: function devolver() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Devolvendo relatório de extensão.' });
      __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].postDevolverRelatorio(this.idProjeto, this.idRelatorio, this.devolucao).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.$router.push({ name: 'RelatoriosProjeto', params: { idProjeto: _this.idProjeto } });
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
        _this.dialog = false;
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Devolvendo relatório de extensão.' });
      });
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    // Carrega o relatório.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando relatório de extensão.' });
    __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getRelatorioExtensao(this.idProjeto, this.idRelatorio).then(function (response) {
      _this2.relatorio = response.data;
      _this2.relatorio.dtInicialFormatada = __WEBPACK_IMPORTED_MODULE_6__utils_dates__["a" /* default */].format(_this2.relatorio.dtInicial);
      _this2.relatorio.dtFinalFormatada = __WEBPACK_IMPORTED_MODULE_6__utils_dates__["a" /* default */].format(_this2.relatorio.dtFinal);
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
      _this2.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando relatório de extensão.' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'c-date-menu': __WEBPACK_IMPORTED_MODULE_2__components_c_date_menu___default.a,
    'c-textarea': __WEBPACK_IMPORTED_MODULE_3__components_c_textarea___default.a,
    'c-readonly-field': __WEBPACK_IMPORTED_MODULE_4__components_c_readonly_field___default.a
  }
});

/***/ }),
/* 747 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": "Devolver relatório técnico para o coordenador"
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-dialog', {
    attrs: {
      "width": "540"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n                    Confirma a devolução do relatório técnico?\n                  ")]), _vm._v(" "), _c('v-card-text'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Não")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.devolver
    }
  }, [_vm._v("Sim")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm11": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Título",
      "value": this.relatorio.tituloAcaoExtensao
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm11": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Número",
      "value": this.relatorio.numeroAcaoExtensao
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(this.relatorio.nomeCoordenador !== null) ? _c('c-readonly-field', {
    attrs: {
      "label": "Coordenador",
      "value": this.relatorio.nomeCoordenador
    }
  }) : _c('c-readonly-field', {
    attrs: {
      "label": "Coordenador",
      "value": "-"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm11": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Relatório",
      "value": 'Relatório Técnico de Extensão ' + _vm.relatorio.ordem
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm11": ""
    }
  }, [(_vm.relatorio.tipoRelatorioTecnicoItem === 1) ? _c('c-readonly-field', {
    attrs: {
      "label": "Tipo do relatório",
      "value": "Relatório Parcial: Deverá ser apresentado a cada 12 meses de atividade e encaminhado à ProEx no prazo máximo de 60 dias após o término do interstício."
    }
  }) : _vm._e(), _vm._v(" "), (_vm.relatorio.tipoRelatorioTecnicoItem === 2) ? _c('c-readonly-field', {
    attrs: {
      "label": "Tipo do relatório",
      "value": "Relatório Parcial com Renovação: Deverá ser apresentado no prazo máximo de até 60 dias do último interstício da ação indicando o período de renovação."
    }
  }) : _vm._e(), _vm._v(" "), (_vm.relatorio.tipoRelatorioTecnicoItem === 3) ? _c('c-readonly-field', {
    attrs: {
      "label": "Tipo do relatório",
      "value": "Relatório Final: Deverá ser apresentado no prazo máximo de até 60 dias após a data prevista de conclusão da ação extensionista ou do término das atividades, no caso de encerramento antes do previsto."
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.relatorio.tipoRelatorioTecnicoItem) ? _c('c-readonly-field', {
    attrs: {
      "label": "Tipo do relatório",
      "value": "-"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', [_vm._v("Período a que se refere o relatório")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md5": "",
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Início:",
      "value": _vm.relatorio.dtInicialFormatada
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md1": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md5": "",
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Fim:",
      "value": _vm.relatorio.dtFinalFormatada
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md1": ""
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-textarea', {
    attrs: {
      "rows": 2,
      "auto-grow": true,
      "multi-line": "",
      "counter": "2000",
      "required": "",
      "label": "Justificativa / Observação"
    },
    model: {
      value: (_vm.devolucao.justificativaObservacao),
      callback: function($$v) {
        _vm.$set(_vm.devolucao, "justificativaObservacao", $$v)
      },
      expression: "devolucao.justificativaObservacao"
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.cancelar
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        _vm.dialog = true
      }
    }
  }, [_vm._v("Devolver")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(749),
  /* template */
  __webpack_require__(750),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_date_menu__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_date_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_date_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_textarea__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_readonly_field__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_readonly_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_c_readonly_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto', 'idRelatorio'],
  data: function data() {
    return {
      dialog: false,
      relatorio: {},
      reprovacao: {},
      observacao: '',
      formularioValido: false,
      regrasBasicas: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    cancelar: function cancelar() {
      this.$router.go(-1);
    },
    reprovar: function reprovar() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Reprovando relatório de extensão.' });
      __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].postReprovarRelatorio(this.idProjeto, this.idRelatorio, this.reprovacao).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.$router.push({ name: 'RelatoriosProjeto', params: { idProjeto: _this.idProjeto } });
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
        _this.dialog = false;
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Reprovando relatório de extensão.' });
      });
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    // Carrega o relatório.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando relatório de extensão.' });
    __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getRelatorioExtensao(this.idProjeto, this.idRelatorio).then(function (response) {
      _this2.relatorio = response.data;
      _this2.relatorio.dtInicialFormatada = __WEBPACK_IMPORTED_MODULE_6__utils_dates__["a" /* default */].format(_this2.relatorio.dtInicial);
      _this2.relatorio.dtFinalFormatada = __WEBPACK_IMPORTED_MODULE_6__utils_dates__["a" /* default */].format(_this2.relatorio.dtFinal);
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
      _this2.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando relatório de extensão.' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'c-date-menu': __WEBPACK_IMPORTED_MODULE_2__components_c_date_menu___default.a,
    'c-textarea': __WEBPACK_IMPORTED_MODULE_3__components_c_textarea___default.a,
    'c-readonly-field': __WEBPACK_IMPORTED_MODULE_4__components_c_readonly_field___default.a
  }
});

/***/ }),
/* 750 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": "Reprovar relatório técnico"
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-dialog', {
    attrs: {
      "width": "540"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n                    Confirma a reprovação do relatório técnico?\n                  ")]), _vm._v(" "), _c('v-card-text'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Não")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.reprovar
    }
  }, [_vm._v("Sim")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm11": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Título",
      "value": this.relatorio.tituloAcaoExtensao
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm11": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Número",
      "value": this.relatorio.numeroAcaoExtensao
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(this.relatorio.nomeCoordenador !== null) ? _c('c-readonly-field', {
    attrs: {
      "label": "Coordenador",
      "value": this.relatorio.nomeCoordenador
    }
  }) : _c('c-readonly-field', {
    attrs: {
      "label": "Coordenador",
      "value": "-"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm11": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Relatório",
      "value": 'Relatório Técnico de Extensão ' + _vm.relatorio.ordem
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm11": ""
    }
  }, [(_vm.relatorio.tipoRelatorioTecnicoItem === 1) ? _c('c-readonly-field', {
    attrs: {
      "label": "Tipo do relatório",
      "value": "Relatório Parcial: Deverá ser apresentado a cada 12 meses de atividade e encaminhado à ProEx no prazo máximo de 60 dias após o término do interstício."
    }
  }) : _vm._e(), _vm._v(" "), (_vm.relatorio.tipoRelatorioTecnicoItem === 2) ? _c('c-readonly-field', {
    attrs: {
      "label": "Tipo do relatório",
      "value": "Relatório Parcial com Renovação: Deverá ser apresentado no prazo máximo de até 60 dias do último interstício da ação indicando o período de renovação."
    }
  }) : _vm._e(), _vm._v(" "), (_vm.relatorio.tipoRelatorioTecnicoItem === 3) ? _c('c-readonly-field', {
    attrs: {
      "label": "Tipo do relatório",
      "value": "Relatório Final: Deverá ser apresentado no prazo máximo de até 60 dias após a data prevista de conclusão da ação extensionista ou do término das atividades, no caso de encerramento antes do previsto."
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.relatorio.tipoRelatorioTecnicoItem) ? _c('c-readonly-field', {
    attrs: {
      "label": "Tipo do relatório",
      "value": "-"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', [_vm._v("Período a que se refere o relatório")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md5": "",
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Início:",
      "value": _vm.relatorio.dtInicialFormatada
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md1": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md5": "",
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Fim:",
      "value": _vm.relatorio.dtFinalFormatada
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md1": ""
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-date-menu', {
    attrs: {
      "label": "Data de reprovação pela Câmara de Extensão*",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.reprovacao.dataReprovacaoRelatorioExtensao),
      callback: function($$v) {
        _vm.$set(_vm.reprovacao, "dataReprovacaoRelatorioExtensao", $$v)
      },
      expression: "reprovacao.dataReprovacaoRelatorioExtensao"
    }
  })], 1), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Processo*",
      "rules": _vm.regrasBasicas,
      "prepend-icon": "feed"
    },
    model: {
      value: (_vm.reprovacao.processo),
      callback: function($$v) {
        _vm.$set(_vm.reprovacao, "processo", $$v)
      },
      expression: "reprovacao.processo"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-textarea', {
    attrs: {
      "rows": 2,
      "auto-grow": true,
      "multi-line": "",
      "counter": "2000",
      "required": "",
      "label": "Justificativa / Observação"
    },
    model: {
      value: (_vm.reprovacao.justificativaObservacao),
      callback: function($$v) {
        _vm.$set(_vm.reprovacao, "justificativaObservacao", $$v)
      },
      expression: "reprovacao.justificativaObservacao"
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.cancelar
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        _vm.dialog = true
      }
    }
  }, [_vm._v("Reprovar")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(752)
  __webpack_require__(753)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(754),
  /* template */
  __webpack_require__(755),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-56b87bbe",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 752 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 753 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_readonly_field__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_readonly_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_c_readonly_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto', 'idRelatorioExtensao'],
  data: function data() {
    return {
      dates: __WEBPACK_IMPORTED_MODULE_3__utils_dates__["a" /* default */],
      projeto: {
        classificacoesPrimariaSecundaria: [{}, {}]
      },
      relatorioExtensao: {
        mudancaDatasAcao: false,
        dataInicio: null,
        dataConclusao: null

      },
      tipoRelatorioTecnicoItemInicial: 0,
      obrigatorio: [function (v) {
        return !!v || 'Este campo é obrigatório';
      }],
      rules500: [function (input) {
        return input.length <= 500 || 'Este campo não pode possuir mais que 500 caracteres';
      }],
      formularioValido: false
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])('auth', ['administrador']), {
    cursoOuEvento: function cursoOuEvento() {
      return this.projeto.classificacaoSecundaria.id === 39729 || this.projeto.classificacaoSecundaria.id === 44194 || this.projeto.classificacaoSecundaria.id === 44195 || this.projeto.classificacaoSecundaria.id === 39730;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    // Verifica se o preenchimento do relatório final está habilitado para ações de extensão com registro tardio.
    relatorioHabilitadoAcaoRegistroTardio: function relatorioHabilitadoAcaoRegistroTardio() {
      if (this.projeto.relatorioFinalHabilitado === true) {
        return true;
      } else {
        return false;
      }
    },
    // Cria um novo relatório técnico.
    novoRelatorioTecnicoExtensao: function novoRelatorioTecnicoExtensao() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Adicionando relatório técnico de extensão.' });
      __WEBPACK_IMPORTED_MODULE_4__utils_projetos__["a" /* default */].postRelatorioExtensao(this.idProjeto, this.relatorioExtensao).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.$router.push({ name: 'RelatoriosProjeto', params: { idProjeto: _this.idProjeto } });
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Adicionando relatório técnico de extensão.' });
      });
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    // Carrega informações da ação de extensão.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ação de extensão.' });
    __WEBPACK_IMPORTED_MODULE_4__utils_projetos__["a" /* default */].getProjeto(this.idProjeto).then(function (response) {
      _this2.projeto = response.data;
      _this2.relatorioExtensao.dataInicio = _this2.projeto.dataInicio;
      _this2.relatorioExtensao.dataConclusao = _this2.projeto.dataConclusao;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ação de extensão.' });
    });
  },
  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar___default.a,
    'c-readonly-field': __WEBPACK_IMPORTED_MODULE_1__components_c_readonly_field___default.a
  }
});

/***/ }),
/* 755 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Novo Relatório Técnico de Extensão'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    staticClass: "alertaEdicao",
    attrs: {
      "dense": "",
      "type": "info",
      "color": "#00796b",
      "outlined": ""
    }
  }, [_vm._v("\n                Em caso de dúvidas ou sugestões entrar em contato pelo e-mail "), _c('a', {
    attrs: {
      "href": "mailto:suporte.proex@ufes.br"
    }
  }, [_vm._v("suporte.proex@ufes.br")]), _vm._v(". Já em caso de problemas com o sistema\n                entrar em contato pelo "), _c('a', {
    attrs: {
      "href": "https://redmine.ufes.br/projects/suporte-projetos-extensao/issues/new",
      "target": "_blank"
    }
  }, [_vm._v("Sistema de Suporte")]), _vm._v(".\n              ")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(this.projeto.titulo !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Título",
      "value": this.projeto.titulo
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Título",
      "value": "-"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(this.projeto.nomeCoordenador !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Nome do coordenador",
      "value": this.projeto.nomeCoordenador
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Nome do coordenador",
      "value": "-"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [(this.projeto.idProjeto !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Número",
      "value": this.projeto.idProjeto
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Número",
      "value": "-"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [(this.projeto.classificacaoSecundaria.descricao !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Tipo",
      "value": this.projeto.classificacaoSecundaria.descricao
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Tipo",
      "value": "-"
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [(_vm.projeto.classificacaoSecundaria.id === 39729 || _vm.projeto.classificacaoSecundaria.id === 44194 || _vm.projeto.classificacaoSecundaria.id === 44195 || _vm.projeto.classificacaoSecundaria.id === 39730) ? _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "v-radio-group_label, item",
    attrs: {
      "id": "v-radio-group_label",
      "mandatory": true,
      "label": "Tipo do relatório"
    },
    model: {
      value: (_vm.relatorioExtensao.tipoRelatorioTecnicoItem),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "tipoRelatorioTecnicoItem", $$v)
      },
      expression: "relatorioExtensao.tipoRelatorioTecnicoItem"
    }
  }, [_c('v-radio', {
    staticClass: "opcaoRadio",
    attrs: {
      "value": 3,
      "label": "Relatório Final: Deverá ser apresentado no prazo máximo de até 60 dias após a data prevista de conclusão da ação extensionista ou do término das atividades, no caso de encerramento antes do previsto."
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.relatorioHabilitadoAcaoRegistroTardio() === false) ? _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "v-radio-group_label, item",
    attrs: {
      "id": "v-radio-group_label",
      "mandatory": true,
      "label": "Houve mudança nas datas de início e/ou de conclusão da ação de extensão?"
    },
    model: {
      value: (_vm.relatorioExtensao.mudancaDatasAcao),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "mudancaDatasAcao", $$v)
      },
      expression: "relatorioExtensao.mudancaDatasAcao"
    }
  }, [_c('v-radio', {
    staticClass: "opcaoRadio",
    attrs: {
      "label": "Sim",
      "value": true
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "opcaoRadio",
    attrs: {
      "label": "Não",
      "value": false
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.relatorioExtensao.mudancaDatasAcao === true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('br'), _vm._v(" "), _c('label', {
    staticClass: "textoConfirmaMudancaDatas"
  }, [_vm._v("Confirme as datas de início e de conclusão da ação de\n                      extensão")])])], 1) : _vm._e(), _vm._v(" "), (_vm.relatorioExtensao.mudancaDatasAcao === true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Data de início",
      "type": "date",
      "required": "",
      "prepend-icon": "event"
    },
    model: {
      value: (_vm.relatorioExtensao.dataInicio),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "dataInicio", $$v)
      },
      expression: "relatorioExtensao.dataInicio"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Data de conclusão",
      "type": "date",
      "required": "",
      "prepend-icon": "event"
    },
    model: {
      value: (_vm.relatorioExtensao.dataConclusao),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "dataConclusao", $$v)
      },
      expression: "relatorioExtensao.dataConclusao"
    }
  })], 1), _vm._v(" "), _c('v-spacer')], 1) : _vm._e(), _vm._v(" "), (_vm.relatorioExtensao.mudancaDatasAcao === true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('br'), _vm._v(" "), _c('label', {
    staticClass: "item"
  }, [_vm._v("Justifique a mudança")]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "rows": "1",
      "auto-grow": "",
      "counter": "500",
      "rules": _vm.obrigatorio.concat( _vm.rules500)
    },
    model: {
      value: (_vm.relatorioExtensao.justificativaMudancaDatasAcao),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "justificativaMudancaDatasAcao", $$v)
      },
      expression: "relatorioExtensao.justificativaMudancaDatasAcao"
    }
  })], 1)], 1) : _vm._e()], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.projeto.classificacaoSecundaria.id === 39733 || _vm.projeto.classificacaoSecundaria.id === 39734 || _vm.projeto.classificacaoSecundaria.id === 39731) ? _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "v-radio-group_label, item",
    attrs: {
      "id": "v-radio-group_label",
      "mandatory": true,
      "label": "Tipo do relatório"
    },
    model: {
      value: (_vm.relatorioExtensao.tipoRelatorioTecnicoItem),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "tipoRelatorioTecnicoItem", $$v)
      },
      expression: "relatorioExtensao.tipoRelatorioTecnicoItem"
    }
  }, [_c('v-radio', {
    attrs: {
      "value": 2,
      "label": "Relatório Parcial com Renovação: Deverá ser apresentado no prazo máximo de até 60 dias do último interstício da ação indicando o período de renovação."
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.relatorioExtensao.tipoRelatorioTecnicoItem === 2) ? _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', [_vm._v("*Em caso de \"Relatório Parcial com Renovação\", é necessária a atualização das atividades e\n                      outras informações relativas ao novo interstício de execução da ação.")])])], 1), _vm._v(" "), _c('br')], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('br'), _vm._v(" "), _c('label', {
    staticClass: "textoInformaPeriodoRelatorio"
  }, [_vm._v("Informe o período a que se refere o relatório")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Início",
      "type": "date",
      "required": "",
      "prepend-icon": "event"
    },
    model: {
      value: (_vm.relatorioExtensao.dataInicial),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "dataInicial", $$v)
      },
      expression: "relatorioExtensao.dataInicial"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Fim",
      "type": "date",
      "required": "",
      "prepend-icon": "event"
    },
    model: {
      value: (_vm.relatorioExtensao.dataFinal),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "dataFinal", $$v)
      },
      expression: "relatorioExtensao.dataFinal"
    }
  })], 1), _vm._v(" "), _c('v-spacer')], 1)], 1) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": _vm.novoRelatorioTecnicoExtensao
    }
  }, [_vm._v("Adicionar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(757)
  __webpack_require__(758)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(759),
  /* template */
  __webpack_require__(766),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1355b276",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 757 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 758 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_checkbox_table__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_checkbox_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_c_checkbox_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_date_menu__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_date_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_date_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu_no_icon__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu_no_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_date_menu_no_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_readonly_field__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_readonly_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_c_readonly_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_c_solo_text_field__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_c_solo_text_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_c_solo_text_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_assessor__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_situacaoAtividade__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto', 'idRelatorioExtensao'],
  data: function data() {
    return {
      dates: __WEBPACK_IMPORTED_MODULE_8__utils_dates__["a" /* default */],
      formatAssessor: __WEBPACK_IMPORTED_MODULE_7__utils_assessor__["a" /* default */],
      situacaoAtividade: __WEBPACK_IMPORTED_MODULE_10__utils_situacaoAtividade__["a" /* default */],
      listaTipoRelatorio: [{ descricao: 'Parcial' }, { descricao: 'Final' }],
      listaTipoRelatorio2: [{ descricao: 'Final' }],
      listaArquivos: [],
      listaParcerias: [],
      listaArquivosSelecionados: [],
      listaParceriasSelecionadas: [],
      projeto: {
        classificacoesPrimariaSecundaria: [{}, {}]
      },
      rules750: [function (input) {
        return input.length <= 750 || 'Este campo não pode possuir mais que 750 caracteres';
      }],
      rules300: [function (input) {
        return input.length <= 300 || 'Este campo não pode possuir mais que 300 caracteres';
      }],
      rules1000: [function (input) {
        return input.length <= 1000 || 'Este campo não pode possuir mais que 1000 caracteres';
      }],
      rules500: [function (input) {
        return input.length <= 500 || 'Este campo não pode possuir mais que 500 caracteres';
      }],
      rules200: [function (input) {
        return input.length <= 200 || 'Este campo não pode possuir mais que 200 caracteres';
      }],
      numerico: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }, function (input) {
        return !isNaN(input) || 'Este campo deve ser numérico';
      }, function (input) {
        return input.length === 0 || Number(input) !== 0 || 'Este campo não pode ser nulo';
      }, function (input) {
        return input.length === 0 || Number(input) >= 0 || 'Este campo não pode ter valor negativo';
      }],
      foraDoPrazo: null,
      relatorioForaPrazo: false,
      relatorioExtensao: {},
      periodoRelatorio: {},
      tipoRelatorioTecnicoItemInicial: 0,
      dtInicialFormatada: '',
      dtFinalFormatada: '',
      dtAprovacaoFormatada: '',
      dtReprovacaoFormatada: '',
      formularioValido: false,
      search: null,
      headersIntegrantes: [{ text: 'Nome', align: 'left', value: 'nome' }, { text: 'Função', align: 'left', value: 'funcao.descricao' }, { text: 'Vínculo', align: 'left', value: 'vinculo' }, { text: 'CH semanal', align: 'left', value: 'cargaHoraria' }, { text: 'Data inicial', align: 'left', value: 'dataInicial' }, { text: 'Data final', align: 'left', value: 'dataFinal' }],
      headersParcerias: [{ checkbox: true, sortable: false, value: 'checkbox' }, { text: 'Nome do parceiro institucional/colaborador', align: 'left', value: 'nome' }, { text: 'Descrição da parceria/colaboração', align: 'left', value: 'detalhamento' }],
      headers: [{ checkbox: true, sortable: false, value: 'checkbox' }, { text: 'Nome', align: 'left', value: 'nome' }, { text: 'Tipo', align: 'left', value: 'tipoArquivo.descricao' }, { text: 'Descrição', left: 'left', value: 'observacao' }],
      opcoesPaginacao: [{ text: 'Todas', value: -1 }]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_11_vuex__["c" /* mapGetters */])('auth', ['administrador']), {
    cursoOuEvento: function cursoOuEvento() {
      return this.projeto.classificacaoSecundaria.id === 39729 || this.projeto.classificacaoSecundaria.id === 44194 || this.projeto.classificacaoSecundaria.id === 44195 || this.projeto.classificacaoSecundaria.id === 39730;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_11_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    salvarRelatorioExtensao: function salvarRelatorioExtensao(retorna) {
      console.log(this.listaArquivosSelecionados);
      console.log(this.listaParceriasSelecionadas);
      this.relatorioExtensao.listaRelatorioArquivo = [];
      this.relatorioExtensao.listaRelatorioParceria = [];
      for (var aux in this.listaArquivosSelecionados) {
        this.relatorioExtensao.listaRelatorioArquivo.push({ idArquivo: this.listaArquivosSelecionados[aux] });
      }
      for (var aux2 in this.listaParceriasSelecionadas) {
        this.relatorioExtensao.listaRelatorioParceria.push({ id: this.listaParceriasSelecionadas[aux2] });
      }

      // Limpa campo caso o item "1) A metodologia foi alterada para alcançar os objetivos da proposta inicial?" seja 'Não'.
      if (this.relatorioExtensao.opcao5 === 'N') {
        this.relatorioExtensao.texto1 = null;
      }

      // Limpa campos caso o item "9.1 - A ação de extensão recebeu apoio da ProEx?" seja 'Não'.
      if (this.relatorioExtensao.opcao1 === 'N') {
        this.relatorioExtensao.boolean1_1 = false;
        this.relatorioExtensao.boolean1_2 = false;
        this.relatorioExtensao.boolean1_3 = false;
        this.relatorioExtensao.boolean1_4 = false;
        this.relatorioExtensao.boolean1_5 = false;
        this.relatorioExtensao.boolean1_6 = false;
        this.relatorioExtensao.boolean1_7 = false;
        this.relatorioExtensao.boolean1_8 = false;
        this.relatorioExtensao.boolean1_9 = false;
        this.relatorioExtensao.boolean1_10 = false;
        this.relatorioExtensao.texto14 = null;
      }

      // Limpa valor do campo "Outros" do item 9.1.
      if (this.relatorioExtensao.boolean1_10 === false) {
        this.relatorioExtensao.texto14 = null;
      }

      // Limpa campos caso o item "9.2 - A ação de extensão recebeu apoio de outras instituições e/ou órgãos de fomento nacionais, internacionais ou estrangeiros?" seja 'Não'.
      if (this.relatorioExtensao.opcao2 === 'N') {
        this.relatorioExtensao.boolean2_1 = false;
        this.relatorioExtensao.boolean2_2 = false;
        this.relatorioExtensao.boolean2_3 = false;
        this.relatorioExtensao.boolean2_4 = false;
        this.relatorioExtensao.boolean2_5 = false;
        this.relatorioExtensao.boolean2_6 = false;
        this.relatorioExtensao.boolean2_7 = false;
        this.relatorioExtensao.boolean2_8 = false;
        this.relatorioExtensao.boolean2_9 = false;
        this.relatorioExtensao.boolean2_10 = false;
        this.relatorioExtensao.texto15 = null;
      }

      // Limpa valor do campo "Outros" do item 9.2.
      if (this.relatorioExtensao.boolean2_10 === false) {
        this.relatorioExtensao.texto15 = null;
      }

      // Limpa campos do item "9.3 - Os recursos financeiros indicados no(s) item(ns) 9.1 e/ou 9.2 foram executados por:".
      if ((this.relatorioExtensao.opcao1 === 'N' || this.relatorioExtensao.boolean1_6 === false) && (this.relatorioExtensao.opcao2 === 'N' || this.relatorioExtensao.boolean2_6 === false)) {
        this.relatorioExtensao.boolean3_1 = false;
        this.relatorioExtensao.boolean3_2 = false;
        this.relatorioExtensao.boolean3_3 = false;
        this.relatorioExtensao.boolean3_4 = false;
        this.relatorioExtensao.boolean3_5 = false;
        this.relatorioExtensao.boolean3_6 = false;
        this.relatorioExtensao.boolean3_7 = false;
        this.relatorioExtensao.valor3_1 = null;
        this.relatorioExtensao.valor3_2 = null;
        this.relatorioExtensao.valor3_3 = null;
        this.relatorioExtensao.valor3_4 = null;
        this.relatorioExtensao.valor3_5 = null;
        this.relatorioExtensao.valor3_6 = null;
        this.relatorioExtensao.valor3_7 = null;
        this.relatorioExtensao.texto16 = null;
      }

      // Limpa valor do campo "UFES" do item 9.3.
      if (this.relatorioExtensao.boolean3_1 === false) {
        this.relatorioExtensao.valor3_1 = null;
      }

      // Limpa valor do campo "CNPq" do item 9.3.
      if (this.relatorioExtensao.boolean3_2 === false) {
        this.relatorioExtensao.valor3_2 = null;
      }

      // Limpa valor do campo "CAPES" do item 9.3.
      if (this.relatorioExtensao.boolean3_3 === false) {
        this.relatorioExtensao.valor3_3 = null;
      }

      // Limpa valor do campo "FAPES" do item 9.3.
      if (this.relatorioExtensao.boolean3_4 === false) {
        this.relatorioExtensao.valor3_4 = null;
      }

      // Limpa valor do campo "FEST" do item 9.3.
      if (this.relatorioExtensao.boolean3_5 === false) {
        this.relatorioExtensao.valor3_5 = null;
      }

      // Limpa valor do campo "FUCAM" do item 9.3.
      if (this.relatorioExtensao.boolean3_6 === false) {
        this.relatorioExtensao.valor3_6 = null;
      }

      // Limpa valor do campo "Outros" do item 9.3.
      if (this.relatorioExtensao.boolean3_7 === false) {
        this.relatorioExtensao.texto16 = null;
        this.relatorioExtensao.valor3_7 = null;
      }

      // Limpa campos caso o item "10) Houve cobrança de taxa de inscrição, participação, visitação ou similar?" seja 'Não'.
      if (this.relatorioExtensao.opcao4 === 'N') {
        this.relatorioExtensao.boolean4_1 = false;
        this.relatorioExtensao.boolean4_2 = false;
        this.relatorioExtensao.boolean4_3 = false;
        this.relatorioExtensao.boolean4_4 = false;
        this.relatorioExtensao.valor4_1 = null;
        this.relatorioExtensao.valor4_2 = null;
        this.relatorioExtensao.valor4_3 = null;
        this.relatorioExtensao.valor4_4 = null;
        this.relatorioExtensao.texto17 = null;
      }

      // Limpa valor do campo "UFES" do item 10.
      if (this.relatorioExtensao.boolean4_1 === false) {
        this.relatorioExtensao.valor4_1 = null;
      }

      // Limpa valor do campo "FEST" do item 10.
      if (this.relatorioExtensao.boolean4_2 === false) {
        this.relatorioExtensao.valor4_2 = null;
      }

      // Limpa valor do campo "FUCAM" do item 10.
      if (this.relatorioExtensao.boolean4_3 === false) {
        this.relatorioExtensao.valor4_3 = null;
      }

      // Limpa valor do campo "Outros" do item 10.
      if (this.relatorioExtensao.boolean4_4 === false) {
        this.relatorioExtensao.texto17 = null;
        this.relatorioExtensao.valor4_4 = null;
      }

      // Limpa valor do campo "Apresentar justificativa para envio do relatório fora do prazo."
      if (this.relatorioForaPrazo === false || this.foraDoPrazo === false) {
        this.relatorioExtensao.justificativaForaPrazo = null;
      }

      // Edita o relatório técnico.
      this.editarRelatorioExtensao(retorna);
    },
    // Edita o relatório técnico.
    editarRelatorioExtensao: function editarRelatorioExtensao(retorna) {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Salvando relatório de extensão.' });
      __WEBPACK_IMPORTED_MODULE_9__utils_projetos__["a" /* default */].putRelatorioExtensao(this.idProjeto, this.idRelatorioExtensao, this.relatorioExtensao).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        if (retorna) {
          _this.$router.push({ name: 'RelatorioTecnico', params: { idProjeto: _this.idProjeto, idRelatorioExtensao: _this.idRelatorioExtensao } });
        }
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Salvando relatório de extensão.' });
      });
    },
    // Retorna a situação do relatório.
    getSituacaoRelatorio: function getSituacaoRelatorio(situacaoRelatorioTecnicoItem) {
      if (situacaoRelatorioTecnicoItem === 1) {
        return 'Em elaboração';
      } else if (situacaoRelatorioTecnicoItem === 2) {
        return 'Aguardando aprovação';
      } else if (situacaoRelatorioTecnicoItem === 3) {
        return 'Aprovado';
      } else if (situacaoRelatorioTecnicoItem === 4) {
        return 'Reprovado';
      } else {
        return 'Situação inválida';
      }
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    // Carrega a ação de extensão.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    __WEBPACK_IMPORTED_MODULE_9__utils_projetos__["a" /* default */].getProjeto(this.idProjeto).then(function (response) {
      _this2.projeto = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    });

    // Carrega o relatório.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando relatório.' });
    __WEBPACK_IMPORTED_MODULE_9__utils_projetos__["a" /* default */].getRelatorioExtensao(this.idProjeto, this.idRelatorioExtensao).then(function (response) {
      _this2.relatorioExtensao = response.data;
      _this2.tipoRelatorioTecnicoItemInicial = _this2.relatorioExtensao.tipoRelatorioTecnicoItem;
      _this2.dtInicialFormatada = __WEBPACK_IMPORTED_MODULE_8__utils_dates__["a" /* default */].format(_this2.relatorioExtensao.dtInicial);
      _this2.dtFinalFormatada = __WEBPACK_IMPORTED_MODULE_8__utils_dates__["a" /* default */].format(_this2.relatorioExtensao.dtFinal);
      _this2.dtAprovacaoFormatada = __WEBPACK_IMPORTED_MODULE_8__utils_dates__["a" /* default */].format(_this2.relatorioExtensao.dtAprovacaoRelatorio);
      _this2.dtReprovacaoFormatada = __WEBPACK_IMPORTED_MODULE_8__utils_dates__["a" /* default */].format(_this2.relatorioExtensao.dtReprovacaoRelatorio);
      _this2.listaArquivosSelecionados = [];
      _this2.listaParceriasSelecionadas = [];
      for (var aux in _this2.relatorioExtensao.listaRelatorioArquivo) {
        _this2.listaArquivosSelecionados.push(_this2.relatorioExtensao.listaRelatorioArquivo[aux].idArquivo);
      }
      for (var aux2 in _this2.relatorioExtensao.listaRelatorioParceria) {
        _this2.listaParceriasSelecionadas.push(_this2.relatorioExtensao.listaRelatorioParceria[aux2].id);
      }
      console.log(_this2.listaArquivosSelecionados);
      console.log(_this2.listaParceriasSelecionadas);
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando relatório.' });
    });

    // Carrega as parcerias da ação de extensão.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando parcerias.' });
    __WEBPACK_IMPORTED_MODULE_9__utils_projetos__["a" /* default */].getParceriasDoProjeto(this.idProjeto).then(function (response) {
      _this2.listaParcerias = response.data.slice();
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando parcerias.' });
    });

    // Carrega os arquivos da ação de extensão.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando arquivos.' });
    __WEBPACK_IMPORTED_MODULE_9__utils_projetos__["a" /* default */].getArquivosDoProjeto(this.idProjeto).then(function (response) {
      _this2.listaArquivos = response.data.slice();
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando arquivos.' });
    });

    // Endpoint que retorna se o relatório está fora do prazo para envio.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações adicionais.' });
    __WEBPACK_IMPORTED_MODULE_9__utils_projetos__["a" /* default */].getRelatorioTecnicoForaPrazo(this.idProjeto, this.idRelatorioExtensao).then(function (response) {
      _this2.relatorioForaPrazo = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações adicionais.' });
    });
  },
  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_6__components_toolbars_basic_toolbar___default.a,
    'c-date-menu': __WEBPACK_IMPORTED_MODULE_2__components_c_date_menu___default.a,
    'c-date-menu-no-icon': __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu_no_icon___default.a,
    'c-solo-text-field': __WEBPACK_IMPORTED_MODULE_5__components_c_solo_text_field___default.a,
    'c-readonly-field': __WEBPACK_IMPORTED_MODULE_4__components_c_readonly_field___default.a,
    'c-checkbox-table': __WEBPACK_IMPORTED_MODULE_1__components_c_checkbox_table___default.a
  }
});

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(761),
  /* template */
  __webpack_require__(762),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_dates__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['label', 'value', 'rules', 'clearable', 'required', 'disabled'],
  data: function data() {
    return {
      dates: __WEBPACK_IMPORTED_MODULE_0__utils_dates__["a" /* default */],
      data: '',
      dataFormatada: '',
      menuData: false
    };
  },
  watch: {
    value: function value(val) {
      if (!val) {
        this.data = '';
        this.dataFormatada = '';
      } else {
        this.data = val;
        this.dataFormatada = this.dates.format(val);
      }
    },
    dataFormatada: function dataFormatada(val) {
      if (val === null) {
        this.data = '';
        this.$emit('input', undefined);
      }
    }
  },
  methods: {
    setData: function setData() {
      this.$emit('input', this.data);
    }
  }
});

/***/ }),
/* 762 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-menu', {
    attrs: {
      "transition": "scroll-y-transition",
      "max-width": "290px",
      "offset-y": "",
      "close-on-content-click": false,
      "nudge-left": -40,
      "nudge-top": 25
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "label": _vm.label,
            "rules": _vm.rules,
            "clearable": _vm.clearable,
            "required": _vm.required,
            "readonly": "",
            "disabled": _vm.disabled
          },
          model: {
            value: (_vm.dataFormatada),
            callback: function($$v) {
              _vm.dataFormatada = $$v
            },
            expression: "dataFormatada"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.DataMenuNoIcon),
      callback: function($$v) {
        _vm.DataMenuNoIcon = $$v
      },
      expression: "DataMenuNoIcon"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "pt-br",
      "scrollable": "",
      "autosave": ""
    },
    on: {
      "input": function($event) {
        return _vm.setData()
      }
    },
    model: {
      value: (_vm.data),
      callback: function($$v) {
        _vm.data = $$v
      },
      expression: "data"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(764),
  /* template */
  __webpack_require__(765),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['label', 'value', 'counter', 'rules', 'clearable', 'required'],
  data: function data() {
    return {
      focus: false
    };
  },
  computed: {
    couterRules: function couterRules(val) {
      var _this = this;

      var area = [function (input) {
        return _this.required === undefined || !!input || 'Este campo é obrigatório';
      }, function (input) {
        return input == null || input.length <= _this.counter || 'Este campo não pode possuir mais que ' + _this.counter + ' caracteres';
      }];
      return area;
    }
  },
  methods: {
    setTexto: function setTexto(value) {
      this.$emit('input', value);
    }
  }
});

/***/ }),
/* 765 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', [_vm._v(_vm._s(_vm.label) + _vm._s(this.required !== undefined ? '*' : ''))]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "rows": 2,
      "auto-grow": true,
      "multi-line": "",
      "counter": _vm.counter,
      "rules": _vm.couterRules,
      "required": _vm.required,
      "value": _vm.value
    },
    on: {
      "input": _vm.setTexto
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 766 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Editar Relatório Técnico de Extensão ' + this.relatorioExtensao.ordem
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    staticClass: "alertaEdicao",
    attrs: {
      "dense": "",
      "type": "info",
      "color": "#00796b",
      "outlined": ""
    }
  }, [_vm._v("\n                  Em caso de dúvidas ou sugestões entrar em contato pelo e-mail "), _c('a', {
    attrs: {
      "href": "mailto:suporte.proex@ufes.br"
    }
  }, [_vm._v("suporte.proex@ufes.br")]), _vm._v(". Já em caso de problemas com o sistema\n                  entrar em contato pelo "), _c('a', {
    attrs: {
      "href": "https://redmine.ufes.br/projects/suporte-projetos-extensao/issues/new",
      "target": "_blank"
    }
  }, [_vm._v("Sistema de Suporte")]), _vm._v(".\n                ")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(this.relatorioExtensao.tituloAcaoExtensao !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Título",
      "value": this.relatorioExtensao.tituloAcaoExtensao
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Título",
      "value": "-"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(this.relatorioExtensao.nomeCoordenador !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Nome do coordenador",
      "value": this.relatorioExtensao.nomeCoordenador
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Nome do coordenador",
      "value": "-"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [(this.relatorioExtensao.numeroAcaoExtensao !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Número",
      "value": this.relatorioExtensao.numeroAcaoExtensao
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Número",
      "value": "-"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [(this.relatorioExtensao.tipoAcaoExtensao !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Tipo",
      "value": this.relatorioExtensao.tipoAcaoExtensao
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Tipo",
      "value": "-"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(this.relatorioExtensao.unidade !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Unidade",
      "value": this.relatorioExtensao.unidade
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Unidade",
      "value": "-"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(this.relatorioExtensao.emailCoordenador !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "E-mail do coordenador",
      "value": this.relatorioExtensao.emailCoordenador
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "E-mail do coordenador",
      "value": "-"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [(this.relatorioExtensao.liberacaoCargaHorariaCoordenador !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Liberação de carga horária do coordenador",
      "value": this.relatorioExtensao.liberacaoCargaHorariaCoordenador == true ? 'Sim' : 'Não'
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Liberação de carga horária do coordenador",
      "value": "-"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [(this.relatorioExtensao.cargaHorariaCoordenador !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Carga horária",
      "value": this.relatorioExtensao.cargaHorariaCoordenador
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Carga horária",
      "value": "-"
    }
  })], 1)], 1), _vm._v(" "), ((_vm.projeto.classificacaoSecundaria.id === 39729 || _vm.projeto.classificacaoSecundaria.id === 44194 || _vm.projeto.classificacaoSecundaria.id === 44195 || _vm.projeto.classificacaoSecundaria.id === 39730) && _vm.relatorioExtensao.tipoRelatorioTecnicoItem === 3) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(this.relatorioExtensao.mudancaDatasAcao !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Houve mudança nas datas de início e/ou de conclusão da ação de extensão?",
      "value": this.relatorioExtensao.mudancaDatasAcao === 'S' ? 'Sim' : 'Não'
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Houve mudança nas datas de início e/ou de conclusão da ação de extensão?",
      "value": "-"
    }
  })], 1), _vm._v(" "), (this.relatorioExtensao.mudancaDatasAcao === 'S') ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(this.relatorioExtensao.justificativaMudancaDatasAcao !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Justificativa",
      "value": this.relatorioExtensao.justificativaMudancaDatasAcao
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Justificativa",
      "value": "-"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "textoRelatorio"
  }, [_vm._v("Período a que se refere o relatório")])])], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.projeto.classificacaoSecundaria.id === 39729 || _vm.projeto.classificacaoSecundaria.id === 44194 || _vm.projeto.classificacaoSecundaria.id === 44195 || _vm.projeto.classificacaoSecundaria.id === 39730) ? _c('div', [(_vm.administrador === true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md5": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "date"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('span', {
          staticStyle: {
            "font-size": "1.25em"
          }
        }, [_vm._v("Início:")])]
      },
      proxy: true
    }], null, false, 3402234077),
    model: {
      value: (_vm.relatorioExtensao.dtInicial),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "dtInicial", $$v)
      },
      expression: "relatorioExtensao.dtInicial"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md1": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md5": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "date"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('span', {
          staticStyle: {
            "font-size": "1.25em"
          }
        }, [_vm._v("Fim:")])]
      },
      proxy: true
    }], null, false, 3049485968),
    model: {
      value: (_vm.relatorioExtensao.dtFinal),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "dtFinal", $$v)
      },
      expression: "relatorioExtensao.dtFinal"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md1": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.administrador === null || _vm.administrador === false) ? _c('v-layout', {
    attrs: {
      "row": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md5": "",
      "xs12": ""
    }
  }, [(_vm.dtInicialFormatada !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Início:",
      "value": _vm.dtInicialFormatada
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Início:",
      "value": "-"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md1": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md5": "",
      "xs12": ""
    }
  }, [(_vm.dtFinalFormatada !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Fim:",
      "value": _vm.dtFinalFormatada
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Fim:",
      "value": "-"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md1": ""
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.projeto.classificacaoSecundaria.id === 39733 || _vm.projeto.classificacaoSecundaria.id === 39734 || _vm.projeto.classificacaoSecundaria.id === 39731) ? _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md5": "",
      "xs12": ""
    }
  }, [(_vm.dtInicialFormatada !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Início:",
      "value": _vm.dtInicialFormatada
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Início:",
      "value": "-"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md1": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md5": "",
      "xs12": ""
    }
  }, [(_vm.dtFinalFormatada !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Fim:",
      "value": _vm.dtFinalFormatada
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Fim:",
      "value": "-"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md1": ""
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.relatorioExtensao.situacaoRelatorioTecnicoItem !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Situação do relatório",
      "value": _vm.getSituacaoRelatorio(_vm.relatorioExtensao.situacaoRelatorioTecnicoItem)
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Situação do relatório",
      "value": "-"
    }
  })], 1)], 1), _vm._v(" "), (_vm.relatorioExtensao.situacaoRelatorioTecnicoItem !== null && (_vm.relatorioExtensao.situacaoRelatorioTecnicoItem === 3 || _vm.relatorioExtensao.situacaoRelatorioTecnicoItem === 4)) ? _c('div', [(_vm.relatorioExtensao.situacaoRelatorioTecnicoItem !== null && _vm.relatorioExtensao.situacaoRelatorioTecnicoItem === 3) ? _c('div', [_c('br'), _vm._v(" "), (_vm.relatorioExtensao.situacaoRelatorioTecnicoItem !== null && _vm.relatorioExtensao.situacaoRelatorioTecnicoItem === 3) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.relatorioExtensao.dtAprovacaoRelatorio !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Data de aprovação do relatório pela Câmara de Extensão",
      "value": _vm.dtAprovacaoFormatada
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Data de aprovação do relatório pela Câmara de Extensão",
      "value": "-"
    }
  })], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.relatorioExtensao.situacaoRelatorioTecnicoItem !== null && _vm.relatorioExtensao.situacaoRelatorioTecnicoItem === 4) ? _c('div', [_c('br'), _vm._v(" "), (_vm.relatorioExtensao.situacaoRelatorioTecnicoItem !== null && _vm.relatorioExtensao.situacaoRelatorioTecnicoItem === 4) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.relatorioExtensao.dtReprovacaoRelatorio !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Data de reprovação do relatório pela Câmara de Extensão",
      "value": _vm.dtReprovacaoFormatada
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Data de reprovação do relatório pela Câmara de Extensão",
      "value": "-"
    }
  })], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.relatorioExtensao.processo !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Processo",
      "value": _vm.relatorioExtensao.processo
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Processo",
      "value": "-"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [(_vm.projeto.classificacaoSecundaria.id === 39729 || _vm.projeto.classificacaoSecundaria.id === 44194 || _vm.projeto.classificacaoSecundaria.id === 44195 || _vm.projeto.classificacaoSecundaria.id === 39730) ? _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "v-radio-group_label, item",
    attrs: {
      "id": "v-radio-group_label",
      "mandatory": true,
      "label": "Tipo do relatório"
    },
    model: {
      value: (_vm.relatorioExtensao.tipoRelatorioTecnicoItem),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "tipoRelatorioTecnicoItem", $$v)
      },
      expression: "relatorioExtensao.tipoRelatorioTecnicoItem"
    }
  }, [_c('v-radio', {
    staticClass: "opcaoRadio",
    attrs: {
      "value": 3,
      "label": "Relatório Final: Deverá ser apresentado no prazo máximo de até 60 dias após a data prevista de conclusão da ação extensionista ou do término das atividades, no caso de encerramento antes do previsto."
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('br')], 1) : _vm._e(), _vm._v(" "), (_vm.projeto.classificacaoSecundaria.id === 39733 || _vm.projeto.classificacaoSecundaria.id === 39734 || _vm.projeto.classificacaoSecundaria.id === 39731) ? _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "v-radio-group_label, item",
    attrs: {
      "id": "v-radio-group_label",
      "mandatory": true,
      "label": "Tipo do relatório"
    },
    model: {
      value: (_vm.relatorioExtensao.tipoRelatorioTecnicoItem),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "tipoRelatorioTecnicoItem", $$v)
      },
      expression: "relatorioExtensao.tipoRelatorioTecnicoItem"
    }
  }, [_c('v-radio', {
    attrs: {
      "value": 2,
      "label": "Relatório Parcial com Renovação: Deverá ser apresentado no prazo máximo de até 60 dias do último interstício da ação indicando o período de renovação."
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.relatorioExtensao.tipoRelatorioTecnicoItem === 2) ? _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', [_vm._v("*Em caso de \"Relatório Parcial com Renovação\", é necessária a atualização das atividades e\n                      outras informações relativas ao novo interstício de execução da ação.")])])], 1), _vm._v(" "), _c('br')], 1) : _vm._e(), _vm._v(" "), (_vm.relatorioExtensao.tipoRelatorioTecnicoItem === 2) ? _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md5": "",
      "xs12": ""
    }
  }, [_c('br'), _vm._v(" "), _c('label', {
    staticClass: "item"
  }, [_vm._v("Nova data de conclusão da ação de extensão:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "type": "date",
      "max-height": "20"
    },
    model: {
      value: (_vm.relatorioExtensao.dtNovaConclusao),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "dtNovaConclusao", $$v)
      },
      expression: "relatorioExtensao.dtNovaConclusao"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.relatorioForaPrazo === true || _vm.foraDoPrazo === true) ? _c('div', [_c('br')]) : _vm._e(), _vm._v(" "), (_vm.relatorioForaPrazo === true || _vm.foraDoPrazo === true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "item"
  }, [_vm._v("Apresentar justificativa para envio do relatório fora do prazo:")]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "rows": "1",
      "auto-grow": "",
      "counter": "500",
      "rules": _vm.rules500
    },
    model: {
      value: (_vm.relatorioExtensao.justificativaForaPrazo),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "justificativaForaPrazo", $$v)
      },
      expression: "relatorioExtensao.justificativaForaPrazo"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "v-radio-group_label, item",
    attrs: {
      "label": "1) A metodologia foi alterada para alcançar os objetivos da proposta inicial?",
      "id": "v-radio-group_label"
    },
    model: {
      value: (_vm.relatorioExtensao.opcao5),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "opcao5", $$v)
      },
      expression: "relatorioExtensao.opcao5"
    }
  }, [_c('v-radio', {
    staticClass: "opcaoRadio",
    attrs: {
      "label": "Sim",
      "value": "S"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "opcaoRadio",
    attrs: {
      "label": "Não",
      "value": "N"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.relatorioExtensao.opcao5 === 'S') ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "textoRelatorio"
  }, [_vm._v("Apresente sucintamente as alterações implementadas:")]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "disabled": _vm.relatorioExtensao.opcao5 !== 'S',
      "rows": "1",
      "auto-grow": "",
      "counter": "750",
      "rules": _vm.rules750
    },
    model: {
      value: (_vm.relatorioExtensao.texto1),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "texto1", $$v)
      },
      expression: "relatorioExtensao.texto1"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "item"
  }, [_vm._v("2) Local de execução da ação:")]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "rows": "1",
      "auto-grow": "",
      "counter": "300",
      "rules": _vm.rules300
    },
    model: {
      value: (_vm.relatorioExtensao.texto2),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "texto2", $$v)
      },
      expression: "relatorioExtensao.texto2"
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "item"
  }, [_vm._v("3) Informar o quantitativo total de indivíduos beneficiados no período deste\n                    relatório")]), _vm._v(" "), _c('v-alert', {
    staticClass: "alertaEdicao",
    attrs: {
      "dense": "",
      "type": "info",
      "color": "#00796b",
      "outlined": ""
    }
  }, [_vm._v("\n                    Solicitamos atenção para que os registros de público-alvo reflitam a veracidade dos dados.\n                  ")])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "textoRelatorio"
  }, [_vm._v("3.1 - Público-alvo direto (público concretamente registrado):")]), _vm._v(" "), _c('v-text-field-integer', {
    attrs: {
      "rules": _vm.numerico
    },
    model: {
      value: (_vm.relatorioExtensao.publicoAlvoDireto),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "publicoAlvoDireto", $$v)
      },
      expression: "relatorioExtensao.publicoAlvoDireto"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "textoRelatorio"
  }, [_vm._v("3.2 - Público-alvo indireto (estimativa de público atingido\n                    indiretamente):")]), _vm._v(" "), _c('v-text-field-integer', {
    attrs: {
      "rules": _vm.numerico
    },
    model: {
      value: (_vm.relatorioExtensao.publicoAlvoIndireto),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "publicoAlvoIndireto", $$v)
      },
      expression: "relatorioExtensao.publicoAlvoIndireto"
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "item"
  }, [_vm._v("4) Atividades e resultados")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, _vm._l((_vm.relatorioExtensao.listaRelatorioAtividade), function(item, i) {
    return _c('v-col', {
      key: i
    }, [_c('v-card', {
      attrs: {
        "outlined": ""
      }
    }, [_c('v-card-text', [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "text-xs-left": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('c-readonly-field', {
      staticClass: "textoRelatorio",
      attrs: {
        "label": "Nome e descrição sucinta da atividade",
        "value": item.descricao
      }
    }), _vm._v(" "), (item.detalhamento !== null && item.detalhamento !== '') ? _c('c-readonly-field', {
      staticClass: "textoRelatorio",
      attrs: {
        "value": item.detalhamento
      }
    }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "text-xs-left": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('c-readonly-field', {
      staticClass: "textoRelatorio",
      attrs: {
        "label": "Principal objetivo específico ao qual esta atividade está vinculada",
        "value": item.objetivoEspecifico !== null && item.objetivoEspecifico !== '' ? item.objetivoEspecifico : '-'
      }
    })], 1)], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "text-xs-left": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [(item.situacaoAtividade !== null) ? _c('c-readonly-field', {
      staticClass: "textoRelatorio",
      attrs: {
        "label": "Situação",
        "value": _vm.situacaoAtividade.format(item.situacaoAtividade.item)
      }
    }) : _vm._e(), _vm._v(" "), (item.situacaoAtividade === null) ? _c('c-readonly-field', {
      staticClass: "textoRelatorio",
      attrs: {
        "label": "Situação",
        "value": "-"
      }
    }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "text-xs-left": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "md5": "",
        "xs12": ""
      }
    }, [_c('c-readonly-field', {
      staticClass: "textoRelatorio",
      attrs: {
        "label": "Início efetivo",
        "value": _vm.dates.format(item.dtInicioEfetivo)
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "md1": ""
      }
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "md5": "",
        "xs12": ""
      }
    }, [_c('c-readonly-field', {
      staticClass: "textoRelatorio",
      attrs: {
        "label": "Conclusão efetiva",
        "value": _vm.dates.format(item.dtFimEfetivo)
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "md1": ""
      }
    })], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "text-xs-left": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('c-readonly-field', {
      staticClass: "textoRelatorio",
      attrs: {
        "label": "Resultados",
        "value": item.resultados !== null && item.resultados !== '' ? item.resultados : '-'
      }
    })], 1)], 1)], 1)], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "item"
  }, [_vm._v("5) Discutir de forma geral a relevância das atividades, seu mérito extensionista,\n                    impacto, abrangência social, interdisciplinaridade e visibilidade:")]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "rows": "1",
      "auto-grow": "",
      "counter": "1000",
      "rules": _vm.rules1000
    },
    model: {
      value: (_vm.relatorioExtensao.texto4),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "texto4", $$v)
      },
      expression: "relatorioExtensao.texto4"
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "item"
  }, [_vm._v("6) Descrever de que maneira a ação de extensão contribuiu para a formação do aluno\n                    de graduação integrante da equipe:")]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "rows": "1",
      "auto-grow": "",
      "counter": "500",
      "rules": _vm.rules500
    },
    model: {
      value: (_vm.relatorioExtensao.texto5),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "texto5", $$v)
      },
      expression: "relatorioExtensao.texto5"
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "item"
  }, [_vm._v("7) Relacionar os fatores que interferiram na execução da ação")])])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "textoRelatorio"
  }, [_vm._v("7.1 - Positivos:")]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "rows": "1",
      "auto-grow": "",
      "counter": "500",
      "rules": _vm.rules500
    },
    model: {
      value: (_vm.relatorioExtensao.texto6),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "texto6", $$v)
      },
      expression: "relatorioExtensao.texto6"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "textoRelatorio"
  }, [_vm._v("7.2 - Negativos:")]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "rows": "1",
      "auto-grow": "",
      "counter": "500",
      "rules": _vm.rules500
    },
    model: {
      value: (_vm.relatorioExtensao.texto7),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "texto7", $$v)
      },
      expression: "relatorioExtensao.texto7"
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "item"
  }, [_vm._v("8) Equipe.")])])], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "tabela",
    attrs: {
      "headers": _vm.headersIntegrantes,
      "items": _vm.relatorioExtensao.listaRelatorioParticipante,
      "items-per-page": -1,
      "hide-default-footer": "",
      "header-props": {
        sortIcon: null
      },
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "item.assessor",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.formatAssessor.format(props.item.assessor,
          props.item.funcao.item)))]
      }
    }, {
      key: "item.dataInicial",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dataInicial)))]
      }
    }, {
      key: "item.dataFinal",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dataFinal)))]
      }
    }])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "item"
  }, [_vm._v("9) Formas de apoio")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "v-radio-group_label",
    attrs: {
      "id": "v-radio-group_label_9",
      "label": "9.1 - A ação de extensão recebeu apoio da ProEx?"
    },
    model: {
      value: (_vm.relatorioExtensao.opcao1),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "opcao1", $$v)
      },
      expression: "relatorioExtensao.opcao1"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Sim",
      "value": "S"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Não",
      "value": "N"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.relatorioExtensao.opcao1 === 'S') ? _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "textoRelatorioSubitem"
  }, [_vm._v("Especifique a(s) forma(s) de apoio:")])])], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": _vm.relatorioExtensao.opcao1 !== 'S'
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Bolsa")])]
      },
      proxy: true
    }], null, false, 3329032051),
    model: {
      value: (_vm.relatorioExtensao.boolean1_1),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean1_1", $$v)
      },
      expression: "relatorioExtensao.boolean1_1"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": _vm.relatorioExtensao.opcao1 !== 'S'
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Passagem")])]
      },
      proxy: true
    }], null, false, 2386299455),
    model: {
      value: (_vm.relatorioExtensao.boolean1_2),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean1_2", $$v)
      },
      expression: "relatorioExtensao.boolean1_2"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": _vm.relatorioExtensao.opcao1 !== 'S'
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Diária")])]
      },
      proxy: true
    }], null, false, 3814078326),
    model: {
      value: (_vm.relatorioExtensao.boolean1_3),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean1_3", $$v)
      },
      expression: "relatorioExtensao.boolean1_3"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": _vm.relatorioExtensao.opcao1 !== 'S'
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Material de consumo")])]
      },
      proxy: true
    }], null, false, 1871919084),
    model: {
      value: (_vm.relatorioExtensao.boolean1_4),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean1_4", $$v)
      },
      expression: "relatorioExtensao.boolean1_4"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": _vm.relatorioExtensao.opcao1 !== 'S'
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Material permanente")])]
      },
      proxy: true
    }], null, false, 961207380),
    model: {
      value: (_vm.relatorioExtensao.boolean1_5),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean1_5", $$v)
      },
      expression: "relatorioExtensao.boolean1_5"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": _vm.relatorioExtensao.opcao1 !== 'S'
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Recurso financeiro")])]
      },
      proxy: true
    }], null, false, 1798790707),
    model: {
      value: (_vm.relatorioExtensao.boolean1_6),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean1_6", $$v)
      },
      expression: "relatorioExtensao.boolean1_6"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": _vm.relatorioExtensao.opcao1 !== 'S'
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Espaço físico")])]
      },
      proxy: true
    }], null, false, 3522186450),
    model: {
      value: (_vm.relatorioExtensao.boolean1_7),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean1_7", $$v)
      },
      expression: "relatorioExtensao.boolean1_7"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": _vm.relatorioExtensao.opcao1 !== 'S'
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Divulgação")])]
      },
      proxy: true
    }], null, false, 2707204751),
    model: {
      value: (_vm.relatorioExtensao.boolean1_8),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean1_8", $$v)
      },
      expression: "relatorioExtensao.boolean1_8"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": _vm.relatorioExtensao.opcao1 !== 'S'
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Transporte")])]
      },
      proxy: true
    }], null, false, 1984826566),
    model: {
      value: (_vm.relatorioExtensao.boolean1_9),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean1_9", $$v)
      },
      expression: "relatorioExtensao.boolean1_9"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": _vm.relatorioExtensao.opcao1 !== 'S'
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Outros")])]
      },
      proxy: true
    }], null, false, 1698063712),
    model: {
      value: (_vm.relatorioExtensao.boolean1_10),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean1_10", $$v)
      },
      expression: "relatorioExtensao.boolean1_10"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm6": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "disabled": (_vm.relatorioExtensao.opcao1 !== 'S' || _vm.relatorioExtensao.boolean1_10 !== true),
      "label": "Especifique:",
      "rows": "1",
      "auto-grow": "",
      "counter": "200",
      "rules": _vm.rules200,
      "placeholder": " "
    },
    model: {
      value: (_vm.relatorioExtensao.texto14),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "texto14", $$v)
      },
      expression: "relatorioExtensao.texto14"
    }
  })], 1)], 1), _vm._v(" "), _c('br')], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "v-radio-group_label",
    attrs: {
      "id": "v-radio-group_label_9",
      "label": "9.2 - A ação de extensão recebeu apoio de outras instituições e/ou órgãos de fomento nacionais, internacionais ou estrangeiros?"
    },
    model: {
      value: (_vm.relatorioExtensao.opcao2),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "opcao2", $$v)
      },
      expression: "relatorioExtensao.opcao2"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Sim",
      "value": "S"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Não",
      "value": "N"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.relatorioExtensao.opcao2 === 'S') ? _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "textoRelatorioSubitem"
  }, [_vm._v("Especifique a(s) forma(s) de apoio:")])])], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": _vm.relatorioExtensao.opcao2 !== 'S'
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Bolsa")])]
      },
      proxy: true
    }], null, false, 3329032051),
    model: {
      value: (_vm.relatorioExtensao.boolean2_1),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean2_1", $$v)
      },
      expression: "relatorioExtensao.boolean2_1"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": _vm.relatorioExtensao.opcao2 !== 'S'
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Passagem")])]
      },
      proxy: true
    }], null, false, 2386299455),
    model: {
      value: (_vm.relatorioExtensao.boolean2_2),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean2_2", $$v)
      },
      expression: "relatorioExtensao.boolean2_2"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": _vm.relatorioExtensao.opcao2 !== 'S'
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Diária")])]
      },
      proxy: true
    }], null, false, 3814078326),
    model: {
      value: (_vm.relatorioExtensao.boolean2_3),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean2_3", $$v)
      },
      expression: "relatorioExtensao.boolean2_3"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": _vm.relatorioExtensao.opcao2 !== 'S'
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Material de consumo")])]
      },
      proxy: true
    }], null, false, 1871919084),
    model: {
      value: (_vm.relatorioExtensao.boolean2_4),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean2_4", $$v)
      },
      expression: "relatorioExtensao.boolean2_4"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": _vm.relatorioExtensao.opcao2 !== 'S'
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Material permanente")])]
      },
      proxy: true
    }], null, false, 961207380),
    model: {
      value: (_vm.relatorioExtensao.boolean2_5),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean2_5", $$v)
      },
      expression: "relatorioExtensao.boolean2_5"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": _vm.relatorioExtensao.opcao2 !== 'S'
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Recurso financeiro")])]
      },
      proxy: true
    }], null, false, 1798790707),
    model: {
      value: (_vm.relatorioExtensao.boolean2_6),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean2_6", $$v)
      },
      expression: "relatorioExtensao.boolean2_6"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": _vm.relatorioExtensao.opcao2 !== 'S'
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Espaço físico")])]
      },
      proxy: true
    }], null, false, 3522186450),
    model: {
      value: (_vm.relatorioExtensao.boolean2_7),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean2_7", $$v)
      },
      expression: "relatorioExtensao.boolean2_7"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": _vm.relatorioExtensao.opcao2 !== 'S'
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Divulgação")])]
      },
      proxy: true
    }], null, false, 2707204751),
    model: {
      value: (_vm.relatorioExtensao.boolean2_8),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean2_8", $$v)
      },
      expression: "relatorioExtensao.boolean2_8"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": _vm.relatorioExtensao.opcao2 !== 'S'
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Transporte")])]
      },
      proxy: true
    }], null, false, 1984826566),
    model: {
      value: (_vm.relatorioExtensao.boolean2_9),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean2_9", $$v)
      },
      expression: "relatorioExtensao.boolean2_9"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": _vm.relatorioExtensao.opcao2 !== 'S'
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Outros")])]
      },
      proxy: true
    }], null, false, 1698063712),
    model: {
      value: (_vm.relatorioExtensao.boolean2_10),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean2_10", $$v)
      },
      expression: "relatorioExtensao.boolean2_10"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm6": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "disabled": (_vm.relatorioExtensao.opcao2 !== 'S' || _vm.relatorioExtensao.boolean2_10 !== true),
      "label": "Especifique:",
      "rows": "1",
      "auto-grow": "",
      "counter": "200",
      "rules": _vm.rules200,
      "placeholder": " "
    },
    model: {
      value: (_vm.relatorioExtensao.texto15),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "texto15", $$v)
      },
      expression: "relatorioExtensao.texto15"
    }
  })], 1)], 1), _vm._v(" "), _c('br')], 1) : _vm._e(), _vm._v(" "), ((_vm.relatorioExtensao.opcao1 === 'S' && _vm.relatorioExtensao.boolean1_6 === true) && (_vm.relatorioExtensao.opcao2 === null || _vm.relatorioExtensao.opcao2 === 'N')) ? _c('div', [_c('br')]) : _vm._e(), _vm._v(" "), ((_vm.relatorioExtensao.opcao1 === 'S' && _vm.relatorioExtensao.boolean1_6 === true) || (_vm.relatorioExtensao.opcao2 === 'S' && _vm.relatorioExtensao.boolean2_6 === true)) ? _c('div', [_c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [((_vm.relatorioExtensao.opcao1 === 'S' && _vm.relatorioExtensao.boolean1_6 === true) && (_vm.relatorioExtensao.opcao2 === 'N' || _vm.relatorioExtensao.boolean2_6 === false)) ? _c('label', {
    staticClass: "textoRelatorio"
  }, [_vm._v("\n                      9.3 - Os recursos financeiros indicados no item 9.1 foram executados por:\n                    ")]) : _vm._e(), _vm._v(" "), ((_vm.relatorioExtensao.opcao1 === 'N' || _vm.relatorioExtensao.boolean1_6 === false) && (_vm.relatorioExtensao.opcao2 === 'S' && _vm.relatorioExtensao.boolean2_6 === true)) ? _c('label', {
    staticClass: "textoRelatorio"
  }, [_vm._v("\n                      9.3 - Os recursos financeiros indicados no item 9.2 foram executados por:\n                    ")]) : _vm._e(), _vm._v(" "), ((_vm.relatorioExtensao.opcao1 === 'S' && _vm.relatorioExtensao.boolean1_6 === true) && (_vm.relatorioExtensao.opcao2 === 'S' && _vm.relatorioExtensao.boolean2_6 === true)) ? _c('label', {
    staticClass: "textoRelatorio"
  }, [_vm._v("\n                      9.3 - Os recursos financeiros indicados nos itens 9.1 e 9.2 foram executados por:\n                    ")]) : _vm._e()])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": (_vm.relatorioExtensao.opcao1 !== 'S' || (_vm.relatorioExtensao.opcao1 === 'S' && _vm.relatorioExtensao.boolean1_6 !== true)) && (_vm.relatorioExtensao.opcao2 !== 'S' || (_vm.relatorioExtensao.opcao2 === 'S' && _vm.relatorioExtensao.boolean2_6 !== true))
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("UFES")])]
      },
      proxy: true
    }], null, false, 4124160677),
    model: {
      value: (_vm.relatorioExtensao.boolean3_1),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean3_1", $$v)
      },
      expression: "relatorioExtensao.boolean3_1"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-text-field-money', {
    attrs: {
      "label": "Valor (R$):",
      "properties": {
        disabled: (_vm.relatorioExtensao.opcao1 !== 'S' || (_vm.relatorioExtensao.opcao1 === 'S' && _vm.relatorioExtensao.boolean1_6 !== true)) && (_vm.relatorioExtensao.opcao2 !== 'S' || (_vm.relatorioExtensao.opcao2 === 'S' && _vm.relatorioExtensao.boolean2_6 !== true)) || _vm.relatorioExtensao.boolean3_1 !== true,
        placeholder: ' ',
      },
      "options": {
        locale: 'pt-BR',
        length: 13,
        precision: 2,
        empty: null,
      }
    },
    model: {
      value: (_vm.relatorioExtensao.valor3_1),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "valor3_1", $$v)
      },
      expression: "relatorioExtensao.valor3_1"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs0": "",
      "sm2": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": (_vm.relatorioExtensao.opcao1 !== 'S' || (_vm.relatorioExtensao.opcao1 === 'S' && _vm.relatorioExtensao.boolean1_6 !== true)) && (_vm.relatorioExtensao.opcao2 !== 'S' || (_vm.relatorioExtensao.opcao2 === 'S' && _vm.relatorioExtensao.boolean2_6 !== true))
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("CNPq")])]
      },
      proxy: true
    }], null, false, 1739938252),
    model: {
      value: (_vm.relatorioExtensao.boolean3_2),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean3_2", $$v)
      },
      expression: "relatorioExtensao.boolean3_2"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-text-field-money', {
    attrs: {
      "label": "Valor (R$):",
      "properties": {
        disabled: (_vm.relatorioExtensao.opcao1 !== 'S' || (_vm.relatorioExtensao.opcao1 === 'S' && _vm.relatorioExtensao.boolean1_6 !== true)) && (_vm.relatorioExtensao.opcao2 !== 'S' || (_vm.relatorioExtensao.opcao2 === 'S' && _vm.relatorioExtensao.boolean2_6 !== true)) || _vm.relatorioExtensao.boolean3_2 !== true,
        placeholder: ' ',
      },
      "options": {
        locale: 'pt-BR',
        length: 13,
        precision: 2,
        empty: null,
      }
    },
    model: {
      value: (_vm.relatorioExtensao.valor3_2),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "valor3_2", $$v)
      },
      expression: "relatorioExtensao.valor3_2"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": (_vm.relatorioExtensao.opcao1 !== 'S' || (_vm.relatorioExtensao.opcao1 === 'S' && _vm.relatorioExtensao.boolean1_6 !== true)) && (_vm.relatorioExtensao.opcao2 !== 'S' || (_vm.relatorioExtensao.opcao2 === 'S' && _vm.relatorioExtensao.boolean2_6 !== true))
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("CAPES")])]
      },
      proxy: true
    }], null, false, 3158995236),
    model: {
      value: (_vm.relatorioExtensao.boolean3_3),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean3_3", $$v)
      },
      expression: "relatorioExtensao.boolean3_3"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-text-field-money', {
    attrs: {
      "label": "Valor (R$):",
      "properties": {
        disabled: (_vm.relatorioExtensao.opcao1 !== 'S' || (_vm.relatorioExtensao.opcao1 === 'S' && _vm.relatorioExtensao.boolean1_6 !== true)) && (_vm.relatorioExtensao.opcao2 !== 'S' || (_vm.relatorioExtensao.opcao2 === 'S' && _vm.relatorioExtensao.boolean2_6 !== true)) || _vm.relatorioExtensao.boolean3_3 !== true,
        placeholder: ' ',
      },
      "options": {
        locale: 'pt-BR',
        length: 13,
        precision: 2,
        empty: null,
      }
    },
    model: {
      value: (_vm.relatorioExtensao.valor3_3),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "valor3_3", $$v)
      },
      expression: "relatorioExtensao.valor3_3"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs0": "",
      "sm2": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": (_vm.relatorioExtensao.opcao1 !== 'S' || (_vm.relatorioExtensao.opcao1 === 'S' && _vm.relatorioExtensao.boolean1_6 !== true)) && (_vm.relatorioExtensao.opcao2 !== 'S' || (_vm.relatorioExtensao.opcao2 === 'S' && _vm.relatorioExtensao.boolean2_6 !== true))
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("FAPES")])]
      },
      proxy: true
    }], null, false, 4155422625),
    model: {
      value: (_vm.relatorioExtensao.boolean3_4),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean3_4", $$v)
      },
      expression: "relatorioExtensao.boolean3_4"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-text-field-money', {
    attrs: {
      "label": "Valor (R$):",
      "properties": {
        disabled: (_vm.relatorioExtensao.opcao1 !== 'S' || (_vm.relatorioExtensao.opcao1 === 'S' && _vm.relatorioExtensao.boolean1_6 !== true)) && (_vm.relatorioExtensao.opcao2 !== 'S' || (_vm.relatorioExtensao.opcao2 === 'S' && _vm.relatorioExtensao.boolean2_6 !== true)) || _vm.relatorioExtensao.boolean3_4 !== true,
        placeholder: ' ',
      },
      "options": {
        locale: 'pt-BR',
        length: 13,
        precision: 2,
        empty: null,
      }
    },
    model: {
      value: (_vm.relatorioExtensao.valor3_4),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "valor3_4", $$v)
      },
      expression: "relatorioExtensao.valor3_4"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": (_vm.relatorioExtensao.opcao1 !== 'S' || (_vm.relatorioExtensao.opcao1 === 'S' && _vm.relatorioExtensao.boolean1_6 !== true)) && (_vm.relatorioExtensao.opcao2 !== 'S' || (_vm.relatorioExtensao.opcao2 === 'S' && _vm.relatorioExtensao.boolean2_6 !== true))
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("FEST")])]
      },
      proxy: true
    }], null, false, 1101797796),
    model: {
      value: (_vm.relatorioExtensao.boolean3_5),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean3_5", $$v)
      },
      expression: "relatorioExtensao.boolean3_5"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-text-field-money', {
    attrs: {
      "label": "Valor (R$):",
      "properties": {
        disabled: (_vm.relatorioExtensao.opcao1 !== 'S' || (_vm.relatorioExtensao.opcao1 === 'S' && _vm.relatorioExtensao.boolean1_6 !== true)) && (_vm.relatorioExtensao.opcao2 !== 'S' || (_vm.relatorioExtensao.opcao2 === 'S' && _vm.relatorioExtensao.boolean2_6 !== true)) || _vm.relatorioExtensao.boolean3_5 !== true,
        placeholder: ' ',
      },
      "options": {
        locale: 'pt-BR',
        length: 13,
        precision: 2,
        empty: null,
      }
    },
    model: {
      value: (_vm.relatorioExtensao.valor3_5),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "valor3_5", $$v)
      },
      expression: "relatorioExtensao.valor3_5"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs0": "",
      "sm2": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": (_vm.relatorioExtensao.opcao1 !== 'S' || (_vm.relatorioExtensao.opcao1 === 'S' && _vm.relatorioExtensao.boolean1_6 !== true)) && (_vm.relatorioExtensao.opcao2 !== 'S' || (_vm.relatorioExtensao.opcao2 === 'S' && _vm.relatorioExtensao.boolean2_6 !== true))
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("FUCAM")])]
      },
      proxy: true
    }], null, false, 1966598076),
    model: {
      value: (_vm.relatorioExtensao.boolean3_6),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean3_6", $$v)
      },
      expression: "relatorioExtensao.boolean3_6"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-text-field-money', {
    attrs: {
      "label": "Valor (R$):",
      "properties": {
        disabled: (_vm.relatorioExtensao.opcao1 !== 'S' || (_vm.relatorioExtensao.opcao1 === 'S' && _vm.relatorioExtensao.boolean1_6 !== true)) && (_vm.relatorioExtensao.opcao2 !== 'S' || (_vm.relatorioExtensao.opcao2 === 'S' && _vm.relatorioExtensao.boolean2_6 !== true)) || _vm.relatorioExtensao.boolean3_6 !== true,
        placeholder: ' ',
      },
      "options": {
        locale: 'pt-BR',
        length: 13,
        precision: 2,
        empty: null,
      }
    },
    model: {
      value: (_vm.relatorioExtensao.valor3_6),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "valor3_6", $$v)
      },
      expression: "relatorioExtensao.valor3_6"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": (_vm.relatorioExtensao.opcao1 !== 'S' || (_vm.relatorioExtensao.opcao1 === 'S' && _vm.relatorioExtensao.boolean1_6 !== true)) && (_vm.relatorioExtensao.opcao2 !== 'S' || (_vm.relatorioExtensao.opcao2 === 'S' && _vm.relatorioExtensao.boolean2_6 !== true))
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Outros")])]
      },
      proxy: true
    }], null, false, 1698063712),
    model: {
      value: (_vm.relatorioExtensao.boolean3_7),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean3_7", $$v)
      },
      expression: "relatorioExtensao.boolean3_7"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm5": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "disabled": (_vm.relatorioExtensao.opcao1 !== 'S' || (_vm.relatorioExtensao.opcao1 === 'S' && _vm.relatorioExtensao.boolean1_6 !== true)) && (_vm.relatorioExtensao.opcao2 !== 'S' || (_vm.relatorioExtensao.opcao2 === 'S' && _vm.relatorioExtensao.boolean2_6 !== true)) || _vm.relatorioExtensao.boolean3_7 !== true,
      "label": "Especifique:",
      "rows": "1",
      "auto-grow": "",
      "counter": "200",
      "rules": _vm.rules200,
      "placeholder": " "
    },
    model: {
      value: (_vm.relatorioExtensao.texto16),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "texto16", $$v)
      },
      expression: "relatorioExtensao.texto16"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-text-field-money', {
    attrs: {
      "label": "Valor (R$):",
      "properties": {
        disabled: (_vm.relatorioExtensao.opcao1 !== 'S' || (_vm.relatorioExtensao.opcao1 === 'S' && _vm.relatorioExtensao.boolean1_6 !== true)) && (_vm.relatorioExtensao.opcao2 !== 'S' || (_vm.relatorioExtensao.opcao2 === 'S' && _vm.relatorioExtensao.boolean2_6 !== true)) || _vm.relatorioExtensao.boolean3_7 !== true,
        placeholder: ' ',
      },
      "options": {
        locale: 'pt-BR',
        length: 13,
        precision: 2,
        empty: null,
      }
    },
    model: {
      value: (_vm.relatorioExtensao.valor3_7),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "valor3_7", $$v)
      },
      expression: "relatorioExtensao.valor3_7"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  })], 1), _vm._v(" "), _c('br')], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "v-radio-group_label, item",
    attrs: {
      "id": "v-radio-group_label",
      "label": "10) Houve cobrança de taxa de inscrição, participação, visitação ou similar?"
    },
    model: {
      value: (_vm.relatorioExtensao.opcao4),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "opcao4", $$v)
      },
      expression: "relatorioExtensao.opcao4"
    }
  }, [_c('v-radio', {
    staticClass: "opcaoRadio",
    attrs: {
      "label": "Sim",
      "value": "S"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "opcaoRadio",
    attrs: {
      "label": "Não",
      "value": "N"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.relatorioExtensao.opcao4 === 'S') ? _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "textoRelatorio"
  }, [_vm._v("Os recursos financeiros foram administrados por:")])])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": _vm.relatorioExtensao.opcao4 !== 'S'
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("UFES")])]
      },
      proxy: true
    }], null, false, 4124160677),
    model: {
      value: (_vm.relatorioExtensao.boolean4_1),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean4_1", $$v)
      },
      expression: "relatorioExtensao.boolean4_1"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-text-field-money', {
    attrs: {
      "label": "Valor (R$):",
      "properties": {
        disabled: (_vm.relatorioExtensao.opcao4 !== 'S' || _vm.relatorioExtensao.boolean4_1 !== true),
        placeholder: ' ',
      },
      "options": {
        locale: 'pt-BR',
        length: 13,
        precision: 2,
        empty: null,
      }
    },
    model: {
      value: (_vm.relatorioExtensao.valor4_1),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "valor4_1", $$v)
      },
      expression: "relatorioExtensao.valor4_1"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": _vm.relatorioExtensao.opcao4 !== 'S'
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("FEST")])]
      },
      proxy: true
    }], null, false, 1101797796),
    model: {
      value: (_vm.relatorioExtensao.boolean4_2),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean4_2", $$v)
      },
      expression: "relatorioExtensao.boolean4_2"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-text-field-money', {
    attrs: {
      "label": "Valor (R$):",
      "properties": {
        disabled: (_vm.relatorioExtensao.opcao4 !== 'S' || _vm.relatorioExtensao.boolean4_2 !== true),
        placeholder: ' ',
      },
      "options": {
        locale: 'pt-BR',
        length: 13,
        precision: 2,
        empty: null,
      }
    },
    model: {
      value: (_vm.relatorioExtensao.valor4_2),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "valor4_2", $$v)
      },
      expression: "relatorioExtensao.valor4_2"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": _vm.relatorioExtensao.opcao4 !== 'S'
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("FUCAM")])]
      },
      proxy: true
    }], null, false, 1966598076),
    model: {
      value: (_vm.relatorioExtensao.boolean4_3),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean4_3", $$v)
      },
      expression: "relatorioExtensao.boolean4_3"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-text-field-money', {
    attrs: {
      "label": "Valor (R$):",
      "properties": {
        disabled: (_vm.relatorioExtensao.opcao4 !== 'S' || _vm.relatorioExtensao.boolean4_3 !== true),
        placeholder: ' ',
      },
      "options": {
        locale: 'pt-BR',
        length: 13,
        precision: 2,
        empty: null,
      }
    },
    model: {
      value: (_vm.relatorioExtensao.valor4_3),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "valor4_3", $$v)
      },
      expression: "relatorioExtensao.valor4_3"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": _vm.relatorioExtensao.opcao4 !== 'S'
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Outros")])]
      },
      proxy: true
    }], null, false, 1698063712),
    model: {
      value: (_vm.relatorioExtensao.boolean4_4),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean4_4", $$v)
      },
      expression: "relatorioExtensao.boolean4_4"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "disabled": (_vm.relatorioExtensao.opcao4 !== 'S' || _vm.relatorioExtensao.boolean4_4 !== true),
      "label": "Especifique:",
      "rows": "1",
      "auto-grow": "",
      "counter": "200",
      "rules": _vm.rules200,
      "placeholder": " "
    },
    model: {
      value: (_vm.relatorioExtensao.texto17),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "texto17", $$v)
      },
      expression: "relatorioExtensao.texto17"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-text-field-money', {
    attrs: {
      "label": "Valor (R$):",
      "properties": {
        disabled: (_vm.relatorioExtensao.opcao4 !== 'S' || _vm.relatorioExtensao.boolean4_4 !== true),
        placeholder: ' ',
      },
      "options": {
        locale: 'pt-BR',
        length: 13,
        precision: 2,
        empty: null,
      }
    },
    model: {
      value: (_vm.relatorioExtensao.valor4_4),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "valor4_4", $$v)
      },
      expression: "relatorioExtensao.valor4_4"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "item"
  }, [_vm._v("11) Informar as parcerias/colaborações: contatos nacionais e internacionais\n                    efetivamente ocorridos em função da atividade, como convênios, acordos de colaboração e\n                    outros.")])])], 1), _vm._v(" "), (_vm.listaParcerias.length !== 0) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    staticClass: "alertaEdicao",
    attrs: {
      "dense": "",
      "type": "info",
      "color": "#00796b",
      "outlined": ""
    }
  }, [_vm._v("\n                    Primeiramente, adicione as parcerias/colaborações na aba \"Parcerias\". Em seguida, selecione-as na\n                    lista abaixo.\n                  ")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.listaParcerias.length !== 0) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "d-block": "",
      "xs12": ""
    }
  }, [_c('c-checkbox-table', {
    staticClass: "tabela",
    attrs: {
      "items": _vm.listaParcerias,
      "headers": _vm.headersParcerias,
      "opcoesPaginacao": _vm.opcoesPaginacao,
      "hideDefaultFooter": true,
      "header-props": {
        sortIcon: null
      },
      "search": _vm.search,
      "item-key": "id",
      "selecionarTudo": false
    },
    model: {
      value: (_vm.listaParceriasSelecionadas),
      callback: function($$v) {
        _vm.listaParceriasSelecionadas = $$v
      },
      expression: "listaParceriasSelecionadas"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.listaParcerias.length === 0) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    staticClass: "alerta",
    attrs: {
      "color": "#00796b",
      "outlined": ""
    }
  }, [_vm._v("\n                    Nenhuma parceria/colaboração foi informada na aba Parcerias\n                  ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "item"
  }, [_vm._v("12) Informar produtos de extensão")])])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "textoRelatorio"
  }, [_vm._v("12.1 - Trabalhos publicados e/ou aceitos para publicação no período, tais\n                    como livros, capítulos de livros, artigos em periódicos nacionais e internacionais, resumos em\n                    congressos, reuniões científicas e semelhantes. Indicar claramente entre os autores dos trabalhos,\n                    quando for o caso, os bolsistas e os voluntários:")]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "rows": "1",
      "auto-grow": "",
      "counter": "500",
      "rules": _vm.rules500
    },
    model: {
      value: (_vm.relatorioExtensao.texto9),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "texto9", $$v)
      },
      expression: "relatorioExtensao.texto9"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "textoRelatorio"
  }, [_vm._v("12.2 - Patente ou registro de invenção ou técnica (informar o título, se a\n                    patente é nacional, internacional ou “joint ventures” e outros dados que julgar adequados):")]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "rows": "1",
      "auto-grow": "",
      "counter": "500",
      "rules": _vm.rules500
    },
    model: {
      value: (_vm.relatorioExtensao.texto10),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "texto10", $$v)
      },
      expression: "relatorioExtensao.texto10"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "textoRelatorio"
  }, [_vm._v("12.3 - Outras atividades extensionistas, científicas ou administrativas\n                    que julgar pertinentes no período: organização ou participação em eventos científicos, consultorias,\n                    assessorias a órgãos de fomento, etc:")]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "rows": "1",
      "auto-grow": "",
      "counter": "500",
      "rules": _vm.rules500
    },
    model: {
      value: (_vm.relatorioExtensao.texto11),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "texto11", $$v)
      },
      expression: "relatorioExtensao.texto11"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "textoRelatorio"
  }, [_vm._v("12.4 - Premiações obtidas em função do desenvolvimento da atividade de\n                    extensão (título do prêmio, quem outorgou, data, local); honrarias acadêmicas:")]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "rows": "1",
      "auto-grow": "",
      "counter": "500",
      "rules": _vm.rules500
    },
    model: {
      value: (_vm.relatorioExtensao.texto12),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "texto12", $$v)
      },
      expression: "relatorioExtensao.texto12"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "textoRelatorio"
  }, [_vm._v("12.5 - Links para matérias jornalísticas sobre a ação:")]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "rows": "1",
      "auto-grow": "",
      "counter": "500",
      "rules": _vm.rules500
    },
    model: {
      value: (_vm.relatorioExtensao.texto13),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "texto13", $$v)
      },
      expression: "relatorioExtensao.texto13"
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "item"
  }, [_vm._v("13) Anexar materiais que comprovem a execução da ação de extensão, como:\n                    fotografias, livros, cartazes, panfletos, folders, manuais e outros:")])])], 1), _vm._v(" "), (_vm.listaArquivos.length !== 0) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    staticClass: "alertaEdicao",
    attrs: {
      "dense": "",
      "type": "info",
      "color": "#00796b",
      "outlined": ""
    }
  }, [_vm._v("\n                    Primeiramente, adicione os materiais desejados na aba \"Arquivos\". Em seguida, selecione-os na lista\n                    abaixo.\n                  ")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.listaArquivos.length !== 0) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "d-block": "",
      "xs12": ""
    }
  }, [_c('c-checkbox-table', {
    staticClass: "tabela",
    attrs: {
      "items": _vm.listaArquivos,
      "headers": _vm.headers,
      "hideDefaultFooter": true,
      "header-props": {
        sortIcon: null
      },
      "opcoesPaginacao": _vm.opcoesPaginacao,
      "search": _vm.search,
      "item-key": "idArquivo",
      "selecionarTudo": false
    },
    model: {
      value: (_vm.listaArquivosSelecionados),
      callback: function($$v) {
        _vm.listaArquivosSelecionados = $$v
      },
      expression: "listaArquivosSelecionados"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.listaArquivos.length === 0) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    staticClass: "alerta",
    attrs: {
      "color": "#00796b",
      "outlined": ""
    }
  }, [_vm._v("\n                    Nenhum material foi anexado na aba Arquivos\n                  ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.salvarRelatorioExtensao(false)
      }
    }
  }, [_vm._v("Salvar")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.salvarRelatorioExtensao(true)
      }
    }
  }, [_vm._v("Salvar e\n                Voltar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(768)
  __webpack_require__(769)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(770),
  /* template */
  __webpack_require__(771),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4cfdca44",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 768 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 769 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_date_menu__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_date_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_c_date_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_readonly_field__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_readonly_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_readonly_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_assessor__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_situacaoAtividade__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto', 'idRelatorioExtensao'],
  data: function data() {
    return {
      api_url: "https://pib-api.prod.uks.ufes.br",
      dates: __WEBPACK_IMPORTED_MODULE_5__utils_dates__["a" /* default */],
      formatAssessor: __WEBPACK_IMPORTED_MODULE_4__utils_assessor__["a" /* default */],
      situacaoAtividade: __WEBPACK_IMPORTED_MODULE_7__utils_situacaoAtividade__["a" /* default */],
      listaTipoRelatorio: [{ descricao: 'Parcial' }, { descricao: 'Final' }],
      listaTipoRelatorio2: [{ descricao: 'Final' }],
      projeto: {
        classificacoesPrimariaSecundaria: [{}, {}]
      },
      relatorioForaPrazo: false,
      relatorioExtensao: {},
      formularioValido: false,
      headersIntegrantes: [{ text: 'Nome', align: 'left', value: 'nome' }, { text: 'Função', align: 'left', value: 'funcao.descricao' }, { text: 'Vínculo', align: 'left', value: 'vinculo' }, { text: 'CH semanal', align: 'left', value: 'cargaHoraria' }, { text: 'Data inicial', align: 'left', value: 'dataInicial' }, { text: 'Data final', align: 'left', value: 'dataFinal' }],
      headersParcerias: [{ text: 'Nome do parceiro institucional/colaborador', align: 'left', value: 'nome' }, { text: 'Descrição da parceria/colaboração', align: 'left', value: 'detalhamento' }],
      headers0: [{ text: 'Nome', align: 'left', value: 'nome' }, { text: 'Tipo', align: 'left', value: 'tipoArquivo.descricao' }, { text: 'Observação', left: 'left', value: 'observacao' }]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])('auth', ['administrador'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    verificarPendenciasRelatorio: function verificarPendenciasRelatorio() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Verificando pendências no relatório.' });
      __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].getVerificarPendenciasRelatorio(this.idProjeto, this.idRelatorioExtensao).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Verificando pendências no relatório.' });
      });
    },
    toSubmeter: function toSubmeter() {
      this.$router.push({ name: 'SubmeterRelatorio', params: { idProjeto: this.idProjeto, idRelatorio: this.idRelatorioExtensao } });
    },
    toRelatorioPDF: function toRelatorioPDF() {
      this.$router.push({ name: 'RelatorioTecnicoPDF', params: { idProjeto: this.projeto.idProjeto, idRelatorio: this.idRelatorioExtensao } });
    },
    toVoltar: function toVoltar() {
      this.$router.push({ name: 'RelatoriosProjeto', params: { idProjeto: this.idProjeto } });
    },
    toEditar: function toEditar() {
      this.$router.push({ name: 'EditarRelatorio', params: { idProjeto: this.idProjeto, idRelatorioExtensao: this.idRelatorioExtensao } });
    },
    // Verifica se a ação de extensão está na situação "Preenchimento incompleto".
    situacaoPreenchimentoIncompleto: function situacaoPreenchimentoIncompleto() {
      if (this.projeto.situacao.item === 15) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se a ação de extensão está na situação "Aguardando aprovação".
    situacaoAguardandoAprovacao: function situacaoAguardandoAprovacao() {
      if (this.projeto.situacao.item === 16) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se a ação de extensão está na situação "Ativo".
    acaoSituacaoAtivo: function acaoSituacaoAtivo() {
      if (this.projeto.situacao.item === 18) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se a ação de extensão está na situação "Inadimplente".
    acaoSituacaoInadimplente: function acaoSituacaoInadimplente() {
      if (this.projeto.situacao.item === 3) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se a ação de extensão está na situação "Aguardando relatório".
    acaoSituacaoAguardandoRelatorio: function acaoSituacaoAguardandoRelatorio() {
      if (this.projeto.situacao.item === 20) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se a ação de extensão está na situação "Relatório aguardando aprovação".
    acaoSituacaoRelatorioAguardandoAprovacao: function acaoSituacaoRelatorioAguardandoAprovacao() {
      if (this.projeto.situacao.item === 22) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se a ação de extensão está na situação "Concluído".
    acaoSituacaoConcluido: function acaoSituacaoConcluido() {
      if (this.projeto.situacao.item === 19) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se a ação de extensão está na situação "Cancelado".
    acaoSituacaoCancelado: function acaoSituacaoCancelado() {
      if (this.projeto.situacao.item === 5) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se o relatório está na situação "Em elaboração".
    relatorioSituacaoEmElaboracao: function relatorioSituacaoEmElaboracao() {
      if (this.relatorioExtensao.situacaoRelatorioTecnicoItem === 1) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se o relatório está na situação "Aguardando aprovação".
    relatorioSituacaoAguardandoAprovacao: function relatorioSituacaoAguardandoAprovacao() {
      if (this.relatorioExtensao.situacaoRelatorioTecnicoItem === 2) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se o relatório está na situação "Aprovado".
    relatorioSituacaoAprovado: function relatorioSituacaoAprovado() {
      if (this.relatorioExtensao.situacaoRelatorioTecnicoItem === 3) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se o usuário logado é administrador.
    usuarioAdministrador: function usuarioAdministrador() {
      if (this.administrador === true) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se o usuário logado é o coordenador da ação de extensão.
    usuarioCoordenador: function usuarioCoordenador() {
      if (this.projeto.funcao != null && this.projeto.funcao.item === 1) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se o usuário logado é assessor da ação de extensão.
    usuarioAssessor: function usuarioAssessor() {
      if (this.projeto.assessor === true) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se o usuário logado é usuário Proex.
    usuarioProex: function usuarioProex() {
      if (this.usuarioPROEX === true) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se o coordenador e o assessor podem editar o relatório.
    coordenadorAssessorPodemEditar: function coordenadorAssessorPodemEditar() {
      if (this.acaoSituacaoAtivo() || this.acaoSituacaoInadimplente() || this.relatorioHabilitadoAcaoRegistroTardio() && this.situacaoPreenchimentoIncompleto()) {
        if (this.relatorioSituacaoEmElaboracao()) {
          if (this.usuarioCoordenador() || this.usuarioAssessor()) {
            return true;
          } else {
            return false;
          }
        }
      }
    },
    // Verifica se o administrador pode editar o relatório.
    administradorPodeEditar: function administradorPodeEditar() {
      if (this.acaoSituacaoAtivo() || this.acaoSituacaoInadimplente() || this.relatorioHabilitadoAcaoRegistroTardio() && this.situacaoPreenchimentoIncompleto()) {
        if (this.relatorioSituacaoEmElaboracao()) {
          if (this.usuarioAdministrador()) {
            return true;
          } else {
            return false;
          }
        }
      }
    },
    // Permissão para coordenador e assessor verificarem as pendências do relatório.
    coordenadorAssessorPodemValidar: function coordenadorAssessorPodemValidar() {
      if (this.coordenadorAssessorPodemEditar()) {
        return true;
      } else {
        return false;
      }
    },
    // Permissão para administrador verificar as pendências do relatório.
    administradorPodeValidar: function administradorPodeValidar() {
      if (this.administradorPodeEditar()) {
        return true;
      } else {
        return false;
      }
    },
    // Verifica se o preenchimento do relatório final está habilitado para ações de extensão com registro tardio.
    relatorioHabilitadoAcaoRegistroTardio: function relatorioHabilitadoAcaoRegistroTardio() {
      if (this.projeto.relatorioFinalHabilitado === true) {
        return true;
      } else {
        return false;
      }
    },
    // Permissão para coordenador e administrador submeterem o relatório para aprovação.
    coordenadorAdministradorSubmeteremAprovacao: function coordenadorAdministradorSubmeteremAprovacao() {
      //Ticket #317413 - projeto ativo ou inadimplmente pode submeter
      if (this.acaoSituacaoInadimplente() || this.acaoSituacaoAtivo() || this.relatorioHabilitadoAcaoRegistroTardio() && this.situacaoAguardandoAprovacao()) {
        if (this.relatorioSituacaoEmElaboracao()) {
          if (this.usuarioCoordenador() || this.usuarioAdministrador()) {
            return true;
          } else {
            return false;
          }
        }
      }
    },
    // Verifica se o usuário logado possui permissão para visualizar o espelho do relatório.
    usuarioPermissaoEspelhoRelatorio: function usuarioPermissaoEspelhoRelatorio() {
      if (this.situacaoAguardandoAprovacao() || this.acaoSituacaoAtivo() || this.acaoSituacaoAguardandoRelatorio() || this.acaoSituacaoRelatorioAguardandoAprovacao() || this.acaoSituacaoConcluido() || this.acaoSituacaoCancelado()) {
        if (this.relatorioSituacaoAguardandoAprovacao() || this.relatorioSituacaoAprovado()) {
          if (this.usuarioAdministrador() || this.usuarioCoordenador() || this.usuarioAssessor() || this.usuarioProex()) {
            return true;
          } else {
            return false;
          }
        }
      }
    },
    // Retorna a situação do relatório.
    getSituacaoRelatorio: function getSituacaoRelatorio(situacaoRelatorioTecnicoItem) {
      if (situacaoRelatorioTecnicoItem === 1) {
        return 'Em elaboração';
      } else if (situacaoRelatorioTecnicoItem === 2) {
        return 'Aguardando aprovação';
      } else if (situacaoRelatorioTecnicoItem === 3) {
        return 'Aprovado';
      } else if (situacaoRelatorioTecnicoItem === 4) {
        return 'Reprovado';
      } else {
        return 'Situação inválida';
      }
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    // Carrega a ação de extensão.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].getProjeto(this.idProjeto).then(function (response) {
      _this2.projeto = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    });

    // Carrega o relatório.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando relatório.' });
    __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].getRelatorioExtensao(this.idProjeto, this.idRelatorioExtensao).then(function (response) {
      _this2.relatorioExtensao = response.data;
      _this2.relatorioExtensao.dtInicialFormatada = __WEBPACK_IMPORTED_MODULE_5__utils_dates__["a" /* default */].format(_this2.relatorioExtensao.dtInicial);
      _this2.relatorioExtensao.dtFinalFormatada = __WEBPACK_IMPORTED_MODULE_5__utils_dates__["a" /* default */].format(_this2.relatorioExtensao.dtFinal);
      _this2.relatorioExtensao.dtNovaConclusaoFormatada = __WEBPACK_IMPORTED_MODULE_5__utils_dates__["a" /* default */].format(_this2.relatorioExtensao.dtNovaConclusao);
      _this2.relatorioExtensao.dtAprovacaoFormatada = __WEBPACK_IMPORTED_MODULE_5__utils_dates__["a" /* default */].format(_this2.relatorioExtensao.dtAprovacaoRelatorio);
      _this2.relatorioExtensao.dtReprovacaoFormatada = __WEBPACK_IMPORTED_MODULE_5__utils_dates__["a" /* default */].format(_this2.relatorioExtensao.dtReprovacaoRelatorio);
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando relatório.' });
    });

    // Endpoint que retorna se o relatório está fora do prazo para envio.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações adicionais.' });
    __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].getRelatorioTecnicoForaPrazo(this.idProjeto, this.idRelatorioExtensao).then(function (response) {
      _this2.relatorioForaPrazo = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações adicionais.' });
    });
  },
  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_3__components_toolbars_basic_toolbar___default.a,
    'c-date-menu': __WEBPACK_IMPORTED_MODULE_1__components_c_date_menu___default.a,
    'c-readonly-field': __WEBPACK_IMPORTED_MODULE_2__components_c_readonly_field___default.a
  }
});

/***/ }),
/* 771 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [(_vm.usuarioPermissaoEspelhoRelatorio()) ? _c('v-btn', {
    staticClass: "text-xs-right, botaoGerarPDF",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.toRelatorioPDF
    }
  }, [_vm._v("Gerar PDF do Relatório")]) : _vm._e(), _vm._v(" "), _c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Relatório Técnico de Extensão ' + this.relatorioExtensao.ordem
    }
  }), _vm._v(" "), _c('v-card-text', [_c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(this.relatorioExtensao.tituloAcaoExtensao !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Título",
      "value": this.relatorioExtensao.tituloAcaoExtensao
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Título",
      "value": "-"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(this.relatorioExtensao.nomeCoordenador !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Nome do coordenador",
      "value": this.relatorioExtensao.nomeCoordenador
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Nome do coordenador",
      "value": "-"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [(this.relatorioExtensao.numeroAcaoExtensao !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Número",
      "value": this.relatorioExtensao.numeroAcaoExtensao
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Número",
      "value": "-"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [(this.relatorioExtensao.tipoAcaoExtensao !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Tipo",
      "value": this.relatorioExtensao.tipoAcaoExtensao
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Tipo",
      "value": "-"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(this.relatorioExtensao.unidade !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Unidade",
      "value": this.relatorioExtensao.unidade
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Unidade",
      "value": "-"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(this.relatorioExtensao.emailCoordenador !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "E-mail do coordenador",
      "value": this.relatorioExtensao.emailCoordenador
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "E-mail do coordenador",
      "value": "-"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [(this.relatorioExtensao.liberacaoCargaHorariaCoordenador !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Liberação de carga horária do coordenador",
      "value": this.relatorioExtensao.liberacaoCargaHorariaCoordenador == true ? 'Sim' : 'Não'
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Liberação de carga horária do coordenador",
      "value": "-"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [(this.relatorioExtensao.cargaHorariaCoordenador !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Carga horária",
      "value": this.relatorioExtensao.cargaHorariaCoordenador
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Carga horária",
      "value": "-"
    }
  })], 1)], 1), _vm._v(" "), ((_vm.projeto.classificacaoSecundaria.id === 39729 || _vm.projeto.classificacaoSecundaria.id === 44194 || _vm.projeto.classificacaoSecundaria.id === 44195 || _vm.projeto.classificacaoSecundaria.id === 39730) && _vm.relatorioExtensao.tipoRelatorioTecnicoItem === 3) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(this.relatorioExtensao.mudancaDatasAcao !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Houve mudança nas datas de início e/ou de conclusão da ação de extensão?",
      "value": this.relatorioExtensao.mudancaDatasAcao === 'S' ? 'Sim' : 'Não'
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Houve mudança nas datas de início e/ou de conclusão da ação de extensão?",
      "value": "-"
    }
  })], 1), _vm._v(" "), (this.relatorioExtensao.mudancaDatasAcao === 'S') ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(this.relatorioExtensao.justificativaMudancaDatasAcao !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Justificativa",
      "value": this.relatorioExtensao.justificativaMudancaDatasAcao
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Justificativa",
      "value": "-"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "textoRelatorio"
  }, [_vm._v("Período a que se refere o relatório")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md5": "",
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Início:",
      "value": _vm.relatorioExtensao.dtInicialFormatada
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md1": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md5": "",
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Fim:",
      "value": _vm.relatorioExtensao.dtFinalFormatada
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md1": ""
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.relatorioExtensao.situacaoRelatorioTecnicoItem !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Situação do relatório",
      "value": _vm.getSituacaoRelatorio(_vm.relatorioExtensao.situacaoRelatorioTecnicoItem)
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Situação do relatório",
      "value": "-"
    }
  })], 1)], 1), _vm._v(" "), (_vm.relatorioExtensao.situacaoRelatorioTecnicoItem !== null && (_vm.relatorioExtensao.situacaoRelatorioTecnicoItem === 3 || _vm.relatorioExtensao.situacaoRelatorioTecnicoItem === 4)) ? _c('div', [(_vm.relatorioExtensao.situacaoRelatorioTecnicoItem !== null && _vm.relatorioExtensao.situacaoRelatorioTecnicoItem === 3) ? _c('div', [_c('br'), _vm._v(" "), (_vm.relatorioExtensao.situacaoRelatorioTecnicoItem !== null && _vm.relatorioExtensao.situacaoRelatorioTecnicoItem === 3) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.relatorioExtensao.dtAprovacaoRelatorio !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Data de aprovação do relatório pela Câmara de Extensão",
      "value": _vm.relatorioExtensao.dtAprovacaoFormatada
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Data de aprovação do relatório pela Câmara de Extensão",
      "value": "-"
    }
  })], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.relatorioExtensao.situacaoRelatorioTecnicoItem !== null && _vm.relatorioExtensao.situacaoRelatorioTecnicoItem === 4) ? _c('div', [_c('br'), _vm._v(" "), (_vm.relatorioExtensao.situacaoRelatorioTecnicoItem !== null && _vm.relatorioExtensao.situacaoRelatorioTecnicoItem === 4) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.relatorioExtensao.dtReprovacaoRelatorio !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Data de reprovação do relatório pela Câmara de Extensão",
      "value": _vm.relatorioExtensao.dtReprovacaoFormatada
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Data de reprovação do relatório pela Câmara de Extensão",
      "value": "-"
    }
  })], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.relatorioExtensao.processo !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Processo",
      "value": _vm.relatorioExtensao.processo
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Processo",
      "value": "-"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "item"
  }, [(_vm.relatorioExtensao.tipoRelatorioTecnicoItem === 1) ? _c('c-readonly-field', {
    attrs: {
      "label": "Tipo do relatório",
      "value": "Relatório Parcial: Deverá ser apresentado a cada 12 meses de atividade e encaminhado à ProEx no prazo máximo de 60 dias após o término do interstício."
    }
  }) : _vm._e(), _vm._v(" "), (_vm.relatorioExtensao.tipoRelatorioTecnicoItem === 2) ? _c('c-readonly-field', {
    attrs: {
      "label": "Tipo do relatório",
      "value": "Relatório Parcial com Renovação: Deverá ser apresentado no prazo máximo de até 60 dias do último interstício da ação indicando o período de renovação."
    }
  }) : _vm._e(), _vm._v(" "), (_vm.relatorioExtensao.tipoRelatorioTecnicoItem === 3) ? _c('c-readonly-field', {
    attrs: {
      "label": "Tipo do relatório",
      "value": "Relatório Final: Deverá ser apresentado no prazo máximo de até 60 dias após a data prevista de conclusão da ação extensionista ou do término das atividades, no caso de encerramento antes do previsto."
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.relatorioExtensao.tipoRelatorioTecnicoItem) ? _c('c-readonly-field', {
    attrs: {
      "label": "Tipo do relatório",
      "value": "-"
    }
  }) : _vm._e()], 1)])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.relatorioExtensao.tipoRelatorioTecnicoItem === 2) ? _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "item",
    attrs: {
      "label": "Nova data de conclusão da ação de extensão:",
      "value": _vm.relatorioExtensao.dtNovaConclusaoFormatada
    }
  }), _vm._v(" "), _c('br')], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.relatorioForaPrazo === true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "item",
    attrs: {
      "label": "Apresentar justificativa para envio do relatório fora do prazo:",
      "align": "justify",
      "value": _vm.relatorioExtensao.justificativaForaPrazo || '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.relatorioForaPrazo === true) ? _c('div', [_c('br'), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "item",
    attrs: {
      "label": "1) A metodologia foi alterada para alcançar os objetivos da proposta inicial?",
      "align": "justify",
      "value": _vm.relatorioExtensao.opcao5 === null ? '-' : _vm.relatorioExtensao.opcao5 === 'S' ? 'Sim' : 'Não'
    }
  })], 1)], 1), _vm._v(" "), (_vm.relatorioExtensao.opcao5 === 'S') ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "align": "justify",
      "label": "Apresente sucintamente as alterações implementadas:",
      "value": _vm.relatorioExtensao.texto1 !== null && _vm.relatorioExtensao.texto1 !== '' ? _vm.relatorioExtensao.texto1 : '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "item",
    attrs: {
      "label": "2) Local de execução da ação:",
      "align": "justify",
      "value": _vm.relatorioExtensao.texto2 || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.relatorioExtensao.texto3 != null && _vm.relatorioExtensao.texto3.length !== 0 && _vm.relatorioExtensao.situacaoRelatorioTecnicoItem !== 1) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "item",
    attrs: {
      "label": "3) Informar o quantitativo total de indivíduos beneficiados no período deste relatório",
      "align": "justify",
      "value": _vm.relatorioExtensao.texto3 || '-'
    }
  })], 1)], 1) : _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "item"
  }, [_vm._v("3) Informar o quantitativo total de indivíduos beneficiados no período deste\n                    relatório")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "3.1 - Público-alvo direto (público concretamente registrado):",
      "value": _vm.relatorioExtensao.publicoAlvoDireto || '-'
    }
  }), _vm._v(" "), _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "3.2 - Público-alvo indireto (estimativa de público atingido indiretamente):",
      "value": _vm.relatorioExtensao.publicoAlvoIndireto || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "item"
  }, [_vm._v("4) Atividades e resultados")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, _vm._l((_vm.relatorioExtensao.listaRelatorioAtividade), function(item, i) {
    return _c('v-col', {
      key: i
    }, [_c('v-card', {
      attrs: {
        "outlined": ""
      }
    }, [_c('v-card-text', [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "text-xs-left": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('c-readonly-field', {
      staticClass: "textoRelatorio",
      attrs: {
        "align": "justify",
        "label": "Nome e descrição sucinta da atividade",
        "value": item.descricao
      }
    }), _vm._v(" "), (item.detalhamento !== null && item.detalhamento !== '') ? _c('c-readonly-field', {
      staticClass: "textoRelatorio",
      attrs: {
        "align": "justify",
        "value": item.detalhamento
      }
    }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "text-xs-left": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('c-readonly-field', {
      staticClass: "textoRelatorio",
      attrs: {
        "align": "justify",
        "label": "Principal objetivo específico ao qual esta atividade está vinculada",
        "value": item.objetivoEspecifico !== null && item.objetivoEspecifico !== '' ? item.objetivoEspecifico : '-'
      }
    })], 1)], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "text-xs-left": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [(item.situacaoAtividade !== null) ? _c('c-readonly-field', {
      staticClass: "textoRelatorio",
      attrs: {
        "label": "Situação",
        "value": _vm.situacaoAtividade.format(item.situacaoAtividade.item)
      }
    }) : _vm._e(), _vm._v(" "), (item.situacaoAtividade === null) ? _c('c-readonly-field', {
      staticClass: "textoRelatorio",
      attrs: {
        "label": "Situação",
        "value": "-"
      }
    }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "text-xs-left": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "md5": "",
        "xs12": ""
      }
    }, [_c('c-readonly-field', {
      staticClass: "textoRelatorio",
      attrs: {
        "label": "Início efetivo",
        "value": _vm.dates.format(item.dtInicioEfetivo)
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "md1": ""
      }
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "md5": "",
        "xs12": ""
      }
    }, [_c('c-readonly-field', {
      staticClass: "textoRelatorio",
      attrs: {
        "label": "Conclusão efetiva",
        "value": _vm.dates.format(item.dtFimEfetivo)
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "md1": ""
      }
    })], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "text-xs-left": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('c-readonly-field', {
      staticClass: "textoRelatorio",
      attrs: {
        "align": "justify",
        "label": "Resultados",
        "value": item.resultados !== null && item.resultados !== '' ? item.resultados : '-'
      }
    })], 1)], 1)], 1)], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "item",
    attrs: {
      "label": "5) Discutir de forma geral a relevância das atividades, seu mérito extensionista, impacto, abrangência social, interdisciplinaridade e visibilidade:",
      "align": "justify",
      "value": _vm.relatorioExtensao.texto4 || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "item",
    attrs: {
      "label": "6) Descrever de que maneira a ação de extensão contribuiu para a formação do aluno de graduação integrante da equipe:",
      "align": "justify",
      "value": _vm.relatorioExtensao.texto5 || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "item"
  }, [_vm._v("7) Relacionar os fatores que interferiram na execução da ação")])])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "align": "justify",
      "label": "7.1 - Positivos:",
      "value": _vm.relatorioExtensao.texto6 || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "align": "justify",
      "label": "7.2 - Negativos:",
      "value": _vm.relatorioExtensao.texto7 || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "item"
  }, [_vm._v("8) Equipe.")])])], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "tabela",
    attrs: {
      "headers": _vm.headersIntegrantes,
      "items": _vm.relatorioExtensao.listaRelatorioParticipante,
      "items-per-page": -1,
      "hide-default-footer": "",
      "header-props": {
        sortIcon: null
      }
    },
    scopedSlots: _vm._u([{
      key: "item.assessor",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.formatAssessor.format(props.item.assessor,
          props.item.funcao.item)))]
      }
    }, {
      key: "item.dataInicial",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dataInicial)))]
      }
    }, {
      key: "item.dataFinal",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dataFinal)))]
      }
    }])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "item"
  }, [_vm._v("9) Formas de apoio")])])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "9.1 - A ação de extensão recebeu apoio da ProEx?",
      "value": _vm.relatorioExtensao.opcao1 === null ? '-' : _vm.relatorioExtensao.opcao1 === 'S' ? 'Sim' : 'Não'
    }
  })], 1)], 1), _vm._v(" "), (_vm.relatorioExtensao.opcao1 === 'S') ? _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "textoRelatorioSubitem"
  }, [_vm._v("Especifique a(s) forma(s) de apoio:")])])], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Bolsa")])]
      },
      proxy: true
    }], null, false, 3329032051),
    model: {
      value: (_vm.relatorioExtensao.boolean1_1),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean1_1", $$v)
      },
      expression: "relatorioExtensao.boolean1_1"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Passagem")])]
      },
      proxy: true
    }], null, false, 2386299455),
    model: {
      value: (_vm.relatorioExtensao.boolean1_2),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean1_2", $$v)
      },
      expression: "relatorioExtensao.boolean1_2"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Diária")])]
      },
      proxy: true
    }], null, false, 3814078326),
    model: {
      value: (_vm.relatorioExtensao.boolean1_3),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean1_3", $$v)
      },
      expression: "relatorioExtensao.boolean1_3"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Material de consumo")])]
      },
      proxy: true
    }], null, false, 1871919084),
    model: {
      value: (_vm.relatorioExtensao.boolean1_4),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean1_4", $$v)
      },
      expression: "relatorioExtensao.boolean1_4"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Material permanente")])]
      },
      proxy: true
    }], null, false, 961207380),
    model: {
      value: (_vm.relatorioExtensao.boolean1_5),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean1_5", $$v)
      },
      expression: "relatorioExtensao.boolean1_5"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Recurso financeiro")])]
      },
      proxy: true
    }], null, false, 1798790707),
    model: {
      value: (_vm.relatorioExtensao.boolean1_6),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean1_6", $$v)
      },
      expression: "relatorioExtensao.boolean1_6"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Espaço físico")])]
      },
      proxy: true
    }], null, false, 3522186450),
    model: {
      value: (_vm.relatorioExtensao.boolean1_7),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean1_7", $$v)
      },
      expression: "relatorioExtensao.boolean1_7"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Divulgação")])]
      },
      proxy: true
    }], null, false, 2707204751),
    model: {
      value: (_vm.relatorioExtensao.boolean1_8),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean1_8", $$v)
      },
      expression: "relatorioExtensao.boolean1_8"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Transporte")])]
      },
      proxy: true
    }], null, false, 1984826566),
    model: {
      value: (_vm.relatorioExtensao.boolean1_9),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean1_9", $$v)
      },
      expression: "relatorioExtensao.boolean1_9"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Outros")])]
      },
      proxy: true
    }], null, false, 1698063712),
    model: {
      value: (_vm.relatorioExtensao.boolean1_10),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean1_10", $$v)
      },
      expression: "relatorioExtensao.boolean1_10"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Especifique:",
      "placeholder": " "
    },
    model: {
      value: (_vm.relatorioExtensao.texto14),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "texto14", $$v)
      },
      expression: "relatorioExtensao.texto14"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "9.2 - A ação de extensão recebeu apoio de outras instituições e/ou órgãos de fomento nacionais, internacionais ou estrangeiros?",
      "value": _vm.relatorioExtensao.opcao2 === null ? '-' : _vm.relatorioExtensao.opcao2 === 'S' ? 'Sim' : 'Não'
    }
  })], 1)], 1), _vm._v(" "), (_vm.relatorioExtensao.opcao2 === 'S') ? _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "textoRelatorioSubitem"
  }, [_vm._v("Especifique a(s) forma(s) de apoio:")])])], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Bolsa")])]
      },
      proxy: true
    }], null, false, 3329032051),
    model: {
      value: (_vm.relatorioExtensao.boolean2_1),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean2_1", $$v)
      },
      expression: "relatorioExtensao.boolean2_1"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Passagem")])]
      },
      proxy: true
    }], null, false, 2386299455),
    model: {
      value: (_vm.relatorioExtensao.boolean2_2),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean2_2", $$v)
      },
      expression: "relatorioExtensao.boolean2_2"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Diária")])]
      },
      proxy: true
    }], null, false, 3814078326),
    model: {
      value: (_vm.relatorioExtensao.boolean2_3),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean2_3", $$v)
      },
      expression: "relatorioExtensao.boolean2_3"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Material de consumo")])]
      },
      proxy: true
    }], null, false, 1871919084),
    model: {
      value: (_vm.relatorioExtensao.boolean2_4),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean2_4", $$v)
      },
      expression: "relatorioExtensao.boolean2_4"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Material permanente")])]
      },
      proxy: true
    }], null, false, 961207380),
    model: {
      value: (_vm.relatorioExtensao.boolean2_5),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean2_5", $$v)
      },
      expression: "relatorioExtensao.boolean2_5"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Recurso financeiro")])]
      },
      proxy: true
    }], null, false, 1798790707),
    model: {
      value: (_vm.relatorioExtensao.boolean2_6),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean2_6", $$v)
      },
      expression: "relatorioExtensao.boolean2_6"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Espaço físico")])]
      },
      proxy: true
    }], null, false, 3522186450),
    model: {
      value: (_vm.relatorioExtensao.boolean2_7),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean2_7", $$v)
      },
      expression: "relatorioExtensao.boolean2_7"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Divulgação")])]
      },
      proxy: true
    }], null, false, 2707204751),
    model: {
      value: (_vm.relatorioExtensao.boolean2_8),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean2_8", $$v)
      },
      expression: "relatorioExtensao.boolean2_8"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Transporte")])]
      },
      proxy: true
    }], null, false, 1984826566),
    model: {
      value: (_vm.relatorioExtensao.boolean2_9),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean2_9", $$v)
      },
      expression: "relatorioExtensao.boolean2_9"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Outros")])]
      },
      proxy: true
    }], null, false, 1698063712),
    model: {
      value: (_vm.relatorioExtensao.boolean2_10),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean2_10", $$v)
      },
      expression: "relatorioExtensao.boolean2_10"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Especifique:",
      "placeholder": " "
    },
    model: {
      value: (_vm.relatorioExtensao.texto15),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "texto15", $$v)
      },
      expression: "relatorioExtensao.texto15"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), ((_vm.relatorioExtensao.opcao1 === 'S' && _vm.relatorioExtensao.boolean1_6 === true) || (_vm.relatorioExtensao.opcao2 === 'S' && _vm.relatorioExtensao.boolean2_6 === true)) ? _c('div', [_c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [((_vm.relatorioExtensao.opcao1 === 'S' && _vm.relatorioExtensao.boolean1_6 === true) && (_vm.relatorioExtensao.opcao2 === 'N' || _vm.relatorioExtensao.boolean2_6 === false)) ? _c('label', {
    staticClass: "textoRelatorio"
  }, [_vm._v("\n                      9.3 - Os recursos financeiros indicados no item 9.1 foram executados por:\n                    ")]) : _vm._e(), _vm._v(" "), ((_vm.relatorioExtensao.opcao1 === 'N' || _vm.relatorioExtensao.boolean1_6 === false) && (_vm.relatorioExtensao.opcao2 === 'S' && _vm.relatorioExtensao.boolean2_6 === true)) ? _c('label', {
    staticClass: "textoRelatorio"
  }, [_vm._v("\n                      9.3 - Os recursos financeiros indicados no item 9.2 foram executados por:\n                    ")]) : _vm._e(), _vm._v(" "), ((_vm.relatorioExtensao.opcao1 === 'S' && _vm.relatorioExtensao.boolean1_6 === true) && (_vm.relatorioExtensao.opcao2 === 'S' && _vm.relatorioExtensao.boolean2_6 === true)) ? _c('label', {
    staticClass: "textoRelatorio"
  }, [_vm._v("\n                      9.3 - Os recursos financeiros indicados nos itens 9.1 e 9.2 foram executados por:\n                    ")]) : _vm._e()])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("UFES")])]
      },
      proxy: true
    }], null, false, 4124160677),
    model: {
      value: (_vm.relatorioExtensao.boolean3_1),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean3_1", $$v)
      },
      expression: "relatorioExtensao.boolean3_1"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-text-field-money', {
    attrs: {
      "label": "Valor (R$):",
      "properties": {
        readonly: true,
        placeholder: ' ',
      },
      "options": {
        locale: 'pt-BR',
        length: 13,
        precision: 2,
        empty: null,
      }
    },
    model: {
      value: (_vm.relatorioExtensao.valor3_1),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "valor3_1", $$v)
      },
      expression: "relatorioExtensao.valor3_1"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs0": "",
      "sm2": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("CNPq")])]
      },
      proxy: true
    }], null, false, 1739938252),
    model: {
      value: (_vm.relatorioExtensao.boolean3_2),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean3_2", $$v)
      },
      expression: "relatorioExtensao.boolean3_2"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-text-field-money', {
    attrs: {
      "label": "Valor (R$):",
      "properties": {
        readonly: true,
        placeholder: ' ',
      },
      "options": {
        locale: 'pt-BR',
        length: 13,
        precision: 2,
        empty: null,
      }
    },
    model: {
      value: (_vm.relatorioExtensao.valor3_2),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "valor3_2", $$v)
      },
      expression: "relatorioExtensao.valor3_2"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("CAPES")])]
      },
      proxy: true
    }], null, false, 3158995236),
    model: {
      value: (_vm.relatorioExtensao.boolean3_3),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean3_3", $$v)
      },
      expression: "relatorioExtensao.boolean3_3"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-text-field-money', {
    attrs: {
      "label": "Valor (R$):",
      "properties": {
        readonly: true,
        placeholder: ' ',
      },
      "options": {
        locale: 'pt-BR',
        length: 13,
        precision: 2,
        empty: null,
      }
    },
    model: {
      value: (_vm.relatorioExtensao.valor3_3),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "valor3_3", $$v)
      },
      expression: "relatorioExtensao.valor3_3"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs0": "",
      "sm2": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("FAPES")])]
      },
      proxy: true
    }], null, false, 4155422625),
    model: {
      value: (_vm.relatorioExtensao.boolean3_4),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean3_4", $$v)
      },
      expression: "relatorioExtensao.boolean3_4"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-text-field-money', {
    attrs: {
      "label": "Valor (R$):",
      "properties": {
        readonly: true,
        placeholder: ' ',
      },
      "options": {
        locale: 'pt-BR',
        length: 13,
        precision: 2,
        empty: null,
      }
    },
    model: {
      value: (_vm.relatorioExtensao.valor3_4),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "valor3_4", $$v)
      },
      expression: "relatorioExtensao.valor3_4"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("FEST")])]
      },
      proxy: true
    }], null, false, 1101797796),
    model: {
      value: (_vm.relatorioExtensao.boolean3_5),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean3_5", $$v)
      },
      expression: "relatorioExtensao.boolean3_5"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-text-field-money', {
    attrs: {
      "label": "Valor (R$):",
      "properties": {
        readonly: true,
        placeholder: ' ',
      },
      "options": {
        locale: 'pt-BR',
        length: 13,
        precision: 2,
        empty: null,
      }
    },
    model: {
      value: (_vm.relatorioExtensao.valor3_5),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "valor3_5", $$v)
      },
      expression: "relatorioExtensao.valor3_5"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs0": "",
      "sm2": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("FUCAM")])]
      },
      proxy: true
    }], null, false, 1966598076),
    model: {
      value: (_vm.relatorioExtensao.boolean3_6),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean3_6", $$v)
      },
      expression: "relatorioExtensao.boolean3_6"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-text-field-money', {
    attrs: {
      "label": "Valor (R$):",
      "properties": {
        readonly: true,
        placeholder: ' ',
      },
      "options": {
        locale: 'pt-BR',
        length: 13,
        precision: 2,
        empty: null,
      }
    },
    model: {
      value: (_vm.relatorioExtensao.valor3_6),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "valor3_6", $$v)
      },
      expression: "relatorioExtensao.valor3_6"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Outros")])]
      },
      proxy: true
    }], null, false, 1698063712),
    model: {
      value: (_vm.relatorioExtensao.boolean3_7),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean3_7", $$v)
      },
      expression: "relatorioExtensao.boolean3_7"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Especifique:",
      "placeholder": " "
    },
    model: {
      value: (_vm.relatorioExtensao.texto16),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "texto16", $$v)
      },
      expression: "relatorioExtensao.texto16"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-text-field-money', {
    attrs: {
      "label": "Valor (R$):",
      "properties": {
        readonly: true,
        placeholder: ' ',
      },
      "options": {
        locale: 'pt-BR',
        length: 13,
        precision: 2,
        empty: null,
      }
    },
    model: {
      value: (_vm.relatorioExtensao.valor3_7),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "valor3_7", $$v)
      },
      expression: "relatorioExtensao.valor3_7"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "item",
    attrs: {
      "label": "10) Houve cobrança de taxa de inscrição, participação, visitação ou similar?",
      "value": _vm.relatorioExtensao.opcao4 === null ? '-' : _vm.relatorioExtensao.opcao4 === 'S' ? 'Sim' : 'Não'
    }
  })], 1)], 1), _vm._v(" "), (_vm.relatorioExtensao.opcao4 === 'S') ? _c('div', [_c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "textoRelatorio"
  }, [_vm._v("Os recursos financeiros foram administrados por:")])])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("UFES")])]
      },
      proxy: true
    }], null, false, 4124160677),
    model: {
      value: (_vm.relatorioExtensao.boolean4_1),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean4_1", $$v)
      },
      expression: "relatorioExtensao.boolean4_1"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-text-field-money', {
    attrs: {
      "label": "Valor (R$):",
      "properties": {
        readonly: true,
        placeholder: ' ',
      },
      "options": {
        locale: 'pt-BR',
        length: 13,
        precision: 2,
        empty: null,
      }
    },
    model: {
      value: (_vm.relatorioExtensao.valor4_1),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "valor4_1", $$v)
      },
      expression: "relatorioExtensao.valor4_1"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("FEST")])]
      },
      proxy: true
    }], null, false, 1101797796),
    model: {
      value: (_vm.relatorioExtensao.boolean4_2),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean4_2", $$v)
      },
      expression: "relatorioExtensao.boolean4_2"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-text-field-money', {
    attrs: {
      "label": "Valor (R$):",
      "properties": {
        readonly: true,
        placeholder: ' ',
      },
      "options": {
        locale: 'pt-BR',
        length: 13,
        precision: 2,
        empty: null,
      }
    },
    model: {
      value: (_vm.relatorioExtensao.valor4_2),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "valor4_2", $$v)
      },
      expression: "relatorioExtensao.valor4_2"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("FUCAM")])]
      },
      proxy: true
    }], null, false, 1966598076),
    model: {
      value: (_vm.relatorioExtensao.boolean4_3),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean4_3", $$v)
      },
      expression: "relatorioExtensao.boolean4_3"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-text-field-money', {
    attrs: {
      "label": "Valor (R$):",
      "properties": {
        readonly: true,
        placeholder: ' ',
      },
      "options": {
        locale: 'pt-BR',
        length: 13,
        precision: 2,
        empty: null,
      }
    },
    model: {
      value: (_vm.relatorioExtensao.valor4_3),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "valor4_3", $$v)
      },
      expression: "relatorioExtensao.valor4_3"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Outros")])]
      },
      proxy: true
    }], null, false, 1698063712),
    model: {
      value: (_vm.relatorioExtensao.boolean4_4),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean4_4", $$v)
      },
      expression: "relatorioExtensao.boolean4_4"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": "",
      "label": "Especifique:",
      "placeholder": " "
    },
    model: {
      value: (_vm.relatorioExtensao.texto17),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "texto17", $$v)
      },
      expression: "relatorioExtensao.texto17"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-text-field-money', {
    attrs: {
      "label": "Valor (R$):",
      "properties": {
        readonly: true,
        placeholder: ' ',
      },
      "options": {
        locale: 'pt-BR',
        length: 13,
        precision: 2,
        empty: null,
      }
    },
    model: {
      value: (_vm.relatorioExtensao.valor4_4),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "valor4_4", $$v)
      },
      expression: "relatorioExtensao.valor4_4"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "item"
  }, [_vm._v("11) Informar as parcerias/colaborações: contatos nacionais e internacionais\n                    efetivamente ocorridos em função da atividade, como convênios, acordos de colaboração e\n                    outros.")])])], 1), _vm._v(" "), (_vm.relatorioExtensao.listaRelatorioParceria.length !== 0) ? _c('v-data-table', {
    staticClass: "tabela",
    attrs: {
      "headers": _vm.headersParcerias,
      "header-props": {
        sortIcon: null
      },
      "items": _vm.relatorioExtensao.listaRelatorioParceria,
      "items-per-page": -1,
      "hide-default-footer": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.relatorioExtensao.listaRelatorioParceria.length === 0) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    staticClass: "alerta",
    attrs: {
      "color": "#00796b",
      "outlined": ""
    }
  }, [_vm._v("\n                    Nenhuma parceria/colaboração foi informada\n                  ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "item"
  }, [_vm._v("12) Informar produtos de extensão")])])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "align": "justify",
      "label": "12.1 - Trabalhos publicados e/ou aceitos para publicação no período, tais como livros, capítulos de livros, artigos em periódicos nacionais e internacionais, resumos em congressos, reuniões científicas e semelhantes. Indicar claramente entre os autores dos trabalhos, quando for o caso, os bolsistas e os voluntários:",
      "value": _vm.relatorioExtensao.texto9 || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "align": "justify",
      "label": "12.2 - Patente ou registro de invenção ou técnica (informar o título, se a patente é nacional, internacional ou “joint ventures” e outros dados que julgar adequados):",
      "value": _vm.relatorioExtensao.texto10 || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "align": "justify",
      "label": "12.3 - Outras atividades extensionistas, científicas ou administrativas que julgar pertinentes no período: organização ou participação em eventos científicos, consultorias, assessorias a órgãos de fomento, etc:",
      "value": _vm.relatorioExtensao.texto11 || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "align": "justify",
      "label": "12.4 - Premiações obtidas em função do desenvolvimento da atividade de extensão (título do prêmio, quem outorgou, data, local); honrarias acadêmicas:",
      "value": _vm.relatorioExtensao.texto12 || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "align": "justify",
      "label": "12.5 - Links para matérias jornalísticas sobre a ação:",
      "value": _vm.relatorioExtensao.texto13 || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "item"
  }, [_vm._v("13) Anexar materiais que comprovem a execução da ação de extensão, como:\n                    fotografias, livros, cartazes, panfletos, folders, manuais e outros:")])])], 1), _vm._v(" "), (_vm.relatorioExtensao.listaRelatorioArquivo.length !== 0) ? _c('v-data-table', {
    staticClass: "tabela",
    attrs: {
      "headers": _vm.headers0,
      "header-props": {
        sortIcon: null
      },
      "items": _vm.relatorioExtensao.listaRelatorioArquivo,
      "items-per-page": -1,
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n                  Total de " + _vm._s(_vm.relatorioExtensao.listaRelatorioArquivo.length) + " arquivos\n                ")]
      }
    }], null, false, 1847614262)
  }) : _vm._e(), _vm._v(" "), (_vm.relatorioExtensao.listaRelatorioArquivo.length === 0) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    staticClass: "alerta",
    attrs: {
      "color": "#00796b",
      "outlined": ""
    }
  }, [_vm._v("\n                    Nenhum material foi anexado\n                  ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [(_vm.coordenadorAdministradorSubmeteremAprovacao() && (_vm.relatorioHabilitadoAcaoRegistroTardio() === false)) ? _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toSubmeter()
      }
    }
  }, [_vm._v("Submeter para aprovação")]) : _vm._e(), _vm._v(" "), (_vm.coordenadorAssessorPodemValidar() || _vm.administradorPodeValidar()) ? _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.verificarPendenciasRelatorio()
      }
    }
  }, [_vm._v("Verificar pendências")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.coordenadorAssessorPodemEditar() || _vm.administradorPodeEditar()) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.toEditar
    }
  }, [_vm._v("Editar")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.toVoltar()
      }
    }
  }, [_vm._v("Voltar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(773)
  __webpack_require__(774)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(775),
  /* template */
  __webpack_require__(776),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2d0f59fa",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 773 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 774 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_date_menu__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_date_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_c_date_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_readonly_field__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_readonly_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_readonly_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_assessor__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_situacaoAtividade__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto', 'idRelatorioExtensao'],
  data: function data() {
    return {
      api_url: "https://pib-api.prod.uks.ufes.br",
      dates: __WEBPACK_IMPORTED_MODULE_5__utils_dates__["a" /* default */],
      formatAssessor: __WEBPACK_IMPORTED_MODULE_4__utils_assessor__["a" /* default */],
      situacaoAtividade: __WEBPACK_IMPORTED_MODULE_7__utils_situacaoAtividade__["a" /* default */],
      listaTipoRelatorio: [{ descricao: 'Parcial' }, { descricao: 'Final' }],
      listaTipoRelatorio2: [{ descricao: 'Final' }],
      projeto: {
        classificacoesPrimariaSecundaria: [{}, {}]
      },
      relatorioForaPrazo: false,
      extensao: {},
      contatos: {},
      dadosCoordenador: {},
      relatorioExtensao: {},
      formularioValido: false,
      headersIntegrantes: [{ text: 'Nome', align: 'left', value: 'nome' }, { text: 'Função', align: 'left', value: 'funcao.descricao' }, { text: 'Vínculo', align: 'left', value: 'vinculo' }, { text: 'CH semanal', align: 'left', value: 'cargaHoraria' }, { text: 'Data inicial', align: 'left', value: 'dataInicial' }, { text: 'Data final', align: 'left', value: 'dataFinal' }],
      headersParcerias: [{ text: 'Nome do parceiro institucional/colaborador', align: 'left', value: 'nome' }, { text: 'Descrição da parceria/colaboração', align: 'left', value: 'detalhamento' }],
      headers0: [{ text: 'Nome', align: 'left', value: 'nome' }, { text: 'Tipo', align: 'left', value: 'tipoArquivo.descricao' }, { text: 'Observação', left: 'left', value: 'observacao' }]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])('auth', ['administrador'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    // Retorna a situação do relatório.
    getSituacaoRelatorio: function getSituacaoRelatorio(situacaoRelatorioTecnicoItem) {
      if (situacaoRelatorioTecnicoItem === 1) {
        return 'Em elaboração';
      } else if (situacaoRelatorioTecnicoItem === 2) {
        return 'Aguardando aprovação';
      } else if (situacaoRelatorioTecnicoItem === 3) {
        return 'Aprovado';
      } else if (situacaoRelatorioTecnicoItem === 4) {
        return 'Reprovado';
      } else {
        return 'Situação inválida';
      }
    }
  }),
  mounted: function mounted() {
    var _this = this;

    // Carrega a ação de extensão.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].getProjeto(this.idProjeto).then(function (response) {
      _this.projeto = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    });

    // Carrega o relatório.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando relatório.' });
    __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].getRelatorioExtensao(this.idProjeto, this.idRelatorioExtensao).then(function (response) {
      _this.relatorioExtensao = response.data;
      _this.relatorioExtensao.dtInicialFormatada = __WEBPACK_IMPORTED_MODULE_5__utils_dates__["a" /* default */].format(_this.relatorioExtensao.dtInicial);
      _this.relatorioExtensao.dtFinalFormatada = __WEBPACK_IMPORTED_MODULE_5__utils_dates__["a" /* default */].format(_this.relatorioExtensao.dtFinal);
      _this.relatorioExtensao.dtNovaConclusaoFormatada = __WEBPACK_IMPORTED_MODULE_5__utils_dates__["a" /* default */].format(_this.relatorioExtensao.dtNovaConclusao);
      _this.relatorioExtensao.dtAprovacaoFormatada = __WEBPACK_IMPORTED_MODULE_5__utils_dates__["a" /* default */].format(_this.relatorioExtensao.dtAprovacaoRelatorio);
      _this.relatorioExtensao.dtReprovacaoFormatada = __WEBPACK_IMPORTED_MODULE_5__utils_dates__["a" /* default */].format(_this.relatorioExtensao.dtReprovacaoRelatorio);
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando relatório.' });
    });

    // Endpoint que retorna se o relatório está fora do prazo para envio.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações adicionais.' });
    __WEBPACK_IMPORTED_MODULE_6__utils_projetos__["a" /* default */].getRelatorioTecnicoForaPrazo(this.idProjeto, this.idRelatorioExtensao).then(function (response) {
      _this.relatorioForaPrazo = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações adicionais.' });
    });
  },
  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_3__components_toolbars_basic_toolbar___default.a,
    'c-date-menu': __WEBPACK_IMPORTED_MODULE_1__components_c_date_menu___default.a,
    'c-readonly-field': __WEBPACK_IMPORTED_MODULE_2__components_c_readonly_field___default.a
  }
});

/***/ }),
/* 776 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    staticStyle: {
      "position": "absolute",
      "z-index": "1",
      "left": "40px",
      "top": "40px"
    }
  }, [_c('v-btn', {
    staticClass: "btnGerarPDF",
    attrs: {
      "color": "primary",
      "onclick": "window.print()"
    }
  }, [_vm._v("Gerar PDF")])], 1), _vm._v(" "), _c('v-card', {
    staticClass: "text-xs-center",
    staticStyle: {
      "margin": "0px 30px 20px"
    }
  }, [_c('br'), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('h2', [_vm._v("Relatório Técnico de Extensão " + _vm._s(this.relatorioExtensao.ordem) + " - " + _vm._s(this.projeto.titulo))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('basic-toolbar', {
    staticStyle: {
      "text-align": "center",
      "height": "12.5px",
      "padding-top": "7px"
    }
  }), _vm._v(" "), _c('v-card-text', [_c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(this.relatorioExtensao.tituloAcaoExtensao !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Título",
      "value": this.relatorioExtensao.tituloAcaoExtensao
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Título",
      "value": "-"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(this.relatorioExtensao.nomeCoordenador !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Nome do coordenador",
      "value": this.relatorioExtensao.nomeCoordenador
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Nome do coordenador",
      "value": "-"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md6": "",
      "xs12": ""
    }
  }, [(this.relatorioExtensao.numeroAcaoExtensao !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Número",
      "value": this.relatorioExtensao.numeroAcaoExtensao
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Número",
      "value": "-"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": "",
      "xs12": ""
    }
  }, [(this.relatorioExtensao.tipoAcaoExtensao !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Tipo",
      "value": this.relatorioExtensao.tipoAcaoExtensao
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Tipo",
      "value": "-"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(this.relatorioExtensao.unidade !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Unidade",
      "value": this.relatorioExtensao.unidade
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Unidade",
      "value": "-"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(this.relatorioExtensao.emailCoordenador !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "E-mail do coordenador",
      "value": this.relatorioExtensao.emailCoordenador
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "E-mail do coordenador",
      "value": "-"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md6": "",
      "xs12": ""
    }
  }, [(this.relatorioExtensao.liberacaoCargaHorariaCoordenador !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Liberação de carga horária do coordenador",
      "value": this.relatorioExtensao.liberacaoCargaHorariaCoordenador == true ? 'Sim' : 'Não'
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Liberação de carga horária do coordenador",
      "value": "-"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": "",
      "xs12": ""
    }
  }, [(this.relatorioExtensao.cargaHorariaCoordenador !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Carga horária",
      "value": this.relatorioExtensao.cargaHorariaCoordenador
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Carga horária",
      "value": "-"
    }
  })], 1)], 1), _vm._v(" "), ((_vm.projeto.classificacaoSecundaria.id === 39729 || _vm.projeto.classificacaoSecundaria.id === 44194 || _vm.projeto.classificacaoSecundaria.id === 44195 || _vm.projeto.classificacaoSecundaria.id === 39730) && _vm.relatorioExtensao.tipoRelatorioTecnicoItem === 3) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(this.relatorioExtensao.mudancaDatasAcao !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Houve mudança nas datas de início e/ou de conclusão da ação de extensão?",
      "value": this.relatorioExtensao.mudancaDatasAcao === 'S' ? 'Sim' : 'Não'
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Houve mudança nas datas de início e/ou de conclusão da ação de extensão?",
      "value": "-"
    }
  })], 1), _vm._v(" "), (this.relatorioExtensao.mudancaDatasAcao === 'S') ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(this.relatorioExtensao.justificativaMudancaDatasAcao !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Justificativa",
      "value": this.relatorioExtensao.justificativaMudancaDatasAcao
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Justificativa",
      "value": "-"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "textoRelatorio"
  }, [_vm._v("Período a que se refere o relatório")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md5": "",
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Início:",
      "value": _vm.relatorioExtensao.dtInicialFormatada
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md1": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md5": "",
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Fim:",
      "value": _vm.relatorioExtensao.dtFinalFormatada
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md1": ""
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.relatorioExtensao.situacaoRelatorioTecnicoItem !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Situação do relatório",
      "value": _vm.getSituacaoRelatorio(_vm.relatorioExtensao.situacaoRelatorioTecnicoItem)
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Situação do relatório",
      "value": "-"
    }
  })], 1)], 1), _vm._v(" "), (_vm.relatorioExtensao.situacaoRelatorioTecnicoItem !== null && (_vm.relatorioExtensao.situacaoRelatorioTecnicoItem === 3 || _vm.relatorioExtensao.situacaoRelatorioTecnicoItem === 4)) ? _c('div', [(_vm.relatorioExtensao.situacaoRelatorioTecnicoItem !== null && _vm.relatorioExtensao.situacaoRelatorioTecnicoItem === 3) ? _c('div', [_c('br'), _vm._v(" "), (_vm.relatorioExtensao.situacaoRelatorioTecnicoItem !== null && _vm.relatorioExtensao.situacaoRelatorioTecnicoItem === 3) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.relatorioExtensao.dtAprovacaoRelatorio !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Data de aprovação do relatório pela Câmara de Extensão",
      "value": _vm.relatorioExtensao.dtAprovacaoFormatada
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Data de aprovação do relatório pela Câmara de Extensão",
      "value": "-"
    }
  })], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.relatorioExtensao.situacaoRelatorioTecnicoItem !== null && _vm.relatorioExtensao.situacaoRelatorioTecnicoItem === 4) ? _c('div', [_c('br'), _vm._v(" "), (_vm.relatorioExtensao.situacaoRelatorioTecnicoItem !== null && _vm.relatorioExtensao.situacaoRelatorioTecnicoItem === 4) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.relatorioExtensao.dtReprovacaoRelatorio !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Data de reprovação do relatório pela Câmara de Extensão",
      "value": _vm.relatorioExtensao.dtReprovacaoFormatada
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Data de reprovação do relatório pela Câmara de Extensão",
      "value": "-"
    }
  })], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.relatorioExtensao.processo !== null) ? _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Processo",
      "value": _vm.relatorioExtensao.processo
    }
  }) : _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "Processo",
      "value": "-"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "item"
  }, [(_vm.relatorioExtensao.tipoRelatorioTecnicoItem === 1) ? _c('c-readonly-field', {
    attrs: {
      "label": "Tipo do relatório",
      "value": "Relatório Parcial: Deverá ser apresentado a cada 12 meses de atividade e encaminhado à ProEx no prazo máximo de 60 dias após o término do interstício."
    }
  }) : _vm._e(), _vm._v(" "), (_vm.relatorioExtensao.tipoRelatorioTecnicoItem === 2) ? _c('c-readonly-field', {
    attrs: {
      "label": "Tipo do relatório",
      "value": "Relatório Parcial com Renovação: Deverá ser apresentado no prazo máximo de até 60 dias do último interstício da ação indicando o período de renovação."
    }
  }) : _vm._e(), _vm._v(" "), (_vm.relatorioExtensao.tipoRelatorioTecnicoItem === 3) ? _c('c-readonly-field', {
    attrs: {
      "label": "Tipo do relatório",
      "value": "Relatório Final: Deverá ser apresentado no prazo máximo de até 60 dias após a data prevista de conclusão da ação extensionista ou do término das atividades, no caso de encerramento antes do previsto."
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.relatorioExtensao.tipoRelatorioTecnicoItem) ? _c('c-readonly-field', {
    attrs: {
      "label": "Tipo do relatório",
      "value": "-"
    }
  }) : _vm._e()], 1)])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.relatorioExtensao.tipoRelatorioTecnicoItem === 2) ? _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "item",
    attrs: {
      "label": "Nova data de conclusão da ação de extensão:",
      "value": _vm.relatorioExtensao.dtNovaConclusaoFormatada
    }
  }), _vm._v(" "), _c('br')], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.relatorioForaPrazo === true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "item",
    attrs: {
      "label": "Apresentar justificativa para envio do relatório fora do prazo:",
      "align": "justify",
      "value": _vm.relatorioExtensao.justificativaForaPrazo || '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.relatorioForaPrazo === true) ? _c('div', [_c('br'), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "item",
    attrs: {
      "label": "1) A metodologia foi alterada para alcançar os objetivos da proposta inicial?",
      "align": "justify",
      "value": _vm.relatorioExtensao.opcao5 === null ? '-' : _vm.relatorioExtensao.opcao5 === 'S' ? 'Sim' : 'Não'
    }
  })], 1)], 1), _vm._v(" "), (_vm.relatorioExtensao.opcao5 === 'S') ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "align": "justify",
      "label": "Apresente sucintamente as alterações implementadas:",
      "value": _vm.relatorioExtensao.texto1 !== null && _vm.relatorioExtensao.texto1 !== '' ? _vm.relatorioExtensao.texto1 : '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "item",
    attrs: {
      "label": "2) Local de execução da ação:",
      "align": "justify",
      "value": _vm.relatorioExtensao.texto2 || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.relatorioExtensao.texto3 != null && _vm.relatorioExtensao.texto3.length !== 0 && _vm.relatorioExtensao.situacaoRelatorioTecnicoItem !== 1) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "item",
    attrs: {
      "label": "3) Informar o quantitativo total de indivíduos beneficiados no período deste relatório",
      "align": "justify",
      "value": _vm.relatorioExtensao.texto3 || '-'
    }
  })], 1)], 1) : _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "item"
  }, [_vm._v("3) Informar o quantitativo total de indivíduos beneficiados no período deste\n                relatório")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "3.1 - Público-alvo direto (público concretamente registrado):",
      "value": _vm.relatorioExtensao.publicoAlvoDireto || '-'
    }
  }), _vm._v(" "), _c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "3.2 - Público-alvo indireto (estimativa de público atingido indiretamente):",
      "value": _vm.relatorioExtensao.publicoAlvoIndireto || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "item"
  }, [_vm._v("4) Atividades e resultados")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, _vm._l((_vm.relatorioExtensao.listaRelatorioAtividade), function(item, i) {
    return _c('v-col', {
      key: i
    }, [_c('v-card', {
      attrs: {
        "outlined": ""
      }
    }, [_c('v-card-text', [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "text-xs-left": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('c-readonly-field', {
      staticClass: "textoRelatorio",
      attrs: {
        "align": "justify",
        "label": "Nome e descrição sucinta da atividade",
        "value": item.descricao
      }
    }), _vm._v(" "), (item.detalhamento !== null && item.detalhamento !== '') ? _c('c-readonly-field', {
      staticClass: "textoRelatorio",
      attrs: {
        "align": "justify",
        "value": item.detalhamento
      }
    }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "text-xs-left": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('c-readonly-field', {
      staticClass: "textoRelatorio",
      attrs: {
        "align": "justify",
        "label": "Principal objetivo específico ao qual esta atividade está vinculada",
        "value": item.objetivoEspecifico !== null && item.objetivoEspecifico !== '' ? item.objetivoEspecifico : '-'
      }
    })], 1)], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "text-xs-left": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [(item.situacaoAtividade !== null) ? _c('c-readonly-field', {
      staticClass: "textoRelatorio",
      attrs: {
        "label": "Situação",
        "value": _vm.situacaoAtividade.format(item.situacaoAtividade.item)
      }
    }) : _vm._e(), _vm._v(" "), (item.situacaoAtividade === null) ? _c('c-readonly-field', {
      staticClass: "textoRelatorio",
      attrs: {
        "label": "Situação",
        "value": "-"
      }
    }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "text-xs-left": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "md5": "",
        "xs12": ""
      }
    }, [_c('c-readonly-field', {
      staticClass: "textoRelatorio",
      attrs: {
        "label": "Início efetivo",
        "value": _vm.dates.format(item.dtInicioEfetivo)
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "md1": ""
      }
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "md5": "",
        "xs12": ""
      }
    }, [_c('c-readonly-field', {
      staticClass: "textoRelatorio",
      attrs: {
        "label": "Conclusão efetiva",
        "value": _vm.dates.format(item.dtFimEfetivo)
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "md1": ""
      }
    })], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "text-xs-left": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('c-readonly-field', {
      staticClass: "textoRelatorio",
      attrs: {
        "align": "justify",
        "label": "Resultados",
        "value": item.resultados !== null && item.resultados !== '' ? item.resultados : '-'
      }
    })], 1)], 1)], 1)], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "item",
    attrs: {
      "label": "5) Discutir de forma geral a relevância das atividades, seu mérito extensionista, impacto, abrangência social, interdisciplinaridade e visibilidade:",
      "align": "justify",
      "value": _vm.relatorioExtensao.texto4 || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "item",
    attrs: {
      "label": "6) Descrever de que maneira a ação de extensão contribuiu para a formação do aluno de graduação integrante da equipe:",
      "align": "justify",
      "value": _vm.relatorioExtensao.texto5 || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "item"
  }, [_vm._v("7) Relacionar os fatores que interferiram na execução da ação")])])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "align": "justify",
      "label": "7.1 - Positivos:",
      "value": _vm.relatorioExtensao.texto6 || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "align": "justify",
      "label": "7.2 - Negativos:",
      "value": _vm.relatorioExtensao.texto7 || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "item"
  }, [_vm._v("8) Equipe.")])])], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "tabelaEquipe",
    attrs: {
      "headers": _vm.headersIntegrantes,
      "items": _vm.relatorioExtensao.listaRelatorioParticipante,
      "items-per-page": -1,
      "hide-default-footer": "",
      "header-props": {
        sortIcon: null
      }
    },
    scopedSlots: _vm._u([{
      key: "item.assessor",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.formatAssessor.format(props.item.assessor, props.item.funcao.item)))]
      }
    }, {
      key: "item.dataInicial",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dataInicial)))]
      }
    }, {
      key: "item.dataFinal",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dataFinal)))]
      }
    }])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "item"
  }, [_vm._v("9) Formas de apoio")])])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "9.1 - A ação de extensão recebeu apoio da ProEx?",
      "value": _vm.relatorioExtensao.opcao1 === null ? '-' : _vm.relatorioExtensao.opcao1 === 'S' ? 'Sim' : 'Não'
    }
  })], 1)], 1), _vm._v(" "), (_vm.relatorioExtensao.opcao1 === 'S') ? _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "textoRelatorioSubitem"
  }, [_vm._v("Especifique a(s) forma(s) de apoio:")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Bolsa")])]
      },
      proxy: true
    }], null, false, 3329032051),
    model: {
      value: (_vm.relatorioExtensao.boolean1_1),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean1_1", $$v)
      },
      expression: "relatorioExtensao.boolean1_1"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Passagem")])]
      },
      proxy: true
    }], null, false, 2386299455),
    model: {
      value: (_vm.relatorioExtensao.boolean1_2),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean1_2", $$v)
      },
      expression: "relatorioExtensao.boolean1_2"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Diária")])]
      },
      proxy: true
    }], null, false, 3814078326),
    model: {
      value: (_vm.relatorioExtensao.boolean1_3),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean1_3", $$v)
      },
      expression: "relatorioExtensao.boolean1_3"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Material de consumo")])]
      },
      proxy: true
    }], null, false, 1871919084),
    model: {
      value: (_vm.relatorioExtensao.boolean1_4),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean1_4", $$v)
      },
      expression: "relatorioExtensao.boolean1_4"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Material permanente")])]
      },
      proxy: true
    }], null, false, 961207380),
    model: {
      value: (_vm.relatorioExtensao.boolean1_5),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean1_5", $$v)
      },
      expression: "relatorioExtensao.boolean1_5"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Recurso financeiro")])]
      },
      proxy: true
    }], null, false, 1798790707),
    model: {
      value: (_vm.relatorioExtensao.boolean1_6),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean1_6", $$v)
      },
      expression: "relatorioExtensao.boolean1_6"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Espaço físico")])]
      },
      proxy: true
    }], null, false, 3522186450),
    model: {
      value: (_vm.relatorioExtensao.boolean1_7),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean1_7", $$v)
      },
      expression: "relatorioExtensao.boolean1_7"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Divulgação")])]
      },
      proxy: true
    }], null, false, 2707204751),
    model: {
      value: (_vm.relatorioExtensao.boolean1_8),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean1_8", $$v)
      },
      expression: "relatorioExtensao.boolean1_8"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Transporte")])]
      },
      proxy: true
    }], null, false, 1984826566),
    model: {
      value: (_vm.relatorioExtensao.boolean1_9),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean1_9", $$v)
      },
      expression: "relatorioExtensao.boolean1_9"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Outros")])]
      },
      proxy: true
    }], null, false, 1698063712),
    model: {
      value: (_vm.relatorioExtensao.boolean1_10),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean1_10", $$v)
      },
      expression: "relatorioExtensao.boolean1_10"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm6": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "align": "justify",
      "label": "Especifique:"
    },
    model: {
      value: (_vm.relatorioExtensao.texto14),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "texto14", $$v)
      },
      expression: "relatorioExtensao.texto14"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "label": "9.2 - A ação de extensão recebeu apoio de outras instituições e/ou órgãos de fomento nacionais, internacionais ou estrangeiros?",
      "value": _vm.relatorioExtensao.opcao2 === null ? '-' : _vm.relatorioExtensao.opcao2 === 'S' ? 'Sim' : 'Não'
    }
  })], 1)], 1), _vm._v(" "), (_vm.relatorioExtensao.opcao2 === 'S') ? _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "textoRelatorioSubitem"
  }, [_vm._v("Especifique a(s) forma(s) de apoio:")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Bolsa")])]
      },
      proxy: true
    }], null, false, 3329032051),
    model: {
      value: (_vm.relatorioExtensao.boolean2_1),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean2_1", $$v)
      },
      expression: "relatorioExtensao.boolean2_1"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Passagem")])]
      },
      proxy: true
    }], null, false, 2386299455),
    model: {
      value: (_vm.relatorioExtensao.boolean2_2),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean2_2", $$v)
      },
      expression: "relatorioExtensao.boolean2_2"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Diária")])]
      },
      proxy: true
    }], null, false, 3814078326),
    model: {
      value: (_vm.relatorioExtensao.boolean2_3),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean2_3", $$v)
      },
      expression: "relatorioExtensao.boolean2_3"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Material de consumo")])]
      },
      proxy: true
    }], null, false, 1871919084),
    model: {
      value: (_vm.relatorioExtensao.boolean2_4),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean2_4", $$v)
      },
      expression: "relatorioExtensao.boolean2_4"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Material permanente")])]
      },
      proxy: true
    }], null, false, 961207380),
    model: {
      value: (_vm.relatorioExtensao.boolean2_5),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean2_5", $$v)
      },
      expression: "relatorioExtensao.boolean2_5"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Recurso financeiro")])]
      },
      proxy: true
    }], null, false, 1798790707),
    model: {
      value: (_vm.relatorioExtensao.boolean2_6),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean2_6", $$v)
      },
      expression: "relatorioExtensao.boolean2_6"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Espaço físico")])]
      },
      proxy: true
    }], null, false, 3522186450),
    model: {
      value: (_vm.relatorioExtensao.boolean2_7),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean2_7", $$v)
      },
      expression: "relatorioExtensao.boolean2_7"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Divulgação")])]
      },
      proxy: true
    }], null, false, 2707204751),
    model: {
      value: (_vm.relatorioExtensao.boolean2_8),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean2_8", $$v)
      },
      expression: "relatorioExtensao.boolean2_8"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Transporte")])]
      },
      proxy: true
    }], null, false, 1984826566),
    model: {
      value: (_vm.relatorioExtensao.boolean2_9),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean2_9", $$v)
      },
      expression: "relatorioExtensao.boolean2_9"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Outros")])]
      },
      proxy: true
    }], null, false, 1698063712),
    model: {
      value: (_vm.relatorioExtensao.boolean2_10),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean2_10", $$v)
      },
      expression: "relatorioExtensao.boolean2_10"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm6": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "align": "justify",
      "label": "Especifique:"
    },
    model: {
      value: (_vm.relatorioExtensao.texto15),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "texto15", $$v)
      },
      expression: "relatorioExtensao.texto15"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), ((_vm.relatorioExtensao.opcao1 === 'S' && _vm.relatorioExtensao.boolean1_6 === true) || (_vm.relatorioExtensao.opcao2 === 'S' && _vm.relatorioExtensao.boolean2_6 === true)) ? _c('div', [_c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [((_vm.relatorioExtensao.opcao1 === 'S' && _vm.relatorioExtensao.boolean1_6 === true) && (_vm.relatorioExtensao.opcao2 === 'N' || _vm.relatorioExtensao.boolean2_6 === false)) ? _c('label', {
    staticClass: "textoRelatorio"
  }, [_vm._v("\n                  9.3 - Os recursos financeiros indicados no item 9.1 foram executados por:\n                ")]) : _vm._e(), _vm._v(" "), ((_vm.relatorioExtensao.opcao1 === 'N' || _vm.relatorioExtensao.boolean1_6 === false) && (_vm.relatorioExtensao.opcao2 === 'S' && _vm.relatorioExtensao.boolean2_6 === true)) ? _c('label', {
    staticClass: "textoRelatorio"
  }, [_vm._v("\n                  9.3 - Os recursos financeiros indicados no item 9.2 foram executados por:\n                ")]) : _vm._e(), _vm._v(" "), ((_vm.relatorioExtensao.opcao1 === 'S' && _vm.relatorioExtensao.boolean1_6 === true) && (_vm.relatorioExtensao.opcao2 === 'S' && _vm.relatorioExtensao.boolean2_6 === true)) ? _c('label', {
    staticClass: "textoRelatorio"
  }, [_vm._v("\n                  9.3 - Os recursos financeiros indicados nos itens 9.1 e 9.2 foram executados por:\n                ")]) : _vm._e()])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("UFES")])]
      },
      proxy: true
    }], null, false, 4124160677),
    model: {
      value: (_vm.relatorioExtensao.boolean3_1),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean3_1", $$v)
      },
      expression: "relatorioExtensao.boolean3_1"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-text-field-money', {
    attrs: {
      "label": "Valor (R$):",
      "properties": {
        readonly: true,
        placeholder: ' ',
      },
      "options": {
        locale: 'pt-BR',
        length: 13,
        precision: 2,
        empty: null,
      }
    },
    model: {
      value: (_vm.relatorioExtensao.valor3_1),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "valor3_1", $$v)
      },
      expression: "relatorioExtensao.valor3_1"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs0": "",
      "sm2": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("CNPq")])]
      },
      proxy: true
    }], null, false, 1739938252),
    model: {
      value: (_vm.relatorioExtensao.boolean3_2),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean3_2", $$v)
      },
      expression: "relatorioExtensao.boolean3_2"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-text-field-money', {
    attrs: {
      "label": "Valor (R$):",
      "properties": {
        readonly: true,
        placeholder: ' ',
      },
      "options": {
        locale: 'pt-BR',
        length: 13,
        precision: 2,
        empty: null,
      }
    },
    model: {
      value: (_vm.relatorioExtensao.valor3_2),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "valor3_2", $$v)
      },
      expression: "relatorioExtensao.valor3_2"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("CAPES")])]
      },
      proxy: true
    }], null, false, 3158995236),
    model: {
      value: (_vm.relatorioExtensao.boolean3_3),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean3_3", $$v)
      },
      expression: "relatorioExtensao.boolean3_3"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-text-field-money', {
    attrs: {
      "label": "Valor (R$):",
      "properties": {
        readonly: true,
        placeholder: ' ',
      },
      "options": {
        locale: 'pt-BR',
        length: 13,
        precision: 2,
        empty: null,
      }
    },
    model: {
      value: (_vm.relatorioExtensao.valor3_3),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "valor3_3", $$v)
      },
      expression: "relatorioExtensao.valor3_3"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs0": "",
      "sm2": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("FAPES")])]
      },
      proxy: true
    }], null, false, 4155422625),
    model: {
      value: (_vm.relatorioExtensao.boolean3_4),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean3_4", $$v)
      },
      expression: "relatorioExtensao.boolean3_4"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-text-field-money', {
    attrs: {
      "label": "Valor (R$):",
      "properties": {
        readonly: true,
        placeholder: ' ',
      },
      "options": {
        locale: 'pt-BR',
        length: 13,
        precision: 2,
        empty: null,
      }
    },
    model: {
      value: (_vm.relatorioExtensao.valor3_4),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "valor3_4", $$v)
      },
      expression: "relatorioExtensao.valor3_4"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("FEST")])]
      },
      proxy: true
    }], null, false, 1101797796),
    model: {
      value: (_vm.relatorioExtensao.boolean3_5),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean3_5", $$v)
      },
      expression: "relatorioExtensao.boolean3_5"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-text-field-money', {
    attrs: {
      "label": "Valor (R$):",
      "properties": {
        readonly: true,
        placeholder: ' ',
      },
      "options": {
        locale: 'pt-BR',
        length: 13,
        precision: 2,
        empty: null,
      }
    },
    model: {
      value: (_vm.relatorioExtensao.valor3_5),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "valor3_5", $$v)
      },
      expression: "relatorioExtensao.valor3_5"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs0": "",
      "sm2": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("FUCAM")])]
      },
      proxy: true
    }], null, false, 1966598076),
    model: {
      value: (_vm.relatorioExtensao.boolean3_6),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean3_6", $$v)
      },
      expression: "relatorioExtensao.boolean3_6"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-text-field-money', {
    attrs: {
      "label": "Valor (R$):",
      "properties": {
        readonly: true,
        placeholder: ' ',
      },
      "options": {
        locale: 'pt-BR',
        length: 13,
        precision: 2,
        empty: null,
      }
    },
    model: {
      value: (_vm.relatorioExtensao.valor3_6),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "valor3_6", $$v)
      },
      expression: "relatorioExtensao.valor3_6"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Outros")])]
      },
      proxy: true
    }], null, false, 1698063712),
    model: {
      value: (_vm.relatorioExtensao.boolean3_7),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean3_7", $$v)
      },
      expression: "relatorioExtensao.boolean3_7"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm5": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "align": "justify",
      "label": "Especifique:"
    },
    model: {
      value: (_vm.relatorioExtensao.texto16),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "texto16", $$v)
      },
      expression: "relatorioExtensao.texto16"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-text-field-money', {
    attrs: {
      "label": "Valor (R$):",
      "properties": {
        readonly: true,
        placeholder: ' ',
      },
      "options": {
        locale: 'pt-BR',
        length: 13,
        precision: 2,
        empty: null,
      }
    },
    model: {
      value: (_vm.relatorioExtensao.valor3_7),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "valor3_7", $$v)
      },
      expression: "relatorioExtensao.valor3_7"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "item",
    attrs: {
      "label": "10) Houve cobrança de taxa de inscrição, participação, visitação ou similar?",
      "value": _vm.relatorioExtensao.opcao4 === null ? '-' : _vm.relatorioExtensao.opcao4 === 'S' ? 'Sim' : 'Não'
    }
  })], 1)], 1), _vm._v(" "), (_vm.relatorioExtensao.opcao4 === 'S') ? _c('div', [_c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "textoRelatorio"
  }, [_vm._v("Os recursos financeiros foram administrados por:")])])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("UFES")])]
      },
      proxy: true
    }], null, false, 4124160677),
    model: {
      value: (_vm.relatorioExtensao.boolean4_1),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean4_1", $$v)
      },
      expression: "relatorioExtensao.boolean4_1"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-text-field-money', {
    attrs: {
      "label": "Valor (R$):",
      "properties": {
        readonly: true,
        placeholder: ' ',
      },
      "options": {
        locale: 'pt-BR',
        length: 13,
        precision: 2,
        empty: null,
      }
    },
    model: {
      value: (_vm.relatorioExtensao.valor4_1),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "valor4_1", $$v)
      },
      expression: "relatorioExtensao.valor4_1"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("FEST")])]
      },
      proxy: true
    }], null, false, 1101797796),
    model: {
      value: (_vm.relatorioExtensao.boolean4_2),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean4_2", $$v)
      },
      expression: "relatorioExtensao.boolean4_2"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-text-field-money', {
    attrs: {
      "label": "Valor (R$):",
      "properties": {
        readonly: true,
        placeholder: ' ',
      },
      "options": {
        locale: 'pt-BR',
        length: 13,
        precision: 2,
        empty: null,
      }
    },
    model: {
      value: (_vm.relatorioExtensao.valor4_2),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "valor4_2", $$v)
      },
      expression: "relatorioExtensao.valor4_2"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("FUCAM")])]
      },
      proxy: true
    }], null, false, 1966598076),
    model: {
      value: (_vm.relatorioExtensao.boolean4_3),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean4_3", $$v)
      },
      expression: "relatorioExtensao.boolean4_3"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-text-field-money', {
    attrs: {
      "label": "Valor (R$):",
      "properties": {
        readonly: true,
        placeholder: ' ',
      },
      "options": {
        locale: 'pt-BR',
        length: 13,
        precision: 2,
        empty: null,
      }
    },
    model: {
      value: (_vm.relatorioExtensao.valor4_3),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "valor4_3", $$v)
      },
      expression: "relatorioExtensao.valor4_3"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          staticClass: "v-checkbox_label"
        }, [_vm._v("Outros")])]
      },
      proxy: true
    }], null, false, 1698063712),
    model: {
      value: (_vm.relatorioExtensao.boolean4_4),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "boolean4_4", $$v)
      },
      expression: "relatorioExtensao.boolean4_4"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "align": "justify",
      "label": "Especifique:"
    },
    model: {
      value: (_vm.relatorioExtensao.texto17),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "texto17", $$v)
      },
      expression: "relatorioExtensao.texto17"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm2": ""
    }
  }, [_c('v-text-field-money', {
    attrs: {
      "label": "Valor (R$):",
      "properties": {
        readonly: true,
        placeholder: ' ',
      },
      "options": {
        locale: 'pt-BR',
        length: 13,
        precision: 2,
        empty: null,
      }
    },
    model: {
      value: (_vm.relatorioExtensao.valor4_4),
      callback: function($$v) {
        _vm.$set(_vm.relatorioExtensao, "valor4_4", $$v)
      },
      expression: "relatorioExtensao.valor4_4"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "item"
  }, [_vm._v("11) Informar as parcerias/colaborações: contatos nacionais e internacionais efetivamente\n                ocorridos em função da atividade, como convênios, acordos de colaboração e outros.")])])], 1), _vm._v(" "), (_vm.relatorioExtensao.listaRelatorioParceria.length !== 0) ? _c('v-data-table', {
    staticClass: "tabela",
    attrs: {
      "headers": _vm.headersParcerias,
      "header-props": {
        sortIcon: null
      },
      "items": _vm.relatorioExtensao.listaRelatorioParceria,
      "items-per-page": -1,
      "hide-default-footer": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.relatorioExtensao.listaRelatorioParceria.length === 0) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    staticClass: "alerta",
    attrs: {
      "color": "#00796b",
      "outlined": ""
    }
  }, [_vm._v("\n                Nenhuma parceria/colaboração foi informada\n              ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "item"
  }, [_vm._v("12) Informar produtos de extensão")])])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "align": "justify",
      "label": "12.1 - Trabalhos publicados e/ou aceitos para publicação no período, tais como livros, capítulos de livros, artigos em periódicos nacionais e internacionais, resumos em congressos, reuniões científicas e semelhantes. Indicar claramente entre os autores dos trabalhos, quando for o caso, os bolsistas e os voluntários:",
      "value": _vm.relatorioExtensao.texto9 || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "align": "justify",
      "label": "12.2 - Patente ou registro de invenção ou técnica (informar o título, se a patente é nacional, internacional ou “joint ventures” e outros dados que julgar adequados):",
      "value": _vm.relatorioExtensao.texto10 || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "align": "justify",
      "label": "12.3 - Outras atividades extensionistas, científicas ou administrativas que julgar pertinentes no período: organização ou participação em eventos científicos, consultorias, assessorias a órgãos de fomento, etc:",
      "value": _vm.relatorioExtensao.texto11 || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "align": "justify",
      "label": "12.4 - Premiações obtidas em função do desenvolvimento da atividade de extensão (título do prêmio, quem outorgou, data, local); honrarias acadêmicas:",
      "value": _vm.relatorioExtensao.texto12 || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    staticClass: "textoRelatorio",
    attrs: {
      "align": "justify",
      "label": "12.5 - Links para matérias jornalísticas sobre a ação:",
      "value": _vm.relatorioExtensao.texto13 || '-'
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "item"
  }, [_vm._v("13) Anexar materiais que comprovem a execução da ação de extensão, como: fotografias,\n                livros, cartazes, panfletos, folders, manuais e outros:")])])], 1), _vm._v(" "), (_vm.relatorioExtensao.listaRelatorioArquivo.length !== 0) ? _c('v-data-table', {
    staticClass: "tabela",
    attrs: {
      "headers": _vm.headers0,
      "header-props": {
        sortIcon: null
      },
      "items": _vm.relatorioExtensao.listaRelatorioArquivo,
      "items-per-page": -1,
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n              Total de " + _vm._s(_vm.relatorioExtensao.listaRelatorioArquivo.length) + " arquivos\n            ")]
      }
    }], null, false, 1169591094)
  }) : _vm._e(), _vm._v(" "), (_vm.relatorioExtensao.listaRelatorioArquivo.length === 0) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    staticClass: "alerta",
    attrs: {
      "color": "#00796b",
      "outlined": ""
    }
  }, [_vm._v("\n                Nenhum material foi anexado\n              ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(778)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(779),
  /* template */
  __webpack_require__(780),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 778 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_bolsas__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      listaFrequencia: [],
      projeto: {},
      integrante: {},
      dates: __WEBPACK_IMPORTED_MODULE_3__utils_dates__["a" /* default */],
      search: null,
      sortBy: 'dtCriacao',
      sortDesc: true,
      itemsPerPage: 10,
      opcoesPaginacao: [10, 25, 50, { text: 'Todas', value: -1 }],
      headers: [{ text: 'Ano', align: 'left', value: 'ano' }, { text: 'Mês', align: 'left', value: 'mes' }, { text: 'Observação', align: 'left', value: 'observacao' }, { text: 'Atividades Realizadas', align: 'left', value: 'atividadesRealizadas' }]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])('auth', ['administrador', 'usuarioPROEX'])),
  props: ['items', 'idProjeto', 'idParticipante'],
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    truncate: function truncate(string, limit) {
      if (string.length > limit) return string.substring(0, limit) + '...';else return string;
    },

    toCriarFrequencia: function toCriarFrequencia() {
      this.$router.push({ name: 'CriarFrequencia' });
    }
  }),
  mounted: function mounted() {
    var _this = this;

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando integrante.' });
    __WEBPACK_IMPORTED_MODULE_4__utils_projetos__["a" /* default */].getIntegrante(this.idProjeto, this.idParticipante).then(function (response) {
      _this.integrante = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando integrante.' });
    });

    __WEBPACK_IMPORTED_MODULE_4__utils_projetos__["a" /* default */].getProjeto(this.idProjeto).then(function (response) {
      _this.projeto = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' });
    });

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando frequências.' });
    __WEBPACK_IMPORTED_MODULE_5__utils_bolsas__["a" /* default */].getFrequencias(this.idProjeto, this.idParticipante).then(function (response) {
      _this.listaFrequencia = response.data.slice();
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando frequências.' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a
  }
});

/***/ }),
/* 780 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', [_c('basic-toolbar', {
    attrs: {
      "title": 'Frequência do Bolsista'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome do Bolsista",
      "readonly": "",
      "max-height": "400"
    },
    model: {
      value: (_vm.integrante.nome),
      callback: function($$v) {
        _vm.$set(_vm.integrante, "nome", $$v)
      },
      expression: "integrante.nome"
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaFrequencia,
      "search": _vm.search,
      "no-data-text": 'Nenhuma frequência encontrada',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', {
          staticClass: "text-xs-center",
          attrs: {
            "width": "10%"
          }
        }, [_vm._v(_vm._s(props.item.ano))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center",
          attrs: {
            "width": "10%"
          }
        }, [_vm._v(_vm._s(props.item.mes))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center",
          attrs: {
            "width": "30%"
          }
        }, [_vm._v(_vm._s(props.item.observacao ? props.item.observacao : '-'))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center",
          attrs: {
            "width": "50%"
          }
        }, [_vm._v(_vm._s(props.item.atividadesRealizadas ? props.item.atividadesRealizadas : '-'))])])]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n              Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaFrequencia.length) + " frequências\n            ")]
      }
    }])
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.administrador === true || (_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1)) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.toCriarFrequencia
    }
  }, [_vm._v("Nova frequência")]) : _vm._e()], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(782)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(783),
  /* template */
  __webpack_require__(784),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 782 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_bolsas__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto', 'idParticipante'],
  data: function data() {
    return {
      formularioValido: false,
      frequenciaRetroativa: false,
      frequencia: {
        ano: 2020,
        mes: 8
      },
      listaMeses: [{ valor: 1, nome: 'Janeiro' }, { valor: 2, nome: 'Fevereiro' }, { valor: 3, nome: 'Março' }, { valor: 4, nome: 'Abril' }, { valor: 5, nome: 'Maio' }, { valor: 6, nome: 'Junho' }, { valor: 7, nome: 'Julho' }, { valor: 8, nome: 'Agosto' }, { valor: 9, nome: 'Setembro' }, { valor: 10, nome: 'Outubro' }, { valor: 11, nome: 'Novembro' }, { valor: 12, nome: 'Dezembro' }],
      regrasBasicas: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }],
      assuntoSummaryRules: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }, function (input) {
        return !!input && input.length <= 200 || 'Este campo não pode possuir mais que 200 caracteres';
      }],
      anoRules: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }, function (input) {
        return !isNaN(parseFloat(input)) && input >= 1900 && input <= 2100 || 'Ano inválido';
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    criarFrequencia: function criarFrequencia() {
      var _this = this;

      this.frequencia.idProjeto = this.idProjeto;
      this.frequencia.idParticipante = this.idParticipante;
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Adicionando frequência.' });
      __WEBPACK_IMPORTED_MODULE_3__utils_bolsas__["a" /* default */].postFrequencia(this.idProjeto, this.idParticipante, this.frequencia).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Adicionando frequência.' });
      });
    }
  }),
  mounted: function mounted() {},

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a
  }
});

/***/ }),
/* 784 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Nova frequência'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Frequência retroativa"
    },
    model: {
      value: (_vm.frequenciaRetroativa),
      callback: function($$v) {
        _vm.frequenciaRetroativa = $$v
      },
      expression: "frequenciaRetroativa"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Ano",
      "type": "number",
      "disabled": !_vm.frequenciaRetroativa,
      "required": "",
      "rules": _vm.anoRules
    },
    model: {
      value: (_vm.frequencia.ano),
      callback: function($$v) {
        _vm.$set(_vm.frequencia, "ano", $$v)
      },
      expression: "frequencia.ano"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Mês",
      "items": _vm.listaMeses,
      "item-text": "nome",
      "item-value": "valor",
      "prepend-icon": "dashboard",
      "disabled": !_vm.frequenciaRetroativa,
      "required": "",
      "autocomplete": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.frequencia.mes),
      callback: function($$v) {
        _vm.$set(_vm.frequencia, "mes", $$v)
      },
      expression: "frequencia.mes"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Observação",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.frequencia.observacao),
      callback: function($$v) {
        _vm.$set(_vm.frequencia, "observacao", $$v)
      },
      expression: "frequencia.observacao"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Atividades realizadas pelo bolsista",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.frequencia.atividadesRealizadas),
      callback: function($$v) {
        _vm.$set(_vm.frequencia, "atividadesRealizadas", $$v)
      },
      expression: "frequencia.atividadesRealizadas"
    }
  })], 1)], 1), _vm._v(" "), (_vm.frequenciaRetroativa) ? _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Justificativa para o atraso",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.frequencia.justificativa),
      callback: function($$v) {
        _vm.$set(_vm.frequencia, "justificativa", $$v)
      },
      expression: "frequencia.justificativa"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.frequenciaRetroativa) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "black--text text-justify text-h6",
    staticStyle: {
      "margin-left": "-10px"
    }
  }, [_vm._v("\n                  Obs.: A confirmação da frequência retroativa depende de homologação da administração.\n                  "), _c('br'), _c('br')])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": _vm.criarFrequencia
    }
  }, [_vm._v("Criar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(786)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(787),
  /* template */
  __webpack_require__(788),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 786 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_date_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_textarea__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_c_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto'],
  data: function data() {
    return {
      dialog: false,
      formularioValido: false,
      listaClassificacaoSecundaria: [],
      projeto: {
        situacao: {},
        tipoPublico: {},
        classificacoesPrimariaSecundaria: [{}, {}]
      },
      devolucao: {
        classificacaoSecundaria: {},
        justificativaObservacao: ''
      },
      regrasBasicas: [function (input) {
        return !!input || 'Este campo é obrigatório';
      }],
      assuntoSummaryRules: [function (input) {
        return input.length <= 2000 || 'Este campo não pode possuir mais que 2000 caracteres';
      }]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])('auth', ['logged', 'username', 'nome', 'administrador', 'usuarioPROEX', 'permissaoCriarProjetoExtensao'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    cancelar: function cancelar() {
      this.$router.push({ name: 'ProjetosAguardandoAprovacao' });
    },
    ativarAdministrador: function ativarAdministrador() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Ativando permissões de administrador...' });
      __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].postAtivarAdministrador().then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Ativando permissões de administrador...' });
      });
    },
    desativarAdministrador: function desativarAdministrador() {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Desativando permissões de administrador...' });
      __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].postDesativarAdministrador().then(function (response) {
        _this2.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
      }).catch(function (error) {
        _this2.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Desativando permissões de administrador...' });
      });
    }
  }),
  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a,
    'c-date-menu': __WEBPACK_IMPORTED_MODULE_3__components_c_date_menu___default.a,
    'c-textarea': __WEBPACK_IMPORTED_MODULE_4__components_c_textarea___default.a
  }
});

/***/ }),
/* 788 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [(_vm.administrador === true) ? _c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Ativar e Desativar Permissão de Administrador'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('p', {
    staticClass: "mt-3"
  })])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.cancelar
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.ativarAdministrador()
      }
    }
  }, [_vm._v("Ativar")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.desativarAdministrador()
      }
    }
  }, [_vm._v("Desativar")])], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(790)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(791),
  /* template */
  __webpack_require__(792),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 790 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_date_dialog__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_date_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_date_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_textarea__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      formularioValido: false,
      dates: __WEBPACK_IMPORTED_MODULE_4__utils_dates__["a" /* default */],
      nomeAreaDisabled: true,
      nomeSubareaDisabled: true,
      projetoPesquisa: {
        prazoMeses: null
      },
      listaAreaDoConhecimento: [],
      listaNomeArea: [],
      listaNomeSubarea: [],
      obrigatorio: [function (v) {
        return !!v || 'Este campo é obrigatório';
      }],
      numerico: [function (input) {
        return !isNaN(input) || 'Este campo deve ser numérico';
      }, function (input) {
        return input.length === 0 || Number(input) !== 0 || 'Este campo não pode ser nulo';
      }, function (input) {
        return input.length === 0 || Number(input) >= 0 || 'Este campo não pode ter valor negativo';
      }],
      max20caracteres: [function (v) {
        return v.length <= 20 || 'Este campo pode ter no máximo 20 caracteres';
      }],
      max50caracteres: [function (v) {
        return v.length <= 50 || 'Este campo pode ter no máximo 50 caracteres';
      }],
      max300caracteres: [function (v) {
        return v.length <= 300 || 'Este campo pode ter no máximo 300 caracteres';
      }],
      max400caracteres: [function (v) {
        return v.length <= 400 || 'Este campo pode ter no máximo 400 caracteres';
      }],
      max2000caracteres: [function (v) {
        return v.length <= 2000 || 'Este campo pode ter no máximo 2000 caracteres';
      }],
      palavrasChaves: [function (v) {
        return (/^(?:[^\s.,:;][a-zA-Z0-9-áéíóúàèìòùâêôûãõçÁÉÍÓÚÀÈÌÒÙÂÊÔÛÃÕÇ\s]+[^\s.,:;],){1}(?:\s?[^\s.,:;][a-zA-Z0-9-áéíóúàèìòùâêôûãõçÁÉÍÓÚÀÈÌÒÙÂÊÔÛÃÕÇ\s]+[^\s.,:;],){1,4}(?:\s?[^\s.,:;][a-zA-Z0-9-áéíóúàèìòùâêôûãõçÁÉÍÓÚÀÈÌÒÙÂÊÔÛÃÕÇ\s]+[^\s.,:;]){1}$/.test(v) || 'O projeto deve conter no mínimo 03 e no máximo 06 palavras-chaves separadas apenas por vírgulas e sem ponto ao final.'
        );
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {

    // Carrega as áreas.
    getNomesDasAreas: function getNomesDasAreas(idClassifSup) {
      this.obtemNomesDasAreas(idClassifSup, this, 'listaNomeArea');
      this.nomeAreaDisabled = false;
      this.listaNomeSubarea = [];
      this.nomeSubareaDisabled = true;
    },

    // Carrega as subáreas.
    getNomesDasSubareas: function getNomesDasSubareas(idClassifSup) {
      this.obtemNomesDasSubareas(idClassifSup, this, 'listaNomeSubarea');
      this.nomeSubareaDisabled = false;
    },

    // Cria um novo projeto de pesquisa.
    novoProjetoPesquisa: function novoProjetoPesquisa() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Criando projeto de pesquisa...' });
      __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].postProjetoPesquisa(this.projetoPesquisa).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        // Obtém o ID do projeto de pesquisa recém-criado.
        var idNovoProjetoPesquisa = response.body.link.split('/').pop();
        // Redireciona o usuário para o cadastro do projeto de pesquisa recém-criado.
        _this.$router.push({ name: 'ProjetoPesquisaDetalhamento', params: { idProjetoPesquisa: idNovoProjetoPesquisa } });
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Criando projeto de pesquisa...' });
      });
    },

    // Carrega as áreas do conhecimento do CNPq.
    obtemAreasDoConhecimento: function obtemAreasDoConhecimento(aqui, atributo) {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando áreas do conhecimento...' });
      __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getClassificacoesAreasDoConhecimento().then(function (response) {
        aqui[atributo] = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando áreas do conhecimento...' });
      });
    },

    // Carrega os nomes das áreas.
    obtemNomesDasAreas: function obtemNomesDasAreas(idClassifSup, aqui, atributo) {
      var _this3 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando nomes das áreas...' });
      __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getClassificacoesClassificacaoSuperior(idClassifSup).then(function (response) {
        aqui[atributo] = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this3.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando nomes das áreas...' });
      });
    },

    // Carrega os nomes das subáreas.
    obtemNomesDasSubareas: function obtemNomesDasSubareas(idClassifSup, aqui, atributo) {
      var _this4 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando nomes das subáreas...' });
      __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getClassificacoesClassificacaoSuperior(idClassifSup).then(function (response) {
        aqui[atributo] = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this4.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando nomes das subáreas...' });
      });
    }
  }),
  mounted: function mounted() {
    // Carrega as áreas do conhecimento do CNPq.
    this.obtemAreasDoConhecimento(this, 'listaAreaDoConhecimento');
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'c-date-dialog': __WEBPACK_IMPORTED_MODULE_2__components_c_date_dialog___default.a,
    'c-textarea': __WEBPACK_IMPORTED_MODULE_3__components_c_textarea___default.a
  }
});

/***/ }),
/* 792 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Novo Projeto de Pesquisa'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Título*",
      "counter": "400",
      "rules": _vm.obrigatorio.concat( _vm.max400caracteres)
    },
    model: {
      value: (_vm.projetoPesquisa.titulo),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "titulo", $$v)
      },
      expression: "projetoPesquisa.titulo"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Sigla",
      "counter": "20",
      "rules": _vm.max20caracteres
    },
    model: {
      value: (_vm.projetoPesquisa.sigla),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "sigla", $$v)
      },
      expression: "projetoPesquisa.sigla"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Área do Conhecimento*",
      "items": _vm.listaAreaDoConhecimento,
      "return-object": "",
      "item-text": "descricao",
      "item-value": "id",
      "rules": _vm.obrigatorio,
      "hint": "O projeto deve ser registrado na área do conhecimento pertinente a sua temática."
    },
    on: {
      "input": function($event) {
        return _vm.getNomesDasAreas(_vm.projetoPesquisa.areaConhecimento.id)
      }
    },
    model: {
      value: (_vm.projetoPesquisa.areaConhecimento),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "areaConhecimento", $$v)
      },
      expression: "projetoPesquisa.areaConhecimento"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Nome da Área*",
      "return-object": "",
      "items": _vm.listaNomeArea,
      "item-text": "descricao",
      "item-value": "id",
      "rules": _vm.obrigatorio,
      "disabled": _vm.nomeAreaDisabled
    },
    on: {
      "input": function($event) {
        return _vm.getNomesDasSubareas(_vm.projetoPesquisa.nomeArea.id)
      }
    },
    model: {
      value: (_vm.projetoPesquisa.nomeArea),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "nomeArea", $$v)
      },
      expression: "projetoPesquisa.nomeArea"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Nome da Subárea*",
      "return-object": "",
      "items": _vm.listaNomeSubarea,
      "item-text": "descricao",
      "item-value": "id",
      "rules": _vm.obrigatorio,
      "disabled": _vm.nomeSubareaDisabled || _vm.listaNomeSubarea.length === 0
    },
    model: {
      value: (_vm.projetoPesquisa.nomeSubarea),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "nomeSubarea", $$v)
      },
      expression: "projetoPesquisa.nomeSubarea"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Linha de Pesquisa no Programa de Pós-Graduação*",
      "return-object": "",
      "items": _vm.listaLinhaPesquisaPPG,
      "disabled": "",
      "hint": "Esta opção está indisponível no momento.",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.projetoPesquisa.linhaPesquisaPPG),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "linhaPesquisaPPG", $$v)
      },
      expression: "projetoPesquisa.linhaPesquisaPPG"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-date-dialog', {
    attrs: {
      "label": "Data de início*",
      "rules": _vm.obrigatorio
    },
    model: {
      value: (_vm.projetoPesquisa.dataInicio),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "dataInicio", $$v)
      },
      expression: "projetoPesquisa.dataInicio"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field-integer', {
    attrs: {
      "label": "Prazo em meses*",
      "properties": {
        rules: _vm.obrigatorio.concat( _vm.numerico)
      }
    },
    model: {
      value: (_vm.projetoPesquisa.prazoMeses),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "prazoMeses", $$v)
      },
      expression: "projetoPesquisa.prazoMeses"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Palavras-chaves*",
      "counter": "300",
      "rows": 1,
      "auto-grow": true,
      "rules": _vm.obrigatorio.concat( _vm.max300caracteres, _vm.palavrasChaves),
      "hint": "Indique no mínimo 03 e no máximo 06 palavras que podem ser relacionadas ao escopo do projeto. As palavras devem ser separadas somente por vírgulas e sem ponto ao final."
    },
    model: {
      value: (_vm.projetoPesquisa.palavrasChaves),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "palavrasChaves", $$v)
      },
      expression: "projetoPesquisa.palavrasChaves"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Resumo*",
      "counter": "2000",
      "rows": 4,
      "auto-grow": true,
      "rules": _vm.obrigatorio.concat( _vm.max2000caracteres),
      "hint": "Deve conter uma descrição do projeto, incluindo sua relevância."
    },
    model: {
      value: (_vm.projetoPesquisa.resumo),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "resumo", $$v)
      },
      expression: "projetoPesquisa.resumo"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Tenho conhecimento da obrigatoriedade (ou não) de cadastro do projeto no Comitê de Ética em Pesquisa (CEP) e/ou Comitê de Ética no Uso de Animais (CEUA) e/ou SisGen.*",
      "rules": _vm.obrigatorio
    },
    model: {
      value: (_vm.projetoPesquisa.conhecimentoCepCeuaSisgen),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "conhecimentoCepCeuaSisgen", $$v)
      },
      expression: "projetoPesquisa.conhecimentoCepCeuaSisgen"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "divisorBotoes"
  }), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.novoProjetoPesquisa()
      }
    }
  }, [_vm._v("Criar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(794)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(795),
  /* template */
  __webpack_require__(796),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 794 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_tooltip_btn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_tooltip_btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_tooltip_btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      dates: __WEBPACK_IMPORTED_MODULE_3__utils_dates__["a" /* default */],
      search: null,
      sortBy: 'id',
      sortDesc: true,
      itemsPerPage: 25,
      opcoesPaginacao: [10, 25, 50, { text: 'Todas', value: -1 }],
      headers: [{ text: 'Nº Registro', align: 'left', value: 'numRegistro' }, { text: 'Título', align: 'left', value: 'titulo' }, { text: 'Sigla', align: 'left', value: 'sigla' }, { text: 'Data de início', align: 'left', value: 'dataInicio' }, { text: 'Prazo (meses)', align: 'left', value: 'prazoMeses' }, { text: 'Situação', align: 'left', value: 'situacao.descricao' }, { text: 'Tipo de participação', align: 'left', value: 'tipoParticipacaoUsuarioLogado.descricao' }, { text: 'Opções', align: 'left', value: 'opcoes' }],
      listaMeusProjetosPesquisa: []
    };
  },
  props: ['items'],
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING']), {

    // Abre o cadastro do projeto de pesquisa.
    toAbrirCadastroProjetoPesquisa: function toAbrirCadastroProjetoPesquisa(idProjetoPesquisa) {
      this.$router.push({ name: 'ProjetoPesquisaInformacoesBasicas', params: { idProjetoPesquisa: idProjetoPesquisa } });
    }
  }),
  mounted: function mounted() {
    var _this = this;

    // Carrega os projetos de pesquisa dos quais o usuário logado faz parte.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando meus projetos de pesquisa...' });
    __WEBPACK_IMPORTED_MODULE_4__utils_projetos__["a" /* default */].getMeusProjetosPesquisa().then(function (response) {
      _this.listaMeusProjetosPesquisa = response.data.slice();
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando meus projetos de pesquisa...' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'c-tooltip-btn': __WEBPACK_IMPORTED_MODULE_2__components_c_tooltip_btn___default.a
  }
});

/***/ }),
/* 796 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('basic-toolbar', {
    attrs: {
      "title": 'Meus Projetos de Pesquisa'
    }
  }), _vm._v(" "), _c('v-card-title', [_c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "filter_list",
      "label": "Filtrar resultados"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaMeusProjetosPesquisa,
      "search": _vm.search,
      "no-data-text": 'Você não participa de nenhum projeto de pesquisa',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.opcoes",
      fn: function(props) {
        return [_c('c-tooltip-btn', {
          attrs: {
            "icon": "library_books",
            "color": "primary",
            "tooltip": "Visualizar cadastro do projeto"
          },
          on: {
            "click": function($event) {
              return _vm.toAbrirCadastroProjetoPesquisa(props.item.id)
            }
          }
        })]
      }
    }, {
      key: "item.numRegistro",
      fn: function(props) {
        return [_vm._v(_vm._s(props.item.numRegistro === null || props.item.numRegistro === '' ? '-' : props.item.numRegistro))]
      }
    }, {
      key: "item.sigla",
      fn: function(props) {
        return [_vm._v(_vm._s(props.item.sigla === null || props.item.sigla === '' ? '-' : props.item.sigla))]
      }
    }, {
      key: "item.dataInicio",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dataInicio)))]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n            Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaMeusProjetosPesquisa.length) + " " + _vm._s(_vm.listaMeusProjetosPesquisa.length > 1 ? 'projetos' : 'projeto') + "\n          ")]
      }
    }])
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(798)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(799),
  /* template */
  __webpack_require__(800),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 798 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_tooltip_btn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_tooltip_btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_tooltip_btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto', 'items'],
  data: function data() {
    return {
      formularioValido: false,
      dates: __WEBPACK_IMPORTED_MODULE_4__utils_dates__["a" /* default */],
      consulta: {
        numRegistro: '',
        titulo: '',
        membroEquipe: '',
        palavraChave: '',
        areaConhecimento: '',
        nomeArea: '',
        nomeSubarea: '',
        linhaPesquisaPPG: ''
      },
      consultaAvancada: false,
      listaAreaDoConhecimento: [],
      listaNomeArea: [],
      listaNomeSubarea: [],
      listaLinhaPesquisaPPG: [],
      nomeAreaDisabled: true,
      nomeSubareaDisabled: true,
      listaProjetosPesquisa: [],
      search: null,
      sortDesc: true,
      itemsPerPage: 25,
      opcoesPaginacao: [10, 25, 50, { text: 'Todas', value: -1 }],
      headers: [{ text: 'Nº Registro', align: 'left', value: 'numRegistro' }, { text: 'Título', align: 'left', value: 'titulo' }, { text: 'Sigla', align: 'left', value: 'sigla' }, { text: 'Data de início', align: 'left', value: 'dataInicio' }, { text: 'Prazo (meses)', align: 'left', value: 'prazoMeses' }, { text: 'Situação', align: 'left', value: 'situacao.descricao' }, { text: 'Coordenador', align: 'left', value: 'coordenador' }, { text: 'Opções', align: 'left', value: 'opcoes' }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {

    // Limpa nome das áreas e subáreas.
    limpaNomeAreaSubarea: function limpaNomeAreaSubarea() {
      this.listaNomeArea = [];
      this.nomeAreaDisabled = true;
      this.consulta.nomeArea = '';
      this.limpaNomeSubarea();
    },

    // Limpa nome das subáreas.
    limpaNomeSubarea: function limpaNomeSubarea() {
      this.listaNomeSubarea = [];
      this.nomeSubareaDisabled = true;
      this.consulta.nomeSubarea = '';
    },

    // Carrega as áreas.
    getNomesDasAreas: function getNomesDasAreas(idClassifSup) {
      this.obtemNomesDasAreas(idClassifSup, this, 'listaNomeArea');
      this.nomeAreaDisabled = false;
      this.listaNomeSubarea = [];
      this.nomeSubareaDisabled = true;
    },

    // Carrega as subáreas.
    getNomesDasSubareas: function getNomesDasSubareas(idClassifSup) {
      this.obtemNomesDasSubareas(idClassifSup, this, 'listaNomeSubarea');
      this.nomeSubareaDisabled = false;
    },

    // Carrega as áreas do conhecimento do CNPq.
    obtemAreasDoConhecimento: function obtemAreasDoConhecimento(aqui, atributo) {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando áreas do conhecimento...' });
      __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getClassificacoesAreasDoConhecimento().then(function (response) {
        aqui[atributo] = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando áreas do conhecimento...' });
      });
    },

    // Carrega os nomes das áreas.
    obtemNomesDasAreas: function obtemNomesDasAreas(idClassifSup, aqui, atributo) {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando nomes das áreas...' });
      __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getClassificacoesClassificacaoSuperior(idClassifSup).then(function (response) {
        aqui[atributo] = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando nomes das áreas...' });
      });
    },

    // Carrega os nomes das subáreas.
    obtemNomesDasSubareas: function obtemNomesDasSubareas(idClassifSup, aqui, atributo) {
      var _this3 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando nomes das subáreas...' });
      __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getClassificacoesClassificacaoSuperior(idClassifSup).then(function (response) {
        aqui[atributo] = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this3.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando nomes das subáreas...' });
      });
    },

    // Abre filtros da consulta simples.
    abrirConsultaAvancada: function abrirConsultaAvancada() {
      this.consultaAvancada = true;
    },


    // Fecha filtros da consulta avançada.
    fecharConsultaAvancada: function fecharConsultaAvancada() {
      this.consultaAvancada = false;
    },


    // Abre o cadastro do projeto de pesquisa.
    toAbrirCadastroProjetoPesquisa: function toAbrirCadastroProjetoPesquisa(idProjetoPesquisa) {
      this.$router.push({ name: 'ProjetoPesquisaInformacoesBasicas', params: { idProjetoPesquisa: idProjetoPesquisa } });
    },

    // Limpa os campos do formulário de consulta.
    limpar: function limpar() {
      this.consulta = {};
    },


    // Consulta projetos de pesquisa.
    consultar: function consultar() {
      var _this4 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Consultando projetos de pesquisa...' });
      __WEBPACK_IMPORTED_MODULE_5__utils_projetos__["a" /* default */].getConsultaProjetosPesquisa(this.consulta).then(function (response) {
        _this4.listaProjetosPesquisa = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this4.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
        _this4.listaProjetosPesquisa = [];
      }).finally(function () {
        _this4.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Consultando projetos de pesquisa...' });
      });
    }
  }),
  mounted: function mounted() {
    // Carrega as áreas do conhecimento do CNPq.
    this.obtemAreasDoConhecimento(this, 'listaAreaDoConhecimento');
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'tooltip': __WEBPACK_IMPORTED_MODULE_2__components_app_layouts_app_tooltip_tooltip___default.a,
    'c-tooltip-btn': __WEBPACK_IMPORTED_MODULE_3__components_c_tooltip_btn___default.a
  }
});

/***/ }),
/* 800 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Consulta de Projetos de Pesquisa'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', {
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.consultar()
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nº Registro",
      "max-height": "400",
      "clearable": ""
    },
    model: {
      value: (_vm.consulta.numRegistro),
      callback: function($$v) {
        _vm.$set(_vm.consulta, "numRegistro", $$v)
      },
      expression: "consulta.numRegistro"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm8": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Título",
      "max-height": "400",
      "clearable": ""
    },
    model: {
      value: (_vm.consulta.titulo),
      callback: function($$v) {
        _vm.$set(_vm.consulta, "titulo", $$v)
      },
      expression: "consulta.titulo"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Palavra-chave",
      "max-height": "400",
      "clearable": ""
    },
    model: {
      value: (_vm.consulta.palavraChave),
      callback: function($$v) {
        _vm.$set(_vm.consulta, "palavraChave", $$v)
      },
      expression: "consulta.palavraChave"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm8": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Membro da equipe",
      "max-height": "400",
      "clearable": ""
    },
    model: {
      value: (_vm.consulta.membroEquipe),
      callback: function($$v) {
        _vm.$set(_vm.consulta, "membroEquipe", $$v)
      },
      expression: "consulta.membroEquipe"
    }
  })], 1)], 1), _vm._v(" "), (_vm.consultaAvancada) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Área do Conhecimento",
      "items": _vm.listaAreaDoConhecimento,
      "item-text": "descricao",
      "item-value": "id",
      "clearable": "",
      "autocomplete": ""
    },
    on: {
      "input": function($event) {
        return _vm.getNomesDasAreas(_vm.consulta.areaConhecimento)
      },
      "click:clear": function($event) {
        return _vm.limpaNomeAreaSubarea()
      }
    },
    model: {
      value: (_vm.consulta.areaConhecimento),
      callback: function($$v) {
        _vm.$set(_vm.consulta, "areaConhecimento", $$v)
      },
      expression: "consulta.areaConhecimento"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Nome da Área",
      "items": _vm.listaNomeArea,
      "item-text": "descricao",
      "item-value": "id",
      "disabled": _vm.nomeAreaDisabled,
      "clearable": "",
      "autocomplete": ""
    },
    on: {
      "input": function($event) {
        return _vm.getNomesDasSubareas(_vm.consulta.nomeArea)
      },
      "click:clear": function($event) {
        return _vm.limpaNomeSubarea()
      }
    },
    model: {
      value: (_vm.consulta.nomeArea),
      callback: function($$v) {
        _vm.$set(_vm.consulta, "nomeArea", $$v)
      },
      expression: "consulta.nomeArea"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.consultaAvancada) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Nome da Subárea",
      "items": _vm.listaNomeSubarea,
      "item-text": "descricao",
      "item-value": "id",
      "disabled": _vm.nomeSubareaDisabled || _vm.listaNomeSubarea.length === 0,
      "clearable": "",
      "autocomplete": ""
    },
    model: {
      value: (_vm.consulta.nomeSubarea),
      callback: function($$v) {
        _vm.$set(_vm.consulta, "nomeSubarea", $$v)
      },
      expression: "consulta.nomeSubarea"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Linha de Pesquisa no Programa de Pós-Graduação",
      "items": _vm.listaLinhaPesquisaPPG,
      "clearable": "",
      "autocomplete": "",
      "disabled": "",
      "hint": "Esta opção está indisponível no momento.",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.consulta.linhaPesquisaPPG),
      callback: function($$v) {
        _vm.$set(_vm.consulta, "linhaPesquisaPPG", $$v)
      },
      expression: "consulta.linhaPesquisaPPG"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": ""
    }
  }, [(!_vm.consultaAvancada) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.abrirConsultaAvancada()
      }
    }
  }, [_vm._v("Consulta avançada")]) : _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.fecharConsultaAvancada()
      }
    }
  }, [_vm._v("Consulta simples")])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "padding-top": "15px"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-btn', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.limpar()
      }
    }
  }, [_vm._v("Limpar")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.consultar()
      }
    }
  }, [_vm._v("Consultar")])], 1)])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Resultados da Consulta'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaProjetosPesquisa,
      "search": _vm.search,
      "no-data-text": 'Nenhum projeto encontrado',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.opcoes",
      fn: function(props) {
        return [_c('c-tooltip-btn', {
          attrs: {
            "icon": "library_books",
            "color": "primary",
            "tooltip": "Visualizar cadastro do projeto"
          },
          on: {
            "click": function($event) {
              return _vm.toAbrirCadastroProjetoPesquisa(props.item.id)
            }
          }
        })]
      }
    }, {
      key: "item.numRegistro",
      fn: function(props) {
        return [_vm._v(_vm._s(props.item.numRegistro === null || props.item.numRegistro === '' ? '-' : props.item.numRegistro))]
      }
    }, {
      key: "item.sigla",
      fn: function(props) {
        return [_vm._v(_vm._s(props.item.sigla === null || props.item.sigla === '' ? '-' : props.item.sigla))]
      }
    }, {
      key: "item.dataInicio",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dataInicio)))]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n            Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaProjetosPesquisa.length) + " " + _vm._s(_vm.listaProjetosPesquisa.length > 1 ? 'projetos' : 'projeto') + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('br')], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(802)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(803),
  /* template */
  __webpack_require__(807),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-cef1b9e0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 802 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_barra_administrador_prppg__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_barra_administrador_prppg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_barra_administrador_prppg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjetoPesquisa'],
  data: function data() {
    return {
      projetoPesquisa: {}
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('auth', ['logged', 'username', 'nome', 'administrador', 'administradorPRPPG', 'permissaoCriarProjetoExtensao'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING']), {

    // Verifica se o projeto de pesquisa está na situação "Em andamento".
    situacaoEmAndamento: function situacaoEmAndamento() {
      if (this.projetoPesquisa.situacao.item === 3) {
        return true;
      } else {
        return false;
      }
    },

    // Verifica se o projeto de pesquisa está na situação "Concluído".
    situacaoConcluido: function situacaoConcluido() {
      if (this.projetoPesquisa.situacao.item === 4) {
        return true;
      } else {
        return false;
      }
    },

    // Verifica se o projeto de pesquisa está na situação "Cancelado".
    situacaoCancelado: function situacaoCancelado() {
      if (this.projetoPesquisa.situacao.item === 5) {
        return true;
      } else {
        return false;
      }
    },

    // Habilita aba "Resultados Obtidos".
    habilitaAbaResultadosObtidos: function habilitaAbaResultadosObtidos() {
      if (this.situacaoEmAndamento() || this.situacaoConcluido()) {
        return true;
      } else {
        return false;
      }
    },

    // Habilita abas exceto "Informações Básicas" e "Resultados Obtidos".
    habilitaOutrasAbas: function habilitaOutrasAbas() {
      if (this.situacaoCancelado() === true && this.administradorPRPPG !== true && this.projetoPesquisa.coordenador !== true) {
        return 'router_disable';
      } else {
        return '';
      }
    }

  }),
  mounted: function mounted() {
    var _this = this;

    // Carrega o projeto de pesquisa.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto de pesquisa...' });
    __WEBPACK_IMPORTED_MODULE_2__utils_projetos__["a" /* default */].getProjetoPesquisa(this.idProjetoPesquisa).then(function (response) {
      _this.projetoPesquisa = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto de pesquisa...' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'c-barra-administrador-prppg': __WEBPACK_IMPORTED_MODULE_3__components_c_barra_administrador_prppg___default.a
  }
});

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(805),
  /* template */
  __webpack_require__(806),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_confirm_dialog__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_confirm_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_c_confirm_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_tooltip_btn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_tooltip_btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_tooltip_btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['projeto', 'extensao'],
  data: function data() {
    return {
      dialogRegistro: false,
      dialogDevolucao: false,
      dialogConclusao: false,
      dialogCancelamento: false,
      data: '',
      dataFormatada: '',
      menuData: false
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('auth', ['administrador', 'usuarioPROEX'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    goRegistrarProjeto: function goRegistrarProjeto() {
      this.dialogRegistro = true;
    },
    goDevolverProjeto: function goDevolverProjeto() {
      this.dialogDevolucao = true;
    },
    goConcluirProjeto: function goConcluirProjeto() {
      this.dialogConclusao = true;
    },
    goCancelarProjeto: function goCancelarProjeto() {
      this.dialogCancelamento = true;
    },

    // Registrar projeto de pesquisa.
    registrarProjeto: function registrarProjeto() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Registrando projeto de pesquisa...' });
      __WEBPACK_IMPORTED_MODULE_3__utils_projetos__["a" /* default */].postRegistrarProjetoPesquisa(this.projeto.id).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Registrando projeto de pesquisa...' });
      });
    },
    // Devolver projeto de pesquisa.
    devolverProjeto: function devolverProjeto() {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Devolvendo projeto de pesquisa...' });
      __WEBPACK_IMPORTED_MODULE_3__utils_projetos__["a" /* default */].postDevolverProjetoPesquisa(this.projeto.id).then(function (response) {
        _this2.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this2.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Devolvendo projeto de pesquisa...' });
      });
    },
    // Concluir projeto de pesquisa.
    concluirProjeto: function concluirProjeto() {
      var _this3 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Concluindo projeto de pesquisa...' });
      __WEBPACK_IMPORTED_MODULE_3__utils_projetos__["a" /* default */].postConcluirProjetoPesquisa(this.projeto.id).then(function (response) {
        _this3.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this3.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this3.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Concluindo projeto de pesquisa...' });
      });
    },
    // Cancelar projeto de pesquisa.
    cancelarProjeto: function cancelarProjeto() {
      var _this4 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Cancelando projeto de pesquisa...' });
      __WEBPACK_IMPORTED_MODULE_3__utils_projetos__["a" /* default */].postCancelarProjetoPesquisa(this.projeto.id).then(function (response) {
        _this4.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this4.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this4.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Cancelando projeto de pesquisa...' });
      });
    }
  }),
  components: {
    'c-confirm-dialog': __WEBPACK_IMPORTED_MODULE_1__components_c_confirm_dialog___default.a,
    'c-tooltip-btn': __WEBPACK_IMPORTED_MODULE_2__components_c_tooltip_btn___default.a
  }
});

/***/ }),
/* 806 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('c-confirm-dialog', {
    attrs: {
      "titulo": "Confirma o registro do projeto de pesquisa?"
    },
    on: {
      "yes": function($event) {
        return _vm.registrarProjeto()
      }
    },
    model: {
      value: (_vm.dialogRegistro),
      callback: function($$v) {
        _vm.dialogRegistro = $$v
      },
      expression: "dialogRegistro"
    }
  }), _vm._v(" "), _c('c-confirm-dialog', {
    attrs: {
      "titulo": "Confirma a devolução do projeto de pesquisa?"
    },
    on: {
      "yes": function($event) {
        return _vm.devolverProjeto()
      }
    },
    model: {
      value: (_vm.dialogDevolucao),
      callback: function($$v) {
        _vm.dialogDevolucao = $$v
      },
      expression: "dialogDevolucao"
    }
  }), _vm._v(" "), _c('c-confirm-dialog', {
    attrs: {
      "titulo": "Confirma a conclusão do projeto de pesquisa?"
    },
    on: {
      "yes": function($event) {
        return _vm.concluirProjeto()
      }
    },
    model: {
      value: (_vm.dialogConclusao),
      callback: function($$v) {
        _vm.dialogConclusao = $$v
      },
      expression: "dialogConclusao"
    }
  }), _vm._v(" "), _c('c-confirm-dialog', {
    attrs: {
      "titulo": "Confirma o cancelamento do projeto de pesquisa?"
    },
    on: {
      "yes": function($event) {
        return _vm.cancelarProjeto()
      }
    },
    model: {
      value: (_vm.dialogCancelamento),
      callback: function($$v) {
        _vm.dialogCancelamento = $$v
      },
      expression: "dialogCancelamento"
    }
  }), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "color": "white"
    }
  }, [_c('v-toolbar-title', [_vm._v("Barra do administrador")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', {
    staticClass: "text-xs-right"
  }, [_c('c-tooltip-btn', {
    attrs: {
      "icon": "done_outline",
      "color": "green",
      "disabled": _vm.projeto.situacao.item != 2,
      "tooltip": "Registrar",
      "disabled-tooltip": "Apenas um projeto de pesquisa na situação \"Aguardando registro\" pode ser registrado"
    },
    on: {
      "click": function($event) {
        return _vm.goRegistrarProjeto()
      }
    }
  }), _vm._v(" "), _c('c-tooltip-btn', {
    attrs: {
      "icon": "not_interested",
      "color": "red",
      "disabled": _vm.projeto.situacao.item != 2,
      "tooltip": "Devolver para o coordenador",
      "disabled-tooltip": "Apenas um projeto de pesquisa na situação \"Aguardando registro\" pode ser devolvido para o coordenador"
    },
    on: {
      "click": function($event) {
        return _vm.goDevolverProjeto()
      }
    }
  }), _vm._v(" "), _c('c-tooltip-btn', {
    attrs: {
      "icon": "folder",
      "color": "brown lighten-1",
      "disabled": _vm.projeto.situacao.item != 3,
      "tooltip": "Concluir",
      "disabled-tooltip": "Apenas um projeto de pesquisa na situação \"Em andamento\" pode ser concluído"
    },
    on: {
      "click": function($event) {
        return _vm.goConcluirProjeto()
      }
    }
  }), _vm._v(" "), _c('c-tooltip-btn', {
    attrs: {
      "icon": "cancel_presentation",
      "color": "red",
      "disabled": _vm.projeto.situacao.item != 3,
      "tooltip": "Cancelar",
      "disabled-tooltip": "Apenas um projeto de pesquisa na situação \"Em andamento\" pode ser cancelado"
    },
    on: {
      "click": function($event) {
        return _vm.goCancelarProjeto()
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 807 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-10"
  }, [_c('v-toolbar', {
    attrs: {
      "color": 'primary white--text'
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-toolbar-title', [_vm._v("\n            Projeto de Pesquisa " + _vm._s(_vm.projetoPesquisa.numRegistro === null || _vm.projetoPesquisa.numRegistro === '' ? '' : 'nº ' + _vm.projetoPesquisa.numRegistro + ' ') + " - " + _vm._s(_vm.projetoPesquisa.titulo) + "\n          ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-tabs', {
    attrs: {
      "slot": "extension",
      "centered": "",
      "show-arrows": "",
      "dark": "",
      "next-icon": "mdi-arrow-right-bold-box-outline",
      "prev-icon": "mdi-arrow-left-bold-box-outline",
      "color": "primary",
      "hide-slider": ""
    },
    slot: "extension"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": {
        name: 'ProjetoPesquisaInformacoesBasicas'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Informações Básicas")]), _vm._v(" "), _c('router-link', {
    class: _vm.habilitaOutrasAbas(),
    attrs: {
      "exact": "",
      "to": {
        name: 'ProjetoPesquisaDetalhamento'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Detalhamento")]), _vm._v(" "), _c('router-link', {
    class: _vm.habilitaOutrasAbas(),
    attrs: {
      "exact": "",
      "to": {
        name: 'ProjetoPesquisaInstituicoes'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Instituições")]), _vm._v(" "), _c('router-link', {
    class: _vm.habilitaOutrasAbas(),
    attrs: {
      "exact": "",
      "to": {
        name: 'ProjetoPesquisaEquipe'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Equipe")]), _vm._v(" "), _c('router-link', {
    class: _vm.habilitaOutrasAbas(),
    attrs: {
      "exact": "",
      "to": {
        name: 'ProjetoPesquisaOrgaosFinanciadores'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Órgãos Financiadores")]), _vm._v(" "), _c('router-link', {
    class: _vm.habilitaOutrasAbas(),
    attrs: {
      "exact": "",
      "to": {
        name: 'ProjetoPesquisaArquivos'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Arquivos")]), _vm._v(" "), _c('router-link', {
    class: _vm.habilitaOutrasAbas(),
    attrs: {
      "exact": "",
      "to": {
        name: 'ProjetoPesquisaOutrasInformacoes'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Outras Informações")]), _vm._v(" "), _c('router-link', {
    class: _vm.habilitaOutrasAbas(),
    attrs: {
      "exact": "",
      "to": {
        name: 'ProjetoPesquisaContatos'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Contatos")]), _vm._v(" "), (_vm.habilitaAbaResultadosObtidos()) ? _c('router-link', {
    attrs: {
      "exact": "",
      "to": {
        name: 'ProjetoPesquisaResultadosObtidos'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Resultados Obtidos")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('router-view', {
    attrs: {
      "idProjetoPesquisa": _vm.idProjetoPesquisa,
      "projetoPesquisa": this.projetoPesquisa
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-10"
  }, [_c('c-barra-administrador-prppg', {
    attrs: {
      "projeto": this.projetoPesquisa
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(809),
  /* template */
  __webpack_require__(810),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_readonly_field__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_readonly_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_c_readonly_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjetoPesquisa', 'projetoPesquisa'],
  data: function data() {
    return {
      dates: __WEBPACK_IMPORTED_MODULE_3__utils_dates__["a" /* default */]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('auth', ['administrador', 'administradorPRPPG'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {

    // Verifica se o projeto de pesquisa está na situação "Cancelado".
    situacaoCancelado: function situacaoCancelado() {
      if (this.projetoPesquisa.situacao.item === 5) {
        return true;
      } else {
        return false;
      }
    },

    // Habilita botão "Avançar".
    habilitaBotaoAvancar: function habilitaBotaoAvancar() {
      if (this.situacaoCancelado() === true && this.administradorPRPPG !== true && this.projetoPesquisa.coordenador !== true) {
        return false;
      } else {
        return true;
      }
    },

    // Edita a aba "Informações Básicas".
    toEditar: function toEditar() {
      this.$router.push({ name: 'EditarProjetoPesquisaInformacoesBasicas', params: { idProjetoPesquisa: this.idProjetoPesquisa } });
    },

    // Avançar para a próxima aba.
    toAvancar: function toAvancar() {
      this.$router.push({ name: 'ProjetoPesquisaDetalhamento', params: { idProjetoPesquisa: this.idProjetoPesquisa } });
    }
  }),
  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar___default.a,
    'c-readonly-field': __WEBPACK_IMPORTED_MODULE_1__components_c_readonly_field___default.a
  }
});

/***/ }),
/* 810 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "lg8": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Título",
      "value": this.projetoPesquisa.titulo ? this.projetoPesquisa.titulo : '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Sigla",
      "value": this.projetoPesquisa.sigla ? this.projetoPesquisa.sigla : '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Área do Conhecimento",
      "value": this.projetoPesquisa.areaConhecimento ? this.projetoPesquisa.areaConhecimento.descricao : '-'
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Nome da Área",
      "value": this.projetoPesquisa.nomeArea ? this.projetoPesquisa.nomeArea.descricao : '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Nome da Subárea",
      "value": this.projetoPesquisa.nomeSubarea ? this.projetoPesquisa.nomeSubarea.descricao : '-'
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Linha de Pesquisa no Programa de Pós-Graduação",
      "value": this.projetoPesquisa.linhaPesquisaPPG ? this.projetoPesquisa.linhaPesquisaPPG.descricao : '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Data de início",
      "value": this.projetoPesquisa.dataInicio ? _vm.dates.format(this.projetoPesquisa.dataInicio) : '-'
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Prazo em meses",
      "value": this.projetoPesquisa.prazoMeses ? this.projetoPesquisa.prazoMeses : '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Situação",
      "value": this.projetoPesquisa.situacao ? this.projetoPesquisa.situacao.descricao : '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Palavras-chaves",
      "value": this.projetoPesquisa.palavrasChaves ? this.projetoPesquisa.palavrasChaves : '-',
      "align": "justify"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Resumo",
      "value": this.projetoPesquisa.resumo ? this.projetoPesquisa.resumo : '-',
      "align": "justify"
    }
  })], 1)], 1), _vm._v(" "), _c('br')], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), (_vm.administradorPRPPG || _vm.projetoPesquisa.coordenador) ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toEditar()
      }
    }
  }, [_vm._v("Editar")]) : _vm._e(), _vm._v(" "), (_vm.habilitaBotaoAvancar()) ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toAvancar()
      }
    }
  }, [_vm._v("Avançar")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(812),
  /* template */
  __webpack_require__(813),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_readonly_field__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_readonly_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_c_readonly_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjetoPesquisa', 'projetoPesquisa'],
  data: function data() {
    return {};
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('auth', ['administrador', 'administradorPRPPG'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {

    // Edita a aba "Detalhamento".
    toEditar: function toEditar() {
      this.$router.push({ name: 'EditarProjetoPesquisaDetalhamento', params: { idProjetoPesquisa: this.idProjetoPesquisa } });
    },

    // Voltar para a aba anterior.
    toVoltar: function toVoltar() {
      this.$router.push({ name: 'ProjetoPesquisaInformacoesBasicas', params: { idProjetoPesquisa: this.idProjetoPesquisa } });
    },

    // Avançar para a próxima aba.
    toAvancar: function toAvancar() {
      this.$router.push({ name: 'ProjetoPesquisaInstituicoes', params: { idProjetoPesquisa: this.idProjetoPesquisa } });
    }
  }),
  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar___default.a,
    'c-readonly-field': __WEBPACK_IMPORTED_MODULE_1__components_c_readonly_field___default.a
  }
});

/***/ }),
/* 813 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "lg8": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Objetivos",
      "value": this.projetoPesquisa.objetivos ? this.projetoPesquisa.objetivos : '-',
      "align": "justify"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Metodologia",
      "value": this.projetoPesquisa.metodologia ? this.projetoPesquisa.metodologia : '-',
      "align": "justify"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Principal Objetivo de Desenvolvimento Sustentável",
      "value": this.projetoPesquisa.principalODS ? this.projetoPesquisa.principalODS.descricao : '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Objetivo de Desenvolvimento Sustentável Afim",
      "value": this.projetoPesquisa.afimODS ? this.projetoPesquisa.afimODS.descricao : '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Resultados esperados",
      "value": this.projetoPesquisa.resultadosEsperados ? this.projetoPesquisa.resultadosEsperados : '-',
      "align": "justify"
    }
  })], 1)], 1), _vm._v(" "), _c('br')], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toVoltar()
      }
    }
  }, [_vm._v("Voltar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.administradorPRPPG || _vm.projetoPesquisa.coordenador) ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toEditar()
      }
    }
  }, [_vm._v("Editar")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toAvancar()
      }
    }
  }, [_vm._v("Avançar")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(815)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(816),
  /* template */
  __webpack_require__(817),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 815 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_confirm_dialog__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_confirm_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_confirm_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_tooltip_btn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_tooltip_btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_c_tooltip_btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjetoPesquisa', 'projetoPesquisa'],
  data: function data() {
    return {
      dialogConfirmaExclusao: false,
      idInstituicaoProjetoPesquisaExclusao: '',
      listaInstituicoes: [],
      search: null,
      sortDesc: false,
      itemsPerPage: 25,
      opcoesPaginacao: [10, 25, 50, { text: 'Todas', value: -1 }],
      headers: [{ text: 'Nome', align: 'left', value: 'nome' }, { text: 'Sigla', align: 'left', value: 'sigla' }, { text: 'Tipo', align: 'left', value: 'tipoInstituicao.descricao' }, { text: 'Opções', align: 'left', value: 'opcoes' }]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])('auth', ['administrador', 'administradorPRPPG'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {

    // Carrega as instituições do projeto de pesquisa.
    carregaInstituicoesProjetoPesquisa: function carregaInstituicoesProjetoPesquisa() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando instituições...' });
      __WEBPACK_IMPORTED_MODULE_1__utils_projetos__["a" /* default */].getInstituicoesProjetoPesquisa(this.idProjetoPesquisa).then(function (response) {
        _this.listaInstituicoes = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando instituições...' });
      });
    },

    // Edita a instituição.
    toEditarInstituicao: function toEditarInstituicao(idInstituicaoProjetoPesquisa) {
      this.$router.push({ name: 'EditarProjetoPesquisaInstituicao', params: { idProjetoPesquisa: this.idProjetoPesquisa, idInstituicaoProjetoPesquisa: idInstituicaoProjetoPesquisa } });
    },

    // Voltar para a aba anterior.
    toVoltar: function toVoltar() {
      this.$router.push({ name: 'ProjetoPesquisaDetalhamento', params: { idProjetoPesquisa: this.idProjetoPesquisa } });
    },

    // Avançar para a próxima aba.
    toAvancar: function toAvancar() {
      this.$router.push({ name: 'ProjetoPesquisaEquipe', params: { idProjetoPesquisa: this.idProjetoPesquisa } });
    },

    // Pesquisa por instituições.
    toPesquisarInstituicao: function toPesquisarInstituicao() {
      this.$router.push({ name: 'ProjetoPesquisaPesquisarInstituicao', params: { idProjetoPesquisa: this.idProjetoPesquisa } });
    },

    // Exclui uma instituição (abre dialog de confirmação).
    toExcluirInstituicao: function toExcluirInstituicao(idInstituicaoProjetoPesquisa) {
      this.idInstituicaoProjetoPesquisaExclusao = idInstituicaoProjetoPesquisa;
      this.dialogConfirmaExclusao = true;
    },

    // Exclui uma instituição (chama endpoint para exclusão).
    excluirInstituicao: function excluirInstituicao() {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo instituição...' });
      __WEBPACK_IMPORTED_MODULE_1__utils_projetos__["a" /* default */].deleteInstituicaoProjetoPesquisa(this.idProjetoPesquisa, this.idInstituicaoProjetoPesquisaExclusao).then(function (response) {
        _this2.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this2.carregaInstituicoesProjetoPesquisa();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this2.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo instituição...' });
      });
    }
  }),
  mounted: function mounted() {
    this.carregaInstituicoesProjetoPesquisa();
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_3__components_toolbars_basic_toolbar___default.a,
    'c-tooltip-btn': __WEBPACK_IMPORTED_MODULE_4__components_c_tooltip_btn___default.a,
    'c-confirm-dialog': __WEBPACK_IMPORTED_MODULE_2__components_c_confirm_dialog___default.a
  }
});

/***/ }),
/* 817 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "text-center": "",
      "d-flex": "",
      "align-center": ""
    }
  }, [_c('c-confirm-dialog', {
    attrs: {
      "titulo": "Deseja realmente excluir a instituição?"
    },
    on: {
      "yes": function($event) {
        return _vm.excluirInstituicao()
      }
    },
    model: {
      value: (_vm.dialogConfirmaExclusao),
      callback: function($$v) {
        _vm.dialogConfirmaExclusao = $$v
      },
      expression: "dialogConfirmaExclusao"
    }
  }), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaInstituicoes,
      "search": _vm.search,
      "no-data-text": 'Nenhuma instituição cadastrada.',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.opcoes",
      fn: function(props) {
        return [(_vm.administradorPRPPG || _vm.projetoPesquisa.coordenador) ? _c('c-tooltip-btn', {
          attrs: {
            "icon": "edit",
            "color": "primary",
            "tooltip": "Editar instituição"
          },
          on: {
            "click": function($event) {
              return _vm.toEditarInstituicao(props.item.id)
            }
          }
        }) : _vm._e(), _vm._v(" "), (_vm.administradorPRPPG || _vm.projetoPesquisa.coordenador) ? _c('c-tooltip-btn', {
          attrs: {
            "icon": "delete",
            "color": "primary",
            "tooltip": "Excluir instituição",
            "disabled": props.item.idInstituicao === 1,
            "disabled-tooltip": "A Ufes não pode ser excluída"
          },
          on: {
            "click": function($event) {
              return _vm.toExcluirInstituicao(props.item.id)
            }
          }
        }) : _vm._e()]
      }
    }, {
      key: "item.sigla",
      fn: function(props) {
        return [_vm._v(_vm._s(props.item.sigla === null || props.item.sigla === '' ? '-' : props.item.sigla))]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n      Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaInstituicoes.length) + " " + _vm._s(_vm.listaInstituicoes.length > 1 ? 'instituições' : 'instituição') + "\n    ")]
      }
    }])
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toVoltar()
      }
    }
  }, [_vm._v("Voltar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.administradorPRPPG || _vm.projetoPesquisa.coordenador) ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toPesquisarInstituicao()
      }
    }
  }, [_vm._v("Adicionar Instituição")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toAvancar()
      }
    }
  }, [_vm._v("Avançar")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(819)
  __webpack_require__(820)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(821),
  /* template */
  __webpack_require__(822),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f3bfc74a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 819 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 820 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_tooltip_btn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_tooltip_btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_tooltip_btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjetoPesquisa', 'projetoPesquisa'],
  data: function data() {
    return {
      tipoBusca: 'nome',
      instituicao: {
        nome: '',
        sigla: ''
      },
      projetoPesquisa: {},
      listaInstituicoes: [],
      search: null,
      sortDesc: true,
      itemsPerPage: 25,
      opcoesPaginacao: [10, 25, 50, { text: 'Todas', value: -1 }],
      headers: [{ text: 'Nome', align: 'left', value: 'nome' }, { text: 'Sigla', align: 'left', value: 'sigla' }, { text: 'Opções', align: 'left', value: 'opcoes' }]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('auth', ['administrador'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {

    // Pesquisa instituições por nome.
    pesquisaInstituicoesPorNome: function pesquisaInstituicoesPorNome() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Pesquisando instituições...' });
      __WEBPACK_IMPORTED_MODULE_3__utils_projetos__["a" /* default */].getPesquisaInstituicoesPorNome(this.instituicao.nome).then(function (response) {
        _this.listaInstituicoes = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
        _this.listaInstituicoes = [];
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Pesquisando instituições...' });
      });
    },


    // Pesquisa instituições por sigla.
    pesquisaInstituicoesPorSigla: function pesquisaInstituicoesPorSigla() {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Pesquisando instituições...' });
      __WEBPACK_IMPORTED_MODULE_3__utils_projetos__["a" /* default */].getPesquisaInstituicoesPorSigla(this.instituicao.sigla).then(function (response) {
        _this2.listaInstituicoes = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this2.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
        _this2.listaInstituicoes = [];
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Pesquisando instituições...' });
      });
    },


    // Cadastra uma instituição.
    cadastrarInstituicao: function cadastrarInstituicao() {
      this.$router.push({ name: 'ProjetoPesquisaCadastrarInstituicao', params: { idProjetoPesquisa: this.idProjetoPesquisa } });
    },


    // Adiciona uma instituição ao projeto de pesquisa.
    toAdicionarInstituicaoProjetoPesquisa: function toAdicionarInstituicaoProjetoPesquisa(idInstituicao) {
      this.$router.push({ name: 'ProjetoPesquisaAdicionarInstituicao', params: { idProjetoPesquisa: this.idProjetoPesquisa, idInstituicao: idInstituicao } });
    },

    // Redireciona para a página anterior.
    cancelar: function cancelar() {
      this.$router.go(-1);
    }
  }),
  mounted: function mounted() {},

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'c-tooltip-btn': __WEBPACK_IMPORTED_MODULE_2__components_c_tooltip_btn___default.a
  }
});

/***/ }),
/* 822 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Pesquisar Instituição'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    staticClass: "alerta",
    attrs: {
      "color": "#00796b",
      "type": "info",
      "dense": "",
      "outlined": ""
    }
  }, [_vm._v("\n                Para adicionar uma instituição, realize a pesquisa pelo nome ou sigla da instituição. Caso a instituição desejada não seja encontrada, \n                clique no botão \"CADASTRAR INSTITUIÇÃO\".\n              ")])], 1)], 1), _vm._v(" "), _c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.tipoBusca),
      callback: function($$v) {
        _vm.tipoBusca = $$v
      },
      expression: "tipoBusca"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Nome",
      "value": "nome"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Sigla",
      "value": "sigla"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipoBusca === 'nome'),
      expression: "tipoBusca==='nome'"
    }],
    attrs: {
      "label": "Nome"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.pesquisaInstituicoesPorNome()
      }
    },
    model: {
      value: (_vm.instituicao.nome),
      callback: function($$v) {
        _vm.$set(_vm.instituicao, "nome", $$v)
      },
      expression: "instituicao.nome"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipoBusca !== 'nome'),
      expression: "tipoBusca!=='nome'"
    }],
    attrs: {
      "label": "Sigla"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.pesquisaInstituicoesPorSigla()
      }
    },
    model: {
      value: (_vm.instituicao.sigla),
      callback: function($$v) {
        _vm.$set(_vm.instituicao, "sigla", $$v)
      },
      expression: "instituicao.sigla"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding-top": "15px"
    },
    attrs: {
      "xs3": ""
    }
  }, [(_vm.tipoBusca === 'nome') ? _c('v-btn', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.pesquisaInstituicoesPorNome()
      }
    }
  }, [_vm._v("Pesquisar")]) : _c('v-btn', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.pesquisaInstituicoesPorSigla()
      }
    }
  }, [_vm._v("Pesquisar")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaInstituicoes,
      "search": _vm.search,
      "no-data-text": 'Nenhuma instituição encontrada',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.sigla",
      fn: function(props) {
        return [_vm._v(_vm._s(props.item.sigla === null || props.item.sigla === '' ? '-' : props.item.sigla))]
      }
    }, {
      key: "item.opcoes",
      fn: function(props) {
        return [_c('c-tooltip-btn', {
          attrs: {
            "icon": "add_box",
            "color": "primary",
            "tooltip": "Adicionar instituição"
          },
          on: {
            "click": function($event) {
              return _vm.toAdicionarInstituicaoProjetoPesquisa(props.item.id)
            }
          }
        })]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n              Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaInstituicoes.length) + " " + _vm._s(_vm.listaInstituicoes.length > 1 ? 'instituições' : 'instituição') + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.cancelar()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.cadastrarInstituicao()
      }
    }
  }, [_vm._v("Cadastrar Instituição")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(824)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(825),
  /* template */
  __webpack_require__(826),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 824 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjetoPesquisa', 'idInstituicao'],
  data: function data() {
    return {
      formularioValido: false,
      instituicao: {},
      instituicaoProjetoPesquisa: {
        idProjetoPesquisa: '',
        idInstituicao: ''
      },
      listaTipoInstituicaoProjetoPesquisa: [],
      obrigatorio: [function (v) {
        return !!v || 'Este campo é obrigatório';
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {

    // Adiciona a instituição ao projeto de pesquisa.
    adicionaInstituicaoProjetoPesquisa: function adicionaInstituicaoProjetoPesquisa() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Adicionando instituição ao projeto de pesquisa...' });
      // Preenche o 'idProjetoPesquisa' e o 'idInstituicao' necessários para adicionar a instituição.
      this.instituicaoProjetoPesquisa.idProjetoPesquisa = this.idProjetoPesquisa;
      this.instituicaoProjetoPesquisa.idInstituicao = this.idInstituicao;
      __WEBPACK_IMPORTED_MODULE_1__utils_projetos__["a" /* default */].postInstituicaoProjetoPesquisa(this.idProjetoPesquisa, this.instituicaoProjetoPesquisa).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.$router.push({ name: 'ProjetoPesquisaInstituicoes' });
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Adicionando instituição ao projeto de pesquisa...' });
      });
    },

    // Carrega uma tabela estruturada.
    opcoesTabelaEstruturada: function opcoesTabelaEstruturada(codTabela, aqui, atributo) {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' });
      __WEBPACK_IMPORTED_MODULE_1__utils_projetos__["a" /* default */].getOpcoesTabelaEstruturada(codTabela).then(function (response) {
        aqui[atributo] = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' });
      });
    },

    // Redireciona para a página anterior.
    cancelar: function cancelar() {
      this.$router.go(-1);
    }
  }),
  mounted: function mounted() {
    var _this3 = this;

    // Carrega a instituição.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando instituição...' });
    __WEBPACK_IMPORTED_MODULE_1__utils_projetos__["a" /* default */].getInstituicao(this.idInstituicao).then(function (response) {
      _this3.instituicao = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this3.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando instituição...' });
    });

    // Carrega lista com os tipos de instituição de um projeto de pesquisa (Tabela estruturada - código 1165).
    this.opcoesTabelaEstruturada(1165, this, 'listaTipoInstituicaoProjetoPesquisa');
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar___default.a
  }
});

/***/ }),
/* 826 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Adicionar Instituição'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome",
      "value": this.instituicao.nome === null || this.instituicao.nome === '' ? '-' : this.instituicao.nome,
      "readonly": ""
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Sigla",
      "value": this.instituicao.sigla === null || this.instituicao.sigla === '' ? '-' : this.instituicao.sigla,
      "readonly": ""
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Tipo*",
      "items": _vm.listaTipoInstituicaoProjetoPesquisa,
      "item-text": "descricao",
      "item-value": "item",
      "max-height": "400",
      "return-object": "",
      "required": "",
      "autocomplete": "",
      "rules": _vm.obrigatorio
    },
    model: {
      value: (_vm.instituicaoProjetoPesquisa.tipoInstituicao),
      callback: function($$v) {
        _vm.$set(_vm.instituicaoProjetoPesquisa, "tipoInstituicao", $$v)
      },
      expression: "instituicaoProjetoPesquisa.tipoInstituicao"
    }
  })], 1)], 1), _vm._v(" "), _c('br')], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.cancelar()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.adicionaInstituicaoProjetoPesquisa()
      }
    }
  }, [_vm._v("Adicionar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(828)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(829),
  /* template */
  __webpack_require__(830),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 828 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjetoPesquisa'],
  data: function data() {
    return {
      formularioValido: false,
      instituicao: {
        pais: null,
        cadastroAprovado: 'S'
      },
      listaPaises: [],
      listaEstados: [],
      obrigatorio: [function (v) {
        return !!v || 'Este campo é obrigatório';
      }],
      max20caracteres: [function (v) {
        return v.length <= 20 || 'Este campo pode ter no máximo 20 caracteres';
      }],
      max200caracteres: [function (v) {
        return v.length <= 200 || 'Este campo pode ter no máximo 200 caracteres';
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {

    // Cadastra a instituição.
    cadastraInstituicao: function cadastraInstituicao() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Cadastrando instituição...' });
      // Se a instituição não for do Brasil, não salva o estado.
      if (this.instituicao.pais !== null && this.instituicao.pais.nome !== 'Brasil') {
        this.instituicao.estado = null;
      }
      __WEBPACK_IMPORTED_MODULE_2__utils_projetos__["a" /* default */].postInstituicao(this.instituicao).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.$router.push({ name: 'ProjetoPesquisaPesquisarInstituicao', params: { idProjetoPesquisa: _this.idProjetoPesquisa } });
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Cadastrando instituição...' });
      });
    },

    // Redireciona para a página anterior.
    cancelar: function cancelar() {
      this.$router.go(-1);
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    // Carrega lista de países.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando países...' });
    __WEBPACK_IMPORTED_MODULE_2__utils_projetos__["a" /* default */].getPaisesInstituicaoProjetoPesquisa().then(function (response) {
      _this2.listaPaises = response.data.slice();
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando países...' });
    });

    // Carrega lista de estados.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando estados...' });
    __WEBPACK_IMPORTED_MODULE_2__utils_projetos__["a" /* default */].getEstadosInstituicaoProjetoPesquisa().then(function (response) {
      _this2.listaEstados = response.data.slice();
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando estados...' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a
  }
});

/***/ }),
/* 830 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Cadastrar Instituição'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome*",
      "counter": "200",
      "rules": _vm.obrigatorio.concat( _vm.max200caracteres)
    },
    model: {
      value: (_vm.instituicao.nome),
      callback: function($$v) {
        _vm.$set(_vm.instituicao, "nome", $$v)
      },
      expression: "instituicao.nome"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Sigla",
      "counter": "20",
      "rules": _vm.max20caracteres
    },
    model: {
      value: (_vm.instituicao.sigla),
      callback: function($$v) {
        _vm.$set(_vm.instituicao, "sigla", $$v)
      },
      expression: "instituicao.sigla"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "País*",
      "items": _vm.listaPaises,
      "item-text": "nome",
      "item-value": "id",
      "max-height": "400",
      "return-object": "",
      "required": "",
      "autocomplete": "",
      "rules": _vm.obrigatorio
    },
    model: {
      value: (_vm.instituicao.pais),
      callback: function($$v) {
        _vm.$set(_vm.instituicao, "pais", $$v)
      },
      expression: "instituicao.pais"
    }
  })], 1)], 1), _vm._v(" "), (_vm.instituicao.pais !== null && _vm.instituicao.pais.nome === 'Brasil') ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Estado*",
      "items": _vm.listaEstados,
      "item-text": "nome",
      "item-value": "id",
      "max-height": "400",
      "return-object": "",
      "required": "",
      "autocomplete": "",
      "rules": _vm.obrigatorio
    },
    model: {
      value: (_vm.instituicao.estado),
      callback: function($$v) {
        _vm.$set(_vm.instituicao, "estado", $$v)
      },
      expression: "instituicao.estado"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('br')], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.cancelar()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.cadastraInstituicao()
      }
    }
  }, [_vm._v("Cadastrar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(832)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(833),
  /* template */
  __webpack_require__(834),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c3518ab4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 832 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_confirm_dialog__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_confirm_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_confirm_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_tooltip_btn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_tooltip_btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_c_tooltip_btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjetoPesquisa', 'projetoPesquisa'],
  data: function data() {
    return {
      dialogConfirmaExclusao: false,
      idParticipanteProjetoPesquisaExclusao: '',
      dates: __WEBPACK_IMPORTED_MODULE_5__utils_dates__["a" /* default */],
      sortBy: null,
      sortDesc: false,
      itemsPerPage: 25,
      opcoesPaginacao: [10, 25, 50, { text: 'Todas', value: -1 }],
      listaParticipantes: [],
      headers: [{ text: 'Nome', align: 'left', value: 'nome' }, { text: 'Tipo de participação', align: 'left', value: 'tipoParticipacao.descricao' }, { text: 'CH semanal*', align: 'left', value: 'cargaHorariaSemanal' }, { text: 'Data inicial', align: 'left', value: 'dataInicial' }, { text: 'Data final', align: 'left', value: 'dataFinal' }, { text: 'Opções', align: 'left', value: 'opcoes' }]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])('auth', ['administrador', 'administradorPRPPG'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {

    // Carrega os participantes do projeto de pesquisa.
    carregaParticipantesProjetoPesquisa: function carregaParticipantesProjetoPesquisa() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando equipe...' });
      __WEBPACK_IMPORTED_MODULE_1__utils_projetos__["a" /* default */].getParticipantesProjetoPesquisa(this.idProjetoPesquisa).then(function (response) {
        _this.listaParticipantes = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando equipe...' });
      });
    },

    // Edita um membro da equipe.
    toEditarParticipanteProjetoPesquisa: function toEditarParticipanteProjetoPesquisa(idParticipanteProjetoPesquisa) {
      this.$router.push({ name: 'EditarProjetoPesquisaMembroEquipe', params: { idProjetoPesquisa: this.idProjetoPesquisa, idParticipanteProjetoPesquisa: idParticipanteProjetoPesquisa } });
    },

    // Voltar para a aba anterior.
    toVoltar: function toVoltar() {
      this.$router.push({ name: 'ProjetoPesquisaInstituicoes', params: { idProjetoPesquisa: this.idProjetoPesquisa } });
    },

    // Avançar para a próxima aba.
    toAvancar: function toAvancar() {
      this.$router.push({ name: 'ProjetoPesquisaOrgaosFinanciadores', params: { idProjetoPesquisa: this.idProjetoPesquisa } });
    },

    // Finaliza a participação de um membro da equipe.
    toFinalizarParticipacaoParticipanteProjetoPesquisa: function toFinalizarParticipacaoParticipanteProjetoPesquisa(idParticipanteProjetoPesquisa) {
      this.$router.push({ name: 'FinalizarParticipacaoProjetoPesquisaMembroEquipe', params: { idProjetoPesquisa: this.idProjetoPesquisa, idParticipanteProjetoPesquisa: idParticipanteProjetoPesquisa } });
    },

    // Pesquisa por pessoas.
    toPesquisarPessoas: function toPesquisarPessoas() {
      this.$router.push({ name: 'ProjetoPesquisaPesquisarPessoas', params: { idProjetoPesquisa: this.idProjetoPesquisa } });
    },

    // Exclui um membro da equipe (abre dialog de confirmação).
    toExcluirParticipanteProjetoPesquisa: function toExcluirParticipanteProjetoPesquisa(idParticipanteProjetoPesquisa) {
      this.idParticipanteProjetoPesquisaExclusao = idParticipanteProjetoPesquisa;
      this.dialogConfirmaExclusao = true;
    },

    // Exclui um membro da equipe (chama endpoint para exclusão).
    excluirMembroEquipe: function excluirMembroEquipe() {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo membro da equipe...' });
      __WEBPACK_IMPORTED_MODULE_1__utils_projetos__["a" /* default */].deleteParticipanteProjetoPesquisa(this.idProjetoPesquisa, this.idParticipanteProjetoPesquisaExclusao).then(function (response) {
        _this2.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this2.carregaParticipantesProjetoPesquisa();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this2.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo membro da equipe...' });
      });
    }
  }),
  mounted: function mounted() {
    this.carregaParticipantesProjetoPesquisa();
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_3__components_toolbars_basic_toolbar___default.a,
    'c-tooltip-btn': __WEBPACK_IMPORTED_MODULE_4__components_c_tooltip_btn___default.a,
    'c-confirm-dialog': __WEBPACK_IMPORTED_MODULE_2__components_c_confirm_dialog___default.a
  }
});

/***/ }),
/* 834 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "text-center": "",
      "d-flex": "",
      "align-center": ""
    }
  }, [_c('c-confirm-dialog', {
    attrs: {
      "titulo": "Deseja realmente excluir o membro da equipe?"
    },
    on: {
      "yes": function($event) {
        return _vm.excluirMembroEquipe()
      }
    },
    model: {
      value: (_vm.dialogConfirmaExclusao),
      callback: function($$v) {
        _vm.dialogConfirmaExclusao = $$v
      },
      expression: "dialogConfirmaExclusao"
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    staticClass: "alerta",
    attrs: {
      "color": "#00796b",
      "type": "info",
      "dense": "",
      "outlined": ""
    }
  }, [_vm._v("\n        *Compete aos Departamentos Acadêmicos destinar carga horária às atividades de pesquisa de seus docentes (Res. 21/2013 - CEPE).\n      ")])], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaParticipantes,
      "search": _vm.search,
      "no-data-text": 'Nenhum participante cadastrado.',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.opcoes",
      fn: function(props) {
        return [_c('div', [(_vm.administradorPRPPG || _vm.projetoPesquisa.coordenador) ? _c('c-tooltip-btn', {
          attrs: {
            "icon": "edit",
            "color": "primary",
            "tooltip": "Editar membro da equipe",
            "disabled": props.item.situacao === 'I',
            "disabled-tooltip": "A participação do membro da equipe já foi finalizada"
          },
          on: {
            "click": function($event) {
              return _vm.toEditarParticipanteProjetoPesquisa(props.item.id)
            }
          }
        }) : _vm._e(), _vm._v(" "), (_vm.administradorPRPPG || _vm.projetoPesquisa.coordenador) ? _c('c-tooltip-btn', {
          attrs: {
            "icon": "transfer_within_a_station",
            "color": "primary",
            "tooltip": "Finalizar participação do membro da equipe",
            "disabled": props.item.situacao === 'I',
            "disabled-tooltip": "A participação do membro da equipe já foi finalizada"
          },
          on: {
            "click": function($event) {
              return _vm.toFinalizarParticipacaoParticipanteProjetoPesquisa(props.item.id)
            }
          }
        }) : _vm._e(), _vm._v(" "), (_vm.administradorPRPPG || _vm.projetoPesquisa.coordenador) ? _c('c-tooltip-btn', {
          attrs: {
            "icon": "delete",
            "color": "primary",
            "tooltip": "Excluir membro da equipe",
            "disabled": props.item.situacao === 'I',
            "disabled-tooltip": "A participação do membro da equipe já foi finalizada"
          },
          on: {
            "click": function($event) {
              return _vm.toExcluirParticipanteProjetoPesquisa(props.item.id)
            }
          }
        }) : _vm._e()], 1)]
      }
    }, {
      key: "item.cargaHorariaSemanal",
      fn: function(props) {
        return [_vm._v(_vm._s(props.item.cargaHorariaSemanal === null || props.item.cargaHorariaSemanal === '' ? '-' : props.item.cargaHorariaSemanal))]
      }
    }, {
      key: "item.dataInicial",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dataInicial)))]
      }
    }, {
      key: "item.dataFinal",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dataFinal)))]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n      Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaParticipantes.length) + " " + _vm._s(_vm.listaParticipantes.length > 1 ? 'membros da equipe' : 'membro da equipe') + "\n    ")]
      }
    }])
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toVoltar()
      }
    }
  }, [_vm._v("Voltar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.administradorPRPPG || _vm.projetoPesquisa.coordenador) ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toPesquisarPessoas()
      }
    }
  }, [_vm._v("Adicionar Membro da Equipe")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toAvancar()
      }
    }
  }, [_vm._v("Avançar")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(836)
  __webpack_require__(837)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(838),
  /* template */
  __webpack_require__(839),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0000181b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 836 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 837 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_tooltip_btn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_tooltip_btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_tooltip_btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjetoPesquisa', 'projetoPesquisa'],
  data: function data() {
    return {
      tipoBusca: 'nome',
      pessoa: {
        nome: '',
        cpf: ''
      },
      listaPessoas: [],
      projetoPesquisa: {},
      search: null,
      sortDesc: true,
      itemsPerPage: 25,
      opcoesPaginacao: [10, 25, 50, { text: 'Todas', value: -1 }],
      headers: [{ text: 'Nome', align: 'left', width: '50%', value: 'nomeSocial' }, { text: 'CPF', align: 'left', width: '25%', value: 'cpf' }, { text: 'Opções', align: 'left', width: '25%', value: 'opcoes' }]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('auth', ['administrador'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {

    // Pesquisa pessoa pelo nome.
    pesquisaPessoasPorNome: function pesquisaPessoasPorNome() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Pesquisando pessoas...' });
      __WEBPACK_IMPORTED_MODULE_3__utils_projetos__["a" /* default */].getPessoasPorNome(this.pessoa.nome).then(function (response) {
        _this.listaPessoas = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Pesquisando pessoas...' });
      });
    },


    // Pesquisa pessoa pelo CPF.
    pesquisaPessoasPorCpf: function pesquisaPessoasPorCpf() {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Pesquisando pessoas...' });
      __WEBPACK_IMPORTED_MODULE_3__utils_projetos__["a" /* default */].getPessoasPorCpf(this.pessoa.cpf).then(function (response) {
        _this2.listaPessoas = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this2.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Pesquisando pessoas...' });
      });
    },


    // Cadastra um membro externo.
    cadastrarMembroExterno: function cadastrarMembroExterno() {
      this.$router.push({ name: 'ProjetoPesquisaCadastrarMembroExterno', params: { idProjetoPesquisa: this.idProjetoPesquisa } });
    },


    // Redireciona para a página anterior.
    cancelar: function cancelar() {
      this.$router.go(-1);
    },

    // Adiciona um participante ao projeto de pesquisa.
    toAdicionarMembroEquipe: function toAdicionarMembroEquipe(idPessoa) {
      this.$router.push({ name: 'ProjetoPesquisaAdicionarMembroEquipe', params: { idProjetoPesquisa: this.idProjetoPesquisa, idPessoa: idPessoa } });
    }
  }),
  mounted: function mounted() {},

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'c-tooltip-btn': __WEBPACK_IMPORTED_MODULE_2__components_c_tooltip_btn___default.a
  }
});

/***/ }),
/* 839 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Pesquisar Pessoa'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    staticClass: "alerta",
    attrs: {
      "color": "#00796b",
      "type": "info",
      "dense": "",
      "outlined": ""
    }
  }, [_vm._v("\n                Para adicionar um membro da equipe, realize a pesquisa pelo nome ou CPF da pessoa. Caso a pessoa desejada não seja encontrada, \n                clique no botão \"CADASTRAR MEMBRO EXTERNO\".\n              ")])], 1)], 1), _vm._v(" "), _c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.tipoBusca),
      callback: function($$v) {
        _vm.tipoBusca = $$v
      },
      expression: "tipoBusca"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Nome",
      "value": "nome"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "CPF",
      "value": "cpf"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipoBusca === 'nome'),
      expression: "tipoBusca==='nome'"
    }],
    attrs: {
      "label": "Nome",
      "max-height": "400"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.pesquisaPessoasPorNome()
      }
    },
    model: {
      value: (_vm.pessoa.nome),
      callback: function($$v) {
        _vm.$set(_vm.pessoa, "nome", $$v)
      },
      expression: "pessoa.nome"
    }
  }), _vm._v(" "), _c('v-text-field-cpf', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipoBusca !== 'nome'),
      expression: "tipoBusca!=='nome'"
    }],
    attrs: {
      "label": "CPF",
      "options": {
        outputMask: '###.###.###-##',
      }
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.pesquisaPessoasPorCpf()
      }
    },
    model: {
      value: (_vm.pessoa.cpf),
      callback: function($$v) {
        _vm.$set(_vm.pessoa, "cpf", $$v)
      },
      expression: "pessoa.cpf"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding-top": "15px"
    },
    attrs: {
      "xs3": ""
    }
  }, [(_vm.tipoBusca === 'nome') ? _c('v-btn', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.pesquisaPessoasPorNome()
      }
    }
  }, [_vm._v("Pesquisar")]) : _c('v-btn', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.pesquisaPessoasPorCpf()
      }
    }
  }, [_vm._v("Pesquisar")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaPessoas,
      "search": _vm.search,
      "no-data-text": 'Nenhuma pessoa encontrada',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.opcoes",
      fn: function(props) {
        return [_c('c-tooltip-btn', {
          attrs: {
            "icon": "add_box",
            "color": "primary",
            "tooltip": "Adicionar como membro da equipe"
          },
          on: {
            "click": function($event) {
              return _vm.toAdicionarMembroEquipe(props.item.idPessoa)
            }
          }
        })]
      }
    }, {
      key: "item.cpf",
      fn: function(props) {
        return [_vm._v(_vm._s(props.item.cpf === null || props.item.cpf === '' ? '-' : props.item.cpf))]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n              Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaPessoas.length) + " " + _vm._s(_vm.listaPessoas.length > 1 ? 'pessoas' : 'pessoa') + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.cancelar()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.cadastrarMembroExterno()
      }
    }
  }, [_vm._v("Cadastrar Membro Externo")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(841)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(842),
  /* template */
  __webpack_require__(843),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 841 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_date_dialog__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_date_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_date_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjetoPesquisa', 'idPessoa'],
  data: function data() {
    return {
      formularioValido: false,
      pessoa: {},
      participanteProjetoPesquisa: {
        idProjetoPesquisa: '',
        idPessoa: '',
        cargaHorariaSemanal: null,
        situacao: 'A'
      },
      listaTiposParticipacao: [],
      obrigatorio: [function (v) {
        return !!v || 'Este campo é obrigatório';
      }],
      numerico: [function (input) {
        return !isNaN(input) || 'Este campo deve ser numérico';
      }, function (input) {
        return input.length === 0 || Number(input) !== 0 || 'Este campo não pode ser nulo';
      }, function (input) {
        return input.length === 0 || Number(input) >= 0 || 'Este campo não pode ter valor negativo';
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {

    // Adiciona o participante ao projeto de pesquisa.
    adicionaParticipanteProjetoPesquisa: function adicionaParticipanteProjetoPesquisa() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Adicionando participante ao projeto de pesquisa...' });
      // Preenche o 'idProjetoPesquisa' e o 'idPessoa' necessários para adicionar o participante.
      this.participanteProjetoPesquisa.idProjetoPesquisa = this.idProjetoPesquisa;
      this.participanteProjetoPesquisa.idPessoa = this.idPessoa;
      __WEBPACK_IMPORTED_MODULE_3__utils_projetos__["a" /* default */].postParticipanteProjetoPesquisa(this.idProjetoPesquisa, this.participanteProjetoPesquisa).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.$router.push({ name: 'ProjetoPesquisaEquipe' });
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Adicionando participante ao projeto de pesquisa...' });
      });
    },

    // Carrega uma tabela estruturada.
    opcoesTabelaEstruturada: function opcoesTabelaEstruturada(codTabela, aqui, atributo) {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções...' });
      __WEBPACK_IMPORTED_MODULE_3__utils_projetos__["a" /* default */].getOpcoesTabelaEstruturada(codTabela).then(function (response) {
        aqui[atributo] = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções...' });
      });
    },

    // Redireciona para a página anterior.
    cancelar: function cancelar() {
      this.$router.go(-1);
    }
  }),
  mounted: function mounted() {
    var _this3 = this;

    // Carrega a pessoa.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando pessoa...' });
    __WEBPACK_IMPORTED_MODULE_3__utils_projetos__["a" /* default */].getPessoa(this.idPessoa).then(function (response) {
      // Preenche dados da pessoa.
      _this3.pessoa = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this3.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando pessoa...' });
    });

    // Carrega lista com os tipos de participação de um membro da equipe de um projeto de pesquisa (Tabela estruturada - código 1160).
    this.opcoesTabelaEstruturada(1160, this, 'listaTiposParticipacao');
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'c-date-dialog': __WEBPACK_IMPORTED_MODULE_2__components_c_date_dialog___default.a
  }
});

/***/ }),
/* 843 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Adicionar Membro da Equipe'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome",
      "value": this.pessoa.nomeSocial === null || this.pessoa.nomeSocial === '' ? '-' : this.pessoa.nomeSocial,
      "readonly": ""
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Tipo de participação*",
      "items": _vm.listaTiposParticipacao,
      "item-text": "descricao",
      "item-value": "item",
      "max-height": "400",
      "return-object": "",
      "required": "",
      "autocomplete": "",
      "rules": _vm.obrigatorio
    },
    model: {
      value: (_vm.participanteProjetoPesquisa.tipoParticipacao),
      callback: function($$v) {
        _vm.$set(_vm.participanteProjetoPesquisa, "tipoParticipacao", $$v)
      },
      expression: "participanteProjetoPesquisa.tipoParticipacao"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field-integer', {
    attrs: {
      "label": "Carga horária semanal",
      "properties": {
        rules: _vm.numerico
      }
    },
    model: {
      value: (_vm.participanteProjetoPesquisa.cargaHorariaSemanal),
      callback: function($$v) {
        _vm.$set(_vm.participanteProjetoPesquisa, "cargaHorariaSemanal", $$v)
      },
      expression: "participanteProjetoPesquisa.cargaHorariaSemanal"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-date-dialog', {
    attrs: {
      "label": "Data inicial*",
      "rules": _vm.obrigatorio
    },
    model: {
      value: (_vm.participanteProjetoPesquisa.dataInicial),
      callback: function($$v) {
        _vm.$set(_vm.participanteProjetoPesquisa, "dataInicial", $$v)
      },
      expression: "participanteProjetoPesquisa.dataInicial"
    }
  })], 1)], 1), _vm._v(" "), _c('br')], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.cancelar()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.adicionaParticipanteProjetoPesquisa()
      }
    }
  }, [_vm._v("Adicionar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(845)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(846),
  /* template */
  __webpack_require__(847),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 845 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjeto'],
  data: function data() {
    return {
      formularioValido: false,
      temNomeSocial: false,
      pessoa: {
        nome: '',
        nomeSocial: '',
        cpf: '',
        passaporte: '',
        estrangeiro: false
      },
      obrigatorio: [function (v) {
        return !!v || 'Este campo é obrigatório';
      }],
      max40caracteres: [function (v) {
        return v.length <= 40 || 'Este campo pode ter no máximo 40 caracteres';
      }],
      max200caracteres: [function (v) {
        return v.length <= 200 || 'Este campo pode ter no máximo 200 caracteres';
      }],
      excadServer: {}
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {
    // Cancelar.
    cancelar: function cancelar() {
      this.$router.go(-1);
    },
    // Cadastra membro externo.
    cadastraMembroExterno: function cadastraMembroExterno(avancar) {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Cadastrando novo membro externo...' });
      if (!this.temNomeSocial) {
        this.pessoa.nomeSocial = this.pessoa.nome;
      }
      __WEBPACK_IMPORTED_MODULE_2__utils_projetos__["a" /* default */].postPessoa(this.pessoa).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.$router.go(-1);
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Cadastrando novo membro externo...' });
      });
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    // Carrega endereço do ExCAD.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando endereço do servidor do ExCAD...' });
    __WEBPACK_IMPORTED_MODULE_2__utils_projetos__["a" /* default */].getExcadServer().then(function (response) {
      _this2.excadServer = response.data;
      // Preenche o link com a URL do ExCAD.
      var excadServerUrl = _this2.excadServer.url;
      document.getElementById('excadLink').setAttribute('href', excadServerUrl);
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando endereço do servidor do ExCAD...' });
    });
  },


  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a
  }
});

/***/ }),
/* 847 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Cadastrar Membro Externo'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "center"
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-text', {
    staticClass: "black--text font-weight-bold"
  }, [_vm._v("\n                        Cadastre o membro externo preenchendo os dados do formulário abaixo. Caso o membro externo necessite ter acesso aos sistemas corporativos da UFES ou ao\n                        "), _c('a', {
    attrs: {
      "href": "http://nti.ufes.br/eduroam",
      "target": "_blank"
    }
  }, [_vm._v("Eduroam")]), _vm._v(", o cadastro deve ser realizado por meio do sistema "), _c('a', {
    attrs: {
      "href": "url",
      "id": "excadLink",
      "target": "_blank"
    }
  }, [_vm._v("ExCAD - Extensão do Cadastro")]), _vm._v(".\n                        Para obter maiores informações sobre o sistema ExCAD, clique no link a seguir: "), _c('a', {
    attrs: {
      "href": "http://www.sti.ufes.br/excad-extensao-de-cadastro-de-pessoas-sem-vinculo",
      "target": "_blank"
    }
  }, [_vm._v("STI - Serviços web - ExCAD")]), _vm._v(".\n                      ")])], 1)], 1)])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-radio-group', {
    attrs: {
      "mandatory": "",
      "label": "O membro externo é estrangeiro?"
    },
    model: {
      value: (_vm.pessoa.estrangeiro),
      callback: function($$v) {
        _vm.$set(_vm.pessoa, "estrangeiro", $$v)
      },
      expression: "pessoa.estrangeiro"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Sim",
      "value": true
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Não",
      "value": false
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome*",
      "counter": "200",
      "rules": _vm.obrigatorio.concat( _vm.max200caracteres),
      "max-height": "400"
    },
    model: {
      value: (_vm.pessoa.nome),
      callback: function($$v) {
        _vm.$set(_vm.pessoa, "nome", $$v)
      },
      expression: "pessoa.nome"
    }
  })], 1)], 1), _vm._v(" "), (_vm.pessoa.estrangeiro === false) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Possui nome social?"
    },
    model: {
      value: (_vm.temNomeSocial),
      callback: function($$v) {
        _vm.temNomeSocial = $$v
      },
      expression: "temNomeSocial"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.temNomeSocial) ? _c('v-text-field', {
    attrs: {
      "label": "Nome Social*",
      "counter": "200",
      "rules": _vm.obrigatorio.concat( _vm.max200caracteres),
      "max-height": "400"
    },
    model: {
      value: (_vm.pessoa.nomeSocial),
      callback: function($$v) {
        _vm.$set(_vm.pessoa, "nomeSocial", $$v)
      },
      expression: "pessoa.nomeSocial"
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.pessoa.estrangeiro === false) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field-cpf', {
    attrs: {
      "label": "CPF*",
      "options": {
        outputMask: '###.###.###-##',
      },
      "properties": {
        rules: _vm.obrigatorio
      }
    },
    model: {
      value: (_vm.pessoa.cpf),
      callback: function($$v) {
        _vm.$set(_vm.pessoa, "cpf", $$v)
      },
      expression: "pessoa.cpf"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.pessoa.estrangeiro === true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Passaporte*",
      "counter": "40",
      "rules": _vm.obrigatorio.concat( _vm.max40caracteres)
    },
    model: {
      value: (_vm.pessoa.passaporte),
      callback: function($$v) {
        _vm.$set(_vm.pessoa, "passaporte", $$v)
      },
      expression: "pessoa.passaporte"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.cancelar
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.cadastraMembroExterno()
      }
    }
  }, [_vm._v("Cadastrar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(849),
  /* template */
  __webpack_require__(850),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_confirm_dialog__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_confirm_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_confirm_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_tooltip_btn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_tooltip_btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_c_tooltip_btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjetoPesquisa', 'projetoPesquisa'],
  data: function data() {
    return {
      dialogConfirmaExclusao: false,
      idOrgaoFinanciadorProjetoPesquisaExclusao: '',
      sortBy: null,
      sortDesc: false,
      itemsPerPage: 25,
      opcoesPaginacao: [10, 25, 50, { text: 'Todas', value: -1 }],
      listaOrgaosFinanciadores: [],
      headers: [{ text: 'Nome', align: 'left', value: 'nome' }, { text: 'Sigla', align: 'left', value: 'sigla' }, { text: 'Valor', align: 'left', value: 'valor' }, { text: 'Opções', align: 'left', value: 'opcoes' }]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])('auth', ['administrador', 'administradorPRPPG'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {

    // Carrega os órgãos financiadores do projeto de pesquisa.
    carregaOrgaosFinanciadoresProjetoPesquisa: function carregaOrgaosFinanciadoresProjetoPesquisa() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando órgãos financiadores...' });
      __WEBPACK_IMPORTED_MODULE_1__utils_projetos__["a" /* default */].getOrgaosFinanciadoresProjetoPesquisa(this.idProjetoPesquisa).then(function (response) {
        _this.listaOrgaosFinanciadores = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando órgãos financiadores...' });
      });
    },

    // Edita o órgão financiador.
    toEditarOrgaoFinanciadorProjetoPesquisa: function toEditarOrgaoFinanciadorProjetoPesquisa(idOrgaoFinanciadorProjetoPesquisa) {
      this.$router.push({ name: 'EditarProjetoPesquisaOrgaoFinanciador', params: { idProjetoPesquisa: this.idProjetoPesquisa, idOrgaoFinanciadorProjetoPesquisa: idOrgaoFinanciadorProjetoPesquisa } });
    },

    // Voltar para a aba anterior.
    toVoltar: function toVoltar() {
      this.$router.push({ name: 'ProjetoPesquisaEquipe', params: { idProjetoPesquisa: this.idProjetoPesquisa } });
    },

    // Avançar para a próxima aba.
    toAvancar: function toAvancar() {
      this.$router.push({ name: 'ProjetoPesquisaArquivos', params: { idProjetoPesquisa: this.idProjetoPesquisa } });
    },

    // Pesquisa por órgãos financiadores.
    toPesquisarOrgao: function toPesquisarOrgao() {
      this.$router.push({ name: 'ProjetoPesquisaPesquisarOrgaoFinanciador', params: { idProjetoPesquisa: this.idProjetoPesquisa } });
    },

    // Exclui um órgão financiador (abre dialog de confirmação).
    toExcluirOrgaoFinanciadorProjetoPesquisa: function toExcluirOrgaoFinanciadorProjetoPesquisa(idOrgaoFinanciadorProjetoPesquisa) {
      this.idOrgaoFinanciadorProjetoPesquisaExclusao = idOrgaoFinanciadorProjetoPesquisa;
      this.dialogConfirmaExclusao = true;
    },

    // Exclui um órgão financiador (chama endpoint para exclusão).
    excluirOrgaoFinanciadorProjetoPesquisa: function excluirOrgaoFinanciadorProjetoPesquisa() {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo órgão financiador...' });
      __WEBPACK_IMPORTED_MODULE_1__utils_projetos__["a" /* default */].deleteOrgaoFinanciadorProjetoPesquisa(this.idProjetoPesquisa, this.idOrgaoFinanciadorProjetoPesquisaExclusao).then(function (response) {
        _this2.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this2.carregaOrgaosFinanciadoresProjetoPesquisa();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this2.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo órgão financiador...' });
      });
    }
  }),
  mounted: function mounted() {
    this.carregaOrgaosFinanciadoresProjetoPesquisa();
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_3__components_toolbars_basic_toolbar___default.a,
    'c-tooltip-btn': __WEBPACK_IMPORTED_MODULE_4__components_c_tooltip_btn___default.a,
    'c-confirm-dialog': __WEBPACK_IMPORTED_MODULE_2__components_c_confirm_dialog___default.a
  }
});

/***/ }),
/* 850 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "text-center": "",
      "d-flex": "",
      "align-center": ""
    }
  }, [_c('c-confirm-dialog', {
    attrs: {
      "titulo": "Deseja realmente excluir o órgão financiador?"
    },
    on: {
      "yes": function($event) {
        return _vm.excluirOrgaoFinanciadorProjetoPesquisa()
      }
    },
    model: {
      value: (_vm.dialogConfirmaExclusao),
      callback: function($$v) {
        _vm.dialogConfirmaExclusao = $$v
      },
      expression: "dialogConfirmaExclusao"
    }
  }), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaOrgaosFinanciadores,
      "search": _vm.search,
      "no-data-text": 'Nenhum órgão financiador cadastrado.',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.opcoes",
      fn: function(props) {
        return [_c('div', [(_vm.administradorPRPPG || _vm.projetoPesquisa.coordenador) ? _c('c-tooltip-btn', {
          attrs: {
            "icon": "edit",
            "color": "primary",
            "tooltip": "Editar órgão financiador"
          },
          on: {
            "click": function($event) {
              return _vm.toEditarOrgaoFinanciadorProjetoPesquisa(props.item.id)
            }
          }
        }) : _vm._e(), _vm._v(" "), (_vm.administradorPRPPG || _vm.projetoPesquisa.coordenador) ? _c('c-tooltip-btn', {
          attrs: {
            "icon": "delete",
            "color": "primary",
            "tooltip": "Excluir órgão financiador"
          },
          on: {
            "click": function($event) {
              return _vm.toExcluirOrgaoFinanciadorProjetoPesquisa(props.item.id)
            }
          }
        }) : _vm._e()], 1)]
      }
    }, {
      key: "item.sigla",
      fn: function(props) {
        return [_vm._v(_vm._s(props.item.sigla === null || props.item.sigla === '' ? '-' : props.item.sigla))]
      }
    }, {
      key: "item.valor",
      fn: function(props) {
        return [_vm._v(_vm._s(props.item.valor.toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL'
        })))]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n      Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaOrgaosFinanciadores.length) + " " + _vm._s(_vm.listaOrgaosFinanciadores.length > 1 ? 'órgãos financiadores' : 'órgão financiador') + "\n    ")]
      }
    }])
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toVoltar()
      }
    }
  }, [_vm._v("Voltar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.administradorPRPPG || _vm.projetoPesquisa.coordenador) ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toPesquisarOrgao()
      }
    }
  }, [_vm._v("Adicionar Órgão Financiador")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toAvancar()
      }
    }
  }, [_vm._v("Avançar")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(852)
  __webpack_require__(853)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(854),
  /* template */
  __webpack_require__(855),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-522b1218",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 852 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 853 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_tooltip_btn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_tooltip_btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_tooltip_btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjetoPesquisa', 'projetoPesquisa'],
  data: function data() {
    return {
      tipoBusca: 'nome',
      orgaoFinanciador: {
        nome: '',
        sigla: ''
      },
      projetoPesquisa: {},
      listaOrgaos: [],
      search: null,
      sortBy: 'dtCriacao',
      sortDesc: true,
      itemsPerPage: 25,
      opcoesPaginacao: [10, 25, 50, { text: 'Todas', value: -1 }],
      headers: [{ text: 'Nome', align: 'left', value: 'nome' }, { text: 'Sigla', align: 'left', value: 'sigla' }, { text: 'Opções', align: 'left', value: 'opcoes' }]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('auth', ['administrador'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {

    // Pesquisa órgãos financiadores por nome.
    pesquisaOrgaosFinanciadoresPorNome: function pesquisaOrgaosFinanciadoresPorNome() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Pesquisando órgãos financiadores...' });
      __WEBPACK_IMPORTED_MODULE_3__utils_projetos__["a" /* default */].getPesquisaOrgaosFinanciadoresPorNome(this.orgaoFinanciador.nome).then(function (response) {
        _this.listaOrgaos = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
        _this.listaOrgaos = [];
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Pesquisando órgãos financiadores...' });
      });
    },


    // Pesquisa órgãos financiadores por sigla.
    pesquisaOrgaosFinanciadoresPorSigla: function pesquisaOrgaosFinanciadoresPorSigla() {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Pesquisando órgãos financiadores...' });
      __WEBPACK_IMPORTED_MODULE_3__utils_projetos__["a" /* default */].getPesquisaOrgaosFinanciadoresPorSigla(this.orgaoFinanciador.sigla).then(function (response) {
        _this2.listaOrgaos = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this2.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
        _this2.listaOrgaos = [];
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Pesquisando órgãos financiadores...' });
      });
    },


    // Cadastra um novo órgão financiador.
    cadastrarOrgao: function cadastrarOrgao() {
      this.$router.push({ name: 'ProjetoPesquisaCadastrarOrgaoFinanciador', params: { idProjetoPesquisa: this.idProjetoPesquisa } });
    },


    // Adiciona um órgão financiador ao projeto de pesquisa.
    toAdicionarOrgaoFinanciador: function toAdicionarOrgaoFinanciador(idOrgaoFinanciador) {
      this.$router.push({ name: 'ProjetoPesquisaAdicionarOrgaoFinanciador', params: { idProjetoPesquisa: this.idProjetoPesquisa, idOrgaoFinanciador: idOrgaoFinanciador } });
    },

    // Redireciona para a página anterior.
    cancelar: function cancelar() {
      this.$router.go(-1);
    }
  }),
  mounted: function mounted() {},

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'c-tooltip-btn': __WEBPACK_IMPORTED_MODULE_2__components_c_tooltip_btn___default.a
  }
});

/***/ }),
/* 855 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Pesquisar Órgãos'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    staticClass: "alerta",
    attrs: {
      "color": "#00796b",
      "type": "info",
      "dense": "",
      "outlined": ""
    }
  }, [_vm._v("\n                Para adicionar um órgão financiador, realize a pesquisa pelo nome ou sigla do órgão. Caso o órgão desejado não seja encontrado, \n                clique no botão \"CADASTRAR ÓRGÃO\".\n              ")])], 1)], 1), _vm._v(" "), _c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.tipoBusca),
      callback: function($$v) {
        _vm.tipoBusca = $$v
      },
      expression: "tipoBusca"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Nome",
      "value": "nome"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Sigla",
      "value": "sigla"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipoBusca === 'nome'),
      expression: "tipoBusca==='nome'"
    }],
    attrs: {
      "label": "Nome"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.pesquisaOrgaosFinanciadoresPorNome()
      }
    },
    model: {
      value: (_vm.orgaoFinanciador.nome),
      callback: function($$v) {
        _vm.$set(_vm.orgaoFinanciador, "nome", $$v)
      },
      expression: "orgaoFinanciador.nome"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipoBusca !== 'nome'),
      expression: "tipoBusca!=='nome'"
    }],
    attrs: {
      "label": "Sigla"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.pesquisaOrgaosFinanciadoresPorSigla()
      }
    },
    model: {
      value: (_vm.orgaoFinanciador.sigla),
      callback: function($$v) {
        _vm.$set(_vm.orgaoFinanciador, "sigla", $$v)
      },
      expression: "orgaoFinanciador.sigla"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding-top": "15px"
    },
    attrs: {
      "xs3": ""
    }
  }, [(_vm.tipoBusca === 'nome') ? _c('v-btn', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.pesquisaOrgaosFinanciadoresPorNome()
      }
    }
  }, [_vm._v("Pesquisar")]) : _c('v-btn', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.pesquisaOrgaosFinanciadoresPorSigla()
      }
    }
  }, [_vm._v("Pesquisar")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaOrgaos,
      "search": _vm.search,
      "no-data-text": 'Nenhum órgão encontrado',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.sigla",
      fn: function(props) {
        return [_vm._v(_vm._s(props.item.sigla === null || props.item.sigla === '' ? '-' : props.item.sigla))]
      }
    }, {
      key: "item.opcoes",
      fn: function(props) {
        return [_c('c-tooltip-btn', {
          attrs: {
            "icon": "add_box",
            "color": "primary",
            "tooltip": "Adicionar órgão financiador"
          },
          on: {
            "click": function($event) {
              return _vm.toAdicionarOrgaoFinanciador(props.item.id)
            }
          }
        })]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n              Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaOrgaos.length) + " " + _vm._s(_vm.listaOrgaos.length > 1 ? 'órgãos' : 'órgão') + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.cancelar()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.cadastrarOrgao()
      }
    }
  }, [_vm._v("Cadastrar Órgão")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(857)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(858),
  /* template */
  __webpack_require__(859),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 857 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjetoPesquisa', 'idOrgaoFinanciador'],
  data: function data() {
    return {
      formularioValido: false,
      orgaoFinanciador: {},
      orgaoFinanciadorProjetoPesquisa: {
        idProjetoPesquisa: '',
        idOrgaoFinanciador: '',
        valor: null
      },
      obrigatorio: [function (v) {
        return !!v || 'Este campo é obrigatório';
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {

    // Adiciona o órgão financiador ao projeto de pesquisa.
    adicionaOrgaoFinanciadorProjetoPesquisa: function adicionaOrgaoFinanciadorProjetoPesquisa() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Adicionando órgão financiador ao projeto de pesquisa...' });
      // Preenche o 'idProjetoPesquisa' e o 'idOrgaoFinanciador' necessários para adicionar o órgão financiador.
      this.orgaoFinanciadorProjetoPesquisa.idProjetoPesquisa = this.idProjetoPesquisa;
      this.orgaoFinanciadorProjetoPesquisa.idOrgaoFinanciador = this.idOrgaoFinanciador;
      __WEBPACK_IMPORTED_MODULE_1__utils_projetos__["a" /* default */].postOrgaoFinanciadorProjetoPesquisa(this.idProjetoPesquisa, this.orgaoFinanciadorProjetoPesquisa).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.$router.push({ name: 'ProjetoPesquisaOrgaosFinanciadores' });
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Adicionando órgão financiador ao projeto de pesquisa...' });
      });
    },

    // Redireciona para a página anterior.
    cancelar: function cancelar() {
      this.$router.go(-1);
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    // Carrega o órgão financiador.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando órgão financiador...' });
    __WEBPACK_IMPORTED_MODULE_1__utils_projetos__["a" /* default */].getOrgaoFinanciador(this.idOrgaoFinanciador).then(function (response) {
      _this2.orgaoFinanciador = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando órgão financiador...' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar___default.a
  }
});

/***/ }),
/* 859 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Adicionar Órgão Financiador'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome",
      "value": this.orgaoFinanciador.nome === null || this.orgaoFinanciador.nome === '' ? '-' : this.orgaoFinanciador.nome,
      "readonly": ""
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Sigla",
      "value": this.orgaoFinanciador.sigla === null || this.orgaoFinanciador.sigla === '' ? '-' : this.orgaoFinanciador.sigla,
      "readonly": ""
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field-money', {
    attrs: {
      "label": "Valor (R$)*",
      "properties": {
        placeholder: ' ',
        rules: _vm.obrigatorio
      },
      "options": {
        locale: 'pt-BR',
        length: 13,
        precision: 2,
        empty: null,
      }
    },
    model: {
      value: (_vm.orgaoFinanciadorProjetoPesquisa.valor),
      callback: function($$v) {
        _vm.$set(_vm.orgaoFinanciadorProjetoPesquisa, "valor", $$v)
      },
      expression: "orgaoFinanciadorProjetoPesquisa.valor"
    }
  })], 1)], 1), _vm._v(" "), _c('br')], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.cancelar()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.adicionaOrgaoFinanciadorProjetoPesquisa()
      }
    }
  }, [_vm._v("Adicionar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(861)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(862),
  /* template */
  __webpack_require__(863),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 861 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjetoPesquisa'],
  data: function data() {
    return {
      formularioValido: false,
      orgaoFinanciador: {
        cadastroAprovado: 'S'
      },
      obrigatorio: [function (v) {
        return !!v || 'Este campo é obrigatório';
      }],
      max20caracteres: [function (v) {
        return v.length <= 20 || 'Este campo pode ter no máximo 20 caracteres';
      }],
      max200caracteres: [function (v) {
        return v.length <= 200 || 'Este campo pode ter no máximo 200 caracteres';
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {

    // Cadastra o órgão financiador.
    cadastraOrgaoFinanciador: function cadastraOrgaoFinanciador() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Cadastrando órgão financiador...' });
      __WEBPACK_IMPORTED_MODULE_2__utils_projetos__["a" /* default */].postOrgaoFinanciador(this.orgaoFinanciador).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.$router.push({ name: 'ProjetoPesquisaPesquisarOrgaoFinanciador', params: { idProjetoPesquisa: _this.idProjetoPesquisa } });
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Cadastrando órgão financiador...' });
      });
    },

    // Redireciona para a página anterior.
    cancelar: function cancelar() {
      this.$router.go(-1);
    }
  }),
  mounted: function mounted() {},

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a
  }
});

/***/ }),
/* 863 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Cadastrar Órgão'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome*",
      "counter": "200",
      "rules": _vm.obrigatorio.concat( _vm.max200caracteres)
    },
    model: {
      value: (_vm.orgaoFinanciador.nome),
      callback: function($$v) {
        _vm.$set(_vm.orgaoFinanciador, "nome", $$v)
      },
      expression: "orgaoFinanciador.nome"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Sigla",
      "counter": "20",
      "rules": _vm.max20caracteres
    },
    model: {
      value: (_vm.orgaoFinanciador.sigla),
      callback: function($$v) {
        _vm.$set(_vm.orgaoFinanciador, "sigla", $$v)
      },
      expression: "orgaoFinanciador.sigla"
    }
  })], 1)], 1), _vm._v(" "), _c('br')], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.cancelar()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.cadastraOrgaoFinanciador()
      }
    }
  }, [_vm._v("Cadastrar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(865),
  /* template */
  __webpack_require__(866),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_readonly_field__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_readonly_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_c_readonly_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjetoPesquisa', 'projetoPesquisa'],
  data: function data() {
    return {};
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('auth', ['administrador', 'administradorPRPPG'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {

    // Edita a aba "Outras Informações".
    toEditar: function toEditar() {
      this.$router.push({ name: 'EditarProjetoPesquisaOutrasInformacoes', params: { idProjetoPesquisa: this.idProjetoPesquisa } });
    },

    // Voltar para a aba anterior.
    toVoltar: function toVoltar() {
      this.$router.push({ name: 'ProjetoPesquisaArquivos', params: { idProjetoPesquisa: this.idProjetoPesquisa } });
    },

    // Avançar para a próxima aba.
    toAvancar: function toAvancar() {
      this.$router.push({ name: 'ProjetoPesquisaContatos', params: { idProjetoPesquisa: this.idProjetoPesquisa } });
    }
  }),
  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar___default.a,
    'c-readonly-field': __WEBPACK_IMPORTED_MODULE_1__components_c_readonly_field___default.a
  }
});

/***/ }),
/* 866 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "lg8": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Número de alunos de graduação participantes",
      "value": this.projetoPesquisa.numAlunosGraduacao ? this.projetoPesquisa.numAlunosGraduacao : '-',
      "align": "justify"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Número de alunos de especialização participantes",
      "value": this.projetoPesquisa.numAlunosEspecializacao ? this.projetoPesquisa.numAlunosEspecializacao : '-',
      "align": "justify"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Possui vínculo com a iniciação científica",
      "value": this.projetoPesquisa.vinculoIniciacaoCientifica != null ? (this.projetoPesquisa.vinculoIniciacaoCientifica ? 'Sim' : 'Não') : '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Possui interface com outras áreas",
      "value": this.projetoPesquisa.interfaceOutrasAreas != null ? (this.projetoPesquisa.interfaceOutrasAreas ? 'Sim' : 'Não') : '-'
    }
  })], 1)], 1), _vm._v(" "), (_vm.projetoPesquisa.interfaceOutrasAreas === true) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', [_vm._v("Áreas de interface com o projeto")])])], 1) : _vm._e(), _vm._v(" "), (_vm.projetoPesquisa.interfaceOutrasAreas === true && _vm.projetoPesquisa.areaDesenvTec === true) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "black--text body-1"
  }, [_vm._v("• Desenvolvimento Tecnológico")])])], 1) : _vm._e(), _vm._v(" "), (_vm.projetoPesquisa.interfaceOutrasAreas === true && _vm.projetoPesquisa.areaEnsino === true) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "black--text body-1"
  }, [_vm._v("• Ensino")])])], 1) : _vm._e(), _vm._v(" "), (_vm.projetoPesquisa.interfaceOutrasAreas === true && _vm.projetoPesquisa.areaExtensao === true) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "black--text body-1"
  }, [_vm._v("• Extensão")])])], 1) : _vm._e(), _vm._v(" "), (_vm.projetoPesquisa.interfaceOutrasAreas === true && _vm.projetoPesquisa.areaOutros === true) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "black--text body-1"
  }, [_vm._v("• " + _vm._s(_vm.projetoPesquisa.especAreaOutros))])])], 1) : _vm._e(), _vm._v(" "), _c('br')], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toVoltar()
      }
    }
  }, [_vm._v("Voltar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.administradorPRPPG || _vm.projetoPesquisa.coordenador) ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toEditar()
      }
    }
  }, [_vm._v("Editar")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toAvancar()
      }
    }
  }, [_vm._v("Avançar")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(868)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(869),
  /* template */
  __webpack_require__(870),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 868 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_confirm_dialog__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_confirm_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_confirm_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_c_tooltip_btn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_c_tooltip_btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_c_tooltip_btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjetoPesquisa', 'projetoPesquisa'],
  data: function data() {
    return {
      dialogConfirmaExclusao: false,
      idArquivoProjetoPesquisaExclusao: '',
      listaArquivos: [],
      api_url: "https://pib-api.prod.uks.ufes.br",
      dates: __WEBPACK_IMPORTED_MODULE_2__utils_dates__["a" /* default */],
      search: null,
      sortDesc: false,
      itemsPerPage: 25,
      opcoesPaginacao: [10, 25, 50, { text: 'Todas', value: -1 }],
      headers: [{ text: 'Nome', align: 'left', value: 'nome' }, { text: 'Tipo', align: 'left', value: 'tipoArquivo.descricao' }, { text: 'Data de inclusão', align: 'left', value: 'dtInclusao' }, { text: 'Observação', align: 'left', value: 'observacao' }, { text: 'Opções', align: 'left', value: 'opcoes' }]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])('auth', ['administrador', 'administradorPRPPG'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {

    // Carrega os arquivos do projeto de pesquisa.
    carregaArquivosProjetoPesquisa: function carregaArquivosProjetoPesquisa() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando arquivos...' });
      __WEBPACK_IMPORTED_MODULE_1__utils_projetos__["a" /* default */].getArquivosProjetoPesquisa(this.idProjetoPesquisa).then(function (response) {
        _this.listaArquivos = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando arquivos...' });
      });
    },

    // Edita as informações do arquivo.
    toEditarArquivo: function toEditarArquivo(idArquivoProjetoPesquisa) {
      this.$router.push({ name: 'EditarProjetoPesquisaArquivo', params: { idProjetoPesquisa: this.idProjetoPesquisa, idArquivoProjetoPesquisa: idArquivoProjetoPesquisa } });
    },

    // Voltar para a aba anterior.
    toVoltar: function toVoltar() {
      this.$router.push({ name: 'ProjetoPesquisaOrgaosFinanciadores', params: { idProjetoPesquisa: this.idProjetoPesquisa } });
    },

    // Avançar para a próxima aba.
    toAvancar: function toAvancar() {
      this.$router.push({ name: 'ProjetoPesquisaOutrasInformacoes', params: { idProjetoPesquisa: this.idProjetoPesquisa } });
    },

    // Adiciona um arquivo.
    toAdicionarArquivo: function toAdicionarArquivo() {
      this.$router.push({ name: 'ProjetoPesquisaAdicionarArquivo', params: { idProjetoPesquisa: this.idProjetoPesquisa } });
    },

    // Exclui um arquivo (abre dialog de confirmação).
    toExcluirArquivo: function toExcluirArquivo(idArquivoProjetoPesquisa) {
      this.idArquivoProjetoPesquisaExclusao = idArquivoProjetoPesquisa;
      this.dialogConfirmaExclusao = true;
    },

    // Exclui um arquivo (chama endpoint para exclusão).
    excluirArquivo: function excluirArquivo() {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo arquivo...' });
      __WEBPACK_IMPORTED_MODULE_1__utils_projetos__["a" /* default */].deleteArquivoProjetoPesquisa(this.idProjetoPesquisa, this.idArquivoProjetoPesquisaExclusao).then(function (response) {
        _this2.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this2.carregaArquivosProjetoPesquisa();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this2.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo arquivo...' });
      });
    }
  }),
  mounted: function mounted() {
    // Carrega os arquivos do projeto de pesquisa.
    this.carregaArquivosProjetoPesquisa();
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_4__components_toolbars_basic_toolbar___default.a,
    'c-tooltip-btn': __WEBPACK_IMPORTED_MODULE_5__components_c_tooltip_btn___default.a,
    'c-confirm-dialog': __WEBPACK_IMPORTED_MODULE_3__components_c_confirm_dialog___default.a
  }
});

/***/ }),
/* 870 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "text-center": "",
      "d-flex": "",
      "align-center": ""
    }
  }, [_c('c-confirm-dialog', {
    attrs: {
      "titulo": "Deseja realmente excluir o arquivo?"
    },
    on: {
      "yes": function($event) {
        return _vm.excluirArquivo()
      }
    },
    model: {
      value: (_vm.dialogConfirmaExclusao),
      callback: function($$v) {
        _vm.dialogConfirmaExclusao = $$v
      },
      expression: "dialogConfirmaExclusao"
    }
  }), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaArquivos,
      "search": _vm.search,
      "no-data-text": 'Nenhum arquivo encontrado',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.opcoes",
      fn: function(props) {
        return [(_vm.administradorPRPPG || _vm.projetoPesquisa.coordenador) ? _c('c-tooltip-btn', {
          attrs: {
            "icon": "edit",
            "color": "primary",
            "tooltip": "Editar informações do arquivo"
          },
          on: {
            "click": function($event) {
              return _vm.toEditarArquivo(props.item.idArquivo)
            }
          }
        }) : _vm._e(), _vm._v(" "), (_vm.administradorPRPPG || _vm.projetoPesquisa.coordenador) ? _c('c-tooltip-btn', {
          attrs: {
            "icon": "delete",
            "color": "primary",
            "tooltip": "Excluir arquivo"
          },
          on: {
            "click": function($event) {
              return _vm.toExcluirArquivo(props.item.idArquivo)
            }
          }
        }) : _vm._e()]
      }
    }, {
      key: "item.nome",
      fn: function(props) {
        return [_c('a', {
          attrs: {
            "href": _vm.api_url + '/pesquisa/projetos/' + _vm.idProjetoPesquisa + '/arquivos/' + props.item.idArquivo
          }
        }, [_c('v-icon', [_vm._v("vertical_align_bottom")]), _vm._v(_vm._s(props.item.nome.trim()) + "\n      ")], 1)]
      }
    }, {
      key: "item.dtInclusao",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dtInclusao)))]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n      Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaArquivos.length) + " " + _vm._s(_vm.listaArquivos.length > 1 ? 'arquivos' : 'arquivo') + "\n    ")]
      }
    }])
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toVoltar()
      }
    }
  }, [_vm._v("Voltar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.administradorPRPPG || _vm.projetoPesquisa.coordenador) ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toAdicionarArquivo()
      }
    }
  }, [_vm._v("Adicionar Arquivo")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toAvancar()
      }
    }
  }, [_vm._v("Avançar")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(872)
  __webpack_require__(873)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(874),
  /* template */
  __webpack_require__(875),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e291a74a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 872 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 873 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjetoPesquisa'],
  data: function data() {
    return {
      formularioValido: false,
      arquivo: {
        conteudo: {},
        nome: '',
        observacao: '',
        tipoArquivo: null,
        nivelAcesso: 'P'
      },
      listaTipoArquivo: [],
      obrigatorio: [function (v) {
        return !!v || 'Este campo é obrigatório';
      }],
      max200caracteres: [function (v) {
        return v.length <= 200 || 'Este campo pode ter no máximo 200 caracteres';
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {

    // Função para ordenar lista de tipos de arquivos.
    funcaoOrdenaListaTiposArquivos: function funcaoOrdenaListaTiposArquivos(tipo1, tipo2) {
      return tipo1.item - tipo2.item;
    },

    // Redireciona para a tela de visualização da aba "Arquivos" -->
    cancelar: function cancelar() {
      this.$router.push({ name: 'ProjetoPesquisaArquivos', params: { idProjetoPesquisa: this.idProjetoPesquisa } });
    },

    // Valida o arquivo selecionado.
    selecionaArquivo: function selecionaArquivo(file) {
      if (file.name.length > 200) {
        this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: 'O nome do arquivo deve conter no máximo 200 caracteres!' });
        document.getElementById('uploadFileInput').value = '';
        return;
      }
      this.arquivo.conteudo = file;
      this.arquivo.nome = file.name;
    },


    // Adiciona o aquivo ao projeto de pesquisa.
    adicionarArquivo: function adicionarArquivo() {
      var _this = this;

      var body = new FormData();
      body.append('arquivo', this.arquivo.conteudo);
      body.append('nome', this.arquivo.nome);
      body.append('observacao', this.arquivo.observacao);
      body.append('tipoArquivoItem', this.arquivo.tipoArquivo.item);
      body.append('nivelAcesso', this.arquivo.nivelAcesso);

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Adicionando arquivo...' });
      __WEBPACK_IMPORTED_MODULE_2__utils_projetos__["a" /* default */].postArquivoProjetoPesquisa(this.idProjetoPesquisa, body).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.$router.push({ name: 'ProjetoPesquisaArquivos', params: { idProjetoPesquisa: _this.idProjetoPesquisa } });
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Adicionando arquivo...' });
      });
    },


    // Carrega tabela estruturada.
    opcoesTabelaEstruturada: function opcoesTabelaEstruturada(codTabela, aqui, atributo) {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando tipos de arquivo...' });
      __WEBPACK_IMPORTED_MODULE_2__utils_projetos__["a" /* default */].getOpcoesTabelaEstruturada(codTabela).then(function (response) {
        aqui[atributo] = response.data.slice();
        aqui[atributo].sort(_this2.funcaoOrdenaListaTiposArquivos);
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando tipos de arquivo...' });
      });
    }
  }),
  mounted: function mounted() {
    // Carrega lista com os tipos de arquivos (COD_TABELA = 1170).
    this.opcoesTabelaEstruturada(1170, this, 'listaTipoArquivo');
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a
  }
});

/***/ }),
/* 875 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Adicionar arquivo'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-file-input', {
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "uploadFileInput",
      "label": "Clique aqui para selecionar o arquivo",
      "outlined": "",
      "truncate-length": "220",
      "chips": "",
      "show-size": "",
      "accept": "application/pdf",
      "hint": "O arquivo deve estar no formato PDF e pode ter no máximo 5 MB.",
      "persistent-hint": "",
      "rules": _vm.obrigatorio
    },
    on: {
      "change": _vm.selecionaArquivo
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "tipoArquivo",
      "label": "Tipo do arquivo*",
      "items": _vm.listaTipoArquivo,
      "item-text": "descricao",
      "item-value": "item",
      "prepend-icon": "dashboard",
      "return-object": "",
      "autocomplete": "",
      "required": "",
      "rules": _vm.obrigatorio
    },
    model: {
      value: (_vm.arquivo.tipoArquivo),
      callback: function($$v) {
        _vm.$set(_vm.arquivo, "tipoArquivo", $$v)
      },
      expression: "arquivo.tipoArquivo"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    staticClass: "observacao",
    attrs: {
      "label": _vm.arquivo.tipoArquivo !== null ? _vm.arquivo.tipoArquivo.item === 3 ? 'Observação*' : 'Observação' : 'Observação',
      "rules": _vm.arquivo.tipoArquivo !== null ? _vm.arquivo.tipoArquivo.item === 3 ? _vm.obrigatorio.concat( _vm.max200caracteres) : _vm.max200caracteres : _vm.max200caracteres,
      "rows": 2,
      "auto-grow": true,
      "multi-line": "",
      "counter": "200",
      "hint": _vm.arquivo.tipoArquivo !== null ? _vm.arquivo.tipoArquivo.item === 3 ? 'Informe o tipo de documento' : false : false,
      "persistent-hint": _vm.arquivo.tipoArquivo !== null ? _vm.arquivo.tipoArquivo.item === 3 ? true : false : false
    },
    model: {
      value: (_vm.arquivo.observacao),
      callback: function($$v) {
        _vm.$set(_vm.arquivo, "observacao", $$v)
      },
      expression: "arquivo.observacao"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.cancelar()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.adicionarArquivo()
      }
    }
  }, [_vm._v("Adicionar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(877)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(878),
  /* template */
  __webpack_require__(879),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4f21bfba",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 877 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_confirm_dialog__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_confirm_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_confirm_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_readonly_field__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_readonly_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_readonly_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjetoPesquisa', 'projetoPesquisa'],
  data: function data() {
    return {
      dialogConfirmaEnvioProjetoParaRegistro: false
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])('auth', ['administrador', 'administradorPRPPG'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {

    // Verifica se o projeto de pesquisa está na situação "Em preenchimento".
    situacaoEmPreenchimento: function situacaoEmPreenchimento() {
      if (this.projetoPesquisa.situacao.item === 1) {
        return true;
      } else {
        return false;
      }
    },

    // Verifica se o projeto de pesquisa está na situação "Em andamento".
    situacaoEmAndamento: function situacaoEmAndamento() {
      if (this.projetoPesquisa.situacao.item === 3) {
        return true;
      } else {
        return false;
      }
    },

    // Verifica se o projeto de pesquisa está na situação "Concluído".
    situacaoConcluido: function situacaoConcluido() {
      if (this.projetoPesquisa.situacao.item === 4) {
        return true;
      } else {
        return false;
      }
    },

    // Verifica se o projeto de pesquisa está na situação "Cancelado".
    situacaoCancelado: function situacaoCancelado() {
      if (this.projetoPesquisa.situacao.item === 5) {
        return true;
      } else {
        return false;
      }
    },

    // Habilita botão "Avançar".
    habilitaBotaoAvancar: function habilitaBotaoAvancar() {
      if (this.situacaoEmAndamento() || this.situacaoConcluido() || this.situacaoCancelado()) {
        return true;
      } else {
        return false;
      }
    },

    // Habilita botão "Enviar para registro".
    habilitaBotaoEnviarParaRegistro: function habilitaBotaoEnviarParaRegistro() {
      if (this.situacaoEmPreenchimento()) {
        return true;
      } else {
        return false;
      }
    },

    // Envia o projeto de pesquisa para registro (abre dialog de confirmação).
    toEnviarParaRegistro: function toEnviarParaRegistro() {
      this.dialogConfirmaEnvioProjetoParaRegistro = true;
    },

    // Edita a aba "Contatos".
    toEditar: function toEditar() {
      this.$router.push({ name: 'EditarProjetoPesquisaContatos', params: { idProjetoPesquisa: this.idProjetoPesquisa } });
    },

    // Voltar para a aba anterior.
    toVoltar: function toVoltar() {
      this.$router.push({ name: 'ProjetoPesquisaOutrasInformacoes', params: { idProjetoPesquisa: this.idProjetoPesquisa } });
    },

    // Avançar para a próxima aba.
    toAvancar: function toAvancar() {
      this.$router.push({ name: 'ProjetoPesquisaResultadosObtidos', params: { idProjetoPesquisa: this.idProjetoPesquisa } });
    },

    // Envia o projeto de pesquisa para registro (chama endpoint para envio).
    enviarProjetoPesquisaParaRegistro: function enviarProjetoPesquisaParaRegistro() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Enviando projeto de pesquisa para registro...' });
      __WEBPACK_IMPORTED_MODULE_1__utils_projetos__["a" /* default */].postProjetoPesquisaRegistro(this.idProjetoPesquisa).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.$router.go({ name: 'ProjetoPesquisaInformacoesBasicas', params: { idProjetoPesquisa: _this.idProjetoPesquisa } });
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Enviando projeto de pesquisa para registro...' });
      });
    }
  }),
  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_4__components_toolbars_basic_toolbar___default.a,
    'c-confirm-dialog': __WEBPACK_IMPORTED_MODULE_2__components_c_confirm_dialog___default.a,
    'c-readonly-field': __WEBPACK_IMPORTED_MODULE_3__components_c_readonly_field___default.a
  }
});

/***/ }),
/* 879 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('br'), _vm._v(" "), _c('c-confirm-dialog', {
    attrs: {
      "titulo": "Confirma o envio do projeto de pesquisa para registro?"
    },
    on: {
      "yes": function($event) {
        return _vm.enviarProjetoPesquisaParaRegistro()
      }
    },
    model: {
      value: (_vm.dialogConfirmaEnvioProjetoParaRegistro),
      callback: function($$v) {
        _vm.dialogConfirmaEnvioProjetoParaRegistro = $$v
      },
      expression: "dialogConfirmaEnvioProjetoParaRegistro"
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "lg8": ""
    }
  }, [(_vm.administradorPRPPG || _vm.projetoPesquisa.coordenador) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "tituloSecao"
  }, [_c('label', [_vm._v("Contatos do coordenador")])])])], 1) : _vm._e(), _vm._v(" "), (_vm.administradorPRPPG || _vm.projetoPesquisa.coordenador) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "E-mail",
      "value": this.projetoPesquisa.emailCoordenador ? this.projetoPesquisa.emailCoordenador : '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.administradorPRPPG || _vm.projetoPesquisa.coordenador) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Telefone",
      "value": this.projetoPesquisa.telefoneCoordenador ? this.projetoPesquisa.telefoneCoordenador : '-'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "tituloSecao"
  }, [_c('label', [_vm._v("Contatos do projeto de pesquisa")])])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Nome do contato",
      "value": this.projetoPesquisa.nomeContato ? this.projetoPesquisa.nomeContato : '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "E-mail",
      "value": this.projetoPesquisa.emailContato ? this.projetoPesquisa.emailContato : '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Telefone",
      "value": this.projetoPesquisa.telefoneContato ? this.projetoPesquisa.telefoneContato : '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Site",
      "value": this.projetoPesquisa.site ? this.projetoPesquisa.site : '-'
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Mídias sociais",
      "value": this.projetoPesquisa.midiasSociais ? this.projetoPesquisa.midiasSociais : '-'
    }
  })], 1)], 1), _vm._v(" "), _c('br')], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toVoltar()
      }
    }
  }, [_vm._v("Voltar")]), _vm._v(" "), (_vm.habilitaBotaoEnviarParaRegistro()) ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toEnviarParaRegistro()
      }
    }
  }, [_vm._v("Enviar para registro")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.administradorPRPPG || _vm.projetoPesquisa.coordenador) ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toEditar()
      }
    }
  }, [_vm._v("Editar")]) : _vm._e(), _vm._v(" "), (_vm.habilitaBotaoAvancar()) ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toAvancar()
      }
    }
  }, [_vm._v("Avançar")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(881)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(882),
  /* template */
  __webpack_require__(883),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2af1de70",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 881 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_readonly_field__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_readonly_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_readonly_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjetoPesquisa', 'projetoPesquisa'],
  data: function data() {
    return {
      listaArquivos: [],
      listaArquivosFiltrada: [],
      api_url: "https://pib-api.prod.uks.ufes.br",
      headersArquivos: [{ text: 'Nome', align: 'left', value: 'nome' }, { text: 'Observação', align: 'left', value: 'observacao' }]
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('auth', ['administrador', 'administradorPRPPG'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {

    // Voltar para a aba anterior.
    toVoltar: function toVoltar() {
      this.$router.push({ name: 'ProjetoPesquisaContatos', params: { idProjetoPesquisa: this.idProjetoPesquisa } });
    },

    // Função que filtra os arquivos que são do tipo "Resultado do projeto" (item = 2).
    filtroTipoArquivoResultadoProjeto: function filtroTipoArquivoResultadoProjeto(arquivo) {
      if ('tipoArquivo' in arquivo && arquivo.tipoArquivo.item === 2) {
        return true;
      } else {
        return false;
      }
    },

    // Carrega os arquivos do projeto de pesquisa e filtra os arquivos que são do tipo "Resultado do projeto".
    carregaArquivosProjetoPesquisa: function carregaArquivosProjetoPesquisa() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando arquivos com resultados do projeto...' });
      __WEBPACK_IMPORTED_MODULE_1__utils_projetos__["a" /* default */].getArquivosProjetoPesquisa(this.idProjetoPesquisa).then(function (response) {
        _this.listaArquivos = response.data.slice();
        _this.listaArquivosFiltrada = _this.listaArquivos.filter(_this.filtroTipoArquivoResultadoProjeto);
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando arquivos com resultados do projeto...' });
      });
    },

    // Edita a aba "Resultados obtidos".
    toEditar: function toEditar() {
      this.$router.push({ name: 'EditarProjetoPesquisaResultadosObtidos', params: { idProjetoPesquisa: this.idProjetoPesquisa } });
    }
  }),
  mounted: function mounted() {
    // Carrega os arquivos do projeto de pesquisa.
    this.carregaArquivosProjetoPesquisa();
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_3__components_toolbars_basic_toolbar___default.a,
    'c-readonly-field': __WEBPACK_IMPORTED_MODULE_2__components_c_readonly_field___default.a
  }
});

/***/ }),
/* 883 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "lg8": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Descrição dos resultados do projeto de pesquisa",
      "value": this.projetoPesquisa.resultadosObtidos ? this.projetoPesquisa.resultadosObtidos : '-',
      "align": "justify"
    }
  })], 1)], 1), _vm._v(" "), (_vm.listaArquivosFiltrada.length !== 0) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', [_vm._v("Arquivos com resultados do projeto")])])], 1) : _vm._e(), _vm._v(" "), (_vm.listaArquivosFiltrada.length !== 0) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-1 arquivos",
    attrs: {
      "headers": _vm.headersArquivos,
      "header-props": {
        sortIcon: null
      },
      "items": _vm.listaArquivosFiltrada,
      "items-per-page": -1,
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "item.nome",
      fn: function(props) {
        return [_c('a', {
          attrs: {
            "href": _vm.api_url + '/pesquisa/projetos/' + _vm.idProjetoPesquisa + '/arquivos/' + props.item.idArquivo
          }
        }, [_c('v-icon', [_vm._v("vertical_align_bottom")]), _vm._v(_vm._s(props.item.nome.trim()) + "\n              ")], 1)]
      }
    }], null, false, 2661201811)
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.listaArquivosFiltrada.length === 0) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Arquivos com resultados do projeto",
      "value": "-",
      "align": "justify"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('br')], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toVoltar()
      }
    }
  }, [_vm._v("Voltar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.administradorPRPPG || _vm.projetoPesquisa.coordenador) ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toEditar()
      }
    }
  }, [_vm._v("Editar")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(885)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(886),
  /* template */
  __webpack_require__(887),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f00684e0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 885 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjetoPesquisa'],
  data: function data() {
    return {
      projetoPesquisa: {}
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('auth', ['logged', 'username', 'nome', 'administrador', 'permissaoCriarProjetoExtensao'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING']), {

    // Verifica se o projeto de pesquisa está na situação "Em andamento".
    situacaoEmAndamento: function situacaoEmAndamento() {
      if (this.projetoPesquisa.situacao.item === 3) {
        return true;
      } else {
        return false;
      }
    },

    // Verifica se o projeto de pesquisa está na situação "Concluído".
    situacaoConcluido: function situacaoConcluido() {
      if (this.projetoPesquisa.situacao.item === 4) {
        return true;
      } else {
        return false;
      }
    },

    // Verifica se o projeto de pesquisa está na situação "Cancelado".
    situacaoCancelado: function situacaoCancelado() {
      if (this.projetoPesquisa.situacao.item === 5) {
        return true;
      } else {
        return false;
      }
    },

    // Habilita aba "Resultados Obtidos".
    habilitaAbaResultadosObtidos: function habilitaAbaResultadosObtidos() {
      if (this.situacaoEmAndamento() || this.situacaoConcluido()) {
        return true;
      } else {
        return false;
      }
    }
  }),
  mounted: function mounted() {
    var _this = this;

    // Carrega o projeto de pesquisa.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto de pesquisa...' });
    __WEBPACK_IMPORTED_MODULE_2__utils_projetos__["a" /* default */].getProjetoPesquisa(this.idProjetoPesquisa).then(function (response) {
      _this.projetoPesquisa = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto de pesquisa...' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a
  }
});

/***/ }),
/* 887 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-10"
  }, [_c('v-toolbar', {
    attrs: {
      "color": 'primary white--text'
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-toolbar-title', [_vm._v("\n              Editar Projeto de Pesquisa " + _vm._s(_vm.projetoPesquisa.numRegistro === null || _vm.projetoPesquisa.numRegistro === '' ? '' : 'nº ' + _vm.projetoPesquisa.numRegistro + ' ') + " - " + _vm._s(_vm.projetoPesquisa.titulo) + "\n          ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-tabs', {
    attrs: {
      "slot": "extension",
      "centered": "",
      "show-arrows": "",
      "dark": "",
      "next-icon": "mdi-arrow-right-bold-box-outline",
      "prev-icon": "mdi-arrow-left-bold-box-outline",
      "color": "primary",
      "hide-slider": ""
    },
    slot: "extension"
  }, [_c('router-link', {
    staticClass: "router_disable",
    attrs: {
      "exact": "",
      "to": {
        name: 'EditarProjetoPesquisaInformacoesBasicas'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Informações Básicas")]), _vm._v(" "), _c('router-link', {
    staticClass: "router_disable",
    attrs: {
      "exact": "",
      "to": {
        name: 'EditarProjetoPesquisaDetalhamento'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Detalhamento")]), _vm._v(" "), _c('router-link', {
    staticClass: "router_disable",
    attrs: {
      "exact": "",
      "to": {
        name: 'ProjetoPesquisaInstituicoes'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Instituições")]), _vm._v(" "), _c('router-link', {
    staticClass: "router_disable",
    attrs: {
      "exact": "",
      "to": {
        name: 'ProjetoPesquisaEquipe'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Equipe")]), _vm._v(" "), _c('router-link', {
    staticClass: "router_disable",
    attrs: {
      "exact": "",
      "to": {
        name: 'ProjetoPesquisaOrgaosFinanciadores'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Órgãos Financiadores")]), _vm._v(" "), _c('router-link', {
    staticClass: "router_disable",
    attrs: {
      "exact": "",
      "to": {
        name: 'ProjetoPesquisaArquivos'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Arquivos")]), _vm._v(" "), _c('router-link', {
    staticClass: "router_disable",
    attrs: {
      "exact": "",
      "to": {
        name: 'EditarProjetoPesquisaOutrasInformacoes'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Outras Informações")]), _vm._v(" "), _c('router-link', {
    staticClass: "router_disable",
    attrs: {
      "exact": "",
      "to": {
        name: 'EditarProjetoPesquisaContatos'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Contatos")]), _vm._v(" "), (_vm.habilitaAbaResultadosObtidos()) ? _c('router-link', {
    staticClass: "router_disable",
    attrs: {
      "exact": "",
      "to": {
        name: 'EditarProjetoPesquisaResultadosObtidos'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Resultados Obtidos")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('router-view', {
    attrs: {
      "idProjetoPesquisa": _vm.idProjetoPesquisa,
      "projetoPesquisa": this.projetoPesquisa
    }
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(889)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(890),
  /* template */
  __webpack_require__(891),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 889 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_dialog__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_date_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_date_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_textarea__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_c_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_dates__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjetoPesquisa'],
  data: function data() {
    return {
      formularioValido: false,
      dates: __WEBPACK_IMPORTED_MODULE_5__utils_dates__["a" /* default */],
      projetoPesquisa: {},
      listaAreaDoConhecimento: [],
      listaNomeArea: [],
      listaNomeSubarea: [],
      listaLinhaPesquisaPPG: [],
      nomeAreaDisabled: false,
      nomeSubareaDisabled: false,
      obrigatorio: [function (v) {
        return !!v || 'Este campo é obrigatório';
      }],
      numerico: [function (input) {
        return !isNaN(input) || 'Este campo deve ser numérico';
      }, function (input) {
        return input.length === 0 || Number(input) !== 0 || 'Este campo não pode ser nulo';
      }, function (input) {
        return input.length === 0 || Number(input) >= 0 || 'Este campo não pode ter valor negativo';
      }],
      max20caracteres: [function (v) {
        return v.length <= 20 || 'Este campo pode ter no máximo 20 caracteres';
      }],
      max50caracteres: [function (v) {
        return v.length <= 50 || 'Este campo pode ter no máximo 50 caracteres';
      }],
      max300caracteres: [function (v) {
        return v.length <= 300 || 'Este campo pode ter no máximo 300 caracteres';
      }],
      max400caracteres: [function (v) {
        return v.length <= 400 || 'Este campo pode ter no máximo 400 caracteres';
      }],
      max2000caracteres: [function (v) {
        return v.length <= 2000 || 'Este campo pode ter no máximo 2000 caracteres';
      }],
      palavrasChaves: [function (v) {
        return (/^(?:[^\s.,:;][a-zA-Z0-9-áéíóúàèìòùâêôûãõçÁÉÍÓÚÀÈÌÒÙÂÊÔÛÃÕÇ\s]+[^\s.,:;],){1}(?:\s?[^\s.,:;][a-zA-Z0-9-áéíóúàèìòùâêôûãõçÁÉÍÓÚÀÈÌÒÙÂÊÔÛÃÕÇ\s]+[^\s.,:;],){1,4}(?:\s?[^\s.,:;][a-zA-Z0-9-áéíóúàèìòùâêôûãõçÁÉÍÓÚÀÈÌÒÙÂÊÔÛÃÕÇ\s]+[^\s.,:;]){1}$/.test(v) || 'O projeto deve conter no mínimo 03 e no máximo 06 palavras-chaves separadas apenas por vírgulas e sem ponto ao final.'
        );
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {

    // Edita um projeto de pesquisa.
    editarProjetoPesquisa: function editarProjetoPesquisa() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Editando Projeto de Pesquisa...' });
      __WEBPACK_IMPORTED_MODULE_1__utils_projetos__["a" /* default */].putProjetoPesquisa(this.idProjetoPesquisa, this.projetoPesquisa).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.$router.push({ name: 'ProjetoPesquisaInformacoesBasicas', params: { idProjetoPesquisa: _this.idProjetoPesquisa } });
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Editando Projeto de Pesquisa...' });
      });
    },

    // Redireciona para a tela de visualização da aba "Informações Básicas".
    cancelar: function cancelar() {
      this.$router.push({ name: 'ProjetoPesquisaInformacoesBasicas', params: { idProjetoPesquisa: this.idProjetoPesquisa } });
    },

    // Carrega as áreas.
    getNomesDasAreas: function getNomesDasAreas(idClassifSup) {
      this.obtemNomesDasAreas(idClassifSup, this, 'listaNomeArea');
      this.nomeAreaDisabled = false;
      this.listaNomeSubarea = [];
      this.nomeSubareaDisabled = true;
    },

    // Carrega as subáreas.
    getNomesDasSubareas: function getNomesDasSubareas(idClassifSup) {
      this.obtemNomesDasSubareas(idClassifSup, this, 'listaNomeSubarea');
      this.nomeSubareaDisabled = false;
    },

    // Carrega as áreas do conhecimento do CNPq.
    obtemAreasDoConhecimento: function obtemAreasDoConhecimento(aqui, atributo) {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando áreas do conhecimento...' });
      __WEBPACK_IMPORTED_MODULE_1__utils_projetos__["a" /* default */].getClassificacoesAreasDoConhecimento().then(function (response) {
        aqui[atributo] = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando áreas do conhecimento...' });
      });
    },

    // Carrega os nomes das áreas.
    obtemNomesDasAreas: function obtemNomesDasAreas(idClassifSup, aqui, atributo) {
      var _this3 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando nomes das áreas...' });
      __WEBPACK_IMPORTED_MODULE_1__utils_projetos__["a" /* default */].getClassificacoesClassificacaoSuperior(idClassifSup).then(function (response) {
        aqui[atributo] = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this3.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando nomes das áreas...' });
      });
    },

    // Carrega os nomes das subáreas.
    obtemNomesDasSubareas: function obtemNomesDasSubareas(idClassifSup, aqui, atributo) {
      var _this4 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando nomes das subáreas...' });
      __WEBPACK_IMPORTED_MODULE_1__utils_projetos__["a" /* default */].getClassificacoesClassificacaoSuperior(idClassifSup).then(function (response) {
        aqui[atributo] = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this4.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando nomes das subáreas...' });
      });
    }
  }),
  mounted: function mounted() {
    var _this5 = this;

    // Carrega o projeto de pesquisa.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto de pesquisa...' });
    __WEBPACK_IMPORTED_MODULE_1__utils_projetos__["a" /* default */].getProjetoPesquisa(this.idProjetoPesquisa).then(function (response) {
      _this5.projetoPesquisa = response.data;
      // Carrega os nomes das áreas.
      _this5.obtemNomesDasAreas(_this5.projetoPesquisa.areaConhecimento.id, _this5, 'listaNomeArea');
      // Carrega os nomes das subáreas.
      _this5.obtemNomesDasSubareas(_this5.projetoPesquisa.nomeArea.id, _this5, 'listaNomeSubarea');
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this5.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto de pesquisa...' });
    });

    // Carrega as áreas do conhecimento do CNPq.
    this.obtemAreasDoConhecimento(this, 'listaAreaDoConhecimento');
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar___default.a,
    'c-date-dialog': __WEBPACK_IMPORTED_MODULE_3__components_c_date_dialog___default.a,
    'c-textarea': __WEBPACK_IMPORTED_MODULE_4__components_c_textarea___default.a
  }
});

/***/ }),
/* 891 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Título*",
      "counter": "400",
      "rules": _vm.obrigatorio.concat( _vm.max400caracteres)
    },
    model: {
      value: (_vm.projetoPesquisa.titulo),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "titulo", $$v)
      },
      expression: "projetoPesquisa.titulo"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Sigla",
      "counter": "20",
      "rules": _vm.max20caracteres
    },
    model: {
      value: (_vm.projetoPesquisa.sigla),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "sigla", $$v)
      },
      expression: "projetoPesquisa.sigla"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Área do Conhecimento*",
      "items": _vm.listaAreaDoConhecimento,
      "return-object": "",
      "item-text": "descricao",
      "item-value": "id",
      "rules": _vm.obrigatorio,
      "hint": "O projeto deve ser registrado na área do conhecimento pertinente a sua temática."
    },
    on: {
      "input": function($event) {
        return _vm.getNomesDasAreas(_vm.projetoPesquisa.areaConhecimento.id)
      }
    },
    model: {
      value: (_vm.projetoPesquisa.areaConhecimento),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "areaConhecimento", $$v)
      },
      expression: "projetoPesquisa.areaConhecimento"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Nome da Área*",
      "items": _vm.listaNomeArea,
      "return-object": "",
      "item-text": "descricao",
      "item-value": "id",
      "rules": _vm.obrigatorio,
      "disabled": _vm.nomeAreaDisabled
    },
    on: {
      "input": function($event) {
        return _vm.getNomesDasSubareas(_vm.projetoPesquisa.nomeArea.id)
      }
    },
    model: {
      value: (_vm.projetoPesquisa.nomeArea),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "nomeArea", $$v)
      },
      expression: "projetoPesquisa.nomeArea"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Nome da Subárea*",
      "items": _vm.listaNomeSubarea,
      "return-object": "",
      "item-text": "descricao",
      "item-value": "id",
      "rules": _vm.obrigatorio,
      "disabled": _vm.nomeSubareaDisabled || _vm.listaNomeSubarea.length === 0
    },
    model: {
      value: (_vm.projetoPesquisa.nomeSubarea),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "nomeSubarea", $$v)
      },
      expression: "projetoPesquisa.nomeSubarea"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Linha de Pesquisa no Programa de Pós-Graduação*",
      "items": _vm.listaLinhaPesquisaPPG,
      "return-object": "",
      "item-text": "descricao",
      "item-value": "id",
      "disabled": "",
      "hint": "Esta opção está indisponível no momento.",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.projetoPesquisa.linhaPesquisaPPG),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "linhaPesquisaPPG", $$v)
      },
      expression: "projetoPesquisa.linhaPesquisaPPG"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('c-date-dialog', {
    attrs: {
      "label": "Data de início*",
      "rules": _vm.obrigatorio
    },
    model: {
      value: (_vm.projetoPesquisa.dataInicio),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "dataInicio", $$v)
      },
      expression: "projetoPesquisa.dataInicio"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-text-field-integer', {
    attrs: {
      "label": "Prazo em meses*",
      "properties": {
        rules: _vm.obrigatorio.concat( _vm.numerico)
      }
    },
    model: {
      value: (_vm.projetoPesquisa.prazoMeses),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "prazoMeses", $$v)
      },
      expression: "projetoPesquisa.prazoMeses"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Palavras-chaves*",
      "counter": "300",
      "rows": 1,
      "auto-grow": true,
      "rules": _vm.obrigatorio.concat( _vm.max300caracteres, _vm.palavrasChaves),
      "hint": "Indique no mínimo 03 e no máximo 06 palavras que podem ser relacionadas ao escopo do projeto. As palavras devem ser separadas somente por vírgulas e sem ponto ao final."
    },
    model: {
      value: (_vm.projetoPesquisa.palavrasChaves),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "palavrasChaves", $$v)
      },
      expression: "projetoPesquisa.palavrasChaves"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Resumo*",
      "counter": "2000",
      "rows": 4,
      "auto-grow": true,
      "rules": _vm.obrigatorio.concat( _vm.max2000caracteres),
      "hint": "Deve conter uma descrição do projeto, incluindo sua relevância."
    },
    model: {
      value: (_vm.projetoPesquisa.resumo),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "resumo", $$v)
      },
      expression: "projetoPesquisa.resumo"
    }
  })], 1)], 1), _vm._v(" "), _c('br')], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.cancelar()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.editarProjetoPesquisa()
      }
    }
  }, [_vm._v("Salvar")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(893)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(894),
  /* template */
  __webpack_require__(895),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 893 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_textarea__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjetoPesquisa'],
  data: function data() {
    return {
      formularioValido: false,
      projetoPesquisa: {
        objetivos: '',
        metodologia: '',
        resultadosEsperados: ''
      },
      listaPrincipalODS: [],
      listaODSAfim: [],
      obrigatorio: [function (v) {
        return !!v || 'Este campo é obrigatório';
      }],
      max20caracteres: [function (v) {
        return v.length <= 20 || 'Este campo pode ter no máximo 20 caracteres';
      }],
      max100caracteres: [function (v) {
        return v.length <= 100 || 'Este campo pode ter no máximo 100 caracteres';
      }],
      max300caracteres: [function (v) {
        return v.length <= 300 || 'Este campo pode ter no máximo 300 caracteres';
      }],
      max400caracteres: [function (v) {
        return v.length <= 400 || 'Este campo pode ter no máximo 400 caracteres';
      }],
      max2000caracteres: [function (v) {
        return v.length <= 2000 || 'Este campo pode ter no máximo 2000 caracteres';
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {

    // Edita um projeto de pesquisa.
    editarProjetoPesquisa: function editarProjetoPesquisa() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Editando Projeto de Pesquisa...' });
      __WEBPACK_IMPORTED_MODULE_1__utils_projetos__["a" /* default */].putProjetoPesquisa(this.idProjetoPesquisa, this.projetoPesquisa).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.$router.push({ name: 'ProjetoPesquisaDetalhamento', params: { idProjetoPesquisa: _this.idProjetoPesquisa } });
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Editando Projeto de Pesquisa...' });
      });
    },

    // Obtém classificações de acordo com o "classificacaoItem".
    obterClassificacoes: function obterClassificacoes(itemTabela, aqui, atributo) {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando classificação ' + atributo + '...' });
      __WEBPACK_IMPORTED_MODULE_1__utils_projetos__["a" /* default */].getClassificacoesPossiveis(itemTabela).then(function (response) {
        aqui[atributo] = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando classificação ' + atributo + '...' });
      });
    },

    // Redireciona para a tela de visualização da aba "Detalhamento" -->
    cancelar: function cancelar() {
      this.$router.push({ name: 'ProjetoPesquisaDetalhamento', params: { idProjetoPesquisa: this.idProjetoPesquisa } });
    }
  }),
  mounted: function mounted() {
    var _this3 = this;

    // Carrega o projeto de pesquisa.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto de pesquisa...' });
    __WEBPACK_IMPORTED_MODULE_1__utils_projetos__["a" /* default */].getProjetoPesquisa(this.idProjetoPesquisa).then(function (response) {
      _this3.projetoPesquisa = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this3.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto de pesquisa...' });
    });

    // Carrega a lista com os principais ODS (classificacaoItem = 103)
    this.obterClassificacoes(103, this, 'listaPrincipalODS');

    // Carrega a lista com os ODS afins (classificacaoItem = 104)
    this.obterClassificacoes(104, this, 'listaODSAfim');
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar___default.a,
    'c-textarea': __WEBPACK_IMPORTED_MODULE_3__components_c_textarea___default.a
  }
});

/***/ }),
/* 895 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Objetivos*",
      "counter": "2000",
      "rows": 3,
      "auto-grow": true,
      "rules": _vm.obrigatorio.concat( _vm.max2000caracteres),
      "hint": "Enumere os objetivos propostos para o projeto. Devem ser formulados com o tempo verbal no infinitivo, indicando uma ação."
    },
    model: {
      value: (_vm.projetoPesquisa.objetivos),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "objetivos", $$v)
      },
      expression: "projetoPesquisa.objetivos"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Metodologia*",
      "counter": "2000",
      "rows": 3,
      "auto-grow": true,
      "rules": _vm.obrigatorio.concat( _vm.max2000caracteres),
      "hint": "Deve explicitar como serão analisados os dados levantados, incluindo método da pesquisa, materiais e público-alvo, se for o caso."
    },
    model: {
      value: (_vm.projetoPesquisa.metodologia),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "metodologia", $$v)
      },
      expression: "projetoPesquisa.metodologia"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Principal Objetivo de Desenvolvimento Sustentável*",
      "items": _vm.listaPrincipalODS,
      "item-text": "descricao",
      "item-value": "id",
      "return-object": "",
      "rules": _vm.obrigatorio
    },
    model: {
      value: (_vm.projetoPesquisa.principalODS),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "principalODS", $$v)
      },
      expression: "projetoPesquisa.principalODS"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Objetivo de Desenvolvimento Sustentável Afim*",
      "items": _vm.listaODSAfim,
      "item-text": "descricao",
      "item-value": "id",
      "return-object": "",
      "rules": _vm.obrigatorio
    },
    model: {
      value: (_vm.projetoPesquisa.afimODS),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "afimODS", $$v)
      },
      expression: "projetoPesquisa.afimODS"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Resultados esperados*",
      "counter": "2000",
      "rows": 3,
      "auto-grow": true,
      "rules": _vm.obrigatorio.concat( _vm.max2000caracteres),
      "hint": "Devem estar claras as metas que se deseja alcançar com o desenvolvimento desta pesquisa e as contribuições esperadas para a área do conhecimento."
    },
    model: {
      value: (_vm.projetoPesquisa.resultadosEsperados),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "resultadosEsperados", $$v)
      },
      expression: "projetoPesquisa.resultadosEsperados"
    }
  })], 1)], 1), _vm._v(" "), _c('br')], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.cancelar()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.editarProjetoPesquisa()
      }
    }
  }, [_vm._v("Salvar")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(897)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(898),
  /* template */
  __webpack_require__(899),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 897 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjetoPesquisa', 'idInstituicaoProjetoPesquisa'],
  data: function data() {
    return {
      formularioValido: false,
      instituicaoProjetoPesquisa: {},
      listaTipoInstituicaoProjetoPesquisa: [],
      obrigatorio: [function (v) {
        return !!v || 'Este campo é obrigatório';
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {

    // Edita a instituição do projeto de pesquisa.
    editaInstituicaoProjetoPesquisa: function editaInstituicaoProjetoPesquisa() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Editando instituição do projeto de pesquisa...' });
      __WEBPACK_IMPORTED_MODULE_1__utils_projetos__["a" /* default */].putInstituicaoProjetoPesquisa(this.idProjetoPesquisa, this.idInstituicaoProjetoPesquisa, this.instituicaoProjetoPesquisa).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.$router.push({ name: 'ProjetoPesquisaInstituicoes' });
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Editando instituição do projeto de pesquisa...' });
      });
    },

    // Carrega uma tabela estruturada.
    opcoesTabelaEstruturada: function opcoesTabelaEstruturada(codTabela, aqui, atributo) {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' });
      __WEBPACK_IMPORTED_MODULE_1__utils_projetos__["a" /* default */].getOpcoesTabelaEstruturada(codTabela).then(function (response) {
        aqui[atributo] = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' });
      });
    },

    // Redireciona para a página anterior.
    cancelar: function cancelar() {
      this.$router.go(-1);
    }
  }),
  mounted: function mounted() {
    var _this3 = this;

    // Carrega a instituição do projeto de pesquisa.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando instituição do projeto de pesquisa...' });
    __WEBPACK_IMPORTED_MODULE_1__utils_projetos__["a" /* default */].getInstituicaoProjetoPesquisa(this.idProjetoPesquisa, this.idInstituicaoProjetoPesquisa).then(function (response) {
      _this3.instituicaoProjetoPesquisa = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this3.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando instituição do projeto de pesquisa...' });
    });

    // Carrega lista com os tipos de instituição de um projeto de pesquisa (Tabela estruturada - código 1165).
    this.opcoesTabelaEstruturada(1165, this, 'listaTipoInstituicaoProjetoPesquisa');
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar___default.a
  }
});

/***/ }),
/* 899 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Editar Instituição'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome",
      "value": _vm.instituicaoProjetoPesquisa.nome === null || _vm.instituicaoProjetoPesquisa.nome === '' ? '-' : _vm.instituicaoProjetoPesquisa.nome,
      "readonly": ""
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Sigla",
      "value": _vm.instituicaoProjetoPesquisa.sigla === null || _vm.instituicaoProjetoPesquisa.sigla === '' ? '-' : _vm.instituicaoProjetoPesquisa.sigla,
      "readonly": ""
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Tipo*",
      "items": _vm.listaTipoInstituicaoProjetoPesquisa,
      "item-text": "descricao",
      "item-value": "item",
      "max-height": "400",
      "return-object": "",
      "required": "",
      "autocomplete": "",
      "rules": _vm.obrigatorio
    },
    model: {
      value: (_vm.instituicaoProjetoPesquisa.tipoInstituicao),
      callback: function($$v) {
        _vm.$set(_vm.instituicaoProjetoPesquisa, "tipoInstituicao", $$v)
      },
      expression: "instituicaoProjetoPesquisa.tipoInstituicao"
    }
  })], 1)], 1), _vm._v(" "), _c('br')], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.cancelar()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.editaInstituicaoProjetoPesquisa()
      }
    }
  }, [_vm._v("Salvar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(901)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(902),
  /* template */
  __webpack_require__(903),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 901 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjetoPesquisa', 'idOrgaoFinanciadorProjetoPesquisa'],
  data: function data() {
    return {
      formularioValido: false,
      orgaoFinanciadorProjetoPesquisa: {},
      obrigatorio: [function (v) {
        return !!v || 'Este campo é obrigatório';
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {

    // Edita o órgão financiador do projeto de pesquisa.
    editaOrgaoFinanciadorProjetoPesquisa: function editaOrgaoFinanciadorProjetoPesquisa() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Editando órgão financiador do projeto de pesquisa...' });
      __WEBPACK_IMPORTED_MODULE_1__utils_projetos__["a" /* default */].putOrgaoFinanciadorProjetoPesquisa(this.idProjetoPesquisa, this.idOrgaoFinanciadorProjetoPesquisa, this.orgaoFinanciadorProjetoPesquisa).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.$router.push({ name: 'ProjetoPesquisaOrgaosFinanciadores' });
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Editando órgão financiador do projeto de pesquisa...' });
      });
    },

    // Redireciona para a página anterior.
    cancelar: function cancelar() {
      this.$router.go(-1);
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    // Carrega o órgão financiador do projeto de pesquisa.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando órgão financiador do projeto de pesquisa...' });
    __WEBPACK_IMPORTED_MODULE_1__utils_projetos__["a" /* default */].getOrgaoFinanciadorProjetoPesquisa(this.idProjetoPesquisa, this.idOrgaoFinanciadorProjetoPesquisa).then(function (response) {
      _this2.orgaoFinanciadorProjetoPesquisa = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando órgão financiador do projeto de pesquisa...' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar___default.a
  }
});

/***/ }),
/* 903 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Editar Órgão Financiador'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome",
      "value": _vm.orgaoFinanciadorProjetoPesquisa.nome === null || _vm.orgaoFinanciadorProjetoPesquisa.nome === '' ? '-' : _vm.orgaoFinanciadorProjetoPesquisa.nome,
      "readonly": ""
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Sigla",
      "value": _vm.orgaoFinanciadorProjetoPesquisa.sigla === null || _vm.orgaoFinanciadorProjetoPesquisa.sigla === '' ? '-' : _vm.orgaoFinanciadorProjetoPesquisa.sigla,
      "readonly": ""
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field-money', {
    attrs: {
      "label": "Valor (R$)*",
      "properties": {
        placeholder: ' ',
        rules: _vm.obrigatorio
      },
      "options": {
        locale: 'pt-BR',
        length: 13,
        precision: 2,
        empty: null,
      }
    },
    model: {
      value: (_vm.orgaoFinanciadorProjetoPesquisa.valor),
      callback: function($$v) {
        _vm.$set(_vm.orgaoFinanciadorProjetoPesquisa, "valor", $$v)
      },
      expression: "orgaoFinanciadorProjetoPesquisa.valor"
    }
  })], 1)], 1), _vm._v(" "), _c('br')], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.cancelar()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.editaOrgaoFinanciadorProjetoPesquisa()
      }
    }
  }, [_vm._v("Salvar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(905)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(906),
  /* template */
  __webpack_require__(907),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 905 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_date_dialog__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_date_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_date_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjetoPesquisa', 'idParticipanteProjetoPesquisa'],
  data: function data() {
    return {
      formularioValido: false,
      participanteProjetoPesquisa: {},
      listaTiposParticipacao: [],
      obrigatorio: [function (v) {
        return !!v || 'Este campo é obrigatório';
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {

    // Edita o participante do projeto de pesquisa.
    editaParticipanteProjetoPesquisa: function editaParticipanteProjetoPesquisa() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Editando membro da equipe do projeto de pesquisa...' });
      __WEBPACK_IMPORTED_MODULE_3__utils_projetos__["a" /* default */].putParticipanteProjetoPesquisa(this.idProjetoPesquisa, this.idParticipanteProjetoPesquisa, this.participanteProjetoPesquisa).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.$router.push({ name: 'ProjetoPesquisaEquipe' });
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Editando membro da equipe do projeto de pesquisa...' });
      });
    },

    // Carrega uma tabela estruturada.
    opcoesTabelaEstruturada: function opcoesTabelaEstruturada(codTabela, aqui, atributo) {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções...' });
      __WEBPACK_IMPORTED_MODULE_3__utils_projetos__["a" /* default */].getOpcoesTabelaEstruturada(codTabela).then(function (response) {
        aqui[atributo] = response.data.slice();
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções...' });
      });
    },

    // Redireciona para a página anterior.
    cancelar: function cancelar() {
      this.$router.go(-1);
    }
  }),
  mounted: function mounted() {
    var _this3 = this;

    // Carrega o participante do projeto de pesquisa.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando membro da equipe do projeto de pesquisa...' });
    __WEBPACK_IMPORTED_MODULE_3__utils_projetos__["a" /* default */].getParticipanteProjetoPesquisa(this.idProjetoPesquisa, this.idParticipanteProjetoPesquisa).then(function (response) {
      _this3.participanteProjetoPesquisa = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this3.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando membro da equipe do projeto de pesquisa...' });
    });

    // Carrega lista com os tipos de participação de um membro da equipe de um projeto de pesquisa (Tabela estruturada - código 1160).
    this.opcoesTabelaEstruturada(1160, this, 'listaTiposParticipacao');
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'c-date-dialog': __WEBPACK_IMPORTED_MODULE_2__components_c_date_dialog___default.a
  }
});

/***/ }),
/* 907 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Editar Membro da Equipe'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome",
      "value": this.participanteProjetoPesquisa.nome === null || this.participanteProjetoPesquisa.nome === '' ? '-' : this.participanteProjetoPesquisa.nome,
      "readonly": ""
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Tipo de participação*",
      "items": _vm.listaTiposParticipacao,
      "item-text": "descricao",
      "item-value": "item",
      "max-height": "400",
      "return-object": "",
      "required": "",
      "autocomplete": "",
      "rules": _vm.obrigatorio
    },
    model: {
      value: (_vm.participanteProjetoPesquisa.tipoParticipacao),
      callback: function($$v) {
        _vm.$set(_vm.participanteProjetoPesquisa, "tipoParticipacao", $$v)
      },
      expression: "participanteProjetoPesquisa.tipoParticipacao"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field-integer', {
    attrs: {
      "label": "Carga horária semanal",
      "properties": {
        rules: _vm.numerico
      }
    },
    model: {
      value: (_vm.participanteProjetoPesquisa.cargaHorariaSemanal),
      callback: function($$v) {
        _vm.$set(_vm.participanteProjetoPesquisa, "cargaHorariaSemanal", $$v)
      },
      expression: "participanteProjetoPesquisa.cargaHorariaSemanal"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-date-dialog', {
    attrs: {
      "label": "Data inicial*",
      "rules": _vm.obrigatorio
    },
    model: {
      value: (_vm.participanteProjetoPesquisa.dataInicial),
      callback: function($$v) {
        _vm.$set(_vm.participanteProjetoPesquisa, "dataInicial", $$v)
      },
      expression: "participanteProjetoPesquisa.dataInicial"
    }
  })], 1)], 1), _vm._v(" "), _c('br')], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.cancelar()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.editaParticipanteProjetoPesquisa()
      }
    }
  }, [_vm._v("Salvar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(909)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(910),
  /* template */
  __webpack_require__(911),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 909 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_date_dialog__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_date_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_date_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjetoPesquisa', 'idParticipanteProjetoPesquisa'],
  data: function data() {
    return {
      formularioValido: false,
      participanteProjetoPesquisa: {
        situacao: ''
      },
      listaTiposParticipacao: [],
      obrigatorio: [function (v) {
        return !!v || 'Este campo é obrigatório';
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {

    // Finaliza a participação do membro da equipe do projeto de pesquisa.
    finalizaParticipanteProjetoPesquisa: function finalizaParticipanteProjetoPesquisa() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Finalizando participação do membro da equipe do projeto de pesquisa...' });
      this.participanteProjetoPesquisa.situacao = 'I';
      __WEBPACK_IMPORTED_MODULE_3__utils_projetos__["a" /* default */].putParticipanteProjetoPesquisa(this.idProjetoPesquisa, this.idParticipanteProjetoPesquisa, this.participanteProjetoPesquisa).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.$router.push({ name: 'ProjetoPesquisaEquipe' });
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Finalizando participação do membro da equipe do projeto de pesquisa...' });
      });
    },

    // Redireciona para a página anterior.
    cancelar: function cancelar() {
      this.$router.go(-1);
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    // Carrega o participante do projeto de pesquisa.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando membro da equipe do projeto de pesquisa...' });
    __WEBPACK_IMPORTED_MODULE_3__utils_projetos__["a" /* default */].getParticipanteProjetoPesquisa(this.idProjetoPesquisa, this.idParticipanteProjetoPesquisa).then(function (response) {
      _this2.participanteProjetoPesquisa = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando membro da equipe do projeto de pesquisa...' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a,
    'c-date-dialog': __WEBPACK_IMPORTED_MODULE_2__components_c_date_dialog___default.a
  }
});

/***/ }),
/* 911 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Finalizar participação do membro da equipe'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome",
      "value": this.participanteProjetoPesquisa.nome === null || this.participanteProjetoPesquisa.nome === '' ? '-' : this.participanteProjetoPesquisa.nome,
      "readonly": ""
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-date-dialog', {
    attrs: {
      "label": "Data final*",
      "rules": _vm.obrigatorio
    },
    model: {
      value: (_vm.participanteProjetoPesquisa.dataFinal),
      callback: function($$v) {
        _vm.$set(_vm.participanteProjetoPesquisa, "dataFinal", $$v)
      },
      expression: "participanteProjetoPesquisa.dataFinal"
    }
  })], 1)], 1), _vm._v(" "), _c('br')], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.cancelar()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.finalizaParticipanteProjetoPesquisa()
      }
    }
  }, [_vm._v("Salvar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(913)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(914),
  /* template */
  __webpack_require__(915),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 913 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjetoPesquisa'],
  data: function data() {
    return {
      formularioValido: false,
      projetoPesquisa: {
        numAlunosGraduacao: null,
        numAlunosEspecializacao: null
      },
      obrigatorio: [function (v) {
        return !!v || 'Este campo é obrigatório';
      }],
      max20caracteres: [function (v) {
        return v.length <= 20 || 'Este campo pode ter no máximo 20 caracteres';
      }],
      max100caracteres: [function (v) {
        return v.length <= 100 || 'Este campo pode ter no máximo 100 caracteres';
      }],
      max300caracteres: [function (v) {
        return v.length <= 300 || 'Este campo pode ter no máximo 300 caracteres';
      }],
      max400caracteres: [function (v) {
        return v.length <= 400 || 'Este campo pode ter no máximo 400 caracteres';
      }],
      max2000caracteres: [function (v) {
        return v.length <= 2000 || 'Este campo pode ter no máximo 2000 caracteres';
      }],
      numerico: [function (input) {
        return !isNaN(input) || 'Este campo é numérico';
      }, function (input) {
        return input.length === 0 || Number(input) >= 0 || 'Este campo não pode ser negativo';
      }, function (input) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default()(Number(input)) || 'Este campo deve ser um número inteiro';
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {

    // Edita um projeto de pesquisa.
    editarProjetoPesquisa: function editarProjetoPesquisa() {
      var _this = this;

      // Limpa áreas de interface com o projeto de pesquisa.
      if (this.projetoPesquisa.interfaceOutrasAreas === false) {
        this.projetoPesquisa.areaDesenvTec = false;
        this.projetoPesquisa.areaEnsino = false;
        this.projetoPesquisa.areaExtensao = false;
        this.projetoPesquisa.areaOutros = false;
        this.projetoPesquisa.especAreaOutros = null;
      }

      // Limpa especificação de outra área de interface com o projeto de pesquisa.
      if (this.projetoPesquisa.areaOutros === false) {
        this.projetoPesquisa.especAreaOutros = null;
      }

      // Chama o endpoint para editar o projeto de pesquisa.
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Editando Projeto de Pesquisa...' });
      __WEBPACK_IMPORTED_MODULE_2__utils_projetos__["a" /* default */].putProjetoPesquisa(this.idProjetoPesquisa, this.projetoPesquisa).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.$router.push({ name: 'ProjetoPesquisaOutrasInformacoes', params: { idProjetoPesquisa: _this.idProjetoPesquisa } });
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Editando Projeto de Pesquisa...' });
      });
    },

    // Redireciona para a página de visualização da aba "Outras Informações".
    cancelar: function cancelar() {
      this.$router.push({ name: 'ProjetoPesquisaOutrasInformacoes', params: { idProjetoPesquisa: this.idProjetoPesquisa } });
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    // Carrega o projeto de pesquisa.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto de pesquisa...' });
    __WEBPACK_IMPORTED_MODULE_2__utils_projetos__["a" /* default */].getProjetoPesquisa(this.idProjetoPesquisa).then(function (response) {
      _this2.projetoPesquisa = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto de pesquisa...' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_3__components_toolbars_basic_toolbar___default.a
  }
});

/***/ }),
/* 915 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field-integer', {
    attrs: {
      "label": "Número de alunos de graduação participantes*",
      "properties": {
        rules: _vm.obrigatorio.concat( _vm.numerico)
      }
    },
    model: {
      value: (_vm.projetoPesquisa.numAlunosGraduacao),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "numAlunosGraduacao", $$v)
      },
      expression: "projetoPesquisa.numAlunosGraduacao"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field-integer', {
    attrs: {
      "label": "Número de alunos de especialização participantes*",
      "properties": {
        rules: _vm.obrigatorio.concat( _vm.numerico)
      }
    },
    model: {
      value: (_vm.projetoPesquisa.numAlunosEspecializacao),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "numAlunosEspecializacao", $$v)
      },
      expression: "projetoPesquisa.numAlunosEspecializacao"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "v-radio-group_label",
    attrs: {
      "label": "Possui vínculo com a iniciação científica*"
    },
    model: {
      value: (_vm.projetoPesquisa.vinculoIniciacaoCientifica),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "vinculoIniciacaoCientifica", $$v)
      },
      expression: "projetoPesquisa.vinculoIniciacaoCientifica"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Sim",
      "value": true
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Não",
      "value": false
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "v-radio-group_label",
    attrs: {
      "label": "Possui interface com outras áreas*"
    },
    model: {
      value: (_vm.projetoPesquisa.interfaceOutrasAreas),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "interfaceOutrasAreas", $$v)
      },
      expression: "projetoPesquisa.interfaceOutrasAreas"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Sim",
      "value": true
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Não",
      "value": false
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.projetoPesquisa.interfaceOutrasAreas === true) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', [_vm._v("Áreas de interface com o projeto*")])])], 1) : _vm._e(), _vm._v(" "), (_vm.projetoPesquisa.interfaceOutrasAreas === true) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Desenvolvimento Tecnológico"
    },
    model: {
      value: (_vm.projetoPesquisa.areaDesenvTec),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "areaDesenvTec", $$v)
      },
      expression: "projetoPesquisa.areaDesenvTec"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.projetoPesquisa.interfaceOutrasAreas === true) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Ensino"
    },
    model: {
      value: (_vm.projetoPesquisa.areaEnsino),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "areaEnsino", $$v)
      },
      expression: "projetoPesquisa.areaEnsino"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.projetoPesquisa.interfaceOutrasAreas === true) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Extensão"
    },
    model: {
      value: (_vm.projetoPesquisa.areaExtensao),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "areaExtensao", $$v)
      },
      expression: "projetoPesquisa.areaExtensao"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.projetoPesquisa.interfaceOutrasAreas === true) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Outras"
    },
    model: {
      value: (_vm.projetoPesquisa.areaOutros),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "areaOutros", $$v)
      },
      expression: "projetoPesquisa.areaOutros"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [(_vm.projetoPesquisa.areaOutros === true) ? _c('v-text-field', {
    attrs: {
      "label": "Especifique*",
      "counter": "100",
      "rules": _vm.obrigatorio.concat( _vm.max100caracteres)
    },
    model: {
      value: (_vm.projetoPesquisa.especAreaOutros),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "especAreaOutros", $$v)
      },
      expression: "projetoPesquisa.especAreaOutros"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-spacer')], 1) : _vm._e(), _vm._v(" "), _c('br')], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.cancelar()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.editarProjetoPesquisa()
      }
    }
  }, [_vm._v("Salvar")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(917)
  __webpack_require__(918)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(919),
  /* template */
  __webpack_require__(920),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-bdcc4b8c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 917 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 918 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjetoPesquisa'],
  data: function data() {
    return {
      formularioValido: false,
      projetoPesquisa: {
        emailCoordenador: '',
        telefoneCoordenador: '',
        nomeContato: '',
        emailContato: '',
        telefoneContato: '',
        site: '',
        midiasSociais: ''
      },
      obrigatorio: [function (v) {
        return !!v || 'Este campo é obrigatório';
      }],
      max20caracteres: [function (v) {
        return v.length <= 20 || 'Este campo pode ter no máximo 20 caracteres';
      }],
      max50caracteres: [function (v) {
        return v.length <= 50 || 'Este campo pode ter no máximo 50 caracteres';
      }],
      max100caracteres: [function (v) {
        return v.length <= 100 || 'Este campo pode ter no máximo 100 caracteres';
      }],
      max200caracteres: [function (v) {
        return v.length <= 200 || 'Este campo pode ter no máximo 200 caracteres';
      }],
      max400caracteres: [function (v) {
        return v.length <= 400 || 'Este campo pode ter no máximo 400 caracteres';
      }],
      max2000caracteres: [function (v) {
        return v.length <= 2000 || 'Este campo pode ter no máximo 2000 caracteres';
      }],
      email: [function (v) {
        return (/.+@.+\..+/.test(v) || 'Digite um e-mail válido'
        );
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {

    // Edita um projeto de pesquisa.
    editarProjetoPesquisa: function editarProjetoPesquisa() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Editando Projeto de Pesquisa...' });
      __WEBPACK_IMPORTED_MODULE_1__utils_projetos__["a" /* default */].putProjetoPesquisa(this.idProjetoPesquisa, this.projetoPesquisa).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.$router.push({ name: 'ProjetoPesquisaContatos', params: { idProjetoPesquisa: _this.idProjetoPesquisa } });
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Editando Projeto de Pesquisa...' });
      });
    },

    // Redireciona para a página de visualização da aba "Contatos".
    cancelar: function cancelar() {
      this.$router.push({ name: 'ProjetoPesquisaContatos', params: { idProjetoPesquisa: this.idProjetoPesquisa } });
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    // Carrega o projeto de pesquisa.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto de pesquisa...' });
    __WEBPACK_IMPORTED_MODULE_1__utils_projetos__["a" /* default */].getProjetoPesquisa(this.idProjetoPesquisa).then(function (response) {
      _this2.projetoPesquisa = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto de pesquisa...' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar___default.a
  }
});

/***/ }),
/* 920 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "tituloSecao"
  }, [_c('label', [_vm._v("Contatos do coordenador (disponíveis apenas para os administradores)")])])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "E-mail*",
      "counter": "100",
      "rules": _vm.obrigatorio.concat( _vm.max100caracteres, _vm.email)
    },
    model: {
      value: (_vm.projetoPesquisa.emailCoordenador),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "emailCoordenador", $$v)
      },
      expression: "projetoPesquisa.emailCoordenador"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Telefone*",
      "counter": "50",
      "rules": _vm.obrigatorio.concat( _vm.max50caracteres)
    },
    model: {
      value: (_vm.projetoPesquisa.telefoneCoordenador),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "telefoneCoordenador", $$v)
      },
      expression: "projetoPesquisa.telefoneCoordenador"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "tituloSecao"
  }, [_c('label', [_vm._v("Contatos do projeto de pesquisa (as informações de contato abaixo ficarão disponíveis para a consulta pública)")])])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome do contato*",
      "counter": "200",
      "rules": _vm.obrigatorio.concat( _vm.max200caracteres)
    },
    model: {
      value: (_vm.projetoPesquisa.nomeContato),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "nomeContato", $$v)
      },
      expression: "projetoPesquisa.nomeContato"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "E-mail*",
      "counter": "100",
      "rules": _vm.obrigatorio.concat( _vm.max100caracteres, _vm.email)
    },
    model: {
      value: (_vm.projetoPesquisa.emailContato),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "emailContato", $$v)
      },
      expression: "projetoPesquisa.emailContato"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Telefone*",
      "counter": "50",
      "rules": _vm.obrigatorio.concat( _vm.max50caracteres)
    },
    model: {
      value: (_vm.projetoPesquisa.telefoneContato),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "telefoneContato", $$v)
      },
      expression: "projetoPesquisa.telefoneContato"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Site",
      "counter": "50",
      "rules": _vm.max50caracteres
    },
    model: {
      value: (_vm.projetoPesquisa.site),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "site", $$v)
      },
      expression: "projetoPesquisa.site"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Mídias sociais",
      "rows": "1",
      "auto-grow": "",
      "counter": "100",
      "rules": _vm.max100caracteres
    },
    model: {
      value: (_vm.projetoPesquisa.midiasSociais),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "midiasSociais", $$v)
      },
      expression: "projetoPesquisa.midiasSociais"
    }
  })], 1)], 1), _vm._v(" "), _c('br')], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.cancelar()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.editarProjetoPesquisa()
      }
    }
  }, [_vm._v("Salvar")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(922)
  __webpack_require__(923)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(924),
  /* template */
  __webpack_require__(925),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-59ffe970",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 922 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 923 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjetoPesquisa'],
  data: function data() {
    return {
      formularioValido: false,
      projetoPesquisa: {},
      obrigatorio: [function (v) {
        return !!v || 'Este campo é obrigatório';
      }],
      max20caracteres: [function (v) {
        return v.length <= 20 || 'Este campo pode ter no máximo 20 caracteres';
      }],
      max300caracteres: [function (v) {
        return v.length <= 300 || 'Este campo pode ter no máximo 300 caracteres';
      }],
      max400caracteres: [function (v) {
        return v.length <= 400 || 'Este campo pode ter no máximo 400 caracteres';
      }],
      max5000caracteres: [function (v) {
        return v.length <= 5000 || 'Este campo pode ter no máximo 5000 caracteres';
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {

    // Edita um projeto de pesquisa.
    editarProjetoPesquisa: function editarProjetoPesquisa() {
      var _this = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Editando Projeto de Pesquisa...' });
      __WEBPACK_IMPORTED_MODULE_1__utils_projetos__["a" /* default */].putProjetoPesquisa(this.idProjetoPesquisa, this.projetoPesquisa).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.$router.push({ name: 'ProjetoPesquisaResultadosObtidos', params: { idProjetoPesquisa: _this.idProjetoPesquisa } });
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Editando Projeto de Pesquisa...' });
      });
    },

    // Redireciona para a página de visualização da aba "Resultados obtidos".
    cancelar: function cancelar() {
      this.$router.push({ name: 'ProjetoPesquisaResultadosObtidos', params: { idProjetoPesquisa: this.idProjetoPesquisa } });
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    // Carrega o projeto de pesquisa.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto de pesquisa...' });
    __WEBPACK_IMPORTED_MODULE_1__utils_projetos__["a" /* default */].getProjetoPesquisa(this.idProjetoPesquisa).then(function (response) {
      _this2.projetoPesquisa = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto de pesquisa...' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_2__components_toolbars_basic_toolbar___default.a
  }
});

/***/ }),
/* 925 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    staticClass: "alerta",
    attrs: {
      "color": "#00796b",
      "type": "info",
      "dense": "",
      "outlined": ""
    }
  }, [_vm._v("\n            Adicione arquivos com os resultados do projeto na aba ARQUIVOS.\n          ")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Descrição dos resultados do projeto de pesquisa*",
      "counter": "5000",
      "rows": 3,
      "auto-grow": true,
      "rules": _vm.obrigatorio.concat( _vm.max5000caracteres),
      "hint": "Deve ser inserida a referência das produções científica(s), tecnológica(s) e artística(s) e a formação de recursos humanos oriundas do projeto de pesquisa."
    },
    model: {
      value: (_vm.projetoPesquisa.resultadosObtidos),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "resultadosObtidos", $$v)
      },
      expression: "projetoPesquisa.resultadosObtidos"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Declaro, para devidos fins de direito, que as informações prestadas são verdadeiras e autênticas. Fico ciente de que a falsidade dessa declaração configura crime previsto no Código Penal Brasileiro, passível de penalidade.*",
      "rules": _vm.obrigatorio
    },
    model: {
      value: (_vm.projetoPesquisa.declaracaoResultadosObtidos),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "declaracaoResultadosObtidos", $$v)
      },
      expression: "projetoPesquisa.declaracaoResultadosObtidos"
    }
  })], 1)], 1), _vm._v(" "), _c('br')], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.cancelar()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.editarProjetoPesquisa()
      }
    }
  }, [_vm._v("Salvar")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(927)
  __webpack_require__(928)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(929),
  /* template */
  __webpack_require__(930),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3b7089e8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 927 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 928 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_projetos__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['idProjetoPesquisa', 'idArquivoProjetoPesquisa'],
  data: function data() {
    return {
      formularioValido: false,
      arquivo: {
        conteudo: {},
        nome: '',
        observacao: '',
        tipoArquivo: null,
        nivelAcesso: 'P'
      },
      listaTipoArquivo: [],
      obrigatorio: [function (v) {
        return !!v || 'Este campo é obrigatório';
      }],
      max200caracteres: [function (v) {
        return v.length <= 200 || 'Este campo pode ter no máximo 200 caracteres';
      }]
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']), {

    // Função para ordenar lista de tipos de arquivos.
    funcaoOrdenaListaTiposArquivos: function funcaoOrdenaListaTiposArquivos(tipo1, tipo2) {
      return tipo1.item - tipo2.item;
    },

    // Redireciona para a tela de visualização da aba "Arquivos" -->
    cancelar: function cancelar() {
      this.$router.push({ name: 'ProjetoPesquisaArquivos', params: { idProjetoPesquisa: this.idProjetoPesquisa } });
    },

    // Edita o arquivo.
    editarArquivo: function editarArquivo() {
      var _this = this;

      var body = new FormData();
      body.append('nome', this.arquivo.nome);
      body.append('tipoArquivoItem', this.arquivo.tipoArquivo.item);
      body.append('nivelAcesso', this.arquivo.nivelAcesso);
      body.append('observacao', this.arquivo.observacao);
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Editando informações do arquivo...' });
      __WEBPACK_IMPORTED_MODULE_2__utils_projetos__["a" /* default */].putArquivoProjetoPesquisa(this.idProjetoPesquisa, this.idArquivoProjetoPesquisa, this.arquivo).then(function (response) {
        _this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem });
        _this.$router.push({ name: 'ProjetoPesquisaArquivos', params: { idProjetoPesquisa: _this.idProjetoPesquisa } });
      }).catch(function (error) {
        _this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem });
      }).finally(function () {
        _this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Editando informações do arquivo...' });
      });
    },


    // Carrega tabela estruturada.
    opcoesTabelaEstruturada: function opcoesTabelaEstruturada(codTabela, aqui, atributo) {
      var _this2 = this;

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando tipos de arquivo...' });
      __WEBPACK_IMPORTED_MODULE_2__utils_projetos__["a" /* default */].getOpcoesTabelaEstruturada(codTabela).then(function (response) {
        aqui[atributo] = response.data.slice();
        aqui[atributo].sort(_this2.funcaoOrdenaListaTiposArquivos);
      }).catch(function (error) {
        console.log('Erro ao mandar o request' + error);
      }).finally(function () {
        _this2.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando tipos de arquivo...' });
      });
    }
  }),
  mounted: function mounted() {
    var _this3 = this;

    // Carrega lista com os tipos de arquivos (COD_TABELA = 1170).
    this.opcoesTabelaEstruturada(1170, this, 'listaTipoArquivo');

    // Carrega as informações do arquivo.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações do arquivo...' });
    __WEBPACK_IMPORTED_MODULE_2__utils_projetos__["a" /* default */].getArquivoProjetoPesquisa(this.idProjetoPesquisa, this.idArquivoProjetoPesquisa).then(function (response) {
      _this3.arquivo = response.data;
    }).catch(function (error) {
      console.log('Erro ao mandar o request' + error);
    }).finally(function () {
      _this3.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações do arquivo...' });
    });
  },

  components: {
    'basic-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_toolbars_basic_toolbar___default.a
  }
});

/***/ }),
/* 930 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Editar informações do arquivo'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "id": "nomeArquivo",
      "label": "Nome do arquivo",
      "readonly": ""
    },
    model: {
      value: (_vm.arquivo.nome),
      callback: function($$v) {
        _vm.$set(_vm.arquivo, "nome", $$v)
      },
      expression: "arquivo.nome"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "id": "tipoArquivo",
      "label": "Tipo do arquivo*",
      "items": _vm.listaTipoArquivo,
      "item-text": "descricao",
      "item-value": "item",
      "prepend-icon": "dashboard",
      "return-object": "",
      "autocomplete": "",
      "required": "",
      "rules": _vm.obrigatorio
    },
    model: {
      value: (_vm.arquivo.tipoArquivo),
      callback: function($$v) {
        _vm.$set(_vm.arquivo, "tipoArquivo", $$v)
      },
      expression: "arquivo.tipoArquivo"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    staticClass: "observacao",
    attrs: {
      "label": _vm.arquivo.tipoArquivo !== null ? _vm.arquivo.tipoArquivo.item === 3 ? 'Observação*' : 'Observação' : 'Observação',
      "rules": _vm.arquivo.tipoArquivo !== null ? _vm.arquivo.tipoArquivo.item === 3 ? _vm.obrigatorio.concat( _vm.max200caracteres) : _vm.max200caracteres : _vm.max200caracteres,
      "rows": 2,
      "auto-grow": true,
      "multi-line": "",
      "counter": "200",
      "hint": _vm.arquivo.tipoArquivo !== null ? _vm.arquivo.tipoArquivo.item === 3 ? 'Informe o tipo de documento' : false : false,
      "persistent-hint": _vm.arquivo.tipoArquivo !== null ? _vm.arquivo.tipoArquivo.item === 3 ? true : false : false
    },
    model: {
      value: (_vm.arquivo.observacao),
      callback: function($$v) {
        _vm.$set(_vm.arquivo, "observacao", $$v)
      },
      expression: "arquivo.observacao"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.cancelar()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.editarArquivo()
      }
    }
  }, [_vm._v("Salvar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(932),
  /* template */
  __webpack_require__(933),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ajuda'
});

/***/ }),
/* 933 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('v-card-text', [_c('v-container', {
    staticClass: "grey lighten-4",
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('h2', [_vm._v("Os seguintes recursos estão disponíveis em caso de dúvidas:")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', [_c('v-card', [_c('v-card-title', [_vm._v("Perguntas Frequentes:")]), _vm._v(" "), _c('v-card-text', [_c('p', [_vm._v("Respostas para as dúvidas mais comuns sobre o sistema e procedimentos realizados pela PRPPG.")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Perguntas Frequentes")])])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', [_c('v-card', [_c('v-card-title', [_vm._v("Orientações Gerais:")]), _vm._v(" "), _c('v-card-text', [_c('p', [_vm._v("Está com dúvidas sobre como registrar um projeto de pesquisa? Acesse os arquivos abaixo:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Arquivo 1")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Arquivo 2")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Arquivo 3")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Para obter maiores informações sobre os Objetivos de Desenvolvimento Sustentável (ODS), clique nos links abaixo:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://ods.ufes.br/",
      "target": "_blank"
    }
  }, [_vm._v("UFES - Objetivos de Desenvolvimento Sustentável")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.agenda2030.com.br/",
      "target": "_blank"
    }
  }, [_vm._v("Plataforma Agenda 2030")])])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', [_c('v-card', [_c('v-card-title', [_vm._v("Fale Conosco:")]), _vm._v(" "), _c('v-card-text', [_c('p', [_vm._v("Sistema de suporte da aplicação, que deve ser utilizado caso não consiga resolver sua dúvida com as orientações gerais ou com as perguntas frequentes.")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Sistema de Suporte")])])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 934 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 935 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[212]);


// WEBPACK FOOTER //
// static/js/app.fd597f1fcecf89b7b9f2.js